var B3 = Object.defineProperty;
var T_ = (e) => {
  throw TypeError(e);
};
var U3 = (e, t, n) => t in e ? B3(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var vi = (e, t, n) => U3(e, typeof t != "symbol" ? t + "" : t, n), P_ = (e, t, n) => t.has(e) || T_("Cannot " + n);
var k_ = (e, t, n) => (P_(e, t, "read from private field"), n ? n.call(e) : t.get(e)), D_ = (e, t, n) => t.has(e) ? T_("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), Oh = (e, t, n, r) => (P_(e, t, "write to private field"), r ? r.call(e, n) : t.set(e, n), n);
import * as ie from "react";
import H, { useState as Ve, createContext as He, useContext as Me, useLayoutEffect as dO, useEffect as Ee, useRef as _e, useCallback as Le, useMemo as Te, forwardRef as fn, createElement as q3, cloneElement as Ou, Children as H3, isValidElement as xy, useReducer as pO, version as W3, Component as Ey, memo as Xf, PureComponent as hO, useImperativeHandle as Z3, Fragment as G3 } from "react";
import Y3, { createPortal as va, flushSync as Sy, unstable_batchedUpdates as Q3 } from "react-dom";
import J3, { keyframes as X3 } from "styled-components";
import { toast as En } from "react-toastify";
import { useMutation as Oy, useQuery as rp, QueryClientProvider as vO } from "@tanstack/react-query";
import { useField as e6 } from "formik";
import { Link as es } from "react-router-dom";
import { Outlet as t6 } from "react-router";
import * as sc from "@apollo/client";
import { gql as li } from "@apollo/client";
import * as $h from "pdfjs-dist";
function ip(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var jc = { exports: {} }, Al = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var A_;
function n6() {
  if (A_) return Al;
  A_ = 1;
  var e = H, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, u) {
    var c, f = {}, d = null, p = null;
    u !== void 0 && (d = "" + u), l.key !== void 0 && (d = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (c in l) r.call(l, c) && !o.hasOwnProperty(c) && (f[c] = l[c]);
    if (s && s.defaultProps) for (c in l = s.defaultProps, l) f[c] === void 0 && (f[c] = l[c]);
    return { $$typeof: t, type: s, key: d, ref: p, props: f, _owner: i.current };
  }
  return Al.Fragment = n, Al.jsx = a, Al.jsxs = a, Al;
}
var Cl = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var C_;
function r6() {
  return C_ || (C_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = H, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), h = Symbol.iterator, v = "@@iterator";
    function m(L) {
      if (L === null || typeof L != "object")
        return null;
      var ye = h && L[h] || L[v];
      return typeof ye == "function" ? ye : null;
    }
    var g = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(L) {
      {
        for (var ye = arguments.length, Ie = new Array(ye > 1 ? ye - 1 : 0), Qe = 1; Qe < ye; Qe++)
          Ie[Qe - 1] = arguments[Qe];
        w("error", L, Ie);
      }
    }
    function w(L, ye, Ie) {
      {
        var Qe = g.ReactDebugCurrentFrame, mt = Qe.getStackAddendum();
        mt !== "" && (ye += "%s", Ie = Ie.concat([mt]));
        var xt = Ie.map(function(at) {
          return String(at);
        });
        xt.unshift("Warning: " + ye), Function.prototype.apply.call(console[L], console, xt);
      }
    }
    var x = !1, S = !1, $ = !1, A = !1, E = !1, y;
    y = Symbol.for("react.module.reference");
    function b(L) {
      return !!(typeof L == "string" || typeof L == "function" || L === r || L === o || E || L === i || L === u || L === c || A || L === p || x || S || $ || typeof L == "object" && L !== null && (L.$$typeof === d || L.$$typeof === f || L.$$typeof === a || L.$$typeof === s || L.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      L.$$typeof === y || L.getModuleId !== void 0));
    }
    function O(L, ye, Ie) {
      var Qe = L.displayName;
      if (Qe)
        return Qe;
      var mt = ye.displayName || ye.name || "";
      return mt !== "" ? Ie + "(" + mt + ")" : Ie;
    }
    function k(L) {
      return L.displayName || "Context";
    }
    function I(L) {
      if (L == null)
        return null;
      if (typeof L.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof L == "function")
        return L.displayName || L.name || null;
      if (typeof L == "string")
        return L;
      switch (L) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof L == "object")
        switch (L.$$typeof) {
          case s:
            var ye = L;
            return k(ye) + ".Consumer";
          case a:
            var Ie = L;
            return k(Ie._context) + ".Provider";
          case l:
            return O(L, L.render, "ForwardRef");
          case f:
            var Qe = L.displayName || null;
            return Qe !== null ? Qe : I(L.type) || "Memo";
          case d: {
            var mt = L, xt = mt._payload, at = mt._init;
            try {
              return I(at(xt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var T = Object.assign, V = 0, z, B, q, M, N, Y, ee;
    function Q() {
    }
    Q.__reactDisabledLog = !0;
    function K() {
      {
        if (V === 0) {
          z = console.log, B = console.info, q = console.warn, M = console.error, N = console.group, Y = console.groupCollapsed, ee = console.groupEnd;
          var L = {
            configurable: !0,
            enumerable: !0,
            value: Q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: L,
            log: L,
            warn: L,
            error: L,
            group: L,
            groupCollapsed: L,
            groupEnd: L
          });
        }
        V++;
      }
    }
    function ne() {
      {
        if (V--, V === 0) {
          var L = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: T({}, L, {
              value: z
            }),
            info: T({}, L, {
              value: B
            }),
            warn: T({}, L, {
              value: q
            }),
            error: T({}, L, {
              value: M
            }),
            group: T({}, L, {
              value: N
            }),
            groupCollapsed: T({}, L, {
              value: Y
            }),
            groupEnd: T({}, L, {
              value: ee
            })
          });
        }
        V < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var se = g.ReactCurrentDispatcher, ce;
    function X(L, ye, Ie) {
      {
        if (ce === void 0)
          try {
            throw Error();
          } catch (mt) {
            var Qe = mt.stack.trim().match(/\n( *(at )?)/);
            ce = Qe && Qe[1] || "";
          }
        return `
` + ce + L;
      }
    }
    var D = !1, P;
    {
      var R = typeof WeakMap == "function" ? WeakMap : Map;
      P = new R();
    }
    function j(L, ye) {
      if (!L || D)
        return "";
      {
        var Ie = P.get(L);
        if (Ie !== void 0)
          return Ie;
      }
      var Qe;
      D = !0;
      var mt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var xt;
      xt = se.current, se.current = null, K();
      try {
        if (ye) {
          var at = function() {
            throw Error();
          };
          if (Object.defineProperty(at.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(at, []);
            } catch (Hn) {
              Qe = Hn;
            }
            Reflect.construct(L, [], at);
          } else {
            try {
              at.call();
            } catch (Hn) {
              Qe = Hn;
            }
            L.call(at.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Hn) {
            Qe = Hn;
          }
          L();
        }
      } catch (Hn) {
        if (Hn && Qe && typeof Hn.stack == "string") {
          for (var nt = Hn.stack.split(`
`), Rn = Qe.stack.split(`
`), en = nt.length - 1, ln = Rn.length - 1; en >= 1 && ln >= 0 && nt[en] !== Rn[ln]; )
            ln--;
          for (; en >= 1 && ln >= 0; en--, ln--)
            if (nt[en] !== Rn[ln]) {
              if (en !== 1 || ln !== 1)
                do
                  if (en--, ln--, ln < 0 || nt[en] !== Rn[ln]) {
                    var _r = `
` + nt[en].replace(" at new ", " at ");
                    return L.displayName && _r.includes("<anonymous>") && (_r = _r.replace("<anonymous>", L.displayName)), typeof L == "function" && P.set(L, _r), _r;
                  }
                while (en >= 1 && ln >= 0);
              break;
            }
        }
      } finally {
        D = !1, se.current = xt, ne(), Error.prepareStackTrace = mt;
      }
      var Za = L ? L.displayName || L.name : "", Ho = Za ? X(Za) : "";
      return typeof L == "function" && P.set(L, Ho), Ho;
    }
    function W(L, ye, Ie) {
      return j(L, !1);
    }
    function J(L) {
      var ye = L.prototype;
      return !!(ye && ye.isReactComponent);
    }
    function le(L, ye, Ie) {
      if (L == null)
        return "";
      if (typeof L == "function")
        return j(L, J(L));
      if (typeof L == "string")
        return X(L);
      switch (L) {
        case u:
          return X("Suspense");
        case c:
          return X("SuspenseList");
      }
      if (typeof L == "object")
        switch (L.$$typeof) {
          case l:
            return W(L.render);
          case f:
            return le(L.type, ye, Ie);
          case d: {
            var Qe = L, mt = Qe._payload, xt = Qe._init;
            try {
              return le(xt(mt), ye, Ie);
            } catch {
            }
          }
        }
      return "";
    }
    var te = Object.prototype.hasOwnProperty, fe = {}, De = g.ReactDebugCurrentFrame;
    function he(L) {
      if (L) {
        var ye = L._owner, Ie = le(L.type, L._source, ye ? ye.type : null);
        De.setExtraStackFrame(Ie);
      } else
        De.setExtraStackFrame(null);
    }
    function Oe(L, ye, Ie, Qe, mt) {
      {
        var xt = Function.call.bind(te);
        for (var at in L)
          if (xt(L, at)) {
            var nt = void 0;
            try {
              if (typeof L[at] != "function") {
                var Rn = Error((Qe || "React class") + ": " + Ie + " type `" + at + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof L[at] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Rn.name = "Invariant Violation", Rn;
              }
              nt = L[at](ye, at, Qe, Ie, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (en) {
              nt = en;
            }
            nt && !(nt instanceof Error) && (he(mt), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Qe || "React class", Ie, at, typeof nt), he(null)), nt instanceof Error && !(nt.message in fe) && (fe[nt.message] = !0, he(mt), _("Failed %s type: %s", Ie, nt.message), he(null));
          }
      }
    }
    var de = Array.isArray;
    function Ue(L) {
      return de(L);
    }
    function tt(L) {
      {
        var ye = typeof Symbol == "function" && Symbol.toStringTag, Ie = ye && L[Symbol.toStringTag] || L.constructor.name || "Object";
        return Ie;
      }
    }
    function vn(L) {
      try {
        return ge(L), !1;
      } catch {
        return !0;
      }
    }
    function ge(L) {
      return "" + L;
    }
    function Ne(L) {
      if (vn(L))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", tt(L)), ge(L);
    }
    var Ye = g.ReactCurrentOwner, et = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ct, F;
    function U(L) {
      if (te.call(L, "ref")) {
        var ye = Object.getOwnPropertyDescriptor(L, "ref").get;
        if (ye && ye.isReactWarning)
          return !1;
      }
      return L.ref !== void 0;
    }
    function Z(L) {
      if (te.call(L, "key")) {
        var ye = Object.getOwnPropertyDescriptor(L, "key").get;
        if (ye && ye.isReactWarning)
          return !1;
      }
      return L.key !== void 0;
    }
    function ue(L, ye) {
      typeof L.ref == "string" && Ye.current;
    }
    function ve(L, ye) {
      {
        var Ie = function() {
          ct || (ct = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ye));
        };
        Ie.isReactWarning = !0, Object.defineProperty(L, "key", {
          get: Ie,
          configurable: !0
        });
      }
    }
    function Se(L, ye) {
      {
        var Ie = function() {
          F || (F = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ye));
        };
        Ie.isReactWarning = !0, Object.defineProperty(L, "ref", {
          get: Ie,
          configurable: !0
        });
      }
    }
    var xe = function(L, ye, Ie, Qe, mt, xt, at) {
      var nt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: L,
        key: ye,
        ref: Ie,
        props: at,
        // Record the component responsible for creating this element.
        _owner: xt
      };
      return nt._store = {}, Object.defineProperty(nt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(nt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Qe
      }), Object.defineProperty(nt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: mt
      }), Object.freeze && (Object.freeze(nt.props), Object.freeze(nt)), nt;
    };
    function $e(L, ye, Ie, Qe, mt) {
      {
        var xt, at = {}, nt = null, Rn = null;
        Ie !== void 0 && (Ne(Ie), nt = "" + Ie), Z(ye) && (Ne(ye.key), nt = "" + ye.key), U(ye) && (Rn = ye.ref, ue(ye, mt));
        for (xt in ye)
          te.call(ye, xt) && !et.hasOwnProperty(xt) && (at[xt] = ye[xt]);
        if (L && L.defaultProps) {
          var en = L.defaultProps;
          for (xt in en)
            at[xt] === void 0 && (at[xt] = en[xt]);
        }
        if (nt || Rn) {
          var ln = typeof L == "function" ? L.displayName || L.name || "Unknown" : L;
          nt && ve(at, ln), Rn && Se(at, ln);
        }
        return xe(L, nt, Rn, mt, Qe, Ye.current, at);
      }
    }
    var We = g.ReactCurrentOwner, pt = g.ReactDebugCurrentFrame;
    function Qt(L) {
      if (L) {
        var ye = L._owner, Ie = le(L.type, L._source, ye ? ye.type : null);
        pt.setExtraStackFrame(Ie);
      } else
        pt.setExtraStackFrame(null);
    }
    var hi;
    hi = !1;
    function or(L) {
      return typeof L == "object" && L !== null && L.$$typeof === t;
    }
    function ro() {
      {
        if (We.current) {
          var L = I(We.current.type);
          if (L)
            return `

Check the render method of \`` + L + "`.";
        }
        return "";
      }
    }
    function xh(L) {
      return "";
    }
    var kl = {};
    function Eh(L) {
      {
        var ye = ro();
        if (!ye) {
          var Ie = typeof L == "string" ? L : L.displayName || L.name;
          Ie && (ye = `

Check the top-level render call using <` + Ie + ">.");
        }
        return ye;
      }
    }
    function Dl(L, ye) {
      {
        if (!L._store || L._store.validated || L.key != null)
          return;
        L._store.validated = !0;
        var Ie = Eh(ye);
        if (kl[Ie])
          return;
        kl[Ie] = !0;
        var Qe = "";
        L && L._owner && L._owner !== We.current && (Qe = " It was passed a child from " + I(L._owner.type) + "."), Qt(L), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ie, Qe), Qt(null);
      }
    }
    function S_(L, ye) {
      {
        if (typeof L != "object")
          return;
        if (Ue(L))
          for (var Ie = 0; Ie < L.length; Ie++) {
            var Qe = L[Ie];
            or(Qe) && Dl(Qe, ye);
          }
        else if (or(L))
          L._store && (L._store.validated = !0);
        else if (L) {
          var mt = m(L);
          if (typeof mt == "function" && mt !== L.entries)
            for (var xt = mt.call(L), at; !(at = xt.next()).done; )
              or(at.value) && Dl(at.value, ye);
        }
      }
    }
    function R3(L) {
      {
        var ye = L.type;
        if (ye == null || typeof ye == "string")
          return;
        var Ie;
        if (typeof ye == "function")
          Ie = ye.propTypes;
        else if (typeof ye == "object" && (ye.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ye.$$typeof === f))
          Ie = ye.propTypes;
        else
          return;
        if (Ie) {
          var Qe = I(ye);
          Oe(Ie, L.props, "prop", Qe, L);
        } else if (ye.PropTypes !== void 0 && !hi) {
          hi = !0;
          var mt = I(ye);
          _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", mt || "Unknown");
        }
        typeof ye.getDefaultProps == "function" && !ye.getDefaultProps.isReactClassApproved && _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function M3(L) {
      {
        for (var ye = Object.keys(L.props), Ie = 0; Ie < ye.length; Ie++) {
          var Qe = ye[Ie];
          if (Qe !== "children" && Qe !== "key") {
            Qt(L), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Qe), Qt(null);
            break;
          }
        }
        L.ref !== null && (Qt(L), _("Invalid attribute `ref` supplied to `React.Fragment`."), Qt(null));
      }
    }
    var O_ = {};
    function $_(L, ye, Ie, Qe, mt, xt) {
      {
        var at = b(L);
        if (!at) {
          var nt = "";
          (L === void 0 || typeof L == "object" && L !== null && Object.keys(L).length === 0) && (nt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Rn = xh();
          Rn ? nt += Rn : nt += ro();
          var en;
          L === null ? en = "null" : Ue(L) ? en = "array" : L !== void 0 && L.$$typeof === t ? (en = "<" + (I(L.type) || "Unknown") + " />", nt = " Did you accidentally export a JSX literal instead of a component?") : en = typeof L, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", en, nt);
        }
        var ln = $e(L, ye, Ie, mt, xt);
        if (ln == null)
          return ln;
        if (at) {
          var _r = ye.children;
          if (_r !== void 0)
            if (Qe)
              if (Ue(_r)) {
                for (var Za = 0; Za < _r.length; Za++)
                  S_(_r[Za], L);
                Object.freeze && Object.freeze(_r);
              } else
                _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              S_(_r, L);
        }
        if (te.call(ye, "key")) {
          var Ho = I(L), Hn = Object.keys(ye).filter(function(K3) {
            return K3 !== "key";
          }), Sh = Hn.length > 0 ? "{key: someKey, " + Hn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!O_[Ho + Sh]) {
            var V3 = Hn.length > 0 ? "{" + Hn.join(": ..., ") + ": ...}" : "{}";
            _(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Sh, Ho, V3, Ho), O_[Ho + Sh] = !0;
          }
        }
        return L === r ? M3(ln) : R3(ln), ln;
      }
    }
    function j3(L, ye, Ie) {
      return $_(L, ye, Ie, !0);
    }
    function F3(L, ye, Ie) {
      return $_(L, ye, Ie, !1);
    }
    var z3 = F3, L3 = j3;
    Cl.Fragment = r, Cl.jsx = z3, Cl.jsxs = L3;
  })()), Cl;
}
var I_;
function i6() {
  return I_ || (I_ = 1, process.env.NODE_ENV === "production" ? jc.exports = n6() : jc.exports = r6()), jc.exports;
}
var C = i6();
function o6() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = mO(t)) && (r && (r += " "), r += n);
  return r;
}
function mO(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = mO(e[r])) && (n && (n += " "), n += t);
  return n;
}
var $y = "-";
function a6(e) {
  var t = l6(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, i = r === void 0 ? {} : r;
  function o(s) {
    var l = s.split($y);
    return l[0] === "" && l.length !== 1 && l.shift(), gO(l, t) || s6(s);
  }
  function a(s, l) {
    var u = n[s] || [];
    return l && i[s] ? [].concat(u, i[s]) : u;
  }
  return {
    getClassGroupId: o,
    getConflictingClassGroupIds: a
  };
}
function gO(e, t) {
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), i = r ? gO(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length !== 0) {
    var o = e.join($y);
    return t.validators.find(function(a) {
      var s = a.validator;
      return s(o);
    })?.classGroupId;
  }
}
var N_ = /^\[(.+)\]$/;
function s6(e) {
  if (N_.test(e)) {
    var t = N_.exec(e)[1], n = t?.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function l6(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, i = c6(Object.entries(e.classGroups), n);
  return i.forEach(function(o) {
    var a = o[0], s = o[1];
    im(s, r, a, t);
  }), r;
}
function im(e, t, n, r) {
  e.forEach(function(i) {
    if (typeof i == "string") {
      var o = i === "" ? t : R_(t, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (u6(i)) {
        im(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(function(a) {
      var s = a[0], l = a[1];
      im(l, R_(t, s), n, r);
    });
  });
}
function R_(e, t) {
  var n = e;
  return t.split($y).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function u6(e) {
  return e.isThemeGetter;
}
function c6(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], i = n[1], o = i.map(function(a) {
      return typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(function(s) {
        var l = s[0], u = s[1];
        return [t + l, u];
      })) : a;
    });
    return [r, o];
  }) : e;
}
function f6(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function i(o, a) {
    n.set(o, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(a) {
      var s = n.get(a);
      if (s !== void 0)
        return s;
      if ((s = r.get(a)) !== void 0)
        return i(a, s), s;
    },
    set: function(a, s) {
      n.has(a) ? n.set(a, s) : i(a, s);
    }
  };
}
var yO = "!";
function d6(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], i = t.length;
  return function(a) {
    for (var s = [], l = 0, u = 0, c, f = 0; f < a.length; f++) {
      var d = a[f];
      if (l === 0) {
        if (d === r && (n || a.slice(f, f + i) === t)) {
          s.push(a.slice(u, f)), u = f + i;
          continue;
        }
        if (d === "/") {
          c = f;
          continue;
        }
      }
      d === "[" ? l++ : d === "]" && l--;
    }
    var p = s.length === 0 ? a : a.substring(u), h = p.startsWith(yO), v = h ? p.substring(1) : p, m = c && c > u ? c - u : void 0;
    return {
      modifiers: s,
      hasImportantModifier: h,
      baseClassName: v,
      maybePostfixModifierPosition: m
    };
  };
}
function p6(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var i = r[0] === "[";
    i ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function h6(e) {
  return {
    cache: f6(e.cacheSize),
    splitModifiers: d6(e),
    ...a6(e)
  };
}
var v6 = /\s+/;
function m6(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, i = t.getConflictingClassGroupIds, o = /* @__PURE__ */ new Set();
  return e.trim().split(v6).map(function(a) {
    var s = n(a), l = s.modifiers, u = s.hasImportantModifier, c = s.baseClassName, f = s.maybePostfixModifierPosition, d = r(f ? c.substring(0, f) : c), p = !!f;
    if (!d) {
      if (!f)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (d = r(c), !d)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      p = !1;
    }
    var h = p6(l).join(":"), v = u ? h + yO : h;
    return {
      isTailwindClass: !0,
      modifierId: v,
      classGroupId: d,
      originalClassName: a,
      hasPostfixModifier: p
    };
  }).reverse().filter(function(a) {
    if (!a.isTailwindClass)
      return !0;
    var s = a.modifierId, l = a.classGroupId, u = a.hasPostfixModifier, c = s + l;
    return o.has(c) ? !1 : (o.add(c), i(l, u).forEach(function(f) {
      return o.add(s + f);
    }), !0);
  }).reverse().map(function(a) {
    return a.originalClassName;
  }).join(" ");
}
function g6() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, i, o, a = s;
  function s(u) {
    var c = t[0], f = t.slice(1), d = f.reduce(function(p, h) {
      return h(p);
    }, c());
    return r = h6(d), i = r.cache.get, o = r.cache.set, a = l, l(u);
  }
  function l(u) {
    var c = i(u);
    if (c)
      return c;
    var f = m6(u, r);
    return o(u, f), f;
  }
  return function() {
    return a(o6.apply(null, arguments));
  };
}
function Dt(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var bO = /^\[(?:([a-z-]+):)?(.+)\]$/i, y6 = /^\d+\/\d+$/, b6 = /* @__PURE__ */ new Set(["px", "full", "screen"]), _6 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, w6 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, x6 = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function Br(e) {
  return oa(e) || b6.has(e) || y6.test(e) || om(e);
}
function om(e) {
  return Ca(e, "length", P6);
}
function E6(e) {
  return Ca(e, "size", _O);
}
function S6(e) {
  return Ca(e, "position", _O);
}
function O6(e) {
  return Ca(e, "url", k6);
}
function Fc(e) {
  return Ca(e, "number", oa);
}
function oa(e) {
  return !Number.isNaN(Number(e));
}
function $6(e) {
  return e.endsWith("%") && oa(e.slice(0, -1));
}
function Il(e) {
  return M_(e) || Ca(e, "number", M_);
}
function rt(e) {
  return bO.test(e);
}
function Nl() {
  return !0;
}
function io(e) {
  return _6.test(e);
}
function T6(e) {
  return Ca(e, "", D6);
}
function Ca(e, t, n) {
  var r = bO.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function P6(e) {
  return w6.test(e);
}
function _O() {
  return !1;
}
function k6(e) {
  return e.startsWith("url(");
}
function M_(e) {
  return Number.isInteger(Number(e));
}
function D6(e) {
  return x6.test(e);
}
function A6() {
  var e = Dt("colors"), t = Dt("spacing"), n = Dt("blur"), r = Dt("brightness"), i = Dt("borderColor"), o = Dt("borderRadius"), a = Dt("borderSpacing"), s = Dt("borderWidth"), l = Dt("contrast"), u = Dt("grayscale"), c = Dt("hueRotate"), f = Dt("invert"), d = Dt("gap"), p = Dt("gradientColorStops"), h = Dt("gradientColorStopPositions"), v = Dt("inset"), m = Dt("margin"), g = Dt("opacity"), _ = Dt("padding"), w = Dt("saturate"), x = Dt("scale"), S = Dt("sepia"), $ = Dt("skew"), A = Dt("space"), E = Dt("translate"), y = function() {
    return ["auto", "contain", "none"];
  }, b = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, O = function() {
    return ["auto", rt, t];
  }, k = function() {
    return [rt, t];
  }, I = function() {
    return ["", Br];
  }, T = function() {
    return ["auto", oa, rt];
  }, V = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, z = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, B = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, q = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, M = function() {
    return ["", "0", rt];
  }, N = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, Y = function() {
    return [oa, Fc];
  }, ee = function() {
    return [oa, rt];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [Nl],
      spacing: [Br],
      blur: ["none", "", io, rt],
      brightness: Y(),
      borderColor: [e],
      borderRadius: ["none", "", "full", io, rt],
      borderSpacing: k(),
      borderWidth: I(),
      contrast: Y(),
      grayscale: M(),
      hueRotate: ee(),
      invert: M(),
      gap: k(),
      gradientColorStops: [e],
      gradientColorStopPositions: [$6, om],
      inset: O(),
      margin: O(),
      opacity: Y(),
      padding: k(),
      saturate: Y(),
      scale: Y(),
      sepia: M(),
      skew: ee(),
      space: k(),
      translate: k()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", rt]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [io]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": N()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": N()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(V(), [rt])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: b()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": b()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": b()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: y()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": y()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": y()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [v]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [v]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [v]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [v]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [v]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [v]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [v]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [v]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [v]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Il]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: O()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", rt]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: M()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: M()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Il]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Nl]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Il]
        }, rt]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": T()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": T()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Nl]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Il]
        }, rt]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": T()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": T()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", rt]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", rt]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [d]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [d]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [d]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(q())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(q(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(q(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [_]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [_]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [_]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [_]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [_]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [_]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [_]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [_]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [_]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [A]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [A]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", rt, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", rt, Br]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [io]
        }, io, rt]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [rt, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", rt, Br]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [rt, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", io, om]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Fc]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Nl]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", rt]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", oa, Fc]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", rt, Br]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", rt]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", rt]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [g]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [g]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(z(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Br]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", rt, Br]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: k()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", rt]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", rt]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [g]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(V(), [S6])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", E6]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, O6]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [h]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [g]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(z(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [g]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: z()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(z())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [rt, Br]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Br]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: I()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [g]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Br]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", io, T6]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Nl]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [g]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": B()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": B()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", io, rt]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [g]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", rt]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: ee()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", rt]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: ee()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", rt]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Il, rt]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [E]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [E]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [$]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [$]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", rt]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", rt]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": k()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": k()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": k()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": k()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": k()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": k()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": k()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": k()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": k()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": k()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": k()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": k()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": k()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": k()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": k()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": k()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": k()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": k()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", rt]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Br, Fc]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var Qn = /* @__PURE__ */ g6(A6);
function Qle(e) {
  const { className: t, children: n, ...r } = e;
  return /* @__PURE__ */ C.jsx("div", { className: Qn("p-8", t), ...r, children: /* @__PURE__ */ C.jsxs("div", { className: "border border-orange-2 p-4 bg-orange-100", children: [
    /* @__PURE__ */ C.jsx("h2", { className: "text-2xl mb-4", children: e.heading || "Note" }),
    n
  ] }) });
}
const Jle = (e) => /* @__PURE__ */ C.jsx("div", { ...e });
function wO(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = wO(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function xO() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = wO(e)) && (r && (r += " "), r += t);
  return r;
}
const j_ = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, F_ = xO, ui = (e, t) => (n) => {
  var r;
  if (t?.variants == null) return F_(e, n?.class, n?.className);
  const { variants: i, defaultVariants: o } = t, a = Object.keys(i).map((u) => {
    const c = n?.[u], f = o?.[u];
    if (c === null) return null;
    const d = j_(c) || j_(f);
    return i[u][d];
  }), s = n && Object.entries(n).reduce((u, c) => {
    let [f, d] = c;
    return d === void 0 || (u[f] = d), u;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, c) => {
    let { class: f, className: d, ...p } = c;
    return Object.entries(p).every((h) => {
      let [v, m] = h;
      return Array.isArray(m) ? m.includes({
        ...o,
        ...s
      }[v]) : {
        ...o,
        ...s
      }[v] === m;
    }) ? [
      ...u,
      f,
      d
    ] : u;
  }, []);
  return F_(e, a, l, n?.class, n?.className);
}, C6 = ui(
  [
    "z-0",
    "flex-grow-0",
    "px-4",
    "py-2",
    "text-sm",
    "text-white",
    "transition-all",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-opacity-75",
    "disabled:opacity-50",
    "disabled:cursor-default"
  ],
  {
    variants: {
      variant: {
        green: "bg-green-400 focus:ring-green-400 hover:bg-green-500 disabled:bg-green-400",
        blue: "bg-blue-400",
        red: "bg-red-400 focus:ring-red-400 hover:bg-red-500 disabled:bg-red-400",
        gray: "text-black bg-neutral-200 focus:ring-gray-200 hover:bg-neutral-300 disabled:bg-neutral-200",
        black: "bg-black focus:ring-neutral-800 hover:bg-neutral-800 disabled:bg-neutral-800"
      }
    }
  }
), Ty = ({
  variant: e = "black",
  className: t,
  ...n
}) => /* @__PURE__ */ C.jsx(
  "button",
  {
    ...n,
    className: Qn(C6({ variant: e }), t)
  }
);
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const I6 = {
  prefix: "fas",
  iconName: "bars",
  icon: [448, 512, ["navicon"], "f0c9", "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"]
}, N6 = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, R6 = {
  prefix: "fas",
  iconName: "clipboard",
  icon: [384, 512, [128203], "f328", "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, M6 = {
  prefix: "fas",
  iconName: "user-gear",
  icon: [640, 512, ["user-cog"], "f4fe", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304l91.4 0c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-30.5c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9l0-30.5zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
}, j6 = M6, EO = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, F6 = {
  prefix: "fas",
  iconName: "x",
  icon: [384, 512, [120], "58", "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"]
};
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function z6(e, t, n) {
  return (t = V6(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function z_(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function be(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? z_(Object(n), !0).forEach(function(r) {
      z6(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : z_(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function L6(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function V6(e) {
  var t = L6(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
const L_ = () => {
};
let Py = {}, SO = {}, OO = null, $O = {
  mark: L_,
  measure: L_
};
try {
  typeof window < "u" && (Py = window), typeof document < "u" && (SO = document), typeof MutationObserver < "u" && (OO = MutationObserver), typeof performance < "u" && ($O = performance);
} catch {
}
const {
  userAgent: V_ = ""
} = Py.navigator || {}, $o = Py, Rt = SO, K_ = OO, zc = $O;
$o.document;
const eo = !!Rt.documentElement && !!Rt.head && typeof Rt.addEventListener == "function" && typeof Rt.createElement == "function", TO = ~V_.indexOf("MSIE") || ~V_.indexOf("Trident/");
var K6 = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, B6 = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, PO = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, U6 = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, kO = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], In = "classic", op = "duotone", q6 = "sharp", H6 = "sharp-duotone", DO = [In, op, q6, H6], W6 = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, Z6 = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, G6 = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), Y6 = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, Q6 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], B_ = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, J6 = ["kit"], X6 = {
  kit: {
    "fa-kit": "fak"
  }
}, eN = ["fak", "fakd"], tN = {
  kit: {
    fak: "fa-kit"
  }
}, U_ = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, Lc = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, nN = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], rN = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], iN = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, oN = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, aN = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, am = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, sN = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], sm = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...nN, ...sN], lN = ["solid", "regular", "light", "thin", "duotone", "brands"], AO = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], uN = AO.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), cN = [...Object.keys(aN), ...lN, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Lc.GROUP, Lc.SWAP_OPACITY, Lc.PRIMARY, Lc.SECONDARY].concat(AO.map((e) => "".concat(e, "x"))).concat(uN.map((e) => "w-".concat(e))), fN = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const Bi = "___FONT_AWESOME___", lm = 16, CO = "fa", IO = "svg-inline--fa", ma = "data-fa-i2svg", um = "data-fa-pseudo-element", dN = "data-fa-pseudo-element-pending", ky = "data-prefix", Dy = "data-icon", q_ = "fontawesome-i2svg", pN = "async", hN = ["HTML", "HEAD", "STYLE", "SCRIPT"], NO = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function lc(e) {
  return new Proxy(e, {
    get(t, n) {
      return n in t ? t[n] : t[In];
    }
  });
}
const RO = be({}, PO);
RO[In] = be(be(be(be({}, {
  "fa-duotone": "duotone"
}), PO[In]), B_.kit), B_["kit-duotone"]);
const vN = lc(RO), cm = be({}, Y6);
cm[In] = be(be(be(be({}, {
  duotone: "fad"
}), cm[In]), U_.kit), U_["kit-duotone"]);
const H_ = lc(cm), fm = be({}, am);
fm[In] = be(be({}, fm[In]), tN.kit);
const Ay = lc(fm), dm = be({}, oN);
dm[In] = be(be({}, dm[In]), X6.kit);
lc(dm);
const mN = K6, MO = "fa-layers-text", gN = B6, yN = be({}, W6);
lc(yN);
const bN = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], Th = U6, _N = [...J6, ...cN], ou = $o.FontAwesomeConfig || {};
function wN(e) {
  var t = Rt.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function xN(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
Rt && typeof Rt.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((t) => {
  let [n, r] = t;
  const i = xN(wN(n));
  i != null && (ou[r] = i);
});
const jO = {
  styleDefault: "solid",
  familyDefault: In,
  cssPrefix: CO,
  replacementClass: IO,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
ou.familyPrefix && (ou.cssPrefix = ou.familyPrefix);
const Cs = be(be({}, jO), ou);
Cs.autoReplaceSvg || (Cs.observeMutations = !1);
const Ke = {};
Object.keys(jO).forEach((e) => {
  Object.defineProperty(Ke, e, {
    enumerable: !0,
    set: function(t) {
      Cs[e] = t, au.forEach((n) => n(Ke));
    },
    get: function() {
      return Cs[e];
    }
  });
});
Object.defineProperty(Ke, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    Cs.cssPrefix = e, au.forEach((t) => t(Ke));
  },
  get: function() {
    return Cs.cssPrefix;
  }
});
$o.FontAwesomeConfig = Ke;
const au = [];
function EN(e) {
  return au.push(e), () => {
    au.splice(au.indexOf(e), 1);
  };
}
const oo = lm, Ei = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function SN(e) {
  if (!e || !eo)
    return;
  const t = Rt.createElement("style");
  t.setAttribute("type", "text/css"), t.innerHTML = e;
  const n = Rt.head.childNodes;
  let r = null;
  for (let i = n.length - 1; i > -1; i--) {
    const o = n[i], a = (o.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(a) > -1 && (r = o);
  }
  return Rt.head.insertBefore(t, r), e;
}
const ON = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function $u() {
  let e = 12, t = "";
  for (; e-- > 0; )
    t += ON[Math.random() * 62 | 0];
  return t;
}
function el(e) {
  const t = [];
  for (let n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function Cy(e) {
  return e.classList ? el(e.classList) : (e.getAttribute("class") || "").split(" ").filter((t) => t);
}
function FO(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function $N(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, '="').concat(FO(e[n]), '" '), "").trim();
}
function ap(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, ": ").concat(e[n].trim(), ";"), "");
}
function Iy(e) {
  return e.size !== Ei.size || e.x !== Ei.x || e.y !== Ei.y || e.rotate !== Ei.rotate || e.flipX || e.flipY;
}
function TN(e) {
  let {
    transform: t,
    containerWidth: n,
    iconWidth: r
  } = e;
  const i = {
    transform: "translate(".concat(n / 2, " 256)")
  }, o = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), a = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), s = "rotate(".concat(t.rotate, " 0 0)"), l = {
    transform: "".concat(o, " ").concat(a, " ").concat(s)
  }, u = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: i,
    inner: l,
    path: u
  };
}
function PN(e) {
  let {
    transform: t,
    width: n = lm,
    height: r = lm,
    startCentered: i = !1
  } = e, o = "";
  return i && TO ? o += "translate(".concat(t.x / oo - n / 2, "em, ").concat(t.y / oo - r / 2, "em) ") : i ? o += "translate(calc(-50% + ".concat(t.x / oo, "em), calc(-50% + ").concat(t.y / oo, "em)) ") : o += "translate(".concat(t.x / oo, "em, ").concat(t.y / oo, "em) "), o += "scale(".concat(t.size / oo * (t.flipX ? -1 : 1), ", ").concat(t.size / oo * (t.flipY ? -1 : 1), ") "), o += "rotate(".concat(t.rotate, "deg) "), o;
}
var kN = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function zO() {
  const e = CO, t = IO, n = Ke.cssPrefix, r = Ke.replacementClass;
  let i = kN;
  if (n !== e || r !== t) {
    const o = new RegExp("\\.".concat(e, "\\-"), "g"), a = new RegExp("\\--".concat(e, "\\-"), "g"), s = new RegExp("\\.".concat(t), "g");
    i = i.replace(o, ".".concat(n, "-")).replace(a, "--".concat(n, "-")).replace(s, ".".concat(r));
  }
  return i;
}
let W_ = !1;
function Ph() {
  Ke.autoAddCss && !W_ && (SN(zO()), W_ = !0);
}
var DN = {
  mixout() {
    return {
      dom: {
        css: zO,
        insertCss: Ph
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        Ph();
      },
      beforeI2svg() {
        Ph();
      }
    };
  }
};
const Ui = $o || {};
Ui[Bi] || (Ui[Bi] = {});
Ui[Bi].styles || (Ui[Bi].styles = {});
Ui[Bi].hooks || (Ui[Bi].hooks = {});
Ui[Bi].shims || (Ui[Bi].shims = []);
var Si = Ui[Bi];
const LO = [], VO = function() {
  Rt.removeEventListener("DOMContentLoaded", VO), ed = 1, LO.map((e) => e());
};
let ed = !1;
eo && (ed = (Rt.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Rt.readyState), ed || Rt.addEventListener("DOMContentLoaded", VO));
function AN(e) {
  eo && (ed ? setTimeout(e, 0) : LO.push(e));
}
function uc(e) {
  const {
    tag: t,
    attributes: n = {},
    children: r = []
  } = e;
  return typeof e == "string" ? FO(e) : "<".concat(t, " ").concat($N(n), ">").concat(r.map(uc).join(""), "</").concat(t, ">");
}
function Z_(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var kh = function(t, n, r, i) {
  var o = Object.keys(t), a = o.length, s = n, l, u, c;
  for (r === void 0 ? (l = 1, c = t[o[0]]) : (l = 0, c = r); l < a; l++)
    u = o[l], c = s(c, t[u], u, t);
  return c;
};
function CN(e) {
  const t = [];
  let n = 0;
  const r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n++);
    if (i >= 55296 && i <= 56319 && n < r) {
      const o = e.charCodeAt(n++);
      (o & 64512) == 56320 ? t.push(((i & 1023) << 10) + (o & 1023) + 65536) : (t.push(i), n--);
    } else
      t.push(i);
  }
  return t;
}
function pm(e) {
  const t = CN(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function IN(e, t) {
  const n = e.length;
  let r = e.charCodeAt(t), i;
  return r >= 55296 && r <= 56319 && n > t + 1 && (i = e.charCodeAt(t + 1), i >= 56320 && i <= 57343) ? (r - 55296) * 1024 + i - 56320 + 65536 : r;
}
function G_(e) {
  return Object.keys(e).reduce((t, n) => {
    const r = e[n];
    return !!r.icon ? t[r.iconName] = r.icon : t[n] = r, t;
  }, {});
}
function hm(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: r = !1
  } = n, i = G_(t);
  typeof Si.hooks.addPack == "function" && !r ? Si.hooks.addPack(e, G_(t)) : Si.styles[e] = be(be({}, Si.styles[e] || {}), i), e === "fas" && hm("fa", t);
}
const {
  styles: Tu,
  shims: NN
} = Si, KO = Object.keys(Ay), RN = KO.reduce((e, t) => (e[t] = Object.keys(Ay[t]), e), {});
let Ny = null, BO = {}, UO = {}, qO = {}, HO = {}, WO = {};
function MN(e) {
  return ~_N.indexOf(e);
}
function jN(e, t) {
  const n = t.split("-"), r = n[0], i = n.slice(1).join("-");
  return r === e && i !== "" && !MN(i) ? i : null;
}
const ZO = () => {
  const e = (r) => kh(Tu, (i, o, a) => (i[a] = kh(o, r, {}), i), {});
  BO = e((r, i, o) => (i[3] && (r[i[3]] = o), i[2] && i[2].filter((s) => typeof s == "number").forEach((s) => {
    r[s.toString(16)] = o;
  }), r)), UO = e((r, i, o) => (r[o] = o, i[2] && i[2].filter((s) => typeof s == "string").forEach((s) => {
    r[s] = o;
  }), r)), WO = e((r, i, o) => {
    const a = i[2];
    return r[o] = o, a.forEach((s) => {
      r[s] = o;
    }), r;
  });
  const t = "far" in Tu || Ke.autoFetchSvg, n = kh(NN, (r, i) => {
    const o = i[0];
    let a = i[1];
    const s = i[2];
    return a === "far" && !t && (a = "fas"), typeof o == "string" && (r.names[o] = {
      prefix: a,
      iconName: s
    }), typeof o == "number" && (r.unicodes[o.toString(16)] = {
      prefix: a,
      iconName: s
    }), r;
  }, {
    names: {},
    unicodes: {}
  });
  qO = n.names, HO = n.unicodes, Ny = sp(Ke.styleDefault, {
    family: Ke.familyDefault
  });
};
EN((e) => {
  Ny = sp(e.styleDefault, {
    family: Ke.familyDefault
  });
});
ZO();
function Ry(e, t) {
  return (BO[e] || {})[t];
}
function FN(e, t) {
  return (UO[e] || {})[t];
}
function aa(e, t) {
  return (WO[e] || {})[t];
}
function GO(e) {
  return qO[e] || {
    prefix: null,
    iconName: null
  };
}
function zN(e) {
  const t = HO[e], n = Ry("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function To() {
  return Ny;
}
const YO = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function LN(e) {
  let t = In;
  const n = KO.reduce((r, i) => (r[i] = "".concat(Ke.cssPrefix, "-").concat(i), r), {});
  return DO.forEach((r) => {
    (e.includes(n[r]) || e.some((i) => RN[r].includes(i))) && (t = r);
  }), t;
}
function sp(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: n = In
  } = t, r = vN[n][e];
  if (n === op && !e)
    return "fad";
  const i = H_[n][e] || H_[n][r], o = e in Si.styles ? e : null;
  return i || o || null;
}
function VN(e) {
  let t = [], n = null;
  return e.forEach((r) => {
    const i = jN(Ke.cssPrefix, r);
    i ? n = i : r && t.push(r);
  }), {
    iconName: n,
    rest: t
  };
}
function Y_(e) {
  return e.sort().filter((t, n, r) => r.indexOf(t) === n);
}
function lp(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: n = !1
  } = t;
  let r = null;
  const i = sm.concat(rN), o = Y_(e.filter((f) => i.includes(f))), a = Y_(e.filter((f) => !sm.includes(f))), s = o.filter((f) => (r = f, !kO.includes(f))), [l = null] = s, u = LN(o), c = be(be({}, VN(a)), {}, {
    prefix: sp(l, {
      family: u
    })
  });
  return be(be(be({}, c), qN({
    values: e,
    family: u,
    styles: Tu,
    config: Ke,
    canonical: c,
    givenPrefix: r
  })), KN(n, r, c));
}
function KN(e, t, n) {
  let {
    prefix: r,
    iconName: i
  } = n;
  if (e || !r || !i)
    return {
      prefix: r,
      iconName: i
    };
  const o = t === "fa" ? GO(i) : {}, a = aa(r, i);
  return i = o.iconName || a || i, r = o.prefix || r, r === "far" && !Tu.far && Tu.fas && !Ke.autoFetchSvg && (r = "fas"), {
    prefix: r,
    iconName: i
  };
}
const BN = DO.filter((e) => e !== In || e !== op), UN = Object.keys(am).filter((e) => e !== In).map((e) => Object.keys(am[e])).flat();
function qN(e) {
  const {
    values: t,
    family: n,
    canonical: r,
    givenPrefix: i = "",
    styles: o = {},
    config: a = {}
  } = e, s = n === op, l = t.includes("fa-duotone") || t.includes("fad"), u = a.familyDefault === "duotone", c = r.prefix === "fad" || r.prefix === "fa-duotone";
  if (!s && (l || u || c) && (r.prefix = "fad"), (t.includes("fa-brands") || t.includes("fab")) && (r.prefix = "fab"), !r.prefix && BN.includes(n) && (Object.keys(o).find((d) => UN.includes(d)) || a.autoFetchSvg)) {
    const d = G6.get(n).defaultShortPrefixId;
    r.prefix = d, r.iconName = aa(r.prefix, r.iconName) || r.iconName;
  }
  return (r.prefix === "fa" || i === "fa") && (r.prefix = To() || "fas"), r;
}
class HN {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    const i = n.reduce(this._pullDefinitions, {});
    Object.keys(i).forEach((o) => {
      this.definitions[o] = be(be({}, this.definitions[o] || {}), i[o]), hm(o, i[o]);
      const a = Ay[In][o];
      a && hm(a, i[o]), ZO();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(t, n) {
    const r = n.prefix && n.iconName && n.icon ? {
      0: n
    } : n;
    return Object.keys(r).map((i) => {
      const {
        prefix: o,
        iconName: a,
        icon: s
      } = r[i], l = s[2];
      t[o] || (t[o] = {}), l.length > 0 && l.forEach((u) => {
        typeof u == "string" && (t[o][u] = s);
      }), t[o][a] = s;
    }), t;
  }
}
let Q_ = [], os = {};
const _s = {}, WN = Object.keys(_s);
function ZN(e, t) {
  let {
    mixoutsTo: n
  } = t;
  return Q_ = e, os = {}, Object.keys(_s).forEach((r) => {
    WN.indexOf(r) === -1 && delete _s[r];
  }), Q_.forEach((r) => {
    const i = r.mixout ? r.mixout() : {};
    if (Object.keys(i).forEach((o) => {
      typeof i[o] == "function" && (n[o] = i[o]), typeof i[o] == "object" && Object.keys(i[o]).forEach((a) => {
        n[o] || (n[o] = {}), n[o][a] = i[o][a];
      });
    }), r.hooks) {
      const o = r.hooks();
      Object.keys(o).forEach((a) => {
        os[a] || (os[a] = []), os[a].push(o[a]);
      });
    }
    r.provides && r.provides(_s);
  }), n;
}
function vm(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    r[i - 2] = arguments[i];
  return (os[e] || []).forEach((a) => {
    t = a.apply(null, [t, ...r]);
  }), t;
}
function ga(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  (os[e] || []).forEach((o) => {
    o.apply(null, n);
  });
}
function Po() {
  const e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return _s[e] ? _s[e].apply(null, t) : void 0;
}
function mm(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  let {
    iconName: t
  } = e;
  const n = e.prefix || To();
  if (t)
    return t = aa(n, t) || t, Z_(QO.definitions, n, t) || Z_(Si.styles, n, t);
}
const QO = new HN(), GN = () => {
  Ke.autoReplaceSvg = !1, Ke.observeMutations = !1, ga("noAuto");
}, YN = {
  i2svg: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return eo ? (ga("beforeI2svg", e), Po("pseudoElements2svg", e), Po("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: t
    } = e;
    Ke.autoReplaceSvg === !1 && (Ke.autoReplaceSvg = !0), Ke.observeMutations = !0, AN(() => {
      JN({
        autoReplaceSvgRoot: t
      }), ga("watch", e);
    });
  }
}, QN = {
  icon: (e) => {
    if (e === null)
      return null;
    if (typeof e == "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: aa(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      const t = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], n = sp(e[0]);
      return {
        prefix: n,
        iconName: aa(n, t) || t
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(Ke.cssPrefix, "-")) > -1 || e.match(mN))) {
      const t = lp(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: t.prefix || To(),
        iconName: aa(t.prefix, t.iconName) || t.iconName
      };
    }
    if (typeof e == "string") {
      const t = To();
      return {
        prefix: t,
        iconName: aa(t, e) || e
      };
    }
  }
}, yr = {
  noAuto: GN,
  config: Ke,
  dom: YN,
  parse: QN,
  library: QO,
  findIconDefinition: mm,
  toHtml: uc
}, JN = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: t = Rt
  } = e;
  (Object.keys(Si.styles).length > 0 || Ke.autoFetchSvg) && eo && Ke.autoReplaceSvg && yr.dom.i2svg({
    node: t
  });
};
function up(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map((n) => uc(n));
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (!eo) return;
      const n = Rt.createElement("div");
      return n.innerHTML = e.html, n.children;
    }
  }), e;
}
function XN(e) {
  let {
    children: t,
    main: n,
    mask: r,
    attributes: i,
    styles: o,
    transform: a
  } = e;
  if (Iy(a) && n.found && !r.found) {
    const {
      width: s,
      height: l
    } = n, u = {
      x: s / l / 2,
      y: 0.5
    };
    i.style = ap(be(be({}, o), {}, {
      "transform-origin": "".concat(u.x + a.x / 16, "em ").concat(u.y + a.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: i,
    children: t
  }];
}
function eR(e) {
  let {
    prefix: t,
    iconName: n,
    children: r,
    attributes: i,
    symbol: o
  } = e;
  const a = o === !0 ? "".concat(t, "-").concat(Ke.cssPrefix, "-").concat(n) : o;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: be(be({}, i), {}, {
        id: a
      }),
      children: r
    }]
  }];
}
function My(e) {
  const {
    icons: {
      main: t,
      mask: n
    },
    prefix: r,
    iconName: i,
    transform: o,
    symbol: a,
    title: s,
    maskId: l,
    titleId: u,
    extra: c,
    watchable: f = !1
  } = e, {
    width: d,
    height: p
  } = n.found ? n : t, h = eN.includes(r), v = [Ke.replacementClass, i ? "".concat(Ke.cssPrefix, "-").concat(i) : ""].filter((S) => c.classes.indexOf(S) === -1).filter((S) => S !== "" || !!S).concat(c.classes).join(" ");
  let m = {
    children: [],
    attributes: be(be({}, c.attributes), {}, {
      "data-prefix": r,
      "data-icon": i,
      class: v,
      role: c.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(d, " ").concat(p)
    })
  };
  const g = h && !~c.classes.indexOf("fa-fw") ? {
    width: "".concat(d / p * 16 * 0.0625, "em")
  } : {};
  f && (m.attributes[ma] = ""), s && (m.children.push({
    tag: "title",
    attributes: {
      id: m.attributes["aria-labelledby"] || "title-".concat(u || $u())
    },
    children: [s]
  }), delete m.attributes.title);
  const _ = be(be({}, m), {}, {
    prefix: r,
    iconName: i,
    main: t,
    mask: n,
    maskId: l,
    transform: o,
    symbol: a,
    styles: be(be({}, g), c.styles)
  }), {
    children: w,
    attributes: x
  } = n.found && t.found ? Po("generateAbstractMask", _) || {
    children: [],
    attributes: {}
  } : Po("generateAbstractIcon", _) || {
    children: [],
    attributes: {}
  };
  return _.children = w, _.attributes = x, a ? eR(_) : XN(_);
}
function J_(e) {
  const {
    content: t,
    width: n,
    height: r,
    transform: i,
    title: o,
    extra: a,
    watchable: s = !1
  } = e, l = be(be(be({}, a.attributes), o ? {
    title: o
  } : {}), {}, {
    class: a.classes.join(" ")
  });
  s && (l[ma] = "");
  const u = be({}, a.styles);
  Iy(i) && (u.transform = PN({
    transform: i,
    startCentered: !0,
    width: n,
    height: r
  }), u["-webkit-transform"] = u.transform);
  const c = ap(u);
  c.length > 0 && (l.style = c);
  const f = [];
  return f.push({
    tag: "span",
    attributes: l,
    children: [t]
  }), o && f.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [o]
  }), f;
}
function tR(e) {
  const {
    content: t,
    title: n,
    extra: r
  } = e, i = be(be(be({}, r.attributes), n ? {
    title: n
  } : {}), {}, {
    class: r.classes.join(" ")
  }), o = ap(r.styles);
  o.length > 0 && (i.style = o);
  const a = [];
  return a.push({
    tag: "span",
    attributes: i,
    children: [t]
  }), n && a.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), a;
}
const {
  styles: Dh
} = Si;
function gm(e) {
  const t = e[0], n = e[1], [r] = e.slice(4);
  let i = null;
  return Array.isArray(r) ? i = {
    tag: "g",
    attributes: {
      class: "".concat(Ke.cssPrefix, "-").concat(Th.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(Ke.cssPrefix, "-").concat(Th.SECONDARY),
        fill: "currentColor",
        d: r[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(Ke.cssPrefix, "-").concat(Th.PRIMARY),
        fill: "currentColor",
        d: r[1]
      }
    }]
  } : i = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: r
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: i
  };
}
const nR = {
  found: !1,
  width: 512,
  height: 512
};
function rR(e, t) {
  !NO && !Ke.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function ym(e, t) {
  let n = t;
  return t === "fa" && Ke.styleDefault !== null && (t = To()), new Promise((r, i) => {
    if (n === "fa") {
      const o = GO(e) || {};
      e = o.iconName || e, t = o.prefix || t;
    }
    if (e && t && Dh[t] && Dh[t][e]) {
      const o = Dh[t][e];
      return r(gm(o));
    }
    rR(e, t), r(be(be({}, nR), {}, {
      icon: Ke.showMissingIcons && e ? Po("missingIconAbstract") || {} : {}
    }));
  });
}
const X_ = () => {
}, bm = Ke.measurePerformance && zc && zc.mark && zc.measure ? zc : {
  mark: X_,
  measure: X_
}, Wl = 'FA "6.7.2"', iR = (e) => (bm.mark("".concat(Wl, " ").concat(e, " begins")), () => JO(e)), JO = (e) => {
  bm.mark("".concat(Wl, " ").concat(e, " ends")), bm.measure("".concat(Wl, " ").concat(e), "".concat(Wl, " ").concat(e, " begins"), "".concat(Wl, " ").concat(e, " ends"));
};
var jy = {
  begin: iR,
  end: JO
};
const Tf = () => {
};
function e1(e) {
  return typeof (e.getAttribute ? e.getAttribute(ma) : null) == "string";
}
function oR(e) {
  const t = e.getAttribute ? e.getAttribute(ky) : null, n = e.getAttribute ? e.getAttribute(Dy) : null;
  return t && n;
}
function aR(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(Ke.replacementClass);
}
function sR() {
  return Ke.autoReplaceSvg === !0 ? Pf.replace : Pf[Ke.autoReplaceSvg] || Pf.replace;
}
function lR(e) {
  return Rt.createElementNS("http://www.w3.org/2000/svg", e);
}
function uR(e) {
  return Rt.createElement(e);
}
function XO(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: n = e.tag === "svg" ? lR : uR
  } = t;
  if (typeof e == "string")
    return Rt.createTextNode(e);
  const r = n(e.tag);
  return Object.keys(e.attributes || []).forEach(function(o) {
    r.setAttribute(o, e.attributes[o]);
  }), (e.children || []).forEach(function(o) {
    r.appendChild(XO(o, {
      ceFn: n
    }));
  }), r;
}
function cR(e) {
  let t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
const Pf = {
  replace: function(e) {
    const t = e[0];
    if (t.parentNode)
      if (e[1].forEach((n) => {
        t.parentNode.insertBefore(XO(n), t);
      }), t.getAttribute(ma) === null && Ke.keepOriginalSource) {
        let n = Rt.createComment(cR(t));
        t.parentNode.replaceChild(n, t);
      } else
        t.remove();
  },
  nest: function(e) {
    const t = e[0], n = e[1];
    if (~Cy(t).indexOf(Ke.replacementClass))
      return Pf.replace(e);
    const r = new RegExp("".concat(Ke.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      const o = n[0].attributes.class.split(" ").reduce((a, s) => (s === Ke.replacementClass || s.match(r) ? a.toSvg.push(s) : a.toNode.push(s), a), {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = o.toSvg.join(" "), o.toNode.length === 0 ? t.removeAttribute("class") : t.setAttribute("class", o.toNode.join(" "));
    }
    const i = n.map((o) => uc(o)).join(`
`);
    t.setAttribute(ma, ""), t.innerHTML = i;
  }
};
function t1(e) {
  e();
}
function e$(e, t) {
  const n = typeof t == "function" ? t : Tf;
  if (e.length === 0)
    n();
  else {
    let r = t1;
    Ke.mutateApproach === pN && (r = $o.requestAnimationFrame || t1), r(() => {
      const i = sR(), o = jy.begin("mutate");
      e.map(i), o(), n();
    });
  }
}
let Fy = !1;
function t$() {
  Fy = !0;
}
function _m() {
  Fy = !1;
}
let td = null;
function n1(e) {
  if (!K_ || !Ke.observeMutations)
    return;
  const {
    treeCallback: t = Tf,
    nodeCallback: n = Tf,
    pseudoElementsCallback: r = Tf,
    observeMutationsRoot: i = Rt
  } = e;
  td = new K_((o) => {
    if (Fy) return;
    const a = To();
    el(o).forEach((s) => {
      if (s.type === "childList" && s.addedNodes.length > 0 && !e1(s.addedNodes[0]) && (Ke.searchPseudoElements && r(s.target), t(s.target)), s.type === "attributes" && s.target.parentNode && Ke.searchPseudoElements && r(s.target.parentNode), s.type === "attributes" && e1(s.target) && ~bN.indexOf(s.attributeName))
        if (s.attributeName === "class" && oR(s.target)) {
          const {
            prefix: l,
            iconName: u
          } = lp(Cy(s.target));
          s.target.setAttribute(ky, l || a), u && s.target.setAttribute(Dy, u);
        } else aR(s.target) && n(s.target);
    });
  }), eo && td.observe(i, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function fR() {
  td && td.disconnect();
}
function dR(e) {
  const t = e.getAttribute("style");
  let n = [];
  return t && (n = t.split(";").reduce((r, i) => {
    const o = i.split(":"), a = o[0], s = o.slice(1);
    return a && s.length > 0 && (r[a] = s.join(":").trim()), r;
  }, {})), n;
}
function pR(e) {
  const t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), r = e.innerText !== void 0 ? e.innerText.trim() : "";
  let i = lp(Cy(e));
  return i.prefix || (i.prefix = To()), t && n && (i.prefix = t, i.iconName = n), i.iconName && i.prefix || (i.prefix && r.length > 0 && (i.iconName = FN(i.prefix, e.innerText) || Ry(i.prefix, pm(e.innerText))), !i.iconName && Ke.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (i.iconName = e.firstChild.data)), i;
}
function hR(e) {
  const t = el(e.attributes).reduce((i, o) => (i.name !== "class" && i.name !== "style" && (i[o.name] = o.value), i), {}), n = e.getAttribute("title"), r = e.getAttribute("data-fa-title-id");
  return Ke.autoA11y && (n ? t["aria-labelledby"] = "".concat(Ke.replacementClass, "-title-").concat(r || $u()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function vR() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: Ei,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function r1(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: n,
    prefix: r,
    rest: i
  } = pR(e), o = hR(e), a = vm("parseNodeAttributes", {}, e);
  let s = t.styleParser ? dR(e) : [];
  return be({
    iconName: n,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: r,
    transform: Ei,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: i,
      styles: s,
      attributes: o
    }
  }, a);
}
const {
  styles: mR
} = Si;
function n$(e) {
  const t = Ke.autoReplaceSvg === "nest" ? r1(e, {
    styleParser: !1
  }) : r1(e);
  return ~t.extra.classes.indexOf(MO) ? Po("generateLayersText", e, t) : Po("generateSvgReplacementMutation", e, t);
}
function gR() {
  return [...Q6, ...sm];
}
function i1(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!eo) return Promise.resolve();
  const n = Rt.documentElement.classList, r = (c) => n.add("".concat(q_, "-").concat(c)), i = (c) => n.remove("".concat(q_, "-").concat(c)), o = Ke.autoFetchSvg ? gR() : kO.concat(Object.keys(mR));
  o.includes("fa") || o.push("fa");
  const a = [".".concat(MO, ":not([").concat(ma, "])")].concat(o.map((c) => ".".concat(c, ":not([").concat(ma, "])"))).join(", ");
  if (a.length === 0)
    return Promise.resolve();
  let s = [];
  try {
    s = el(e.querySelectorAll(a));
  } catch {
  }
  if (s.length > 0)
    r("pending"), i("complete");
  else
    return Promise.resolve();
  const l = jy.begin("onTree"), u = s.reduce((c, f) => {
    try {
      const d = n$(f);
      d && c.push(d);
    } catch (d) {
      NO || d.name === "MissingIcon" && console.error(d);
    }
    return c;
  }, []);
  return new Promise((c, f) => {
    Promise.all(u).then((d) => {
      e$(d, () => {
        r("active"), r("complete"), i("pending"), typeof t == "function" && t(), l(), c();
      });
    }).catch((d) => {
      l(), f(d);
    });
  });
}
function yR(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  n$(e).then((n) => {
    n && e$([n], t);
  });
}
function bR(e) {
  return function(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = (t || {}).icon ? t : mm(t || {});
    let {
      mask: i
    } = n;
    return i && (i = (i || {}).icon ? i : mm(i || {})), e(r, be(be({}, n), {}, {
      mask: i
    }));
  };
}
const _R = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: n = Ei,
    symbol: r = !1,
    mask: i = null,
    maskId: o = null,
    title: a = null,
    titleId: s = null,
    classes: l = [],
    attributes: u = {},
    styles: c = {}
  } = t;
  if (!e) return;
  const {
    prefix: f,
    iconName: d,
    icon: p
  } = e;
  return up(be({
    type: "icon"
  }, e), () => (ga("beforeDOMElementCreation", {
    iconDefinition: e,
    params: t
  }), Ke.autoA11y && (a ? u["aria-labelledby"] = "".concat(Ke.replacementClass, "-title-").concat(s || $u()) : (u["aria-hidden"] = "true", u.focusable = "false")), My({
    icons: {
      main: gm(p),
      mask: i ? gm(i.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: f,
    iconName: d,
    transform: be(be({}, Ei), n),
    symbol: r,
    title: a,
    maskId: o,
    titleId: s,
    extra: {
      attributes: u,
      styles: c,
      classes: l
    }
  })));
};
var wR = {
  mixout() {
    return {
      icon: bR(_R)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.treeCallback = i1, e.nodeCallback = yR, e;
      }
    };
  },
  provides(e) {
    e.i2svg = function(t) {
      const {
        node: n = Rt,
        callback: r = () => {
        }
      } = t;
      return i1(n, r);
    }, e.generateSvgReplacementMutation = function(t, n) {
      const {
        iconName: r,
        title: i,
        titleId: o,
        prefix: a,
        transform: s,
        symbol: l,
        mask: u,
        maskId: c,
        extra: f
      } = n;
      return new Promise((d, p) => {
        Promise.all([ym(r, a), u.iconName ? ym(u.iconName, u.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((h) => {
          let [v, m] = h;
          d([t, My({
            icons: {
              main: v,
              mask: m
            },
            prefix: a,
            iconName: r,
            transform: s,
            symbol: l,
            maskId: c,
            title: i,
            titleId: o,
            extra: f,
            watchable: !0
          })]);
        }).catch(p);
      });
    }, e.generateAbstractIcon = function(t) {
      let {
        children: n,
        attributes: r,
        main: i,
        transform: o,
        styles: a
      } = t;
      const s = ap(a);
      s.length > 0 && (r.style = s);
      let l;
      return Iy(o) && (l = Po("generateAbstractTransformGrouping", {
        main: i,
        transform: o,
        containerWidth: i.width,
        iconWidth: i.width
      })), n.push(l || i.icon), {
        children: n,
        attributes: r
      };
    };
  }
}, xR = {
  mixout() {
    return {
      layer(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: n = []
        } = t;
        return up({
          type: "layer"
        }, () => {
          ga("beforeDOMElementCreation", {
            assembler: e,
            params: t
          });
          let r = [];
          return e((i) => {
            Array.isArray(i) ? i.map((o) => {
              r = r.concat(o.abstract);
            }) : r = r.concat(i.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(Ke.cssPrefix, "-layers"), ...n].join(" ")
            },
            children: r
          }];
        });
      }
    };
  }
}, ER = {
  mixout() {
    return {
      counter(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: n = null,
          classes: r = [],
          attributes: i = {},
          styles: o = {}
        } = t;
        return up({
          type: "counter",
          content: e
        }, () => (ga("beforeDOMElementCreation", {
          content: e,
          params: t
        }), tR({
          content: e.toString(),
          title: n,
          extra: {
            attributes: i,
            styles: o,
            classes: ["".concat(Ke.cssPrefix, "-layers-counter"), ...r]
          }
        })));
      }
    };
  }
}, SR = {
  mixout() {
    return {
      text(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: n = Ei,
          title: r = null,
          classes: i = [],
          attributes: o = {},
          styles: a = {}
        } = t;
        return up({
          type: "text",
          content: e
        }, () => (ga("beforeDOMElementCreation", {
          content: e,
          params: t
        }), J_({
          content: e,
          transform: be(be({}, Ei), n),
          title: r,
          extra: {
            attributes: o,
            styles: a,
            classes: ["".concat(Ke.cssPrefix, "-layers-text"), ...i]
          }
        })));
      }
    };
  },
  provides(e) {
    e.generateLayersText = function(t, n) {
      const {
        title: r,
        transform: i,
        extra: o
      } = n;
      let a = null, s = null;
      if (TO) {
        const l = parseInt(getComputedStyle(t).fontSize, 10), u = t.getBoundingClientRect();
        a = u.width / l, s = u.height / l;
      }
      return Ke.autoA11y && !r && (o.attributes["aria-hidden"] = "true"), Promise.resolve([t, J_({
        content: t.innerHTML,
        width: a,
        height: s,
        transform: i,
        title: r,
        extra: o,
        watchable: !0
      })]);
    };
  }
};
const OR = new RegExp('"', "ug"), o1 = [1105920, 1112319], a1 = be(be(be(be({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), Z6), fN), iN), wm = Object.keys(a1).reduce((e, t) => (e[t.toLowerCase()] = a1[t], e), {}), $R = Object.keys(wm).reduce((e, t) => {
  const n = wm[t];
  return e[t] = n[900] || [...Object.entries(n)][0][1], e;
}, {});
function TR(e) {
  const t = e.replace(OR, ""), n = IN(t, 0), r = n >= o1[0] && n <= o1[1], i = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: pm(i ? t[0] : t),
    isSecondary: r || i
  };
}
function PR(e, t) {
  const n = e.replace(/^['"]|['"]$/g, "").toLowerCase(), r = parseInt(t), i = isNaN(r) ? "normal" : r;
  return (wm[n] || {})[i] || $R[n];
}
function s1(e, t) {
  const n = "".concat(dN).concat(t.replace(":", "-"));
  return new Promise((r, i) => {
    if (e.getAttribute(n) !== null)
      return r();
    const a = el(e.children).filter((d) => d.getAttribute(um) === t)[0], s = $o.getComputedStyle(e, t), l = s.getPropertyValue("font-family"), u = l.match(gN), c = s.getPropertyValue("font-weight"), f = s.getPropertyValue("content");
    if (a && !u)
      return e.removeChild(a), r();
    if (u && f !== "none" && f !== "") {
      const d = s.getPropertyValue("content");
      let p = PR(l, c);
      const {
        value: h,
        isSecondary: v
      } = TR(d), m = u[0].startsWith("FontAwesome");
      let g = Ry(p, h), _ = g;
      if (m) {
        const w = zN(h);
        w.iconName && w.prefix && (g = w.iconName, p = w.prefix);
      }
      if (g && !v && (!a || a.getAttribute(ky) !== p || a.getAttribute(Dy) !== _)) {
        e.setAttribute(n, _), a && e.removeChild(a);
        const w = vR(), {
          extra: x
        } = w;
        x.attributes[um] = t, ym(g, p).then((S) => {
          const $ = My(be(be({}, w), {}, {
            icons: {
              main: S,
              mask: YO()
            },
            prefix: p,
            iconName: _,
            extra: x,
            watchable: !0
          })), A = Rt.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(A, e.firstChild) : e.appendChild(A), A.outerHTML = $.map((E) => uc(E)).join(`
`), e.removeAttribute(n), r();
        }).catch(i);
      } else
        r();
    } else
      r();
  });
}
function kR(e) {
  return Promise.all([s1(e, "::before"), s1(e, "::after")]);
}
function DR(e) {
  return e.parentNode !== document.head && !~hN.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(um) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function l1(e) {
  if (eo)
    return new Promise((t, n) => {
      const r = el(e.querySelectorAll("*")).filter(DR).map(kR), i = jy.begin("searchPseudoElements");
      t$(), Promise.all(r).then(() => {
        i(), _m(), t();
      }).catch(() => {
        i(), _m(), n();
      });
    });
}
var AR = {
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.pseudoElementsCallback = l1, e;
      }
    };
  },
  provides(e) {
    e.pseudoElements2svg = function(t) {
      const {
        node: n = Rt
      } = t;
      Ke.searchPseudoElements && l1(n);
    };
  }
};
let u1 = !1;
var CR = {
  mixout() {
    return {
      dom: {
        unwatch() {
          t$(), u1 = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        n1(vm("mutationObserverCallbacks", {}));
      },
      noAuto() {
        fR();
      },
      watch(e) {
        const {
          observeMutationsRoot: t
        } = e;
        u1 ? _m() : n1(vm("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
};
const c1 = (e) => {
  let t = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce((n, r) => {
    const i = r.toLowerCase().split("-"), o = i[0];
    let a = i.slice(1).join("-");
    if (o && a === "h")
      return n.flipX = !0, n;
    if (o && a === "v")
      return n.flipY = !0, n;
    if (a = parseFloat(a), isNaN(a))
      return n;
    switch (o) {
      case "grow":
        n.size = n.size + a;
        break;
      case "shrink":
        n.size = n.size - a;
        break;
      case "left":
        n.x = n.x - a;
        break;
      case "right":
        n.x = n.x + a;
        break;
      case "up":
        n.y = n.y - a;
        break;
      case "down":
        n.y = n.y + a;
        break;
      case "rotate":
        n.rotate = n.rotate + a;
        break;
    }
    return n;
  }, t);
};
var IR = {
  mixout() {
    return {
      parse: {
        transform: (e) => c1(e)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-transform");
        return n && (e.transform = c1(n)), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractTransformGrouping = function(t) {
      let {
        main: n,
        transform: r,
        containerWidth: i,
        iconWidth: o
      } = t;
      const a = {
        transform: "translate(".concat(i / 2, " 256)")
      }, s = "translate(".concat(r.x * 32, ", ").concat(r.y * 32, ") "), l = "scale(".concat(r.size / 16 * (r.flipX ? -1 : 1), ", ").concat(r.size / 16 * (r.flipY ? -1 : 1), ") "), u = "rotate(".concat(r.rotate, " 0 0)"), c = {
        transform: "".concat(s, " ").concat(l, " ").concat(u)
      }, f = {
        transform: "translate(".concat(o / 2 * -1, " -256)")
      }, d = {
        outer: a,
        inner: c,
        path: f
      };
      return {
        tag: "g",
        attributes: be({}, d.outer),
        children: [{
          tag: "g",
          attributes: be({}, d.inner),
          children: [{
            tag: n.icon.tag,
            children: n.icon.children,
            attributes: be(be({}, n.icon.attributes), d.path)
          }]
        }]
      };
    };
  }
};
const Ah = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function f1(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function NR(e) {
  return e.tag === "g" ? e.children : [e];
}
var RR = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-mask"), r = n ? lp(n.split(" ").map((i) => i.trim())) : YO();
        return r.prefix || (r.prefix = To()), e.mask = r, e.maskId = t.getAttribute("data-fa-mask-id"), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractMask = function(t) {
      let {
        children: n,
        attributes: r,
        main: i,
        mask: o,
        maskId: a,
        transform: s
      } = t;
      const {
        width: l,
        icon: u
      } = i, {
        width: c,
        icon: f
      } = o, d = TN({
        transform: s,
        containerWidth: c,
        iconWidth: l
      }), p = {
        tag: "rect",
        attributes: be(be({}, Ah), {}, {
          fill: "white"
        })
      }, h = u.children ? {
        children: u.children.map(f1)
      } : {}, v = {
        tag: "g",
        attributes: be({}, d.inner),
        children: [f1(be({
          tag: u.tag,
          attributes: be(be({}, u.attributes), d.path)
        }, h))]
      }, m = {
        tag: "g",
        attributes: be({}, d.outer),
        children: [v]
      }, g = "mask-".concat(a || $u()), _ = "clip-".concat(a || $u()), w = {
        tag: "mask",
        attributes: be(be({}, Ah), {}, {
          id: g,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [p, m]
      }, x = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: _
          },
          children: NR(f)
        }, w]
      };
      return n.push(x, {
        tag: "rect",
        attributes: be({
          fill: "currentColor",
          "clip-path": "url(#".concat(_, ")"),
          mask: "url(#".concat(g, ")")
        }, Ah)
      }), {
        children: n,
        attributes: r
      };
    };
  }
}, MR = {
  provides(e) {
    let t = !1;
    $o.matchMedia && (t = $o.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      const n = [], r = {
        fill: "currentColor"
      }, i = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n.push({
        tag: "path",
        attributes: be(be({}, r), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const o = be(be({}, i), {}, {
        attributeName: "opacity"
      }), a = {
        tag: "circle",
        attributes: be(be({}, r), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return t || a.children.push({
        tag: "animate",
        attributes: be(be({}, i), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: be(be({}, o), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), n.push(a), n.push({
        tag: "path",
        attributes: be(be({}, r), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: t ? [] : [{
          tag: "animate",
          attributes: be(be({}, o), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), t || n.push({
        tag: "path",
        attributes: be(be({}, r), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: be(be({}, o), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n
      };
    };
  }
}, jR = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-symbol"), r = n === null ? !1 : n === "" ? !0 : n;
        return e.symbol = r, e;
      }
    };
  }
}, FR = [DN, wR, xR, ER, SR, AR, CR, IR, RR, MR, jR];
ZN(FR, {
  mixoutsTo: yr
});
yr.noAuto;
yr.config;
yr.library;
yr.dom;
const xm = yr.parse;
yr.findIconDefinition;
yr.toHtml;
const zR = yr.icon;
yr.layer;
yr.text;
yr.counter;
var Vc = { exports: {} }, Kc = { exports: {} }, gt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var d1;
function LR() {
  if (d1) return gt;
  d1 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function w(S) {
    if (typeof S == "object" && S !== null) {
      var $ = S.$$typeof;
      switch ($) {
        case t:
          switch (S = S.type, S) {
            case l:
            case u:
            case r:
            case o:
            case i:
            case f:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case s:
                case c:
                case h:
                case p:
                case a:
                  return S;
                default:
                  return $;
              }
          }
        case n:
          return $;
      }
    }
  }
  function x(S) {
    return w(S) === u;
  }
  return gt.AsyncMode = l, gt.ConcurrentMode = u, gt.ContextConsumer = s, gt.ContextProvider = a, gt.Element = t, gt.ForwardRef = c, gt.Fragment = r, gt.Lazy = h, gt.Memo = p, gt.Portal = n, gt.Profiler = o, gt.StrictMode = i, gt.Suspense = f, gt.isAsyncMode = function(S) {
    return x(S) || w(S) === l;
  }, gt.isConcurrentMode = x, gt.isContextConsumer = function(S) {
    return w(S) === s;
  }, gt.isContextProvider = function(S) {
    return w(S) === a;
  }, gt.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === t;
  }, gt.isForwardRef = function(S) {
    return w(S) === c;
  }, gt.isFragment = function(S) {
    return w(S) === r;
  }, gt.isLazy = function(S) {
    return w(S) === h;
  }, gt.isMemo = function(S) {
    return w(S) === p;
  }, gt.isPortal = function(S) {
    return w(S) === n;
  }, gt.isProfiler = function(S) {
    return w(S) === o;
  }, gt.isStrictMode = function(S) {
    return w(S) === i;
  }, gt.isSuspense = function(S) {
    return w(S) === f;
  }, gt.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === r || S === u || S === o || S === i || S === f || S === d || typeof S == "object" && S !== null && (S.$$typeof === h || S.$$typeof === p || S.$$typeof === a || S.$$typeof === s || S.$$typeof === c || S.$$typeof === m || S.$$typeof === g || S.$$typeof === _ || S.$$typeof === v);
  }, gt.typeOf = w, gt;
}
var yt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var p1;
function VR() {
  return p1 || (p1 = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function w(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === r || j === u || j === o || j === i || j === f || j === d || typeof j == "object" && j !== null && (j.$$typeof === h || j.$$typeof === p || j.$$typeof === a || j.$$typeof === s || j.$$typeof === c || j.$$typeof === m || j.$$typeof === g || j.$$typeof === _ || j.$$typeof === v);
    }
    function x(j) {
      if (typeof j == "object" && j !== null) {
        var W = j.$$typeof;
        switch (W) {
          case t:
            var J = j.type;
            switch (J) {
              case l:
              case u:
              case r:
              case o:
              case i:
              case f:
                return J;
              default:
                var le = J && J.$$typeof;
                switch (le) {
                  case s:
                  case c:
                  case h:
                  case p:
                  case a:
                    return le;
                  default:
                    return W;
                }
            }
          case n:
            return W;
        }
      }
    }
    var S = l, $ = u, A = s, E = a, y = t, b = c, O = r, k = h, I = p, T = n, V = o, z = i, B = f, q = !1;
    function M(j) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), N(j) || x(j) === l;
    }
    function N(j) {
      return x(j) === u;
    }
    function Y(j) {
      return x(j) === s;
    }
    function ee(j) {
      return x(j) === a;
    }
    function Q(j) {
      return typeof j == "object" && j !== null && j.$$typeof === t;
    }
    function K(j) {
      return x(j) === c;
    }
    function ne(j) {
      return x(j) === r;
    }
    function se(j) {
      return x(j) === h;
    }
    function ce(j) {
      return x(j) === p;
    }
    function X(j) {
      return x(j) === n;
    }
    function D(j) {
      return x(j) === o;
    }
    function P(j) {
      return x(j) === i;
    }
    function R(j) {
      return x(j) === f;
    }
    yt.AsyncMode = S, yt.ConcurrentMode = $, yt.ContextConsumer = A, yt.ContextProvider = E, yt.Element = y, yt.ForwardRef = b, yt.Fragment = O, yt.Lazy = k, yt.Memo = I, yt.Portal = T, yt.Profiler = V, yt.StrictMode = z, yt.Suspense = B, yt.isAsyncMode = M, yt.isConcurrentMode = N, yt.isContextConsumer = Y, yt.isContextProvider = ee, yt.isElement = Q, yt.isForwardRef = K, yt.isFragment = ne, yt.isLazy = se, yt.isMemo = ce, yt.isPortal = X, yt.isProfiler = D, yt.isStrictMode = P, yt.isSuspense = R, yt.isValidElementType = w, yt.typeOf = x;
  })()), yt;
}
var h1;
function r$() {
  return h1 || (h1 = 1, process.env.NODE_ENV === "production" ? Kc.exports = LR() : Kc.exports = VR()), Kc.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ch, v1;
function KR() {
  if (v1) return Ch;
  v1 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(c) {
        return a[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ch = i() ? Object.assign : function(o, a) {
    for (var s, l = r(o), u, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var f in s)
        t.call(s, f) && (l[f] = s[f]);
      if (e) {
        u = e(s);
        for (var d = 0; d < u.length; d++)
          n.call(s, u[d]) && (l[u[d]] = s[u[d]]);
      }
    }
    return l;
  }, Ch;
}
var Ih, m1;
function zy() {
  if (m1) return Ih;
  m1 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ih = e, Ih;
}
var Nh, g1;
function i$() {
  return g1 || (g1 = 1, Nh = Function.call.bind(Object.prototype.hasOwnProperty)), Nh;
}
var Rh, y1;
function BR() {
  if (y1) return Rh;
  y1 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ zy(), n = {}, r = /* @__PURE__ */ i$();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in o)
        if (r(o, c)) {
          var f;
          try {
            if (typeof o[c] != "function") {
              var d = Error(
                (l || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = o[c](a, c, l, s, null, t);
          } catch (h) {
            f = h;
          }
          if (f && !(f instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var p = u ? u() : "";
            e(
              "Failed " + s + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Rh = i, Rh;
}
var Mh, b1;
function UR() {
  if (b1) return Mh;
  b1 = 1;
  var e = r$(), t = KR(), n = /* @__PURE__ */ zy(), r = /* @__PURE__ */ i$(), i = /* @__PURE__ */ BR(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Mh = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function f(N) {
      var Y = N && (u && N[u] || N[c]);
      if (typeof Y == "function")
        return Y;
    }
    var d = "<<anonymous>>", p = {
      array: g("array"),
      bigint: g("bigint"),
      bool: g("boolean"),
      func: g("function"),
      number: g("number"),
      object: g("object"),
      string: g("string"),
      symbol: g("symbol"),
      any: _(),
      arrayOf: w,
      element: x(),
      elementType: S(),
      instanceOf: $,
      node: b(),
      objectOf: E,
      oneOf: A,
      oneOfType: y,
      shape: k,
      exact: I
    };
    function h(N, Y) {
      return N === Y ? N !== 0 || 1 / N === 1 / Y : N !== N && Y !== Y;
    }
    function v(N, Y) {
      this.message = N, this.data = Y && typeof Y == "object" ? Y : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function m(N) {
      if (process.env.NODE_ENV !== "production")
        var Y = {}, ee = 0;
      function Q(ne, se, ce, X, D, P, R) {
        if (X = X || d, P = P || ce, R !== n) {
          if (l) {
            var j = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw j.name = "Invariant Violation", j;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var W = X + ":" + ce;
            !Y[W] && // Avoid spamming the console because they are often not actionable except for lib authors
            ee < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + P + "` prop on `" + X + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Y[W] = !0, ee++);
          }
        }
        return se[ce] == null ? ne ? se[ce] === null ? new v("The " + D + " `" + P + "` is marked as required " + ("in `" + X + "`, but its value is `null`.")) : new v("The " + D + " `" + P + "` is marked as required in " + ("`" + X + "`, but its value is `undefined`.")) : null : N(se, ce, X, D, P);
      }
      var K = Q.bind(null, !1);
      return K.isRequired = Q.bind(null, !0), K;
    }
    function g(N) {
      function Y(ee, Q, K, ne, se, ce) {
        var X = ee[Q], D = z(X);
        if (D !== N) {
          var P = B(X);
          return new v(
            "Invalid " + ne + " `" + se + "` of type " + ("`" + P + "` supplied to `" + K + "`, expected ") + ("`" + N + "`."),
            { expectedType: N }
          );
        }
        return null;
      }
      return m(Y);
    }
    function _() {
      return m(a);
    }
    function w(N) {
      function Y(ee, Q, K, ne, se) {
        if (typeof N != "function")
          return new v("Property `" + se + "` of component `" + K + "` has invalid PropType notation inside arrayOf.");
        var ce = ee[Q];
        if (!Array.isArray(ce)) {
          var X = z(ce);
          return new v("Invalid " + ne + " `" + se + "` of type " + ("`" + X + "` supplied to `" + K + "`, expected an array."));
        }
        for (var D = 0; D < ce.length; D++) {
          var P = N(ce, D, K, ne, se + "[" + D + "]", n);
          if (P instanceof Error)
            return P;
        }
        return null;
      }
      return m(Y);
    }
    function x() {
      function N(Y, ee, Q, K, ne) {
        var se = Y[ee];
        if (!s(se)) {
          var ce = z(se);
          return new v("Invalid " + K + " `" + ne + "` of type " + ("`" + ce + "` supplied to `" + Q + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(N);
    }
    function S() {
      function N(Y, ee, Q, K, ne) {
        var se = Y[ee];
        if (!e.isValidElementType(se)) {
          var ce = z(se);
          return new v("Invalid " + K + " `" + ne + "` of type " + ("`" + ce + "` supplied to `" + Q + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(N);
    }
    function $(N) {
      function Y(ee, Q, K, ne, se) {
        if (!(ee[Q] instanceof N)) {
          var ce = N.name || d, X = M(ee[Q]);
          return new v("Invalid " + ne + " `" + se + "` of type " + ("`" + X + "` supplied to `" + K + "`, expected ") + ("instance of `" + ce + "`."));
        }
        return null;
      }
      return m(Y);
    }
    function A(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function Y(ee, Q, K, ne, se) {
        for (var ce = ee[Q], X = 0; X < N.length; X++)
          if (h(ce, N[X]))
            return null;
        var D = JSON.stringify(N, function(R, j) {
          var W = B(j);
          return W === "symbol" ? String(j) : j;
        });
        return new v("Invalid " + ne + " `" + se + "` of value `" + String(ce) + "` " + ("supplied to `" + K + "`, expected one of " + D + "."));
      }
      return m(Y);
    }
    function E(N) {
      function Y(ee, Q, K, ne, se) {
        if (typeof N != "function")
          return new v("Property `" + se + "` of component `" + K + "` has invalid PropType notation inside objectOf.");
        var ce = ee[Q], X = z(ce);
        if (X !== "object")
          return new v("Invalid " + ne + " `" + se + "` of type " + ("`" + X + "` supplied to `" + K + "`, expected an object."));
        for (var D in ce)
          if (r(ce, D)) {
            var P = N(ce, D, K, ne, se + "." + D, n);
            if (P instanceof Error)
              return P;
          }
        return null;
      }
      return m(Y);
    }
    function y(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var Y = 0; Y < N.length; Y++) {
        var ee = N[Y];
        if (typeof ee != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + q(ee) + " at index " + Y + "."
          ), a;
      }
      function Q(K, ne, se, ce, X) {
        for (var D = [], P = 0; P < N.length; P++) {
          var R = N[P], j = R(K, ne, se, ce, X, n);
          if (j == null)
            return null;
          j.data && r(j.data, "expectedType") && D.push(j.data.expectedType);
        }
        var W = D.length > 0 ? ", expected one of type [" + D.join(", ") + "]" : "";
        return new v("Invalid " + ce + " `" + X + "` supplied to " + ("`" + se + "`" + W + "."));
      }
      return m(Q);
    }
    function b() {
      function N(Y, ee, Q, K, ne) {
        return T(Y[ee]) ? null : new v("Invalid " + K + " `" + ne + "` supplied to " + ("`" + Q + "`, expected a ReactNode."));
      }
      return m(N);
    }
    function O(N, Y, ee, Q, K) {
      return new v(
        (N || "React class") + ": " + Y + " type `" + ee + "." + Q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + K + "`."
      );
    }
    function k(N) {
      function Y(ee, Q, K, ne, se) {
        var ce = ee[Q], X = z(ce);
        if (X !== "object")
          return new v("Invalid " + ne + " `" + se + "` of type `" + X + "` " + ("supplied to `" + K + "`, expected `object`."));
        for (var D in N) {
          var P = N[D];
          if (typeof P != "function")
            return O(K, ne, se, D, B(P));
          var R = P(ce, D, K, ne, se + "." + D, n);
          if (R)
            return R;
        }
        return null;
      }
      return m(Y);
    }
    function I(N) {
      function Y(ee, Q, K, ne, se) {
        var ce = ee[Q], X = z(ce);
        if (X !== "object")
          return new v("Invalid " + ne + " `" + se + "` of type `" + X + "` " + ("supplied to `" + K + "`, expected `object`."));
        var D = t({}, ee[Q], N);
        for (var P in D) {
          var R = N[P];
          if (r(N, P) && typeof R != "function")
            return O(K, ne, se, P, B(R));
          if (!R)
            return new v(
              "Invalid " + ne + " `" + se + "` key `" + P + "` supplied to `" + K + "`.\nBad object: " + JSON.stringify(ee[Q], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(N), null, "  ")
            );
          var j = R(ce, P, K, ne, se + "." + P, n);
          if (j)
            return j;
        }
        return null;
      }
      return m(Y);
    }
    function T(N) {
      switch (typeof N) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !N;
        case "object":
          if (Array.isArray(N))
            return N.every(T);
          if (N === null || s(N))
            return !0;
          var Y = f(N);
          if (Y) {
            var ee = Y.call(N), Q;
            if (Y !== N.entries) {
              for (; !(Q = ee.next()).done; )
                if (!T(Q.value))
                  return !1;
            } else
              for (; !(Q = ee.next()).done; ) {
                var K = Q.value;
                if (K && !T(K[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function V(N, Y) {
      return N === "symbol" ? !0 : Y ? Y["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Y instanceof Symbol : !1;
    }
    function z(N) {
      var Y = typeof N;
      return Array.isArray(N) ? "array" : N instanceof RegExp ? "object" : V(Y, N) ? "symbol" : Y;
    }
    function B(N) {
      if (typeof N > "u" || N === null)
        return "" + N;
      var Y = z(N);
      if (Y === "object") {
        if (N instanceof Date)
          return "date";
        if (N instanceof RegExp)
          return "regexp";
      }
      return Y;
    }
    function q(N) {
      var Y = B(N);
      switch (Y) {
        case "array":
        case "object":
          return "an " + Y;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Y;
        default:
          return Y;
      }
    }
    function M(N) {
      return !N.constructor || !N.constructor.name ? d : N.constructor.name;
    }
    return p.checkPropTypes = i, p.resetWarningCache = i.resetWarningCache, p.PropTypes = p, p;
  }, Mh;
}
var jh, _1;
function qR() {
  if (_1) return jh;
  _1 = 1;
  var e = /* @__PURE__ */ zy();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, jh = function() {
    function r(a, s, l, u, c, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, jh;
}
var w1;
function HR() {
  if (w1) return Vc.exports;
  if (w1 = 1, process.env.NODE_ENV !== "production") {
    var e = r$(), t = !0;
    Vc.exports = /* @__PURE__ */ UR()(e.isElement, t);
  } else
    Vc.exports = /* @__PURE__ */ qR()();
  return Vc.exports;
}
var WR = /* @__PURE__ */ HR();
const Fe = /* @__PURE__ */ ip(WR);
function x1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function yo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? x1(Object(n), !0).forEach(function(r) {
      as(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : x1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function nd(e) {
  "@babel/helpers - typeof";
  return nd = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, nd(e);
}
function as(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function ZR(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function o$(e, t) {
  if (e == null) return {};
  var n = ZR(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Em(e) {
  return GR(e) || YR(e) || QR(e) || JR();
}
function GR(e) {
  if (Array.isArray(e)) return Sm(e);
}
function YR(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function QR(e, t) {
  if (e) {
    if (typeof e == "string") return Sm(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Sm(e, t);
  }
}
function Sm(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function JR() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function XR(e) {
  var t, n = e.beat, r = e.fade, i = e.beatFade, o = e.bounce, a = e.shake, s = e.flash, l = e.spin, u = e.spinPulse, c = e.spinReverse, f = e.pulse, d = e.fixedWidth, p = e.inverse, h = e.border, v = e.listItem, m = e.flip, g = e.size, _ = e.rotation, w = e.pull, x = (t = {
    "fa-beat": n,
    "fa-fade": r,
    "fa-beat-fade": i,
    "fa-bounce": o,
    "fa-shake": a,
    "fa-flash": s,
    "fa-spin": l,
    "fa-spin-reverse": c,
    "fa-spin-pulse": u,
    "fa-pulse": f,
    "fa-fw": d,
    "fa-inverse": p,
    "fa-border": h,
    "fa-li": v,
    "fa-flip": m === !0,
    "fa-flip-horizontal": m === "horizontal" || m === "both",
    "fa-flip-vertical": m === "vertical" || m === "both"
  }, as(t, "fa-".concat(g), typeof g < "u" && g !== null), as(t, "fa-rotate-".concat(_), typeof _ < "u" && _ !== null && _ !== 0), as(t, "fa-pull-".concat(w), typeof w < "u" && w !== null), as(t, "fa-swap-opacity", e.swapOpacity), t);
  return Object.keys(x).map(function(S) {
    return x[S] ? S : null;
  }).filter(function(S) {
    return S;
  });
}
function eM(e) {
  return e = e - 0, e === e;
}
function a$(e) {
  return eM(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(t, n) {
    return n ? n.toUpperCase() : "";
  }), e.substr(0, 1).toLowerCase() + e.substr(1));
}
var tM = ["style"];
function nM(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function rM(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, n) {
    var r = n.indexOf(":"), i = a$(n.slice(0, r)), o = n.slice(r + 1).trim();
    return i.startsWith("webkit") ? t[nM(i)] = o : t[i] = o, t;
  }, {});
}
function s$(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var r = (t.children || []).map(function(l) {
    return s$(e, l);
  }), i = Object.keys(t.attributes || {}).reduce(function(l, u) {
    var c = t.attributes[u];
    switch (u) {
      case "class":
        l.attrs.className = c, delete t.attributes.class;
        break;
      case "style":
        l.attrs.style = rM(c);
        break;
      default:
        u.indexOf("aria-") === 0 || u.indexOf("data-") === 0 ? l.attrs[u.toLowerCase()] = c : l.attrs[a$(u)] = c;
    }
    return l;
  }, {
    attrs: {}
  }), o = n.style, a = o === void 0 ? {} : o, s = o$(n, tM);
  return i.attrs.style = yo(yo({}, i.attrs.style), a), e.apply(void 0, [t.tag, yo(yo({}, i.attrs), s)].concat(Em(r)));
}
var l$ = !1;
try {
  l$ = process.env.NODE_ENV === "production";
} catch {
}
function iM() {
  if (!l$ && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function E1(e) {
  if (e && nd(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (xm.icon)
    return xm.icon(e);
  if (e === null)
    return null;
  if (e && nd(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
function Fh(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? as({}, e, t) : {};
}
var oM = ["forwardedRef"];
function hr(e) {
  var t = e.forwardedRef, n = o$(e, oM), r = n.icon, i = n.mask, o = n.symbol, a = n.className, s = n.title, l = n.titleId, u = n.maskId, c = E1(r), f = Fh("classes", [].concat(Em(XR(n)), Em(a.split(" ")))), d = Fh("transform", typeof n.transform == "string" ? xm.transform(n.transform) : n.transform), p = Fh("mask", E1(i)), h = zR(c, yo(yo(yo(yo({}, f), d), p), {}, {
    symbol: o,
    title: s,
    titleId: l,
    maskId: u
  }));
  if (!h)
    return iM("Could not find icon", c), null;
  var v = h.abstract, m = {
    ref: t
  };
  return Object.keys(n).forEach(function(g) {
    hr.defaultProps.hasOwnProperty(g) || (m[g] = n[g]);
  }), aM(v[0], m);
}
hr.displayName = "FontAwesomeIcon";
hr.propTypes = {
  beat: Fe.bool,
  border: Fe.bool,
  beatFade: Fe.bool,
  bounce: Fe.bool,
  className: Fe.string,
  fade: Fe.bool,
  flash: Fe.bool,
  mask: Fe.oneOfType([Fe.object, Fe.array, Fe.string]),
  maskId: Fe.string,
  fixedWidth: Fe.bool,
  inverse: Fe.bool,
  flip: Fe.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: Fe.oneOfType([Fe.object, Fe.array, Fe.string]),
  listItem: Fe.bool,
  pull: Fe.oneOf(["right", "left"]),
  pulse: Fe.bool,
  rotation: Fe.oneOf([0, 90, 180, 270]),
  shake: Fe.bool,
  size: Fe.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: Fe.bool,
  spinPulse: Fe.bool,
  spinReverse: Fe.bool,
  symbol: Fe.oneOfType([Fe.bool, Fe.string]),
  title: Fe.string,
  titleId: Fe.string,
  transform: Fe.oneOfType([Fe.string, Fe.object]),
  swapOpacity: Fe.bool
};
hr.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var aM = s$.bind(null, H.createElement);
const sM = ui(
  [
    "absolute",
    "p-1",
    "text-sm",
    "-translate-y-1/2",
    "top-1/2",
    "left-full",
    "text-neutral-800",
    "dark:text-neutral-100",
    "z-[9999]",
    "transition-opacity"
  ],
  {
    variants: {
      visible: {
        true: "opacity-100",
        false: "opacity-0"
      }
    }
  }
), lM = (e) => /* @__PURE__ */ C.jsx("p", { className: sM({ visible: e.visible }), children: "Copied!" }), Xle = ({
  text: e,
  onCopy: t,
  element: n,
  copyElement: r,
  disabled: i = !1,
  className: o = ""
}) => {
  const [a, s] = Ve(!1);
  return /* @__PURE__ */ C.jsxs(
    "button",
    {
      disabled: i,
      className: `${o} relative w-3 h-3`,
      onClick: () => {
        t?.(e), navigator.clipboard.writeText(e), s(!0), setTimeout(() => s(!1), 1500);
      },
      children: [
        n || /* @__PURE__ */ C.jsx(
          hr,
          {
            className: "w-full h-full p-1 cursor-pointer place-items-center aspect-square",
            icon: R6
          }
        ),
        /* @__PURE__ */ C.jsx(lM, { visible: a, children: r || "Copied!" })
      ]
    }
  );
};
var Om = function(e, t) {
  return Om = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, Om(e, t);
};
function u$(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Om(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var we = function() {
  return we = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, we.apply(this, arguments);
};
function Fr(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function Ia(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(c) {
      try {
        u(r.next(c));
      } catch (f) {
        a(f);
      }
    }
    function l(c) {
      try {
        u(r.throw(c));
      } catch (f) {
        a(f);
      }
    }
    function u(c) {
      c.done ? o(c.value) : i(c.value).then(s, l);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function uM(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Zt(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}
function ei(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var S1 = "production", Ly = typeof process > "u" || process.env === void 0 ? S1 : process.env.NODE_ENV || S1, Ri = function(e) {
  return {
    isEnabled: function(t) {
      return e.some(function(n) {
        return !!t[n];
      });
    }
  };
}, Pu = {
  measureLayout: Ri(["layout", "layoutId", "drag"]),
  animation: Ri([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: Ri(["exit"]),
  drag: Ri(["drag", "dragControls"]),
  focus: Ri(["whileFocus"]),
  hover: Ri(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: Ri(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: Ri([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: Ri([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function cM(e) {
  for (var t in e)
    e[t] !== null && (t === "projectionNodeConstructor" ? Pu.projectionNodeConstructor = e[t] : Pu[t].Component = e[t]);
}
var tl = function() {
}, Rr = function() {
};
process.env.NODE_ENV !== "production" && (tl = function(e, t) {
  !e && typeof console < "u" && console.warn(t);
}, Rr = function(e, t) {
  if (!e)
    throw new Error(t);
});
var c$ = He({ strict: !1 }), f$ = Object.keys(Pu), fM = f$.length;
function dM(e, t, n) {
  var r = [], i = Me(c$);
  if (!t)
    return null;
  Ly !== "production" && n && i.strict && Rr(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  for (var o = 0; o < fM; o++) {
    var a = f$[o], s = Pu[a], l = s.isEnabled, u = s.Component;
    l(e) && u && r.push(ie.createElement(u, we({ key: a }, e, { visualElement: t })));
  }
  return r;
}
var Vy = He({
  transformPagePoint: function(e) {
    return e;
  },
  isStatic: !1,
  reducedMotion: "never"
}), cp = He({});
function pM() {
  return Me(cp).visualElement;
}
var cc = He(null), nl = typeof document < "u", rd = nl ? dO : Ee, $m = { current: null }, d$ = !1;
function hM() {
  if (d$ = !0, !!nl)
    if (window.matchMedia) {
      var e = window.matchMedia("(prefers-reduced-motion)"), t = function() {
        return $m.current = e.matches;
      };
      e.addListener(t), t();
    } else
      $m.current = !1;
}
function vM() {
  !d$ && hM();
  var e = Zt(Ve($m.current), 1), t = e[0];
  return t;
}
function mM() {
  var e = vM(), t = Me(Vy).reducedMotion;
  return t === "never" ? !1 : t === "always" ? !0 : e;
}
function gM(e, t, n, r) {
  var i = Me(c$), o = pM(), a = Me(cc), s = mM(), l = _e(void 0);
  r || (r = i.renderer), !l.current && r && (l.current = r(e, {
    visualState: t,
    parent: o,
    props: n,
    presenceId: a?.id,
    blockInitialAnimation: a?.initial === !1,
    shouldReduceMotion: s
  }));
  var u = l.current;
  return rd(function() {
    u?.syncRender();
  }), Ee(function() {
    var c;
    (c = u?.animationState) === null || c === void 0 || c.animateChanges();
  }), rd(function() {
    return function() {
      return u?.notifyUnmount();
    };
  }, []), u;
}
function ss(e) {
  return typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function yM(e, t, n) {
  return Le(
    function(r) {
      var i;
      r && ((i = e.mount) === null || i === void 0 || i.call(e, r)), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : ss(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function p$(e) {
  return Array.isArray(e);
}
function Zr(e) {
  return typeof e == "string" || p$(e);
}
function bM(e) {
  var t = {};
  return e.forEachValue(function(n, r) {
    return t[r] = n.get();
  }), t;
}
function _M(e) {
  var t = {};
  return e.forEachValue(function(n, r) {
    return t[r] = n.getVelocity();
  }), t;
}
function h$(e, t, n, r, i) {
  var o;
  return r === void 0 && (r = {}), i === void 0 && (i = {}), typeof t == "function" && (t = t(n ?? e.custom, r, i)), typeof t == "string" && (t = (o = e.variants) === null || o === void 0 ? void 0 : o[t]), typeof t == "function" && (t = t(n ?? e.custom, r, i)), t;
}
function fp(e, t, n) {
  var r = e.getProps();
  return h$(r, t, n ?? r.custom, bM(e), _M(e));
}
function dp(e) {
  var t;
  return typeof ((t = e.animate) === null || t === void 0 ? void 0 : t.start) == "function" || Zr(e.initial) || Zr(e.animate) || Zr(e.whileHover) || Zr(e.whileDrag) || Zr(e.whileTap) || Zr(e.whileFocus) || Zr(e.exit);
}
function v$(e) {
  return !!(dp(e) || e.variants);
}
function wM(e, t) {
  if (dp(e)) {
    var n = e.initial, r = e.animate;
    return {
      initial: n === !1 || Zr(n) ? n : void 0,
      animate: Zr(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function xM(e) {
  var t = wM(e, Me(cp)), n = t.initial, r = t.animate;
  return Te(function() {
    return { initial: n, animate: r };
  }, [O1(n), O1(r)]);
}
function O1(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
function rl(e) {
  var t = _e(null);
  return t.current === null && (t.current = e()), t.current;
}
var su = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, EM = 1;
function SM() {
  return rl(function() {
    if (su.hasEverUpdated)
      return EM++;
  });
}
var ku = He({}), m$ = He({});
function OM(e, t, n, r) {
  var i, o = t.layoutId, a = t.layout, s = t.drag, l = t.dragConstraints, u = t.layoutScroll, c = Me(m$);
  !r || !n || n?.projection || (n.projection = new r(e, n.getLatestValues(), (i = n.parent) === null || i === void 0 ? void 0 : i.projection), n.projection.setOptions({
    layoutId: o,
    layout: a,
    alwaysMeasureLayout: !!s || l && ss(l),
    visualElement: n,
    scheduleRender: function() {
      return n.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof a == "string" ? a : "both",
    initialPromotionConfig: c,
    layoutScroll: u
  }));
}
var $M = (
  /** @class */
  (function(e) {
    u$(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getSnapshotBeforeUpdate = function() {
      return this.updateProps(), null;
    }, t.prototype.componentDidUpdate = function() {
    }, t.prototype.updateProps = function() {
      var n = this.props, r = n.visualElement, i = n.props;
      r && r.setProps(i);
    }, t.prototype.render = function() {
      return this.props.children;
    }, t;
  })(H.Component)
);
function TM(e) {
  var t = e.preloadedFeatures, n = e.createVisualElement, r = e.projectionNodeConstructor, i = e.useRender, o = e.useVisualState, a = e.Component;
  t && cM(t);
  function s(l, u) {
    var c = PM(l);
    l = we(we({}, l), { layoutId: c });
    var f = Me(Vy), d = null, p = xM(l), h = f.isStatic ? void 0 : SM(), v = o(l, f.isStatic);
    return !f.isStatic && nl && (p.visualElement = gM(a, v, we(we({}, f), l), n), OM(h, l, p.visualElement, r || Pu.projectionNodeConstructor), d = dM(l, p.visualElement, t)), ie.createElement(
      $M,
      { visualElement: p.visualElement, props: we(we({}, f), l) },
      d,
      ie.createElement(cp.Provider, { value: p }, i(a, l, h, yM(v, p.visualElement, u), v, f.isStatic, p.visualElement))
    );
  }
  return fn(s);
}
function PM(e) {
  var t, n = e.layoutId, r = (t = Me(ku)) === null || t === void 0 ? void 0 : t.id;
  return r && n !== void 0 ? r + "-" + n : n;
}
function kM(e) {
  function t(r, i) {
    return i === void 0 && (i = {}), TM(e(r, i));
  }
  if (typeof Proxy > "u")
    return t;
  var n = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(r, i) {
      return n.has(i) || n.set(i, t(i)), n.get(i);
    }
  });
}
var DM = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function Ky(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(DM.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
var id = {};
function AM(e) {
  Object.assign(id, e);
}
var Tm = ["", "X", "Y", "Z"], CM = ["translate", "scale", "rotate", "skew"], Du = ["transformPerspective", "x", "y", "z"];
CM.forEach(function(e) {
  return Tm.forEach(function(t) {
    return Du.push(e + t);
  });
});
function IM(e, t) {
  return Du.indexOf(e) - Du.indexOf(t);
}
var NM = new Set(Du);
function fc(e) {
  return NM.has(e);
}
var RM = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function g$(e) {
  return RM.has(e);
}
function y$(e, t) {
  var n = t.layout, r = t.layoutId;
  return fc(e) || g$(e) || (n || r !== void 0) && (!!id[e] || e === "opacity");
}
var qi = function(e) {
  return !!(e !== null && typeof e == "object" && e.getVelocity);
}, MM = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function jM(e, t, n, r) {
  var i = e.transform, o = e.transformKeys, a = t.enableHardwareAcceleration, s = a === void 0 ? !0 : a, l = t.allowTransformNone, u = l === void 0 ? !0 : l, c = "";
  o.sort(IM);
  for (var f = !1, d = o.length, p = 0; p < d; p++) {
    var h = o[p];
    c += "".concat(MM[h] || h, "(").concat(i[h], ") "), h === "z" && (f = !0);
  }
  return !f && s ? c += "translateZ(0)" : c = c.trim(), r ? c = r(i, n ? "" : c) : u && n && (c = "none"), c;
}
function FM(e) {
  var t = e.originX, n = t === void 0 ? "50%" : t, r = e.originY, i = r === void 0 ? "50%" : r, o = e.originZ, a = o === void 0 ? 0 : o;
  return "".concat(n, " ").concat(i, " ").concat(a);
}
function b$(e) {
  return e.startsWith("--");
}
var zM = function(e, t) {
  return t && typeof e == "number" ? t.transform(e) : e;
};
const _$ = (e, t) => (n) => Math.max(Math.min(n, t), e), lu = (e) => e % 1 ? Number(e.toFixed(5)) : e, Au = /(-)?([\d]*\.?[\d])+/g, Pm = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, LM = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function dc(e) {
  return typeof e == "string";
}
const Na = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, uu = Object.assign(Object.assign({}, Na), { transform: _$(0, 1) }), Bc = Object.assign(Object.assign({}, Na), { default: 1 }), pc = (e) => ({
  test: (t) => dc(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), so = pc("deg"), $i = pc("%"), Ze = pc("px"), VM = pc("vh"), KM = pc("vw"), $1 = Object.assign(Object.assign({}, $i), { parse: (e) => $i.parse(e) / 100, transform: (e) => $i.transform(e * 100) }), By = (e, t) => (n) => !!(dc(n) && LM.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t)), w$ = (e, t, n) => (r) => {
  if (!dc(r))
    return r;
  const [i, o, a, s] = r.match(Au);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(o),
    [n]: parseFloat(a),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, sa = {
  test: By("hsl", "hue"),
  parse: w$("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + $i.transform(lu(t)) + ", " + $i.transform(lu(n)) + ", " + lu(uu.transform(r)) + ")"
}, BM = _$(0, 255), zh = Object.assign(Object.assign({}, Na), { transform: (e) => Math.round(BM(e)) }), bo = {
  test: By("rgb", "red"),
  parse: w$("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + zh.transform(e) + ", " + zh.transform(t) + ", " + zh.transform(n) + ", " + lu(uu.transform(r)) + ")"
};
function UM(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substr(1, 2), n = e.substr(3, 2), r = e.substr(5, 2), i = e.substr(7, 2)) : (t = e.substr(1, 1), n = e.substr(2, 1), r = e.substr(3, 1), i = e.substr(4, 1), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const km = {
  test: By("#"),
  parse: UM,
  transform: bo.transform
}, zn = {
  test: (e) => bo.test(e) || km.test(e) || sa.test(e),
  parse: (e) => bo.test(e) ? bo.parse(e) : sa.test(e) ? sa.parse(e) : km.parse(e),
  transform: (e) => dc(e) ? e : e.hasOwnProperty("red") ? bo.transform(e) : sa.transform(e)
}, x$ = "${c}", E$ = "${n}";
function qM(e) {
  var t, n, r, i;
  return isNaN(e) && dc(e) && ((n = (t = e.match(Au)) === null || t === void 0 ? void 0 : t.length) !== null && n !== void 0 ? n : 0) + ((i = (r = e.match(Pm)) === null || r === void 0 ? void 0 : r.length) !== null && i !== void 0 ? i : 0) > 0;
}
function S$(e) {
  typeof e == "number" && (e = `${e}`);
  const t = [];
  let n = 0;
  const r = e.match(Pm);
  r && (n = r.length, e = e.replace(Pm, x$), t.push(...r.map(zn.parse)));
  const i = e.match(Au);
  return i && (e = e.replace(Au, E$), t.push(...i.map(Na.parse))), { values: t, numColors: n, tokenised: e };
}
function O$(e) {
  return S$(e).values;
}
function $$(e) {
  const { values: t, numColors: n, tokenised: r } = S$(e), i = t.length;
  return (o) => {
    let a = r;
    for (let s = 0; s < i; s++)
      a = a.replace(s < n ? x$ : E$, s < n ? zn.transform(o[s]) : lu(o[s]));
    return a;
  };
}
const HM = (e) => typeof e == "number" ? 0 : e;
function WM(e) {
  const t = O$(e);
  return $$(e)(t.map(HM));
}
const Hi = { test: qM, parse: O$, createTransformer: $$, getAnimatableNone: WM }, ZM = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function GM(e) {
  let [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(Au) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let o = ZM.has(t) ? 1 : 0;
  return r !== n && (o *= 100), t + "(" + o + i + ")";
}
const YM = /([a-z-]*)\(.*?\)/g, Dm = Object.assign(Object.assign({}, Hi), { getAnimatableNone: (e) => {
  const t = e.match(YM);
  return t ? t.map(GM).join(" ") : e;
} });
var T1 = we(we({}, Na), { transform: Math.round }), T$ = {
  // Border props
  borderWidth: Ze,
  borderTopWidth: Ze,
  borderRightWidth: Ze,
  borderBottomWidth: Ze,
  borderLeftWidth: Ze,
  borderRadius: Ze,
  radius: Ze,
  borderTopLeftRadius: Ze,
  borderTopRightRadius: Ze,
  borderBottomRightRadius: Ze,
  borderBottomLeftRadius: Ze,
  // Positioning props
  width: Ze,
  maxWidth: Ze,
  height: Ze,
  maxHeight: Ze,
  size: Ze,
  top: Ze,
  right: Ze,
  bottom: Ze,
  left: Ze,
  // Spacing props
  padding: Ze,
  paddingTop: Ze,
  paddingRight: Ze,
  paddingBottom: Ze,
  paddingLeft: Ze,
  margin: Ze,
  marginTop: Ze,
  marginRight: Ze,
  marginBottom: Ze,
  marginLeft: Ze,
  // Transform props
  rotate: so,
  rotateX: so,
  rotateY: so,
  rotateZ: so,
  scale: Bc,
  scaleX: Bc,
  scaleY: Bc,
  scaleZ: Bc,
  skew: so,
  skewX: so,
  skewY: so,
  distance: Ze,
  translateX: Ze,
  translateY: Ze,
  translateZ: Ze,
  x: Ze,
  y: Ze,
  z: Ze,
  perspective: Ze,
  transformPerspective: Ze,
  opacity: uu,
  originX: $1,
  originY: $1,
  originZ: Ze,
  // Misc
  zIndex: T1,
  // SVG
  fillOpacity: uu,
  strokeOpacity: uu,
  numOctaves: T1
};
function Uy(e, t, n, r) {
  var i, o = e.style, a = e.vars, s = e.transform, l = e.transformKeys, u = e.transformOrigin;
  l.length = 0;
  var c = !1, f = !1, d = !0;
  for (var p in t) {
    var h = t[p];
    if (b$(p)) {
      a[p] = h;
      continue;
    }
    var v = T$[p], m = zM(h, v);
    if (fc(p)) {
      if (c = !0, s[p] = m, l.push(p), !d)
        continue;
      h !== ((i = v.default) !== null && i !== void 0 ? i : 0) && (d = !1);
    } else g$(p) ? (u[p] = m, f = !0) : o[p] = m;
  }
  c ? o.transform = jM(e, n, d, r) : r ? o.transform = r({}, "") : !t.transform && o.transform && (o.transform = "none"), f && (o.transformOrigin = FM(u));
}
var qy = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function P$(e, t, n) {
  for (var r in t)
    !qi(t[r]) && !y$(r, n) && (e[r] = t[r]);
}
function QM(e, t, n) {
  var r = e.transformTemplate;
  return Te(function() {
    var i = qy();
    Uy(i, t, { enableHardwareAcceleration: !n }, r);
    var o = i.vars, a = i.style;
    return we(we({}, o), a);
  }, [t]);
}
function JM(e, t, n) {
  var r = e.style || {}, i = {};
  return P$(i, r, e), Object.assign(i, QM(e, t, n)), e.transformValues && (i = e.transformValues(i)), i;
}
function XM(e, t, n) {
  var r = {}, i = JM(e, t, n);
  return e.drag && e.dragListener !== !1 && (r.draggable = !1, i.userSelect = i.WebkitUserSelect = i.WebkitTouchCallout = "none", i.touchAction = e.drag === !0 ? "none" : "pan-".concat(e.drag === "x" ? "y" : "x")), r.style = i, r;
}
var e5 = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function od(e) {
  return e5.has(e);
}
var k$ = function(e) {
  return !od(e);
};
function t5(e) {
  e && (k$ = function(t) {
    return t.startsWith("on") ? !od(t) : e(t);
  });
}
try {
  t5(require("@emotion/is-prop-valid").default);
} catch {
}
function n5(e, t, n) {
  var r = {};
  for (var i in e)
    (k$(i) || n === !0 && od(i) || !t && !od(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
function P1(e, t, n) {
  return typeof e == "string" ? e : Ze.transform(t + n * e);
}
function r5(e, t, n) {
  var r = P1(t, e.x, e.width), i = P1(n, e.y, e.height);
  return "".concat(r, " ").concat(i);
}
var i5 = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function o5(e, t, n, r, i) {
  n === void 0 && (n = 1), r === void 0 && (r = 0), e.pathLength = 1;
  var o = i5;
  e[o.offset] = Ze.transform(-r);
  var a = Ze.transform(t), s = Ze.transform(n);
  e[o.array] = "".concat(a, " ").concat(s);
}
function Hy(e, t, n, r) {
  var i = t.attrX, o = t.attrY, a = t.originX, s = t.originY, l = t.pathLength, u = t.pathSpacing, c = u === void 0 ? 1 : u, f = t.pathOffset, d = f === void 0 ? 0 : f, p = Fr(t, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  Uy(e, p, n, r), e.attrs = e.style, e.style = {};
  var h = e.attrs, v = e.style, m = e.dimensions;
  h.transform && (m && (v.transform = h.transform), delete h.transform), m && (a !== void 0 || s !== void 0 || v.transform) && (v.transformOrigin = r5(m, a !== void 0 ? a : 0.5, s !== void 0 ? s : 0.5)), i !== void 0 && (h.x = i), o !== void 0 && (h.y = o), l !== void 0 && o5(h, l, c, d);
}
var D$ = function() {
  return we(we({}, qy()), { attrs: {} });
};
function a5(e, t) {
  var n = Te(function() {
    var i = D$();
    return Hy(i, t, { enableHardwareAcceleration: !1 }, e.transformTemplate), we(we({}, i.attrs), { style: we({}, i.style) });
  }, [t]);
  if (e.style) {
    var r = {};
    P$(r, e.style, e), n.style = we(we({}, r), n.style);
  }
  return n;
}
function s5(e) {
  e === void 0 && (e = !1);
  var t = function(n, r, i, o, a, s) {
    var l = a.latestValues, u = Ky(n) ? a5 : XM, c = u(r, l, s), f = n5(r, typeof n == "string", e), d = we(we(we({}, f), c), { ref: o });
    return i && (d["data-projection-id"] = i), q3(n, d);
  };
  return t;
}
var l5 = /([a-z])([A-Z])/g, u5 = "$1-$2", A$ = function(e) {
  return e.replace(l5, u5).toLowerCase();
};
function C$(e, t, n, r) {
  var i = t.style, o = t.vars;
  Object.assign(e.style, i, r && r.getProjectionStyles(n));
  for (var a in o)
    e.style.setProperty(a, o[a]);
}
var I$ = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function N$(e, t, n, r) {
  C$(e, t, void 0, r);
  for (var i in t.attrs)
    e.setAttribute(I$.has(i) ? i : A$(i), t.attrs[i]);
}
function Wy(e) {
  var t = e.style, n = {};
  for (var r in t)
    (qi(t[r]) || y$(r, e)) && (n[r] = t[r]);
  return n;
}
function R$(e) {
  var t = Wy(e);
  for (var n in e)
    if (qi(e[n])) {
      var r = n === "x" || n === "y" ? "attr" + n.toUpperCase() : n;
      t[r] = e[n];
    }
  return t;
}
function Zy(e) {
  return typeof e == "object" && typeof e.start == "function";
}
var Cu = function(e) {
  return Array.isArray(e);
}, c5 = function(e) {
  return !!(e && typeof e == "object" && e.mix && e.toValue);
}, M$ = function(e) {
  return Cu(e) ? e[e.length - 1] || 0 : e;
};
function kf(e) {
  var t = qi(e) ? e.get() : e;
  return c5(t) ? t.toValue() : t;
}
function k1(e, t, n, r) {
  var i = e.scrapeMotionValuesFromProps, o = e.createRenderState, a = e.onMount, s = {
    latestValues: f5(t, n, r, i),
    renderState: o()
  };
  return a && (s.mount = function(l) {
    return a(t, l, s);
  }), s;
}
var j$ = function(e) {
  return function(t, n) {
    var r = Me(cp), i = Me(cc);
    return n ? k1(e, t, r, i) : rl(function() {
      return k1(e, t, r, i);
    });
  };
};
function f5(e, t, n, r) {
  var i = {}, o = n?.initial === !1, a = r(e);
  for (var s in a)
    i[s] = kf(a[s]);
  var l = e.initial, u = e.animate, c = dp(e), f = v$(e);
  t && f && !c && e.inherit !== !1 && (l ?? (l = t.initial), u ?? (u = t.animate));
  var d = o || l === !1, p = d ? u : l;
  if (p && typeof p != "boolean" && !Zy(p)) {
    var h = Array.isArray(p) ? p : [p];
    h.forEach(function(v) {
      var m = h$(e, v);
      if (m) {
        var g = m.transitionEnd;
        m.transition;
        var _ = Fr(m, ["transitionEnd", "transition"]);
        for (var w in _) {
          var x = _[w];
          if (Array.isArray(x)) {
            var S = d ? x.length - 1 : 0;
            x = x[S];
          }
          x !== null && (i[w] = x);
        }
        for (var w in g)
          i[w] = g[w];
      }
    });
  }
  return i;
}
var d5 = {
  useVisualState: j$({
    scrapeMotionValuesFromProps: R$,
    createRenderState: D$,
    onMount: function(e, t, n) {
      var r = n.renderState, i = n.latestValues;
      try {
        r.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
      } catch {
        r.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      Hy(r, i, { enableHardwareAcceleration: !1 }, e.transformTemplate), N$(t, r);
    }
  })
}, p5 = {
  useVisualState: j$({
    scrapeMotionValuesFromProps: Wy,
    createRenderState: qy
  })
};
function h5(e, t, n, r, i) {
  var o = t.forwardMotionProps, a = o === void 0 ? !1 : o, s = Ky(e) ? d5 : p5;
  return we(we({}, s), { preloadedFeatures: n, useRender: s5(a), createVisualElement: r, projectionNodeConstructor: i, Component: e });
}
var Tt;
(function(e) {
  e.Animate = "animate", e.Hover = "whileHover", e.Tap = "whileTap", e.Drag = "whileDrag", e.Focus = "whileFocus", e.InView = "whileInView", e.Exit = "exit";
})(Tt || (Tt = {}));
function pp(e, t, n, r) {
  return r === void 0 && (r = { passive: !0 }), e.addEventListener(t, n, r), function() {
    return e.removeEventListener(t, n);
  };
}
function Am(e, t, n, r) {
  Ee(function() {
    var i = e.current;
    if (n && i)
      return pp(i, t, n, r);
  }, [e, t, n, r]);
}
function v5(e) {
  var t = e.whileFocus, n = e.visualElement, r = function() {
    var o;
    (o = n.animationState) === null || o === void 0 || o.setActive(Tt.Focus, !0);
  }, i = function() {
    var o;
    (o = n.animationState) === null || o === void 0 || o.setActive(Tt.Focus, !1);
  };
  Am(n, "focus", t ? r : void 0), Am(n, "blur", t ? i : void 0);
}
function F$(e) {
  return typeof PointerEvent < "u" && e instanceof PointerEvent ? e.pointerType === "mouse" : e instanceof MouseEvent;
}
function z$(e) {
  var t = !!e.touches;
  return t;
}
function m5(e) {
  return function(t) {
    var n = t instanceof MouseEvent, r = !n || n && t.button === 0;
    r && e(t);
  };
}
var g5 = { pageX: 0, pageY: 0 };
function y5(e, t) {
  t === void 0 && (t = "page");
  var n = e.touches[0] || e.changedTouches[0], r = n || g5;
  return {
    x: r[t + "X"],
    y: r[t + "Y"]
  };
}
function b5(e, t) {
  return t === void 0 && (t = "page"), {
    x: e[t + "X"],
    y: e[t + "Y"]
  };
}
function Gy(e, t) {
  return t === void 0 && (t = "page"), {
    point: z$(e) ? y5(e, t) : b5(e, t)
  };
}
var L$ = function(e, t) {
  t === void 0 && (t = !1);
  var n = function(r) {
    return e(r, Gy(r));
  };
  return t ? m5(n) : n;
}, _5 = function() {
  return nl && window.onpointerdown === null;
}, w5 = function() {
  return nl && window.ontouchstart === null;
}, x5 = function() {
  return nl && window.onmousedown === null;
}, E5 = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, S5 = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function V$(e) {
  return _5() ? e : w5() ? S5[e] : x5() ? E5[e] : e;
}
function ws(e, t, n, r) {
  return pp(e, V$(t), L$(n, t === "pointerdown"), r);
}
function ad(e, t, n, r) {
  return Am(e, V$(t), n && L$(n, t === "pointerdown"), r);
}
function K$(e) {
  var t = null;
  return function() {
    var n = function() {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
var D1 = K$("dragHorizontal"), A1 = K$("dragVertical");
function B$(e) {
  var t = !1;
  if (e === "y")
    t = A1();
  else if (e === "x")
    t = D1();
  else {
    var n = D1(), r = A1();
    n && r ? t = function() {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function U$() {
  var e = B$(!0);
  return e ? (e(), !1) : !0;
}
function C1(e, t, n) {
  return function(r, i) {
    var o;
    !F$(r) || U$() || ((o = e.animationState) === null || o === void 0 || o.setActive(Tt.Hover, t), n?.(r, i));
  };
}
function O5(e) {
  var t = e.onHoverStart, n = e.onHoverEnd, r = e.whileHover, i = e.visualElement;
  ad(i, "pointerenter", t || r ? C1(i, !0, t) : void 0, { passive: !t }), ad(i, "pointerleave", n || r ? C1(i, !1, n) : void 0, { passive: !n });
}
var q$ = function(e, t) {
  return t ? e === t ? !0 : q$(e, t.parentElement) : !1;
};
function Yy(e) {
  return Ee(function() {
    return function() {
      return e();
    };
  }, []);
}
const sd = (e, t, n) => Math.min(Math.max(n, e), t), Lh = 1e-3, $5 = 0.01, I1 = 10, T5 = 0.05, P5 = 1;
function k5({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let i, o;
  tl(e <= I1 * 1e3, "Spring duration must be 10 seconds or less");
  let a = 1 - t;
  a = sd(T5, P5, a), e = sd($5, I1, e / 1e3), a < 1 ? (i = (u) => {
    const c = u * a, f = c * e, d = c - n, p = Cm(u, a), h = Math.exp(-f);
    return Lh - d / p * h;
  }, o = (u) => {
    const f = u * a * e, d = f * n + n, p = Math.pow(a, 2) * Math.pow(u, 2) * e, h = Math.exp(-f), v = Cm(Math.pow(u, 2), a);
    return (-i(u) + Lh > 0 ? -1 : 1) * ((d - p) * h) / v;
  }) : (i = (u) => {
    const c = Math.exp(-u * e), f = (u - n) * e + 1;
    return -Lh + c * f;
  }, o = (u) => {
    const c = Math.exp(-u * e), f = (n - u) * (e * e);
    return c * f;
  });
  const s = 5 / e, l = A5(i, o, s);
  if (e = e * 1e3, isNaN(l))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const u = Math.pow(l, 2) * r;
    return {
      stiffness: u,
      damping: a * 2 * Math.sqrt(r * u),
      duration: e
    };
  }
}
const D5 = 12;
function A5(e, t, n) {
  let r = n;
  for (let i = 1; i < D5; i++)
    r = r - e(r) / t(r);
  return r;
}
function Cm(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const C5 = ["duration", "bounce"], I5 = ["stiffness", "damping", "mass"];
function N1(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function N5(e) {
  let t = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, e);
  if (!N1(e, I5) && N1(e, C5)) {
    const n = k5(e);
    t = Object.assign(Object.assign(Object.assign({}, t), n), { velocity: 0, mass: 1 }), t.isResolvedFromDuration = !0;
  }
  return t;
}
function Qy(e) {
  var { from: t = 0, to: n = 1, restSpeed: r = 2, restDelta: i } = e, o = Fr(e, ["from", "to", "restSpeed", "restDelta"]);
  const a = { done: !1, value: t };
  let { stiffness: s, damping: l, mass: u, velocity: c, duration: f, isResolvedFromDuration: d } = N5(o), p = R1, h = R1;
  function v() {
    const m = c ? -(c / 1e3) : 0, g = n - t, _ = l / (2 * Math.sqrt(s * u)), w = Math.sqrt(s / u) / 1e3;
    if (i === void 0 && (i = Math.min(Math.abs(n - t) / 100, 0.4)), _ < 1) {
      const x = Cm(w, _);
      p = (S) => {
        const $ = Math.exp(-_ * w * S);
        return n - $ * ((m + _ * w * g) / x * Math.sin(x * S) + g * Math.cos(x * S));
      }, h = (S) => {
        const $ = Math.exp(-_ * w * S);
        return _ * w * $ * (Math.sin(x * S) * (m + _ * w * g) / x + g * Math.cos(x * S)) - $ * (Math.cos(x * S) * (m + _ * w * g) - x * g * Math.sin(x * S));
      };
    } else if (_ === 1)
      p = (x) => n - Math.exp(-w * x) * (g + (m + w * g) * x);
    else {
      const x = w * Math.sqrt(_ * _ - 1);
      p = (S) => {
        const $ = Math.exp(-_ * w * S), A = Math.min(x * S, 300);
        return n - $ * ((m + _ * w * g) * Math.sinh(A) + x * g * Math.cosh(A)) / x;
      };
    }
  }
  return v(), {
    next: (m) => {
      const g = p(m);
      if (d)
        a.done = m >= f;
      else {
        const _ = h(m) * 1e3, w = Math.abs(_) <= r, x = Math.abs(n - g) <= i;
        a.done = w && x;
      }
      return a.value = a.done ? n : g, a;
    },
    flipTarget: () => {
      c = -c, [t, n] = [n, t], v();
    }
  };
}
Qy.needsInterpolation = (e, t) => typeof e == "string" || typeof t == "string";
const R1 = (e) => 0, Iu = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, Jt = (e, t, n) => -n * e + n * t + e;
function Vh(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function M1({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, o = 0, a = 0;
  if (!t)
    i = o = a = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    i = Vh(l, s, e + 1 / 3), o = Vh(l, s, e), a = Vh(l, s, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(o * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
const R5 = (e, t, n) => {
  const r = e * e, i = t * t;
  return Math.sqrt(Math.max(0, n * (i - r) + r));
}, M5 = [km, bo, sa], j1 = (e) => M5.find((t) => t.test(e)), F1 = (e) => `'${e}' is not an animatable color. Use the equivalent color code instead.`, H$ = (e, t) => {
  let n = j1(e), r = j1(t);
  Rr(!!n, F1(e)), Rr(!!r, F1(t));
  let i = n.parse(e), o = r.parse(t);
  n === sa && (i = M1(i), n = bo), r === sa && (o = M1(o), r = bo);
  const a = Object.assign({}, i);
  return (s) => {
    for (const l in a)
      l !== "alpha" && (a[l] = R5(i[l], o[l], s));
    return a.alpha = Jt(i.alpha, o.alpha, s), n.transform(a);
  };
}, Im = (e) => typeof e == "number", j5 = (e, t) => (n) => t(e(n)), hp = (...e) => e.reduce(j5);
function W$(e, t) {
  return Im(e) ? (n) => Jt(e, t, n) : zn.test(e) ? H$(e, t) : G$(e, t);
}
const Z$ = (e, t) => {
  const n = [...e], r = n.length, i = e.map((o, a) => W$(o, t[a]));
  return (o) => {
    for (let a = 0; a < r; a++)
      n[a] = i[a](o);
    return n;
  };
}, F5 = (e, t) => {
  const n = Object.assign(Object.assign({}, e), t), r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = W$(e[i], t[i]));
  return (i) => {
    for (const o in r)
      n[o] = r[o](i);
    return n;
  };
};
function z1(e) {
  const t = Hi.parse(e), n = t.length;
  let r = 0, i = 0, o = 0;
  for (let a = 0; a < n; a++)
    r || typeof t[a] == "number" ? r++ : t[a].hue !== void 0 ? o++ : i++;
  return { parsed: t, numNumbers: r, numRGB: i, numHSL: o };
}
const G$ = (e, t) => {
  const n = Hi.createTransformer(t), r = z1(e), i = z1(t);
  return r.numHSL === i.numHSL && r.numRGB === i.numRGB && r.numNumbers >= i.numNumbers ? hp(Z$(r.parsed, i.parsed), n) : (tl(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (a) => `${a > 0 ? t : e}`);
}, z5 = (e, t) => (n) => Jt(e, t, n);
function L5(e) {
  if (typeof e == "number")
    return z5;
  if (typeof e == "string")
    return zn.test(e) ? H$ : G$;
  if (Array.isArray(e))
    return Z$;
  if (typeof e == "object")
    return F5;
}
function V5(e, t, n) {
  const r = [], i = n || L5(e[0]), o = e.length - 1;
  for (let a = 0; a < o; a++) {
    let s = i(e[a], e[a + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[a] : t;
      s = hp(l, s);
    }
    r.push(s);
  }
  return r;
}
function K5([e, t], [n]) {
  return (r) => n(Iu(e, t, r));
}
function B5(e, t) {
  const n = e.length, r = n - 1;
  return (i) => {
    let o = 0, a = !1;
    if (i <= e[0] ? a = !0 : i >= e[r] && (o = r - 1, a = !0), !a) {
      let l = 1;
      for (; l < n && !(e[l] > i || l === r); l++)
        ;
      o = l - 1;
    }
    const s = Iu(e[o], e[o + 1], i);
    return t[o](s);
  };
}
function Y$(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const o = e.length;
  Rr(o === t.length, "Both input and output ranges must be the same length"), Rr(!r || !Array.isArray(r) || r.length === o - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), e[0] > e[o - 1] && (e = [].concat(e), t = [].concat(t), e.reverse(), t.reverse());
  const a = V5(t, r, i), s = o === 2 ? K5(e, a) : B5(e, a);
  return n ? (l) => s(sd(e[0], e[o - 1], l)) : s;
}
const vp = (e) => (t) => 1 - e(1 - t), Jy = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, U5 = (e) => (t) => Math.pow(t, e), Q$ = (e) => (t) => t * t * ((e + 1) * t - e), q5 = (e) => {
  const t = Q$(e);
  return (n) => (n *= 2) < 1 ? 0.5 * t(n) : 0.5 * (2 - Math.pow(2, -10 * (n - 1)));
}, J$ = 1.525, H5 = 4 / 11, W5 = 8 / 11, Z5 = 9 / 10, Xy = (e) => e, eb = U5(2), G5 = vp(eb), X$ = Jy(eb), eT = (e) => 1 - Math.sin(Math.acos(e)), tb = vp(eT), Y5 = Jy(tb), nb = Q$(J$), Q5 = vp(nb), J5 = Jy(nb), X5 = q5(J$), ej = 4356 / 361, tj = 35442 / 1805, nj = 16061 / 1805, ld = (e) => {
  if (e === 1 || e === 0)
    return e;
  const t = e * e;
  return e < H5 ? 7.5625 * t : e < W5 ? 9.075 * t - 9.9 * e + 3.4 : e < Z5 ? ej * t - tj * e + nj : 10.8 * e * e - 20.52 * e + 10.72;
}, rj = vp(ld), ij = (e) => e < 0.5 ? 0.5 * (1 - ld(1 - e * 2)) : 0.5 * ld(e * 2 - 1) + 0.5;
function oj(e, t) {
  return e.map(() => t || X$).splice(0, e.length - 1);
}
function aj(e) {
  const t = e.length;
  return e.map((n, r) => r !== 0 ? r / (t - 1) : 0);
}
function sj(e, t) {
  return e.map((n) => n * t);
}
function Df({ from: e = 0, to: t = 1, ease: n, offset: r, duration: i = 300 }) {
  const o = { done: !1, value: e }, a = Array.isArray(t) ? t : [e, t], s = sj(r && r.length === a.length ? r : aj(a), i);
  function l() {
    return Y$(s, a, {
      ease: Array.isArray(n) ? n : oj(a, n)
    });
  }
  let u = l();
  return {
    next: (c) => (o.value = u(c), o.done = c >= i, o),
    flipTarget: () => {
      a.reverse(), u = l();
    }
  };
}
function lj({ velocity: e = 0, from: t = 0, power: n = 0.8, timeConstant: r = 350, restDelta: i = 0.5, modifyTarget: o }) {
  const a = { done: !1, value: t };
  let s = n * e;
  const l = t + s, u = o === void 0 ? l : o(l);
  return u !== l && (s = u - t), {
    next: (c) => {
      const f = -s * Math.exp(-c / r);
      return a.done = !(f > i || f < -i), a.value = a.done ? u : u + f, a;
    },
    flipTarget: () => {
    }
  };
}
const L1 = { keyframes: Df, spring: Qy, decay: lj };
function uj(e) {
  if (Array.isArray(e.to))
    return Df;
  if (L1[e.type])
    return L1[e.type];
  const t = new Set(Object.keys(e));
  return t.has("ease") || t.has("duration") && !t.has("dampingRatio") ? Df : t.has("dampingRatio") || t.has("stiffness") || t.has("mass") || t.has("damping") || t.has("restSpeed") || t.has("restDelta") ? Qy : Df;
}
const tT = 1 / 60 * 1e3, cj = typeof performance < "u" ? () => performance.now() : () => Date.now(), nT = typeof window < "u" ? (e) => window.requestAnimationFrame(e) : (e) => setTimeout(() => e(cj()), tT);
function fj(e) {
  let t = [], n = [], r = 0, i = !1, o = !1;
  const a = /* @__PURE__ */ new WeakSet(), s = {
    schedule: (l, u = !1, c = !1) => {
      const f = c && i, d = f ? t : n;
      return u && a.add(l), d.indexOf(l) === -1 && (d.push(l), f && i && (r = t.length)), l;
    },
    cancel: (l) => {
      const u = n.indexOf(l);
      u !== -1 && n.splice(u, 1), a.delete(l);
    },
    process: (l) => {
      if (i) {
        o = !0;
        return;
      }
      if (i = !0, [t, n] = [n, t], n.length = 0, r = t.length, r)
        for (let u = 0; u < r; u++) {
          const c = t[u];
          c(l), a.has(c) && (s.schedule(c), e());
        }
      i = !1, o && (o = !1, s.process(l));
    }
  };
  return s;
}
const dj = 40;
let Nm = !0, Nu = !1, Rm = !1;
const xs = {
  delta: 0,
  timestamp: 0
}, hc = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], mp = hc.reduce((e, t) => (e[t] = fj(() => Nu = !0), e), {}), ti = hc.reduce((e, t) => {
  const n = mp[t];
  return e[t] = (r, i = !1, o = !1) => (Nu || hj(), n.schedule(r, i, o)), e;
}, {}), Is = hc.reduce((e, t) => (e[t] = mp[t].cancel, e), {}), Kh = hc.reduce((e, t) => (e[t] = () => mp[t].process(xs), e), {}), pj = (e) => mp[e].process(xs), rT = (e) => {
  Nu = !1, xs.delta = Nm ? tT : Math.max(Math.min(e - xs.timestamp, dj), 1), xs.timestamp = e, Rm = !0, hc.forEach(pj), Rm = !1, Nu && (Nm = !1, nT(rT));
}, hj = () => {
  Nu = !0, Nm = !0, Rm || nT(rT);
}, ud = () => xs;
function iT(e, t, n = 0) {
  return e - t - n;
}
function vj(e, t, n = 0, r = !0) {
  return r ? iT(t + -e, t, n) : t - (e - t) + n;
}
function mj(e, t, n, r) {
  return r ? e >= t + n : e <= -n;
}
const gj = (e) => {
  const t = ({ delta: n }) => e(n);
  return {
    start: () => ti.update(t, !0),
    stop: () => Is.update(t)
  };
};
function oT(e) {
  var t, n, { from: r, autoplay: i = !0, driver: o = gj, elapsed: a = 0, repeat: s = 0, repeatType: l = "loop", repeatDelay: u = 0, onPlay: c, onStop: f, onComplete: d, onRepeat: p, onUpdate: h } = e, v = Fr(e, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to: m } = v, g, _ = 0, w = v.duration, x, S = !1, $ = !0, A;
  const E = uj(v);
  !((n = (t = E).needsInterpolation) === null || n === void 0) && n.call(t, r, m) && (A = Y$([0, 100], [r, m], {
    clamp: !1
  }), r = 0, m = 100);
  const y = E(Object.assign(Object.assign({}, v), { from: r, to: m }));
  function b() {
    _++, l === "reverse" ? ($ = _ % 2 === 0, a = vj(a, w, u, $)) : (a = iT(a, w, u), l === "mirror" && y.flipTarget()), S = !1, p && p();
  }
  function O() {
    g.stop(), d && d();
  }
  function k(T) {
    if ($ || (T = -T), a += T, !S) {
      const V = y.next(Math.max(0, a));
      x = V.value, A && (x = A(x)), S = $ ? V.done : a <= 0;
    }
    h?.(x), S && (_ === 0 && (w ?? (w = a)), _ < s ? mj(a, w, u, $) && b() : O());
  }
  function I() {
    c?.(), g = o(k), g.start();
  }
  return i && I(), {
    stop: () => {
      f?.(), g.stop();
    }
  };
}
function aT(e, t) {
  return t ? e * (1e3 / t) : 0;
}
function yj({ from: e = 0, velocity: t = 0, min: n, max: r, power: i = 0.8, timeConstant: o = 750, bounceStiffness: a = 500, bounceDamping: s = 10, restDelta: l = 1, modifyTarget: u, driver: c, onUpdate: f, onComplete: d, onStop: p }) {
  let h;
  function v(w) {
    return n !== void 0 && w < n || r !== void 0 && w > r;
  }
  function m(w) {
    return n === void 0 ? r : r === void 0 || Math.abs(n - w) < Math.abs(r - w) ? n : r;
  }
  function g(w) {
    h?.stop(), h = oT(Object.assign(Object.assign({}, w), {
      driver: c,
      onUpdate: (x) => {
        var S;
        f?.(x), (S = w.onUpdate) === null || S === void 0 || S.call(w, x);
      },
      onComplete: d,
      onStop: p
    }));
  }
  function _(w) {
    g(Object.assign({ type: "spring", stiffness: a, damping: s, restDelta: l }, w));
  }
  if (v(e))
    _({ from: e, velocity: t, to: m(e) });
  else {
    let w = i * t + e;
    typeof u < "u" && (w = u(w));
    const x = m(w), S = x === n ? -1 : 1;
    let $, A;
    const E = (y) => {
      $ = A, A = y, t = aT(y - $, ud().delta), (S === 1 && y > x || S === -1 && y < x) && _({ from: y, to: x, velocity: t });
    };
    g({
      type: "decay",
      from: e,
      velocity: t,
      timeConstant: o,
      power: i,
      restDelta: l,
      modifyTarget: u,
      onUpdate: v(w) ? E : void 0
    });
  }
  return {
    stop: () => h?.stop()
  };
}
const Mm = (e) => e.hasOwnProperty("x") && e.hasOwnProperty("y"), V1 = (e) => Mm(e) && e.hasOwnProperty("z"), Uc = (e, t) => Math.abs(e - t);
function sT(e, t) {
  if (Im(e) && Im(t))
    return Uc(e, t);
  if (Mm(e) && Mm(t)) {
    const n = Uc(e.x, t.x), r = Uc(e.y, t.y), i = V1(e) && V1(t) ? Uc(e.z, t.z) : 0;
    return Math.sqrt(Math.pow(n, 2) + Math.pow(r, 2) + Math.pow(i, 2));
  }
}
const lT = (e, t) => 1 - 3 * t + 3 * e, uT = (e, t) => 3 * t - 6 * e, cT = (e) => 3 * e, cd = (e, t, n) => ((lT(t, n) * e + uT(t, n)) * e + cT(t)) * e, fT = (e, t, n) => 3 * lT(t, n) * e * e + 2 * uT(t, n) * e + cT(t), bj = 1e-7, _j = 10;
function wj(e, t, n, r, i) {
  let o, a, s = 0;
  do
    a = t + (n - t) / 2, o = cd(a, r, i) - e, o > 0 ? n = a : t = a;
  while (Math.abs(o) > bj && ++s < _j);
  return a;
}
const xj = 8, Ej = 1e-3;
function Sj(e, t, n, r) {
  for (let i = 0; i < xj; ++i) {
    const o = fT(t, n, r);
    if (o === 0)
      return t;
    const a = cd(t, n, r) - e;
    t -= a / o;
  }
  return t;
}
const Af = 11, qc = 1 / (Af - 1);
function Oj(e, t, n, r) {
  if (e === t && n === r)
    return Xy;
  const i = new Float32Array(Af);
  for (let a = 0; a < Af; ++a)
    i[a] = cd(a * qc, e, n);
  function o(a) {
    let s = 0, l = 1;
    const u = Af - 1;
    for (; l !== u && i[l] <= a; ++l)
      s += qc;
    --l;
    const c = (a - i[l]) / (i[l + 1] - i[l]), f = s + c * qc, d = fT(f, e, n);
    return d >= Ej ? Sj(a, f, e, n) : d === 0 ? f : wj(a, s, s + qc, e, n);
  }
  return (a) => a === 0 || a === 1 ? a : cd(o(a), t, r);
}
function $j(e) {
  var t = e.onTap, n = e.onTapStart, r = e.onTapCancel, i = e.whileTap, o = e.visualElement, a = t || n || r || i, s = _e(!1), l = _e(null), u = {
    passive: !(n || t || r || h)
  };
  function c() {
    var v;
    (v = l.current) === null || v === void 0 || v.call(l), l.current = null;
  }
  function f() {
    var v;
    return c(), s.current = !1, (v = o.animationState) === null || v === void 0 || v.setActive(Tt.Tap, !1), !U$();
  }
  function d(v, m) {
    f() && (q$(o.getInstance(), v.target) ? t?.(v, m) : r?.(v, m));
  }
  function p(v, m) {
    f() && r?.(v, m);
  }
  function h(v, m) {
    var g;
    c(), !s.current && (s.current = !0, l.current = hp(ws(window, "pointerup", d, u), ws(window, "pointercancel", p, u)), (g = o.animationState) === null || g === void 0 || g.setActive(Tt.Tap, !0), n?.(v, m));
  }
  ad(o, "pointerdown", a ? h : void 0, u), Yy(c);
}
var K1 = /* @__PURE__ */ new Set();
function dT(e, t, n) {
  e || K1.has(t) || (console.warn(t), K1.add(t));
}
var jm = /* @__PURE__ */ new WeakMap(), Bh = /* @__PURE__ */ new WeakMap(), Tj = function(e) {
  var t;
  (t = jm.get(e.target)) === null || t === void 0 || t(e);
}, Pj = function(e) {
  e.forEach(Tj);
};
function kj(e) {
  var t = e.root, n = Fr(e, ["root"]), r = t || document;
  Bh.has(r) || Bh.set(r, {});
  var i = Bh.get(r), o = JSON.stringify(n);
  return i[o] || (i[o] = new IntersectionObserver(Pj, we({ root: t }, n))), i[o];
}
function Dj(e, t, n) {
  var r = kj(t);
  return jm.set(e, n), r.observe(e), function() {
    jm.delete(e), r.unobserve(e);
  };
}
function Aj(e) {
  var t = e.visualElement, n = e.whileInView, r = e.onViewportEnter, i = e.onViewportLeave, o = e.viewport, a = o === void 0 ? {} : o, s = _e({
    hasEnteredView: !1,
    isInView: !1
  }), l = !!(n || r || i);
  a.once && s.current.hasEnteredView && (l = !1);
  var u = typeof IntersectionObserver > "u" ? Nj : Ij;
  u(l, s.current, t, a);
}
var Cj = {
  some: 0,
  all: 1
};
function Ij(e, t, n, r) {
  var i = r.root, o = r.margin, a = r.amount, s = a === void 0 ? "some" : a, l = r.once;
  Ee(function() {
    if (e) {
      var u = {
        root: i?.current,
        rootMargin: o,
        threshold: typeof s == "number" ? s : Cj[s]
      }, c = function(f) {
        var d, p = f.isIntersecting;
        if (t.isInView !== p && (t.isInView = p, !(l && !p && t.hasEnteredView))) {
          p && (t.hasEnteredView = !0), (d = n.animationState) === null || d === void 0 || d.setActive(Tt.InView, p);
          var h = n.getProps(), v = p ? h.onViewportEnter : h.onViewportLeave;
          v?.(f);
        }
      };
      return Dj(n.getInstance(), u, c);
    }
  }, [e, i, o, s]);
}
function Nj(e, t, n, r) {
  var i = r.fallback, o = i === void 0 ? !0 : i;
  Ee(function() {
    !e || !o || (Ly !== "production" && dT(!1, "IntersectionObserver not available on this device. whileInView animations will trigger on mount."), requestAnimationFrame(function() {
      var a;
      t.hasEnteredView = !0;
      var s = n.getProps().onViewportEnter;
      s?.(null), (a = n.animationState) === null || a === void 0 || a.setActive(Tt.InView, !0);
    }));
  }, [e]);
}
var _o = function(e) {
  return function(t) {
    return e(t), null;
  };
}, Rj = {
  inView: _o(Aj),
  tap: _o($j),
  focus: _o(v5),
  hover: _o(O5)
}, Mj = 0, jj = function() {
  return Mj++;
}, pT = function() {
  return rl(jj);
};
function hT() {
  var e = Me(cc);
  if (e === null)
    return [!0, null];
  var t = e.isPresent, n = e.onExitComplete, r = e.register, i = pT();
  Ee(function() {
    return r(i);
  }, []);
  var o = function() {
    return n?.(i);
  };
  return !t && n ? [!1, o] : [!0];
}
function vT(e, t) {
  if (!Array.isArray(t))
    return !1;
  var n = t.length;
  if (n !== e.length)
    return !1;
  for (var r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
var fd = function(e) {
  return e * 1e3;
}, B1 = {
  linear: Xy,
  easeIn: eb,
  easeInOut: X$,
  easeOut: G5,
  circIn: eT,
  circInOut: Y5,
  circOut: tb,
  backIn: nb,
  backInOut: J5,
  backOut: Q5,
  anticipate: X5,
  bounceIn: rj,
  bounceInOut: ij,
  bounceOut: ld
}, U1 = function(e) {
  if (Array.isArray(e)) {
    Rr(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var t = Zt(e, 4), n = t[0], r = t[1], i = t[2], o = t[3];
    return Oj(n, r, i, o);
  } else if (typeof e == "string")
    return Rr(B1[e] !== void 0, "Invalid easing type '".concat(e, "'")), B1[e];
  return e;
}, Fj = function(e) {
  return Array.isArray(e) && typeof e[0] != "number";
}, q1 = function(e, t) {
  return e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
  Hi.test(t) && // And it contains numbers and/or colors
  !t.startsWith("url("));
}, Wo = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
}, Hc = function(e) {
  return {
    type: "spring",
    stiffness: 550,
    damping: e === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
}, Uh = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, zj = function(e) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: e
  };
}, H1 = {
  x: Wo,
  y: Wo,
  z: Wo,
  rotate: Wo,
  rotateX: Wo,
  rotateY: Wo,
  rotateZ: Wo,
  scaleX: Hc,
  scaleY: Hc,
  scale: Hc,
  opacity: Uh,
  backgroundColor: Uh,
  color: Uh,
  default: Hc
}, Lj = function(e, t) {
  var n;
  return Cu(t) ? n = zj : n = H1[e] || H1.default, we({ to: t }, n(t));
}, Vj = we(we({}, T$), {
  // Color props
  color: zn,
  backgroundColor: zn,
  outlineColor: zn,
  fill: zn,
  stroke: zn,
  // Border props
  borderColor: zn,
  borderTopColor: zn,
  borderRightColor: zn,
  borderBottomColor: zn,
  borderLeftColor: zn,
  filter: Dm,
  WebkitFilter: Dm
}), rb = function(e) {
  return Vj[e];
};
function ib(e, t) {
  var n, r = rb(e);
  return r !== Dm && (r = Hi), (n = r.getAnimatableNone) === null || n === void 0 ? void 0 : n.call(r, t);
}
function Kj(e) {
  e.when, e.delay, e.delayChildren, e.staggerChildren, e.staggerDirection, e.repeat, e.repeatType, e.repeatDelay, e.from;
  var t = Fr(e, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(t).length;
}
var W1 = !1;
function Bj(e) {
  var t = e.ease, n = e.times, r = e.yoyo, i = e.flip, o = e.loop, a = Fr(e, ["ease", "times", "yoyo", "flip", "loop"]), s = we({}, a);
  return n && (s.offset = n), a.duration && (s.duration = fd(a.duration)), a.repeatDelay && (s.repeatDelay = fd(a.repeatDelay)), t && (s.ease = Fj(t) ? t.map(U1) : U1(t)), a.type === "tween" && (s.type = "keyframes"), (r || o || i) && (tl(!W1, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), W1 = !0, r ? s.repeatType = "reverse" : o ? s.repeatType = "loop" : i && (s.repeatType = "mirror"), s.repeat = o || r || i || a.repeat), a.type !== "spring" && (s.type = "keyframes"), s;
}
function Uj(e, t) {
  var n, r, i = ob(e, t) || {};
  return (r = (n = i.delay) !== null && n !== void 0 ? n : e.delay) !== null && r !== void 0 ? r : 0;
}
function qj(e) {
  return Array.isArray(e.to) && e.to[0] === null && (e.to = ei([], Zt(e.to), !1), e.to[0] = e.from), e;
}
function Hj(e, t, n) {
  var r;
  return Array.isArray(t.to) && ((r = e.duration) !== null && r !== void 0 || (e.duration = 0.8)), qj(t), Kj(e) || (e = we(we({}, e), Lj(n, t.to))), we(we({}, t), Bj(e));
}
function Wj(e, t, n, r, i) {
  var o, a = ob(r, e), s = (o = a.from) !== null && o !== void 0 ? o : t.get(), l = q1(e, n);
  s === "none" && l && typeof n == "string" ? s = ib(e, n) : Z1(s) && typeof n == "string" ? s = G1(n) : !Array.isArray(n) && Z1(n) && typeof s == "string" && (n = G1(s));
  var u = q1(e, s);
  tl(u === l, "You are trying to animate ".concat(e, ' from "').concat(s, '" to "').concat(n, '". ').concat(s, " is not an animatable value - to enable this animation set ").concat(s, " to a value animatable to ").concat(n, " via the `style` property."));
  function c() {
    var d = {
      from: s,
      to: n,
      velocity: t.getVelocity(),
      onComplete: i,
      onUpdate: function(p) {
        return t.set(p);
      }
    };
    return a.type === "inertia" || a.type === "decay" ? yj(we(we({}, d), a)) : oT(we(we({}, Hj(a, d, e)), { onUpdate: function(p) {
      var h;
      d.onUpdate(p), (h = a.onUpdate) === null || h === void 0 || h.call(a, p);
    }, onComplete: function() {
      var p;
      d.onComplete(), (p = a.onComplete) === null || p === void 0 || p.call(a);
    } }));
  }
  function f() {
    var d, p, h = M$(n);
    return t.set(h), i(), (d = a?.onUpdate) === null || d === void 0 || d.call(a, h), (p = a?.onComplete) === null || p === void 0 || p.call(a), { stop: function() {
    } };
  }
  return !u || !l || a.type === !1 ? f : c;
}
function Z1(e) {
  return e === 0 || typeof e == "string" && parseFloat(e) === 0 && e.indexOf(" ") === -1;
}
function G1(e) {
  return typeof e == "number" ? 0 : ib("", e);
}
function ob(e, t) {
  return e[t] || e.default || e;
}
function ab(e, t, n, r) {
  return r === void 0 && (r = {}), t.start(function(i) {
    var o, a, s = Wj(e, t, n, r, i), l = Uj(r, e), u = function() {
      return a = s();
    };
    return l ? o = window.setTimeout(u, fd(l)) : u(), function() {
      clearTimeout(o), a?.stop();
    };
  });
}
var Zj = function(e) {
  return /^\-?\d*\.?\d+$/.test(e);
}, Gj = function(e) {
  return /^0[^.\s]+$/.test(e);
};
function sb(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function lb(e, t) {
  var n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
var cu = (
  /** @class */
  (function() {
    function e() {
      this.subscriptions = [];
    }
    return e.prototype.add = function(t) {
      var n = this;
      return sb(this.subscriptions, t), function() {
        return lb(n.subscriptions, t);
      };
    }, e.prototype.notify = function(t, n, r) {
      var i = this.subscriptions.length;
      if (i)
        if (i === 1)
          this.subscriptions[0](t, n, r);
        else
          for (var o = 0; o < i; o++) {
            var a = this.subscriptions[o];
            a && a(t, n, r);
          }
    }, e.prototype.getSize = function() {
      return this.subscriptions.length;
    }, e.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, e;
  })()
), Yj = function(e) {
  return !isNaN(parseFloat(e));
}, Qj = (
  /** @class */
  (function() {
    function e(t) {
      var n = this;
      this.version = "6.5.1", this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new cu(), this.velocityUpdateSubscribers = new cu(), this.renderSubscribers = new cu(), this.canTrackVelocity = !1, this.updateAndNotify = function(r, i) {
        i === void 0 && (i = !0), n.prev = n.current, n.current = r;
        var o = ud(), a = o.delta, s = o.timestamp;
        n.lastUpdated !== s && (n.timeDelta = a, n.lastUpdated = s, ti.postRender(n.scheduleVelocityCheck)), n.prev !== n.current && n.updateSubscribers.notify(n.current), n.velocityUpdateSubscribers.getSize() && n.velocityUpdateSubscribers.notify(n.getVelocity()), i && n.renderSubscribers.notify(n.current);
      }, this.scheduleVelocityCheck = function() {
        return ti.postRender(n.velocityCheck);
      }, this.velocityCheck = function(r) {
        var i = r.timestamp;
        i !== n.lastUpdated && (n.prev = n.current, n.velocityUpdateSubscribers.notify(n.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = t, this.canTrackVelocity = Yj(this.current);
    }
    return e.prototype.onChange = function(t) {
      return this.updateSubscribers.add(t);
    }, e.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, e.prototype.onRenderRequest = function(t) {
      return t(this.get()), this.renderSubscribers.add(t);
    }, e.prototype.attach = function(t) {
      this.passiveEffect = t;
    }, e.prototype.set = function(t, n) {
      n === void 0 && (n = !0), !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
    }, e.prototype.get = function() {
      return this.current;
    }, e.prototype.getPrevious = function() {
      return this.prev;
    }, e.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        aT(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, e.prototype.start = function(t) {
      var n = this;
      return this.stop(), new Promise(function(r) {
        n.hasAnimated = !0, n.stopAnimation = t(r);
      }).then(function() {
        return n.clearAnimation();
      });
    }, e.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, e.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, e.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, e.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, e;
  })()
);
function Ns(e) {
  return new Qj(e);
}
var mT = function(e) {
  return function(t) {
    return t.test(e);
  };
}, Jj = {
  test: function(e) {
    return e === "auto";
  },
  parse: function(e) {
    return e;
  }
}, gT = [Na, Ze, $i, so, KM, VM, Jj], Rl = function(e) {
  return gT.find(mT(e));
}, Xj = ei(ei([], Zt(gT), !1), [zn, Hi], !1), eF = function(e) {
  return Xj.find(mT(e));
};
function tF(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Ns(n));
}
function nF(e, t) {
  var n = fp(e, t), r = n ? e.makeTargetAnimatable(n, !1) : {}, i = r.transitionEnd, o = i === void 0 ? {} : i;
  r.transition;
  var a = Fr(r, ["transitionEnd", "transition"]);
  a = we(we({}, a), o);
  for (var s in a) {
    var l = M$(a[s]);
    tF(e, s, l);
  }
}
function rF(e, t, n) {
  var r, i, o, a, s = Object.keys(t).filter(function(p) {
    return !e.hasValue(p);
  }), l = s.length;
  if (l)
    for (var u = 0; u < l; u++) {
      var c = s[u], f = t[c], d = null;
      Array.isArray(f) && (d = f[0]), d === null && (d = (i = (r = n[c]) !== null && r !== void 0 ? r : e.readValue(c)) !== null && i !== void 0 ? i : t[c]), d != null && (typeof d == "string" && (Zj(d) || Gj(d)) ? d = parseFloat(d) : !eF(d) && Hi.test(f) && (d = ib(c, f)), e.addValue(c, Ns(d)), (o = (a = n)[c]) !== null && o !== void 0 || (a[c] = d), e.setBaseTarget(c, d));
    }
}
function iF(e, t) {
  if (t) {
    var n = t[e] || t.default || t;
    return n.from;
  }
}
function oF(e, t, n) {
  var r, i, o = {};
  for (var a in e)
    o[a] = (r = iF(a, t)) !== null && r !== void 0 ? r : (i = n.getValue(a)) === null || i === void 0 ? void 0 : i.get();
  return o;
}
function aF(e, t, n) {
  n === void 0 && (n = {}), e.notifyAnimationStart(t);
  var r;
  if (Array.isArray(t)) {
    var i = t.map(function(a) {
      return Fm(e, a, n);
    });
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = Fm(e, t, n);
  else {
    var o = typeof t == "function" ? fp(e, t, n.custom) : t;
    r = yT(e, o, n);
  }
  return r.then(function() {
    return e.notifyAnimationComplete(t);
  });
}
function Fm(e, t, n) {
  var r;
  n === void 0 && (n = {});
  var i = fp(e, t, n.custom), o = (i || {}).transition, a = o === void 0 ? e.getDefaultTransition() || {} : o;
  n.transitionOverride && (a = n.transitionOverride);
  var s = i ? function() {
    return yT(e, i, n);
  } : function() {
    return Promise.resolve();
  }, l = !((r = e.variantChildren) === null || r === void 0) && r.size ? function(p) {
    p === void 0 && (p = 0);
    var h = a.delayChildren, v = h === void 0 ? 0 : h, m = a.staggerChildren, g = a.staggerDirection;
    return sF(e, t, v + p, m, g, n);
  } : function() {
    return Promise.resolve();
  }, u = a.when;
  if (u) {
    var c = Zt(u === "beforeChildren" ? [s, l] : [l, s], 2), f = c[0], d = c[1];
    return f().then(d);
  } else
    return Promise.all([s(), l(n.delay)]);
}
function yT(e, t, n) {
  var r, i = n === void 0 ? {} : n, o = i.delay, a = o === void 0 ? 0 : o, s = i.transitionOverride, l = i.type, u = e.makeTargetAnimatable(t), c = u.transition, f = c === void 0 ? e.getDefaultTransition() : c, d = u.transitionEnd, p = Fr(u, ["transition", "transitionEnd"]);
  s && (f = s);
  var h = [], v = l && ((r = e.animationState) === null || r === void 0 ? void 0 : r.getState()[l]);
  for (var m in p) {
    var g = e.getValue(m), _ = p[m];
    if (!(!g || _ === void 0 || v && uF(v, m))) {
      var w = we({ delay: a }, f);
      e.shouldReduceMotion && fc(m) && (w = we(we({}, w), { type: !1, delay: 0 }));
      var x = ab(m, g, _, w);
      h.push(x);
    }
  }
  return Promise.all(h).then(function() {
    d && nF(e, d);
  });
}
function sF(e, t, n, r, i, o) {
  n === void 0 && (n = 0), r === void 0 && (r = 0), i === void 0 && (i = 1);
  var a = [], s = (e.variantChildren.size - 1) * r, l = i === 1 ? function(u) {
    return u === void 0 && (u = 0), u * r;
  } : function(u) {
    return u === void 0 && (u = 0), s - u * r;
  };
  return Array.from(e.variantChildren).sort(lF).forEach(function(u, c) {
    a.push(Fm(u, t, we(we({}, o), { delay: n + l(c) })).then(function() {
      return u.notifyAnimationComplete(t);
    }));
  }), Promise.all(a);
}
function lF(e, t) {
  return e.sortNodePosition(t);
}
function uF(e, t) {
  var n = e.protectedKeys, r = e.needsAnimating, i = n.hasOwnProperty(t) && r[t] !== !0;
  return r[t] = !1, i;
}
var ub = [
  Tt.Animate,
  Tt.InView,
  Tt.Focus,
  Tt.Hover,
  Tt.Tap,
  Tt.Drag,
  Tt.Exit
], cF = ei([], Zt(ub), !1).reverse(), fF = ub.length;
function dF(e) {
  return function(t) {
    return Promise.all(t.map(function(n) {
      var r = n.animation, i = n.options;
      return aF(e, r, i);
    }));
  };
}
function pF(e) {
  var t = dF(e), n = vF(), r = {}, i = !0, o = function(c, f) {
    var d = fp(e, f);
    if (d) {
      d.transition;
      var p = d.transitionEnd, h = Fr(d, ["transition", "transitionEnd"]);
      c = we(we(we({}, c), h), p);
    }
    return c;
  };
  function a(c) {
    return r[c] !== void 0;
  }
  function s(c) {
    t = c(e);
  }
  function l(c, f) {
    for (var d, p = e.getProps(), h = e.getVariantContext(!0) || {}, v = [], m = /* @__PURE__ */ new Set(), g = {}, _ = 1 / 0, w = function(A) {
      var E = cF[A], y = n[E], b = (d = p[E]) !== null && d !== void 0 ? d : h[E], O = Zr(b), k = E === f ? y.isActive : null;
      k === !1 && (_ = A);
      var I = b === h[E] && b !== p[E] && O;
      if (I && i && e.manuallyAnimateOnMount && (I = !1), y.protectedKeys = we({}, g), // If it isn't active and hasn't *just* been set as inactive
      !y.isActive && k === null || // If we didn't and don't have any defined prop for this animation type
      !b && !y.prevProp || // Or if the prop doesn't define an animation
      Zy(b) || typeof b == "boolean")
        return "continue";
      var T = hF(y.prevProp, b), V = T || // If we're making this variant active, we want to always make it active
      E === f && y.isActive && !I && O || // If we removed a higher-priority variant (i is in reverse order)
      A > _ && O, z = Array.isArray(b) ? b : [b], B = z.reduce(o, {});
      k === !1 && (B = {});
      var q = y.prevResolvedValues, M = q === void 0 ? {} : q, N = we(we({}, M), B), Y = function(ne) {
        V = !0, m.delete(ne), y.needsAnimating[ne] = !0;
      };
      for (var ee in N) {
        var Q = B[ee], K = M[ee];
        g.hasOwnProperty(ee) || (Q !== K ? Cu(Q) && Cu(K) ? !vT(Q, K) || T ? Y(ee) : y.protectedKeys[ee] = !0 : Q !== void 0 ? Y(ee) : m.add(ee) : Q !== void 0 && m.has(ee) ? Y(ee) : y.protectedKeys[ee] = !0);
      }
      y.prevProp = b, y.prevResolvedValues = B, y.isActive && (g = we(we({}, g), B)), i && e.blockInitialAnimation && (V = !1), V && !I && v.push.apply(v, ei([], Zt(z.map(function(ne) {
        return {
          animation: ne,
          options: we({ type: E }, c)
        };
      })), !1));
    }, x = 0; x < fF; x++)
      w(x);
    if (r = we({}, g), m.size) {
      var S = {};
      m.forEach(function(A) {
        var E = e.getBaseTarget(A);
        E !== void 0 && (S[A] = E);
      }), v.push({ animation: S });
    }
    var $ = !!v.length;
    return i && p.initial === !1 && !e.manuallyAnimateOnMount && ($ = !1), i = !1, $ ? t(v) : Promise.resolve();
  }
  function u(c, f, d) {
    var p;
    if (n[c].isActive === f)
      return Promise.resolve();
    (p = e.variantChildren) === null || p === void 0 || p.forEach(function(m) {
      var g;
      return (g = m.animationState) === null || g === void 0 ? void 0 : g.setActive(c, f);
    }), n[c].isActive = f;
    var h = l(d, c);
    for (var v in n)
      n[v].protectedKeys = {};
    return h;
  }
  return {
    isAnimated: a,
    animateChanges: l,
    setActive: u,
    setAnimateFunction: s,
    getState: function() {
      return n;
    }
  };
}
function hF(e, t) {
  return typeof t == "string" ? t !== e : p$(t) ? !vT(t, e) : !1;
}
function Zo(e) {
  return e === void 0 && (e = !1), {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function vF() {
  var e;
  return e = {}, e[Tt.Animate] = Zo(!0), e[Tt.InView] = Zo(), e[Tt.Hover] = Zo(), e[Tt.Tap] = Zo(), e[Tt.Drag] = Zo(), e[Tt.Focus] = Zo(), e[Tt.Exit] = Zo(), e;
}
var mF = {
  animation: _o(function(e) {
    var t = e.visualElement, n = e.animate;
    t.animationState || (t.animationState = pF(t)), Zy(n) && Ee(function() {
      return n.subscribe(t);
    }, [n]);
  }),
  exit: _o(function(e) {
    var t = e.custom, n = e.visualElement, r = Zt(hT(), 2), i = r[0], o = r[1], a = Me(cc);
    Ee(function() {
      var s, l;
      n.isPresent = i;
      var u = (s = n.animationState) === null || s === void 0 ? void 0 : s.setActive(Tt.Exit, !i, { custom: (l = a?.custom) !== null && l !== void 0 ? l : t });
      !i && u?.then(o);
    }, [i]);
  })
}, bT = (
  /** @class */
  (function() {
    function e(t, n, r) {
      var i = this, o = r === void 0 ? {} : r, a = o.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (i.lastMoveEvent && i.lastMoveEventInfo) {
          var d = Hh(i.lastMoveEventInfo, i.history), p = i.startEvent !== null, h = sT(d.offset, { x: 0, y: 0 }) >= 3;
          if (!(!p && !h)) {
            var v = d.point, m = ud().timestamp;
            i.history.push(we(we({}, v), { timestamp: m }));
            var g = i.handlers, _ = g.onStart, w = g.onMove;
            p || (_ && _(i.lastMoveEvent, d), i.startEvent = i.lastMoveEvent), w && w(i.lastMoveEvent, d);
          }
        }
      }, this.handlePointerMove = function(d, p) {
        if (i.lastMoveEvent = d, i.lastMoveEventInfo = qh(p, i.transformPagePoint), F$(d) && d.buttons === 0) {
          i.handlePointerUp(d, p);
          return;
        }
        ti.update(i.updatePoint, !0);
      }, this.handlePointerUp = function(d, p) {
        i.end();
        var h = i.handlers, v = h.onEnd, m = h.onSessionEnd, g = Hh(qh(p, i.transformPagePoint), i.history);
        i.startEvent && v && v(d, g), m && m(d, g);
      }, !(z$(t) && t.touches.length > 1)) {
        this.handlers = n, this.transformPagePoint = a;
        var s = Gy(t), l = qh(s, this.transformPagePoint), u = l.point, c = ud().timestamp;
        this.history = [we(we({}, u), { timestamp: c })];
        var f = n.onSessionStart;
        f && f(t, Hh(l, this.history)), this.removeListeners = hp(ws(window, "pointermove", this.handlePointerMove), ws(window, "pointerup", this.handlePointerUp), ws(window, "pointercancel", this.handlePointerUp));
      }
    }
    return e.prototype.updateHandlers = function(t) {
      this.handlers = t;
    }, e.prototype.end = function() {
      this.removeListeners && this.removeListeners(), Is.update(this.updatePoint);
    }, e;
  })()
);
function qh(e, t) {
  return t ? { point: t(e.point) } : e;
}
function Y1(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Hh(e, t) {
  var n = e.point;
  return {
    point: n,
    delta: Y1(n, _T(t)),
    offset: Y1(n, gF(t)),
    velocity: yF(t, 0.1)
  };
}
function gF(e) {
  return e[0];
}
function _T(e) {
  return e[e.length - 1];
}
function yF(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  for (var n = e.length - 1, r = null, i = _T(e); n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > fd(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  var o = (i.timestamp - r.timestamp) / 1e3;
  if (o === 0)
    return { x: 0, y: 0 };
  var a = {
    x: (i.x - r.x) / o,
    y: (i.y - r.y) / o
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function Wi(e) {
  return e.max - e.min;
}
function Q1(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 0.01), sT(e, t) < n;
}
function J1(e, t, n, r) {
  r === void 0 && (r = 0.5), e.origin = r, e.originPoint = Jt(t.min, t.max, e.origin), e.scale = Wi(n) / Wi(t), (Q1(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = Jt(n.min, n.max, e.origin) - e.originPoint, (Q1(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function fu(e, t, n, r) {
  J1(e.x, t.x, n.x, r?.originX), J1(e.y, t.y, n.y, r?.originY);
}
function X1(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + Wi(t);
}
function bF(e, t, n) {
  X1(e.x, t.x, n.x), X1(e.y, t.y, n.y);
}
function ew(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + Wi(t);
}
function du(e, t, n) {
  ew(e.x, t.x, n.x), ew(e.y, t.y, n.y);
}
function _F(e, t, n) {
  var r = t.min, i = t.max;
  return r !== void 0 && e < r ? e = n ? Jt(r, e, n.min) : Math.max(e, r) : i !== void 0 && e > i && (e = n ? Jt(i, e, n.max) : Math.min(e, i)), e;
}
function tw(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function wF(e, t) {
  var n = t.top, r = t.left, i = t.bottom, o = t.right;
  return {
    x: tw(e.x, r, o),
    y: tw(e.y, n, i)
  };
}
function nw(e, t) {
  var n, r = t.min - e.min, i = t.max - e.max;
  return t.max - t.min < e.max - e.min && (n = Zt([i, r], 2), r = n[0], i = n[1]), { min: r, max: i };
}
function xF(e, t) {
  return {
    x: nw(e.x, t.x),
    y: nw(e.y, t.y)
  };
}
function EF(e, t) {
  var n = 0.5, r = Wi(e), i = Wi(t);
  return i > r ? n = Iu(t.min, t.max - r, e.min) : r > i && (n = Iu(e.min, e.max - i, t.min)), sd(0, 1, n);
}
function SF(e, t) {
  var n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
var zm = 0.35;
function OF(e) {
  return e === void 0 && (e = zm), e === !1 ? e = 0 : e === !0 && (e = zm), {
    x: rw(e, "left", "right"),
    y: rw(e, "top", "bottom")
  };
}
function rw(e, t, n) {
  return {
    min: iw(e, t),
    max: iw(e, n)
  };
}
function iw(e, t) {
  var n;
  return typeof e == "number" ? e : (n = e[t]) !== null && n !== void 0 ? n : 0;
}
var ow = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
}, pu = function() {
  return {
    x: ow(),
    y: ow()
  };
}, aw = function() {
  return { min: 0, max: 0 };
}, Dn = function() {
  return {
    x: aw(),
    y: aw()
  };
};
function yi(e) {
  return [e("x"), e("y")];
}
function wT(e) {
  var t = e.top, n = e.left, r = e.right, i = e.bottom;
  return {
    x: { min: n, max: r },
    y: { min: t, max: i }
  };
}
function $F(e) {
  var t = e.x, n = e.y;
  return { top: n.min, right: t.max, bottom: n.max, left: t.min };
}
function TF(e, t) {
  if (!t)
    return e;
  var n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function Wh(e) {
  return e === void 0 || e === 1;
}
function xT(e) {
  var t = e.scale, n = e.scaleX, r = e.scaleY;
  return !Wh(t) || !Wh(n) || !Wh(r);
}
function lo(e) {
  return xT(e) || sw(e.x) || sw(e.y) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function sw(e) {
  return e && e !== "0%";
}
function dd(e, t, n) {
  var r = e - n, i = t * r;
  return n + i;
}
function lw(e, t, n, r, i) {
  return i !== void 0 && (e = dd(e, i, r)), dd(e, n, r) + t;
}
function Lm(e, t, n, r, i) {
  t === void 0 && (t = 0), n === void 0 && (n = 1), e.min = lw(e.min, t, n, r, i), e.max = lw(e.max, t, n, r, i);
}
function ET(e, t) {
  var n = t.x, r = t.y;
  Lm(e.x, n.translate, n.scale, n.originPoint), Lm(e.y, r.translate, r.scale, r.originPoint);
}
function PF(e, t, n, r) {
  var i, o;
  r === void 0 && (r = !1);
  var a = n.length;
  if (a) {
    t.x = t.y = 1;
    for (var s, l, u = 0; u < a; u++)
      s = n[u], l = s.projectionDelta, ((o = (i = s.instance) === null || i === void 0 ? void 0 : i.style) === null || o === void 0 ? void 0 : o.display) !== "contents" && (r && s.options.layoutScroll && s.scroll && s !== s.root && ls(e, { x: -s.scroll.x, y: -s.scroll.y }), l && (t.x *= l.x.scale, t.y *= l.y.scale, ET(e, l)), r && lo(s.latestValues) && ls(e, s.latestValues));
  }
}
function co(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function uw(e, t, n) {
  var r = Zt(n, 3), i = r[0], o = r[1], a = r[2], s = t[a] !== void 0 ? t[a] : 0.5, l = Jt(e.min, e.max, s);
  Lm(e, t[i], t[o], l, t.scale);
}
var kF = ["x", "scaleX", "originX"], DF = ["y", "scaleY", "originY"];
function ls(e, t) {
  uw(e.x, t, kF), uw(e.y, t, DF);
}
function ST(e, t) {
  return wT(TF(e.getBoundingClientRect(), t));
}
function AF(e, t, n) {
  var r = ST(e, n), i = t.scroll;
  return i && (co(r.x, i.x), co(r.y, i.y)), r;
}
var CF = /* @__PURE__ */ new WeakMap(), IF = (
  /** @class */
  (function() {
    function e(t) {
      this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = Dn(), this.visualElement = t;
    }
    return e.prototype.start = function(t, n) {
      var r = this, i = n === void 0 ? {} : n, o = i.snapToCursor, a = o === void 0 ? !1 : o;
      if (this.visualElement.isPresent !== !1) {
        var s = function(f) {
          r.stopAnimation(), a && r.snapToCursor(Gy(f, "page").point);
        }, l = function(f, d) {
          var p, h = r.getProps(), v = h.drag, m = h.dragPropagation, g = h.onDragStart;
          v && !m && (r.openGlobalLock && r.openGlobalLock(), r.openGlobalLock = B$(v), !r.openGlobalLock) || (r.isDragging = !0, r.currentDirection = null, r.resolveConstraints(), r.visualElement.projection && (r.visualElement.projection.isAnimationBlocked = !0, r.visualElement.projection.target = void 0), yi(function(_) {
            var w, x, S = r.getAxisMotionValue(_).get() || 0;
            if ($i.test(S)) {
              var $ = (x = (w = r.visualElement.projection) === null || w === void 0 ? void 0 : w.layout) === null || x === void 0 ? void 0 : x.actual[_];
              if ($) {
                var A = Wi($);
                S = A * (parseFloat(S) / 100);
              }
            }
            r.originPoint[_] = S;
          }), g?.(f, d), (p = r.visualElement.animationState) === null || p === void 0 || p.setActive(Tt.Drag, !0));
        }, u = function(f, d) {
          var p = r.getProps(), h = p.dragPropagation, v = p.dragDirectionLock, m = p.onDirectionLock, g = p.onDrag;
          if (!(!h && !r.openGlobalLock)) {
            var _ = d.offset;
            if (v && r.currentDirection === null) {
              r.currentDirection = NF(_), r.currentDirection !== null && m?.(r.currentDirection);
              return;
            }
            r.updateAxis("x", d.point, _), r.updateAxis("y", d.point, _), r.visualElement.syncRender(), g?.(f, d);
          }
        }, c = function(f, d) {
          return r.stop(f, d);
        };
        this.panSession = new bT(t, {
          onSessionStart: s,
          onStart: l,
          onMove: u,
          onSessionEnd: c
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
      }
    }, e.prototype.stop = function(t, n) {
      var r = this.isDragging;
      if (this.cancel(), !!r) {
        var i = n.velocity;
        this.startAnimation(i);
        var o = this.getProps().onDragEnd;
        o?.(t, n);
      }
    }, e.prototype.cancel = function() {
      var t, n;
      this.isDragging = !1, this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !1), (t = this.panSession) === null || t === void 0 || t.end(), this.panSession = void 0;
      var r = this.getProps().dragPropagation;
      !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (n = this.visualElement.animationState) === null || n === void 0 || n.setActive(Tt.Drag, !1);
    }, e.prototype.updateAxis = function(t, n, r) {
      var i = this.getProps().drag;
      if (!(!r || !Wc(t, i, this.currentDirection))) {
        var o = this.getAxisMotionValue(t), a = this.originPoint[t] + r[t];
        this.constraints && this.constraints[t] && (a = _F(a, this.constraints[t], this.elastic[t])), o.set(a);
      }
    }, e.prototype.resolveConstraints = function() {
      var t = this, n = this.getProps(), r = n.dragConstraints, i = n.dragElastic, o = (this.visualElement.projection || {}).layout, a = this.constraints;
      r && ss(r) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : r && o ? this.constraints = wF(o.actual, r) : this.constraints = !1, this.elastic = OF(i), a !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && yi(function(s) {
        t.getAxisMotionValue(s) && (t.constraints[s] = SF(o.actual[s], t.constraints[s]));
      });
    }, e.prototype.resolveRefConstraints = function() {
      var t = this.getProps(), n = t.dragConstraints, r = t.onMeasureDragConstraints;
      if (!n || !ss(n))
        return !1;
      var i = n.current;
      Rr(i !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var o = this.visualElement.projection;
      if (!o || !o.layout)
        return !1;
      var a = AF(i, o.root, this.visualElement.getTransformPagePoint()), s = xF(o.layout.actual, a);
      if (r) {
        var l = r($F(s));
        this.hasMutatedConstraints = !!l, l && (s = wT(l));
      }
      return s;
    }, e.prototype.startAnimation = function(t) {
      var n = this, r = this.getProps(), i = r.drag, o = r.dragMomentum, a = r.dragElastic, s = r.dragTransition, l = r.dragSnapToOrigin, u = r.onDragTransitionEnd, c = this.constraints || {}, f = yi(function(d) {
        var p;
        if (Wc(d, i, n.currentDirection)) {
          var h = (p = c?.[d]) !== null && p !== void 0 ? p : {};
          l && (h = { min: 0, max: 0 });
          var v = a ? 200 : 1e6, m = a ? 40 : 1e7, g = we(we({ type: "inertia", velocity: o ? t[d] : 0, bounceStiffness: v, bounceDamping: m, timeConstant: 750, restDelta: 1, restSpeed: 10 }, s), h);
          return n.startAxisValueAnimation(d, g);
        }
      });
      return Promise.all(f).then(u);
    }, e.prototype.startAxisValueAnimation = function(t, n) {
      var r = this.getAxisMotionValue(t);
      return ab(t, r, 0, n);
    }, e.prototype.stopAnimation = function() {
      var t = this;
      yi(function(n) {
        return t.getAxisMotionValue(n).stop();
      });
    }, e.prototype.getAxisMotionValue = function(t) {
      var n, r, i = "_drag" + t.toUpperCase(), o = this.visualElement.getProps()[i];
      return o || this.visualElement.getValue(t, (r = (n = this.visualElement.getProps().initial) === null || n === void 0 ? void 0 : n[t]) !== null && r !== void 0 ? r : 0);
    }, e.prototype.snapToCursor = function(t) {
      var n = this;
      yi(function(r) {
        var i = n.getProps().drag;
        if (Wc(r, i, n.currentDirection)) {
          var o = n.visualElement.projection, a = n.getAxisMotionValue(r);
          if (o && o.layout) {
            var s = o.layout.actual[r], l = s.min, u = s.max;
            a.set(t[r] - Jt(l, u, 0.5));
          }
        }
      });
    }, e.prototype.scalePositionWithinConstraints = function() {
      var t = this, n, r = this.getProps(), i = r.drag, o = r.dragConstraints, a = this.visualElement.projection;
      if (!(!ss(o) || !a || !this.constraints)) {
        this.stopAnimation();
        var s = { x: 0, y: 0 };
        yi(function(u) {
          var c = t.getAxisMotionValue(u);
          if (c) {
            var f = c.get();
            s[u] = EF({ min: f, max: f }, t.constraints[u]);
          }
        });
        var l = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = l ? l({}, "") : "none", (n = a.root) === null || n === void 0 || n.updateScroll(), a.updateLayout(), this.resolveConstraints(), yi(function(u) {
          if (Wc(u, i, null)) {
            var c = t.getAxisMotionValue(u), f = t.constraints[u], d = f.min, p = f.max;
            c.set(Jt(d, p, s[u]));
          }
        });
      }
    }, e.prototype.addListeners = function() {
      var t = this, n;
      CF.set(this.visualElement, this);
      var r = this.visualElement.getInstance(), i = ws(r, "pointerdown", function(u) {
        var c = t.getProps(), f = c.drag, d = c.dragListener, p = d === void 0 ? !0 : d;
        f && p && t.start(u);
      }), o = function() {
        var u = t.getProps().dragConstraints;
        ss(u) && (t.constraints = t.resolveRefConstraints());
      }, a = this.visualElement.projection, s = a.addEventListener("measure", o);
      a && !a.layout && ((n = a.root) === null || n === void 0 || n.updateScroll(), a.updateLayout()), o();
      var l = pp(window, "resize", function() {
        return t.scalePositionWithinConstraints();
      });
      return a.addEventListener("didUpdate", (function(u) {
        var c = u.delta, f = u.hasLayoutChanged;
        t.isDragging && f && (yi(function(d) {
          var p = t.getAxisMotionValue(d);
          p && (t.originPoint[d] += c[d].translate, p.set(p.get() + c[d].translate));
        }), t.visualElement.syncRender());
      })), function() {
        l(), i(), s();
      };
    }, e.prototype.getProps = function() {
      var t = this.visualElement.getProps(), n = t.drag, r = n === void 0 ? !1 : n, i = t.dragDirectionLock, o = i === void 0 ? !1 : i, a = t.dragPropagation, s = a === void 0 ? !1 : a, l = t.dragConstraints, u = l === void 0 ? !1 : l, c = t.dragElastic, f = c === void 0 ? zm : c, d = t.dragMomentum, p = d === void 0 ? !0 : d;
      return we(we({}, t), { drag: r, dragDirectionLock: o, dragPropagation: s, dragConstraints: u, dragElastic: f, dragMomentum: p });
    }, e;
  })()
);
function Wc(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function NF(e, t) {
  t === void 0 && (t = 10);
  var n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
function RF(e) {
  var t = e.dragControls, n = e.visualElement, r = rl(function() {
    return new IF(n);
  });
  Ee(function() {
    return t && t.subscribe(r);
  }, [r, t]), Ee(function() {
    return r.addListeners();
  }, [r]);
}
function MF(e) {
  var t = e.onPan, n = e.onPanStart, r = e.onPanEnd, i = e.onPanSessionStart, o = e.visualElement, a = t || n || r || i, s = _e(null), l = Me(Vy).transformPagePoint, u = {
    onSessionStart: i,
    onStart: n,
    onMove: t,
    onEnd: function(f, d) {
      s.current = null, r && r(f, d);
    }
  };
  Ee(function() {
    s.current !== null && s.current.updateHandlers(u);
  });
  function c(f) {
    s.current = new bT(f, u, {
      transformPagePoint: l
    });
  }
  ad(o, "pointerdown", a && c), Yy(function() {
    return s.current && s.current.end();
  });
}
var jF = {
  pan: _o(MF),
  drag: _o(RF)
}, Zc = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function FF() {
  var e = Zc.map(function() {
    return new cu();
  }), t = {}, n = {
    clearAllListeners: function() {
      return e.forEach(function(r) {
        return r.clear();
      });
    },
    updatePropListeners: function(r) {
      Zc.forEach(function(i) {
        var o, a = "on" + i, s = r[a];
        (o = t[i]) === null || o === void 0 || o.call(t), s && (t[i] = n[a](s));
      });
    }
  };
  return e.forEach(function(r, i) {
    n["on" + Zc[i]] = function(o) {
      return r.add(o);
    }, n["notify" + Zc[i]] = function() {
      for (var o = [], a = 0; a < arguments.length; a++)
        o[a] = arguments[a];
      return r.notify.apply(r, ei([], Zt(o), !1));
    };
  }), n;
}
function zF(e, t, n) {
  var r;
  for (var i in t) {
    var o = t[i], a = n[i];
    if (qi(o))
      e.addValue(i, o), process.env.NODE_ENV === "development" && dT(o.version === "6.5.1", "Attempting to mix Framer Motion versions ".concat(o.version, " with 6.5.1 may not work as expected."));
    else if (qi(a))
      e.addValue(i, Ns(o));
    else if (a !== o)
      if (e.hasValue(i)) {
        var s = e.getValue(i);
        !s.hasAnimated && s.set(o);
      } else
        e.addValue(i, Ns((r = e.getStaticValue(i)) !== null && r !== void 0 ? r : o));
  }
  for (var i in n)
    t[i] === void 0 && e.removeValue(i);
  return t;
}
var OT = function(e) {
  var t = e.treeType, n = t === void 0 ? "" : t, r = e.build, i = e.getBaseTarget, o = e.makeTargetAnimatable, a = e.measureViewportBox, s = e.render, l = e.readValueFromInstance, u = e.removeValueFromRenderState, c = e.sortNodePosition, f = e.scrapeMotionValuesFromProps;
  return function(d, p) {
    var h = d.parent, v = d.props, m = d.presenceId, g = d.blockInitialAnimation, _ = d.visualState, w = d.shouldReduceMotion;
    p === void 0 && (p = {});
    var x = !1, S = _.latestValues, $ = _.renderState, A, E = FF(), y = /* @__PURE__ */ new Map(), b = /* @__PURE__ */ new Map(), O = {}, k = we({}, S), I;
    function T() {
      !A || !x || (V(), s(A, $, v.style, Q.projection));
    }
    function V() {
      r(Q, $, S, p, v);
    }
    function z() {
      E.notifyUpdate(S);
    }
    function B(K, ne) {
      var se = ne.onChange(function(X) {
        S[K] = X, v.onUpdate && ti.update(z, !1, !0);
      }), ce = ne.onRenderRequest(Q.scheduleRender);
      b.set(K, function() {
        se(), ce();
      });
    }
    var q = f(v);
    for (var M in q) {
      var N = q[M];
      S[M] !== void 0 && qi(N) && N.set(S[M], !1);
    }
    var Y = dp(v), ee = v$(v), Q = we(we({
      treeType: n,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: h ? h.depth + 1 : 0,
      parent: h,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId: m,
      shouldReduceMotion: w,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: ee ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!h?.isMounted(),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: g,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!A;
      },
      mount: function(K) {
        x = !0, A = Q.current = K, Q.projection && Q.projection.mount(K), ee && h && !Y && (I = h?.addVariantChild(Q)), y.forEach(function(ne, se) {
          return B(se, ne);
        }), h?.children.add(Q), Q.setProps(v);
      },
      /**
       *
       */
      unmount: function() {
        var K;
        (K = Q.projection) === null || K === void 0 || K.unmount(), Is.update(z), Is.render(T), b.forEach(function(ne) {
          return ne();
        }), I?.(), h?.children.delete(Q), E.clearAllListeners(), A = void 0, x = !1;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(K) {
        var ne, se = Q.getClosestVariantNode();
        if (se)
          return (ne = se.variantChildren) === null || ne === void 0 || ne.add(K), function() {
            return se.variantChildren.delete(K);
          };
      },
      sortNodePosition: function(K) {
        return !c || n !== K.treeType ? 0 : c(Q.getInstance(), K.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return ee ? Q : h?.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return v.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return A;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(K) {
        return S[K];
      },
      setStaticValue: function(K, ne) {
        return S[K] = ne;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return S;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(K) {
        Q.isVisible !== K && (Q.isVisible = K, Q.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(K, ne) {
        return ne === void 0 && (ne = !0), o(Q, K, v, ne);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return a(A, v);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(K, ne) {
        Q.hasValue(K) && Q.removeValue(K), y.set(K, ne), S[K] = ne.get(), B(K, ne);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(K) {
        var ne;
        y.delete(K), (ne = b.get(K)) === null || ne === void 0 || ne(), b.delete(K), delete S[K], u(K, $);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(K) {
        return y.has(K);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(K, ne) {
        var se = y.get(K);
        return se === void 0 && ne !== void 0 && (se = Ns(ne), Q.addValue(K, se)), se;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(K) {
        return y.forEach(K);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(K) {
        var ne;
        return (ne = S[K]) !== null && ne !== void 0 ? ne : l(A, K, p);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(K, ne) {
        k[K] = ne;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(K) {
        if (i) {
          var ne = i(v, K);
          if (ne !== void 0 && !qi(ne))
            return ne;
        }
        return k[K];
      }
    }, E), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return V(), $;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        ti.render(T, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: T,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(K) {
        (K.transformTemplate || v.transformTemplate) && Q.scheduleRender(), v = K, E.updatePropListeners(K), O = zF(Q, f(v), O);
      },
      getProps: function() {
        return v;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(K) {
        var ne;
        return (ne = v.variants) === null || ne === void 0 ? void 0 : ne[K];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return v.transition;
      },
      getTransformPagePoint: function() {
        return v.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(K) {
        if (K === void 0 && (K = !1), K)
          return h?.getVariantContext();
        if (!Y) {
          var ne = h?.getVariantContext() || {};
          return v.initial !== void 0 && (ne.initial = v.initial), ne;
        }
        for (var se = {}, ce = 0; ce < LF; ce++) {
          var X = $T[ce], D = v[X];
          (Zr(D) || D === !1) && (se[X] = D);
        }
        return se;
      }
    });
    return Q;
  };
}, $T = ei(["initial"], Zt(ub), !1), LF = $T.length;
function Vm(e) {
  return typeof e == "string" && e.startsWith("var(--");
}
var TT = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function VF(e) {
  var t = TT.exec(e);
  if (!t)
    return [,];
  var n = Zt(t, 3), r = n[1], i = n[2];
  return [r, i];
}
var KF = 4;
function Km(e, t, n) {
  n === void 0 && (n = 1), Rr(n <= KF, 'Max CSS variable fallback depth detected in property "'.concat(e, '". This may indicate a circular fallback dependency.'));
  var r = Zt(VF(e), 2), i = r[0], o = r[1];
  if (i) {
    var a = window.getComputedStyle(t).getPropertyValue(i);
    return a ? a.trim() : Vm(o) ? Km(o, t, n + 1) : o;
  }
}
function BF(e, t, n) {
  var r, i = Fr(t, []), o = e.getInstance();
  if (!(o instanceof Element))
    return { target: i, transitionEnd: n };
  n && (n = we({}, n)), e.forEachValue(function(u) {
    var c = u.get();
    if (Vm(c)) {
      var f = Km(c, o);
      f && u.set(f);
    }
  });
  for (var a in i) {
    var s = i[a];
    if (Vm(s)) {
      var l = Km(s, o);
      l && (i[a] = l, n && ((r = n[a]) !== null && r !== void 0 || (n[a] = s)));
    }
  }
  return { target: i, transitionEnd: n };
}
var UF = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), PT = function(e) {
  return UF.has(e);
}, qF = function(e) {
  return Object.keys(e).some(PT);
}, kT = function(e, t) {
  e.set(t, !1), e.set(t);
}, Gc = function(e) {
  return e === Na || e === Ze;
}, cw;
(function(e) {
  e.width = "width", e.height = "height", e.left = "left", e.right = "right", e.top = "top", e.bottom = "bottom";
})(cw || (cw = {}));
var fw = function(e, t) {
  return parseFloat(e.split(", ")[t]);
}, dw = function(e, t) {
  return function(n, r) {
    var i = r.transform;
    if (i === "none" || !i)
      return 0;
    var o = i.match(/^matrix3d\((.+)\)$/);
    if (o)
      return fw(o[1], t);
    var a = i.match(/^matrix\((.+)\)$/);
    return a ? fw(a[1], e) : 0;
  };
}, HF = /* @__PURE__ */ new Set(["x", "y", "z"]), WF = Du.filter(function(e) {
  return !HF.has(e);
});
function ZF(e) {
  var t = [];
  return WF.forEach(function(n) {
    var r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t.length && e.syncRender(), t;
}
var pw = {
  // Dimensions
  width: function(e, t) {
    var n = e.x, r = t.paddingLeft, i = r === void 0 ? "0" : r, o = t.paddingRight, a = o === void 0 ? "0" : o;
    return n.max - n.min - parseFloat(i) - parseFloat(a);
  },
  height: function(e, t) {
    var n = e.y, r = t.paddingTop, i = r === void 0 ? "0" : r, o = t.paddingBottom, a = o === void 0 ? "0" : o;
    return n.max - n.min - parseFloat(i) - parseFloat(a);
  },
  top: function(e, t) {
    var n = t.top;
    return parseFloat(n);
  },
  left: function(e, t) {
    var n = t.left;
    return parseFloat(n);
  },
  bottom: function(e, t) {
    var n = e.y, r = t.top;
    return parseFloat(r) + (n.max - n.min);
  },
  right: function(e, t) {
    var n = e.x, r = t.left;
    return parseFloat(r) + (n.max - n.min);
  },
  // Transform
  x: dw(4, 13),
  y: dw(5, 14)
}, GF = function(e, t, n) {
  var r = t.measureViewportBox(), i = t.getInstance(), o = getComputedStyle(i), a = o.display, s = {};
  a === "none" && t.setStaticValue("display", e.display || "block"), n.forEach(function(u) {
    s[u] = pw[u](r, o);
  }), t.syncRender();
  var l = t.measureViewportBox();
  return n.forEach(function(u) {
    var c = t.getValue(u);
    kT(c, s[u]), e[u] = pw[u](l, o);
  }), e;
}, YF = function(e, t, n, r) {
  n === void 0 && (n = {}), r === void 0 && (r = {}), t = we({}, t), r = we({}, r);
  var i = Object.keys(t).filter(PT), o = [], a = !1, s = [];
  if (i.forEach(function(c) {
    var f = e.getValue(c);
    if (e.hasValue(c)) {
      var d = n[c], p = Rl(d), h = t[c], v;
      if (Cu(h)) {
        var m = h.length, g = h[0] === null ? 1 : 0;
        d = h[g], p = Rl(d);
        for (var _ = g; _ < m; _++)
          v ? Rr(Rl(h[_]) === v, "All keyframes must be of the same type") : (v = Rl(h[_]), Rr(v === p || Gc(p) && Gc(v), "Keyframes must be of the same dimension as the current value"));
      } else
        v = Rl(h);
      if (p !== v)
        if (Gc(p) && Gc(v)) {
          var w = f.get();
          typeof w == "string" && f.set(parseFloat(w)), typeof h == "string" ? t[c] = parseFloat(h) : Array.isArray(h) && v === Ze && (t[c] = h.map(parseFloat));
        } else p?.transform && v?.transform && (d === 0 || h === 0) ? d === 0 ? f.set(v.transform(d)) : t[c] = p.transform(h) : (a || (o = ZF(e), a = !0), s.push(c), r[c] = r[c] !== void 0 ? r[c] : t[c], kT(f, h));
    }
  }), s.length) {
    var l = s.indexOf("height") >= 0 ? window.pageYOffset : null, u = GF(t, e, s);
    return o.length && o.forEach(function(c) {
      var f = Zt(c, 2), d = f[0], p = f[1];
      e.getValue(d).set(p);
    }), e.syncRender(), l !== null && window.scrollTo({ top: l }), { target: u, transitionEnd: r };
  } else
    return { target: t, transitionEnd: r };
};
function QF(e, t, n, r) {
  return qF(t) ? YF(e, t, n, r) : { target: t, transitionEnd: r };
}
var JF = function(e, t, n, r) {
  var i = BF(e, t, r);
  return t = i.target, r = i.transitionEnd, QF(e, t, n, r);
};
function XF(e) {
  return window.getComputedStyle(e);
}
var DT = {
  treeType: "dom",
  readValueFromInstance: function(e, t) {
    if (fc(t)) {
      var n = rb(t);
      return n && n.default || 0;
    } else {
      var r = XF(e);
      return (b$(t) ? r.getPropertyValue(t) : r[t]) || 0;
    }
  },
  sortNodePosition: function(e, t) {
    return e.compareDocumentPosition(t) & 2 ? 1 : -1;
  },
  getBaseTarget: function(e, t) {
    var n;
    return (n = e.style) === null || n === void 0 ? void 0 : n[t];
  },
  measureViewportBox: function(e, t) {
    var n = t.transformPagePoint;
    return ST(e, n);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(e, t, n) {
    var r = n.transformTemplate;
    t.style.transform = r ? r({}, "") : "none", e.scheduleRender();
  },
  restoreTransform: function(e, t) {
    e.style.transform = t.style.transform;
  },
  removeValueFromRenderState: function(e, t) {
    var n = t.vars, r = t.style;
    delete n[e], delete r[e];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(e, t, n, r) {
    var i = n.transformValues;
    r === void 0 && (r = !0);
    var o = t.transition, a = t.transitionEnd, s = Fr(t, ["transition", "transitionEnd"]), l = oF(s, o || {}, e);
    if (i && (a && (a = i(a)), s && (s = i(s)), l && (l = i(l))), r) {
      rF(e, s, l);
      var u = JF(e, s, l, a);
      a = u.transitionEnd, s = u.target;
    }
    return we({ transition: o, transitionEnd: a }, s);
  },
  scrapeMotionValuesFromProps: Wy,
  build: function(e, t, n, r, i) {
    e.isVisible !== void 0 && (t.style.visibility = e.isVisible ? "visible" : "hidden"), Uy(t, n, r, i.transformTemplate);
  },
  render: C$
}, e8 = OT(DT), t8 = OT(we(we({}, DT), { getBaseTarget: function(e, t) {
  return e[t];
}, readValueFromInstance: function(e, t) {
  var n;
  return fc(t) ? ((n = rb(t)) === null || n === void 0 ? void 0 : n.default) || 0 : (t = I$.has(t) ? t : A$(t), e.getAttribute(t));
}, scrapeMotionValuesFromProps: R$, build: function(e, t, n, r, i) {
  Hy(t, n, r, i.transformTemplate);
}, render: N$ })), n8 = function(e, t) {
  return Ky(e) ? t8(t, { enableHardwareAcceleration: !1 }) : e8(t, { enableHardwareAcceleration: !0 });
};
function hw(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
var Ml = {
  correct: function(e, t) {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (Ze.test(e))
        e = parseFloat(e);
      else
        return e;
    var n = hw(e, t.target.x), r = hw(e, t.target.y);
    return "".concat(n, "% ").concat(r, "%");
  }
}, vw = "_$css", r8 = {
  correct: function(e, t) {
    var n = t.treeScale, r = t.projectionDelta, i = e, o = e.includes("var("), a = [];
    o && (e = e.replace(TT, function(v) {
      return a.push(v), vw;
    }));
    var s = Hi.parse(e);
    if (s.length > 5)
      return i;
    var l = Hi.createTransformer(e), u = typeof s[0] != "number" ? 1 : 0, c = r.x.scale * n.x, f = r.y.scale * n.y;
    s[0 + u] /= c, s[1 + u] /= f;
    var d = Jt(c, f, 0.5);
    typeof s[2 + u] == "number" && (s[2 + u] /= d), typeof s[3 + u] == "number" && (s[3 + u] /= d);
    var p = l(s);
    if (o) {
      var h = 0;
      p = p.replace(vw, function() {
        var v = a[h];
        return h++, v;
      });
    }
    return p;
  }
}, i8 = (
  /** @class */
  (function(e) {
    u$(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.componentDidMount = function() {
      var n = this, r = this.props, i = r.visualElement, o = r.layoutGroup, a = r.switchLayoutGroup, s = r.layoutId, l = i.projection;
      AM(a8), l && (o?.group && o.group.add(l), a?.register && s && a.register(l), l.root.didUpdate(), l.addEventListener("animationComplete", function() {
        n.safeToRemove();
      }), l.setOptions(we(we({}, l.options), { onExitComplete: function() {
        return n.safeToRemove();
      } }))), su.hasEverUpdated = !0;
    }, t.prototype.getSnapshotBeforeUpdate = function(n) {
      var r = this, i = this.props, o = i.layoutDependency, a = i.visualElement, s = i.drag, l = i.isPresent, u = a.projection;
      return u && (u.isPresent = l, s || n.layoutDependency !== o || o === void 0 ? u.willUpdate() : this.safeToRemove(), n.isPresent !== l && (l ? u.promote() : u.relegate() || ti.postRender(function() {
        var c;
        !((c = u.getStack()) === null || c === void 0) && c.members.length || r.safeToRemove();
      }))), null;
    }, t.prototype.componentDidUpdate = function() {
      var n = this.props.visualElement.projection;
      n && (n.root.didUpdate(), !n.currentAnimation && n.isLead() && this.safeToRemove());
    }, t.prototype.componentWillUnmount = function() {
      var n = this.props, r = n.visualElement, i = n.layoutGroup, o = n.switchLayoutGroup, a = r.projection;
      a && (a.scheduleCheckAfterUnmount(), i?.group && i.group.remove(a), o?.deregister && o.deregister(a));
    }, t.prototype.safeToRemove = function() {
      var n = this.props.safeToRemove;
      n?.();
    }, t.prototype.render = function() {
      return null;
    }, t;
  })(H.Component)
);
function o8(e) {
  var t = Zt(hT(), 2), n = t[0], r = t[1], i = Me(ku);
  return H.createElement(i8, we({}, e, { layoutGroup: i, switchLayoutGroup: Me(m$), isPresent: n, safeToRemove: r }));
}
var a8 = {
  borderRadius: we(we({}, Ml), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: Ml,
  borderTopRightRadius: Ml,
  borderBottomLeftRadius: Ml,
  borderBottomRightRadius: Ml,
  boxShadow: r8
}, s8 = {
  measureLayout: o8
};
function l8(e, t, n) {
  n === void 0 && (n = {});
  var r = qi(e) ? e : Ns(e);
  return ab("", r, t, n), {
    stop: function() {
      return r.stop();
    },
    isAnimating: function() {
      return r.isAnimating();
    }
  };
}
var AT = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], u8 = AT.length, mw = function(e) {
  return typeof e == "string" ? parseFloat(e) : e;
}, gw = function(e) {
  return typeof e == "number" || Ze.test(e);
};
function c8(e, t, n, r, i, o) {
  var a, s, l, u;
  i ? (e.opacity = Jt(
    0,
    // (follow?.opacity as number) ?? 0,
    // TODO Reinstate this if only child
    (a = n.opacity) !== null && a !== void 0 ? a : 1,
    f8(r)
  ), e.opacityExit = Jt((s = t.opacity) !== null && s !== void 0 ? s : 1, 0, d8(r))) : o && (e.opacity = Jt((l = t.opacity) !== null && l !== void 0 ? l : 1, (u = n.opacity) !== null && u !== void 0 ? u : 1, r));
  for (var c = 0; c < u8; c++) {
    var f = "border".concat(AT[c], "Radius"), d = yw(t, f), p = yw(n, f);
    if (!(d === void 0 && p === void 0)) {
      d || (d = 0), p || (p = 0);
      var h = d === 0 || p === 0 || gw(d) === gw(p);
      h ? (e[f] = Math.max(Jt(mw(d), mw(p), r), 0), ($i.test(p) || $i.test(d)) && (e[f] += "%")) : e[f] = p;
    }
  }
  (t.rotate || n.rotate) && (e.rotate = Jt(t.rotate || 0, n.rotate || 0, r));
}
function yw(e, t) {
  var n;
  return (n = e[t]) !== null && n !== void 0 ? n : e.borderRadius;
}
var f8 = CT(0, 0.5, tb), d8 = CT(0.5, 0.95, Xy);
function CT(e, t, n) {
  return function(r) {
    return r < e ? 0 : r > t ? 1 : n(Iu(e, t, r));
  };
}
function bw(e, t) {
  e.min = t.min, e.max = t.max;
}
function Ur(e, t) {
  bw(e.x, t.x), bw(e.y, t.y);
}
function _w(e, t, n, r, i) {
  return e -= t, e = dd(e, 1 / n, r), i !== void 0 && (e = dd(e, 1 / i, r)), e;
}
function p8(e, t, n, r, i, o, a) {
  if (t === void 0 && (t = 0), n === void 0 && (n = 1), r === void 0 && (r = 0.5), o === void 0 && (o = e), a === void 0 && (a = e), $i.test(t)) {
    t = parseFloat(t);
    var s = Jt(a.min, a.max, t / 100);
    t = s - a.min;
  }
  if (typeof t == "number") {
    var l = Jt(o.min, o.max, r);
    e === o && (l -= t), e.min = _w(e.min, t, n, l, i), e.max = _w(e.max, t, n, l, i);
  }
}
function ww(e, t, n, r, i) {
  var o = Zt(n, 3), a = o[0], s = o[1], l = o[2];
  p8(e, t[a], t[s], t[l], t.scale, r, i);
}
var h8 = ["x", "scaleX", "originX"], v8 = ["y", "scaleY", "originY"];
function xw(e, t, n, r) {
  ww(e.x, t, h8, n?.x, r?.x), ww(e.y, t, v8, n?.y, r?.y);
}
function Ew(e) {
  return e.translate === 0 && e.scale === 1;
}
function IT(e) {
  return Ew(e.x) && Ew(e.y);
}
function NT(e, t) {
  return e.x.min === t.x.min && e.x.max === t.x.max && e.y.min === t.y.min && e.y.max === t.y.max;
}
var m8 = (
  /** @class */
  (function() {
    function e() {
      this.members = [];
    }
    return e.prototype.add = function(t) {
      sb(this.members, t), t.scheduleRender();
    }, e.prototype.remove = function(t) {
      if (lb(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
        var n = this.members[this.members.length - 1];
        n && this.promote(n);
      }
    }, e.prototype.relegate = function(t) {
      var n = this.members.findIndex(function(a) {
        return t === a;
      });
      if (n === 0)
        return !1;
      for (var r, i = n; i >= 0; i--) {
        var o = this.members[i];
        if (o.isPresent !== !1) {
          r = o;
          break;
        }
      }
      return r ? (this.promote(r), !0) : !1;
    }, e.prototype.promote = function(t, n) {
      var r, i = this.lead;
      if (t !== i && (this.prevLead = i, this.lead = t, t.show(), i)) {
        i.instance && i.scheduleRender(), t.scheduleRender(), t.resumeFrom = i, n && (t.resumeFrom.preserveOpacity = !0), i.snapshot && (t.snapshot = i.snapshot, t.snapshot.latestValues = i.animationValues || i.latestValues, t.snapshot.isShared = !0), !((r = t.root) === null || r === void 0) && r.isUpdating && (t.isLayoutDirty = !0);
        var o = t.options.crossfade;
        o === !1 && i.hide();
      }
    }, e.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(t) {
        var n, r, i, o, a;
        (r = (n = t.options).onExitComplete) === null || r === void 0 || r.call(n), (a = (i = t.resumingFrom) === null || i === void 0 ? void 0 : (o = i.options).onExitComplete) === null || a === void 0 || a.call(o);
      });
    }, e.prototype.scheduleRender = function() {
      this.members.forEach(function(t) {
        t.instance && t.scheduleRender(!1);
      });
    }, e.prototype.removeLeadSnapshot = function() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }, e;
  })()
), g8 = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function Sw(e, t, n) {
  var r = e.x.translate / t.x, i = e.y.translate / t.y, o = "translate3d(".concat(r, "px, ").concat(i, "px, 0) ");
  if (o += "scale(".concat(1 / t.x, ", ").concat(1 / t.y, ") "), n) {
    var a = n.rotate, s = n.rotateX, l = n.rotateY;
    a && (o += "rotate(".concat(a, "deg) ")), s && (o += "rotateX(".concat(s, "deg) ")), l && (o += "rotateY(".concat(l, "deg) "));
  }
  var u = e.x.scale * t.x, c = e.y.scale * t.y;
  return o += "scale(".concat(u, ", ").concat(c, ")"), o === g8 ? "none" : o;
}
var y8 = function(e, t) {
  return e.depth - t.depth;
}, b8 = (
  /** @class */
  (function() {
    function e() {
      this.children = [], this.isDirty = !1;
    }
    return e.prototype.add = function(t) {
      sb(this.children, t), this.isDirty = !0;
    }, e.prototype.remove = function(t) {
      lb(this.children, t), this.isDirty = !0;
    }, e.prototype.forEach = function(t) {
      this.isDirty && this.children.sort(y8), this.isDirty = !1, this.children.forEach(t);
    }, e;
  })()
), Ow = 1e3;
function RT(e) {
  var t = e.attachResizeListener, n = e.defaultParent, r = e.measureScroll, i = e.checkIsScrollRoot, o = e.resetTransform;
  return (
    /** @class */
    (function() {
      function a(s, l, u) {
        var c = this;
        l === void 0 && (l = {}), u === void 0 && (u = n?.()), this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = function() {
          c.isUpdating && (c.isUpdating = !1, c.clearAllSnapshots());
        }, this.updateProjection = function() {
          c.nodes.forEach(O8), c.nodes.forEach($8);
        }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.id = s, this.latestValues = l, this.root = u ? u.root || u : this, this.path = u ? ei(ei([], Zt(u.path), !1), [u], !1) : [], this.parent = u, this.depth = u ? u.depth + 1 : 0, s && this.root.registerPotentialNode(s, this);
        for (var f = 0; f < this.path.length; f++)
          this.path[f].shouldResetTransform = !0;
        this.root === this && (this.nodes = new b8());
      }
      return a.prototype.addEventListener = function(s, l) {
        return this.eventHandlers.has(s) || this.eventHandlers.set(s, new cu()), this.eventHandlers.get(s).add(l);
      }, a.prototype.notifyListeners = function(s) {
        for (var l = [], u = 1; u < arguments.length; u++)
          l[u - 1] = arguments[u];
        var c = this.eventHandlers.get(s);
        c?.notify.apply(c, ei([], Zt(l), !1));
      }, a.prototype.hasListeners = function(s) {
        return this.eventHandlers.has(s);
      }, a.prototype.registerPotentialNode = function(s, l) {
        this.potentialNodes.set(s, l);
      }, a.prototype.mount = function(s, l) {
        var u = this, c;
        if (l === void 0 && (l = !1), !this.instance) {
          this.isSVG = s instanceof SVGElement && s.tagName !== "svg", this.instance = s;
          var f = this.options, d = f.layoutId, p = f.layout, h = f.visualElement;
          if (h && !h.getInstance() && h.mount(s), this.root.nodes.add(this), (c = this.parent) === null || c === void 0 || c.children.add(this), this.id && this.root.potentialNodes.delete(this.id), l && (p || d) && (this.isLayoutDirty = !0), t) {
            var v, m = function() {
              return u.root.updateBlockedByResize = !1;
            };
            t(s, function() {
              u.root.updateBlockedByResize = !0, clearTimeout(v), v = window.setTimeout(m, 250), su.hasAnimatedSinceResize && (su.hasAnimatedSinceResize = !1, u.nodes.forEach(S8));
            });
          }
          d && this.root.registerSharedNode(d, this), this.options.animate !== !1 && h && (d || p) && this.addEventListener("didUpdate", function(g) {
            var _, w, x, S, $, A = g.delta, E = g.hasLayoutChanged, y = g.hasRelativeTargetChanged, b = g.layout;
            if (u.isTreeAnimationBlocked()) {
              u.target = void 0, u.relativeTarget = void 0;
              return;
            }
            var O = (w = (_ = u.options.transition) !== null && _ !== void 0 ? _ : h.getDefaultTransition()) !== null && w !== void 0 ? w : A8, k = h.getProps(), I = k.onLayoutAnimationStart, T = k.onLayoutAnimationComplete, V = !u.targetLayout || !NT(u.targetLayout, b) || y, z = !E && y;
            if (!((x = u.resumeFrom) === null || x === void 0) && x.instance || z || E && (V || !u.currentAnimation)) {
              u.resumeFrom && (u.resumingFrom = u.resumeFrom, u.resumingFrom.resumingFrom = void 0), u.setAnimationOrigin(A, z);
              var B = we(we({}, ob(O, "layout")), { onPlay: I, onComplete: T });
              h.shouldReduceMotion && (B.delay = 0, B.type = !1), u.startAnimation(B);
            } else
              !E && u.animationProgress === 0 && u.finishAnimation(), u.isLead() && (($ = (S = u.options).onExitComplete) === null || $ === void 0 || $.call(S));
            u.targetLayout = b;
          });
        }
      }, a.prototype.unmount = function() {
        var s, l;
        this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this), (s = this.getStack()) === null || s === void 0 || s.remove(this), (l = this.parent) === null || l === void 0 || l.children.delete(this), this.instance = void 0, Is.preRender(this.updateProjection);
      }, a.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = !0;
      }, a.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = !1;
      }, a.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }, a.prototype.isTreeAnimationBlocked = function() {
        var s;
        return this.isAnimationBlocked || ((s = this.parent) === null || s === void 0 ? void 0 : s.isTreeAnimationBlocked()) || !1;
      }, a.prototype.startUpdate = function() {
        var s;
        this.isUpdateBlocked() || (this.isUpdating = !0, (s = this.nodes) === null || s === void 0 || s.forEach(T8));
      }, a.prototype.willUpdate = function(s) {
        var l, u, c;
        if (s === void 0 && (s = !0), this.root.isUpdateBlocked()) {
          (u = (l = this.options).onExitComplete) === null || u === void 0 || u.call(l);
          return;
        }
        if (!this.root.isUpdating && this.root.startUpdate(), !this.isLayoutDirty) {
          this.isLayoutDirty = !0;
          for (var f = 0; f < this.path.length; f++) {
            var d = this.path[f];
            d.shouldResetTransform = !0, d.updateScroll();
          }
          var p = this.options, h = p.layoutId, v = p.layout;
          if (!(h === void 0 && !v)) {
            var m = (c = this.options.visualElement) === null || c === void 0 ? void 0 : c.getProps().transformTemplate;
            this.prevTransformTemplateValue = m?.(this.latestValues, ""), this.updateSnapshot(), s && this.notifyListeners("willUpdate");
          }
        }
      }, a.prototype.didUpdate = function() {
        var s = this.isUpdateBlocked();
        if (s) {
          this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach($w);
          return;
        }
        this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(C8), this.potentialNodes.clear()), this.nodes.forEach(E8), this.nodes.forEach(_8), this.nodes.forEach(w8), this.clearAllSnapshots(), Kh.update(), Kh.preRender(), Kh.render());
      }, a.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(x8), this.sharedNodes.forEach(P8);
      }, a.prototype.scheduleUpdateProjection = function() {
        ti.preRender(this.updateProjection, !1, !0);
      }, a.prototype.scheduleCheckAfterUnmount = function() {
        var s = this;
        ti.postRender(function() {
          s.isLayoutDirty ? s.root.didUpdate() : s.root.checkUpdateFailed();
        });
      }, a.prototype.updateSnapshot = function() {
        if (!(this.snapshot || !this.instance)) {
          var s = this.measure(), l = this.removeTransform(this.removeElementScroll(s));
          Dw(l), this.snapshot = {
            measured: s,
            layout: l,
            latestValues: {}
          };
        }
      }, a.prototype.updateLayout = function() {
        var s;
        if (this.instance && (this.updateScroll(), !(!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))) {
          if (this.resumeFrom && !this.resumeFrom.instance)
            for (var l = 0; l < this.path.length; l++) {
              var u = this.path[l];
              u.updateScroll();
            }
          var c = this.measure();
          Dw(c);
          var f = this.layout;
          this.layout = {
            measured: c,
            actual: this.removeElementScroll(c)
          }, this.layoutCorrected = Dn(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.actual), (s = this.options.visualElement) === null || s === void 0 || s.notifyLayoutMeasure(this.layout.actual, f?.actual);
        }
      }, a.prototype.updateScroll = function() {
        this.options.layoutScroll && this.instance && (this.isScrollRoot = i(this.instance), this.scroll = r(this.instance));
      }, a.prototype.resetTransform = function() {
        var s;
        if (o) {
          var l = this.isLayoutDirty || this.shouldResetTransform, u = this.projectionDelta && !IT(this.projectionDelta), c = (s = this.options.visualElement) === null || s === void 0 ? void 0 : s.getProps().transformTemplate, f = c?.(this.latestValues, ""), d = f !== this.prevTransformTemplateValue;
          l && (u || lo(this.latestValues) || d) && (o(this.instance, f), this.shouldResetTransform = !1, this.scheduleRender());
        }
      }, a.prototype.measure = function() {
        var s = this.options.visualElement;
        if (!s)
          return Dn();
        var l = s.measureViewportBox(), u = this.root.scroll;
        return u && (co(l.x, u.x), co(l.y, u.y)), l;
      }, a.prototype.removeElementScroll = function(s) {
        var l = Dn();
        Ur(l, s);
        for (var u = 0; u < this.path.length; u++) {
          var c = this.path[u], f = c.scroll, d = c.options, p = c.isScrollRoot;
          if (c !== this.root && f && d.layoutScroll) {
            if (p) {
              Ur(l, s);
              var h = this.root.scroll;
              h && (co(l.x, -h.x), co(l.y, -h.y));
            }
            co(l.x, f.x), co(l.y, f.y);
          }
        }
        return l;
      }, a.prototype.applyTransform = function(s, l) {
        l === void 0 && (l = !1);
        var u = Dn();
        Ur(u, s);
        for (var c = 0; c < this.path.length; c++) {
          var f = this.path[c];
          !l && f.options.layoutScroll && f.scroll && f !== f.root && ls(u, {
            x: -f.scroll.x,
            y: -f.scroll.y
          }), lo(f.latestValues) && ls(u, f.latestValues);
        }
        return lo(this.latestValues) && ls(u, this.latestValues), u;
      }, a.prototype.removeTransform = function(s) {
        var l, u = Dn();
        Ur(u, s);
        for (var c = 0; c < this.path.length; c++) {
          var f = this.path[c];
          if (f.instance && lo(f.latestValues)) {
            xT(f.latestValues) && f.updateSnapshot();
            var d = Dn(), p = f.measure();
            Ur(d, p), xw(u, f.latestValues, (l = f.snapshot) === null || l === void 0 ? void 0 : l.layout, d);
          }
        }
        return lo(this.latestValues) && xw(u, this.latestValues), u;
      }, a.prototype.setTargetDelta = function(s) {
        this.targetDelta = s, this.root.scheduleUpdateProjection();
      }, a.prototype.setOptions = function(s) {
        var l;
        this.options = we(we(we({}, this.options), s), { crossfade: (l = s.crossfade) !== null && l !== void 0 ? l : !0 });
      }, a.prototype.clearMeasurements = function() {
        this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
      }, a.prototype.resolveTargetDelta = function() {
        var s, l = this.options, u = l.layout, c = l.layoutId;
        !this.layout || !(u || c) || (!this.targetDelta && !this.relativeTarget && (this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && this.relativeParent.layout && (this.relativeTarget = Dn(), this.relativeTargetOrigin = Dn(), du(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual), Ur(this.relativeTarget, this.relativeTargetOrigin))), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = Dn(), this.targetWithTransforms = Dn()), this.relativeTarget && this.relativeTargetOrigin && (!((s = this.relativeParent) === null || s === void 0) && s.target) ? bF(this.target, this.relativeTarget, this.relativeParent.target) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.actual) : Ur(this.target, this.layout.actual), ET(this.target, this.targetDelta)) : Ur(this.target, this.layout.actual), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && !!this.relativeParent.resumingFrom == !!this.resumingFrom && !this.relativeParent.options.layoutScroll && this.relativeParent.target && (this.relativeTarget = Dn(), this.relativeTargetOrigin = Dn(), du(this.relativeTargetOrigin, this.target, this.relativeParent.target), Ur(this.relativeTarget, this.relativeTargetOrigin)))));
      }, a.prototype.getClosestProjectingParent = function() {
        if (!(!this.parent || lo(this.parent.latestValues)))
          return (this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout ? this.parent : this.parent.getClosestProjectingParent();
      }, a.prototype.calcProjection = function() {
        var s, l = this.options, u = l.layout, c = l.layoutId;
        if (this.isTreeAnimating = !!(!((s = this.parent) === null || s === void 0) && s.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !(!this.layout || !(u || c))) {
          var f = this.getLead();
          Ur(this.layoutCorrected, this.layout.actual), PF(this.layoutCorrected, this.treeScale, this.path, !!this.resumingFrom || this !== f);
          var d = f.target;
          if (d) {
            this.projectionDelta || (this.projectionDelta = pu(), this.projectionDeltaWithTransform = pu());
            var p = this.treeScale.x, h = this.treeScale.y, v = this.projectionTransform;
            fu(this.projectionDelta, this.layoutCorrected, d, this.latestValues), this.projectionTransform = Sw(this.projectionDelta, this.treeScale), (this.projectionTransform !== v || this.treeScale.x !== p || this.treeScale.y !== h) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", d));
          }
        }
      }, a.prototype.hide = function() {
        this.isVisible = !1;
      }, a.prototype.show = function() {
        this.isVisible = !0;
      }, a.prototype.scheduleRender = function(s) {
        var l, u, c;
        s === void 0 && (s = !0), (u = (l = this.options).scheduleRender) === null || u === void 0 || u.call(l), s && ((c = this.getStack()) === null || c === void 0 || c.scheduleRender()), this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }, a.prototype.setAnimationOrigin = function(s, l) {
        var u = this, c;
        l === void 0 && (l = !1);
        var f = this.snapshot, d = f?.latestValues || {}, p = we({}, this.latestValues), h = pu();
        this.relativeTarget = this.relativeTargetOrigin = void 0, this.attemptToResolveRelativeTarget = !l;
        var v = Dn(), m = f?.isShared, g = (((c = this.getStack()) === null || c === void 0 ? void 0 : c.members.length) || 0) <= 1, _ = !!(m && !g && this.options.crossfade === !0 && !this.path.some(D8));
        this.animationProgress = 0, this.mixTargetDelta = function(w) {
          var x, S = w / 1e3;
          Tw(h.x, s.x, S), Tw(h.y, s.y, S), u.setTargetDelta(h), u.relativeTarget && u.relativeTargetOrigin && u.layout && (!((x = u.relativeParent) === null || x === void 0) && x.layout) && (du(v, u.layout.actual, u.relativeParent.layout.actual), k8(u.relativeTarget, u.relativeTargetOrigin, v, S)), m && (u.animationValues = p, c8(p, d, u.latestValues, S, _, g)), u.root.scheduleUpdateProjection(), u.scheduleRender(), u.animationProgress = S;
        }, this.mixTargetDelta(0);
      }, a.prototype.startAnimation = function(s) {
        var l = this, u, c;
        this.notifyListeners("animationStart"), (u = this.currentAnimation) === null || u === void 0 || u.stop(), this.resumingFrom && ((c = this.resumingFrom.currentAnimation) === null || c === void 0 || c.stop()), this.pendingAnimation && (Is.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = ti.update(function() {
          su.hasAnimatedSinceResize = !0, l.currentAnimation = l8(0, Ow, we(we({}, s), { onUpdate: function(f) {
            var d;
            l.mixTargetDelta(f), (d = s.onUpdate) === null || d === void 0 || d.call(s, f);
          }, onComplete: function() {
            var f;
            (f = s.onComplete) === null || f === void 0 || f.call(s), l.completeAnimation();
          } })), l.resumingFrom && (l.resumingFrom.currentAnimation = l.currentAnimation), l.pendingAnimation = void 0;
        });
      }, a.prototype.completeAnimation = function() {
        var s;
        this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0), (s = this.getStack()) === null || s === void 0 || s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
      }, a.prototype.finishAnimation = function() {
        var s;
        this.currentAnimation && ((s = this.mixTargetDelta) === null || s === void 0 || s.call(this, Ow), this.currentAnimation.stop()), this.completeAnimation();
      }, a.prototype.applyTransformsToTarget = function() {
        var s = this.getLead(), l = s.targetWithTransforms, u = s.target, c = s.layout, f = s.latestValues;
        !l || !u || !c || (Ur(l, u), ls(l, f), fu(this.projectionDeltaWithTransform, this.layoutCorrected, l, f));
      }, a.prototype.registerSharedNode = function(s, l) {
        var u, c, f;
        this.sharedNodes.has(s) || this.sharedNodes.set(s, new m8());
        var d = this.sharedNodes.get(s);
        d.add(l), l.promote({
          transition: (u = l.options.initialPromotionConfig) === null || u === void 0 ? void 0 : u.transition,
          preserveFollowOpacity: (f = (c = l.options.initialPromotionConfig) === null || c === void 0 ? void 0 : c.shouldPreserveFollowOpacity) === null || f === void 0 ? void 0 : f.call(c, l)
        });
      }, a.prototype.isLead = function() {
        var s = this.getStack();
        return s ? s.lead === this : !0;
      }, a.prototype.getLead = function() {
        var s, l = this.options.layoutId;
        return l ? ((s = this.getStack()) === null || s === void 0 ? void 0 : s.lead) || this : this;
      }, a.prototype.getPrevLead = function() {
        var s, l = this.options.layoutId;
        return l ? (s = this.getStack()) === null || s === void 0 ? void 0 : s.prevLead : void 0;
      }, a.prototype.getStack = function() {
        var s = this.options.layoutId;
        if (s)
          return this.root.sharedNodes.get(s);
      }, a.prototype.promote = function(s) {
        var l = s === void 0 ? {} : s, u = l.needsReset, c = l.transition, f = l.preserveFollowOpacity, d = this.getStack();
        d && d.promote(this, f), u && (this.projectionDelta = void 0, this.needsReset = !0), c && this.setOptions({ transition: c });
      }, a.prototype.relegate = function() {
        var s = this.getStack();
        return s ? s.relegate(this) : !1;
      }, a.prototype.resetRotation = function() {
        var s = this.options.visualElement;
        if (s) {
          for (var l = !1, u = {}, c = 0; c < Tm.length; c++) {
            var f = Tm[c], d = "rotate" + f;
            s.getStaticValue(d) && (l = !0, u[d] = s.getStaticValue(d), s.setStaticValue(d, 0));
          }
          if (l) {
            s?.syncRender();
            for (var d in u)
              s.setStaticValue(d, u[d]);
            s.scheduleRender();
          }
        }
      }, a.prototype.getProjectionStyles = function(s) {
        var l, u, c, f, d, p;
        s === void 0 && (s = {});
        var h = {};
        if (!this.instance || this.isSVG)
          return h;
        if (this.isVisible)
          h.visibility = "";
        else
          return { visibility: "hidden" };
        var v = (l = this.options.visualElement) === null || l === void 0 ? void 0 : l.getProps().transformTemplate;
        if (this.needsReset)
          return this.needsReset = !1, h.opacity = "", h.pointerEvents = kf(s.pointerEvents) || "", h.transform = v ? v(this.latestValues, "") : "none", h;
        var m = this.getLead();
        if (!this.projectionDelta || !this.layout || !m.target) {
          var g = {};
          return this.options.layoutId && (g.opacity = (u = this.latestValues.opacity) !== null && u !== void 0 ? u : 1, g.pointerEvents = kf(s.pointerEvents) || ""), this.hasProjected && !lo(this.latestValues) && (g.transform = v ? v({}, "") : "none", this.hasProjected = !1), g;
        }
        var _ = m.animationValues || m.latestValues;
        this.applyTransformsToTarget(), h.transform = Sw(this.projectionDeltaWithTransform, this.treeScale, _), v && (h.transform = v(_, h.transform));
        var w = this.projectionDelta, x = w.x, S = w.y;
        h.transformOrigin = "".concat(x.origin * 100, "% ").concat(S.origin * 100, "% 0"), m.animationValues ? h.opacity = m === this ? (f = (c = _.opacity) !== null && c !== void 0 ? c : this.latestValues.opacity) !== null && f !== void 0 ? f : 1 : this.preserveOpacity ? this.latestValues.opacity : _.opacityExit : h.opacity = m === this ? (d = _.opacity) !== null && d !== void 0 ? d : "" : (p = _.opacityExit) !== null && p !== void 0 ? p : 0;
        for (var $ in id)
          if (_[$] !== void 0) {
            var A = id[$], E = A.correct, y = A.applyTo, b = E(_[$], m);
            if (y)
              for (var O = y.length, k = 0; k < O; k++)
                h[y[k]] = b;
            else
              h[$] = b;
          }
        return this.options.layoutId && (h.pointerEvents = m === this ? kf(s.pointerEvents) || "" : "none"), h;
      }, a.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      }, a.prototype.resetTree = function() {
        this.root.nodes.forEach(function(s) {
          var l;
          return (l = s.currentAnimation) === null || l === void 0 ? void 0 : l.stop();
        }), this.root.nodes.forEach($w), this.root.sharedNodes.clear();
      }, a;
    })()
  );
}
function _8(e) {
  e.updateLayout();
}
function w8(e) {
  var t, n, r, i, o = (n = (t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) !== null && n !== void 0 ? n : e.snapshot;
  if (e.isLead() && e.layout && o && e.hasListeners("didUpdate")) {
    var a = e.layout, s = a.actual, l = a.measured;
    e.options.animationType === "size" ? yi(function(_) {
      var w = o.isShared ? o.measured[_] : o.layout[_], x = Wi(w);
      w.min = s[_].min, w.max = w.min + x;
    }) : e.options.animationType === "position" && yi(function(_) {
      var w = o.isShared ? o.measured[_] : o.layout[_], x = Wi(s[_]);
      w.max = w.min + x;
    });
    var u = pu();
    fu(u, s, o.layout);
    var c = pu();
    o.isShared ? fu(c, e.applyTransform(l, !0), o.measured) : fu(c, s, o.layout);
    var f = !IT(u), d = !1;
    if (!e.resumeFrom && (e.relativeParent = e.getClosestProjectingParent(), e.relativeParent && !e.relativeParent.resumeFrom)) {
      var p = e.relativeParent, h = p.snapshot, v = p.layout;
      if (h && v) {
        var m = Dn();
        du(m, o.layout, h.layout);
        var g = Dn();
        du(g, s, v.actual), NT(m, g) || (d = !0);
      }
    }
    e.notifyListeners("didUpdate", {
      layout: s,
      snapshot: o,
      delta: c,
      layoutDelta: u,
      hasLayoutChanged: f,
      hasRelativeTargetChanged: d
    });
  } else e.isLead() && ((i = (r = e.options).onExitComplete) === null || i === void 0 || i.call(r));
  e.options.transition = void 0;
}
function x8(e) {
  e.clearSnapshot();
}
function $w(e) {
  e.clearMeasurements();
}
function E8(e) {
  var t = e.options.visualElement;
  t?.getProps().onBeforeLayoutMeasure && t.notifyBeforeLayoutMeasure(), e.resetTransform();
}
function S8(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0;
}
function O8(e) {
  e.resolveTargetDelta();
}
function $8(e) {
  e.calcProjection();
}
function T8(e) {
  e.resetRotation();
}
function P8(e) {
  e.removeLeadSnapshot();
}
function Tw(e, t, n) {
  e.translate = Jt(t.translate, 0, n), e.scale = Jt(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function Pw(e, t, n, r) {
  e.min = Jt(t.min, n.min, r), e.max = Jt(t.max, n.max, r);
}
function k8(e, t, n, r) {
  Pw(e.x, t.x, n.x, r), Pw(e.y, t.y, n.y, r);
}
function D8(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
var A8 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function C8(e, t) {
  for (var n = e.root, r = e.path.length - 1; r >= 0; r--)
    if (e.path[r].instance) {
      n = e.path[r];
      break;
    }
  var i = n && n !== e.root ? n.instance : document, o = i.querySelector('[data-projection-id="'.concat(t, '"]'));
  o && e.mount(o, !0);
}
function kw(e) {
  e.min = Math.round(e.min), e.max = Math.round(e.max);
}
function Dw(e) {
  kw(e.x), kw(e.y);
}
var I8 = RT({
  attachResizeListener: function(e, t) {
    return pp(e, "resize", t);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return !0;
  }
}), Zh = {
  current: void 0
}, N8 = RT({
  measureScroll: function(e) {
    return {
      x: e.scrollLeft,
      y: e.scrollTop
    };
  },
  defaultParent: function() {
    if (!Zh.current) {
      var e = new I8(0, {});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Zh.current = e;
    }
    return Zh.current;
  },
  resetTransform: function(e, t) {
    e.style.transform = t ?? "none";
  },
  checkIsScrollRoot: function(e) {
    return window.getComputedStyle(e).position === "fixed";
  }
}), R8 = we(we(we(we({}, mF), Rj), jF), s8), Vn = /* @__PURE__ */ kM(function(e, t) {
  return h5(e, t, R8, n8, N8);
});
function MT() {
  var e = _e(!1);
  return rd(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), e;
}
function jT() {
  var e = MT(), t = Zt(Ve(0), 2), n = t[0], r = t[1], i = Le(function() {
    e.current && r(n + 1);
  }, [n]), o = Le(function() {
    return ti.postRender(i);
  }, [i]);
  return [o, n];
}
var Gh = function(e) {
  var t = e.children, n = e.initial, r = e.isPresent, i = e.onExitComplete, o = e.custom, a = e.presenceAffectsLayout, s = rl(M8), l = pT(), u = Te(
    function() {
      return {
        id: l,
        initial: n,
        isPresent: r,
        custom: o,
        onExitComplete: function(c) {
          var f, d;
          s.set(c, !0);
          try {
            for (var p = uM(s.values()), h = p.next(); !h.done; h = p.next()) {
              var v = h.value;
              if (!v)
                return;
            }
          } catch (m) {
            f = { error: m };
          } finally {
            try {
              h && !h.done && (d = p.return) && d.call(p);
            } finally {
              if (f) throw f.error;
            }
          }
          i?.();
        },
        register: function(c) {
          return s.set(c, !1), function() {
            return s.delete(c);
          };
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    a ? void 0 : [r]
  );
  return Te(function() {
    s.forEach(function(c, f) {
      return s.set(f, !1);
    });
  }, [r]), ie.useEffect(function() {
    !r && !s.size && i?.();
  }, [r]), ie.createElement(cc.Provider, { value: u }, t);
};
function M8() {
  return /* @__PURE__ */ new Map();
}
var ts = function(e) {
  return e.key || "";
};
function j8(e, t) {
  e.forEach(function(n) {
    var r = ts(n);
    t.set(r, n);
  });
}
function F8(e) {
  var t = [];
  return H3.forEach(e, function(n) {
    xy(n) && t.push(n);
  }), t;
}
var Bm = function(e) {
  var t = e.children, n = e.custom, r = e.initial, i = r === void 0 ? !0 : r, o = e.onExitComplete, a = e.exitBeforeEnter, s = e.presenceAffectsLayout, l = s === void 0 ? !0 : s, u = Zt(jT(), 1), c = u[0], f = Me(ku).forceRender;
  f && (c = f);
  var d = MT(), p = F8(t), h = p, v = /* @__PURE__ */ new Set(), m = _e(h), g = _e(/* @__PURE__ */ new Map()).current, _ = _e(!0);
  if (rd(function() {
    _.current = !1, j8(p, g), m.current = h;
  }), Yy(function() {
    _.current = !0, g.clear(), v.clear();
  }), _.current)
    return ie.createElement(ie.Fragment, null, h.map(function(E) {
      return ie.createElement(Gh, { key: ts(E), isPresent: !0, initial: i ? void 0 : !1, presenceAffectsLayout: l }, E);
    }));
  h = ei([], Zt(h), !1);
  for (var w = m.current.map(ts), x = p.map(ts), S = w.length, $ = 0; $ < S; $++) {
    var A = w[$];
    x.indexOf(A) === -1 && v.add(A);
  }
  return a && v.size && (h = []), v.forEach(function(E) {
    if (x.indexOf(E) === -1) {
      var y = g.get(E);
      if (y) {
        var b = w.indexOf(E), O = function() {
          g.delete(E), v.delete(E);
          var k = m.current.findIndex(function(I) {
            return I.key === E;
          });
          if (m.current.splice(k, 1), !v.size) {
            if (m.current = p, d.current === !1)
              return;
            c(), o && o();
          }
        };
        h.splice(b, 0, ie.createElement(Gh, { key: ts(y), isPresent: !1, onExitComplete: O, custom: n, presenceAffectsLayout: l }, y));
      }
    }
  }), h = h.map(function(E) {
    var y = E.key;
    return v.has(y) ? E : ie.createElement(Gh, { key: ts(E), isPresent: !0, presenceAffectsLayout: l }, E);
  }), Ly !== "production" && a && h.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), ie.createElement(ie.Fragment, null, v.size ? h : h.map(function(E) {
    return Ou(E);
  }));
}, z8 = He(null), L8 = function(e) {
  return !e.isLayoutDirty && e.willUpdate(!1);
};
function Aw() {
  var e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new WeakMap(), n = function() {
    return e.forEach(L8);
  };
  return {
    add: function(r) {
      e.add(r), t.set(r, r.addEventListener("willUpdate", n));
    },
    remove: function(r) {
      var i;
      e.delete(r), (i = t.get(r)) === null || i === void 0 || i(), t.delete(r), n();
    },
    dirty: n
  };
}
var FT = function(e) {
  return e === !0;
}, V8 = function(e) {
  return FT(e === !0) || e === "id";
}, K8 = function(e) {
  var t, n, r = e.children, i = e.id, o = e.inheritId, a = e.inherit, s = a === void 0 ? !0 : a;
  o !== void 0 && (s = o);
  var l = Me(ku), u = Me(z8), c = Zt(jT(), 2), f = c[0], d = c[1], p = _e(null), h = (t = l.id) !== null && t !== void 0 ? t : u;
  p.current === null && (V8(s) && h && (i = i ? h + "-" + i : h), p.current = {
    id: i,
    group: FT(s) && (n = l?.group) !== null && n !== void 0 ? n : Aw()
  });
  var v = Te(function() {
    return we(we({}, p.current), { forceRender: f });
  }, [d]);
  return ie.createElement(ku.Provider, { value: v }, r);
}, B8 = 0, U8 = function(e) {
  var t = e.children;
  return ie.useEffect(function() {
    tl(!1, "AnimateSharedLayout is deprecated: https://www.framer.com/docs/guide-upgrade/##shared-layout-animations");
  }, []), ie.createElement(K8, { id: rl(function() {
    return "asl-".concat(B8++);
  }) }, t);
};
const q8 = {
  y: "-200%",
  top: "50%",
  left: "50%",
  x: "-50%"
}, H8 = {
  y: "-50%",
  top: "50%",
  left: "50%",
  x: "-50%"
}, eue = ({ onDelete: e, className: t = "" }) => {
  const [n, r] = Ve(!1);
  return /* @__PURE__ */ C.jsxs(
    Vn.button,
    {
      layout: !0,
      className: `${t} relative cursor-pointer bg-red-400 focus:ring-red-400 hover:bg-red-500 disabled:bg-red-400 z-0 px-4 py-2 text-sm text-white transition-all rounded-lg focus:outline-none focus:ring-2 focus:ring-opacity-75 disabled:opacity-50 disabled:cursor-default`,
      children: [
        /* @__PURE__ */ C.jsx("p", { className: "opacity-0", children: n ? "Sure?" : "Delete" }),
        /* @__PURE__ */ C.jsx(Bm, { children: /* @__PURE__ */ C.jsx(
          Vn.p,
          {
            className: "absolute text-white",
            onClick: () => r(!0),
            exit: q8,
            initial: H8,
            children: !n && "Delete"
          }
        ) }),
        /* @__PURE__ */ C.jsx(Bm, { children: n && /* @__PURE__ */ C.jsx(
          Vn.p,
          {
            className: "absolute text-white",
            onClick: () => e(),
            initial: { y: "200%", top: "50%", left: "50%", x: "-50%" },
            animate: { y: "-50%", top: "50%", left: "50%", x: "-50%" },
            children: "Sure?"
          }
        ) })
      ]
    }
  );
}, tue = () => /* @__PURE__ */ C.jsx("hr", { className: "w-full h-px border-t-neutral-600" }), W8 = ui(
  [
    "w-48",
    "h-screen",
    "fixed",
    "top-0",
    "left-[100vw]",
    "bg-white",
    "transition-transform"
  ],
  {
    variants: {
      visible: {
        true: "-translate-x-full",
        false: ""
      }
    }
  }
), nue = ({
  visible: e,
  children: t,
  onClose: n
}) => /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
  e && /* @__PURE__ */ C.jsx(
    "div",
    {
      className: "fixed top-0 left-0 w-screen h-screen bg-black opacity-50",
      onClick: () => n()
    }
  ),
  /* @__PURE__ */ C.jsx("div", { className: W8({ visible: e }), children: t })
] }), Mn = 16, Um = ({
  sideBarVisible: e,
  onClick: t,
  className: n = ""
}) => /* @__PURE__ */ C.jsxs(
  Vn.svg,
  {
    className: `my-auto cursor-pointer ${n}`,
    width: Mn,
    height: Mn,
    viewBox: `0 0 ${Mn} ${Mn}`,
    animate: e ? "open" : "closed",
    onClick: () => t(),
    children: [
      /* @__PURE__ */ C.jsx(
        Vn.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          variants: {
            closed: { d: `M 0 1 L ${Mn} 1` },
            open: { d: `M ${Mn} 0 L 0 ${Mn}` }
          }
        }
      ),
      /* @__PURE__ */ C.jsx(
        Vn.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          d: `M 0 ${Mn / 2} L ${Mn} ${Mn / 2}`,
          variants: {
            closed: { opacity: 1 },
            open: { opacity: 0 }
          },
          transition: { duration: 0.1 }
        }
      ),
      /* @__PURE__ */ C.jsx(
        Vn.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          variants: {
            closed: { d: `M 0 ${Mn - 1} L ${Mn} ${Mn - 1}` },
            open: { d: `M 0 0 L ${Mn} ${Mn}` }
          }
        }
      )
    ]
  }
);
function Ra(...e) {
  return (...t) => {
    for (let n of e) typeof n == "function" && n(...t);
  };
}
const ht = typeof document < "u" ? H.useLayoutEffect : () => {
}, pd = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, zT = /* @__PURE__ */ H.createContext(pd), Z8 = /* @__PURE__ */ H.createContext(!1);
let G8 = !!(typeof window < "u" && window.document && window.document.createElement), Yh = /* @__PURE__ */ new WeakMap();
function Y8(e = !1) {
  let t = Me(zT), n = _e(null);
  if (n.current === null && !e) {
    let r = (
      // @ts-ignore
      H.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED?.ReactCurrentOwner?.current
    );
    if (r) {
      let i = Yh.get(r);
      i == null ? Yh.set(r, {
        id: t.current,
        state: r.memoizedState
      }) : r.memoizedState !== i.state && (t.current = i.id, Yh.delete(r));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function Q8(e) {
  let t = Me(zT);
  t === pd && !G8 && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = Y8(!!e), r = t === pd && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function J8(e) {
  let t = H.useId(), [n] = Ve(vc()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${pd.prefix}`;
  return e || `${r}-${t}`;
}
const X8 = typeof H.useId == "function" ? J8 : Q8;
function ez() {
  return !1;
}
function tz() {
  return !0;
}
function nz(e) {
  return () => {
  };
}
function vc() {
  return typeof H.useSyncExternalStore == "function" ? H.useSyncExternalStore(nz, ez, tz) : Me(Z8);
}
function rz(e) {
  let [t, n] = Ve(e), r = _e(t), i = _e(null), o = _e(() => {
    if (!i.current) return;
    let s = i.current.next();
    if (s.done) {
      i.current = null;
      return;
    }
    r.current === s.value ? o.current() : n(s.value);
  });
  ht(() => {
    r.current = t, i.current && o.current();
  });
  let a = Le((s) => {
    i.current = s(r.current), o.current();
  }, [
    o
  ]);
  return [
    t,
    a
  ];
}
let iz = !!(typeof window < "u" && window.document && window.document.createElement), Es = /* @__PURE__ */ new Map(), Zl;
typeof FinalizationRegistry < "u" && (Zl = new FinalizationRegistry((e) => {
  Es.delete(e);
}));
function Jn(e) {
  let [t, n] = Ve(e), r = _e(null), i = X8(t), o = _e(null);
  if (Zl && Zl.register(o, i), iz) {
    const a = Es.get(i);
    a && !a.includes(r) ? a.push(r) : Es.set(i, [
      r
    ]);
  }
  return ht(() => {
    let a = i;
    return () => {
      Zl && Zl.unregister(o), Es.delete(a);
    };
  }, [
    i
  ]), Ee(() => {
    let a = r.current;
    return a && n(a), () => {
      a && (r.current = null);
    };
  }), i;
}
function oz(e, t) {
  if (e === t) return e;
  let n = Es.get(e);
  if (n)
    return n.forEach((i) => i.current = t), t;
  let r = Es.get(t);
  return r ? (r.forEach((i) => i.current = e), e) : t;
}
function fa(e = []) {
  let t = Jn(), [n, r] = rz(t), i = Le(() => {
    r(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    r
  ]);
  return ht(i, [
    t,
    i,
    ...e
  ]), n;
}
function cb(...e) {
  return e.length === 1 && e[0] ? e[0] : (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = Cw(i, t);
      return n || (n = typeof o == "function"), o;
    });
    if (n) return () => {
      r.forEach((i, o) => {
        typeof i == "function" ? i() : Cw(e[o], null);
      });
    };
  };
}
function Cw(e, t) {
  if (typeof e == "function") return e(t);
  e != null && (e.current = t);
}
function ut(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let i in r) {
      let o = t[i], a = r[i];
      typeof o == "function" && typeof a == "function" && // This is a lot faster than a regex.
      i[0] === "o" && i[1] === "n" && i.charCodeAt(2) >= /* 'A' */
      65 && i.charCodeAt(2) <= /* 'Z' */
      90 ? t[i] = Ra(o, a) : (i === "className" || i === "UNSAFE_className") && typeof o == "string" && typeof a == "string" ? t[i] = xO(o, a) : i === "id" && o && a ? t.id = oz(o, a) : i === "ref" && o && a ? t.ref = cb(o, a) : t[i] = a !== void 0 ? a : o;
    }
  }
  return t;
}
function il(e) {
  const t = _e(null), n = _e(void 0), r = Le((i) => {
    if (typeof e == "function") {
      const o = e, a = o(i);
      return () => {
        typeof a == "function" ? a() : o(null);
      };
    } else if (e)
      return e.current = i, () => {
        e.current = null;
      };
  }, [
    e
  ]);
  return Te(() => ({
    get current() {
      return t.current;
    },
    set current(i) {
      t.current = i, n.current && (n.current(), n.current = void 0), i != null && (n.current = r(i));
    }
  }), [
    r
  ]);
}
const fb = Symbol("default");
function Ma({ values: e, children: t }) {
  for (let [n, r] of e)
    t = /* @__PURE__ */ H.createElement(n.Provider, {
      value: r
    }, t);
  return t;
}
function zr(e) {
  let { className: t, style: n, children: r, defaultClassName: i, defaultChildren: o, defaultStyle: a, values: s, render: l } = e;
  return Te(() => {
    let u, c, f;
    return typeof t == "function" ? u = t({
      ...s,
      defaultClassName: i
    }) : u = t, typeof n == "function" ? c = n({
      ...s,
      defaultStyle: a || {}
    }) : c = n, typeof r == "function" ? f = r({
      ...s,
      defaultChildren: o
    }) : r == null ? f = o : f = r, {
      className: u ?? i,
      style: c || a ? {
        ...a,
        ...c
      } : void 0,
      children: f ?? o,
      "data-rac": "",
      render: l ? (d) => l(d, s) : void 0
    };
  }, [
    t,
    n,
    r,
    i,
    o,
    a,
    s,
    l
  ]);
}
function gp(e, t) {
  let n = Me(e);
  if (t === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = t || fb;
    if (!n.slots[r]) {
      let i = new Intl.ListFormat().format(Object.keys(n.slots).map((a) => `"${a}"`)), o = t ? `Invalid slot "${t}".` : "A slot prop is required.";
      throw new Error(`${o} Valid slot names are ${i}.`);
    }
    return n.slots[r];
  }
  return n;
}
function Ai(e, t, n) {
  let r = gp(n, e.slot) || {}, { ref: i, ...o } = r, a = il(Te(() => cb(t, i), [
    t,
    i
  ])), s = ut(o, e);
  return "style" in o && o.style && "style" in e && e.style && (typeof o.style == "function" || typeof e.style == "function" ? s.style = (l) => {
    let u = typeof o.style == "function" ? o.style(l) : o.style, c = {
      ...l.defaultStyle,
      ...u
    }, f = typeof e.style == "function" ? e.style({
      ...l,
      defaultStyle: c
    }) : e.style;
    return {
      ...c,
      ...f
    };
  } : s.style = {
    ...o.style,
    ...e.style
  }), [
    s,
    a
  ];
}
function db(e = !0) {
  let [t, n] = Ve(e), r = _e(!1), i = Le((o) => {
    r.current = !0, n(!!o);
  }, []);
  return ht(() => {
    r.current || n(!1);
  }, []), [
    i,
    t
  ];
}
function az(e) {
  const t = /^(data-.*)$/;
  let n = {};
  for (const r in e) t.test(r) || (n[r] = e[r]);
  return n;
}
function sz(e, t, n) {
  let { render: r, ...i } = t, o = _e(null), a = Te(() => cb(n, o), [
    n,
    o
  ]);
  ht(() => {
    process.env.NODE_ENV !== "production" && r && (o.current ? o.current.localName !== e && console.warn(`Unexpected DOM element returned by custom \`render\` function. Expected <${e}>, got <${o.current.localName}>. This may break the component behavior and accessibility.`) : console.warn("Ref was not connected to DOM element returned by custom `render` function. Did you forget to pass through or merge the `ref`?"));
  }, [
    e,
    r
  ]);
  let s = {
    ...i,
    ref: a
  };
  return r ? r(s, void 0) : /* @__PURE__ */ H.createElement(e, s);
}
const Iw = {}, Bn = new Proxy({}, {
  get(e, t) {
    if (typeof t != "string") return;
    let n = Iw[t];
    return n || (n = /* @__PURE__ */ fn(sz.bind(null, t)), Iw[t] = n), n;
  }
}), lz = "react-aria-clear-focus", uz = "react-aria-focus", st = (e) => e?.ownerDocument ?? document, Tn = (e) => e && "window" in e && e.window === e ? e : st(e).defaultView || window;
function cz(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number";
}
function fz(e) {
  return cz(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
}
let dz = !1;
function Mi() {
  return dz;
}
function Je(e, t) {
  if (!Mi()) return t && e ? e.contains(t) : !1;
  if (!e || !t) return !1;
  let n = t;
  for (; n !== null; ) {
    if (n === e) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : fz(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const Vt = (e = document) => {
  if (!Mi()) return e.activeElement;
  let t = e.activeElement;
  for (; t && "shadowRoot" in t && t.shadowRoot?.activeElement; ) t = t.shadowRoot.activeElement;
  return t;
};
function Ae(e) {
  if (Mi() && e.target instanceof Element && e.target.shadowRoot) {
    if ("composedPath" in e) return e.composedPath()[0] ?? null;
    if ("composedPath" in e.nativeEvent) return e.nativeEvent.composedPath()[0] ?? null;
  }
  return e.target;
}
function hd(e) {
  if (!e) return !1;
  let t = e.getRootNode(), n = Tn(e);
  if (!(t instanceof n.Document || t instanceof n.ShadowRoot)) return !1;
  let r = t.activeElement;
  return r != null && e.contains(r);
}
function LT(e) {
  let t = hz(st(e));
  t !== e && (t && pz(t, e), e && VT(e, t));
}
function pz(e, t) {
  e.dispatchEvent(new FocusEvent("blur", {
    relatedTarget: t
  })), e.dispatchEvent(new FocusEvent("focusout", {
    bubbles: !0,
    relatedTarget: t
  }));
}
function VT(e, t) {
  e.dispatchEvent(new FocusEvent("focus", {
    relatedTarget: t
  })), e.dispatchEvent(new FocusEvent("focusin", {
    bubbles: !0,
    relatedTarget: t
  }));
}
function hz(e) {
  let t = Vt(e), n = t?.getAttribute("aria-activedescendant");
  return n && e.getElementById(n) || t;
}
function oi(e) {
  if (vz()) e.focus({
    preventScroll: !0
  });
  else {
    let t = mz(e);
    e.focus(), gz(t);
  }
}
let Yc = null;
function vz() {
  if (Yc == null) {
    Yc = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return Yc = !0, !0;
        }
      });
    } catch {
    }
  }
  return Yc;
}
function mz(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function gz(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
const yz = typeof Element < "u" && "checkVisibility" in Element.prototype;
function bz(e) {
  const t = Tn(e);
  if (!(e instanceof t.HTMLElement) && !(e instanceof t.SVGElement)) return !1;
  let { display: n, visibility: r } = e.style, i = n !== "none" && r !== "hidden" && r !== "collapse";
  if (i) {
    const { getComputedStyle: o } = Tn(e);
    let { display: a, visibility: s } = o(e);
    i = a !== "none" && s !== "hidden" && s !== "collapse";
  }
  return i;
}
function _z(e, t) {
  return !e.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !e.hasAttribute("data-react-aria-prevent-focus") && (e.nodeName === "DETAILS" && t && t.nodeName !== "SUMMARY" ? e.hasAttribute("open") : !0);
}
function pb(e, t) {
  return yz ? e.checkVisibility({
    visibilityProperty: !0
  }) && !e.closest("[data-react-aria-prevent-focus]") : e.nodeName !== "#comment" && bz(e) && _z(e, t) && (!e.parentElement || pb(e.parentElement, e));
}
const hb = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])',
  "permission"
], wz = hb.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
hb.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const xz = hb.join(':not([hidden]):not([tabindex="-1"]),');
function KT(e, t) {
  return e.matches(wz) && !UT(e) && (t?.skipVisibilityCheck || pb(e));
}
function BT(e) {
  return e.matches(xz) && pb(e) && !UT(e);
}
function UT(e) {
  let t = e;
  for (; t != null; ) {
    if (t instanceof Tn(t).HTMLElement && t.inert) return !0;
    t = t.parentElement;
  }
  return !1;
}
function vb(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function qT(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function HT(e) {
  let t = _e({
    isFocused: !1,
    observer: null
  });
  return ht(() => {
    const n = t.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []), Le((n) => {
    let r = Ae(n);
    if (r instanceof HTMLButtonElement || r instanceof HTMLInputElement || r instanceof HTMLTextAreaElement || r instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let i = r, o = (a) => {
        if (t.current.isFocused = !1, i.disabled) {
          let s = vb(a);
          e?.(s);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      i.addEventListener("focusout", o, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && i.disabled) {
          t.current.observer?.disconnect();
          let a = i === Vt() ? null : Vt();
          i.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: a
          })), i.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: a
          }));
        }
      }), t.current.observer.observe(i, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    e
  ]);
}
let vd = !1;
function Nw(e) {
  for (; e && !KT(e, {
    skipVisibilityCheck: !0
  }); ) e = e.parentElement;
  let t = Tn(e), n = t.document.activeElement;
  if (!n || n === e) return;
  vd = !0;
  let r = !1, i = (c) => {
    (Ae(c) === n || r) && c.stopImmediatePropagation();
  }, o = (c) => {
    (Ae(c) === n || r) && (c.stopImmediatePropagation(), !e && !r && (r = !0, oi(n), l()));
  }, a = (c) => {
    (Ae(c) === e || r) && c.stopImmediatePropagation();
  }, s = (c) => {
    (Ae(c) === e || r) && (c.stopImmediatePropagation(), r || (r = !0, oi(n), l()));
  };
  t.addEventListener("blur", i, !0), t.addEventListener("focusout", o, !0), t.addEventListener("focusin", s, !0), t.addEventListener("focus", a, !0);
  let l = () => {
    cancelAnimationFrame(u), t.removeEventListener("blur", i, !0), t.removeEventListener("focusout", o, !0), t.removeEventListener("focusin", s, !0), t.removeEventListener("focus", a, !0), vd = !1, r = !1;
  }, u = requestAnimationFrame(l);
  return l;
}
function yp(e) {
  if (typeof window > "u" || window.navigator == null) return !1;
  let t = window.navigator.userAgentData?.brands;
  return Array.isArray(t) && t.some((n) => e.test(n.brand)) || e.test(window.navigator.userAgent);
}
function mb(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.userAgentData?.platform || window.navigator.platform) : !1;
}
function to(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const ya = to(function() {
  return mb(/^Mac/i);
}), Ez = to(function() {
  return mb(/^iPhone/i);
}), WT = to(function() {
  return mb(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  ya() && navigator.maxTouchPoints > 1;
}), mc = to(function() {
  return Ez() || WT();
}), Sz = to(function() {
  return ya() || mc();
}), ZT = to(function() {
  return yp(/AppleWebKit/i) && !GT();
}), GT = to(function() {
  return yp(/Chrome/i);
}), gb = to(function() {
  return yp(/Android/i);
}), Oz = to(function() {
  return yp(/Firefox/i);
});
function qm(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : gb() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function $z(e) {
  return !gb() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
const Tz = /* @__PURE__ */ He({
  isNative: !0,
  open: Dz,
  useHref: (e) => e
});
function bp() {
  return Me(Tz);
}
function Pz(e, t) {
  let n = e.getAttribute("target");
  return (!n || n === "_self") && e.origin === location.origin && !e.hasAttribute("download") && !t.metaKey && // open in new tab (mac)
  !t.ctrlKey && // open in new tab (windows)
  !t.altKey && // download
  !t.shiftKey;
}
function Zi(e, t, n = !0) {
  let { metaKey: r, ctrlKey: i, altKey: o, shiftKey: a } = t;
  Oz() && window.event?.type?.startsWith("key") && e.target === "_blank" && (ya() ? r = !0 : i = !0);
  let s = ZT() && ya() && !WT() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: r,
    ctrlKey: i,
    altKey: o,
    shiftKey: a
  }) : new MouseEvent("click", {
    metaKey: r,
    ctrlKey: i,
    altKey: o,
    shiftKey: a,
    detail: 1,
    bubbles: !0,
    cancelable: !0
  });
  Zi.isOpening = n, oi(e), e.dispatchEvent(s), Zi.isOpening = !1;
}
Zi.isOpening = !1;
function kz(e, t) {
  if (e instanceof HTMLAnchorElement) t(e);
  else if (e.hasAttribute("data-href")) {
    let n = document.createElement("a");
    n.href = e.getAttribute("data-href"), e.hasAttribute("data-target") && (n.target = e.getAttribute("data-target")), e.hasAttribute("data-rel") && (n.rel = e.getAttribute("data-rel")), e.hasAttribute("data-download") && (n.download = e.getAttribute("data-download")), e.hasAttribute("data-ping") && (n.ping = e.getAttribute("data-ping")), e.hasAttribute("data-referrer-policy") && (n.referrerPolicy = e.getAttribute("data-referrer-policy")), e.appendChild(n), t(n), e.removeChild(n);
  }
}
function Dz(e, t) {
  kz(e, (n) => Zi(n, t));
}
function YT(e) {
  const n = bp().useHref(e?.href ?? "");
  let r = {};
  if (e)
    for (let i of [
      "href",
      "target",
      "rel",
      "download",
      "ping",
      "referrerPolicy"
    ]) i in e && (r[i] = i === "href" ? n : e[i]);
  return r;
}
function Az(e, t, n, r) {
  !t.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
  !e.isDefaultPrevented() && Pz(e.currentTarget, e) && n && (e.preventDefault(), t.open(e.currentTarget, e, n, r));
}
let ja = null;
const Hm = /* @__PURE__ */ new Set();
let hu = /* @__PURE__ */ new Map(), ba = !1, Wm = !1;
const Cz = {
  Tab: !0,
  Escape: !0
};
function _p(e, t) {
  for (let n of Hm) n(e, t);
}
function Iz(e) {
  return !(e.metaKey || !ya() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function md(e) {
  ba = !0, !Zi.isOpening && Iz(e) && (ja = "keyboard", _p("keyboard", e));
}
function xr(e) {
  ja = "pointer", "pointerType" in e && e.pointerType, (e.type === "mousedown" || e.type === "pointerdown") && (ba = !0, _p("pointer", e));
}
function QT(e) {
  !Zi.isOpening && qm(e) && (ba = !0, ja = "virtual");
}
function JT(e) {
  let t = Tn(Ae(e)), n = st(Ae(e));
  Ae(e) === t || Ae(e) === n || vd || !e.isTrusted || (!ba && !Wm && (ja = "virtual", _p("virtual", e)), ba = !1, Wm = !1);
}
function XT() {
  vd || (ba = !1, Wm = !0);
}
function Zm(e) {
  if (typeof window > "u" || typeof document > "u") return;
  const t = Tn(e), n = st(e);
  if (hu.get(t)) return;
  let r = t.HTMLElement.prototype.focus;
  Reflect.defineProperty(t.HTMLElement.prototype, "focus", {
    configurable: !0,
    writable: !0,
    value: function() {
      ba = !0, r.apply(this, arguments);
    }
  }), n.addEventListener("keydown", md, !0), n.addEventListener("keyup", md, !0), n.addEventListener("click", QT, !0), t.addEventListener("focus", JT, !0), t.addEventListener("blur", XT, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", xr, !0), n.addEventListener("pointermove", xr, !0), n.addEventListener("pointerup", xr, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", xr, !0), n.addEventListener("mousemove", xr, !0), n.addEventListener("mouseup", xr, !0)), t.addEventListener("beforeunload", () => {
    eP(e);
  }, {
    once: !0
  }), hu.set(t, {
    focus: r
  });
}
const eP = (e, t) => {
  const n = Tn(e), r = st(e);
  t && r.removeEventListener("DOMContentLoaded", t), hu.has(n) && (Reflect.defineProperty(n.HTMLElement.prototype, "focus", {
    configurable: !0,
    writable: !0,
    value: hu.get(n).focus
  }), r.removeEventListener("keydown", md, !0), r.removeEventListener("keyup", md, !0), r.removeEventListener("click", QT, !0), n.removeEventListener("focus", JT, !0), n.removeEventListener("blur", XT, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", xr, !0), r.removeEventListener("pointermove", xr, !0), r.removeEventListener("pointerup", xr, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", xr, !0), r.removeEventListener("mousemove", xr, !0), r.removeEventListener("mouseup", xr, !0)), hu.delete(n));
};
function Nz(e) {
  const t = st(e);
  let n;
  return t.readyState !== "loading" ? Zm(e) : (n = () => {
    Zm(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => eP(e, n);
}
typeof document < "u" && Nz();
function _a() {
  return ja !== "pointer";
}
function Ru() {
  return ja;
}
function gd(e) {
  ja = e, _p(e, null);
}
const Rz = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Mz(e, t, n) {
  let r = n ? Ae(n) : void 0, i = st(r), o = Tn(r);
  const a = typeof o < "u" ? o.HTMLInputElement : HTMLInputElement, s = typeof o < "u" ? o.HTMLTextAreaElement : HTMLTextAreaElement, l = typeof o < "u" ? o.HTMLElement : HTMLElement, u = typeof o < "u" ? o.KeyboardEvent : KeyboardEvent;
  let c = Vt(i);
  return e = e || c instanceof a && !Rz.has(c.type) || c instanceof s || c instanceof l && c.isContentEditable, !(e && t === "keyboard" && n instanceof u && !Cz[n.key]);
}
function jz(e, t, n) {
  Zm(), Ee(() => {
    if (n?.enabled === !1) return;
    let r = (i, o) => {
      Mz(!!n?.isTextInput, i, o) && e(_a());
    };
    return Hm.add(r), () => {
      Hm.delete(r);
    };
  }, t);
}
function ns(e) {
  return ya() ? e.metaKey : e.ctrlKey;
}
const Fz = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Qh(e) {
  return e instanceof HTMLInputElement && !Fz.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
const zz = H.useInsertionEffect ?? ht;
function Cr(e) {
  const t = _e(null);
  return zz(() => {
    t.current = e;
  }, [
    e
  ]), Le((...n) => {
    const r = t.current;
    return r?.(...n);
  }, []);
}
function Qc(e, t, n, r) {
  let i = Cr(n), o = n == null;
  Ee(() => {
    if (o || !e.current) return;
    let a = e.current;
    return a.addEventListener(t, i, r), () => {
      a.removeEventListener(t, i, r);
    };
  }, [
    e,
    t,
    r,
    o
  ]);
}
function tP(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": i } = e;
  return n = Jn(n), i && r ? i = [
    .../* @__PURE__ */ new Set([
      n,
      ...i.trim().split(/\s+/)
    ])
  ].join(" ") : i && (i = i.trim().split(/\s+/).join(" ")), !r && !i && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": i
  };
}
const Lz = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), Vz = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function Kz(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = (
      // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
      typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo
    );
    if (r) return r.direction === "rtl";
    if (n.script) return Lz.has(n.script);
  }
  let t = e.split("-")[0];
  return Vz.has(t);
}
const nP = Symbol.for("react-aria.i18n.locale");
function rP() {
  let e = typeof window < "u" && window[nP] || // @ts-ignore
  typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: Kz(e) ? "rtl" : "ltr"
  };
}
let Gm = rP(), Gl = /* @__PURE__ */ new Set();
function Rw() {
  Gm = rP();
  for (let e of Gl) e(Gm);
}
function Bz() {
  let e = vc(), [t, n] = Ve(Gm);
  return Ee(() => (Gl.size === 0 && window.addEventListener("languagechange", Rw), Gl.add(n), () => {
    Gl.delete(n), Gl.size === 0 && window.removeEventListener("languagechange", Rw);
  }), []), e ? {
    locale: typeof window < "u" && window[nP] || "en-US",
    direction: "ltr"
  } : t;
}
const Uz = /* @__PURE__ */ H.createContext(null);
function ol() {
  let e = Bz();
  return Me(Uz) || e;
}
const qz = Symbol.for("react-aria.i18n.locale"), Hz = Symbol.for("react-aria.i18n.strings");
let Jc;
class wp {
  constructor(t, n = "en-US") {
    this.strings = Object.fromEntries(Object.entries(t).filter(([, r]) => r)), this.defaultLocale = n;
  }
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(t, n) {
    let i = this.getStringsForLocale(n)[t];
    if (!i) throw new Error(`Could not find intl message ${t} in ${n} locale`);
    return i;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(t) {
    let n = this.strings[t];
    return n || (n = Wz(t, this.strings, this.defaultLocale), this.strings[t] = n), n;
  }
  static getGlobalDictionaryForPackage(t) {
    if (typeof window > "u") return null;
    let n = window[qz];
    if (Jc === void 0) {
      let i = window[Hz];
      if (!i) return null;
      Jc = {};
      for (let o in i) Jc[o] = new wp({
        [n]: i[o]
      }, n);
    }
    let r = Jc?.[t];
    if (!r) throw new Error(`Strings for package "${t}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
}
function Wz(e, t, n = "en-US") {
  if (t[e]) return t[e];
  let r = Zz(e);
  if (t[r]) return t[r];
  for (let i in t)
    if (i.startsWith(r + "-")) return t[i];
  return t[n];
}
function Zz(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const Mw = /* @__PURE__ */ new Map(), jw = /* @__PURE__ */ new Map();
class Gz {
  constructor(t, n) {
    this.locale = t, this.strings = n;
  }
  /** Formats a localized string for the given key with the provided variables. */
  format(t, n) {
    let r = this.strings.getStringForLocale(t, this.locale);
    return typeof r == "function" ? r(n, this) : r;
  }
  plural(t, n, r = "cardinal") {
    let i = n["=" + t];
    if (i) return typeof i == "function" ? i() : i;
    let o = this.locale + ":" + r, a = Mw.get(o);
    a || (a = new Intl.PluralRules(this.locale, {
      type: r
    }), Mw.set(o, a));
    let s = a.select(t);
    return i = n[s] || n.other, typeof i == "function" ? i() : i;
  }
  number(t) {
    let n = jw.get(this.locale);
    return n || (n = new Intl.NumberFormat(this.locale), jw.set(this.locale, n)), n.format(t);
  }
  select(t, n) {
    let r = t[n] || t.other;
    return typeof r == "function" ? r() : r;
  }
}
const Fw = /* @__PURE__ */ new WeakMap();
function Yz(e) {
  let t = Fw.get(e);
  return t || (t = new wp(e), Fw.set(e, t)), t;
}
function Qz(e, t) {
  return t && wp.getGlobalDictionaryForPackage(t) || Yz(e);
}
function iP(e, t) {
  let { locale: n } = ol(), r = Qz(e, t);
  return Te(() => new Gz(n, r), [
    n,
    r
  ]);
}
const Jz = typeof document < "u" ? H.useInsertionEffect ?? H.useLayoutEffect : () => {
};
function xp(e, t, n) {
  let [r, i] = Ve(e || t), o = _e(r), a = _e(e !== void 0), s = e !== void 0;
  Ee(() => {
    let f = a.current;
    f !== s && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}.`), a.current = s;
  }, [
    s
  ]);
  let l = s ? e : r;
  Jz(() => {
    o.current = l;
  });
  let [, u] = pO(() => ({}), {}), c = Le((f, ...d) => {
    let p = typeof f == "function" ? f(o.current) : f;
    Object.is(o.current, p) || (o.current = p, i(p), u(), n?.(p, ...d));
  }, [
    n
  ]);
  return [
    l,
    c
  ];
}
const Ym = /* @__PURE__ */ He(null), Xz = /* @__PURE__ */ He(null);
class al {
  constructor(t) {
    this.value = null, this.level = 0, this.hasChildNodes = !1, this.rendered = null, this.textValue = "", this["aria-label"] = void 0, this.index = 0, this.parentKey = null, this.prevKey = null, this.nextKey = null, this.firstChildKey = null, this.lastChildKey = null, this.props = {}, this.colSpan = null, this.colIndex = null, this.type = this.constructor.type, this.key = t;
  }
  get childNodes() {
    throw new Error("childNodes is not supported");
  }
  clone() {
    let t = new this.constructor(this.key);
    return t.value = this.value, t.level = this.level, t.hasChildNodes = this.hasChildNodes, t.rendered = this.rendered, t.textValue = this.textValue, t["aria-label"] = this["aria-label"], t.index = this.index, t.parentKey = this.parentKey, t.prevKey = this.prevKey, t.nextKey = this.nextKey, t.firstChildKey = this.firstChildKey, t.lastChildKey = this.lastChildKey, t.props = this.props, t.render = this.render, t.colSpan = this.colSpan, t.colIndex = this.colIndex, t;
  }
  filter(t, n, r) {
    let i = this.clone();
    return n.addDescendants(i, t), i;
  }
}
class oP extends al {
  filter(t, n, r) {
    let [i, o] = aP(t, n, this.firstChildKey, r), a = this.clone();
    return a.firstChildKey = i, a.lastChildKey = o, a;
  }
}
const y_ = class y_ extends al {
};
y_.type = "header";
let zw = y_;
const b_ = class b_ extends al {
};
b_.type = "loader";
let Qm = b_;
const __ = class __ extends oP {
  filter(t, n, r) {
    if (r(this.textValue, this)) {
      let i = this.clone();
      return n.addDescendants(i, t), i;
    }
    return null;
  }
};
__.type = "item";
let yd = __;
const w_ = class w_ extends oP {
  filter(t, n, r) {
    let i = super.filter(t, n, r);
    if (i && i.lastChildKey !== null) {
      let o = t.getItem(i.lastChildKey);
      if (o && o.type !== "header") return i;
    }
    return null;
  }
};
w_.type = "section";
let Lw = w_;
class eL {
  get size() {
    return this.itemCount;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  *[Symbol.iterator]() {
    let t = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;
    for (; t; )
      yield t, t = t.nextKey != null ? this.keyMap.get(t.nextKey) : void 0;
  }
  getChildren(t) {
    let n = this.keyMap;
    return {
      *[Symbol.iterator]() {
        let r = n.get(t), i = r?.firstChildKey != null ? n.get(r.firstChildKey) : null;
        for (; i; )
          yield i, i = i.nextKey != null ? n.get(i.nextKey) : void 0;
      }
    };
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    if (!n) return null;
    if (n.prevKey != null) {
      for (n = this.keyMap.get(n.prevKey); n && n.type !== "item" && n.lastChildKey != null; ) n = this.keyMap.get(n.lastChildKey);
      return n?.key ?? null;
    }
    return n.parentKey;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    if (!n) return null;
    if (n.type !== "item" && n.firstChildKey != null) return n.firstChildKey;
    for (; n; ) {
      if (n.nextKey != null) return n.nextKey;
      if (n.parentKey != null) n = this.keyMap.get(n.parentKey);
      else return null;
    }
    return null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    let t = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
    for (; t?.lastChildKey != null; ) t = this.keyMap.get(t.lastChildKey);
    return t?.key ?? null;
  }
  getItem(t) {
    return this.keyMap.get(t) ?? null;
  }
  at() {
    throw new Error("Not implemented");
  }
  clone() {
    let t = this.constructor, n = new t();
    return n.keyMap = new Map(this.keyMap), n.firstKey = this.firstKey, n.lastKey = this.lastKey, n.itemCount = this.itemCount, n;
  }
  addNode(t) {
    if (this.frozen) throw new Error("Cannot add a node to a frozen collection");
    t.type === "item" && this.keyMap.get(t.key) == null && this.itemCount++, this.keyMap.set(t.key, t);
  }
  // Deeply add a node and its children to the collection from another collection, primarily used when filtering a collection
  addDescendants(t, n) {
    this.addNode(t);
    let r = n.getChildren(t.key);
    for (let i of r) this.addDescendants(i, n);
  }
  removeNode(t) {
    if (this.frozen) throw new Error("Cannot remove a node to a frozen collection");
    let n = this.keyMap.get(t);
    n != null && n.type === "item" && this.itemCount--, this.keyMap.delete(t);
  }
  commit(t, n, r = !1) {
    if (this.frozen) throw new Error("Cannot commit a frozen collection");
    this.firstKey = t, this.lastKey = n, this.frozen = !r;
  }
  filter(t) {
    let n = new this.constructor(), [r, i] = aP(this, n, this.firstKey, t);
    return n?.commit(r, i), n;
  }
  constructor() {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.frozen = !1, this.itemCount = 0;
  }
}
function aP(e, t, n, r) {
  if (n == null) return [
    null,
    null
  ];
  let i = null, o = null, a = e.getItem(n);
  for (; a != null; ) {
    let s = a.filter(e, t, r);
    s != null && (s.nextKey = null, o && (s.prevKey = o.key, o.nextKey = s.key), i == null && (i = s), t.addNode(s), o = s), a = a.nextKey != null ? e.getItem(a.nextKey) : null;
  }
  if (o && o.type === "separator") {
    let s = o.prevKey;
    t.removeNode(o.key), s != null ? (o = t.getItem(s), o.nextKey = null) : o = null;
  }
  return [
    i?.key ?? null,
    o?.key ?? null
  ];
}
class sP {
  constructor(t) {
    this._firstChild = null, this._lastChild = null, this._previousSibling = null, this._nextSibling = null, this._parentNode = null, this._minInvalidChildIndex = null, this.ownerDocument = t;
  }
  *[Symbol.iterator]() {
    let t = this.firstChild;
    for (; t; )
      yield t, t = t.nextSibling;
  }
  get firstChild() {
    return this._firstChild;
  }
  set firstChild(t) {
    this._firstChild = t, this.ownerDocument.markDirty(this);
  }
  get lastChild() {
    return this._lastChild;
  }
  set lastChild(t) {
    this._lastChild = t, this.ownerDocument.markDirty(this);
  }
  get previousSibling() {
    return this._previousSibling;
  }
  set previousSibling(t) {
    this._previousSibling = t, this.ownerDocument.markDirty(this);
  }
  get nextSibling() {
    return this._nextSibling;
  }
  set nextSibling(t) {
    this._nextSibling = t, this.ownerDocument.markDirty(this);
  }
  get parentNode() {
    return this._parentNode;
  }
  set parentNode(t) {
    this._parentNode = t, this.ownerDocument.markDirty(this);
  }
  get isConnected() {
    return this.parentNode?.isConnected || !1;
  }
  invalidateChildIndices(t) {
    (this._minInvalidChildIndex == null || !this._minInvalidChildIndex.isConnected || t.index < this._minInvalidChildIndex.index) && (this._minInvalidChildIndex = t, this.ownerDocument.markDirty(this));
  }
  updateChildIndices() {
    let t = this._minInvalidChildIndex;
    for (; t; )
      t.index = t.previousSibling ? t.previousSibling.index + 1 : 0, t = t.nextSibling;
    this._minInvalidChildIndex = null;
  }
  appendChild(t) {
    t.parentNode && t.parentNode.removeChild(t), this.firstChild == null && (this.firstChild = t), this.lastChild ? (this.lastChild.nextSibling = t, t.index = this.lastChild.index + 1, t.previousSibling = this.lastChild) : (t.previousSibling = null, t.index = 0), t.parentNode = this, t.nextSibling = null, this.lastChild = t, this.ownerDocument.markDirty(this), this.isConnected && this.ownerDocument.queueUpdate();
  }
  insertBefore(t, n) {
    if (n == null) return this.appendChild(t);
    t.parentNode && t.parentNode.removeChild(t), t.nextSibling = n, t.previousSibling = n.previousSibling, t.index = n.index - 1, this.firstChild === n ? this.firstChild = t : n.previousSibling && (n.previousSibling.nextSibling = t), n.previousSibling = t, t.parentNode = n.parentNode, this.invalidateChildIndices(t), this.isConnected && this.ownerDocument.queueUpdate();
  }
  removeChild(t) {
    t.parentNode === this && (this._minInvalidChildIndex === t && (this._minInvalidChildIndex = null), t.nextSibling && (this.invalidateChildIndices(t.nextSibling), t.nextSibling.previousSibling = t.previousSibling), t.previousSibling && (t.previousSibling.nextSibling = t.nextSibling), this.firstChild === t && (this.firstChild = t.nextSibling), this.lastChild === t && (this.lastChild = t.previousSibling), t.parentNode = null, t.nextSibling = null, t.previousSibling = null, t.index = 0, this.ownerDocument.markDirty(t), this.isConnected && this.ownerDocument.queueUpdate());
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  get previousVisibleSibling() {
    let t = this.previousSibling;
    for (; t && t.isHidden; ) t = t.previousSibling;
    return t;
  }
  get nextVisibleSibling() {
    let t = this.nextSibling;
    for (; t && t.isHidden; ) t = t.nextSibling;
    return t;
  }
  get firstVisibleChild() {
    let t = this.firstChild;
    for (; t && t.isHidden; ) t = t.nextSibling;
    return t;
  }
  get lastVisibleChild() {
    let t = this.lastChild;
    for (; t && t.isHidden; ) t = t.previousSibling;
    return t;
  }
}
class Ss extends sP {
  constructor(t, n) {
    super(n), this.nodeType = 8, this.isMutated = !0, this._index = 0, this.isHidden = !1, this.node = null;
  }
  get index() {
    return this._index;
  }
  set index(t) {
    this._index = t, this.ownerDocument.markDirty(this);
  }
  get level() {
    return this.parentNode instanceof Ss ? this.parentNode.level + (this.parentNode.node?.type === "item" ? 1 : 0) : 0;
  }
  /**
  * Lazily gets a mutable instance of a Node. If the node has already
  * been cloned during this update cycle, it just returns the existing one.
  */
  getMutableNode() {
    return this.node == null ? null : (this.isMutated || (this.node = this.node.clone(), this.isMutated = !0), this.ownerDocument.markDirty(this), this.node);
  }
  updateNode() {
    let t = this.nextVisibleSibling, n = this.getMutableNode();
    if (n != null && (n.index = this.index, n.level = this.level, n.parentKey = this.parentNode instanceof Ss ? this.parentNode.node?.key ?? null : null, n.prevKey = this.previousVisibleSibling?.node?.key ?? null, n.nextKey = t?.node?.key ?? null, n.hasChildNodes = !!this.firstChild, n.firstChildKey = this.firstVisibleChild?.node?.key ?? null, n.lastChildKey = this.lastVisibleChild?.node?.key ?? null, (n.colSpan != null || n.colIndex != null) && t)) {
      let r = (n.colIndex ?? n.index) + (n.colSpan ?? 1);
      if (t.node != null && r !== t.node.colIndex) {
        let i = t.getMutableNode();
        i.colIndex = r;
      }
    }
  }
  setProps(t, n, r, i, o) {
    let a, { value: s, textValue: l, id: u, ...c } = t;
    if (this.node == null ? (a = new r(u ?? `react-aria-${++this.ownerDocument.nodeId}`), this.node = a) : a = this.getMutableNode(), c.ref = n, a.props = c, a.rendered = i, a.render = o, a.value = s, t["aria-label"] && (a["aria-label"] = t["aria-label"]), a.textValue = l || (typeof c.children == "string" ? c.children : "") || t["aria-label"] || "", u != null && u !== a.key) throw new Error("Cannot change the id of an item");
    c.colSpan != null && (a.colSpan = c.colSpan), this.isConnected && this.ownerDocument.queueUpdate();
  }
  get style() {
    let t = this;
    return {
      get display() {
        return t.isHidden ? "none" : "";
      },
      set display(n) {
        let r = n === "none";
        if (t.isHidden !== r) {
          (t.parentNode?.firstVisibleChild === t || t.parentNode?.lastVisibleChild === t) && t.ownerDocument.markDirty(t.parentNode);
          let i = t.previousVisibleSibling, o = t.nextVisibleSibling;
          i && t.ownerDocument.markDirty(i), o && t.ownerDocument.markDirty(o), t.isHidden = r, t.ownerDocument.markDirty(t);
        }
      }
    };
  }
  hasAttribute() {
  }
  setAttribute() {
  }
  setAttributeNS() {
  }
  removeAttribute() {
  }
}
class tL extends sP {
  constructor(t) {
    super(null), this.nodeType = 11, this.ownerDocument = this, this.dirtyNodes = /* @__PURE__ */ new Set(), this.isSSR = !1, this.nodeId = 0, this.nodesByProps = /* @__PURE__ */ new WeakMap(), this.nextCollection = null, this.subscriptions = /* @__PURE__ */ new Set(), this.queuedRender = !1, this.inSubscription = !1, this.collection = t, this.nextCollection = t;
  }
  get isConnected() {
    return !0;
  }
  createElement(t) {
    return new Ss(t, this);
  }
  getMutableCollection() {
    return this.nextCollection || (this.nextCollection = this.collection.clone()), this.nextCollection;
  }
  markDirty(t) {
    this.dirtyNodes.add(t);
  }
  addNode(t) {
    if (t.isHidden || t.node == null) return;
    let n = this.getMutableCollection();
    if (!n.getItem(t.node.key)) for (let r of t) this.addNode(r);
    n.addNode(t.node);
  }
  removeNode(t) {
    for (let n of t) this.removeNode(n);
    t.node && this.getMutableCollection().removeNode(t.node.key);
  }
  /** Finalizes the collection update, updating all nodes and freezing the collection. */
  getCollection() {
    return this.inSubscription ? this.collection : (this.queuedRender = !1, this.updateCollection(), this.collection);
  }
  updateCollection() {
    for (let t of this.dirtyNodes) t instanceof Ss && (!t.isConnected || t.isHidden) ? this.removeNode(t) : t.updateChildIndices();
    for (let t of this.dirtyNodes) t instanceof Ss ? (t.isConnected && !t.isHidden && (t.updateNode(), this.addNode(t)), t.node && this.dirtyNodes.delete(t), t.isMutated = !1) : this.dirtyNodes.delete(t);
    this.nextCollection && (this.nextCollection.commit(this.firstVisibleChild?.node?.key ?? null, this.lastVisibleChild?.node?.key ?? null, this.isSSR), this.isSSR || (this.collection = this.nextCollection, this.nextCollection = null));
  }
  queueUpdate() {
    if (!(this.dirtyNodes.size === 0 || this.queuedRender)) {
      this.queuedRender = !0, this.inSubscription = !0, this.isSSR || (this.collection = this.collection.clone());
      for (let t of this.subscriptions) t();
      this.inSubscription = !1;
    }
  }
  subscribe(t) {
    return this.subscriptions.add(t), () => this.subscriptions.delete(t);
  }
  resetAfterSSR() {
    this.isSSR && (this.isSSR = !1, this.firstChild = null, this.lastChild = null, this.nodeId = 0);
  }
}
function lP(e) {
  let { children: t, items: n, idScope: r, addIdAndValue: i, dependencies: o = [] } = e, a = Te(() => process.env.NODE_ENV !== "production" && typeof t == "function" ? t.toString() : void 0, [
    t
  ]), s = Te(() => /* @__PURE__ */ new WeakMap(), [
    ...o,
    a
  ]);
  return Te(() => {
    if (n && typeof t == "function") {
      let l = [];
      for (let u of n) {
        let c = nL(u) ? u : null, f = c ? s.get(c) : null;
        if (!f) {
          f = t(u);
          let d = f.props.id ?? u?.key ?? u?.id;
          r != null && f.props.id == null && d != null && (d = r + ":" + d);
          let p = d ?? l.length;
          f = Ou(f, i ? {
            key: p,
            id: d,
            value: u
          } : {
            key: p
          }), c && s.set(c, f);
        }
        l.push(f);
      }
      return l;
    } else if (typeof t != "function") return t;
  }, [
    t,
    n,
    s,
    r,
    i
  ]);
}
function nL(e) {
  switch (typeof e) {
    case "object":
      return e != null;
    case "function":
    case "symbol":
      return !0;
    default:
      return !1;
  }
}
let go = /* @__PURE__ */ new Map(), Jm = /* @__PURE__ */ new Set();
function Vw() {
  if (typeof window > "u") return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    let i = Ae(r);
    if (!e(r) || !i) return;
    let o = go.get(i);
    o || (o = /* @__PURE__ */ new Set(), go.set(i, o), i.addEventListener("transitioncancel", n, {
      once: !0
    })), o.add(r.propertyName);
  }, n = (r) => {
    let i = Ae(r);
    if (!e(r) || !i) return;
    let o = go.get(i);
    if (o && (o.delete(r.propertyName), o.size === 0 && (i.removeEventListener("transitioncancel", n), go.delete(i)), go.size === 0)) {
      for (let a of Jm) a();
      Jm.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? Vw() : document.addEventListener("DOMContentLoaded", Vw));
function rL() {
  for (const [e] of go)
    "isConnected" in e && !e.isConnected && go.delete(e);
}
function uP(e) {
  requestAnimationFrame(() => {
    rL(), go.size === 0 ? e() : Jm.add(e);
  });
}
function Rs(e) {
  if (!e.isConnected) return;
  const t = st(e);
  if (Ru() === "virtual") {
    let n = Vt(t);
    uP(() => {
      const r = Vt(t);
      (r === n || r === t.body) && e.isConnected && oi(e);
    });
  } else oi(e);
}
function yb(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: i } = e;
  const o = Le((l) => {
    if (Ae(l) === l.currentTarget)
      return r && r(l), i && i(!1), !0;
  }, [
    r,
    i
  ]), a = HT(o), s = Le((l) => {
    let u = Ae(l);
    const c = st(u), f = c ? Vt(c) : Vt();
    u === l.currentTarget && u === f && (n && n(l), i && i(!0), a(l));
  }, [
    i,
    n,
    a
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || i || r) ? s : void 0,
      onBlur: !t && (r || i) ? o : void 0
    }
  };
}
function Kw(e) {
  if (!e) return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        t && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : t = !0;
      },
      continuePropagation() {
        t = !1, typeof n.continuePropagation == "function" && n.continuePropagation();
      },
      isPropagationStopped() {
        return t;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function bb(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: Kw(e.onKeyDown),
      onKeyUp: Kw(e.onKeyUp)
    }
  };
}
function _b(e, t) {
  ht(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
let Xm = /* @__PURE__ */ H.createContext(null);
function iL(e) {
  let t = Me(Xm) || {};
  _b(t, e);
  let { ref: n, ...r } = t;
  return r;
}
function cP(e, t) {
  let { focusProps: n } = yb(e), { keyboardProps: r } = bb(e), i = ut(n, r), o = iL(t), a = e.isDisabled ? {} : o, s = _e(e.autoFocus);
  Ee(() => {
    s.current && t.current && Rs(t.current), s.current = !1;
  }, [
    t
  ]);
  let l = e.excludeFromTabOrder ? -1 : 0;
  return e.isDisabled && (l = void 0), {
    focusableProps: ut({
      ...i,
      tabIndex: l
    }, a)
  };
}
typeof HTMLTemplateElement < "u" && (Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
  configurable: !0,
  enumerable: !0,
  get: function() {
    return this.content.firstChild;
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "appendChild", {
  configurable: !0,
  enumerable: !0,
  value: function(e) {
    return this.content.appendChild(e);
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "removeChild", {
  configurable: !0,
  enumerable: !0,
  value: function(e) {
    return this.content.removeChild(e);
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "insertBefore", {
  configurable: !0,
  enumerable: !0,
  value: function(e, t) {
    return this.content.insertBefore(e, t);
  }
}));
const bd = /* @__PURE__ */ He(!1);
function oL(e) {
  if (Me(bd))
    return /* @__PURE__ */ H.createElement(H.Fragment, null, e.children);
  let n = /* @__PURE__ */ H.createElement(bd.Provider, {
    value: !0
  }, e.children);
  return /* @__PURE__ */ H.createElement("template", null, n);
}
function Ep(e) {
  let t = (n, r) => Me(bd) ? null : e(n, r);
  return t.displayName = e.displayName || e.name, fn(t);
}
function fP() {
  return Me(bd);
}
var Xc = { exports: {} }, Jh = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bw;
function aL() {
  if (Bw) return Jh;
  Bw = 1;
  var e = H;
  function t(f, d) {
    return f === d && (f !== 0 || 1 / f === 1 / d) || f !== f && d !== d;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, o = e.useLayoutEffect, a = e.useDebugValue;
  function s(f, d) {
    var p = d(), h = r({ inst: { value: p, getSnapshot: d } }), v = h[0].inst, m = h[1];
    return o(
      function() {
        v.value = p, v.getSnapshot = d, l(v) && m({ inst: v });
      },
      [f, p, d]
    ), i(
      function() {
        return l(v) && m({ inst: v }), f(function() {
          l(v) && m({ inst: v });
        });
      },
      [f]
    ), a(p), p;
  }
  function l(f) {
    var d = f.getSnapshot;
    f = f.value;
    try {
      var p = d();
      return !n(f, p);
    } catch {
      return !0;
    }
  }
  function u(f, d) {
    return d();
  }
  var c = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : s;
  return Jh.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : c, Jh;
}
var Xh = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Uw;
function sL() {
  return Uw || (Uw = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(p, h) {
      return p === h && (p !== 0 || 1 / p === 1 / h) || p !== p && h !== h;
    }
    function t(p, h) {
      c || i.startTransition === void 0 || (c = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var v = h();
      if (!f) {
        var m = h();
        o(v, m) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      m = a({
        inst: { value: v, getSnapshot: h }
      });
      var g = m[0].inst, _ = m[1];
      return l(
        function() {
          g.value = v, g.getSnapshot = h, n(g) && _({ inst: g });
        },
        [p, v, h]
      ), s(
        function() {
          return n(g) && _({ inst: g }), p(function() {
            n(g) && _({ inst: g });
          });
        },
        [p]
      ), u(v), v;
    }
    function n(p) {
      var h = p.getSnapshot;
      p = p.value;
      try {
        var v = h();
        return !o(p, v);
      } catch {
        return !0;
      }
    }
    function r(p, h) {
      return h();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = H, o = typeof Object.is == "function" ? Object.is : e, a = i.useState, s = i.useEffect, l = i.useLayoutEffect, u = i.useDebugValue, c = !1, f = !1, d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    Xh.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : d, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), Xh;
}
var qw;
function lL() {
  return qw || (qw = 1, process.env.NODE_ENV === "production" ? Xc.exports = aL() : Xc.exports = sL()), Xc.exports;
}
var dP = lL();
const pP = /* @__PURE__ */ He(!1), Mu = /* @__PURE__ */ He(null);
function wb(e) {
  if (Me(Mu))
    return e.content;
  let { collection: n, document: r } = dL(e.createCollection);
  return /* @__PURE__ */ H.createElement(H.Fragment, null, /* @__PURE__ */ H.createElement(oL, null, /* @__PURE__ */ H.createElement(Mu.Provider, {
    value: r
  }, e.content)), /* @__PURE__ */ H.createElement(uL, {
    render: e.children,
    collection: n
  }));
}
function uL({ collection: e, render: t }) {
  return t(e);
}
function cL(e, t, n) {
  let r = vc(), i = _e(r);
  i.current = r;
  let o = Le(() => i.current ? n() : t(), [
    t,
    n
  ]);
  return dP.useSyncExternalStore(e, o);
}
const fL = typeof H.useSyncExternalStore == "function" ? H.useSyncExternalStore : cL;
function dL(e) {
  let [t] = Ve(() => new tL(e?.() || new eL())), n = Le((a) => t.subscribe(a), [
    t
  ]), r = Le(() => {
    let a = t.getCollection();
    return t.isSSR && t.resetAfterSSR(), a;
  }, [
    t
  ]), i = Le(() => (t.isSSR = !0, t.getCollection()), [
    t
  ]);
  return {
    collection: fL(n, r, i),
    document: t
  };
}
const eg = /* @__PURE__ */ He(null);
function pL(e) {
  var n;
  return n = class extends al {
  }, n.type = e, n;
}
function hL(e, t, n, r, i, o) {
  typeof e == "string" && (e = pL(e));
  let a = Le((l) => {
    l?.setProps(t, n, e, r, o);
  }, [
    t,
    n,
    r,
    o,
    e
  ]), s = Me(eg);
  if (s) {
    let l = s.ownerDocument.nodesByProps.get(t);
    return l || (l = s.ownerDocument.createElement(e.type), l.setProps(t, n, e, r, o), s.appendChild(l), s.ownerDocument.updateCollection(), s.ownerDocument.nodesByProps.set(t, l)), i ? /* @__PURE__ */ H.createElement(eg.Provider, {
      value: l
    }, i) : null;
  }
  return /* @__PURE__ */ H.createElement(e.type, {
    ref: a
  }, i);
}
function xb(e, t) {
  let n = ({ node: i }) => t(i.props, i.props.ref, i), r = fn((i, o) => {
    let a = Me(Xm);
    if (!Me(pP)) {
      if (t.length >= 3) throw new Error(t.name + " cannot be rendered outside a collection.");
      return t(i, o);
    }
    return hL(e, i, o, "children" in i ? i.children : null, null, (l) => (
      // Forward FocusableContext to real DOM tree so tooltips work.
      /* @__PURE__ */ H.createElement(Xm.Provider, {
        value: a
      }, /* @__PURE__ */ H.createElement(n, {
        node: l
      }))
    ));
  });
  return r.displayName = t.name, r;
}
function vL(e) {
  return lP({
    ...e,
    addIdAndValue: !0
  });
}
const Hw = /* @__PURE__ */ He(null);
function hP(e) {
  let t = Me(Hw), n = (t?.dependencies || []).concat(e.dependencies), r = e.idScope ?? t?.idScope, i = vL({
    ...e,
    idScope: r,
    dependencies: n
  });
  return Me(Mu) && (i = /* @__PURE__ */ H.createElement(mL, null, i)), t = Te(
    () => ({
      dependencies: n,
      idScope: r
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      ...n
    ]
  ), /* @__PURE__ */ H.createElement(Hw.Provider, {
    value: t
  }, i);
}
function mL({ children: e }) {
  let t = Me(Mu), n = Te(() => /* @__PURE__ */ H.createElement(Mu.Provider, {
    value: null
  }, /* @__PURE__ */ H.createElement(pP.Provider, {
    value: !0
  }, e)), [
    e
  ]);
  return vc() ? /* @__PURE__ */ H.createElement(eg.Provider, {
    value: t
  }, n) : /* @__PURE__ */ va(n, t);
}
const vP = /* @__PURE__ */ He(null), gL = {
  CollectionRoot({ collection: e, renderDropIndicator: t }) {
    return Ww(e, null, t);
  },
  CollectionBranch({ collection: e, parent: t, renderDropIndicator: n }) {
    return Ww(e, t, n);
  }
};
function Ww(e, t, n) {
  return lP({
    items: t ? e.getChildren(t.key) : e,
    dependencies: [
      n
    ],
    children(r) {
      if (r.type === "content") return /* @__PURE__ */ H.createElement(H.Fragment, null);
      let i = r.render(r);
      return !n || r.type !== "item" ? i : /* @__PURE__ */ H.createElement(H.Fragment, null, n({
        type: "item",
        key: r.key,
        dropPosition: "before"
      }), i, yL(e, r, n));
    }
  });
}
function yL(e, t, n) {
  let r = t.key, i = e.getKeyAfter(r), o = i != null ? e.getItem(i) : null;
  for (; o != null && o.type !== "item"; )
    i = e.getKeyAfter(o.key), o = i != null ? e.getItem(i) : null;
  let a = t.nextKey != null ? e.getItem(t.nextKey) : null;
  for (; a != null && a.type !== "item"; ) a = a.nextKey != null ? e.getItem(a.nextKey) : null;
  let s = [];
  if (a == null) {
    let l = t;
    for (; l?.type === "item" && (!o || l.parentKey !== o.parentKey && o.level < l.level); ) {
      let u = n({
        type: "item",
        key: l.key,
        dropPosition: "after"
      });
      /* @__PURE__ */ xy(u) && s.push(/* @__PURE__ */ Ou(u, {
        key: `${l.key}-after`
      })), l = l.parentKey != null ? e.getItem(l.parentKey) : null;
    }
  }
  return s;
}
const sl = /* @__PURE__ */ He(gL);
function bL(e) {
  return Te(() => e != null ? /* @__PURE__ */ new Set([
    e
  ]) : null, [
    e
  ]);
}
const _L = /* @__PURE__ */ new Set([
  "id"
]), wL = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), xL = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), EL = /* @__PURE__ */ new Set([
  "dir",
  "lang",
  "hidden",
  "inert",
  "translate"
]), Zw = /* @__PURE__ */ new Set([
  "onClick",
  "onAuxClick",
  "onContextMenu",
  "onDoubleClick",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onPointerDown",
  "onPointerMove",
  "onPointerUp",
  "onPointerCancel",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerOver",
  "onPointerOut",
  "onGotPointerCapture",
  "onLostPointerCapture",
  "onScroll",
  "onWheel",
  "onAnimationStart",
  "onAnimationEnd",
  "onAnimationIteration",
  "onTransitionCancel",
  "onTransitionEnd",
  "onTransitionRun",
  "onTransitionStart"
]), SL = /^(data-.*)$/;
function kn(e, t = {}) {
  let { labelable: n, isLink: r, global: i, events: o = i, propNames: a } = t, s = {};
  for (const l in e) Object.prototype.hasOwnProperty.call(e, l) && (_L.has(l) || n && wL.has(l) || r && xL.has(l) || i && EL.has(l) || o && (Zw.has(l) || l.endsWith("Capture") && Zw.has(l.slice(0, -7))) || a?.has(l) || SL.test(l)) && (s[l] = e[l]);
  return s;
}
let us = "default", tg = "", Cf = /* @__PURE__ */ new WeakMap();
function Gw(e) {
  if (mc()) {
    if (us === "default") {
      const t = st(e);
      tg = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    us = "disabled";
  } else if (e instanceof HTMLElement || e instanceof SVGElement) {
    let t = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    Cf.set(e, e.style[t]), e.style[t] = "none";
  }
}
function ev(e) {
  if (mc()) {
    if (us !== "disabled") return;
    us = "restoring", setTimeout(() => {
      uP(() => {
        if (us === "restoring") {
          const t = st(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = tg || ""), tg = "", us = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && Cf.has(e)) {
    let t = Cf.get(e), n = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    e.style[n] === "none" && (e.style[n] = t), e.getAttribute("style") === "" && e.removeAttribute("style"), Cf.delete(e);
  }
}
function Yw(e) {
  return e?.defaultView?.__webpack_nonce__ || globalThis.__webpack_nonce__ || void 0;
}
let tv = /* @__PURE__ */ new WeakMap();
function mP(e) {
  let t = e ?? (typeof document < "u" ? document : void 0);
  if (!t) return Yw(t);
  if (tv.has(t)) return tv.get(t);
  let n = t.querySelector('meta[property="csp-nonce"]'), r = n && n instanceof Tn(n).HTMLMetaElement && (n.nonce || n.content) || Yw(t) || void 0;
  return r !== void 0 && tv.set(t, r), r;
}
const ju = H.createContext({
  register: () => {
  }
});
ju.displayName = "PressResponderContext";
function Sp() {
  let e = _e(/* @__PURE__ */ new Map()), t = Le((i, o, a, s) => {
    let l = s?.once ? (...u) => {
      e.current.delete(a), a(...u);
    } : a;
    e.current.set(a, {
      type: o,
      eventTarget: i,
      fn: l,
      options: s
    }), i.addEventListener(o, l, s);
  }, []), n = Le((i, o, a, s) => {
    let l = e.current.get(a)?.fn || a;
    i.removeEventListener(o, l, s), e.current.delete(a);
  }, []), r = Le(() => {
    e.current.forEach((i, o) => {
      n(i.eventTarget, i.type, o, i.options);
    });
  }, [
    n
  ]);
  return Ee(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function OL(e) {
  let t = Me(ju);
  if (t) {
    let { register: n, ref: r, ...i } = t;
    e = ut(i, e), n();
  }
  return _b(t, e.ref), e;
}
var As;
class ef {
  constructor(t, n, r, i) {
    D_(this, As);
    Oh(this, As, !0);
    const a = (i?.target ?? r.currentTarget)?.getBoundingClientRect();
    let s, l = 0, u, c = null;
    r.clientX != null && r.clientY != null && (u = r.clientX, c = r.clientY), a && (u != null && c != null ? (s = u - a.left, l = c - a.top) : (s = a.width / 2, l = a.height / 2)), this.type = t, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = s, this.y = l, this.key = r.key;
  }
  continuePropagation() {
    Oh(this, As, !1);
  }
  get shouldStopPropagation() {
    return k_(this, As);
  }
}
As = new WeakMap();
const Qw = Symbol("linkClicked"), Jw = "react-aria-pressable-style", Xw = "data-react-aria-pressable";
function Op(e) {
  let { onPress: t, onPressChange: n, onPressStart: r, onPressEnd: i, onPressUp: o, onClick: a, isDisabled: s, isPressed: l, preventFocusOnPress: u, shouldCancelOnPointerExit: c, allowTextSelectionOnPress: f, ref: d, ...p } = OL(e), [h, v] = Ve(!1), m = _e({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: g, removeAllGlobalListeners: _ } = Sp(), w = Le((T, V) => {
    let z = m.current;
    if (s || z.didFirePressStart) return !1;
    let B = !0;
    if (z.isTriggeringEvent = !0, r) {
      let q = new ef("pressstart", V, T);
      r(q), B = q.shouldStopPropagation;
    }
    return n && n(!0), z.isTriggeringEvent = !1, z.didFirePressStart = !0, v(!0), B;
  }, [
    s,
    r,
    n
  ]), x = Le((T, V, z = !0) => {
    let B = m.current;
    if (!B.didFirePressStart) return !1;
    B.didFirePressStart = !1, B.isTriggeringEvent = !0;
    let q = !0;
    if (i) {
      let M = new ef("pressend", V, T);
      i(M), q = M.shouldStopPropagation;
    }
    if (n && n(!1), v(!1), t && z && !s) {
      let M = new ef("press", V, T);
      t(M), q && (q = M.shouldStopPropagation);
    }
    return B.isTriggeringEvent = !1, q;
  }, [
    s,
    i,
    n,
    t
  ]), S = Cr(x), $ = Le((T, V) => {
    let z = m.current;
    if (s) return !1;
    if (o) {
      z.isTriggeringEvent = !0;
      let B = new ef("pressup", V, T);
      return o(B), z.isTriggeringEvent = !1, B.shouldStopPropagation;
    }
    return !0;
  }, [
    s,
    o
  ]), A = Cr($), E = Le((T) => {
    let V = m.current;
    if (V.isPressed && V.target) {
      V.didFirePressStart && V.pointerType != null && x(Go(V.target, T), V.pointerType, !1), V.isPressed = !1, V.isOverTarget = !1, V.activePointerId = null, V.pointerType = null, _(), f || ev(V.target);
      for (let z of V.disposables) z();
      V.disposables = [];
    }
  }, [
    f,
    _,
    x
  ]), y = Cr(E);
  Ee(() => {
    s && m.current.isPressed && y({
      currentTarget: m.current.target,
      shiftKey: !1,
      ctrlKey: !1,
      metaKey: !1,
      altKey: !1
    });
  }, [
    s
  ]);
  let b = Le((T) => {
    c && E(T);
  }, [
    c,
    E
  ]), O = Le((T) => {
    s || a?.(T);
  }, [
    s,
    a
  ]), k = Le((T, V) => {
    if (!s && a) {
      let z = new MouseEvent("click", T);
      qT(z, V), a(vb(z));
    }
  }, [
    s,
    a
  ]), I = Te(() => {
    let T = m.current, V = {
      onKeyDown(B) {
        if (nv(B.nativeEvent, B.currentTarget) && Je(B.currentTarget, Ae(B))) {
          nx(Ae(B), B.key) && B.preventDefault();
          let q = !0;
          !T.isPressed && !B.repeat && (T.target = B.currentTarget, T.isPressed = !0, T.pointerType = "keyboard", q = w(B, "keyboard"));
          let M = B.currentTarget, N = (Y) => {
            nv(Y, M) && !Y.repeat && Je(M, Ae(Y)) && T.target && A(Go(T.target, Y), "keyboard");
          };
          g(st(B.currentTarget), "keyup", Ra(N, z), !0), q && B.stopPropagation(), B.metaKey && ya() && T.metaKeyEvents?.set(B.key, B.nativeEvent);
        } else B.key === "Meta" && (T.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(B) {
        if (!(B && !Je(B.currentTarget, Ae(B))) && B && B.button === 0 && !T.isTriggeringEvent && !Zi.isOpening) {
          let q = !0;
          if (s && B.preventDefault(), !T.ignoreEmulatedMouseEvents && !T.isPressed && (T.pointerType === "virtual" || qm(B.nativeEvent))) {
            let M = w(B, "virtual"), N = A(B, "virtual"), Y = S(B, "virtual");
            O(B), q = M && N && Y;
          } else if (T.isPressed && T.pointerType !== "keyboard") {
            let M = T.pointerType || B.nativeEvent.pointerType || "virtual", N = A(Go(B.currentTarget, B), M), Y = S(Go(B.currentTarget, B), M, !0);
            q = N && Y, T.isOverTarget = !1, O(B), y(B);
          }
          T.ignoreEmulatedMouseEvents = !1, q && B.stopPropagation();
        }
      }
    }, z = (B) => {
      if (T.isPressed && T.target && nv(B, T.target)) {
        nx(Ae(B), B.key) && B.preventDefault();
        let q = Ae(B), M = Je(T.target, q);
        S(Go(T.target, B), "keyboard", M), M && k(B, T.target), _(), B.key !== "Enter" && Eb(T.target) && Je(T.target, q) && !B[Qw] && (B[Qw] = !0, Zi(T.target, B, !1)), T.isPressed = !1, T.metaKeyEvents?.delete(B.key);
      } else if (B.key === "Meta" && T.metaKeyEvents?.size) {
        let q = T.metaKeyEvents;
        T.metaKeyEvents = void 0;
        for (let M of q.values()) T.target?.dispatchEvent(new KeyboardEvent("keyup", M));
      }
    };
    if (typeof PointerEvent < "u") {
      V.onPointerDown = (M) => {
        if (M.button !== 0 || !Je(M.currentTarget, Ae(M))) return;
        if ($z(M.nativeEvent)) {
          T.pointerType = "virtual";
          return;
        }
        T.pointerType = M.pointerType;
        let N = !0;
        if (!T.isPressed) {
          T.isPressed = !0, T.isOverTarget = !0, T.activePointerId = M.pointerId, T.target = M.currentTarget, f || Gw(T.target), N = w(M, T.pointerType);
          let Y = Ae(M);
          "releasePointerCapture" in Y && ("hasPointerCapture" in Y ? Y.hasPointerCapture(M.pointerId) && Y.releasePointerCapture(M.pointerId) : Y.releasePointerCapture(M.pointerId)), g(st(M.currentTarget), "pointerup", B, !1), g(st(M.currentTarget), "pointercancel", q, !1);
        }
        N && M.stopPropagation();
      }, V.onMouseDown = (M) => {
        if (Je(M.currentTarget, Ae(M)) && M.button === 0) {
          if (u) {
            let N = Nw(M.target);
            N && T.disposables.push(N);
          }
          M.stopPropagation();
        }
      }, V.onPointerUp = (M) => {
        !Je(M.currentTarget, Ae(M)) || T.pointerType === "virtual" || M.button === 0 && !T.isPressed && A(M, T.pointerType || M.pointerType);
      }, V.onPointerEnter = (M) => {
        M.pointerId === T.activePointerId && T.target && !T.isOverTarget && T.pointerType != null && (T.isOverTarget = !0, w(Go(T.target, M), T.pointerType));
      }, V.onPointerLeave = (M) => {
        M.pointerId === T.activePointerId && T.target && T.isOverTarget && T.pointerType != null && (T.isOverTarget = !1, S(Go(T.target, M), T.pointerType, !1), b(M));
      };
      let B = (M) => {
        if (M.pointerId === T.activePointerId && T.isPressed && M.button === 0 && T.target) {
          if (Je(T.target, Ae(M)) && T.pointerType != null) {
            let N = !1, Y = setTimeout(() => {
              T.isPressed && T.target instanceof HTMLElement && (N ? y(M) : (oi(T.target), T.target.click()));
            }, 80);
            g(M.currentTarget, "click", () => N = !0, !0), T.disposables.push(() => clearTimeout(Y));
          } else
            y(M);
          T.isOverTarget = !1;
        }
      }, q = (M) => {
        y(M);
      };
      V.onDragStart = (M) => {
        Je(M.currentTarget, Ae(M)) && y(M);
      };
    } else if (process.env.NODE_ENV === "test") {
      V.onMouseDown = (M) => {
        if (M.button !== 0 || !Je(M.currentTarget, Ae(M))) return;
        if (T.ignoreEmulatedMouseEvents) {
          M.stopPropagation();
          return;
        }
        if (T.isPressed = !0, T.isOverTarget = !0, T.target = M.currentTarget, T.pointerType = qm(M.nativeEvent) ? "virtual" : "mouse", Sy(() => w(M, T.pointerType)) && M.stopPropagation(), u) {
          let Y = Nw(M.target);
          Y && T.disposables.push(Y);
        }
        g(st(M.currentTarget), "mouseup", B, !1);
      }, V.onMouseEnter = (M) => {
        if (!Je(M.currentTarget, Ae(M))) return;
        let N = !0;
        T.isPressed && !T.ignoreEmulatedMouseEvents && T.pointerType != null && (T.isOverTarget = !0, N = w(M, T.pointerType)), N && M.stopPropagation();
      }, V.onMouseLeave = (M) => {
        if (!Je(M.currentTarget, Ae(M))) return;
        let N = !0;
        T.isPressed && !T.ignoreEmulatedMouseEvents && T.pointerType != null && (T.isOverTarget = !1, N = S(M, T.pointerType, !1), b(M)), N && M.stopPropagation();
      }, V.onMouseUp = (M) => {
        Je(M.currentTarget, Ae(M)) && !T.ignoreEmulatedMouseEvents && M.button === 0 && !T.isPressed && A(M, T.pointerType || "mouse");
      };
      let B = (M) => {
        if (M.button === 0) {
          if (T.ignoreEmulatedMouseEvents) {
            T.ignoreEmulatedMouseEvents = !1;
            return;
          }
          T.target && Je(T.target, Ae(M)) && T.pointerType != null || y(M), T.isOverTarget = !1;
        }
      };
      V.onTouchStart = (M) => {
        if (!Je(M.currentTarget, Ae(M))) return;
        let N = $L(M.nativeEvent);
        if (!N) return;
        T.activePointerId = N.identifier, T.ignoreEmulatedMouseEvents = !0, T.isOverTarget = !0, T.isPressed = !0, T.target = M.currentTarget, T.pointerType = "touch", f || Gw(T.target), w(ao(T.target, M), T.pointerType) && M.stopPropagation(), g(Tn(M.currentTarget), "scroll", q, !0);
      }, V.onTouchMove = (M) => {
        if (!Je(M.currentTarget, Ae(M))) return;
        if (!T.isPressed) {
          M.stopPropagation();
          return;
        }
        let N = ex(M.nativeEvent, T.activePointerId), Y = !0;
        N && tx(N, M.currentTarget) ? !T.isOverTarget && T.pointerType != null && (T.isOverTarget = !0, Y = w(ao(T.target, M), T.pointerType)) : T.isOverTarget && T.pointerType != null && (T.isOverTarget = !1, Y = S(ao(T.target, M), T.pointerType, !1), b(ao(T.target, M))), Y && M.stopPropagation();
      }, V.onTouchEnd = (M) => {
        if (!Je(M.currentTarget, Ae(M))) return;
        if (!T.isPressed) {
          M.stopPropagation();
          return;
        }
        let N = ex(M.nativeEvent, T.activePointerId), Y = !0;
        N && tx(N, M.currentTarget) && T.pointerType != null ? (A(ao(T.target, M), T.pointerType), Y = S(ao(T.target, M), T.pointerType), k(M.nativeEvent, T.target)) : T.isOverTarget && T.pointerType != null && (Y = S(ao(T.target, M), T.pointerType, !1)), Y && M.stopPropagation(), T.isPressed = !1, T.activePointerId = null, T.isOverTarget = !1, T.ignoreEmulatedMouseEvents = !0, T.target && !f && ev(T.target), _();
      }, V.onTouchCancel = (M) => {
        Je(M.currentTarget, Ae(M)) && (M.stopPropagation(), T.isPressed && y(ao(T.target, M)));
      };
      let q = (M) => {
        T.isPressed && Je(Ae(M), T.target) && y({
          currentTarget: T.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      V.onDragStart = (M) => {
        Je(M.currentTarget, Ae(M)) && y(M);
      };
    }
    return V;
  }, [
    g,
    s,
    u,
    _,
    f,
    b,
    w,
    O,
    k
  ]);
  return Ee(() => {
    if (!d || process.env.NODE_ENV === "test") return;
    const T = st(d.current);
    if (!T || !T.head || T.getElementById(Jw)) return;
    const V = T.createElement("style");
    V.id = Jw;
    let z = mP(T);
    z && (V.nonce = z), V.textContent = `
@layer {
  [${Xw}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim(), T.head.prepend(V);
  }, [
    d
  ]), Ee(() => {
    let T = m.current;
    return () => {
      f || ev(T.target ?? void 0);
      for (let V of T.disposables) V();
      T.disposables = [];
    };
  }, [
    f
  ]), {
    isPressed: l || h,
    pressProps: ut(p, I, {
      [Xw]: !0
    })
  };
}
function Eb(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function nv(e, t) {
  const { key: n, code: r } = e, i = t, o = i.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(i instanceof Tn(i).HTMLInputElement && !gP(i, n) || i instanceof Tn(i).HTMLTextAreaElement || i.isContentEditable) && // Links should only trigger with Enter key
  !((o === "link" || !o && Eb(i)) && n !== "Enter");
}
function $L(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function ex(e, t) {
  const n = e.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const i = n[r];
    if (i.identifier === t) return i;
  }
  return null;
}
function ao(e, t) {
  let n = 0, r = 0;
  return t.targetTouches && t.targetTouches.length === 1 && (n = t.targetTouches[0].clientX, r = t.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function Go(e, t) {
  let n = t.clientX, r = t.clientY;
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r,
    key: t.key
  };
}
function TL(e) {
  let t = 0, n = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? n = e.height / 2 : e.radiusY !== void 0 && (n = e.radiusY), {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function PL(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function tx(e, t) {
  let n = t.getBoundingClientRect(), r = TL(e);
  return PL(n, r);
}
function kL(e) {
  return e instanceof HTMLInputElement ? !1 : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !Eb(e);
}
function nx(e, t) {
  return e instanceof HTMLInputElement ? !gP(e, t) : kL(e);
}
const DL = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function gP(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : DL.has(e.type);
}
function $p(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: i } = e, o = _e({
    isFocusWithin: !1
  }), { addGlobalListener: a, removeAllGlobalListeners: s } = Sp(), l = Le((f) => {
    Je(f.currentTarget, Ae(f)) && o.current.isFocusWithin && !Je(f.currentTarget, f.relatedTarget) && (o.current.isFocusWithin = !1, s(), n && n(f), i && i(!1));
  }, [
    n,
    i,
    o,
    s
  ]), u = HT(l), c = Le((f) => {
    if (!Je(f.currentTarget, Ae(f))) return;
    let d = Ae(f);
    const p = st(d), h = Vt(p);
    if (!o.current.isFocusWithin && h === d) {
      r && r(f), i && i(!0), o.current.isFocusWithin = !0, u(f);
      let v = f.currentTarget;
      a(p, "focus", (m) => {
        let g = Ae(m);
        if (o.current.isFocusWithin && !Je(v, g)) {
          let _ = new p.defaultView.FocusEvent("blur", {
            relatedTarget: g
          });
          qT(_, v);
          let w = vb(_);
          l(w);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    i,
    u,
    a,
    l
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: c,
      onBlur: l
    }
  };
}
function Tp(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, i = _e({
    isFocused: !1,
    isFocusVisible: t || _a()
  }), [o, a] = Ve(!1), [s, l] = Ve(() => i.current.isFocused && i.current.isFocusVisible), u = Le(() => l(i.current.isFocused && i.current.isFocusVisible), []), c = Le((p) => {
    i.current.isFocused = p, i.current.isFocusVisible = _a(), a(p), u();
  }, [
    u
  ]);
  jz((p) => {
    i.current.isFocusVisible = p, u();
  }, [
    n,
    o
  ], {
    enabled: o,
    isTextInput: n
  });
  let { focusProps: f } = yb({
    isDisabled: r,
    onFocusChange: c
  }), { focusWithinProps: d } = $p({
    isDisabled: !r,
    onFocusWithinChange: c
  });
  return {
    isFocused: o,
    isFocusVisible: s,
    focusProps: r ? d : f
  };
}
let _d = !1, tf = 0;
function ng() {
  _d = !0, setTimeout(() => {
    _d = !1;
  }, 500);
}
function rx(e) {
  e.pointerType === "touch" && ng();
}
function AL() {
  let e = st(null);
  if (!(typeof e > "u"))
    return tf === 0 && (typeof PointerEvent < "u" ? e.addEventListener("pointerup", rx) : process.env.NODE_ENV === "test" && e.addEventListener("touchend", ng)), tf++, () => {
      tf--, !(tf > 0) && (typeof PointerEvent < "u" ? e.removeEventListener("pointerup", rx) : process.env.NODE_ENV === "test" && e.removeEventListener("touchend", ng));
    };
}
function ll(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: i } = e, [o, a] = Ve(!1), s = _e({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  Ee(AL, []);
  let { addGlobalListener: l, removeAllGlobalListeners: u } = Sp(), { hoverProps: c, triggerHoverEnd: f } = Te(() => {
    let d = (v, m) => {
      if (s.pointerType = m, i || m === "touch" || s.isHovered || !Je(v.currentTarget, Ae(v))) return;
      s.isHovered = !0;
      let g = v.currentTarget;
      s.target = g, l(st(Ae(v)), "pointerover", (_) => {
        s.isHovered && s.target && !Je(s.target, Ae(_)) && p(_, _.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: g,
        pointerType: m
      }), n && n(!0), a(!0);
    }, p = (v, m) => {
      let g = s.target;
      s.pointerType = "", s.target = null, !(m === "touch" || !s.isHovered || !g) && (s.isHovered = !1, u(), r && r({
        type: "hoverend",
        target: g,
        pointerType: m
      }), n && n(!1), a(!1));
    }, h = {};
    return typeof PointerEvent < "u" ? (h.onPointerEnter = (v) => {
      _d && v.pointerType === "mouse" || d(v, v.pointerType);
    }, h.onPointerLeave = (v) => {
      !i && Je(v.currentTarget, Ae(v)) && p(v, v.pointerType);
    }) : process.env.NODE_ENV === "test" && (h.onTouchStart = () => {
      s.ignoreEmulatedMouseEvents = !0;
    }, h.onMouseEnter = (v) => {
      !s.ignoreEmulatedMouseEvents && !_d && d(v, "mouse"), s.ignoreEmulatedMouseEvents = !1;
    }, h.onMouseLeave = (v) => {
      !i && Je(v.currentTarget, Ae(v)) && p(v, "mouse");
    }), {
      hoverProps: h,
      triggerHoverEnd: p
    };
  }, [
    t,
    n,
    r,
    i,
    s,
    l,
    u
  ]);
  return Ee(() => {
    i && f({
      currentTarget: s.target
    }, s.pointerType);
  }, [
    i
  ]), {
    hoverProps: c,
    isHovered: o
  };
}
const Sb = /* @__PURE__ */ He({}), CL = /* @__PURE__ */ Ep(function(t, n) {
  [t, n] = Ai(t, n, Sb);
  let { elementType: r = "label", ...i } = t, o = Bn[r];
  return /* @__PURE__ */ H.createElement(o, {
    className: "react-aria-Label",
    ...i,
    ref: n
  });
});
function yP(e) {
  let { id: t, label: n, "aria-labelledby": r, "aria-label": i, labelElementType: o = "label" } = e;
  t = Jn(t);
  let a = Jn(), s = {};
  n ? (r = r ? `${a} ${r}` : a, s = {
    id: a,
    htmlFor: o === "label" ? t : void 0
  }) : !r && !i && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let l = tP({
    id: t,
    "aria-label": i,
    "aria-labelledby": r
  });
  return {
    labelProps: s,
    fieldProps: l
  };
}
function rg(e, t = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(e, t), n);
}
const IL = /* @__PURE__ */ He(null), bP = 7e3;
let Ga = null;
function ix(e, t = "assertive", n = bP) {
  Ga ? Ga.announce(e, t, n) : (Ga = new NL(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? Ga.announce(e, t, n) : setTimeout(() => {
    Ga?.isAttached() && Ga?.announce(e, t, n);
  }, 100));
}
class NL {
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
  isAttached() {
    return this.node?.isConnected;
  }
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = bP) {
    if (!this.node) return;
    let i = document.createElement("div");
    typeof t == "object" ? (i.setAttribute("role", "img"), i.setAttribute("aria-labelledby", t["aria-labelledby"])) : i.textContent = t, n === "assertive" ? this.assertiveLog?.appendChild(i) : this.politeLog?.appendChild(i), t !== "" && setTimeout(() => {
      i.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
}
function RL(e, t) {
  let { elementType: n = "button", isDisabled: r, onPress: i, onPressStart: o, onPressEnd: a, onPressUp: s, onPressChange: l, preventFocusOnPress: u, allowFocusWhenDisabled: c, onClick: f, href: d, target: p, rel: h, type: v = "button" } = e, m;
  n === "button" ? m = {
    type: v,
    disabled: r,
    form: e.form,
    formAction: e.formAction,
    formEncType: e.formEncType,
    formMethod: e.formMethod,
    formNoValidate: e.formNoValidate,
    formTarget: e.formTarget,
    name: e.name,
    value: e.value
  } : m = {
    role: "button",
    href: n === "a" && !r ? d : void 0,
    target: n === "a" ? p : void 0,
    type: n === "input" ? v : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? h : void 0
  };
  let { pressProps: g, isPressed: _ } = Op({
    onPressStart: o,
    onPressEnd: a,
    onPressChange: l,
    onPress: i,
    onPressUp: s,
    onClick: f,
    isDisabled: r,
    preventFocusOnPress: u,
    ref: t
  }), { focusableProps: w } = cP(e, t);
  c && (w.tabIndex = r ? -1 : w.tabIndex);
  let x = ut(w, g, kn(e, {
    labelable: !0
  }));
  return {
    isPressed: _,
    buttonProps: ut(m, x, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      "aria-current": e["aria-current"],
      "aria-disabled": e["aria-disabled"]
    })
  };
}
const Ob = /* @__PURE__ */ He({}), $b = /* @__PURE__ */ Ep(function(t, n) {
  [t, n] = Ai(t, n, Ob);
  let r = t, { isPending: i } = r, { buttonProps: o, isPressed: a } = RL(t, n);
  o = jL(o, i);
  let { focusProps: s, isFocused: l, isFocusVisible: u } = Tp(t), { hoverProps: c, isHovered: f } = ll({
    ...t,
    isDisabled: t.isDisabled || i
  }), d = {
    isHovered: f,
    isPressed: (r.isPressed || a) && !i,
    isFocused: l,
    isFocusVisible: u,
    isDisabled: t.isDisabled || !1,
    isPending: i ?? !1
  }, p = zr({
    ...t,
    values: d,
    defaultClassName: "react-aria-Button"
  }), h = Jn(o.id), v = Jn(), m = o["aria-labelledby"];
  i && (m ? m = `${m} ${v}` : o["aria-label"] && (m = `${h} ${v}`));
  let g = _e(i);
  Ee(() => {
    let w = {
      "aria-labelledby": m || h
    };
    (!g.current && l && i || g.current && l && !i) && ix(w, "assertive"), g.current = i;
  }, [
    i,
    l,
    m,
    h
  ]);
  let _ = kn(t, {
    global: !0
  });
  return delete _.onClick, /* @__PURE__ */ H.createElement(Bn.button, {
    ...ut(_, p, o, s, c),
    // When the button is in a pending state, we want to stop implicit form submission (ie. when the user presses enter on a text input).
    // We do this by changing the button's type to button.
    type: o.type === "submit" && i ? "button" : o.type,
    id: h,
    ref: n,
    "aria-labelledby": m,
    slot: t.slot || void 0,
    "aria-disabled": i ? "true" : o["aria-disabled"],
    "data-disabled": t.isDisabled || void 0,
    "data-pressed": d.isPressed || void 0,
    "data-hovered": f || void 0,
    "data-focused": l || void 0,
    "data-pending": i || void 0,
    "data-focus-visible": u || void 0
  }, /* @__PURE__ */ H.createElement(IL.Provider, {
    value: {
      id: v
    }
  }, p.children));
}), ML = /Focus|Blur|Hover|Pointer(Enter|Leave|Over|Out)|Mouse(Enter|Leave|Over|Out)/;
function jL(e, t) {
  if (t) {
    for (const n in e) n.startsWith("on") && !ML.test(n) && (e[n] = void 0);
    e.href = void 0, e.target = void 0;
  }
  return e;
}
const Pp = /* @__PURE__ */ He({});
function Ms(e, t) {
  if (!e) return !1;
  let n = window.getComputedStyle(e), r = document.scrollingElement || document.documentElement, i = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
  return e === r && n.overflow !== "hidden" && (i = !0), i && t && (i = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), i;
}
function Tb(e, t) {
  let n = e;
  for (Ms(n, t) && (n = n.parentElement); n && !Ms(n, t); ) n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
function rv(e, t) {
  let n = [], r = document.scrollingElement || document.documentElement;
  for (; e && (Ms(e, t) && n.push(e), e !== r); )
    e = e.parentElement;
  return n;
}
function If(e, t, n = {}) {
  let { block: r = "nearest", inline: i = "nearest" } = n;
  if (e === t) return;
  let o = e.scrollTop, a = e.scrollLeft, s = t.getBoundingClientRect(), l = e.getBoundingClientRect(), u = window.getComputedStyle(t), c = window.getComputedStyle(e), f = document.scrollingElement || document.documentElement, d = e === f, p = e === f ? 0 : l.top, h = e === f ? e.clientHeight : l.bottom, v = e === f ? 0 : l.left, m = e === f ? e.clientWidth : l.right, g = parseFloat(u.scrollMarginTop) || 0, _ = parseFloat(u.scrollMarginBottom) || 0, w = parseFloat(u.scrollMarginLeft) || 0, x = parseFloat(u.scrollMarginRight) || 0, S = parseFloat(c.scrollPaddingTop) || 0, $ = parseFloat(c.scrollPaddingBottom) || 0, A = parseFloat(c.scrollPaddingLeft) || 0, E = parseFloat(c.scrollPaddingRight) || 0, y = parseFloat(c.borderTopWidth) || 0, b = parseFloat(c.borderBottomWidth) || 0, O = parseFloat(c.borderLeftWidth) || 0, k = parseFloat(c.borderRightWidth) || 0, I = s.top - g, T = s.bottom + _, V = s.left - w, z = s.right + x, B = e === f ? 0 : O + k, q = e === f ? 0 : y + b, M = e === f ? 0 : e.offsetWidth - e.clientWidth - B, N = e === f ? 0 : e.offsetHeight - e.clientHeight - q, Y = p + (d ? 0 : y) + S, ee = h - (d ? 0 : b) - $ - N, Q = v + (d ? 0 : O) + A, K = m - (d ? 0 : k) - E;
  c.direction === "rtl" && !mc() ? Q += M : K -= M;
  let ne = I < Y || T > ee, se = V < Q || z > K;
  if (ne && r === "start") o += I - Y;
  else if (ne && r === "center") o += (I + T) / 2 - (Y + ee) / 2;
  else if (ne && r === "end") o += T - ee;
  else if (ne && r === "nearest") {
    let ce = I - Y, X = T - ee;
    o += Math.abs(ce) <= Math.abs(X) ? ce : X;
  }
  if (se && i === "start") a += V - Q;
  else if (se && i === "center") a += (V + z) / 2 - (Q + K) / 2;
  else if (se && i === "end") a += z - K;
  else if (se && i === "nearest") {
    let ce = V - Q, X = z - K;
    a += Math.abs(ce) <= Math.abs(X) ? ce : X;
  }
  if (process.env.NODE_ENV === "test") {
    e.scrollLeft = a, e.scrollTop = o;
    return;
  }
  e.scrollTo({
    left: a,
    top: o
  });
}
function ox(e, t = {}) {
  let { containingElement: n } = t;
  if (e && e.isConnected) {
    let r = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(r).overflow === "hidden") {
      let { left: o, top: a } = e.getBoundingClientRect(), s = rv(e, !0);
      for (let c of s) If(c, e);
      let { left: l, top: u } = e.getBoundingClientRect();
      if (Math.abs(o - l) > 1 || Math.abs(a - u) > 1) {
        s = n ? rv(n, !0) : [];
        for (let c of s) If(c, n, {
          block: "center",
          inline: "center"
        });
        for (let c of rv(e, !0)) If(c, e);
      }
    } else {
      let { left: o, top: a } = e.getBoundingClientRect();
      e?.scrollIntoView?.({
        block: "nearest"
      });
      let { left: s, top: l } = e.getBoundingClientRect();
      (Math.abs(o - s) > 1 || Math.abs(a - l) > 1) && (n?.scrollIntoView?.({
        block: "center",
        inline: "center"
      }), e.scrollIntoView?.({
        block: "nearest"
      }));
    }
  }
}
let FL = 0;
const iv = /* @__PURE__ */ new Map();
function zL(e) {
  let [t, n] = Ve();
  return ht(() => {
    if (!e) return;
    let r = iv.get(e);
    if (r)
      n(r.element.id);
    else {
      let i = `react-aria-description-${FL++}`;
      n(i);
      let o = document.createElement("div");
      o.id = i, o.style.display = "none", o.textContent = e, document.body.appendChild(o), r = {
        refCount: 0,
        element: o
      }, iv.set(e, r);
    }
    return r.refCount++, () => {
      r && --r.refCount === 0 && (r.element.remove(), iv.delete(e));
    };
  }, [
    e
  ]), {
    "aria-describedby": e ? t : void 0
  };
}
const ax = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function _P(e = {}) {
  let { style: t, isFocusable: n } = e, [r, i] = Ve(!1), { focusWithinProps: o } = $p({
    isDisabled: !n,
    onFocusWithinChange: (s) => i(s)
  }), a = Te(() => r ? t : t ? {
    ...ax,
    ...t
  } : ax, [
    r
  ]);
  return {
    visuallyHiddenProps: {
      ...o,
      style: a
    }
  };
}
function LL(e) {
  let { children: t, elementType: n = "div", isFocusable: r, style: i, ...o } = e, { visuallyHiddenProps: a } = _P(e);
  return /* @__PURE__ */ H.createElement(n, ut(o, a), t);
}
const VL = /* @__PURE__ */ He(null), wP = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, xP = {
  ...wP,
  customError: !0,
  valid: !1
}, jl = {
  isInvalid: !1,
  validationDetails: wP,
  validationErrors: []
}, KL = He({}), sx = "__reactAriaFormValidationState";
function BL(e) {
  if (e[sx]) {
    let { realtimeValidation: t, displayValidation: n, updateValidation: r, resetValidation: i, commitValidation: o } = e[sx];
    return {
      realtimeValidation: t,
      displayValidation: n,
      updateValidation: r,
      resetValidation: i,
      commitValidation: o
    };
  }
  return UL(e);
}
function UL(e) {
  let { isInvalid: t, validationState: n, name: r, value: i, builtinValidation: o, validate: a, validationBehavior: s = "aria" } = e;
  n && (t || (t = n === "invalid"));
  let l = t !== void 0 ? {
    isInvalid: t,
    validationErrors: [],
    validationDetails: xP
  } : null, u = Te(() => {
    if (!a || i == null) return null;
    let b = qL(a, i);
    return lx(b);
  }, [
    a,
    i
  ]);
  o?.validationDetails.valid && (o = void 0);
  let c = Me(KL), f = Te(() => r ? Array.isArray(r) ? r.flatMap((b) => ig(c[b])) : ig(c[r]) : [], [
    c,
    r
  ]), [d, p] = Ve(c), [h, v] = Ve(!1);
  c !== d && (p(c), v(!1));
  let m = Te(() => lx(h ? [] : f), [
    h,
    f
  ]), g = _e(jl), [_, w] = Ve(jl), x = _e(jl), S = () => {
    if (!$) return;
    A(!1);
    let b = u || o || g.current;
    ov(b, x.current) || (x.current = b, w(b));
  }, [$, A] = Ve(!1);
  return Ee(S), {
    realtimeValidation: l || m || u || o || jl,
    displayValidation: s === "native" ? l || m || _ : l || m || u || o || _,
    updateValidation(b) {
      s === "aria" && !ov(_, b) ? w(b) : g.current = b;
    },
    resetValidation() {
      let b = jl;
      ov(b, x.current) || (x.current = b, w(b)), s === "native" && A(!1), v(!0);
    },
    commitValidation() {
      s === "native" && A(!0), v(!0);
    }
  };
}
function ig(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function qL(e, t) {
  if (typeof e == "function") {
    let n = e(t);
    if (n && typeof n != "boolean") return ig(n);
  }
  return [];
}
function lx(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: xP
  } : null;
}
function ov(e, t) {
  return e === t ? !0 : !!e && !!t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((n, r) => n === t.validationErrors[r]) && Object.entries(e.validationDetails).every(([n, r]) => t.validationDetails[n] === r);
}
const HL = /* @__PURE__ */ He(null);
function WL(e) {
  let { description: t, errorMessage: n, isInvalid: r, validationState: i } = e, { labelProps: o, fieldProps: a } = yP(e), s = fa([
    !!t,
    !!n,
    r,
    i
  ]), l = fa([
    !!t,
    !!n,
    r,
    i
  ]);
  return a = ut(a, {
    "aria-describedby": [
      s,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      l,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: o,
    fieldProps: a,
    descriptionProps: {
      id: s
    },
    errorMessageProps: {
      id: l
    }
  };
}
function ZL(e, t, n) {
  let r = Cr((i) => {
    n && !i.defaultPrevented && n(t);
  });
  Ee(() => {
    let i = e?.current?.form;
    return i?.addEventListener("reset", r), () => {
      i?.removeEventListener("reset", r);
    };
  }, [
    e
  ]);
}
function GL(e, t, n) {
  let { validationBehavior: r, focus: i } = e;
  ht(() => {
    if (r === "native" && n?.current && "setCustomValidity" in n.current && !n.current.disabled) {
      let u = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(u), n.current.hasAttribute("title") || (n.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(QL(n.current));
    }
  });
  let o = _e(!1), a = Cr(() => {
    o.current || t.resetValidation();
  }), s = Cr((u) => {
    t.displayValidation.isInvalid || t.commitValidation();
    let c = n?.current?.form;
    !u.defaultPrevented && n && c && JL(c) === n.current && (i ? i() : n.current?.focus(), gd("keyboard")), u.preventDefault();
  }), l = Cr(() => {
    t.commitValidation();
  });
  Ee(() => {
    let u = n?.current;
    if (!u) return;
    let c = u.form, f = c?.reset;
    return c && (c.reset = () => {
      o.current = !window.event || window.event.type === "message" && Ae(window.event) instanceof MessagePort, f?.call(c), o.current = !1;
    }), u.addEventListener("invalid", s), u.addEventListener("change", l), c?.addEventListener("reset", a), () => {
      u.removeEventListener("invalid", s), u.removeEventListener("change", l), c?.removeEventListener("reset", a), c && (c.reset = f);
    };
  }, [
    n,
    r
  ]);
}
function YL(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function QL(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: YL(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function JL(e) {
  for (let t = 0; t < e.elements.length; t++) {
    let n = e.elements[t];
    if (n.validity?.valid === !1) return n;
  }
  return null;
}
const XL = /* @__PURE__ */ He({});
let e9 = (e) => {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, ...i } = e;
  return i;
};
const t9 = /* @__PURE__ */ Ep(function(t, n) {
  [t, n] = Ai(t, n, XL);
  let { hoverProps: r, isHovered: i } = ll({
    ...t,
    isDisabled: t.disabled
  }), { isFocused: o, isFocusVisible: a, focusProps: s } = Tp({
    isTextInput: !0,
    autoFocus: t.autoFocus
  }), l = !!t["aria-invalid"] && t["aria-invalid"] !== "false", u = zr({
    ...t,
    values: {
      isHovered: i,
      isFocused: o,
      isFocusVisible: a,
      isDisabled: t.disabled || !1,
      isInvalid: l
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ H.createElement(Bn.input, {
    ...ut(e9(t), s, r),
    ...u,
    ref: n,
    "data-focused": o || void 0,
    "data-disabled": t.disabled || void 0,
    "data-hovered": i || void 0,
    "data-focus-visible": a || void 0,
    "data-invalid": l || void 0
  });
}), kp = /* @__PURE__ */ He({}), EP = /* @__PURE__ */ He(null), n9 = /* @__PURE__ */ fn(function(t, n) {
  let { render: r } = Me(EP);
  return /* @__PURE__ */ H.createElement(H.Fragment, null, r(t, n));
});
function SP(e, t) {
  let n = e?.renderDropIndicator, r = e?.isVirtualDragging?.(), i = Le(
    (o) => {
      if (r || t?.isDropTarget(o)) return n ? n(o) : /* @__PURE__ */ H.createElement(n9, {
        target: o
      });
    },
    // We invalidate whenever the target changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t?.target,
      r,
      n
    ]
  );
  return e?.useDropIndicator ? i : void 0;
}
function r9(e, t, n) {
  let r = e.focusedKey, i = null;
  if (t?.isVirtualDragging?.() && n?.target?.type === "item" && (i = n.target.key, n.target.dropPosition === "after")) {
    let o = n.collection.getKeyAfter(i), a = null;
    if (o != null) {
      let s = n.collection.getItem(i)?.level ?? 0;
      for (; o != null; ) {
        let l = n.collection.getItem(o);
        if (!l) break;
        if (l.type !== "item") {
          o = n.collection.getKeyAfter(o);
          continue;
        }
        if ((l.level ?? 0) <= s) break;
        a = o, o = n.collection.getKeyAfter(o);
      }
    }
    i = o ?? a ?? i;
  }
  return Te(() => new Set([
    r,
    i
  ].filter((o) => o != null)), [
    r,
    i
  ]);
}
const OP = /* @__PURE__ */ He({}), i9 = /* @__PURE__ */ He(null);
function $P(e) {
  let t = _e({});
  return /* @__PURE__ */ H.createElement(i9.Provider, {
    value: t
  }, e.children);
}
const TP = /* @__PURE__ */ He({
  isSelected: !1
}), PP = /* @__PURE__ */ He({}), x_ = class x_ extends al {
  filter(t, n) {
    let r = n.getItem(this.prevKey);
    if (r && r.type !== "separator") {
      let i = this.clone();
      return n.addDescendants(i, t), i;
    }
    return null;
  }
};
x_.type = "separator";
let ux = x_;
const Pb = /* @__PURE__ */ new WeakMap();
function o9(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
function a9(e, t) {
  let n = Pb.get(e);
  if (!n) throw new Error("Unknown list");
  return `${n.id}-option-${o9(t)}`;
}
class s9 {
  constructor(t, n, r, i) {
    this._walkerStack = [], this._currentSetFor = /* @__PURE__ */ new Set(), this._acceptNode = (a) => {
      if (a.nodeType === Node.ELEMENT_NODE) {
        const s = a.shadowRoot;
        if (s) {
          const l = this._doc.createTreeWalker(s, this.whatToShow, {
            acceptNode: this._acceptNode
          });
          return this._walkerStack.unshift(l), NodeFilter.FILTER_ACCEPT;
        } else {
          if (typeof this.filter == "function") return this.filter(a);
          if (this.filter?.acceptNode) return this.filter.acceptNode(a);
          if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
        }
      }
      return NodeFilter.FILTER_SKIP;
    }, this._doc = t, this.root = n, this.filter = i ?? null, this.whatToShow = r ?? NodeFilter.SHOW_ALL, this._currentNode = n, this._walkerStack.unshift(t.createTreeWalker(n, r, this._acceptNode));
    const o = n.shadowRoot;
    if (o) {
      const a = this._doc.createTreeWalker(o, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      this._walkerStack.unshift(a);
    }
  }
  get currentNode() {
    return this._currentNode;
  }
  set currentNode(t) {
    if (!Je(this.root, t)) throw new Error("Cannot set currentNode to a node that is not contained by the root node.");
    const n = [];
    let r = t, i = t;
    for (this._currentNode = t; r && r !== this.root; ) if (r.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      const a = r, s = this._doc.createTreeWalker(a, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      n.push(s), s.currentNode = i, this._currentSetFor.add(s), r = i = a.host;
    } else r = r.parentNode;
    const o = this._doc.createTreeWalker(this.root, this.whatToShow, {
      acceptNode: this._acceptNode
    });
    n.push(o), o.currentNode = i, this._currentSetFor.add(o), this._walkerStack = n;
  }
  get doc() {
    return this._doc;
  }
  firstChild() {
    let t = this.currentNode, n = this.nextNode();
    return Je(t, n) ? (n && (this.currentNode = n), n) : (this.currentNode = t, null);
  }
  lastChild() {
    let n = this._walkerStack[0].lastChild();
    return n && (this.currentNode = n), n;
  }
  nextNode() {
    const t = this._walkerStack[0].nextNode();
    if (t) {
      if (t.shadowRoot) {
        let r;
        if (typeof this.filter == "function" ? r = this.filter(t) : this.filter?.acceptNode && (r = this.filter.acceptNode(t)), r === NodeFilter.FILTER_ACCEPT)
          return this.currentNode = t, t;
        let i = this.nextNode();
        return i && (this.currentNode = i), i;
      }
      return t && (this.currentNode = t), t;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let n = this.nextNode();
      return n && (this.currentNode = n), n;
    } else return null;
  }
  previousNode() {
    const t = this._walkerStack[0];
    if (t.currentNode === t.root) {
      if (this._currentSetFor.has(t))
        if (this._currentSetFor.delete(t), this._walkerStack.length > 1) {
          this._walkerStack.shift();
          let r = this.previousNode();
          return r && (this.currentNode = r), r;
        } else return null;
      return null;
    }
    const n = t.previousNode();
    if (n) {
      if (n.shadowRoot) {
        let i;
        if (typeof this.filter == "function" ? i = this.filter(n) : this.filter?.acceptNode && (i = this.filter.acceptNode(n)), i === NodeFilter.FILTER_ACCEPT)
          return n && (this.currentNode = n), n;
        let o = this.lastChild();
        return o && (this.currentNode = o), o;
      }
      return n && (this.currentNode = n), n;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let r = this.previousNode();
      return r && (this.currentNode = r), r;
    } else return null;
  }
  /**
  * @deprecated
  */
  nextSibling() {
    return null;
  }
  /**
  * @deprecated
  */
  previousSibling() {
    return null;
  }
  /**
  * @deprecated
  */
  parentNode() {
    return null;
  }
}
function kP(e, t, n, r) {
  return Mi() ? new s9(e, t, n, r) : e.createTreeWalker(t, n, r);
}
const cx = /* @__PURE__ */ H.createContext(null), og = "react-aria-focus-scope-restore";
let $t = null;
function kb(e) {
  let { children: t, contain: n, restoreFocus: r, autoFocus: i } = e, o = _e(null), a = _e(null), s = _e([]), { parentNode: l } = Me(cx) || {}, u = Te(() => new sg({
    scopeRef: s
  }), [
    s
  ]);
  ht(() => {
    let d = l || cn.root;
    if (cn.getTreeNode(d.scopeRef) && $t && !wd($t, d.scopeRef)) {
      let p = cn.getTreeNode($t);
      p && (d = p);
    }
    d.addChild(u), cn.addNode(u);
  }, [
    u,
    l
  ]), ht(() => {
    let d = cn.getTreeNode(s);
    d && (d.contain = !!n);
  }, [
    n
  ]), ht(() => {
    let d = o.current?.nextSibling, p = [], h = (v) => v.stopPropagation();
    for (; d && d !== a.current; )
      p.push(d), d.addEventListener(og, h), d = d.nextSibling;
    return s.current = p, () => {
      for (let v of p) v.removeEventListener(og, h);
    };
  }, [
    t
  ]), h9(s, r, n), f9(s, n), v9(s, r, n), p9(s, i), Ee(() => {
    const d = Vt(st(s.current ? s.current[0] : void 0));
    let p = null;
    if (Mr(d, s.current)) {
      for (let h of cn.traverse()) h.scopeRef && Mr(d, h.scopeRef.current) && (p = h);
      p === cn.getTreeNode(s) && ($t = p.scopeRef);
    }
  }, [
    s
  ]), ht(() => () => {
    let d = cn.getTreeNode(s)?.parent?.scopeRef ?? null;
    (s === $t || wd(s, $t)) && (!d || cn.getTreeNode(d)) && ($t = d), cn.removeTreeNode(s);
  }, [
    s
  ]);
  let c = Te(() => l9(s), []), f = Te(() => ({
    focusManager: c,
    parentNode: u
  }), [
    u,
    c
  ]);
  return /* @__PURE__ */ H.createElement(cx.Provider, {
    value: f
  }, /* @__PURE__ */ H.createElement("span", {
    "data-focus-scope-start": !0,
    hidden: !0,
    ref: o
  }), t, /* @__PURE__ */ H.createElement("span", {
    "data-focus-scope-end": !0,
    hidden: !0,
    ref: a
  }));
}
function l9(e) {
  return {
    focusNext(t = {}) {
      let n = e.current, { from: r, tabbable: i, wrap: o, accept: a } = t, s = r || Vt(st(n[0] ?? void 0)), l = n[0].previousElementSibling, u = la(n), c = Li(u, {
        tabbable: i,
        accept: a
      }, n);
      c.currentNode = Mr(s, n) ? s : l;
      let f = c.nextNode();
      return !f && o && (c.currentNode = l, f = c.nextNode()), f && zi(f, !0), f;
    },
    focusPrevious(t = {}) {
      let n = e.current, { from: r, tabbable: i, wrap: o, accept: a } = t, s = r || Vt(st(n[0] ?? void 0)), l = n[n.length - 1].nextElementSibling, u = la(n), c = Li(u, {
        tabbable: i,
        accept: a
      }, n);
      c.currentNode = Mr(s, n) ? s : l;
      let f = c.previousNode();
      return !f && o && (c.currentNode = l, f = c.previousNode()), f && zi(f, !0), f;
    },
    focusFirst(t = {}) {
      let n = e.current, { tabbable: r, accept: i } = t, o = la(n), a = Li(o, {
        tabbable: r,
        accept: i
      }, n);
      a.currentNode = n[0].previousElementSibling;
      let s = a.nextNode();
      return s && zi(s, !0), s;
    },
    focusLast(t = {}) {
      let n = e.current, { tabbable: r, accept: i } = t, o = la(n), a = Li(o, {
        tabbable: r,
        accept: i
      }, n);
      a.currentNode = n[n.length - 1].nextElementSibling;
      let s = a.previousNode();
      return s && zi(s, !0), s;
    }
  };
}
function la(e) {
  return e[0].parentElement;
}
function Yl(e) {
  let t = cn.getTreeNode($t);
  for (; t && t.scopeRef !== e; ) {
    if (t.contain) return !1;
    t = t.parent;
  }
  return !0;
}
function u9(e) {
  if (!e.form)
    return Array.from(st(e).querySelectorAll(`input[type="radio"][name="${CSS.escape(e.name)}"]`)).filter((r) => !r.form);
  const t = e.form.elements.namedItem(e.name);
  let n = Tn(e);
  return t instanceof n.RadioNodeList ? Array.from(t).filter((r) => r instanceof n.HTMLInputElement) : t instanceof n.HTMLInputElement ? [
    t
  ] : [];
}
function c9(e) {
  if (e.checked) return !0;
  const t = u9(e);
  return t.length > 0 && !t.some((n) => n.checked);
}
function f9(e, t) {
  let n = _e(void 0), r = _e(void 0);
  ht(() => {
    let i = e.current;
    if (!t) {
      r.current && (cancelAnimationFrame(r.current), r.current = void 0);
      return;
    }
    const o = st(i ? i[0] : void 0);
    let a = (u) => {
      if (u.key !== "Tab" || u.altKey || u.ctrlKey || u.metaKey || !Yl(e) || u.isComposing) return;
      let c = Vt(o), f = e.current;
      if (!f || !Mr(c, f)) return;
      let d = la(f), p = Li(d, {
        tabbable: !0
      }, f);
      if (!c) return;
      p.currentNode = c;
      let h = u.shiftKey ? p.previousNode() : p.nextNode();
      h || (p.currentNode = u.shiftKey ? f[f.length - 1].nextElementSibling : f[0].previousElementSibling, h = u.shiftKey ? p.previousNode() : p.nextNode()), u.preventDefault(), h && (zi(h, !0), h instanceof Tn(h).HTMLInputElement && h.select());
    }, s = (u) => {
      (!$t || wd($t, e)) && Mr(Ae(u), e.current) ? ($t = e, n.current = Ae(u)) : Yl(e) && !wo(Ae(u), e) ? n.current ? n.current.focus() : $t && $t.current && ag($t.current) : Yl(e) && (n.current = Ae(u));
    }, l = (u) => {
      r.current && cancelAnimationFrame(r.current), r.current = requestAnimationFrame(() => {
        let c = Ru(), f = (c === "virtual" || c === null) && gb() && GT(), d = Vt(o);
        if (!f && d && Yl(e) && !wo(d, e)) {
          $t = e;
          let p = Ae(u);
          p && p.isConnected ? (n.current = p, n.current?.focus()) : $t.current && ag($t.current);
        }
      });
    };
    return o.addEventListener("keydown", a, !1), o.addEventListener("focusin", s, !1), i?.forEach((u) => u.addEventListener("focusin", s, !1)), i?.forEach((u) => u.addEventListener("focusout", l, !1)), () => {
      o.removeEventListener("keydown", a, !1), o.removeEventListener("focusin", s, !1), i?.forEach((u) => u.removeEventListener("focusin", s, !1)), i?.forEach((u) => u.removeEventListener("focusout", l, !1));
    };
  }, [
    e,
    t
  ]), ht(() => () => {
    r.current && cancelAnimationFrame(r.current);
  }, [
    r
  ]);
}
function DP(e) {
  return wo(e);
}
function Mr(e, t) {
  return !e || !t ? !1 : t.some((n) => Je(n, e));
}
function wo(e, t = null) {
  if (e instanceof Element && e.closest("[data-react-aria-top-layer]")) return !0;
  for (let { scopeRef: n } of cn.traverse(cn.getTreeNode(t)))
    if (n && Mr(e, n.current)) return !0;
  return !1;
}
function d9(e) {
  return wo(e, $t);
}
function wd(e, t) {
  let n = cn.getTreeNode(t)?.parent;
  for (; n; ) {
    if (n.scopeRef === e) return !0;
    n = n.parent;
  }
  return !1;
}
function zi(e, t = !1) {
  if (e != null && !t) try {
    Rs(e);
  } catch {
  }
  else if (e != null) try {
    e.focus();
  } catch {
  }
}
function AP(e, t = !0) {
  let n = e[0].previousElementSibling, r = la(e), i = Li(r, {
    tabbable: t
  }, e);
  i.currentNode = n;
  let o = i.nextNode();
  return t && !o && (r = la(e), i = Li(r, {
    tabbable: !1
  }, e), i.currentNode = n, o = i.nextNode()), o;
}
function ag(e, t = !0) {
  zi(AP(e, t));
}
function p9(e, t) {
  const n = H.useRef(t);
  Ee(() => {
    if (n.current) {
      $t = e;
      const r = st(e.current ? e.current[0] : void 0);
      !Mr(Vt(r), $t.current) && e.current && ag(e.current);
    }
    n.current = !1;
  }, [
    e
  ]);
}
function h9(e, t, n) {
  ht(() => {
    if (t || n) return;
    let r = e.current;
    const i = st(r ? r[0] : void 0);
    let o = (a) => {
      let s = Ae(a);
      Mr(s, e.current) ? $t = e : DP(s) || ($t = null);
    };
    return i.addEventListener("focusin", o, !1), r?.forEach((a) => a.addEventListener("focusin", o, !1)), () => {
      i.removeEventListener("focusin", o, !1), r?.forEach((a) => a.removeEventListener("focusin", o, !1));
    };
  }, [
    e,
    t,
    n
  ]);
}
function fx(e) {
  let t = cn.getTreeNode($t);
  for (; t && t.scopeRef !== e; ) {
    if (t.nodeToRestore) return !1;
    t = t.parent;
  }
  return t?.scopeRef === e;
}
function v9(e, t, n) {
  const r = _e(typeof document < "u" ? Vt(st(e.current ? e.current[0] : void 0)) : null);
  ht(() => {
    let i = e.current;
    const o = st(i ? i[0] : void 0);
    if (!t || n) return;
    let a = () => {
      (!$t || wd($t, e)) && Mr(Vt(o), e.current) && ($t = e);
    };
    return o.addEventListener("focusin", a, !1), i?.forEach((s) => s.addEventListener("focusin", a, !1)), () => {
      o.removeEventListener("focusin", a, !1), i?.forEach((s) => s.removeEventListener("focusin", a, !1));
    };
  }, [
    e,
    n
  ]), ht(() => {
    const i = st(e.current ? e.current[0] : void 0);
    if (!t) return;
    let o = (a) => {
      if (a.key !== "Tab" || a.altKey || a.ctrlKey || a.metaKey || !Yl(e) || a.isComposing) return;
      let s = i.activeElement;
      if (!wo(s, e) || !fx(e)) return;
      let l = cn.getTreeNode(e);
      if (!l) return;
      let u = l.nodeToRestore, c = Li(i.body, {
        tabbable: !0
      });
      c.currentNode = s;
      let f = a.shiftKey ? c.previousNode() : c.nextNode();
      if ((!u || !u.isConnected || u === i.body) && (u = void 0, l.nodeToRestore = void 0), (!f || !wo(f, e)) && u) {
        c.currentNode = u;
        do
          f = a.shiftKey ? c.previousNode() : c.nextNode();
        while (wo(f, e));
        a.preventDefault(), a.stopPropagation(), f ? zi(f, !0) : DP(u) ? zi(u, !0) : s.blur();
      }
    };
    return n || i.addEventListener("keydown", o, !0), () => {
      n || i.removeEventListener("keydown", o, !0);
    };
  }, [
    e,
    t,
    n
  ]), ht(() => {
    const i = st(e.current ? e.current[0] : void 0);
    if (!t) return;
    let o = cn.getTreeNode(e);
    if (o)
      return o.nodeToRestore = r.current ?? void 0, () => {
        let a = cn.getTreeNode(e);
        if (!a) return;
        let s = a.nodeToRestore, l = Vt(i);
        if (t && s && (l && wo(l, e) || l === i.body && fx(e))) {
          let u = cn.clone();
          requestAnimationFrame(() => {
            if (i.activeElement === i.body) {
              let c = u.getTreeNode(e);
              for (; c; ) {
                if (c.nodeToRestore && c.nodeToRestore.isConnected) {
                  dx(c.nodeToRestore);
                  return;
                }
                c = c.parent;
              }
              for (c = u.getTreeNode(e); c; ) {
                if (c.scopeRef && // TODO: this is probably a false positive based on naming, it's not a real ref, rename.
                // oxlint-disable-next-line react-hooks/exhaustive-deps
                c.scopeRef.current && cn.getTreeNode(c.scopeRef)) {
                  let f = AP(c.scopeRef.current, !0);
                  dx(f);
                  return;
                }
                c = c.parent;
              }
            }
          });
        }
      };
  }, [
    e,
    t
  ]);
}
function dx(e) {
  e.dispatchEvent(new CustomEvent(og, {
    bubbles: !0,
    cancelable: !0
  })) && zi(e);
}
function Li(e, t, n) {
  let r = t?.tabbable ? BT : KT, i = e?.nodeType === Node.ELEMENT_NODE ? e : null, o = st(i), a = kP(o, e || o, NodeFilter.SHOW_ELEMENT, {
    acceptNode(s) {
      return Je(t?.from, s) || t?.tabbable && s.tagName === "INPUT" && s.getAttribute("type") === "radio" && (!c9(s) || a.currentNode.tagName === "INPUT" && a.currentNode.type === "radio" && a.currentNode.name === s.name) ? NodeFilter.FILTER_REJECT : r(s) && (!n || Mr(s, n)) && (!t?.accept || t.accept(s)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return t?.from && (a.currentNode = t.from), a;
}
class Db {
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new sg({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(t) {
    return this.fastMap.get(t);
  }
  addTreeNode(t, n, r) {
    let i = this.fastMap.get(n ?? null);
    if (!i) return;
    let o = new sg({
      scopeRef: t
    });
    i.addChild(o), o.parent = i, this.fastMap.set(t, o), r && (o.nodeToRestore = r);
  }
  addNode(t) {
    this.fastMap.set(t.scopeRef, t);
  }
  removeTreeNode(t) {
    if (t === null) return;
    let n = this.fastMap.get(t);
    if (!n) return;
    let r = n.parent;
    for (let o of this.traverse()) o !== n && n.nodeToRestore && o.nodeToRestore && n.scopeRef && n.scopeRef.current && Mr(o.nodeToRestore, n.scopeRef.current) && (o.nodeToRestore = n.nodeToRestore);
    let i = n.children;
    r && (r.removeChild(n), i.size > 0 && i.forEach((o) => r && r.addChild(o))), this.fastMap.delete(n.scopeRef);
  }
  // Pre Order Depth First
  *traverse(t = this.root) {
    if (t.scopeRef != null && (yield t), t.children.size > 0) for (let n of t.children) yield* this.traverse(n);
  }
  clone() {
    let t = new Db();
    for (let n of this.traverse()) t.addTreeNode(n.scopeRef, n.parent?.scopeRef ?? null, n.nodeToRestore);
    return t;
  }
}
class sg {
  constructor(t) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = t.scopeRef;
  }
  addChild(t) {
    this.children.add(t), t.parent = this;
  }
  removeChild(t) {
    this.children.delete(t), t.parent = void 0;
  }
}
let cn = new Db();
function lg(e) {
  return Sz() ? e.altKey : e.ctrlKey;
}
function da(e, t) {
  let n = `[data-key="${CSS.escape(String(t))}"]`, r = e.current?.dataset.collection;
  return r && (n = `[data-collection="${CSS.escape(r)}"]${n}`), e.current?.querySelector(n);
}
const CP = /* @__PURE__ */ new WeakMap();
function m9(e) {
  let t = Jn();
  return CP.set(e, t), t;
}
function g9(e) {
  return CP.get(e);
}
const px = 1e3;
function IP(e) {
  let { keyboardDelegate: t, selectionManager: n, onTypeSelect: r } = e, i = _e({
    search: "",
    timeout: void 0
  }), o = (s) => {
    if (i.current.search.length > 0 && s.key === " ") {
      if (s.preventDefault(), (!("continuePropagation" in s) || "continuePropagation" in s && !s.isPropagationStopped()) && s.stopPropagation(), i.current.search += " ", t.getKeyForSearch != null) {
        let l = t.getKeyForSearch(i.current.search, n.focusedKey);
        l == null && (l = t.getKeyForSearch(i.current.search)), l != null && (n.setFocusedKey(l), r && r(l));
      }
      clearTimeout(i.current.timeout), i.current.timeout = setTimeout(() => {
        i.current.search = "";
      }, px);
    }
  }, a = (s) => {
    let l = y9(s.key);
    if (!(!l || s.ctrlKey || s.metaKey || s.altKey || !Je(s.currentTarget, Ae(s)) || i.current.search.length === 0 && l === " ")) {
      if (i.current.search += l, t.getKeyForSearch != null) {
        let u = t.getKeyForSearch(i.current.search, n.focusedKey);
        if (u == null && (u = t.getKeyForSearch(i.current.search)), u != null)
          n.setFocusedKey(u), r && r(u), s.preventDefault(), "continuePropagation" in s || s.stopPropagation();
        else {
          i.current.search = "", clearTimeout(i.current.timeout), i.current.timeout = void 0;
          return;
        }
      }
      clearTimeout(i.current.timeout), i.current.timeout = setTimeout(() => {
        i.current.search = "";
      }, px);
    }
  };
  return Ee(() => {
    let s = i.current.timeout;
    return () => {
      clearTimeout(s);
    };
  }, [
    i
  ]), {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: t.getKeyForSearch ? o : void 0,
      onKeyDown: t.getKeyForSearch ? a : void 0
    }
  };
}
function y9(e) {
  return e.length === 1 || !/^[A-Z]/i.test(e) ? e : "";
}
function hx(e, t) {
  const n = _e(!0), r = _e(null);
  ht(() => (n.current = !0, () => {
    n.current = !1;
  }), []), ht(() => {
    n.current ? n.current = !1 : (!r.current || t.some((i, o) => !Object.is(i, r[o]))) && e(), r.current = t;
  }, t);
}
function b9(e) {
  let { selectionManager: t, keyboardDelegate: n, ref: r, autoFocus: i = !1, shouldFocusWrap: o = !1, disallowEmptySelection: a = !1, disallowSelectAll: s = !1, escapeKeyBehavior: l = "clearSelection", selectOnFocus: u = t.selectionBehavior === "replace", disallowTypeAhead: c = !1, shouldUseVirtualFocus: f, allowsTabNavigation: d = !1, scrollRef: p = r, linkBehavior: h = "action", UNSTABLE_focusOnEntry: v } = e, { direction: m } = ol(), g = bp(), _ = (z) => {
    if (z.altKey && z.key === "Tab" && z.preventDefault(), !r.current || !Je(r.current, Ae(z))) return;
    const B = (q, M) => {
      if (q != null) {
        if (t.isLink(q) && h === "selection" && u && !lg(z)) {
          Sy(() => {
            t.setFocusedKey(q, M);
          });
          let N = da(r, q), Y = t.getItemProps(q);
          N && g.open(N, z, Y.href, Y.routerOptions);
          return;
        }
        if (t.setFocusedKey(q, M), t.isLink(q) && h === "override") return;
        z.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(q) : u && !lg(z) && t.replaceSelection(q);
      }
    };
    switch (z.key) {
      case "ArrowDown":
        if (n.getKeyBelow) {
          let q = t.focusedKey != null ? n.getKeyBelow?.(t.focusedKey) : n.getFirstKey?.();
          q == null && o && (q = n.getFirstKey?.(t.focusedKey)), q != null && (z.preventDefault(), B(q));
        }
        break;
      case "ArrowUp":
        if (n.getKeyAbove) {
          let q = t.focusedKey != null ? n.getKeyAbove?.(t.focusedKey) : n.getLastKey?.();
          q == null && o && (q = n.getLastKey?.(t.focusedKey)), q != null && (z.preventDefault(), B(q));
        }
        break;
      case "ArrowLeft":
        if (n.getKeyLeftOf) {
          let q = t.focusedKey != null ? n.getKeyLeftOf?.(t.focusedKey) : n.getFirstKey?.();
          q == null && o && (q = m === "rtl" ? n.getFirstKey?.(t.focusedKey) : n.getLastKey?.(t.focusedKey)), q != null && (z.preventDefault(), B(q, m === "rtl" ? "first" : "last"));
        }
        break;
      case "ArrowRight":
        if (n.getKeyRightOf) {
          let q = t.focusedKey != null ? n.getKeyRightOf?.(t.focusedKey) : n.getFirstKey?.();
          q == null && o && (q = m === "rtl" ? n.getLastKey?.(t.focusedKey) : n.getFirstKey?.(t.focusedKey)), q != null && (z.preventDefault(), B(q, m === "rtl" ? "last" : "first"));
        }
        break;
      case "Home":
        if (n.getFirstKey) {
          if (t.focusedKey === null && z.shiftKey) return;
          z.preventDefault();
          let q = n.getFirstKey(t.focusedKey, ns(z));
          t.setFocusedKey(q), q != null && (ns(z) && z.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(q) : u && t.replaceSelection(q));
        }
        break;
      case "End":
        if (n.getLastKey) {
          if (t.focusedKey === null && z.shiftKey) return;
          z.preventDefault();
          let q = n.getLastKey(t.focusedKey, ns(z));
          t.setFocusedKey(q), q != null && (ns(z) && z.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(q) : u && t.replaceSelection(q));
        }
        break;
      case "PageDown":
        if (n.getKeyPageBelow && t.focusedKey != null) {
          let q = n.getKeyPageBelow(t.focusedKey);
          q != null && (z.preventDefault(), B(q));
        }
        break;
      case "PageUp":
        if (n.getKeyPageAbove && t.focusedKey != null) {
          let q = n.getKeyPageAbove(t.focusedKey);
          q != null && (z.preventDefault(), B(q));
        }
        break;
      case "a":
        ns(z) && t.selectionMode === "multiple" && s !== !0 && (z.preventDefault(), t.selectAll());
        break;
      case "Escape":
        l === "clearSelection" && !a && t.selectedKeys.size !== 0 && (z.stopPropagation(), z.preventDefault(), t.clearSelection());
        break;
      case "Tab":
        if (!d) {
          if (z.shiftKey) r.current.focus();
          else {
            let q = Li(r.current, {
              tabbable: !0
            }), M, N;
            do
              N = q.lastChild(), N && (M = N);
            while (N);
            let Y = Vt();
            M && (!hd(M) || Y && !BT(Y)) && oi(M);
          }
          break;
        }
    }
  }, w = _e({
    top: 0,
    left: 0
  });
  Qc(p, "scroll", () => {
    w.current = {
      top: p.current?.scrollTop ?? 0,
      left: p.current?.scrollLeft ?? 0
    };
  });
  let x = (z) => {
    if (t.isFocused) {
      Je(z.currentTarget, Ae(z)) || t.setFocused(!1);
      return;
    }
    if (!Je(z.currentTarget, Ae(z))) return;
    let B = Ru();
    t.setFocused(!0);
    let q = (M) => {
      M != null && (t.setFocusedKey(M), u && !t.isSelected(M) && t.replaceSelection(M));
    };
    if (v && (B === "keyboard" || B === "virtual"))
      q(v === "first" ? n.getFirstKey?.() : n.getLastKey?.());
    else if (t.focusedKey == null) {
      let M = z.relatedTarget;
      M && z.currentTarget.compareDocumentPosition(M) & Node.DOCUMENT_POSITION_FOLLOWING ? q(t.lastSelectedKey ?? n.getLastKey?.()) : q(t.firstSelectedKey ?? n.getFirstKey?.());
    } else p.current && (p.current.scrollTop = w.current.top, p.current.scrollLeft = w.current.left);
    if (t.focusedKey != null && p.current) {
      let M = da(r, t.focusedKey);
      M instanceof HTMLElement && (!hd(M) && !f && oi(M), (B === "keyboard" || v && B === "virtual") && ox(M, {
        containingElement: r.current
      }));
    }
  }, S = (z) => {
    Je(z.currentTarget, z.relatedTarget) || t.setFocused(!1);
  }, $ = _e(!1);
  Qc(r, uz, f ? (z) => {
    let { detail: B } = z;
    z.stopPropagation(), t.setFocused(!0), B?.focusStrategy === "first" && ($.current = !0);
  } : void 0);
  let A = n.getFirstKey?.() ?? null;
  hx(() => {
    if ($.current)
      if (A == null) {
        let z = Vt();
        LT(r.current), VT(z, null), t.collection.size > 0 && ($.current = !1);
      } else
        t.setFocusedKey(A), $.current = !1;
  }, [
    A,
    t.collection.size
  ]), hx(() => {
    t.collection.size > 0 && ($.current = !1);
  }, [
    t.focusedKey
  ]), Qc(r, lz, f ? (z) => {
    z.stopPropagation(), t.setFocused(!1), z.detail?.clearFocusKey && t.setFocusedKey(null);
  } : void 0);
  const E = _e(i), y = _e(!1);
  Ee(() => {
    if (E.current) {
      let z = null;
      i === "first" && (z = n.getFirstKey?.() ?? null), i === "last" && (z = n.getLastKey?.() ?? null);
      let B = t.selectedKeys;
      if (B.size) {
        for (let q of B) if (t.canSelectItem(q)) {
          z = q;
          break;
        }
      }
      t.setFocused(!0), t.setFocusedKey(z), z == null && !f && r.current && Rs(r.current), t.collection.size > 0 && (E.current = !1, y.current = !0);
    }
  });
  let b = _e(t.focusedKey), O = _e(null);
  Ee(() => {
    if (t.isFocused && t.focusedKey != null && (t.focusedKey !== b.current || y.current) && p.current && r.current) {
      let z = Ru(), B = da(r, t.focusedKey);
      if (!(B instanceof HTMLElement))
        return;
      (z === "keyboard" || y.current) && (O.current && cancelAnimationFrame(O.current), O.current = requestAnimationFrame(() => {
        p.current && (If(p.current, B), z !== "virtual" && ox(B, {
          containingElement: r.current
        }));
      }));
    }
    !f && t.isFocused && t.focusedKey == null && b.current != null && r.current && Rs(r.current), b.current = t.focusedKey, y.current = !1;
  }), Ee(() => () => {
    O.current && cancelAnimationFrame(O.current);
  }, []), Qc(r, "react-aria-focus-scope-restore", (z) => {
    z.preventDefault(), t.setFocused(!0);
  });
  let k = {
    onKeyDown: _,
    onFocus: x,
    onBlur: S,
    onMouseDown(z) {
      p.current === Ae(z) && z.preventDefault();
    }
  }, { typeSelectProps: I } = IP({
    keyboardDelegate: n,
    selectionManager: t
  });
  c || (k = ut(I, k));
  let T;
  f || (T = t.focusedKey == null ? 0 : -1);
  let V = m9(t.collection);
  return {
    collectionProps: ut(k, {
      tabIndex: T,
      "data-collection": V
    })
  };
}
class vx {
  constructor(t) {
    this.ref = t;
  }
  getItemRect(t) {
    let n = this.ref.current;
    if (!n) return null;
    let r = t != null ? da(this.ref, t) : null;
    if (!r) return null;
    let i = n.getBoundingClientRect(), o = r.getBoundingClientRect();
    return {
      x: o.left - i.left - n.clientLeft + n.scrollLeft,
      y: o.top - i.top - n.clientTop + n.scrollTop,
      width: o.width,
      height: o.height
    };
  }
  getContentSize() {
    let t = this.ref.current;
    return {
      width: t?.scrollWidth ?? 0,
      height: t?.scrollHeight ?? 0
    };
  }
  getVisibleRect() {
    let t = this.ref.current;
    return {
      x: t?.scrollLeft ?? 0,
      y: t?.scrollTop ?? 0,
      width: t?.clientWidth ?? 0,
      height: t?.clientHeight ?? 0
    };
  }
}
class Ab {
  constructor(...t) {
    if (t.length === 1) {
      let n = t[0];
      this.collection = n.collection, this.ref = n.ref, this.collator = n.collator, this.disabledKeys = n.disabledKeys || /* @__PURE__ */ new Set(), this.disabledBehavior = n.disabledBehavior || "all", this.orientation = n.orientation || "vertical", this.direction = n.direction, this.layout = n.layout || "stack", this.layoutDelegate = n.layoutDelegate || new vx(n.ref);
    } else
      this.collection = t[0], this.disabledKeys = t[1], this.ref = t[2], this.collator = t[3], this.layout = "stack", this.orientation = "vertical", this.disabledBehavior = "all", this.layoutDelegate = new vx(this.ref);
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
  isDisabled(t) {
    return this.disabledBehavior === "all" && (t.props?.isDisabled || this.disabledKeys.has(t.key)) && t.props?.disabledBehavior !== "selection";
  }
  findNextNonDisabled(t, n, r = !1) {
    let i = t;
    for (; i != null; ) {
      let o = this.collection.getItem(i);
      if (o?.type === "item" && (r || !this.isDisabled(o))) return i;
      i = n(i);
    }
    return null;
  }
  getNextKey(t, n) {
    let r = t;
    return r = this.collection.getKeyAfter(r), this.findNextNonDisabled(r, (i) => this.collection.getKeyAfter(i), n?.includeDisabled);
  }
  getPreviousKey(t, n) {
    let r = t;
    return r = this.collection.getKeyBefore(r), this.findNextNonDisabled(r, (i) => this.collection.getKeyBefore(i), n?.includeDisabled);
  }
  findKey(t, n, r) {
    let i = t, o = this.layoutDelegate.getItemRect(i);
    if (!o || i == null) return null;
    let a = o;
    do {
      if (i = n(i), i == null) break;
      o = this.layoutDelegate.getItemRect(i);
    } while (o && r(a, o) && i != null);
    return i;
  }
  isSameRow(t, n) {
    return t.y === n.y || t.x !== n.x;
  }
  isSameColumn(t, n) {
    return t.x === n.x || t.y !== n.y;
  }
  // checks to see if the next/prev key is spatially above/below the current key. If not, that means we are in
  // a reversed column layout and need to adjust appropriately
  // TODO: still need to see how this works with virtualizer once there is handling for the reverse layout
  // this felt like a simpler approach then changing getKeyAbove/Below to be purely spatial calculations
  isReversed(t) {
    let n = this.getNextKey(t), r = da(this.ref, t);
    if (n != null) {
      let o = da(this.ref, n);
      return !r || !o ? !1 : r.getBoundingClientRect().top > o.getBoundingClientRect().top;
    }
    let i = this.getPreviousKey(t);
    if (i != null) {
      let o = da(this.ref, i);
      return !r || !o ? !1 : o.getBoundingClientRect().top > r.getBoundingClientRect().top;
    }
    return !1;
  }
  getKeyBelow(t, n) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (r) => this.getNextKey(r, n), this.isSameRow) : this.orientation === "vertical" ? this.isReversed(t) ? this.getPreviousKey(t, n) : this.getNextKey(t, n) : this.getNextKey(t, n);
  }
  getKeyAbove(t, n) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (r) => this.getPreviousKey(r, n), this.isSameRow) : this.orientation === "vertical" ? this.isReversed(t) ? this.getNextKey(t, n) : this.getPreviousKey(t, n) : this.getPreviousKey(t, n);
  }
  getNextColumn(t, n, r) {
    return n ? this.getPreviousKey(t, r) : this.getNextKey(t, r);
  }
  getKeyRightOf(t, n) {
    let r = this.direction === "ltr" ? "getKeyRightOf" : "getKeyLeftOf";
    return this.layoutDelegate[r] ? (t = this.layoutDelegate[r](t), this.findNextNonDisabled(t, (i) => this.layoutDelegate[r](i), n?.includeDisabled)) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "rtl", n) : this.findKey(t, (i) => this.getNextColumn(i, this.direction === "rtl", n), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "rtl", n) : null;
  }
  getKeyLeftOf(t, n) {
    let r = this.direction === "ltr" ? "getKeyLeftOf" : "getKeyRightOf";
    return this.layoutDelegate[r] ? (t = this.layoutDelegate[r](t), this.findNextNonDisabled(t, (i) => this.layoutDelegate[r](i), n?.includeDisabled)) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "ltr", n) : this.findKey(t, (i) => this.getNextColumn(i, this.direction === "ltr", n), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "ltr", n) : null;
  }
  getFirstKey() {
    let t = this.collection.getFirstKey();
    return this.findNextNonDisabled(t, (n) => this.collection.getKeyAfter(n));
  }
  getLastKey() {
    let t = this.collection.getLastKey();
    return this.findNextNonDisabled(t, (n) => this.collection.getKeyBefore(n));
  }
  getKeyPageAbove(t) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(t);
    if (!r) return null;
    let i = this.isReversed(t);
    if (n && !Ms(n)) return this.getFirstKey();
    let o = t;
    if (this.orientation === "horizontal") {
      let a = Math.max(0, r.x + r.width - this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x > a && o != null; )
        o = this.getKeyAbove(o), r = o == null ? null : this.layoutDelegate.getItemRect(o);
    } else {
      let a = this.layoutDelegate.getVisibleRect(), s = i ? r.y - a.height : Math.max(0, r.y + r.height - a.height);
      for (; r && r.y > s && o != null; )
        o = this.getKeyAbove(o), r = o == null ? null : this.layoutDelegate.getItemRect(o);
    }
    return o ?? (i ? this.getLastKey() : this.getFirstKey());
  }
  getKeyPageBelow(t) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(t);
    if (!r) return null;
    let i = this.isReversed(t);
    if (n && !Ms(n)) return this.getLastKey();
    let o = t;
    if (this.orientation === "horizontal") {
      let a = Math.min(this.layoutDelegate.getContentSize().width, r.x - r.width + this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x < a && o != null; )
        o = this.getKeyBelow(o), r = o == null ? null : this.layoutDelegate.getItemRect(o);
    } else {
      let a = Math.min(this.layoutDelegate.getContentSize().height, r.y - r.height + this.layoutDelegate.getVisibleRect().height);
      for (; r && r.y < a && o != null; )
        o = this.getKeyBelow(o), r = o == null ? null : this.layoutDelegate.getItemRect(o);
    }
    return o ?? (i ? this.getFirstKey() : this.getLastKey());
  }
  getKeyForSearch(t, n) {
    if (!this.collator) return null;
    let r = this.collection, i = n || this.getFirstKey();
    for (; i != null; ) {
      let o = r.getItem(i);
      if (!o) return null;
      let a = o.textValue.slice(0, t.length);
      if (o.textValue && this.collator.compare(a, t) === 0) return i;
      i = this.getNextKey(i);
    }
    return null;
  }
}
let av = /* @__PURE__ */ new Map();
function Cb(e) {
  let { locale: t } = ol(), n = t + (e ? Object.entries(e).sort((i, o) => i[0] < o[0] ? -1 : 1).join() : "");
  if (av.has(n)) return av.get(n);
  let r = new Intl.Collator(t, e);
  return av.set(n, r), r;
}
function NP(e) {
  let { selectionManager: t, collection: n, disabledKeys: r, ref: i, keyboardDelegate: o, layoutDelegate: a, orientation: s } = e, l = Cb({
    usage: "search",
    sensitivity: "base"
  }), u = t.disabledBehavior, c = Te(() => o || new Ab({
    collection: n,
    disabledKeys: r,
    disabledBehavior: u,
    ref: i,
    collator: l,
    layoutDelegate: a,
    orientation: s
  }), [
    o,
    a,
    n,
    r,
    i,
    l,
    u,
    s
  ]), { collectionProps: f } = b9({
    ...e,
    ref: i,
    selectionManager: t,
    keyboardDelegate: c
  });
  return {
    listProps: f
  };
}
function _9(e, t, n) {
  let r = kn(e, {
    labelable: !0
  }), i = e.selectionBehavior || "toggle", o = e.orientation || "vertical", a = e.linkBehavior || (i === "replace" ? "action" : "override");
  i === "toggle" && a === "action" && (a = "override");
  let { listProps: s } = NP({
    ...e,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    linkBehavior: a
  }), { focusWithinProps: l } = $p({
    onFocusWithin: e.onFocus,
    onBlurWithin: e.onBlur,
    onFocusWithinChange: e.onFocusChange
  }), u = Jn(e.id);
  Pb.set(t, {
    id: u,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus,
    shouldSelectOnPressUp: e.shouldSelectOnPressUp,
    shouldFocusOnHover: e.shouldFocusOnHover,
    isVirtualized: e.isVirtualized,
    onAction: e.onAction,
    linkBehavior: a,
    // @ts-ignore
    UNSTABLE_itemBehavior: e.UNSTABLE_itemBehavior
  });
  let { labelProps: c, fieldProps: f } = yP({
    ...e,
    id: u,
    // listbox is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  return {
    labelProps: c,
    listBoxProps: ut(r, l, t.selectionManager.selectionMode === "multiple" ? {
      "aria-multiselectable": "true"
    } : {}, {
      role: "listbox",
      "aria-orientation": o,
      ...ut(f, s)
    })
  };
}
const w9 = 500;
function RP(e) {
  let { isDisabled: t, onLongPressStart: n, onLongPressEnd: r, onLongPress: i, threshold: o = w9, accessibilityDescription: a } = e;
  const s = _e(void 0);
  let { addGlobalListener: l, removeGlobalListener: u } = Sp(), { pressProps: c } = Op({
    isDisabled: t,
    onPressStart(d) {
      if (d.continuePropagation(), (d.pointerType === "mouse" || d.pointerType === "touch") && (n && n({
        ...d,
        type: "longpressstart"
      }), s.current = setTimeout(() => {
        d.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), st(d.target).activeElement !== d.target && oi(d.target), i && i({
          ...d,
          type: "longpress"
        }), s.current = void 0;
      }, o), d.pointerType === "touch")) {
        let p = (v) => {
          v.preventDefault();
        }, h = Tn(d.target);
        l(d.target, "contextmenu", p, {
          once: !0
        }), l(h, "pointerup", () => {
          setTimeout(() => {
            u(d.target, "contextmenu", p);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(d) {
      s.current && clearTimeout(s.current), r && (d.pointerType === "mouse" || d.pointerType === "touch") && r({
        ...d,
        type: "longpressend"
      });
    }
  }), f = zL(i && !t ? a : void 0);
  return {
    longPressProps: ut(c, f)
  };
}
function MP(e) {
  let { id: t, selectionManager: n, key: r, ref: i, shouldSelectOnPressUp: o, shouldUseVirtualFocus: a, focus: s, isDisabled: l, onAction: u, allowsDifferentPressOrigin: c, linkBehavior: f = "action" } = e, d = bp();
  t = Jn(t);
  let p = (N) => {
    if (N.pointerType === "keyboard" && lg(N)) n.toggleSelection(r);
    else {
      if (n.selectionMode === "none") return;
      if (n.isLink(r)) {
        if (f === "selection" && i.current) {
          let Y = n.getItemProps(r);
          d.open(i.current, N, Y.href, Y.routerOptions), n.setSelectedKeys(n.selectedKeys);
          return;
        } else if (f === "override" || f === "none") return;
      }
      n.selectionMode === "single" ? n.isSelected(r) && !n.disallowEmptySelection ? n.toggleSelection(r) : n.replaceSelection(r) : N && N.shiftKey ? n.extendSelection(r) : n.selectionBehavior === "toggle" || N && (ns(N) || N.pointerType === "touch" || N.pointerType === "virtual") ? n.toggleSelection(r) : n.replaceSelection(r);
    }
  };
  Ee(() => {
    r === n.focusedKey && n.isFocused && (a ? LT(i.current) : s ? s() : Vt() !== i.current && i.current && Rs(i.current));
  }, [
    i,
    r,
    n.focusedKey,
    n.childFocusStrategy,
    n.isFocused,
    a
  ]), l = l || n.isDisabled(r);
  let h = {};
  !a && !l ? h = {
    tabIndex: r === n.focusedKey ? 0 : -1,
    onFocus(N) {
      Ae(N) === i.current && n.setFocusedKey(r);
    }
  } : l && (h.onMouseDown = (N) => {
    N.preventDefault();
  }), Ee(() => {
    l && n.focusedKey === r && n.setFocusedKey(null);
  }, [
    n,
    l,
    r
  ]);
  let v = n.isLink(r) && f === "override", m = u && e.UNSTABLE_itemBehavior === "action", g = n.isLink(r) && f !== "selection" && f !== "none", _ = !l && n.canSelectItem(r) && !v && !m, w = (u || g) && !l, x = w && (n.selectionBehavior === "replace" ? !_ : !_ || n.isEmpty), S = w && _ && n.selectionBehavior === "replace", $ = x || S, A = _e(null), E = $ && _, y = _e(!1), b = _e(!1), O = n.getItemProps(r), k = (N) => {
    u && (u(), i.current?.dispatchEvent(new CustomEvent("react-aria-item-action", {
      bubbles: !0
    }))), g && i.current && d.open(i.current, N, O.href, O.routerOptions);
  }, I = {
    ref: i
  };
  if (o ? (I.onPressStart = (N) => {
    A.current = N.pointerType, y.current = E, N.pointerType === "keyboard" && (!$ || gx(N.key)) && p(N);
  }, c ? (I.onPressUp = x ? void 0 : (N) => {
    N.pointerType === "mouse" && _ && p(N);
  }, I.onPress = x ? k : (N) => {
    N.pointerType !== "keyboard" && N.pointerType !== "mouse" && _ && p(N);
  }) : I.onPress = (N) => {
    if (x || S && N.pointerType !== "mouse") {
      if (N.pointerType === "keyboard" && !mx(N.key)) return;
      k(N);
    } else N.pointerType !== "keyboard" && _ && p(N);
  }) : (I.onPressStart = (N) => {
    A.current = N.pointerType, y.current = E, b.current = x, _ && (N.pointerType === "mouse" && !x || N.pointerType === "keyboard" && (!w || gx(N.key))) && p(N);
  }, I.onPress = (N) => {
    (N.pointerType === "touch" || N.pointerType === "pen" || N.pointerType === "virtual" || N.pointerType === "keyboard" && $ && mx(N.key) || N.pointerType === "mouse" && b.current) && ($ ? k(N) : _ && p(N));
  }), h["data-collection"] = g9(n.collection), h["data-key"] = r, I.preventFocusOnPress = a, a && (I = ut(I, {
    onPressStart(N) {
      N.pointerType !== "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    },
    onPress(N) {
      N.pointerType === "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    }
  })), O)
    for (let N of [
      "onPressStart",
      "onPressEnd",
      "onPressChange",
      "onPress",
      "onPressUp",
      "onClick"
    ]) O[N] && (I[N] = Ra(I[N], O[N]));
  let { pressProps: T, isPressed: V } = Op(I), z = S ? (N) => {
    A.current === "mouse" && (N.stopPropagation(), N.preventDefault(), k(N));
  } : void 0, { longPressProps: B } = RP({
    isDisabled: !E,
    onLongPress(N) {
      N.pointerType === "touch" && (p(N), n.setSelectionBehavior("toggle"));
    }
  }), q = (N) => {
    A.current === "touch" && y.current && N.preventDefault();
  }, M = f !== "none" && n.isLink(r) ? (N) => {
    Zi.isOpening || N.preventDefault();
  } : void 0;
  return {
    itemProps: ut(
      h,
      _ || x || a && !l ? T : {},
      E ? B : {},
      {
        onDoubleClick: z,
        onDragStartCapture: q,
        onClick: M,
        id: t
      },
      // Prevent DOM focus from moving on mouse down when using virtual focus
      a ? {
        onMouseDown: (N) => N.preventDefault()
      } : void 0
    ),
    isPressed: V,
    isSelected: n.isSelected(r),
    isFocused: n.isFocused && n.focusedKey === r,
    isDisabled: l,
    allowsSelection: _,
    hasAction: $
  };
}
function mx(e) {
  return e === "Enter";
}
function gx(e) {
  return e === " ";
}
function jP(e, t) {
  return typeof t.getChildren == "function" ? t.getChildren(e.key) : e.childNodes;
}
function x9(e) {
  return E9(e);
}
function E9(e, t) {
  for (let n of e)
    return n;
}
function sv(e, t, n) {
  if (t.parentKey === n.parentKey) return t.index - n.index;
  let r = [
    ...yx(e, t),
    t
  ], i = [
    ...yx(e, n),
    n
  ], o = r.slice(0, i.length).findIndex((a, s) => a !== i[s]);
  return o !== -1 ? (t = r[o], n = i[o], t.index - n.index) : r.findIndex((a) => a === n) >= 0 ? 1 : (i.findIndex((a) => a === t) >= 0, -1);
}
function yx(e, t) {
  let n = [], r = t;
  for (; r?.parentKey != null; )
    r = e.getItem(r.parentKey), r && n.unshift(r);
  return n;
}
const bx = /* @__PURE__ */ new WeakMap();
function FP(e) {
  let t = bx.get(e);
  if (t != null) return t;
  let n = 0, r = (i) => {
    for (let o of i)
      o.type === "section" ? r(jP(o, e)) : o.type === "item" && n++;
  };
  return r(e), bx.set(e, n), n;
}
function S9(e, t, n) {
  let { key: r } = e, i = Pb.get(t), o = e.isDisabled ?? t.selectionManager.isDisabled(r), a = e.isSelected ?? t.selectionManager.isSelected(r), s = e.shouldSelectOnPressUp ?? i?.shouldSelectOnPressUp, l = e.shouldFocusOnHover ?? i?.shouldFocusOnHover, u = e.shouldUseVirtualFocus ?? i?.shouldUseVirtualFocus, c = e.isVirtualized ?? i?.isVirtualized, f = fa(), d = fa(), p = {
    role: "option",
    "aria-disabled": o || void 0,
    "aria-selected": t.selectionManager.selectionMode !== "none" ? a : void 0,
    "aria-label": e["aria-label"],
    "aria-labelledby": f,
    "aria-describedby": d
  }, h = t.collection.getItem(r);
  if (c) {
    let y = Number(h?.index);
    p["aria-posinset"] = Number.isNaN(y) ? void 0 : y + 1, p["aria-setsize"] = FP(t.collection);
  }
  let v = i?.onAction ? () => i?.onAction?.(r) : void 0, m = a9(t, r), { itemProps: g, isPressed: _, isFocused: w, hasAction: x, allowsSelection: S } = MP({
    selectionManager: t.selectionManager,
    key: r,
    ref: n,
    shouldSelectOnPressUp: s,
    allowsDifferentPressOrigin: s && l,
    isVirtualized: c,
    shouldUseVirtualFocus: u,
    isDisabled: o,
    onAction: v || h?.props?.onAction ? Ra(h?.props?.onAction, v) : void 0,
    linkBehavior: i?.linkBehavior,
    // @ts-ignore
    UNSTABLE_itemBehavior: i?.UNSTABLE_itemBehavior,
    id: m
  }), { hoverProps: $ } = ll({
    isDisabled: o || !l,
    onHoverStart() {
      _a() || (t.selectionManager.setFocused(!0), t.selectionManager.setFocusedKey(r));
    }
  }), A = kn(h?.props);
  delete A.id;
  let E = YT(h?.props);
  return {
    optionProps: {
      ...p,
      ...ut(A, g, $, E),
      id: m
    },
    labelProps: {
      id: f
    },
    descriptionProps: {
      id: d
    },
    isFocused: w,
    isFocusVisible: w && t.selectionManager.isFocused && _a(),
    isSelected: a,
    isDisabled: o,
    isPressed: _,
    allowsSelection: S,
    hasAction: x
  };
}
function O9(e) {
  let { heading: t, "aria-label": n } = e, r = Jn();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Technically, listbox cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a visual label for the nested group.
      id: r,
      role: "presentation",
      onMouseDown: (i) => {
        i.preventDefault();
      }
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": t ? r : void 0
    }
  };
}
function $9(e) {
  const t = W3.split(".");
  return parseInt(t[0], 10) >= 19 ? e : e ? "true" : void 0;
}
class _x {
  constructor(t) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = t;
    let n = (a) => {
      if (this.keyMap.set(a.key, a), a.childNodes && a.type === "section") for (let s of a.childNodes) n(s);
    };
    for (let a of t) n(a);
    let r = null, i = 0, o = 0;
    for (let [a, s] of this.keyMap)
      r ? (r.nextKey = a, s.prevKey = r.key) : (this.firstKey = a, s.prevKey = void 0), s.type === "item" && (s.index = i++), (s.type === "section" || s.type === "item") && o++, r = s, r.nextKey = void 0;
    this._size = o, this.lastKey = r?.key ?? null;
  }
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this._size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    return n ? n.prevKey ?? null : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    return n ? n.nextKey ?? null : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    return this.keyMap.get(t) ?? null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  getChildren(t) {
    return this.keyMap.get(t)?.childNodes || [];
  }
}
class Gr extends Set {
  constructor(t, n, r) {
    super(t), t instanceof Gr ? (this.anchorKey = n ?? t.anchorKey, this.currentKey = r ?? t.currentKey) : (this.anchorKey = n ?? null, this.currentKey = r ?? null);
  }
}
function T9(e, t) {
  if (e.size !== t.size) return !1;
  for (let n of e)
    if (!t.has(n)) return !1;
  return !0;
}
function Ib(e) {
  let { selectionMode: t = "none", disallowEmptySelection: n = !1, allowDuplicateSelectionEvents: r, selectionBehavior: i = "toggle", disabledBehavior: o = "all" } = e, a = _e(!1), [, s] = Ve(!1), l = _e(null), u = _e(null), [, c] = Ve(null), f = Te(() => wx(e.selectedKeys), [
    e.selectedKeys
  ]), d = Te(() => wx(e.defaultSelectedKeys, new Gr()), [
    e.defaultSelectedKeys
  ]), [p, h] = xp(f, d, e.onSelectionChange), v = Te(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), [m, g] = Ve(i);
  i === "replace" && m === "toggle" && typeof p == "object" && p.size === 0 && g("replace");
  let _ = _e(i);
  return Ee(() => {
    i !== _.current && (g(i), _.current = i);
  }, [
    i
  ]), {
    selectionMode: t,
    disallowEmptySelection: n,
    selectionBehavior: m,
    setSelectionBehavior: g,
    get isFocused() {
      return a.current;
    },
    setFocused(w) {
      a.current = w, s(w);
    },
    get focusedKey() {
      return l.current;
    },
    get childFocusStrategy() {
      return u.current;
    },
    setFocusedKey(w, x = "first") {
      l.current = w, u.current = x, c(w);
    },
    selectedKeys: p,
    setSelectedKeys(w) {
      (r || !T9(w, p)) && h(w);
    },
    disabledKeys: v,
    disabledBehavior: o
  };
}
function wx(e, t) {
  return e ? e === "all" ? "all" : new Gr(e) : t;
}
class gc {
  constructor(t, n, r) {
    this.collection = t, this.state = n, this.allowsCellSelection = r?.allowsCellSelection ?? !1, this._isSelectAll = null, this.layoutDelegate = r?.layoutDelegate || null, this.fullCollection = r?.fullCollection || null;
  }
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(t) {
    this.state.setSelectionBehavior(t);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(t) {
    this.state.setFocused(t);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(t, n) {
    (t == null || this.collection.getItem(t)) && this.state.setFocusedKey(t, n);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(t) {
    if (this.state.selectionMode === "none") return !1;
    let n = this.getKey(t);
    return n == null ? !1 : this.state.selectedKeys === "all" ? this.canSelectItem(n) : this.state.selectedKeys.has(n);
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty) return !1;
    if (this.state.selectedKeys === "all") return !0;
    if (this._isSelectAll != null) return this._isSelectAll;
    let t = this.getSelectAllKeys(), n = this.state.selectedKeys;
    return this._isSelectAll = t.every((r) => n.has(r)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let t = null;
    for (let n of this.state.selectedKeys) {
      let r = this.collection.getItem(n);
      (!t || r && sv(this.collection, r, t) < 0) && (t = r);
    }
    return t?.key ?? null;
  }
  get lastSelectedKey() {
    let t = null;
    for (let n of this.state.selectedKeys) {
      let r = this.collection.getItem(n);
      (!t || r && sv(this.collection, r, t) > 0) && (t = r);
    }
    return t?.key ?? null;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(t) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single") {
      this.replaceSelection(t);
      return;
    }
    let n = this.getKey(t);
    if (n == null) return;
    let r;
    if (this.state.selectedKeys === "all") r = new Gr([
      n
    ], n, n);
    else {
      let i = this.state.selectedKeys, o = i.anchorKey ?? n;
      r = new Gr(i, o, n);
      for (let a of this.getKeyRange(o, i.currentKey ?? n)) r.delete(a);
      for (let a of this.getKeyRange(n, o)) this.canSelectItem(a) && r.add(a);
    }
    this.state.setSelectedKeys(r);
  }
  getKeyRange(t, n) {
    let r = this.collection.getItem(t), i = this.collection.getItem(n);
    return r && i ? sv(this.collection, r, i) <= 0 ? this.getKeyRangeInternal(t, n) : this.getKeyRangeInternal(n, t) : [];
  }
  getKeyRangeInternal(t, n) {
    if (this.layoutDelegate?.getKeyRange) return this.layoutDelegate.getKeyRange(t, n);
    let r = [], i = t;
    for (; i != null; ) {
      let o = this.collection.getItem(i);
      if (o && (o.type === "item" || o.type === "cell" && this.allowsCellSelection) && r.push(i), i === n) return r;
      i = this.collection.getKeyAfter(i);
    }
    return [];
  }
  getKey(t) {
    let n = this.collection.getItem(t);
    if (!n || n.type === "cell" && this.allowsCellSelection) return t;
    for (; n && n.type !== "item" && n.parentKey != null; ) n = this.collection.getItem(n.parentKey);
    return !n || n.type !== "item" ? null : n.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(t) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single" && !this.isSelected(t)) {
      this.replaceSelection(t);
      return;
    }
    let n = this.getKey(t);
    if (n == null) return;
    let r = new Gr(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    r.has(n) ? r.delete(n) : this.canSelectItem(n) && (r.add(n), r.anchorKey = n, r.currentKey = n), !(this.disallowEmptySelection && r.size === 0) && this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(t) {
    if (this.selectionMode === "none") return;
    let n = this.getKey(t);
    if (n == null) return;
    let r = this.canSelectItem(n) ? new Gr([
      n
    ], n, n) : new Gr();
    this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(t) {
    if (this.selectionMode === "none") return;
    let n = new Gr();
    for (let r of t) {
      let i = this.getKey(r);
      if (i != null && (n.add(i), this.selectionMode === "single"))
        break;
    }
    this.state.setSelectedKeys(n);
  }
  getSelectAllKeys() {
    let t = this.fullCollection ?? this.collection, n = [], r = (i) => {
      for (; i != null; ) {
        if (this.canSelectItemIn(i, t)) {
          let o = t.getItem(i);
          o?.type === "item" && n.push(i), o?.hasChildNodes && (this.allowsCellSelection || o.type !== "item") && r(x9(jP(o, t))?.key ?? null);
        }
        i = t.getKeyAfter(i);
      }
    };
    return r(t.getFirstKey()), n;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new Gr());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(t, n) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(t) && !this.disallowEmptySelection ? this.toggleSelection(t) : this.replaceSelection(t) : this.selectionBehavior === "toggle" || n && (n.pointerType === "touch" || n.pointerType === "virtual") ? this.toggleSelection(t) : this.replaceSelection(t));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(t) {
    if (t === this.state.selectedKeys) return !0;
    let n = this.selectedKeys;
    if (t.size !== n.size) return !1;
    for (let r of t)
      if (!n.has(r)) return !1;
    for (let r of n)
      if (!t.has(r)) return !1;
    return !0;
  }
  canSelectItem(t) {
    return this.canSelectItemIn(t, this.collection);
  }
  canSelectItemIn(t, n) {
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(t)) return !1;
    let r = n.getItem(t);
    return !(!r || r?.props?.isDisabled || r.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(t) {
    let n = this.collection.getItem(t);
    return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(t) || !!n?.props?.isDisabled) && n?.props?.disabledBehavior !== "selection";
  }
  isLink(t) {
    return !!this.collection.getItem(t)?.props?.href;
  }
  getItemProps(t) {
    return this.collection.getItem(t)?.props;
  }
  withCollection(t) {
    return new gc(t, this.state, {
      allowsCellSelection: this.allowsCellSelection,
      layoutDelegate: this.layoutDelegate || void 0,
      fullCollection: this.fullCollection ?? this.collection
    });
  }
}
class P9 {
  build(t, n) {
    return this.context = n, xx(() => this.iterateCollection(t));
  }
  *iterateCollection(t) {
    let { children: n, items: r } = t;
    if (H.isValidElement(n) && n.type === H.Fragment) yield* this.iterateCollection({
      children: n.props.children,
      items: r
    });
    else if (typeof n == "function") {
      if (!r) throw new Error("props.children was a function but props.items is missing");
      let i = 0;
      for (let o of r)
        yield* this.getFullNode({
          value: o,
          index: i
        }, {
          renderer: n
        }), i++;
    } else {
      let i = [];
      H.Children.forEach(n, (a) => {
        a && i.push(a);
      });
      let o = 0;
      for (let a of i) {
        let s = this.getFullNode({
          element: a,
          index: o
        }, {});
        for (let l of s)
          o++, yield l;
      }
    }
  }
  getKey(t, n, r, i) {
    if (t.key != null) return t.key;
    if (n.type === "cell" && n.key != null) return `${i}${n.key}`;
    let o = n.value;
    if (o != null) {
      let a = o.key ?? o.id;
      if (a == null) throw new Error("No key found for item");
      return a;
    }
    return i ? `${i}.${n.index}` : `$.${n.index}`;
  }
  getChildState(t, n) {
    return {
      renderer: n.renderer || t.renderer
    };
  }
  *getFullNode(t, n, r, i) {
    if (H.isValidElement(t.element) && t.element.type === H.Fragment) {
      let l = [];
      H.Children.forEach(t.element.props.children, (c) => {
        l.push(c);
      });
      let u = t.index ?? 0;
      for (const c of l) yield* this.getFullNode({
        element: c,
        index: u++
      }, n, r, i);
      return;
    }
    let o = t.element;
    if (!o && t.value && n && n.renderer) {
      let l = this.cache.get(t.value);
      if (l && (!l.shouldInvalidate || !l.shouldInvalidate(this.context))) {
        l.index = t.index, l.parentKey = i ? i.key : null, yield l;
        return;
      }
      o = n.renderer(t.value);
    }
    if (H.isValidElement(o)) {
      let l = o.type;
      if (typeof l != "function" && typeof l.getCollectionNode != "function") {
        let d = o.type;
        throw new Error(`Unknown element <${d}> in collection.`);
      }
      let u = l.getCollectionNode(o.props, this.context), c = t.index ?? 0, f = u.next();
      for (; !f.done && f.value; ) {
        let d = f.value;
        t.index = c;
        let p = d.key ?? null;
        p == null && (p = d.element ? null : this.getKey(o, t, n, r));
        let v = [
          ...this.getFullNode({
            ...d,
            key: p,
            index: c,
            wrapper: k9(t.wrapper, d.wrapper)
          }, this.getChildState(n, d), r ? `${r}${o.key}` : o.key, i)
        ];
        for (let m of v) {
          if (m.value = d.value ?? t.value ?? null, m.value && this.cache.set(m.value, m), t.type && m.type !== t.type) throw new Error(`Unsupported type <${lv(m.type)}> in <${lv(i?.type ?? "unknown parent type")}>. Only <${lv(t.type)}> is supported.`);
          c++, yield m;
        }
        f = u.next(v);
      }
      return;
    }
    if (t.key == null || t.type == null) return;
    let a = this, s = {
      type: t.type,
      props: t.props,
      key: t.key,
      parentKey: i ? i.key : null,
      value: t.value ?? null,
      level: (i?.level ?? 0) + (i?.type === "item" ? 1 : 0),
      index: t.index,
      rendered: t.rendered,
      textValue: t.textValue ?? "",
      "aria-label": t["aria-label"],
      wrapper: t.wrapper,
      shouldInvalidate: t.shouldInvalidate,
      hasChildNodes: t.hasChildNodes || !1,
      childNodes: xx(function* () {
        if (!t.hasChildNodes || !t.childNodes) return;
        let l = 0;
        for (let u of t.childNodes()) {
          u.key != null && (u.key = `${s.key}${u.key}`);
          let c = a.getFullNode({
            ...u,
            index: l
          }, a.getChildState(n, u), s.key, s);
          for (let f of c)
            l++, yield f;
        }
      })
    };
    yield s;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function xx(e) {
  let t = [], n = null;
  return {
    *[Symbol.iterator]() {
      for (let r of t) yield r;
      n || (n = e());
      for (let r of n)
        t.push(r), yield r;
    }
  };
}
function k9(e, t) {
  if (e && t) return (n) => e(t(n));
  if (e) return e;
  if (t) return t;
}
function lv(e) {
  return e[0].toUpperCase() + e.slice(1);
}
function zP(e, t, n) {
  let r = Te(() => new P9(), []), { children: i, items: o, collection: a } = e;
  return Te(() => {
    if (a) return a;
    let l = r.build({
      children: i,
      items: o
    }, n);
    return t(l);
  }, [
    r,
    i,
    o,
    a,
    n,
    t
  ]);
}
function LP(e) {
  let { filter: t, layoutDelegate: n } = e, r = Ib(e), i = Te(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), o = Le((u) => t ? new _x(t(u)) : new _x(u), [
    t
  ]), a = Te(() => ({
    suppressTextValueWarning: e.suppressTextValueWarning
  }), [
    e.suppressTextValueWarning
  ]), s = zP(e, o, a), l = Te(() => new gc(s, r, {
    layoutDelegate: n
  }), [
    s,
    r,
    n
  ]);
  return VP(s, l), {
    collection: s,
    disabledKeys: i,
    selectionManager: l
  };
}
function D9(e, t) {
  let n = Te(() => t ? e.collection.filter(t) : e.collection, [
    e.collection,
    t
  ]), r = e.selectionManager.withCollection(n);
  return VP(n, r), {
    collection: n,
    selectionManager: r,
    disabledKeys: e.disabledKeys
  };
}
function VP(e, t) {
  const n = _e(null);
  Ee(() => {
    if (t.focusedKey != null && !e.getItem(t.focusedKey) && n.current) {
      let r = n.current.getKeyAfter(t.focusedKey), i = null;
      for (; r != null; ) {
        let o = e.getItem(r);
        if (o && o.type === "item" && !t.isDisabled(r)) {
          i = r;
          break;
        }
        r = n.current.getKeyAfter(r);
      }
      if (i == null)
        for (r = n.current.getKeyBefore(t.focusedKey); r != null; ) {
          let o = e.getItem(r);
          if (o && o.type === "item" && !t.isDisabled(r)) {
            i = r;
            break;
          }
          r = n.current.getKeyBefore(r);
        }
      t.setFocusedKey(i);
    }
    n.current = e;
  }, [
    e,
    t
  ]);
}
function A9(e, t) {
  let { collection: n, onLoadMore: r, scrollOffset: i = 1 } = e, o = _e(null), a = Cr((s) => {
    for (let l of s)
      l.isIntersecting && r && r();
  });
  ht(() => (t.current && (o.current = new IntersectionObserver(a, {
    root: Tb(t?.current),
    rootMargin: `0px ${100 * i}% ${100 * i}% ${100 * i}%`
  }), o.current.observe(t.current)), () => {
    o.current && o.current.disconnect();
  }), [
    n,
    t,
    i
  ]);
}
const Nb = /* @__PURE__ */ He(null), ul = /* @__PURE__ */ He(null), C9 = /* @__PURE__ */ fn(function(t, n) {
  [t, n] = Ai(t, n, Nb);
  let r = Me(ul);
  return r ? /* @__PURE__ */ H.createElement(KP, {
    state: r,
    props: t,
    listBoxRef: n
  }) : /* @__PURE__ */ H.createElement(wb, {
    content: /* @__PURE__ */ H.createElement(hP, t)
  }, (i) => /* @__PURE__ */ H.createElement(I9, {
    props: t,
    listBoxRef: n,
    collection: i
  }));
});
function I9({ props: e, listBoxRef: t, collection: n }) {
  e = {
    ...e,
    collection: n,
    children: null,
    items: null
  };
  let { layoutDelegate: r } = Me(sl), i = LP({
    ...e,
    layoutDelegate: r
  });
  return /* @__PURE__ */ H.createElement(KP, {
    state: i,
    props: e,
    listBoxRef: t
  });
}
function KP({ state: e, props: t, listBoxRef: n }) {
  [t, n] = Ai(t, n, Ym);
  let { dragAndDropHooks: r, layout: i = "stack", orientation: o = "vertical", filter: a } = t, s = D9(e, a), { collection: l, selectionManager: u } = s, c = !!r?.useDraggableCollectionState, f = !!r?.useDroppableCollectionState, { direction: d } = ol(), { disabledBehavior: p, disabledKeys: h } = u, v = Cb({
    usage: "search",
    sensitivity: "base"
  }), { isVirtualized: m, layoutDelegate: g, dropTargetDelegate: _, CollectionRoot: w } = Me(sl), x = Te(() => t.keyboardDelegate || new Ab({
    collection: l,
    collator: v,
    ref: n,
    disabledKeys: h,
    disabledBehavior: p,
    layout: i,
    orientation: o,
    direction: d,
    layoutDelegate: g
  }), [
    l,
    v,
    n,
    p,
    h,
    o,
    d,
    t.keyboardDelegate,
    i,
    g
  ]), { listBoxProps: S } = _9({
    ...t,
    shouldSelectOnPressUp: c || t.shouldSelectOnPressUp,
    keyboardDelegate: x,
    isVirtualized: m
  }, s, n), $ = _e(c), A = _e(f);
  Ee(() => {
    process.env.NODE_ENV !== "production" && ($.current !== c && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), A.current !== f && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."));
  }, [
    c,
    f
  ]);
  let E, y, b, O = !1, k = null, I = _e(null);
  if (c && r) {
    E = r.useDraggableCollectionState({
      collection: l,
      selectionManager: u,
      preview: r.renderDragPreview ? I : void 0
    }), r.useDraggableCollection({}, E, n);
    let ee = r.DragPreview;
    k = r.renderDragPreview ? /* @__PURE__ */ H.createElement(ee, {
      ref: I
    }, r.renderDragPreview) : null;
  }
  if (f && r) {
    y = r.useDroppableCollectionState({
      collection: l,
      selectionManager: u
    });
    let ee = r.dropTargetDelegate || _ || new r.ListDropTargetDelegate(l, n, {
      orientation: o,
      layout: i,
      direction: d
    });
    b = r.useDroppableCollection({
      keyboardDelegate: x,
      dropTargetDelegate: ee
    }, y, n), O = y.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: T, isFocused: V, isFocusVisible: z } = Tp(), B = s.collection.size === 0, q = {
    isDropTarget: O,
    isEmpty: B,
    isFocused: V,
    isFocusVisible: z,
    layout: t.layout || "stack",
    orientation: o,
    state: s
  }, M = zr({
    ...t,
    children: void 0,
    defaultClassName: "react-aria-ListBox",
    values: q
  }), N = null;
  B && t.renderEmptyState && (N = /* @__PURE__ */ H.createElement("div", {
    // eslint-disable-next-line
    role: "option",
    style: {
      display: "contents"
    }
  }, t.renderEmptyState(q)));
  let Y = kn(t, {
    global: !0
  });
  return /* @__PURE__ */ H.createElement(kb, null, /* @__PURE__ */ H.createElement(Bn.div, {
    ...ut(Y, M, S, T, b?.collectionProps),
    ref: n,
    slot: t.slot || void 0,
    onScroll: t.onScroll,
    "data-drop-target": O || void 0,
    "data-empty": B || void 0,
    "data-focused": V || void 0,
    "data-focus-visible": z || void 0,
    "data-layout": t.layout || "stack",
    "data-orientation": o
  }, /* @__PURE__ */ H.createElement(Ma, {
    values: [
      [
        Nb,
        t
      ],
      [
        ul,
        s
      ],
      [
        kp,
        {
          dragAndDropHooks: r,
          dragState: E,
          dropState: y
        }
      ],
      [
        PP,
        {
          elementType: "div"
        }
      ],
      [
        EP,
        {
          render: M9
        }
      ],
      [
        vP,
        {
          name: "ListBoxSection",
          render: N9
        }
      ]
    ]
  }, /* @__PURE__ */ H.createElement($P, null, /* @__PURE__ */ H.createElement(w, {
    collection: l,
    scrollRef: n,
    persistedKeys: r9(u, r, y),
    renderDropIndicator: SP(r, y)
  }))), N, k));
}
function N9(e, t, n, r = "react-aria-ListBoxSection") {
  let i = Me(ul), { dragAndDropHooks: o, dropState: a } = Me(kp), { CollectionBranch: s } = Me(sl), [l, u] = db(), { headingProps: c, groupProps: f } = O9({
    heading: u,
    "aria-label": e["aria-label"] ?? void 0
  }), d = zr({
    ...e,
    id: void 0,
    children: void 0,
    defaultClassName: r,
    values: void 0
  }), p = kn(e, {
    global: !0
  });
  return delete p.id, /* @__PURE__ */ H.createElement(Bn.section, {
    ...ut(p, d, f),
    ref: t
  }, /* @__PURE__ */ H.createElement(OP.Provider, {
    value: {
      ...c,
      ref: l
    }
  }, /* @__PURE__ */ H.createElement(s, {
    collection: i.collection,
    parent: n,
    renderDropIndicator: SP(o, a)
  })));
}
const R9 = /* @__PURE__ */ xb(yd, function(t, n, r) {
  let i = il(n), o = Me(ul), { dragAndDropHooks: a, dragState: s, dropState: l } = Me(kp), u = s && !(s.isDisabled || s.selectionManager.isDisabled(r.key)), { optionProps: c, labelProps: f, descriptionProps: d, ...p } = S9({
    key: r.key,
    "aria-label": t?.["aria-label"]
  }, o, i), { hoverProps: h, isHovered: v } = ll({
    isDisabled: !p.allowsSelection && !p.hasAction && !u,
    onHoverStart: r.props.onHoverStart,
    onHoverChange: r.props.onHoverChange,
    onHoverEnd: r.props.onHoverEnd
  }), { keyboardProps: m } = bb(t), { focusProps: g } = yb(t), _ = null;
  s && a && (_ = a.useDraggableItem({
    key: r.key,
    hasAction: p.hasAction
  }, s));
  let w = null;
  l && a && (w = a.useDroppableItem({
    target: {
      type: "item",
      key: r.key,
      dropPosition: "on"
    }
  }, l, i));
  let x = s && s.isDragging(r.key), S = zr({
    ...t,
    id: void 0,
    children: t.children,
    defaultClassName: "react-aria-ListBoxItem",
    values: {
      ...p,
      isHovered: v,
      selectionMode: o.selectionManager.selectionMode,
      selectionBehavior: o.selectionManager.selectionBehavior,
      allowsDragging: !!s,
      isDragging: x,
      isDropTarget: w?.isDropTarget
    }
  });
  Ee(() => {
    !r.textValue && process.env.NODE_ENV !== "production" && console.warn("A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.");
  }, [
    r.textValue
  ]);
  let $ = t.href ? Bn.a : Bn.div, A = kn(t, {
    global: !0
  });
  return delete A.id, delete A.onClick, t.href && c.tabIndex == null && (c.tabIndex = -1), /* @__PURE__ */ H.createElement($, {
    ...ut(A, S, c, h, m, g, _?.dragProps, w?.dropProps),
    ref: i,
    "data-allows-dragging": !!s || void 0,
    "data-selected": p.isSelected || void 0,
    "data-disabled": p.isDisabled || void 0,
    "data-hovered": v || void 0,
    "data-focused": p.isFocused || void 0,
    "data-focus-visible": p.isFocusVisible || void 0,
    "data-pressed": p.isPressed || void 0,
    "data-dragging": x || void 0,
    "data-drop-target": w?.isDropTarget || void 0,
    "data-selection-mode": o.selectionManager.selectionMode === "none" ? void 0 : o.selectionManager.selectionMode
  }, /* @__PURE__ */ H.createElement(Ma, {
    values: [
      [
        Pp,
        {
          slots: {
            [fb]: f,
            label: f,
            description: d
          }
        }
      ],
      [
        TP,
        {
          isSelected: p.isSelected
        }
      ]
    ]
  }, S.children));
});
function M9(e, t) {
  t = il(t);
  let { dragAndDropHooks: n, dropState: r } = Me(kp), { dropIndicatorProps: i, isHidden: o, isDropTarget: a } = n.useDropIndicator(e, r, t);
  return o ? null : /* @__PURE__ */ H.createElement(F9, {
    ...e,
    dropIndicatorProps: i,
    isDropTarget: a,
    ref: t
  });
}
function j9(e, t) {
  let { dropIndicatorProps: n, isDropTarget: r, ...i } = e, o = zr({
    ...i,
    defaultClassName: "react-aria-DropIndicator",
    values: {
      isDropTarget: r
    }
  });
  return /* @__PURE__ */ H.createElement(H.Fragment, null, /* @__PURE__ */ H.createElement(Bn.div, {
    ...n,
    ...o,
    role: "option",
    ref: t,
    "data-drop-target": r || void 0
  }));
}
const F9 = /* @__PURE__ */ fn(j9);
xb(Qm, function(t, n, r) {
  let i = Me(ul), { isLoading: o, onLoadMore: a, scrollOffset: s, ...l } = t, u = _e(null), c = Te(() => ({
    onLoadMore: a,
    collection: i?.collection,
    sentinelRef: u,
    scrollOffset: s
  }), [
    a,
    s,
    i?.collection
  ]);
  A9(c, u);
  let f = zr({
    ...l,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-ListBoxLoadingIndicator",
    values: void 0
  }), d = {
    // For Android talkback
    tabIndex: -1
  };
  return /* @__PURE__ */ H.createElement(H.Fragment, null, /* @__PURE__ */ H.createElement("div", {
    style: {
      position: "relative",
      width: 0,
      height: 0
    },
    inert: $9(!0)
  }, /* @__PURE__ */ H.createElement("div", {
    "data-testid": "loadMoreSentinel",
    ref: u,
    style: {
      position: "absolute",
      height: 1,
      width: 1
    }
  })), o && f.children && /* @__PURE__ */ H.createElement(H.Fragment, null, /* @__PURE__ */ H.createElement(Bn.div, {
    ...ut(kn(t, {
      global: !0
    }), d),
    ...f,
    // aria-selected isn't needed here since this option is not selectable.
    role: "option",
    ref: n
  }, f.children)));
});
const z9 = /* @__PURE__ */ He({
  placement: "bottom"
}), L9 = typeof HTMLElement < "u" && "inert" in HTMLElement.prototype;
function Ex(e) {
  return e.dataset.liveAnnouncer === "true" || e.dataset.reactAriaTopLayer !== void 0;
}
let Fl = /* @__PURE__ */ new WeakMap(), Wn = [];
function V9(e, t) {
  let n = Tn(e?.[0]), r = t instanceof n.Element ? {
    root: t
  } : t, i = r?.root ?? document.body, o = r?.shouldUseInert && L9, a = new Set(e), s = /* @__PURE__ */ new Set(), l = (m) => o && m instanceof n.HTMLElement ? m.inert : m.getAttribute("aria-hidden") === "true", u = (m, g) => {
    o && m instanceof n.HTMLElement ? m.inert = g : g ? m.setAttribute("aria-hidden", "true") : (m.removeAttribute("aria-hidden"), m instanceof n.HTMLElement && (m.inert = !1));
  }, c = /* @__PURE__ */ new Set();
  if (Mi())
    for (let m of e) {
      let g = m;
      for (; g && g !== i; ) {
        let _ = g.getRootNode();
        "shadowRoot" in _ && c.add(_.shadowRoot), g = _.parentNode;
      }
    }
  let f = (m) => {
    for (let x of m.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]")) a.add(x);
    let g = (x) => {
      if (s.has(x) || a.has(x) || x.parentElement && s.has(x.parentElement) && x.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
      for (let S of a)
        if (Je(x, S)) return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, _ = kP(st(m), m, NodeFilter.SHOW_ELEMENT, {
      acceptNode: g
    }), w = g(m);
    if (w === NodeFilter.FILTER_ACCEPT && d(m), w !== NodeFilter.FILTER_REJECT) {
      let x = _.nextNode();
      for (; x != null; )
        d(x), x = _.nextNode();
    }
  }, d = (m) => {
    let g = Fl.get(m) ?? 0;
    l(m) && g === 0 || (g === 0 && u(m, !0), s.add(m), Fl.set(m, g + 1));
  };
  Wn.length && Wn[Wn.length - 1].disconnect(), f(i);
  let p = new MutationObserver((m) => {
    for (let g of m)
      if (g.type === "childList") {
        if (g.target.isConnected && ![
          ...a,
          ...s
        ].some((_) => Je(_, g.target))) for (let _ of g.addedNodes)
          (_ instanceof HTMLElement || _ instanceof SVGElement) && Ex(_) ? a.add(_) : _ instanceof Element && f(_);
        if (Mi()) {
          for (let _ of c) if (!_.isConnected) {
            p.disconnect();
            break;
          }
        }
      }
  });
  p.observe(i, {
    childList: !0,
    subtree: !0
  });
  let h = /* @__PURE__ */ new Set();
  if (Mi()) for (let m of c) {
    let g = new MutationObserver((_) => {
      for (let w of _)
        if (w.type === "childList") {
          if (w.target.isConnected && ![
            ...a,
            ...s
          ].some((x) => Je(x, w.target))) for (let x of w.addedNodes)
            (x instanceof HTMLElement || x instanceof SVGElement) && Ex(x) ? a.add(x) : x instanceof Element && f(x);
          if (Mi()) {
            for (let x of c) if (!x.isConnected) {
              p.disconnect();
              break;
            }
          }
        }
    });
    g.observe(m, {
      childList: !0,
      subtree: !0
    }), h.add(g);
  }
  let v = {
    visibleNodes: a,
    hiddenNodes: s,
    observe() {
      p.observe(i, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      p.disconnect();
    }
  };
  return Wn.push(v), () => {
    if (p.disconnect(), Mi()) for (let m of h) m.disconnect();
    for (let m of s) {
      let g = Fl.get(m);
      g != null && (g === 1 ? (u(m, !1), Fl.delete(m)) : Fl.set(m, g - 1));
    }
    v === Wn[Wn.length - 1] ? (Wn.pop(), Wn.length && Wn[Wn.length - 1].observe()) : Wn.splice(Wn.indexOf(v), 1);
  };
}
function K9(e) {
  let t = Wn[Wn.length - 1];
  if (t && !t.visibleNodes.has(e))
    return t.visibleNodes.add(e), () => {
      t.visibleNodes.delete(e);
    };
}
const Er = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, xd = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, B9 = {
  top: "left",
  left: "top"
}, ug = {
  top: "height",
  left: "width"
}, BP = {
  width: "totalWidth",
  height: "totalHeight"
}, nf = {};
let U9 = () => typeof document < "u" ? window.visualViewport : null;
function Sx(e, t) {
  let n = 0, r = 0, i = 0, o = 0, a = 0, s = 0, l = {}, u = (t?.scale ?? 1) > 1;
  if (e.tagName === "BODY" || e.tagName === "HTML") {
    let c = document.documentElement;
    i = c.clientWidth, o = c.clientHeight, n = t?.width ?? i, r = t?.height ?? o, l.top = c.scrollTop || e.scrollTop, l.left = c.scrollLeft || e.scrollLeft, t && (a = t.offsetTop, s = t.offsetLeft);
  } else
    ({ width: n, height: r, top: a, left: s } = Fu(e, !1)), l.top = e.scrollTop, l.left = e.scrollLeft, i = n, o = r;
  return ZT() && (e.tagName === "BODY" || e.tagName === "HTML") && u && (l.top = 0, l.left = 0, a = t?.pageTop ?? 0, s = t?.pageLeft ?? 0), {
    width: n,
    height: r,
    totalWidth: i,
    totalHeight: o,
    scroll: l,
    top: a,
    left: s
  };
}
function q9(e) {
  return {
    top: e.scrollTop,
    left: e.scrollLeft,
    width: e.scrollWidth,
    height: e.scrollHeight
  };
}
function Ox(e, t, n, r, i, o, a) {
  let s = i.scroll[e] ?? 0, l = r[ug[e]], u = a[e] + r.scroll[Er[e]] + o, c = a[e] + r.scroll[Er[e]] + l - o, f = t - s + r.scroll[Er[e]] + a[e] - r[Er[e]], d = t - s + n + r.scroll[Er[e]] + a[e] - r[Er[e]];
  return f < u ? u - f : d > c ? Math.max(c - d, u - f) : 0;
}
function H9(e) {
  let t = window.getComputedStyle(e);
  return {
    top: parseInt(t.marginTop, 10) || 0,
    bottom: parseInt(t.marginBottom, 10) || 0,
    left: parseInt(t.marginLeft, 10) || 0,
    right: parseInt(t.marginRight, 10) || 0
  };
}
function $x(e) {
  if (nf[e]) return nf[e];
  let [t, n] = e.split(" "), r = Er[t] || "right", i = B9[r];
  Er[n] || (n = "center");
  let o = ug[r], a = ug[i];
  return nf[e] = {
    placement: t,
    crossPlacement: n,
    axis: r,
    crossAxis: i,
    size: o,
    crossSize: a
  }, nf[e];
}
function uv(e, t, n, r, i, o, a, s, l, u, c) {
  let { placement: f, crossPlacement: d, axis: p, crossAxis: h, size: v, crossSize: m } = r, g = {};
  g[h] = e[h] ?? 0, d === "center" ? g[h] += ((e[m] ?? 0) - (n[m] ?? 0)) / 2 : d !== h && (g[h] += (e[m] ?? 0) - (n[m] ?? 0)), g[h] += o;
  const _ = e[h] - n[m] + l + u, w = e[h] + e[m] - l - u;
  if (g[h] = rg(g[h], _, w), f === p) {
    let x = s ? c[v] : c[BP[v]];
    g[xd[p]] = Math.floor(x - e[p] + i);
  } else g[p] = Math.floor(e[p] + e[v] + i);
  return g;
}
function W9(e, t, n, r, i, o, a, s, l, u, c) {
  let f = (e.top != null ? e.top : l[BP.height] - (e.bottom ?? 0) - a) - (l.scroll.top ?? 0), d = u ? n.top : 0, p = {
    // This should be boundary top in container coord system vs viewport top in container coord system
    // For the viewport top, there are several cases
    // 1. pinchzoom case where we want the viewports offset top as top here
    // 2. case where container is offset from the boundary and is contained by the boundary. In this case the top we want here is NOT 0, we want to take boundary's top even though is is a negative number OR the visual viewport, whichever is more restrictive
    top: Math.max(t.top + d, (c?.offsetTop ?? t.top) + d),
    bottom: Math.min(t.top + t.height + d, (c?.offsetTop ?? 0) + (c?.height ?? 0))
  };
  return s !== "top" ? Math.max(0, p.bottom - // this is the bottom of the boundary
  f - // this is the top of the overlay
  ((i.top ?? 0) + (i.bottom ?? 0) + o)) : Math.max(0, f + a - // this is the bottom of the overlay
  p.top - // this is the top of the boundary
  ((i.top ?? 0) + (i.bottom ?? 0) + o));
}
function Tx(e, t, n, r, i, o, a, s) {
  let { placement: l, axis: u, size: c } = o;
  return l === u ? Math.max(0, n[u] - // trigger start
  (a.scroll[u] ?? 0) - // transform trigger position to be with respect to viewport 0,0
  (e[u] + (s ? t[u] : 0)) - // boundary start
  (r[u] ?? 0) - // margins usually for arrows or other decorations
  r[xd[u]] - i) : Math.max(0, e[c] + e[u] + (s ? t[u] : 0) - n[u] - n[c] + (a.scroll[u] ?? 0) - (r[u] ?? 0) - r[xd[u]] - i);
}
function Z9(e, t, n, r, i, o, a, s, l, u, c, f, d, p, h, v, m, g) {
  let _ = $x(e), { size: w, crossAxis: x, crossSize: S, placement: $, crossPlacement: A } = _, E = uv(t, s, n, _, c, f, u, d, h, v, l), y = c, b = Tx(s, u, t, i, o + c, _, l, m);
  if (a && n[w] > b) {
    let ne = $x(`${xd[$]} ${A}`), se = uv(t, s, n, ne, c, f, u, d, h, v, l);
    Tx(s, u, t, i, o + c, ne, l, m) > b && (_ = ne, E = se, y = c);
  }
  let O = "bottom";
  _.axis === "top" ? _.placement === "top" ? O = "top" : _.placement === "bottom" && (O = "bottom") : _.crossAxis === "top" && (_.crossPlacement === "top" ? O = "bottom" : _.crossPlacement === "bottom" && (O = "top"));
  let k = Ox(x, E[x], n[S], s, l, o, u);
  E[x] += k;
  let I = W9(E, s, u, d, i, o, n.height, O, l, m, g);
  p && p < I && (I = p), n.height = Math.min(n.height, I), E = uv(t, s, n, _, y, f, u, d, h, v, l), k = Ox(x, E[x], n[S], s, l, o, u), E[x] += k;
  let T = {}, V = t[x] - E[x] - i[Er[x]], z = V + 0.5 * t[S];
  const B = h / 2 + v, q = Er[x] === "left" ? (i.left ?? 0) + (i.right ?? 0) : (i.top ?? 0) + (i.bottom ?? 0), M = n[S] - q - h / 2 - v, N = t[x] + h / 2 - (E[x] + i[Er[x]]), Y = t[x] + t[S] - h / 2 - (E[x] + i[Er[x]]), ee = rg(z, N, Y);
  T[x] = rg(ee, B, M), { placement: $, crossPlacement: A } = _, h ? V = T[x] : A === "right" ? V += t[S] : A === "center" && (V += t[S] / 2);
  let Q = $ === "left" || $ === "top" ? n[w] : 0, K = {
    x: $ === "top" || $ === "bottom" ? V : Q,
    y: $ === "left" || $ === "right" ? V : Q
  };
  return {
    position: E,
    maxHeight: I,
    arrowOffsetLeft: T.left,
    arrowOffsetTop: T.top,
    placement: $,
    triggerAnchorPoint: K
  };
}
function G9(e) {
  let { placement: t, targetNode: n, overlayNode: r, scrollNode: i, padding: o, shouldFlip: a, boundaryElement: s, offset: l, crossOffset: u, maxHeight: c, arrowSize: f = 0, arrowBoundaryOffset: d = 0, targetRect: p } = e, h = U9(), v = r instanceof HTMLElement ? Y9(r) : document.documentElement, m = v === document.documentElement;
  const g = window.getComputedStyle(v).position;
  let _ = !!g && g !== "static", w = m ? Fu(n, !1, p) : Px(n, v, !1, p);
  if (!m) {
    let { marginTop: O, marginLeft: k } = window.getComputedStyle(n);
    w.top += parseInt(O, 10) || 0, w.left += parseInt(k, 10) || 0;
  }
  let x = Fu(r, !0), S = H9(r);
  x.width += (S.left ?? 0) + (S.right ?? 0), x.height += (S.top ?? 0) + (S.bottom ?? 0);
  let $ = q9(i), A = Sx(s, h), E = Sx(v, h), y;
  if ((s.tagName === "BODY" || s.tagName === "HTML") && !m) {
    let O = Dp(v, !1);
    y = {
      top: -(O.top - A.top),
      left: -(O.left - A.left),
      width: 0,
      height: 0
    };
  } else (s.tagName === "BODY" || s.tagName === "HTML") && m ? y = {
    top: 0,
    left: 0,
    width: 0,
    height: 0
  } : y = Px(s, v, !1);
  let b = Je(s, v);
  return Z9(t, w, x, $, S, o, a, A, E, y, l, u, _, c, f, d, b, h);
}
function Dp(e, t) {
  let { top: n, left: r, width: i, height: o } = e.getBoundingClientRect();
  return t && e instanceof e.ownerDocument.defaultView.HTMLElement && (i = e.offsetWidth, o = e.offsetHeight), {
    top: n,
    left: r,
    width: i,
    height: o
  };
}
function Fu(e, t, n) {
  let { top: r, left: i, width: o, height: a } = n || Dp(e, t), { scrollTop: s, scrollLeft: l, clientTop: u, clientLeft: c } = document.documentElement;
  return {
    top: r + s - u,
    left: i + l - c,
    width: o,
    height: a
  };
}
function Px(e, t, n, r) {
  let i = window.getComputedStyle(e), o;
  if (i.position === "fixed") o = r || Dp(e, n);
  else {
    o = Fu(e, n, r);
    let a = Fu(t, n), s = window.getComputedStyle(t);
    a.top += (parseInt(s.borderTopWidth, 10) || 0) - t.scrollTop, a.left += (parseInt(s.borderLeftWidth, 10) || 0) - t.scrollLeft, o.top -= a.top, o.left -= a.left;
  }
  return o.top -= parseInt(i.marginTop, 10) || 0, o.left -= parseInt(i.marginLeft, 10) || 0, o;
}
function Y9(e) {
  let t = e.offsetParent;
  if (t && t === document.body && window.getComputedStyle(t).position === "static" && !kx(t) && (t = document.documentElement), t == null)
    for (t = e.parentElement; t && !kx(t); ) t = t.parentElement;
  return t || document.documentElement;
}
function kx(e) {
  let t = window.getComputedStyle(e);
  return t.transform !== "none" || /transform|perspective/.test(t.willChange) || t.filter !== "none" || t.contain === "paint" || "backdropFilter" in t && t.backdropFilter !== "none" || "WebkitBackdropFilter" in t && t.WebkitBackdropFilter !== "none";
}
const UP = /* @__PURE__ */ new WeakMap();
function Q9(e) {
  let { triggerRef: t, isOpen: n, onClose: r } = e;
  Ee(() => {
    if (!n || r === null) return;
    let i = (o) => {
      let a = Ae(o);
      if (!t.current || a instanceof Node && !Je(a, t.current) || a instanceof HTMLInputElement || a instanceof HTMLTextAreaElement) return;
      let s = r || UP.get(t.current);
      s && s();
    };
    return window.addEventListener("scroll", i, !0), () => {
      window.removeEventListener("scroll", i, !0);
    };
  }, [
    n,
    r,
    t
  ]);
}
function J9() {
  return typeof window.ResizeObserver < "u";
}
function cg(e) {
  const { ref: t, box: n, onResize: r } = e;
  let i = Cr(r);
  Ee(() => {
    let o = t?.current;
    if (o)
      if (J9()) {
        const a = new window.ResizeObserver((s) => {
          s.length && i();
        });
        return a.observe(o, {
          box: n
        }), () => {
          o && a.unobserve(o);
        };
      } else
        return window.addEventListener("resize", i, !1), () => {
          window.removeEventListener("resize", i, !1);
        };
  }, [
    t,
    n
  ]);
}
let Yo = typeof document < "u" ? window.visualViewport : null;
function X9(e) {
  let { direction: t } = ol(), { arrowSize: n, targetRef: r, overlayRef: i, arrowRef: o, scrollRef: a = i, placement: s = "bottom", containerPadding: l = 12, shouldFlip: u = !0, boundaryElement: c = typeof document < "u" ? document.body : null, offset: f = 0, crossOffset: d = 0, shouldUpdatePosition: p = !0, isOpen: h = !0, onClose: v, maxHeight: m, arrowBoundaryOffset: g = 0, getTargetRect: _ } = e, [w, x] = Ve(null), S = [
    p,
    s,
    i.current,
    r.current,
    o?.current,
    a.current,
    l,
    u,
    c,
    f,
    d,
    h,
    t,
    m,
    g,
    n
  ], $ = _e(Yo?.scale);
  Ee(() => {
    h && ($.current = Yo?.scale);
  }, [
    h
  ]);
  let A = Le(() => {
    if (p === !1 || !h || !i.current || !r.current || !c || Yo?.scale !== $.current) return;
    let b = null;
    if (a.current && hd(a.current)) {
      let T = Vt()?.getBoundingClientRect(), V = a.current.getBoundingClientRect();
      b = {
        type: "top",
        offset: (T?.top ?? 0) - V.top
      }, b.offset > V.height / 2 && (b.type = "bottom", b.offset = (T?.bottom ?? 0) - V.bottom);
    }
    let O = i.current;
    !m && i.current && (O.style.top = "0px", O.style.bottom = "", O.style.maxHeight = (window.visualViewport?.height ?? window.innerHeight) + "px");
    let k = G9({
      placement: tV(s, t),
      overlayNode: i.current,
      targetNode: r.current,
      scrollNode: a.current || i.current,
      padding: l,
      shouldFlip: u,
      boundaryElement: c,
      offset: f,
      crossOffset: d,
      maxHeight: m,
      arrowSize: n ?? (o?.current ? Dp(o.current, !0).width : 0),
      arrowBoundaryOffset: g,
      targetRect: _?.(r.current)
    });
    if (!k.position) return;
    O.style.top = "", O.style.bottom = "", O.style.left = "", O.style.right = "", Object.keys(k.position).forEach((T) => O.style[T] = k.position[T] + "px"), O.style.maxHeight = k.maxHeight != null ? k.maxHeight + "px" : "";
    let I = Vt();
    if (b && I && a.current) {
      let T = I.getBoundingClientRect(), V = a.current.getBoundingClientRect(), z = T[b.type] - V[b.type];
      a.current.scrollTop += z - b.offset;
    }
    x(k);
  }, S);
  ht(A, S), eV(A), cg({
    ref: i,
    onResize: A
  }), cg({
    ref: r,
    onResize: A
  });
  let E = _e(!1);
  ht(() => {
    let b, O = () => {
      E.current = !0, clearTimeout(b), b = setTimeout(() => {
        E.current = !1;
      }, 500), A();
    }, k = () => {
      E.current && O();
    };
    return Yo?.addEventListener("resize", O), Yo?.addEventListener("scroll", k), () => {
      Yo?.removeEventListener("resize", O), Yo?.removeEventListener("scroll", k);
    };
  }, [
    A
  ]);
  let y = Le(() => {
    E.current || v?.();
  }, [
    v,
    E
  ]);
  return Q9({
    triggerRef: r,
    isOpen: h,
    onClose: v && y
  }), {
    overlayProps: {
      style: {
        position: w ? "absolute" : "fixed",
        top: w ? void 0 : 0,
        left: w ? void 0 : 0,
        zIndex: 1e5,
        ...w?.position,
        maxHeight: w?.maxHeight ?? "100vh"
      }
    },
    placement: w?.placement ?? null,
    triggerAnchorPoint: w?.triggerAnchorPoint ?? null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: w?.arrowOffsetLeft,
        top: w?.arrowOffsetTop
      }
    },
    updatePosition: A
  };
}
function eV(e) {
  ht(() => (window.addEventListener("resize", e, !1), () => {
    window.removeEventListener("resize", e, !1);
  }), [
    e
  ]);
}
function tV(e, t) {
  return t === "rtl" ? e.replace("start", "right").replace("end", "left") : e.replace("start", "left").replace("end", "right");
}
function nV(e) {
  let { ref: t, onInteractOutside: n, isDisabled: r, onInteractOutsideStart: i } = e, o = _e({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }), a = Cr((l) => {
    n && rf(l, t) && (i && i(l), o.current.isPointerDown = !0);
  }), s = Cr((l) => {
    n && n(l);
  });
  Ee(() => {
    let l = o.current;
    if (r) return;
    const u = t.current, c = st(u);
    if (typeof PointerEvent < "u") {
      let f = (d) => {
        l.isPointerDown && rf(d, t) && s(d), l.isPointerDown = !1;
      };
      return c.addEventListener("pointerdown", a, !0), c.addEventListener("click", f, !0), () => {
        c.removeEventListener("pointerdown", a, !0), c.removeEventListener("click", f, !0);
      };
    } else if (process.env.NODE_ENV === "test") {
      let f = (p) => {
        l.ignoreEmulatedMouseEvents ? l.ignoreEmulatedMouseEvents = !1 : l.isPointerDown && rf(p, t) && s(p), l.isPointerDown = !1;
      }, d = (p) => {
        l.ignoreEmulatedMouseEvents = !0, l.isPointerDown && rf(p, t) && s(p), l.isPointerDown = !1;
      };
      return c.addEventListener("mousedown", a, !0), c.addEventListener("mouseup", f, !0), c.addEventListener("touchstart", a, !0), c.addEventListener("touchend", d, !0), () => {
        c.removeEventListener("mousedown", a, !0), c.removeEventListener("mouseup", f, !0), c.removeEventListener("touchstart", a, !0), c.removeEventListener("touchend", d, !0);
      };
    }
  }, [
    t,
    r
  ]);
}
function rf(e, t) {
  if (e.button > 0) return !1;
  let n = Ae(e);
  if (n) {
    const r = n.ownerDocument;
    if (!r || !Je(r.documentElement, n) || n.closest("[data-react-aria-top-layer]")) return !1;
  }
  return t.current ? !e.composedPath().includes(t.current) : !1;
}
const mi = [];
function rV(e, t) {
  let { onClose: n, shouldCloseOnBlur: r, isOpen: i, isDismissable: o = !1, isKeyboardDismissDisabled: a = !1, shouldCloseOnInteractOutside: s } = e, l = _e(void 0);
  Ee(() => {
    if (i && !mi.includes(t))
      return mi.push(t), () => {
        let h = mi.indexOf(t);
        h >= 0 && mi.splice(h, 1);
      };
  }, [
    i,
    t
  ]);
  let u = () => {
    mi[mi.length - 1] === t && n && n();
  }, c = (h) => {
    const v = mi[mi.length - 1];
    l.current = v, (!s || s(Ae(h))) && v === t && h.stopPropagation();
  }, f = (h) => {
    (!s || s(Ae(h))) && (mi[mi.length - 1] === t && h.stopPropagation(), l.current === t && u()), l.current = void 0;
  }, d = (h) => {
    h.key === "Escape" && !a && !h.nativeEvent.isComposing && (h.stopPropagation(), h.preventDefault(), u());
  };
  nV({
    ref: t,
    onInteractOutside: o && i ? f : void 0,
    onInteractOutsideStart: c
  });
  let { focusWithinProps: p } = $p({
    isDisabled: !r,
    onBlurWithin: (h) => {
      !h.relatedTarget || d9(h.relatedTarget) || (!s || s(h.relatedTarget)) && n?.();
    }
  });
  return {
    overlayProps: {
      onKeyDown: d,
      ...p
    },
    underlayProps: {}
  };
}
const vu = typeof document < "u" && window.visualViewport;
let of = 0, cv;
function iV(e = {}) {
  let { isDisabled: t } = e;
  ht(() => {
    if (!t)
      return of++, of === 1 && (mc() ? cv = aV() : cv = oV()), () => {
        of--, of === 0 && cv();
      };
  }, [
    t
  ]);
}
function oV() {
  let e = window.innerWidth - document.documentElement.clientWidth;
  return Ra(e > 0 && // Use scrollbar-gutter when supported because it also works for fixed positioned elements.
  ("scrollbarGutter" in document.documentElement.style ? Nf(document.documentElement, "scrollbarGutter", "stable") : Nf(document.documentElement, "paddingRight", `${e}px`)), Nf(document.documentElement, "overflow", "hidden"));
}
function aV() {
  let e = Nf(document.documentElement, "overflow", "hidden"), t, n = !1, r = (c) => {
    let f = Ae(c);
    t = Ms(f) ? f : Tb(f, !0), n = !1;
    let d = f.ownerDocument.defaultView.getSelection();
    d && !d.isCollapsed && d.containsNode(f, !0) && (n = !0), c.composedPath().some((p) => p instanceof HTMLInputElement && p.type === "range") && (n = !0), "selectionStart" in f && "selectionEnd" in f && f.selectionStart < f.selectionEnd && f.ownerDocument.activeElement === f && (n = !0);
  }, i = document.createElement("style"), o = mP();
  o && (i.nonce = o), i.textContent = `
@layer {
  * {
    overscroll-behavior: contain;
  }
}`.trim(), document.head.prepend(i);
  let a = (c) => {
    if (!(c.touches.length === 2 || n)) {
      if (!t || t === document.documentElement || t === document.body) {
        c.preventDefault();
        return;
      }
      t.scrollHeight === t.clientHeight && t.scrollWidth === t.clientWidth && c.preventDefault();
    }
  }, s = (c) => {
    let f = Ae(c), d = c.relatedTarget;
    d && Qh(d) ? (d.focus({
      preventScroll: !0
    }), Dx(d, Qh(f))) : d || f.parentElement?.closest("[tabindex]")?.focus({
      preventScroll: !0
    });
  }, l = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function(c) {
    let f = Vt(), d = f != null && Qh(f);
    l.call(this, {
      ...c,
      preventScroll: !0
    }), (!c || !c.preventScroll) && Dx(this, d);
  };
  let u = Ra(fv(document, "touchstart", r, {
    passive: !1,
    capture: !0
  }), fv(document, "touchmove", a, {
    passive: !1,
    capture: !0
  }), fv(document, "blur", s, !0));
  return () => {
    e(), u(), i.remove(), HTMLElement.prototype.focus = l;
  };
}
function Nf(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function fv(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function Dx(e, t) {
  t || !vu ? Ax(e) : vu.addEventListener("resize", () => Ax(e), {
    once: !0
  });
}
function Ax(e) {
  let t = document.scrollingElement || document.documentElement, n = e;
  for (; n && n !== t; ) {
    let r = Tb(n);
    if (r !== document.documentElement && r !== document.body && r !== n) {
      let i = r.getBoundingClientRect(), o = n.getBoundingClientRect();
      if (o.top < i.top || o.bottom > i.top + n.clientHeight) {
        let a = i.bottom;
        vu && (a = Math.min(a, vu.offsetTop + vu.height));
        let s = o.top - i.top - ((a - i.top) / 2 - o.height / 2);
        r.scrollTo({
          // Clamp to the valid range to prevent over-scrolling.
          top: Math.max(0, Math.min(r.scrollHeight - r.clientHeight, r.scrollTop + s)),
          behavior: "smooth"
        });
      }
    }
    n = r.parentElement;
  }
}
function sV(e, t) {
  let { triggerRef: n, popoverRef: r, groupRef: i, isNonModal: o, isKeyboardDismissDisabled: a, shouldCloseOnInteractOutside: s, ...l } = e, u = l.trigger === "SubmenuTrigger", { overlayProps: c, underlayProps: f } = rV({
    isOpen: t.isOpen,
    onClose: t.close,
    shouldCloseOnBlur: !0,
    isDismissable: !o || u,
    isKeyboardDismissDisabled: a,
    shouldCloseOnInteractOutside: s
  }, i ?? r), { overlayProps: d, arrowProps: p, placement: h, triggerAnchorPoint: v } = X9({
    ...l,
    targetRef: n,
    overlayRef: r,
    isOpen: t.isOpen,
    onClose: o && !u ? t.close : null
  });
  return iV({
    isDisabled: o || !t.isOpen
  }), Ee(() => {
    if (t.isOpen && r.current)
      return o ? K9(i?.current ?? r.current) : V9([
        i?.current ?? r.current
      ], {
        shouldUseInert: !0
      });
  }, [
    o,
    t.isOpen,
    r,
    i
  ]), {
    popoverProps: ut(c, d),
    arrowProps: p,
    underlayProps: f,
    placement: h,
    triggerAnchorPoint: v
  };
}
var qP = {};
qP = {
  dismiss: "تجاهل"
};
var HP = {};
HP = {
  dismiss: "Отхвърляне"
};
var WP = {};
WP = {
  dismiss: "Odstranit"
};
var ZP = {};
ZP = {
  dismiss: "Luk"
};
var GP = {};
GP = {
  dismiss: "Schließen"
};
var YP = {};
YP = {
  dismiss: "Απόρριψη"
};
var QP = {};
QP = {
  dismiss: "Dismiss"
};
var JP = {};
JP = {
  dismiss: "Descartar"
};
var XP = {};
XP = {
  dismiss: "Lõpeta"
};
var ek = {};
ek = {
  dismiss: "Hylkää"
};
var tk = {};
tk = {
  dismiss: "Rejeter"
};
var nk = {};
nk = {
  dismiss: "התעלם"
};
var rk = {};
rk = {
  dismiss: "Odbaci"
};
var ik = {};
ik = {
  dismiss: "Elutasítás"
};
var ok = {};
ok = {
  dismiss: "Ignora"
};
var ak = {};
ak = {
  dismiss: "閉じる"
};
var sk = {};
sk = {
  dismiss: "무시"
};
var lk = {};
lk = {
  dismiss: "Atmesti"
};
var uk = {};
uk = {
  dismiss: "Nerādīt"
};
var ck = {};
ck = {
  dismiss: "Lukk"
};
var fk = {};
fk = {
  dismiss: "Negeren"
};
var dk = {};
dk = {
  dismiss: "Zignoruj"
};
var pk = {};
pk = {
  dismiss: "Descartar"
};
var hk = {};
hk = {
  dismiss: "Dispensar"
};
var vk = {};
vk = {
  dismiss: "Revocare"
};
var mk = {};
mk = {
  dismiss: "Пропустить"
};
var gk = {};
gk = {
  dismiss: "Zrušiť"
};
var yk = {};
yk = {
  dismiss: "Opusti"
};
var bk = {};
bk = {
  dismiss: "Odbaci"
};
var _k = {};
_k = {
  dismiss: "Avvisa"
};
var wk = {};
wk = {
  dismiss: "Kapat"
};
var xk = {};
xk = {
  dismiss: "Скасувати"
};
var Ek = {};
Ek = {
  dismiss: "取消"
};
var Sk = {};
Sk = {
  dismiss: "關閉"
};
var Ok = {};
Ok = {
  "ar-AE": qP,
  "bg-BG": HP,
  "cs-CZ": WP,
  "da-DK": ZP,
  "de-DE": GP,
  "el-GR": YP,
  "en-US": QP,
  "es-ES": JP,
  "et-EE": XP,
  "fi-FI": ek,
  "fr-FR": tk,
  "he-IL": nk,
  "hr-HR": rk,
  "hu-HU": ik,
  "it-IT": ok,
  "ja-JP": ak,
  "ko-KR": sk,
  "lt-LT": lk,
  "lv-LV": uk,
  "nb-NO": ck,
  "nl-NL": fk,
  "pl-PL": dk,
  "pt-BR": pk,
  "pt-PT": hk,
  "ro-RO": vk,
  "ru-RU": mk,
  "sk-SK": gk,
  "sl-SI": yk,
  "sr-SP": bk,
  "sv-SE": _k,
  "tr-TR": wk,
  "uk-UA": xk,
  "zh-CN": Ek,
  "zh-TW": Sk
};
function lV(e) {
  return e && e.__esModule ? e.default : e;
}
function Cx(e) {
  let { onDismiss: t, ...n } = e, r = iP(lV(Ok), "@react-aria/overlays"), i = tP(n, r.format("dismiss")), o = () => {
    t && t();
  };
  return /* @__PURE__ */ H.createElement(LL, null, /* @__PURE__ */ H.createElement("button", {
    ...i,
    tabIndex: -1,
    onClick: o,
    style: {
      width: 1,
      height: 1
    }
  }));
}
const $k = /* @__PURE__ */ H.forwardRef(({ children: e, ...t }, n) => {
  let r = _e(!1), i = Me(ju), o = ut(i || {}, {
    ...t,
    register() {
      r.current = !0, i && i.register();
    }
  });
  return o.ref = il(n || i?.ref), _b(i, o.ref), Ee(() => {
    r.current || (process.env.NODE_ENV !== "production" && console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component."), r.current = !0);
  }, []), /* @__PURE__ */ H.createElement(ju.Provider, {
    value: o
  }, e);
});
function uV({ children: e }) {
  let t = Te(() => ({
    register: () => {
    }
  }), []);
  return /* @__PURE__ */ H.createElement(ju.Provider, {
    value: t
  }, e);
}
const cV = /* @__PURE__ */ He({});
function fV() {
  return Me(cV) ?? {};
}
const dV = /* @__PURE__ */ H.createContext(null);
function Ix(e) {
  let t = vc(), { portalContainer: n = t ? null : document.body, isExiting: r } = e, [i, o] = Ve(!1), a = Te(() => ({
    contain: i,
    setContain: o
  }), [
    i,
    o
  ]), { getContainer: s } = fV();
  if (!e.portalContainer && s && (n = s()), !n) return null;
  let l = e.children;
  return e.disableFocusManagement || (l = /* @__PURE__ */ H.createElement(kb, {
    restoreFocus: !0,
    contain: (e.shouldContainFocus || i) && !r
  }, l)), l = /* @__PURE__ */ H.createElement(dV.Provider, {
    value: a
  }, /* @__PURE__ */ H.createElement(uV, null, l)), /* @__PURE__ */ Y3.createPortal(l, n);
}
function Rb(e) {
  let [t, n] = xp(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
  const r = Le(() => {
    n(!0);
  }, [
    n
  ]), i = Le(() => {
    n(!1);
  }, [
    n
  ]), o = Le(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isOpen: t,
    setOpen: n,
    open: r,
    close: i,
    toggle: o
  };
}
function pV(e, t = !0) {
  let [n, r] = Ve(!0), i = n && t;
  return ht(() => {
    if (i && e.current && "getAnimations" in e.current)
      for (let o of e.current.getAnimations()) o instanceof CSSTransition && o.cancel();
  }, [
    e,
    i
  ]), Tk(e, i, Le(() => r(!1), [])), i;
}
function hV(e, t) {
  let [n, r] = Ve(t ? "open" : "closed");
  switch (n) {
    case "open":
      t || r("exiting");
      break;
    case "closed":
    case "exiting":
      t && r("open");
      break;
  }
  let i = n === "exiting";
  return Tk(e, i, Le(() => {
    r((o) => o === "exiting" ? "closed" : o);
  }, [])), i;
}
function Tk(e, t, n) {
  ht(() => {
    if (t && e.current) {
      if (!("getAnimations" in e.current)) {
        n();
        return;
      }
      let r = e.current.getAnimations();
      if (r.length === 0) {
        n();
        return;
      }
      let i = !1;
      return Promise.allSettled(r.map((o) => o.finished)).then(() => {
        i || Sy(() => {
          n();
        });
      }), () => {
        i = !0;
      };
    }
  }, [
    e,
    t,
    n
  ]);
}
const Mb = /* @__PURE__ */ He(null), Nx = /* @__PURE__ */ He(null), Pk = /* @__PURE__ */ fn(function(t, n) {
  [t, n] = Ai(t, n, Mb);
  let r = Me(Fb), i = Rb(t), o = t.isOpen != null || t.defaultOpen != null || !r ? i : r, a = hV(n, o.isOpen) || t.isExiting || !1, s = fP(), { direction: l } = ol();
  if (s) {
    let u = t.children;
    return typeof u == "function" && (u = u({
      trigger: t.trigger || null,
      placement: "bottom",
      isEntering: !1,
      isExiting: !1,
      defaultChildren: null
    })), /* @__PURE__ */ H.createElement(H.Fragment, null, u);
  }
  return o && !o.isOpen && !a ? null : /* @__PURE__ */ H.createElement(vV, {
    ...t,
    triggerRef: t.triggerRef,
    state: o,
    popoverRef: n,
    isExiting: a,
    dir: l
  });
});
function vV({ state: e, isExiting: t, UNSTABLE_portalContainer: n, clearContexts: r, ...i }) {
  let o = _e(null), a = _e(null), s = Me(Nx), l = s && i.trigger === "SubmenuTrigger", { popoverProps: u, underlayProps: c, arrowProps: f, placement: d, triggerAnchorPoint: p } = sV({
    ...i,
    offset: i.offset ?? 8,
    arrowRef: o,
    // If this is a submenu/subdialog, use the root popover's container
    // to detect outside interaction and add aria-hidden.
    groupRef: l ? s : a
  }, e), h = i.popoverRef, v = pV(h, !!d) || i.isEntering || !1, m = zr({
    ...i,
    defaultClassName: "react-aria-Popover",
    values: {
      trigger: i.trigger || null,
      placement: d,
      isEntering: v,
      isExiting: t
    }
  }), g = !i.isNonModal || i.trigger === "SubmenuTrigger", [_, w] = Ve(!1);
  ht(() => {
    h.current && w(g && !h.current.querySelector("[role=dialog]"));
  }, [
    h,
    g
  ]), Ee(() => {
    _ && (i.trigger !== "SubmenuTrigger" || Ru() !== "pointer") && h.current && !hd(h.current) && Rs(h.current);
  }, [
    _,
    h,
    i.trigger
  ]);
  let x = Te(() => {
    let b = m.children;
    if (r) for (let O of r) b = /* @__PURE__ */ H.createElement(O.Provider, {
      value: null
    }, b);
    return b;
  }, [
    m.children,
    r
  ]), [S, $] = Ve(null), A = Le(() => {
    i.triggerRef.current && $(i.triggerRef.current.getBoundingClientRect().width + "px");
  }, [
    i.triggerRef
  ]);
  ht(A, [
    A
  ]), cg({
    ref: m.style?.["--trigger-width"] ? void 0 : i.triggerRef,
    onResize: A
  });
  let E = {
    ...u.style,
    "--trigger-anchor-point": p ? `${p.x}px ${p.y}px` : void 0,
    ...m.style,
    "--trigger-width": m.style?.["--trigger-width"] || S
  }, y = /* @__PURE__ */ H.createElement(Bn.div, {
    ...ut(kn(i, {
      global: !0
    }), u),
    ...m,
    role: _ ? "dialog" : void 0,
    tabIndex: _ ? -1 : void 0,
    "aria-label": i["aria-label"],
    "aria-labelledby": i["aria-labelledby"],
    ref: h,
    slot: i.slot || void 0,
    style: E,
    dir: i.dir,
    "data-trigger": i.trigger,
    "data-placement": d,
    "data-entering": v || void 0,
    "data-exiting": t || void 0
  }, !i.isNonModal && /* @__PURE__ */ H.createElement(Cx, {
    onDismiss: e.close
  }), /* @__PURE__ */ H.createElement(z9.Provider, {
    value: {
      ...f,
      placement: d,
      ref: o
    }
  }, x), /* @__PURE__ */ H.createElement(Cx, {
    onDismiss: e.close
  }));
  return l ? /* @__PURE__ */ H.createElement(Ix, {
    ...i,
    shouldContainFocus: _,
    isExiting: t,
    portalContainer: n ?? s?.current ?? void 0
  }, y) : /* @__PURE__ */ H.createElement(Ix, {
    ...i,
    shouldContainFocus: _,
    isExiting: t,
    portalContainer: n
  }, !i.isNonModal && e.isOpen && /* @__PURE__ */ H.createElement("div", {
    "data-testid": "underlay",
    ...c,
    style: {
      position: "fixed",
      inset: 0
    }
  }), /* @__PURE__ */ H.createElement("div", {
    ref: a,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ H.createElement(Nx.Provider, {
    value: a
  }, y)));
}
const mV = /* @__PURE__ */ He({});
var kk = {};
kk = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var Dk = {};
Dk = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var Ak = {};
Ak = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var Ck = {};
Ck = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var Ik = {};
Ik = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var Nk = {};
Nk = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var Rk = {};
Rk = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var Mk = {};
Mk = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var jk = {};
jk = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var Fk = {};
Fk = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var zk = {};
zk = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var Lk = {};
Lk = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var Vk = {};
Vk = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var Kk = {};
Kk = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var Bk = {};
Bk = {
  longPressMessage: "Premi a lungo o premi Alt + Freccia giù per aprire il menu"
};
var Uk = {};
Uk = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var qk = {};
qk = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var Hk = {};
Hk = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var Wk = {};
Wk = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var Zk = {};
Zk = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var Gk = {};
Gk = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var Yk = {};
Yk = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var Qk = {};
Qk = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var Jk = {};
Jk = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var Xk = {};
Xk = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var eD = {};
eD = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var tD = {};
tD = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var nD = {};
nD = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var rD = {};
rD = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var iD = {};
iD = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var oD = {};
oD = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var aD = {};
aD = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var sD = {};
sD = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var lD = {};
lD = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
var uD = {};
uD = {
  "ar-AE": kk,
  "bg-BG": Dk,
  "cs-CZ": Ak,
  "da-DK": Ck,
  "de-DE": Ik,
  "el-GR": Nk,
  "en-US": Rk,
  "es-ES": Mk,
  "et-EE": jk,
  "fi-FI": Fk,
  "fr-FR": zk,
  "he-IL": Lk,
  "hr-HR": Vk,
  "hu-HU": Kk,
  "it-IT": Bk,
  "ja-JP": Uk,
  "ko-KR": qk,
  "lt-LT": Hk,
  "lv-LV": Wk,
  "nb-NO": Zk,
  "nl-NL": Gk,
  "pl-PL": Yk,
  "pt-BR": Qk,
  "pt-PT": Jk,
  "ro-RO": Xk,
  "ru-RU": eD,
  "sk-SK": tD,
  "sl-SI": nD,
  "sr-SP": rD,
  "sv-SE": iD,
  "tr-TR": oD,
  "uk-UA": aD,
  "zh-CN": sD,
  "zh-TW": lD
};
function gV(e, t, n) {
  let { type: r } = e, { isOpen: i } = t;
  Ee(() => {
    n && n.current && UP.set(n.current, t.close);
  });
  let o;
  r === "menu" ? o = !0 : r === "listbox" && (o = "listbox");
  let a = Jn();
  return {
    triggerProps: {
      "aria-haspopup": o,
      "aria-expanded": i,
      "aria-controls": i ? a : void 0,
      onPress: t.toggle
    },
    overlayProps: {
      id: a
    }
  };
}
function yV(e) {
  return e && e.__esModule ? e.default : e;
}
function cD(e, t, n) {
  let { type: r = "menu", isDisabled: i, trigger: o = "press" } = e, a = Jn(), { triggerProps: s, overlayProps: l } = gV({
    type: r
  }, t, n), u = (p) => {
    if (!i && !(o === "longPress" && !p.altKey) && n && n.current)
      switch (p.key) {
        case "Enter":
        case " ":
          if (o === "longPress" || p.isDefaultPrevented()) return;
        // fallthrough
        case "ArrowDown":
          "continuePropagation" in p || p.stopPropagation(), p.preventDefault(), t.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in p || p.stopPropagation(), p.preventDefault(), t.toggle("last");
          break;
        default:
          "continuePropagation" in p && p.continuePropagation();
      }
  }, c = iP(yV(uD), "@react-aria/menu"), { longPressProps: f } = RP({
    isDisabled: i || o !== "longPress",
    accessibilityDescription: c.format("longPressMessage"),
    onLongPressStart() {
      t.close();
    },
    onLongPress() {
      t.open("first");
    }
  }), d = {
    preventFocusOnPress: !0,
    onPressStart(p) {
      p.pointerType !== "touch" && p.pointerType !== "keyboard" && !i && (oi(p.target), t.open(p.pointerType === "virtual" ? "first" : null));
    },
    onPress(p) {
      p.pointerType === "touch" && !i && (oi(p.target), t.toggle());
    }
  };
  return delete s.onPress, {
    // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
    menuTriggerProps: {
      ...s,
      ...o === "press" ? d : f,
      id: a,
      onKeyDown: u
    },
    menuProps: {
      ...l,
      "aria-labelledby": a,
      autoFocus: t.focusStrategy || !0,
      onClose: t.close
    }
  };
}
const fD = /* @__PURE__ */ new WeakMap();
function bV(e, t, n) {
  let { shouldFocusWrap: r = !0, onKeyDown: i, onKeyUp: o, ...a } = e;
  !e["aria-label"] && !e["aria-labelledby"] && process.env.NODE_ENV !== "production" && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let s = kn(e, {
    labelable: !0
  }), { listProps: l } = NP({
    ...a,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    shouldFocusWrap: r,
    linkBehavior: "override"
  });
  return fD.set(t, {
    onClose: e.onClose,
    onAction: e.onAction,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus
  }), {
    menuProps: ut(s, {
      onKeyDown: i,
      onKeyUp: o
    }, {
      role: "menu",
      ...l,
      onKeyDown: (u) => {
        (u.key !== "Escape" || e.shouldUseVirtualFocus) && l.onKeyDown?.(u);
      }
    })
  };
}
function _V(e, t, n) {
  let { id: r, key: i, closeOnSelect: o, shouldCloseOnSelect: a, isVirtualized: s, "aria-haspopup": l, onPressStart: u, onPressUp: c, onPress: f, onPressChange: d, onPressEnd: p, onClick: h, onHoverStart: v, onHoverChange: m, onHoverEnd: g, onKeyDown: _, onKeyUp: w, onFocus: x, onFocusChange: S, onBlur: $, selectionManager: A = t.selectionManager } = e, E = !!l, y = E && e["aria-expanded"] === "true", b = e.isDisabled ?? A.isDisabled(i), O = e.isSelected ?? A.isSelected(i), k = fD.get(t), I = t.collection.getItem(i), T = e.onClose || k.onClose, V = bp(), z = () => {
    if (!E && (I?.props?.onAction ? I.props.onAction() : e.onAction && e.onAction(i), k.onAction)) {
      let te = k.onAction;
      te(i, I?.value);
    }
  }, B = "menuitem";
  E || (A.selectionMode === "single" ? B = "menuitemradio" : A.selectionMode === "multiple" && (B = "menuitemcheckbox"));
  let q = fa(), M = fa(), N = fa(), Y = {
    id: r,
    "aria-disabled": b || void 0,
    role: B,
    "aria-label": e["aria-label"],
    "aria-labelledby": q,
    "aria-describedby": [
      e["aria-describedby"],
      M,
      N
    ].filter(Boolean).join(" ") || void 0,
    "aria-controls": e["aria-controls"],
    "aria-haspopup": l,
    "aria-expanded": e["aria-expanded"]
  };
  if (A.selectionMode !== "none" && !E && (Y["aria-checked"] = O), s) {
    let te = Number(I?.index);
    Y["aria-posinset"] = Number.isNaN(te) ? void 0 : te + 1, Y["aria-setsize"] = FP(t.collection);
  }
  let ee = _e(!1), Q = (te) => {
    d?.(te), ee.current = te;
  }, K = _e(null), ne = (te) => {
    te.pointerType !== "keyboard" && (K.current = {
      pointerType: te.pointerType
    }), te.pointerType === "mouse" && (ee.current || te.target.click()), c?.(te);
  }, se = (te) => {
    h?.(te), z(), Az(te, V, I.props.href, I?.props.routerOptions);
    let fe = K.current?.pointerType === "keyboard" ? K.current?.key === "Enter" || A.selectionMode === "none" || A.isLink(i) : A.selectionMode !== "multiple" || A.isLink(i);
    fe = a ?? o ?? fe, T && !E && fe && T(), K.current = null;
  }, { itemProps: ce, isFocused: X } = MP({
    id: r,
    selectionManager: A,
    key: i,
    ref: n,
    shouldSelectOnPressUp: !0,
    allowsDifferentPressOrigin: !0,
    // Disable all handling of links in useSelectable item
    // because we handle it ourselves. The behavior of menus
    // is slightly different from other collections because
    // actions are performed on key down rather than key up.
    linkBehavior: "none",
    shouldUseVirtualFocus: k.shouldUseVirtualFocus
  }), { pressProps: D, isPressed: P } = Op({
    onPressStart: u,
    onPress: f,
    onPressUp: ne,
    onPressChange: Q,
    onPressEnd: p,
    isDisabled: b
  }), { hoverProps: R } = ll({
    isDisabled: b,
    onHoverStart(te) {
      !_a() && !(y && l) && (A.setFocused(!0), A.setFocusedKey(i)), v?.(te);
    },
    onHoverChange: m,
    onHoverEnd: g
  }), { keyboardProps: j } = bb({
    onKeyDown: (te) => {
      if (te.repeat) {
        te.continuePropagation();
        return;
      }
      switch (te.key) {
        case " ":
          K.current = {
            pointerType: "keyboard",
            key: " "
          }, Ae(te).click(), gd("keyboard");
          break;
        case "Enter":
          K.current = {
            pointerType: "keyboard",
            key: "Enter"
          }, Ae(te).tagName !== "A" && Ae(te).click(), gd("keyboard");
          break;
        default:
          E || te.continuePropagation(), _?.(te);
          break;
      }
    },
    onKeyUp: w
  }), { focusableProps: W } = cP({
    onBlur: $,
    onFocus: x,
    onFocusChange: S
  }, n), J = kn(I?.props);
  delete J.id;
  let le = YT(I?.props);
  return {
    menuItemProps: {
      ...Y,
      ...ut(
        J,
        le,
        E ? {
          onFocus: ce.onFocus,
          "data-collection": ce["data-collection"],
          "data-key": ce["data-key"]
        } : ce,
        D,
        R,
        j,
        W,
        // Prevent DOM focus from moving on mouse down when using virtual focus or this is a submenu/subdialog trigger.
        k.shouldUseVirtualFocus || E ? {
          onMouseDown: (te) => te.preventDefault()
        } : void 0,
        b ? void 0 : {
          onClick: se
        }
      ),
      // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
      tabIndex: ce.tabIndex != null && y && !k.shouldUseVirtualFocus ? -1 : ce.tabIndex
    },
    labelProps: {
      id: q
    },
    descriptionProps: {
      id: M
    },
    keyboardShortcutProps: {
      id: N
    },
    isFocused: X,
    isFocusVisible: X && A.isFocused && _a() && !y,
    isSelected: O,
    isPressed: P,
    isDisabled: b
  };
}
function wV(e) {
  let { heading: t, "aria-label": n } = e, r = Jn();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Techincally, menus cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a label for the nested group.
      id: r,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": t ? r : void 0
    }
  };
}
function dD(e) {
  let t = Rb(e), [n, r] = Ve(null), [i, o] = Ve([]), a = () => {
    o([]), t.close();
  };
  return {
    focusStrategy: n,
    ...t,
    open(u = null) {
      r(u), t.open();
    },
    toggle(u = null) {
      r(u), t.toggle();
    },
    close() {
      a();
    },
    expandedKeysStack: i,
    openSubmenu: (u, c) => {
      o((f) => c > f.length ? f : [
        ...f.slice(0, c),
        u
      ]);
    },
    closeSubmenu: (u, c) => {
      o((f) => f[c] === u ? f.slice(0, c) : f);
    }
  };
}
class xV {
  constructor(t, { expandedKeys: n } = {}) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = t, n = n || /* @__PURE__ */ new Set();
    let r = (a) => {
      if (this.keyMap.set(a.key, a), a.childNodes && (a.type === "section" || n.has(a.key))) for (let s of a.childNodes) r(s);
    };
    for (let a of t) r(a);
    let i = null, o = 0;
    for (let [a, s] of this.keyMap)
      i ? (i.nextKey = a, s.prevKey = i.key) : (this.firstKey = a, s.prevKey = void 0), s.type === "item" && (s.index = o++), i = s, i.nextKey = void 0;
    this.lastKey = i?.key ?? null;
  }
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    return n ? n.prevKey ?? null : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    return n ? n.nextKey ?? null : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    return this.keyMap.get(t) ?? null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
}
function EV(e) {
  let { onExpandedChange: t } = e, [n, r] = xp(e.expandedKeys ? new Set(e.expandedKeys) : void 0, e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : /* @__PURE__ */ new Set(), t), i = Ib(e), o = Te(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), a = zP(e, Le((l) => new xV(l, {
    expandedKeys: n
  }), [
    n
  ]), null);
  return Ee(() => {
    i.focusedKey != null && !a.getItem(i.focusedKey) && i.setFocusedKey(null);
  }, [
    a,
    i.focusedKey
  ]), {
    collection: a,
    expandedKeys: n,
    disabledKeys: o,
    toggleKey: (l) => {
      r(SV(n, l));
    },
    setExpandedKeys: r,
    selectionManager: new gc(a, i)
  };
}
function SV(e, t) {
  let n = new Set(e);
  return n.has(t) ? n.delete(t) : n.add(t), n;
}
const pD = /* @__PURE__ */ He(null), jb = /* @__PURE__ */ He(null), fg = /* @__PURE__ */ He(null), Ed = /* @__PURE__ */ He(null);
function OV(e) {
  let t = dD(e), n = _e(null), { menuTriggerProps: r, menuProps: i } = cD({
    ...e,
    type: "menu"
  }, t, n), o = _e(null);
  return fP() ? null : /* @__PURE__ */ H.createElement(Ma, {
    values: [
      [
        pD,
        {
          ...i,
          ref: o
        }
      ],
      [
        Fb,
        t
      ],
      [
        fg,
        t
      ],
      [
        Mb,
        {
          trigger: "MenuTrigger",
          triggerRef: n,
          scrollRef: o,
          placement: "bottom start",
          "aria-labelledby": i["aria-labelledby"]
        }
      ]
    ]
  }, /* @__PURE__ */ H.createElement($k, {
    ...r,
    ref: n,
    isPressed: t.isOpen
  }, e.children));
}
const $V = /* @__PURE__ */ He(null), E_ = class E_ extends al {
  filter(t, n, r) {
    let i = t.getItem(this.firstChildKey);
    if (i && r(i.textValue, this)) {
      let o = this.clone();
      return n.addDescendants(o, t), o;
    }
    return null;
  }
};
E_.type = "submenutrigger";
let Rx = E_;
const TV = /* @__PURE__ */ fn(function(t, n) {
  return [t, n] = Ai(t, n, pD), /* @__PURE__ */ H.createElement(wb, {
    content: /* @__PURE__ */ H.createElement(hP, t)
  }, (r) => /* @__PURE__ */ H.createElement(PV, {
    props: t,
    collection: r,
    menuRef: n
  }));
});
function PV({ props: e, collection: t, menuRef: n }) {
  [e, n] = Ai(e, n, Ym);
  let { filter: r, ...i } = e, o = Te(() => r ? t.filter(r) : t, [
    t,
    r
  ]), a = EV({
    ...e,
    collection: o,
    children: void 0
  }), s = Me(fg), { isVirtualized: l, CollectionRoot: u } = Me(sl), { menuProps: c } = bV({
    ...e,
    isVirtualized: l,
    onClose: e.onClose || s?.close
  }, a, n), f = zr({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-Menu",
    values: {
      isEmpty: a.collection.size === 0
    }
  }), d = null;
  a.collection.size === 0 && e.renderEmptyState && (d = /* @__PURE__ */ H.createElement("div", {
    role: "menuitem",
    style: {
      display: "contents"
    }
  }, e.renderEmptyState()));
  let p = kn(e, {
    global: !0
  });
  return /* @__PURE__ */ H.createElement(kb, null, /* @__PURE__ */ H.createElement(Bn.div, {
    ...ut(p, f, c),
    ref: n,
    slot: e.slot || void 0,
    "data-empty": a.collection.size === 0 || void 0,
    onScroll: e.onScroll
  }, /* @__PURE__ */ H.createElement(Ma, {
    values: [
      [
        jb,
        a
      ],
      [
        PP,
        {
          elementType: "div"
        }
      ],
      [
        vP,
        {
          name: "MenuSection",
          render: DV
        }
      ],
      [
        $V,
        {
          parentMenuRef: n,
          shouldUseVirtualFocus: i?.shouldUseVirtualFocus
        }
      ],
      [
        zu,
        {
          shouldCloseOnSelect: e.shouldCloseOnSelect
        }
      ],
      [
        Ym,
        null
      ],
      [
        Xz,
        null
      ],
      [
        Ed,
        a.selectionManager
      ],
      /* Ensure root MenuTriggerState is defined, in case Menu is rendered outside a MenuTrigger. */
      /* We assume the context can never change between defined and undefined. */
      /* eslint-disable-next-line react-hooks/rules-of-hooks */
      [
        fg,
        s ?? dD({})
      ]
    ]
  }, /* @__PURE__ */ H.createElement($P, null, /* @__PURE__ */ H.createElement(u, {
    collection: a.collection,
    persistedKeys: bL(a.selectionManager.focusedKey),
    scrollRef: n
  }))), d));
}
class kV extends gc {
  constructor(t, n) {
    super(t.collection, n), this.parent = t;
  }
  get focusedKey() {
    return this.parent.focusedKey;
  }
  get isFocused() {
    return this.parent.isFocused;
  }
  setFocusedKey(t, n) {
    return this.parent.setFocusedKey(t, n);
  }
  setFocused(t) {
    this.parent.setFocused(t);
  }
  get childFocusStrategy() {
    return this.parent.childFocusStrategy;
  }
}
function DV(e, t, n, r = "react-aria-MenuSection") {
  let i = Me(jb), { CollectionBranch: o } = Me(sl), [a, s] = db(), { headingProps: l, groupProps: u } = wV({
    heading: s,
    "aria-label": n.props["aria-label"] ?? void 0
  }), c = zr({
    ...e,
    id: void 0,
    children: void 0,
    defaultClassName: r,
    className: n.props?.className,
    style: n.props?.style,
    values: void 0
  }), f = Me(Ed), d = Ib(e), p = e.selectionMode != null ? new kV(f, d) : f, h = gp(zu)?.shouldCloseOnSelect, v = kn(e, {
    global: !0
  });
  return delete v.id, /* @__PURE__ */ H.createElement(Bn.section, {
    ...ut(v, c, u),
    ref: t
  }, /* @__PURE__ */ H.createElement(Ma, {
    values: [
      [
        OP,
        {
          ...l,
          ref: a
        }
      ],
      [
        Ed,
        p
      ],
      [
        zu,
        {
          shouldCloseOnSelect: e.shouldCloseOnSelect ?? h
        }
      ]
    ]
  }, /* @__PURE__ */ H.createElement(o, {
    collection: i.collection,
    parent: n
  })));
}
const zu = /* @__PURE__ */ He(null), AV = /* @__PURE__ */ xb(yd, function(t, n, r) {
  [t, n] = Ai(t, n, zu);
  let i = gp(zu)?.id, o = Me(jb), a = il(n), s = Me(Ed), { isVirtualized: l } = Me(sl), { menuItemProps: u, labelProps: c, descriptionProps: f, keyboardShortcutProps: d, ...p } = _V({
    ...t,
    id: i,
    key: r.key,
    selectionManager: s,
    isVirtualized: l
  }, o, a), { hoverProps: h, isHovered: v } = ll({
    isDisabled: p.isDisabled
  }), m = zr({
    ...t,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-MenuItem",
    values: {
      ...p,
      isHovered: v,
      isFocusVisible: p.isFocusVisible,
      selectionMode: s.selectionMode,
      selectionBehavior: s.selectionBehavior,
      hasSubmenu: !!t["aria-haspopup"],
      isOpen: t["aria-expanded"] === "true"
    }
  }), g = t.href ? Bn.a : Bn.div, _ = kn(t, {
    global: !0
  });
  return delete _.id, delete _.onClick, /* @__PURE__ */ H.createElement(g, {
    ...ut(_, m, u, h),
    ref: a,
    "data-disabled": p.isDisabled || void 0,
    "data-hovered": v || void 0,
    "data-focused": p.isFocused || void 0,
    "data-focus-visible": p.isFocusVisible || void 0,
    "data-pressed": p.isPressed || void 0,
    "data-selected": p.isSelected || void 0,
    "data-selection-mode": s.selectionMode === "none" ? void 0 : s.selectionMode,
    "data-has-submenu": !!t["aria-haspopup"] || void 0,
    "data-open": t["aria-expanded"] === "true" || void 0
  }, /* @__PURE__ */ H.createElement(Ma, {
    values: [
      [
        Pp,
        {
          slots: {
            [fb]: c,
            label: c,
            description: f
          }
        }
      ],
      [
        mV,
        d
      ],
      [
        TP,
        {
          isSelected: p.isSelected
        }
      ]
    ]
  }, m.children));
}), Fb = /* @__PURE__ */ He(null), CV = /* @__PURE__ */ fn(function(t, n) {
  let { onSelect: r, acceptedFileTypes: i, allowsMultiple: o, defaultCamera: a, children: s, acceptDirectory: l, ...u } = t, c = il(n), f = kn(u, {
    global: !0
  });
  return /* @__PURE__ */ H.createElement(H.Fragment, null, /* @__PURE__ */ H.createElement($k, {
    onPress: () => {
      c.current?.value && (c.current.value = ""), c.current?.click();
    }
  }, s), /* @__PURE__ */ H.createElement(t9, {
    ...f,
    className: "",
    type: "file",
    ref: c,
    style: {
      display: "none"
    },
    accept: i?.toString(),
    onChange: (d) => r?.(Ae(d).files),
    capture: a,
    multiple: o,
    // @ts-expect-error
    webkitdirectory: l ? "" : void 0
  }));
}), zb = /* @__PURE__ */ new WeakMap();
function IV(e, t, n) {
  let { keyboardDelegate: r, isDisabled: i, isRequired: o, name: a, form: s, validationBehavior: l = "aria" } = e, u = Cb({
    usage: "search",
    sensitivity: "base"
  }), c = Te(() => r || new Ab(t.collection, t.disabledKeys, n, u), [
    r,
    t.collection,
    t.disabledKeys,
    u,
    n
  ]), { menuTriggerProps: f, menuProps: d } = cD({
    isDisabled: i,
    type: "listbox"
  }, t, n), p = (y) => {
    if (t.selectionManager.selectionMode !== "multiple")
      switch (y.key) {
        case "ArrowLeft": {
          y.preventDefault();
          let b = t.selectedKey != null ? c.getKeyAbove?.(t.selectedKey) : c.getFirstKey?.();
          b != null && t.setSelectedKey(b);
          break;
        }
        case "ArrowRight": {
          y.preventDefault();
          let b = t.selectedKey != null ? c.getKeyBelow?.(t.selectedKey) : c.getFirstKey?.();
          b != null && t.setSelectedKey(b);
          break;
        }
      }
  }, { typeSelectProps: h } = IP({
    keyboardDelegate: c,
    selectionManager: t.selectionManager,
    onTypeSelect(y) {
      t.setSelectedKey(y);
    }
  }), { isInvalid: v, validationErrors: m, validationDetails: g } = t.displayValidation, { labelProps: _, fieldProps: w, descriptionProps: x, errorMessageProps: S } = WL({
    ...e,
    labelElementType: "span",
    isInvalid: v,
    errorMessage: e.errorMessage || m
  });
  t.selectionManager.selectionMode === "multiple" && (h = {});
  let $ = kn(e, {
    labelable: !0
  }), A = ut(h, f, w), E = Jn();
  return zb.set(t, {
    isDisabled: i,
    isRequired: o,
    name: a,
    form: s,
    validationBehavior: l
  }), {
    labelProps: {
      ..._,
      onClick: () => {
        e.isDisabled || (n.current?.focus(), gd("keyboard"));
      }
    },
    triggerProps: ut($, {
      ...A,
      isDisabled: i,
      onKeyDown: Ra(A.onKeyDown, p, e.onKeyDown),
      onKeyUp: e.onKeyUp,
      "aria-labelledby": [
        E,
        A["aria-labelledby"],
        A["aria-label"] && !A["aria-labelledby"] ? A.id : null
      ].filter(Boolean).join(" "),
      onFocus(y) {
        t.isFocused || (e.onFocus && e.onFocus(y), e.onFocusChange && e.onFocusChange(!0), t.setFocused(!0));
      },
      onBlur(y) {
        t.isOpen || (e.onBlur && e.onBlur(y), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      }
    }),
    valueProps: {
      id: E
    },
    menuProps: {
      ...d,
      onAction: void 0,
      autoFocus: t.focusStrategy || !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      disallowEmptySelection: !0,
      linkBehavior: "selection",
      onBlur: (y) => {
        Je(y.currentTarget, y.relatedTarget) || (e.onBlur && e.onBlur(y), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      },
      "aria-labelledby": [
        w["aria-labelledby"],
        A["aria-label"] && !w["aria-labelledby"] ? A.id : null
      ].filter(Boolean).join(" ")
    },
    descriptionProps: x,
    errorMessageProps: S,
    isInvalid: v,
    validationErrors: m,
    validationDetails: g,
    hiddenSelectProps: {
      isDisabled: i,
      name: a,
      label: e.label,
      state: t,
      triggerRef: n,
      form: s
    }
  };
}
function NV(e, t, n) {
  let r = zb.get(t) || {}, { autoComplete: i, name: o = r.name, form: a = r.form, isDisabled: s = r.isDisabled } = e, { validationBehavior: l, isRequired: u } = r, { visuallyHiddenProps: c } = _P({
    style: {
      // Prevent page scrolling.
      position: "fixed",
      top: 0,
      left: 0
    }
  });
  ZL(e.selectRef, t.defaultValue, t.setValue), GL({
    validationBehavior: l,
    focus: () => n.current?.focus()
  }, t, e.selectRef);
  let f = t.setValue, d = Le((p) => {
    let h = Ae(p);
    h.multiple ? f(Array.from(h.selectedOptions, (v) => v.value)) : f(p.currentTarget.value);
  }, [
    f
  ]);
  return {
    containerProps: {
      ...c,
      "aria-hidden": !0,
      // @ts-ignore
      "data-react-aria-prevent-focus": !0,
      // @ts-ignore
      "data-a11y-ignore": "aria-hidden-focus"
    },
    inputProps: {
      style: {
        display: "none"
      }
    },
    selectProps: {
      tabIndex: -1,
      autoComplete: i,
      disabled: s,
      multiple: t.selectionManager.selectionMode === "multiple",
      required: l === "native" && u,
      name: o,
      form: a,
      value: t.value ?? "",
      onChange: d,
      onInput: d
    }
  };
}
function RV(e) {
  let { state: t, triggerRef: n, label: r, name: i, form: o, isDisabled: a } = e, s = _e(null), l = _e(null), { containerProps: u, selectProps: c } = NV({
    ...e,
    selectRef: t.collection.size <= 300 ? s : l
  }, t, n), f = Array.isArray(t.value) ? t.value : [
    t.value
  ];
  if (t.collection.size <= 300) return /* @__PURE__ */ H.createElement("div", {
    ...u,
    "data-testid": "hidden-select-container"
  }, /* @__PURE__ */ H.createElement("label", null, r, /* @__PURE__ */ H.createElement("select", {
    ...c,
    ref: s
  }, /* @__PURE__ */ H.createElement("option", {
    value: "",
    label: " "
  }, " "), [
    ...t.collection.getKeys()
  ].map((d) => {
    let p = t.collection.getItem(d);
    if (p && p.type === "item") return /* @__PURE__ */ H.createElement("option", {
      key: p.key,
      value: p.key
    }, p.textValue);
  }), t.collection.size === 0 && i && f.map((d, p) => /* @__PURE__ */ H.createElement("option", {
    key: p,
    value: d ?? ""
  })))));
  if (i) {
    let d = zb.get(t) || {}, { validationBehavior: p } = d;
    f.length === 0 && (f = [
      null
    ]);
    let h = f.map((v, m) => {
      let g = {
        type: "hidden",
        autoComplete: c.autoComplete,
        name: i,
        form: o,
        disabled: a,
        value: v ?? ""
      };
      return p === "native" ? /* @__PURE__ */ H.createElement("input", {
        key: m,
        ...g,
        ref: m === 0 ? l : null,
        style: {
          display: "none"
        },
        type: "text",
        required: m === 0 ? c.required : !1,
        onChange: () => {
        }
      }) : /* @__PURE__ */ H.createElement("input", {
        key: m,
        ...g,
        ref: m === 0 ? l : null
      });
    });
    return /* @__PURE__ */ H.createElement(H.Fragment, null, h);
  }
  return null;
}
function MV(e) {
  let { selectionMode: t = "single", shouldCloseOnSelect: n = t === "single" } = e, r = Rb(e), [i, o] = Ve(null), a = Te(() => e.defaultValue !== void 0 ? e.defaultValue : t === "single" ? e.defaultSelectedKey ?? null : [], [
    e.defaultValue,
    e.defaultSelectedKey,
    t
  ]), s = Te(() => e.value !== void 0 ? e.value : t === "single" ? e.selectedKey : void 0, [
    e.value,
    e.selectedKey,
    t
  ]), [l, u] = xp(s, a, e.onChange), c = t === "single" && Array.isArray(l) ? l[0] : l, f = (w) => {
    if (t === "single") {
      let x = Array.isArray(w) ? w[0] ?? null : w;
      u(x), x !== c && e.onSelectionChange?.(x);
    } else {
      let x = [];
      Array.isArray(w) ? x = w : w != null && (x = [
        w
      ]), u(x);
    }
  }, d = LP({
    ...e,
    selectionMode: t,
    disallowEmptySelection: t === "single",
    allowDuplicateSelectionEvents: !0,
    selectedKeys: Te(() => jV(c), [
      c
    ]),
    onSelectionChange: (w) => {
      if (w !== "all") {
        if (t === "single") {
          let x = w.values().next().value ?? null;
          f(x);
        } else f([
          ...w
        ]);
        n && r.close(), v.commitValidation();
      }
    }
  }), p = d.selectionManager.firstSelectedKey, h = Te(() => [
    ...d.selectionManager.selectedKeys
  ].map((w) => d.collection.getItem(w)).filter((w) => w != null), [
    d.selectionManager.selectedKeys,
    d.collection
  ]), v = BL({
    ...e,
    value: Array.isArray(c) && c.length === 0 ? null : c
  }), [m, g] = Ve(!1), [_] = Ve(c);
  return {
    ...v,
    ...d,
    ...r,
    value: c,
    defaultValue: a ?? _,
    setValue: f,
    selectedKey: p,
    setSelectedKey: f,
    selectedItem: h[0] ?? null,
    selectedItems: h,
    defaultSelectedKey: e.defaultSelectedKey ?? (e.selectionMode === "single" ? _ : null),
    focusStrategy: i,
    open(w = null) {
      (d.collection.size !== 0 || e.allowsEmptyCollection) && (o(w), r.open());
    },
    toggle(w = null) {
      (d.collection.size !== 0 || e.allowsEmptyCollection) && (o(w), r.toggle());
    },
    isFocused: m,
    setFocused: g
  };
}
function jV(e) {
  if (e !== void 0)
    return e === null ? [] : Array.isArray(e) ? e : [
      e
    ];
}
const hD = /* @__PURE__ */ He(null), FV = /* @__PURE__ */ He(null), zV = /* @__PURE__ */ Ep(function(t, n) {
  [t, n] = Ai(t, n, hD);
  let { children: r, isDisabled: i = !1, isInvalid: o = !1, isRequired: a = !1 } = t, s = Te(() => typeof r == "function" ? r({
    isOpen: !1,
    isDisabled: i,
    isInvalid: o,
    isRequired: a,
    isFocused: !1,
    isFocusVisible: !1,
    defaultChildren: null
  }) : r, [
    r,
    i,
    o,
    a
  ]);
  return /* @__PURE__ */ H.createElement(wb, {
    content: s
  }, (l) => /* @__PURE__ */ H.createElement(VV, {
    props: t,
    collection: l,
    selectRef: n
  }));
}), LV = [
  Sb,
  Ob,
  Pp
];
function VV({ props: e, selectRef: t, collection: n }) {
  let { validationBehavior: r } = gp(HL) || {}, i = e.validationBehavior ?? r ?? "native", o = MV({
    ...e,
    collection: n,
    children: void 0,
    validationBehavior: i
  }), { isFocusVisible: a, focusProps: s } = Tp({
    within: !0
  }), l = _e(null), [u, c] = db(!e["aria-label"] && !e["aria-labelledby"]), { labelProps: f, triggerProps: d, valueProps: p, menuProps: h, descriptionProps: v, errorMessageProps: m, hiddenSelectProps: g, ..._ } = IV({
    ...az(e),
    label: c,
    validationBehavior: i
  }, o, l), w = Te(() => ({
    isOpen: o.isOpen,
    isFocused: o.isFocused,
    isFocusVisible: a,
    isDisabled: e.isDisabled || !1,
    isInvalid: _.isInvalid || !1,
    isRequired: e.isRequired || !1
  }), [
    o.isOpen,
    o.isFocused,
    a,
    e.isDisabled,
    _.isInvalid,
    e.isRequired
  ]), x = zr({
    ...e,
    values: w,
    defaultClassName: "react-aria-Select"
  }), S = kn(e, {
    global: !0
  });
  delete S.id;
  let $ = _e(null);
  return /* @__PURE__ */ H.createElement(Ma, {
    values: [
      [
        hD,
        e
      ],
      [
        FV,
        o
      ],
      [
        KV,
        p
      ],
      [
        Sb,
        {
          ...f,
          ref: u,
          elementType: "span"
        }
      ],
      [
        Ob,
        {
          ...d,
          ref: l,
          isPressed: o.isOpen,
          autoFocus: e.autoFocus
        }
      ],
      [
        Fb,
        o
      ],
      [
        Mb,
        {
          trigger: "Select",
          triggerRef: l,
          scrollRef: $,
          placement: "bottom start",
          "aria-labelledby": h["aria-labelledby"],
          clearContexts: LV
        }
      ],
      [
        Nb,
        {
          ...h,
          ref: $
        }
      ],
      [
        ul,
        o
      ],
      [
        Pp,
        {
          slots: {
            description: v,
            errorMessage: m
          }
        }
      ],
      [
        VL,
        _
      ]
    ]
  }, /* @__PURE__ */ H.createElement(Bn.div, {
    ...ut(S, x, s),
    ref: t,
    slot: e.slot || void 0,
    "data-focused": o.isFocused || void 0,
    "data-focus-visible": a || void 0,
    "data-open": o.isOpen || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": _.isInvalid || void 0,
    "data-required": e.isRequired || void 0
  }, x.children, /* @__PURE__ */ H.createElement(RV, {
    ...g,
    autoComplete: e.autoComplete
  })));
}
const KV = /* @__PURE__ */ He(null), rue = ({
  options: e,
  onSelect: t,
  label: n,
  className: r = ""
}) => /* @__PURE__ */ C.jsxs(
  zV,
  {
    className: r,
    onSelectionChange: (i) => {
      t(i);
    },
    children: [
      /* @__PURE__ */ C.jsx($b, { children: /* @__PURE__ */ C.jsxs("span", { "aria-hidden": "true", children: [
        n && /* @__PURE__ */ C.jsx(CL, { children: n }),
        /* @__PURE__ */ C.jsx(hr, { className: "px-2", icon: EO, size: "sm" })
      ] }) }),
      /* @__PURE__ */ C.jsx(Pk, { className: "bg-white border border-black", children: /* @__PURE__ */ C.jsx(C9, { children: e.map((i) => /* @__PURE__ */ C.jsx(R9, { id: i.id, children: /* @__PURE__ */ C.jsx("span", { className: "p-1 bg-white w-full block cursor-auto focus:outline-2 focus:outline-neutral-800 ", children: i.label }) }, `dropdown-${i.id}`)) }) })
    ]
  }
), Sd = fn(({ className: e, ...t }, n) => /* @__PURE__ */ C.jsx("input", { ref: n, className: Qn(
  "bg-neutral-200 p-2 block h-auto max-h-8 my-2 border-black border dark:bg-neutral-500 dark:text-neutral-100 placeholder-neutral-400 dark:placeholder-neutral-400",
  e
), ...t })), BV = fn(({ className: e, ...t }, n) => /* @__PURE__ */ C.jsx("select", { ref: n, ...t, className: Qn("bg-neutral-200 rounded-md p-2 block h-auto", e) })), iue = fn(({ field: e, onChange: t, other: n, ...r }, i) => {
  const [o, a] = Ve(!1);
  switch (e.type) {
    case "textarea":
      return /* @__PURE__ */ C.jsx(
        "textarea",
        {
          ref: i,
          onChange: t,
          ...r
        }
      );
    case "select":
      return /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
        /* @__PURE__ */ C.jsxs(
          BV,
          {
            ref: i,
            required: !e.optional,
            onChange: (s) => {
              s.target.value === "other" ? a(!0) : a(!1), t && t(s);
            },
            ...r,
            children: [
              e.options.map((s, l) => /* @__PURE__ */ C.jsx("option", { value: s, children: s }, l)),
              e?.allowOther && /* @__PURE__ */ C.jsx("option", { value: "other", children: "Other" })
            ]
          }
        ),
        o && n?.()
      ] });
    case "submit":
      return /* @__PURE__ */ C.jsx(
        Ty,
        {
          ref: i,
          onChange: t,
          ...r,
          type: "submit",
          children: e.text
        }
      );
    case "email":
      return /* @__PURE__ */ C.jsx(
        Sd,
        {
          required: !e.optional,
          ref: i,
          onChange: t,
          type: "email",
          ...r
        }
      );
    default:
      return /* @__PURE__ */ C.jsx(
        Sd,
        {
          required: !e.optional,
          ref: i,
          onChange: t,
          ...r
        }
      );
  }
}), UV = X3`
    0% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`, dv = J3.span`
  animation: ${UV} 3s linear infinite;
  animation-delay: ${({ index: e }) => e * 0.1}s;
`, oue = () => /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
  /* @__PURE__ */ C.jsx(dv, { index: 0, children: "." }),
  /* @__PURE__ */ C.jsx(dv, { index: 1, children: "." }),
  /* @__PURE__ */ C.jsx(dv, { index: 2, children: "." })
] }), qV = (e) => /* @__PURE__ */ C.jsx("p", { ...e, className: "text-red-500 text-sm" });
class aue extends Ey {
  constructor() {
    super(...arguments);
    vi(this, "state", {
      hasError: !1
    });
  }
  static getDerivedStateFromError(n) {
    return { hasError: !0 };
  }
  componentDidCatch(n, r) {
    console.error("Uncaught error:", n, r);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ C.jsx("h1", { children: "Sorry.. there was an error" }) : this.props.children;
  }
}
var Ln = /* @__PURE__ */ ((e) => (e.ALL = "all", e.NONE = "none", e.FILE = "file", e.DIR = "dir", e.FILE_LIST = "file_list", e.DIR_LIST = "dir_list", e))(Ln || {});
function oe(e, t, n) {
  function r(s, l) {
    if (s._zod || Object.defineProperty(s, "_zod", {
      value: {
        def: l,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), s._zod.traits.has(e))
      return;
    s._zod.traits.add(e), t(s, l);
    const u = a.prototype, c = Object.keys(u);
    for (let f = 0; f < c.length; f++) {
      const d = c[f];
      d in s || (s[d] = u[d].bind(s));
    }
  }
  const i = n?.Parent ?? Object;
  class o extends i {
  }
  Object.defineProperty(o, "name", { value: e });
  function a(s) {
    var l;
    const u = n != null && n.Parent ? new o() : this;
    r(u, s), (l = u._zod).deferred ?? (l.deferred = []);
    for (const c of u._zod.deferred)
      c();
    return u;
  }
  return Object.defineProperty(a, "init", { value: r }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (s) => {
      var l, u;
      return n != null && n.Parent && s instanceof n.Parent ? !0 : (u = (l = s?._zod) == null ? void 0 : l.traits) == null ? void 0 : u.has(e);
    }
  }), Object.defineProperty(a, "name", { value: e }), a;
}
let Os = class extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}, vD = class extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
};
const mD = {};
function ko(e) {
  return mD;
}
function gD(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, r]) => t.indexOf(+n) === -1).map(([n, r]) => r);
}
function dg(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Lb(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Vb(e) {
  return e == null;
}
function Kb(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function HV(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = t.toString();
  let i = (r.split(".")[1] || "").length;
  if (i === 0 && /\d?e-\d?/.test(r)) {
    const l = r.match(/\d?e-(\d?)/);
    l != null && l[1] && (i = Number.parseInt(l[1]));
  }
  const o = n > i ? n : i, a = Number.parseInt(e.toFixed(o).replace(".", "")), s = Number.parseInt(t.toFixed(o).replace(".", ""));
  return a % s / 10 ** o;
}
const Mx = Symbol("evaluating");
function lt(e, t, n) {
  let r;
  Object.defineProperty(e, t, {
    get() {
      if (r !== Mx)
        return r === void 0 && (r = Mx, r = n()), r;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Fa(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function jo(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function jx(e) {
  return JSON.stringify(e);
}
function WV(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const yD = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Od(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const ZV = Lb(() => {
  var e;
  if (typeof navigator < "u" && (e = navigator?.userAgent) != null && e.includes("Cloudflare"))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function js(e) {
  if (Od(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(Od(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function bD(e) {
  return js(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const GV = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Fs(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Fo(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (r._zod.parent = e), r;
}
function Be(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function YV(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const QV = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function JV(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const i = jo(e._zod.def, {
    get shape() {
      const o = {};
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && (o[a] = n.shape[a]);
      }
      return Fa(this, "shape", o), o;
    },
    checks: []
  });
  return Fo(e, i);
}
function XV(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const i = jo(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape };
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && delete o[a];
      }
      return Fa(this, "shape", o), o;
    },
    checks: []
  });
  return Fo(e, i);
}
function e7(e, t) {
  if (!js(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const i = e._zod.def.shape;
    for (const o in t)
      if (Object.getOwnPropertyDescriptor(i, o) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const r = jo(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape, ...t };
      return Fa(this, "shape", i), i;
    }
  });
  return Fo(e, r);
}
function t7(e, t) {
  if (!js(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = jo(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return Fa(this, "shape", r), r;
    }
  });
  return Fo(e, n);
}
function n7(e, t) {
  const n = jo(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Fa(this, "shape", r), r;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Fo(e, n);
}
function r7(e, t, n) {
  const r = t._zod.def.checks;
  if (r && r.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const i = jo(t._zod.def, {
    get shape() {
      const o = t._zod.def.shape, a = { ...o };
      if (n)
        for (const s in n) {
          if (!(s in o))
            throw new Error(`Unrecognized key: "${s}"`);
          n[s] && (a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s]);
        }
      else
        for (const s in o)
          a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s];
      return Fa(this, "shape", a), a;
    },
    checks: []
  });
  return Fo(t, i);
}
function i7(e, t, n) {
  const r = jo(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, o = { ...i };
      if (n)
        for (const a in n) {
          if (!(a in o))
            throw new Error(`Unrecognized key: "${a}"`);
          n[a] && (o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          }));
        }
      else
        for (const a in i)
          o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          });
      return Fa(this, "shape", o), o;
    }
  });
  return Fo(t, r);
}
function cs(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let r = t; r < e.issues.length; r++)
    if (((n = e.issues[r]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function fs(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function af(e) {
  return typeof e == "string" ? e : e?.message;
}
function Do(e, t, n) {
  var r, i, o, a, s, l;
  const u = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const c = af((o = (i = (r = e.inst) == null ? void 0 : r._zod.def) == null ? void 0 : i.error) == null ? void 0 : o.call(i, e)) ?? af((a = t?.error) == null ? void 0 : a.call(t, e)) ?? af((s = n.customError) == null ? void 0 : s.call(n, e)) ?? af((l = n.localeError) == null ? void 0 : l.call(n, e)) ?? "Invalid input";
    u.message = c;
  }
  return delete u.inst, delete u.continue, t != null && t.reportInput || delete u.input, u;
}
function Bb(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Lu(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const _D = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, dg, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, wD = oe("$ZodError", _D), xD = oe("$ZodError", _D, { Parent: Error });
function o7(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const i of e.issues)
    i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
  return { formErrors: r, fieldErrors: n };
}
function a7(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (i) => {
    for (const o of i.issues)
      if (o.code === "invalid_union" && o.errors.length)
        o.errors.map((a) => r({ issues: a }));
      else if (o.code === "invalid_key")
        r({ issues: o.issues });
      else if (o.code === "invalid_element")
        r({ issues: o.issues });
      else if (o.path.length === 0)
        n._errors.push(t(o));
      else {
        let a = n, s = 0;
        for (; s < o.path.length; ) {
          const l = o.path[s];
          s === o.path.length - 1 ? (a[l] = a[l] || { _errors: [] }, a[l]._errors.push(t(o))) : a[l] = a[l] || { _errors: [] }, a = a[l], s++;
        }
      }
  };
  return r(e), n;
}
const Ub = (e) => (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !1 }) : { async: !1 }, a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise)
    throw new Os();
  if (a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => Do(l, o, ko())));
    throw yD(s, i?.callee), s;
  }
  return a.value;
}, qb = (e) => async (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => Do(l, o, ko())));
    throw yD(s, i?.callee), s;
  }
  return a.value;
}, Ap = (e) => (t, n, r) => {
  const i = r ? { ...r, async: !1 } : { async: !1 }, o = t._zod.run({ value: n, issues: [] }, i);
  if (o instanceof Promise)
    throw new Os();
  return o.issues.length ? {
    success: !1,
    error: new (e ?? wD)(o.issues.map((a) => Do(a, i, ko())))
  } : { success: !0, data: o.value };
}, s7 = /* @__PURE__ */ Ap(xD), Cp = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let o = t._zod.run({ value: n, issues: [] }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? {
    success: !1,
    error: new e(o.issues.map((a) => Do(a, i, ko())))
  } : { success: !0, data: o.value };
}, l7 = /* @__PURE__ */ Cp(xD), u7 = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Ub(e)(t, n, i);
}, c7 = (e) => (t, n, r) => Ub(e)(t, n, r), f7 = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return qb(e)(t, n, i);
}, d7 = (e) => async (t, n, r) => qb(e)(t, n, r), p7 = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Ap(e)(t, n, i);
}, h7 = (e) => (t, n, r) => Ap(e)(t, n, r), v7 = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Cp(e)(t, n, i);
}, m7 = (e) => async (t, n, r) => Cp(e)(t, n, r), g7 = /^[cC][^\s-]{8,}$/, y7 = /^[0-9a-z]+$/, b7 = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, _7 = /^[0-9a-vA-V]{20}$/, w7 = /^[A-Za-z0-9]{27}$/, x7 = /^[a-zA-Z0-9_-]{21}$/, E7 = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, S7 = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Fx = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, O7 = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, $7 = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function T7() {
  return new RegExp($7, "u");
}
const P7 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, k7 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, D7 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, A7 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, C7 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, ED = /^[A-Za-z0-9_-]*$/, I7 = /^\+[1-9]\d{6,14}$/, SD = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", N7 = /* @__PURE__ */ new RegExp(`^${SD}$`);
function OD(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function R7(e) {
  return new RegExp(`^${OD(e)}$`);
}
function M7(e) {
  const t = OD({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${SD}T(?:${r})$`);
}
const j7 = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, F7 = /^-?\d+$/, $D = /^-?\d+(?:\.\d+)?$/, z7 = /^(?:true|false)$/i, L7 = /^[^A-Z]*$/, V7 = /^[^a-z]*$/, rr = /* @__PURE__ */ oe("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), TD = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, PD = /* @__PURE__ */ oe("$ZodCheckLessThan", (e, t) => {
  rr.init(e, t);
  const n = TD[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.maximum : i.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < o && (t.inclusive ? i.maximum = t.value : i.exclusiveMaximum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), kD = /* @__PURE__ */ oe("$ZodCheckGreaterThan", (e, t) => {
  rr.init(e, t);
  const n = TD[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.minimum : i.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > o && (t.inclusive ? i.minimum = t.value : i.exclusiveMinimum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), K7 = /* @__PURE__ */ oe("$ZodCheckMultipleOf", (e, t) => {
  rr.init(e, t), e._zod.onattach.push((n) => {
    var r;
    (r = n._zod.bag).multipleOf ?? (r.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : HV(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), B7 = /* @__PURE__ */ oe("$ZodCheckNumberFormat", (e, t) => {
  var n;
  rr.init(e, t), t.format = t.format || "float64";
  const r = (n = t.format) == null ? void 0 : n.includes("int"), i = r ? "int" : "number", [o, a] = QV[t.format];
  e._zod.onattach.push((s) => {
    const l = s._zod.bag;
    l.format = t.format, l.minimum = o, l.maximum = a, r && (l.pattern = F7);
  }), e._zod.check = (s) => {
    const l = s.value;
    if (r) {
      if (!Number.isInteger(l)) {
        s.issues.push({
          expected: i,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: l,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(l)) {
        l > 0 ? s.issues.push({
          input: l,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        }) : s.issues.push({
          input: l,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    l < o && s.issues.push({
      origin: "number",
      input: l,
      code: "too_small",
      minimum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), l > a && s.issues.push({
      origin: "number",
      input: l,
      code: "too_big",
      maximum: a,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), U7 = /* @__PURE__ */ oe("$ZodCheckMaxLength", (e, t) => {
  var n;
  rr.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Vb(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length <= t.maximum)
      return;
    const o = Bb(i);
    r.issues.push({
      origin: o,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), q7 = /* @__PURE__ */ oe("$ZodCheckMinLength", (e, t) => {
  var n;
  rr.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Vb(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length >= t.minimum)
      return;
    const o = Bb(i);
    r.issues.push({
      origin: o,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), H7 = /* @__PURE__ */ oe("$ZodCheckLengthEquals", (e, t) => {
  var n;
  rr.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Vb(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (r) => {
    const i = r.value, o = i.length;
    if (o === t.length)
      return;
    const a = Bb(i), s = o > t.length;
    r.issues.push({
      origin: a,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ip = /* @__PURE__ */ oe("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  rr.init(e, t), e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.format = t.format, t.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), W7 = /* @__PURE__ */ oe("$ZodCheckRegex", (e, t) => {
  Ip.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Z7 = /* @__PURE__ */ oe("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = L7), Ip.init(e, t);
}), G7 = /* @__PURE__ */ oe("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = V7), Ip.init(e, t);
}), Y7 = /* @__PURE__ */ oe("$ZodCheckIncludes", (e, t) => {
  rr.init(e, t);
  const n = Fs(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(r);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Q7 = /* @__PURE__ */ oe("$ZodCheckStartsWith", (e, t) => {
  rr.init(e, t);
  const n = new RegExp(`^${Fs(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), J7 = /* @__PURE__ */ oe("$ZodCheckEndsWith", (e, t) => {
  rr.init(e, t);
  const n = new RegExp(`.*${Fs(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), X7 = /* @__PURE__ */ oe("$ZodCheckOverwrite", (e, t) => {
  rr.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
let eK = class {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((o) => o), r = Math.min(...n.map((o) => o.length - o.trimStart().length)), i = n.map((o) => o.slice(r)).map((o) => " ".repeat(this.indent * 2) + o);
    for (const o of i)
      this.content.push(o);
  }
  compile() {
    const t = Function, n = this == null ? void 0 : this.args, r = [...((this == null ? void 0 : this.content) ?? [""]).map((i) => `  ${i}`)];
    return new t(...n, r.join(`
`));
  }
};
const tK = {
  major: 4,
  minor: 3,
  patch: 6
}, jt = /* @__PURE__ */ oe("$ZodType", (e, t) => {
  var n, r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = tK;
  const i = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && i.unshift(e);
  for (const o of i)
    for (const a of o._zod.onattach)
      a(e);
  if (i.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (n = e._zod.deferred) == null || n.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (s, l, u) => {
      let c = cs(s), f;
      for (const d of l) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(s))
            continue;
        } else if (c)
          continue;
        const p = s.issues.length, h = d._zod.check(s);
        if (h instanceof Promise && u?.async === !1)
          throw new Os();
        if (f || h instanceof Promise)
          f = (f ?? Promise.resolve()).then(async () => {
            await h, s.issues.length !== p && (c || (c = cs(s, p)));
          });
        else {
          if (s.issues.length === p)
            continue;
          c || (c = cs(s, p));
        }
      }
      return f ? f.then(() => s) : s;
    }, a = (s, l, u) => {
      if (cs(s))
        return s.aborted = !0, s;
      const c = o(l, i, u);
      if (c instanceof Promise) {
        if (u.async === !1)
          throw new Os();
        return c.then((f) => e._zod.parse(f, u));
      }
      return e._zod.parse(c, u);
    };
    e._zod.run = (s, l) => {
      if (l.skipChecks)
        return e._zod.parse(s, l);
      if (l.direction === "backward") {
        const c = e._zod.parse({ value: s.value, issues: [] }, { ...l, skipChecks: !0 });
        return c instanceof Promise ? c.then((f) => a(f, s, l)) : a(c, s, l);
      }
      const u = e._zod.parse(s, l);
      if (u instanceof Promise) {
        if (l.async === !1)
          throw new Os();
        return u.then((c) => o(c, i, l));
      }
      return o(u, i, l);
    };
  }
  lt(e, "~standard", () => ({
    validate: (o) => {
      var a;
      try {
        const s = s7(e, o);
        return s.success ? { value: s.data } : { issues: (a = s.error) == null ? void 0 : a.issues };
      } catch {
        return l7(e, o).then((s) => {
          var l;
          return s.success ? { value: s.data } : { issues: (l = s.error) == null ? void 0 : l.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Hb = /* @__PURE__ */ oe("$ZodString", (e, t) => {
  var n;
  jt.init(e, t), e._zod.pattern = [...((n = e?._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? j7(e._zod.bag), e._zod.parse = (r, i) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), Bt = /* @__PURE__ */ oe("$ZodStringFormat", (e, t) => {
  Ip.init(e, t), Hb.init(e, t);
}), nK = /* @__PURE__ */ oe("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = S7), Bt.init(e, t);
}), rK = /* @__PURE__ */ oe("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Fx(n));
  } else
    t.pattern ?? (t.pattern = Fx());
  Bt.init(e, t);
}), iK = /* @__PURE__ */ oe("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = O7), Bt.init(e, t);
}), oK = /* @__PURE__ */ oe("$ZodURL", (e, t) => {
  Bt.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value.trim(), i = new URL(r);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = i.href : n.value = r;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), aK = /* @__PURE__ */ oe("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = T7()), Bt.init(e, t);
}), sK = /* @__PURE__ */ oe("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = x7), Bt.init(e, t);
}), lK = /* @__PURE__ */ oe("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = g7), Bt.init(e, t);
}), uK = /* @__PURE__ */ oe("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = y7), Bt.init(e, t);
}), cK = /* @__PURE__ */ oe("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = b7), Bt.init(e, t);
}), fK = /* @__PURE__ */ oe("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = _7), Bt.init(e, t);
}), dK = /* @__PURE__ */ oe("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = w7), Bt.init(e, t);
}), pK = /* @__PURE__ */ oe("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = M7(t)), Bt.init(e, t);
}), hK = /* @__PURE__ */ oe("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = N7), Bt.init(e, t);
}), vK = /* @__PURE__ */ oe("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = R7(t)), Bt.init(e, t);
}), mK = /* @__PURE__ */ oe("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = E7), Bt.init(e, t);
}), gK = /* @__PURE__ */ oe("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = P7), Bt.init(e, t), e._zod.bag.format = "ipv4";
}), yK = /* @__PURE__ */ oe("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = k7), Bt.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), bK = /* @__PURE__ */ oe("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = D7), Bt.init(e, t);
}), _K = /* @__PURE__ */ oe("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = A7), Bt.init(e, t), e._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [i, o] = r;
      if (!o)
        throw new Error();
      const a = Number(o);
      if (`${a}` !== o)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function DD(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const wK = /* @__PURE__ */ oe("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = C7), Bt.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
    DD(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function xK(e) {
  if (!ED.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return DD(n);
}
const EK = /* @__PURE__ */ oe("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = ED), Bt.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
    xK(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), SK = /* @__PURE__ */ oe("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = I7), Bt.init(e, t);
});
function OK(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const i = JSON.parse(atob(r));
    return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const $K = /* @__PURE__ */ oe("$ZodJWT", (e, t) => {
  Bt.init(e, t), e._zod.check = (n) => {
    OK(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), AD = /* @__PURE__ */ oe("$ZodNumber", (e, t) => {
  jt.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? $D, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const i = n.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return n;
    const o = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...o ? { received: o } : {}
    }), n;
  };
}), TK = /* @__PURE__ */ oe("$ZodNumberFormat", (e, t) => {
  B7.init(e, t), AD.init(e, t);
}), PK = /* @__PURE__ */ oe("$ZodBoolean", (e, t) => {
  jt.init(e, t), e._zod.pattern = z7, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const i = n.value;
    return typeof i == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), n;
  };
}), kK = /* @__PURE__ */ oe("$ZodUnknown", (e, t) => {
  jt.init(e, t), e._zod.parse = (n) => n;
}), DK = /* @__PURE__ */ oe("$ZodNever", (e, t) => {
  jt.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
}), AK = /* @__PURE__ */ oe("$ZodDate", (e, t) => {
  jt.init(e, t), e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = new Date(n.value);
      } catch {
      }
    const i = n.value, o = i instanceof Date;
    return o && !Number.isNaN(i.getTime()) || n.issues.push({
      expected: "date",
      code: "invalid_type",
      input: i,
      ...o ? { received: "Invalid Date" } : {},
      inst: e
    }), n;
  };
});
function zx(e, t, n) {
  e.issues.length && t.issues.push(...fs(n, e.issues)), t.value[n] = e.value;
}
const CK = /* @__PURE__ */ oe("$ZodArray", (e, t) => {
  jt.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Array.isArray(i))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    n.value = Array(i.length);
    const o = [];
    for (let a = 0; a < i.length; a++) {
      const s = i[a], l = t.element._zod.run({
        value: s,
        issues: []
      }, r);
      l instanceof Promise ? o.push(l.then((u) => zx(u, n, a))) : zx(l, n, a);
    }
    return o.length ? Promise.all(o).then(() => n) : n;
  };
});
function $d(e, t, n, r, i) {
  if (e.issues.length) {
    if (i && !(n in r))
      return;
    t.issues.push(...fs(n, e.issues));
  }
  e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
function CD(e) {
  var t, n, r, i;
  const o = Object.keys(e.shape);
  for (const s of o)
    if (!((i = (r = (n = (t = e.shape) == null ? void 0 : t[s]) == null ? void 0 : n._zod) == null ? void 0 : r.traits) != null && i.has("$ZodType")))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const a = YV(e.shape);
  return {
    ...e,
    keys: o,
    keySet: new Set(o),
    numKeys: o.length,
    optionalKeys: new Set(a)
  };
}
function ID(e, t, n, r, i, o) {
  const a = [], s = i.keySet, l = i.catchall._zod, u = l.def.type, c = l.optout === "optional";
  for (const f in t) {
    if (s.has(f))
      continue;
    if (u === "never") {
      a.push(f);
      continue;
    }
    const d = l.run({ value: t[f], issues: [] }, r);
    d instanceof Promise ? e.push(d.then((p) => $d(p, n, f, t, c))) : $d(d, n, f, t, c);
  }
  return a.length && n.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: t,
    inst: o
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const IK = /* @__PURE__ */ oe("$ZodObject", (e, t) => {
  jt.init(e, t);
  const n = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(n != null && n.get)) {
    const s = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const l = { ...s };
        return Object.defineProperty(t, "shape", {
          value: l
        }), l;
      }
    });
  }
  const r = Lb(() => CD(t));
  lt(e._zod, "propValues", () => {
    const s = t.shape, l = {};
    for (const u in s) {
      const c = s[u]._zod;
      if (c.values) {
        l[u] ?? (l[u] = /* @__PURE__ */ new Set());
        for (const f of c.values)
          l[u].add(f);
      }
    }
    return l;
  });
  const i = Od, o = t.catchall;
  let a;
  e._zod.parse = (s, l) => {
    a ?? (a = r.value);
    const u = s.value;
    if (!i(u))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: u,
        inst: e
      }), s;
    s.value = {};
    const c = [], f = a.shape;
    for (const d of a.keys) {
      const p = f[d], h = p._zod.optout === "optional", v = p._zod.run({ value: u[d], issues: [] }, l);
      v instanceof Promise ? c.push(v.then((m) => $d(m, s, d, u, h))) : $d(v, s, d, u, h);
    }
    return o ? ID(c, u, s, l, r.value, e) : c.length ? Promise.all(c).then(() => s) : s;
  };
}), NK = /* @__PURE__ */ oe("$ZodObjectJIT", (e, t) => {
  IK.init(e, t);
  const n = e._zod.parse, r = Lb(() => CD(t)), i = (f) => {
    var d;
    const p = new eK(["shape", "payload", "ctx"]), h = r.value, v = (w) => {
      const x = jx(w);
      return `shape[${x}]._zod.run({ value: input[${x}], issues: [] }, ctx)`;
    };
    p.write("const input = payload.value;");
    const m = /* @__PURE__ */ Object.create(null);
    let g = 0;
    for (const w of h.keys)
      m[w] = `key_${g++}`;
    p.write("const newResult = {};");
    for (const w of h.keys) {
      const x = m[w], S = jx(w), $ = f[w], A = ((d = $?._zod) == null ? void 0 : d.optout) === "optional";
      p.write(`const ${x} = ${v(w)};`), A ? p.write(`
        if (${x}.issues.length) {
          if (${S} in input) {
            payload.issues = payload.issues.concat(${x}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${S}, ...iss.path] : [${S}]
            })));
          }
        }
        
        if (${x}.value === undefined) {
          if (${S} in input) {
            newResult[${S}] = undefined;
          }
        } else {
          newResult[${S}] = ${x}.value;
        }
        
      `) : p.write(`
        if (${x}.issues.length) {
          payload.issues = payload.issues.concat(${x}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${S}, ...iss.path] : [${S}]
          })));
        }
        
        if (${x}.value === undefined) {
          if (${S} in input) {
            newResult[${S}] = undefined;
          }
        } else {
          newResult[${S}] = ${x}.value;
        }
        
      `);
    }
    p.write("payload.value = newResult;"), p.write("return payload;");
    const _ = p.compile();
    return (w, x) => _(f, w, x);
  };
  let o;
  const a = Od, s = !mD.jitless, l = s && ZV.value, u = t.catchall;
  let c;
  e._zod.parse = (f, d) => {
    c ?? (c = r.value);
    const p = f.value;
    return a(p) ? s && l && d?.async === !1 && d.jitless !== !0 ? (o || (o = i(t.shape)), f = o(f, d), u ? ID([], p, f, d, c, e) : f) : n(f, d) : (f.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), f);
  };
});
function Lx(e, t, n, r) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  const i = e.filter((o) => !cs(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((o) => o.issues.map((a) => Do(a, r, ko())))
  }), t);
}
const RK = /* @__PURE__ */ oe("$ZodUnion", (e, t) => {
  jt.init(e, t), lt(e._zod, "optin", () => t.options.some((i) => i._zod.optin === "optional") ? "optional" : void 0), lt(e._zod, "optout", () => t.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), lt(e._zod, "values", () => {
    if (t.options.every((i) => i._zod.values))
      return new Set(t.options.flatMap((i) => Array.from(i._zod.values)));
  }), lt(e._zod, "pattern", () => {
    if (t.options.every((i) => i._zod.pattern)) {
      const i = t.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${i.map((o) => Kb(o.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, r = t.options[0]._zod.run;
  e._zod.parse = (i, o) => {
    if (n)
      return r(i, o);
    let a = !1;
    const s = [];
    for (const l of t.options) {
      const u = l._zod.run({
        value: i.value,
        issues: []
      }, o);
      if (u instanceof Promise)
        s.push(u), a = !0;
      else {
        if (u.issues.length === 0)
          return u;
        s.push(u);
      }
    }
    return a ? Promise.all(s).then((l) => Lx(l, i, e, o)) : Lx(s, i, e, o);
  };
}), MK = /* @__PURE__ */ oe("$ZodIntersection", (e, t) => {
  jt.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value, o = t.left._zod.run({ value: i, issues: [] }, r), a = t.right._zod.run({ value: i, issues: [] }, r);
    return o instanceof Promise || a instanceof Promise ? Promise.all([o, a]).then(([s, l]) => Vx(n, s, l)) : Vx(n, o, a);
  };
});
function pg(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (js(e) && js(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((o) => n.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of r) {
      const a = pg(e[o], t[o]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...a.mergeErrorPath]
        };
      i[o] = a.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const i = e[r], o = t[r], a = pg(i, o);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...a.mergeErrorPath]
        };
      n.push(a.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Vx(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  let i;
  for (const s of t.issues)
    if (s.code === "unrecognized_keys") {
      i ?? (i = s);
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).l = !0;
    } else
      e.issues.push(s);
  for (const s of n.issues)
    if (s.code === "unrecognized_keys")
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).r = !0;
    else
      e.issues.push(s);
  const o = [...r].filter(([, s]) => s.l && s.r).map(([s]) => s);
  if (o.length && i && e.issues.push({ ...i, keys: o }), cs(e))
    return e;
  const a = pg(t.value, n.value);
  if (!a.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(a.mergeErrorPath)}`);
  return e.value = a.data, e;
}
const jK = /* @__PURE__ */ oe("$ZodRecord", (e, t) => {
  jt.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!js(i))
      return n.issues.push({
        expected: "record",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    const o = [], a = t.keyType._zod.values;
    if (a) {
      n.value = {};
      const s = /* @__PURE__ */ new Set();
      for (const u of a)
        if (typeof u == "string" || typeof u == "number" || typeof u == "symbol") {
          s.add(typeof u == "number" ? u.toString() : u);
          const c = t.valueType._zod.run({ value: i[u], issues: [] }, r);
          c instanceof Promise ? o.push(c.then((f) => {
            f.issues.length && n.issues.push(...fs(u, f.issues)), n.value[u] = f.value;
          })) : (c.issues.length && n.issues.push(...fs(u, c.issues)), n.value[u] = c.value);
        }
      let l;
      for (const u in i)
        s.has(u) || (l = l ?? [], l.push(u));
      l && l.length > 0 && n.issues.push({
        code: "unrecognized_keys",
        input: i,
        inst: e,
        keys: l
      });
    } else {
      n.value = {};
      for (const s of Reflect.ownKeys(i)) {
        if (s === "__proto__")
          continue;
        let l = t.keyType._zod.run({ value: s, issues: [] }, r);
        if (l instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (typeof s == "string" && $D.test(s) && l.issues.length) {
          const c = t.keyType._zod.run({ value: Number(s), issues: [] }, r);
          if (c instanceof Promise)
            throw new Error("Async schemas not supported in object keys currently");
          c.issues.length === 0 && (l = c);
        }
        if (l.issues.length) {
          t.mode === "loose" ? n.value[s] = i[s] : n.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: l.issues.map((c) => Do(c, r, ko())),
            input: s,
            path: [s],
            inst: e
          });
          continue;
        }
        const u = t.valueType._zod.run({ value: i[s], issues: [] }, r);
        u instanceof Promise ? o.push(u.then((c) => {
          c.issues.length && n.issues.push(...fs(s, c.issues)), n.value[l.value] = c.value;
        })) : (u.issues.length && n.issues.push(...fs(s, u.issues)), n.value[l.value] = u.value);
      }
    }
    return o.length ? Promise.all(o).then(() => n) : n;
  };
}), FK = /* @__PURE__ */ oe("$ZodEnum", (e, t) => {
  jt.init(e, t);
  const n = gD(t.entries), r = new Set(n);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.filter((i) => GV.has(typeof i)).map((i) => typeof i == "string" ? Fs(i) : i.toString()).join("|")})$`), e._zod.parse = (i, o) => {
    const a = i.value;
    return r.has(a) || i.issues.push({
      code: "invalid_value",
      values: n,
      input: a,
      inst: e
    }), i;
  };
}), zK = /* @__PURE__ */ oe("$ZodLiteral", (e, t) => {
  if (jt.init(e, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const n = new Set(t.values);
  e._zod.values = n, e._zod.pattern = new RegExp(`^(${t.values.map((r) => typeof r == "string" ? Fs(r) : r ? Fs(r.toString()) : String(r)).join("|")})$`), e._zod.parse = (r, i) => {
    const o = r.value;
    return n.has(o) || r.issues.push({
      code: "invalid_value",
      values: t.values,
      input: o,
      inst: e
    }), r;
  };
}), LK = /* @__PURE__ */ oe("$ZodTransform", (e, t) => {
  jt.init(e, t), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new vD(e.constructor.name);
    const i = t.transform(n.value, n);
    if (r.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((o) => (n.value = o, n));
    if (i instanceof Promise)
      throw new Os();
    return n.value = i, n;
  };
});
function Kx(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const ND = /* @__PURE__ */ oe("$ZodOptional", (e, t) => {
  jt.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", lt(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), lt(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Kb(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (t.innerType._zod.optin === "optional") {
      const i = t.innerType._zod.run(n, r);
      return i instanceof Promise ? i.then((o) => Kx(o, n.value)) : Kx(i, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, r);
  };
}), VK = /* @__PURE__ */ oe("$ZodExactOptional", (e, t) => {
  ND.init(e, t), lt(e._zod, "values", () => t.innerType._zod.values), lt(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (n, r) => t.innerType._zod.run(n, r);
}), KK = /* @__PURE__ */ oe("$ZodNullable", (e, t) => {
  jt.init(e, t), lt(e._zod, "optin", () => t.innerType._zod.optin), lt(e._zod, "optout", () => t.innerType._zod.optout), lt(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Kb(n.source)}|null)$`) : void 0;
  }), lt(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), BK = /* @__PURE__ */ oe("$ZodDefault", (e, t) => {
  jt.init(e, t), e._zod.optin = "optional", lt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => Bx(o, t)) : Bx(i, t);
  };
});
function Bx(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const UK = /* @__PURE__ */ oe("$ZodPrefault", (e, t) => {
  jt.init(e, t), e._zod.optin = "optional", lt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), qK = /* @__PURE__ */ oe("$ZodNonOptional", (e, t) => {
  jt.init(e, t), lt(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => Ux(o, e)) : Ux(i, e);
  };
});
function Ux(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const HK = /* @__PURE__ */ oe("$ZodCatch", (e, t) => {
  jt.init(e, t), lt(e._zod, "optin", () => t.innerType._zod.optin), lt(e._zod, "optout", () => t.innerType._zod.optout), lt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((a) => Do(a, r, ko()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((o) => Do(o, r, ko()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), WK = /* @__PURE__ */ oe("$ZodPipe", (e, t) => {
  jt.init(e, t), lt(e._zod, "values", () => t.in._zod.values), lt(e._zod, "optin", () => t.in._zod.optin), lt(e._zod, "optout", () => t.out._zod.optout), lt(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const o = t.out._zod.run(n, r);
      return o instanceof Promise ? o.then((a) => sf(a, t.in, r)) : sf(o, t.in, r);
    }
    const i = t.in._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => sf(o, t.out, r)) : sf(i, t.out, r);
  };
});
function sf(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const ZK = /* @__PURE__ */ oe("$ZodReadonly", (e, t) => {
  jt.init(e, t), lt(e._zod, "propValues", () => t.innerType._zod.propValues), lt(e._zod, "values", () => t.innerType._zod.values), lt(e._zod, "optin", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin;
  }), lt(e._zod, "optout", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout;
  }), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then(qx) : qx(i);
  };
});
function qx(e) {
  return e.value = Object.freeze(e.value), e;
}
const GK = /* @__PURE__ */ oe("$ZodLazy", (e, t) => {
  jt.init(e, t), lt(e._zod, "innerType", () => t.getter()), lt(e._zod, "pattern", () => {
    var n, r;
    return (r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.pattern;
  }), lt(e._zod, "propValues", () => {
    var n, r;
    return (r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.propValues;
  }), lt(e._zod, "optin", () => {
    var n, r;
    return ((r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin) ?? void 0;
  }), lt(e._zod, "optout", () => {
    var n, r;
    return ((r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout) ?? void 0;
  }), e._zod.parse = (n, r) => e._zod.innerType._zod.run(n, r);
}), YK = /* @__PURE__ */ oe("$ZodCustom", (e, t) => {
  rr.init(e, t), jt.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, i = t.fn(r);
    if (i instanceof Promise)
      return i.then((o) => Hx(o, n, r, e));
    Hx(i, n, r, e);
  };
});
function Hx(e, t, n, r) {
  if (!e) {
    const i = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (i.params = r._zod.def.params), t.issues.push(Lu(i));
  }
}
var Wx;
let QK = class {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    return this._map.set(t, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const i = { ...r, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
};
function JK() {
  return new QK();
}
(Wx = globalThis).__zod_globalRegistry ?? (Wx.__zod_globalRegistry = JK());
const Ql = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function XK(e, t) {
  return new e({
    type: "string",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function eB(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Zx(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function tB(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nB(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rB(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function iB(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function oB(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function aB(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sB(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lB(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function uB(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function cB(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fB(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function dB(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function pB(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function hB(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function vB(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function mB(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function gB(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function yB(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function bB(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function _B(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function wB(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xB(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function EB(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function SB(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function OB(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function $B(e, t) {
  return new e({
    type: "number",
    coerce: !0,
    checks: [],
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function TB(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function PB(e, t) {
  return new e({
    type: "boolean",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function kB(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function DB(e, t) {
  return new e({
    type: "never",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function AB(e, t) {
  return new e({
    type: "date",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Gx(e, t) {
  return new PD({
    check: "less_than",
    ...Be(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Rf(e, t) {
  return new PD({
    check: "less_than",
    ...Be(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Yx(e, t) {
  return new kD({
    check: "greater_than",
    ...Be(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Mf(e, t) {
  return new kD({
    check: "greater_than",
    ...Be(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Qx(e, t) {
  return new K7({
    check: "multiple_of",
    ...Be(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function RD(e, t) {
  return new U7({
    check: "max_length",
    ...Be(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function Td(e, t) {
  return new q7({
    check: "min_length",
    ...Be(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function MD(e, t) {
  return new H7({
    check: "length_equals",
    ...Be(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function CB(e, t) {
  return new W7({
    check: "string_format",
    format: "regex",
    ...Be(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function IB(e) {
  return new Z7({
    check: "string_format",
    format: "lowercase",
    ...Be(e)
  });
}
// @__NO_SIDE_EFFECTS__
function NB(e) {
  return new G7({
    check: "string_format",
    format: "uppercase",
    ...Be(e)
  });
}
// @__NO_SIDE_EFFECTS__
function RB(e, t) {
  return new Y7({
    check: "string_format",
    format: "includes",
    ...Be(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function MB(e, t) {
  return new Q7({
    check: "string_format",
    format: "starts_with",
    ...Be(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function jB(e, t) {
  return new J7({
    check: "string_format",
    format: "ends_with",
    ...Be(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function cl(e) {
  return new X7({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function FB(e) {
  return /* @__PURE__ */ cl((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function zB() {
  return /* @__PURE__ */ cl((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function LB() {
  return /* @__PURE__ */ cl((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function VB() {
  return /* @__PURE__ */ cl((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function KB() {
  return /* @__PURE__ */ cl((e) => WV(e));
}
// @__NO_SIDE_EFFECTS__
function BB(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...Be(n)
  });
}
// @__NO_SIDE_EFFECTS__
function UB(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...Be(n)
  });
}
// @__NO_SIDE_EFFECTS__
function qB(e) {
  const t = /* @__PURE__ */ HB((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(Lu(r, n.value, t._zod.def));
    else {
      const i = r;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = t), i.continue ?? (i.continue = !t._zod.def.abort), n.issues.push(Lu(i));
    }
  }, e(n.value, n)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function HB(e, t) {
  const n = new rr({
    check: "custom",
    ...Be(t)
  });
  return n._zod.check = e, n;
}
function jD(e) {
  let t = e?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: e?.metadata ?? Ql,
    target: t,
    unrepresentable: e?.unrepresentable ?? "throw",
    override: e?.override ?? (() => {
    }),
    io: e?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: e?.cycles ?? "ref",
    reused: e?.reused ?? "inline",
    external: e?.external ?? void 0
  };
}
function rn(e, t, n = { path: [], schemaPath: [] }) {
  var r, i, o;
  const a = e._zod.def, s = t.seen.get(e);
  if (s)
    return s.count++, n.schemaPath.includes(e) && (s.cycle = n.path), s.schema;
  const l = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, l);
  const u = (i = (r = e._zod).toJSONSchema) == null ? void 0 : i.call(r);
  if (u)
    l.schema = u;
  else {
    const f = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, l.schema, f);
    else {
      const p = l.schema, h = t.processors[a.type];
      if (!h)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${a.type}`);
      h(e, t, p, f);
    }
    const d = e._zod.parent;
    d && (l.ref || (l.ref = d), rn(d, t, f), t.seen.get(d).isParent = !0);
  }
  const c = t.metadataRegistry.get(e);
  return c && Object.assign(l.schema, c), t.io === "input" && jn(e) && (delete l.schema.examples, delete l.schema.default), t.io === "input" && l.schema._prefault && ((o = l.schema).default ?? (o.default = l.schema._prefault)), delete l.schema._prefault, t.seen.get(e).schema;
}
function FD(e, t) {
  var n, r, i, o;
  const a = e.seen.get(t);
  if (!a)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const s = /* @__PURE__ */ new Map();
  for (const c of e.seen.entries()) {
    const f = (n = e.metadataRegistry.get(c[0])) == null ? void 0 : n.id;
    if (f) {
      const d = s.get(f);
      if (d && d !== c[0])
        throw new Error(`Duplicate schema id "${f}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      s.set(f, c[0]);
    }
  }
  const l = (c) => {
    var f;
    const d = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const v = (f = e.external.registry.get(c[0])) == null ? void 0 : f.id, m = e.external.uri ?? ((_) => _);
      if (v)
        return { ref: m(v) };
      const g = c[1].defId ?? c[1].schema.id ?? `schema${e.counter++}`;
      return c[1].defId = g, { defId: g, ref: `${m("__shared")}#/${d}/${g}` };
    }
    if (c[1] === a)
      return { ref: "#" };
    const p = `#/${d}/`, h = c[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: h, ref: p + h };
  }, u = (c) => {
    if (c[1].schema.$ref)
      return;
    const f = c[1], { ref: d, defId: p } = l(c);
    f.def = { ...f.schema }, p && (f.defId = p);
    const h = f.schema;
    for (const v in h)
      delete h[v];
    h.$ref = d;
  };
  if (e.cycles === "throw")
    for (const c of e.seen.entries()) {
      const f = c[1];
      if (f.cycle)
        throw new Error(`Cycle detected: #/${(r = f.cycle) == null ? void 0 : r.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const c of e.seen.entries()) {
    const f = c[1];
    if (t === c[0]) {
      u(c);
      continue;
    }
    if (e.external) {
      const d = (i = e.external.registry.get(c[0])) == null ? void 0 : i.id;
      if (t !== c[0] && d) {
        u(c);
        continue;
      }
    }
    if ((o = e.metadataRegistry.get(c[0])) != null && o.id) {
      u(c);
      continue;
    }
    if (f.cycle) {
      u(c);
      continue;
    }
    if (f.count > 1 && e.reused === "ref") {
      u(c);
      continue;
    }
  }
}
function zD(e, t) {
  var n, r, i;
  const o = e.seen.get(t);
  if (!o)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = (u) => {
    const c = e.seen.get(u);
    if (c.ref === null)
      return;
    const f = c.def ?? c.schema, d = { ...f }, p = c.ref;
    if (c.ref = null, p) {
      a(p);
      const v = e.seen.get(p), m = v.schema;
      if (m.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (f.allOf = f.allOf ?? [], f.allOf.push(m)) : Object.assign(f, m), Object.assign(f, d), u._zod.parent === p)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in d || delete f[g];
      if (m.$ref && v.def)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in v.def && JSON.stringify(f[g]) === JSON.stringify(v.def[g]) && delete f[g];
    }
    const h = u._zod.parent;
    if (h && h !== p) {
      a(h);
      const v = e.seen.get(h);
      if (v != null && v.schema.$ref && (f.$ref = v.schema.$ref, v.def))
        for (const m in f)
          m === "$ref" || m === "allOf" || m in v.def && JSON.stringify(f[m]) === JSON.stringify(v.def[m]) && delete f[m];
    }
    e.override({
      zodSchema: u,
      jsonSchema: f,
      path: c.path ?? []
    });
  };
  for (const u of [...e.seen.entries()].reverse())
    a(u[0]);
  const s = {};
  if (e.target === "draft-2020-12" ? s.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? s.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? s.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (n = e.external) != null && n.uri) {
    const u = (r = e.external.registry.get(t)) == null ? void 0 : r.id;
    if (!u)
      throw new Error("Schema is missing an `id` property");
    s.$id = e.external.uri(u);
  }
  Object.assign(s, o.def ?? o.schema);
  const l = ((i = e.external) == null ? void 0 : i.defs) ?? {};
  for (const u of e.seen.entries()) {
    const c = u[1];
    c.def && c.defId && (l[c.defId] = c.def);
  }
  e.external || Object.keys(l).length > 0 && (e.target === "draft-2020-12" ? s.$defs = l : s.definitions = l);
  try {
    const u = JSON.parse(JSON.stringify(s));
    return Object.defineProperty(u, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: Pd(t, "input", e.processors),
          output: Pd(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), u;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function jn(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const r = e._zod.def;
  if (r.type === "transform")
    return !0;
  if (r.type === "array")
    return jn(r.element, n);
  if (r.type === "set")
    return jn(r.valueType, n);
  if (r.type === "lazy")
    return jn(r.getter(), n);
  if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault")
    return jn(r.innerType, n);
  if (r.type === "intersection")
    return jn(r.left, n) || jn(r.right, n);
  if (r.type === "record" || r.type === "map")
    return jn(r.keyType, n) || jn(r.valueType, n);
  if (r.type === "pipe")
    return jn(r.in, n) || jn(r.out, n);
  if (r.type === "object") {
    for (const i in r.shape)
      if (jn(r.shape[i], n))
        return !0;
    return !1;
  }
  if (r.type === "union") {
    for (const i of r.options)
      if (jn(i, n))
        return !0;
    return !1;
  }
  if (r.type === "tuple") {
    for (const i of r.items)
      if (jn(i, n))
        return !0;
    return !!(r.rest && jn(r.rest, n));
  }
  return !1;
}
const WB = (e, t = {}) => (n) => {
  const r = jD({ ...n, processors: t });
  return rn(e, r), FD(r, e), zD(r, e);
}, Pd = (e, t, n = {}) => (r) => {
  const { libraryOptions: i, target: o } = r ?? {}, a = jD({ ...i ?? {}, target: o, io: t, processors: n });
  return rn(e, a), FD(a, e), zD(a, e);
}, ZB = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, GB = (e, t, n, r) => {
  const i = n;
  i.type = "string";
  const { minimum: o, maximum: a, format: s, patterns: l, contentEncoding: u } = e._zod.bag;
  if (typeof o == "number" && (i.minLength = o), typeof a == "number" && (i.maxLength = a), s && (i.format = ZB[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), u && (i.contentEncoding = u), l && l.size > 0) {
    const c = [...l];
    c.length === 1 ? i.pattern = c[0].source : c.length > 1 && (i.allOf = [
      ...c.map((f) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: f.source
      }))
    ]);
  }
}, YB = (e, t, n, r) => {
  const i = n, { minimum: o, maximum: a, format: s, multipleOf: l, exclusiveMaximum: u, exclusiveMinimum: c } = e._zod.bag;
  typeof s == "string" && s.includes("int") ? i.type = "integer" : i.type = "number", typeof c == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.minimum = c, i.exclusiveMinimum = !0) : i.exclusiveMinimum = c), typeof o == "number" && (i.minimum = o, typeof c == "number" && t.target !== "draft-04" && (c >= o ? delete i.minimum : delete i.exclusiveMinimum)), typeof u == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.maximum = u, i.exclusiveMaximum = !0) : i.exclusiveMaximum = u), typeof a == "number" && (i.maximum = a, typeof u == "number" && t.target !== "draft-04" && (u <= a ? delete i.maximum : delete i.exclusiveMaximum)), typeof l == "number" && (i.multipleOf = l);
}, QB = (e, t, n, r) => {
  n.type = "boolean";
}, JB = (e, t, n, r) => {
  n.not = {};
}, XB = (e, t, n, r) => {
}, eU = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Date cannot be represented in JSON Schema");
}, tU = (e, t, n, r) => {
  const i = e._zod.def, o = gD(i.entries);
  o.every((a) => typeof a == "number") && (n.type = "number"), o.every((a) => typeof a == "string") && (n.type = "string"), n.enum = o;
}, nU = (e, t, n, r) => {
  const i = e._zod.def, o = [];
  for (const a of i.values)
    if (a === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof a == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      o.push(Number(a));
    } else
      o.push(a);
  if (o.length !== 0) if (o.length === 1) {
    const a = o[0];
    n.type = a === null ? "null" : typeof a, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [a] : n.const = a;
  } else
    o.every((a) => typeof a == "number") && (n.type = "number"), o.every((a) => typeof a == "string") && (n.type = "string"), o.every((a) => typeof a == "boolean") && (n.type = "boolean"), o.every((a) => a === null) && (n.type = "null"), n.enum = o;
}, rU = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, iU = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, oU = (e, t, n, r) => {
  const i = n, o = e._zod.def, { minimum: a, maximum: s } = e._zod.bag;
  typeof a == "number" && (i.minItems = a), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = rn(o.element, t, { ...r, path: [...r.path, "items"] });
}, aU = (e, t, n, r) => {
  var i;
  const o = n, a = e._zod.def;
  o.type = "object", o.properties = {};
  const s = a.shape;
  for (const c in s)
    o.properties[c] = rn(s[c], t, {
      ...r,
      path: [...r.path, "properties", c]
    });
  const l = new Set(Object.keys(s)), u = new Set([...l].filter((c) => {
    const f = a.shape[c]._zod;
    return t.io === "input" ? f.optin === void 0 : f.optout === void 0;
  }));
  u.size > 0 && (o.required = Array.from(u)), ((i = a.catchall) == null ? void 0 : i._zod.def.type) === "never" ? o.additionalProperties = !1 : a.catchall ? a.catchall && (o.additionalProperties = rn(a.catchall, t, {
    ...r,
    path: [...r.path, "additionalProperties"]
  })) : t.io === "output" && (o.additionalProperties = !1);
}, sU = (e, t, n, r) => {
  const i = e._zod.def, o = i.inclusive === !1, a = i.options.map((s, l) => rn(s, t, {
    ...r,
    path: [...r.path, o ? "oneOf" : "anyOf", l]
  }));
  o ? n.oneOf = a : n.anyOf = a;
}, lU = (e, t, n, r) => {
  const i = e._zod.def, o = rn(i.left, t, {
    ...r,
    path: [...r.path, "allOf", 0]
  }), a = rn(i.right, t, {
    ...r,
    path: [...r.path, "allOf", 1]
  }), s = (u) => "allOf" in u && Object.keys(u).length === 1, l = [
    ...s(o) ? o.allOf : [o],
    ...s(a) ? a.allOf : [a]
  ];
  n.allOf = l;
}, uU = (e, t, n, r) => {
  const i = n, o = e._zod.def;
  i.type = "object";
  const a = o.keyType, s = a._zod.bag, l = s?.patterns;
  if (o.mode === "loose" && l && l.size > 0) {
    const c = rn(o.valueType, t, {
      ...r,
      path: [...r.path, "patternProperties", "*"]
    });
    i.patternProperties = {};
    for (const f of l)
      i.patternProperties[f.source] = c;
  } else
    (t.target === "draft-07" || t.target === "draft-2020-12") && (i.propertyNames = rn(o.keyType, t, {
      ...r,
      path: [...r.path, "propertyNames"]
    })), i.additionalProperties = rn(o.valueType, t, {
      ...r,
      path: [...r.path, "additionalProperties"]
    });
  const u = a._zod.values;
  if (u) {
    const c = [...u].filter((f) => typeof f == "string" || typeof f == "number");
    c.length > 0 && (i.required = c);
  }
}, cU = (e, t, n, r) => {
  const i = e._zod.def, o = rn(i.innerType, t, r), a = t.seen.get(e);
  t.target === "openapi-3.0" ? (a.ref = i.innerType, n.nullable = !0) : n.anyOf = [o, { type: "null" }];
}, fU = (e, t, n, r) => {
  const i = e._zod.def;
  rn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, dU = (e, t, n, r) => {
  const i = e._zod.def;
  rn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.default = JSON.parse(JSON.stringify(i.defaultValue));
}, pU = (e, t, n, r) => {
  const i = e._zod.def;
  rn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, hU = (e, t, n, r) => {
  const i = e._zod.def;
  rn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  let a;
  try {
    a = i.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = a;
}, vU = (e, t, n, r) => {
  const i = e._zod.def, o = t.io === "input" ? i.in._zod.def.type === "transform" ? i.out : i.in : i.out;
  rn(o, t, r);
  const a = t.seen.get(e);
  a.ref = o;
}, mU = (e, t, n, r) => {
  const i = e._zod.def;
  rn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.readOnly = !0;
}, LD = (e, t, n, r) => {
  const i = e._zod.def;
  rn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, gU = (e, t, n, r) => {
  const i = e._zod.innerType;
  rn(i, t, r);
  const o = t.seen.get(e);
  o.ref = i;
}, yU = /* @__PURE__ */ oe("ZodISODateTime", (e, t) => {
  pK.init(e, t), Gt.init(e, t);
});
function bU(e) {
  return /* @__PURE__ */ wB(yU, e);
}
const _U = /* @__PURE__ */ oe("ZodISODate", (e, t) => {
  hK.init(e, t), Gt.init(e, t);
});
function wU(e) {
  return /* @__PURE__ */ xB(_U, e);
}
const xU = /* @__PURE__ */ oe("ZodISOTime", (e, t) => {
  vK.init(e, t), Gt.init(e, t);
});
function EU(e) {
  return /* @__PURE__ */ EB(xU, e);
}
const SU = /* @__PURE__ */ oe("ZodISODuration", (e, t) => {
  mK.init(e, t), Gt.init(e, t);
});
function OU(e) {
  return /* @__PURE__ */ SB(SU, e);
}
const $U = (e, t) => {
  wD.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => a7(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => o7(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, dg, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, dg, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Lr = oe("ZodError", $U, {
  Parent: Error
}), TU = /* @__PURE__ */ Ub(Lr), PU = /* @__PURE__ */ qb(Lr), kU = /* @__PURE__ */ Ap(Lr), DU = /* @__PURE__ */ Cp(Lr), AU = /* @__PURE__ */ u7(Lr), CU = /* @__PURE__ */ c7(Lr), IU = /* @__PURE__ */ f7(Lr), NU = /* @__PURE__ */ d7(Lr), RU = /* @__PURE__ */ p7(Lr), MU = /* @__PURE__ */ h7(Lr), jU = /* @__PURE__ */ v7(Lr), FU = /* @__PURE__ */ m7(Lr), Ft = /* @__PURE__ */ oe("ZodType", (e, t) => (jt.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: Pd(e, "input"),
    output: Pd(e, "output")
  }
}), e.toJSONSchema = WB(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(jo(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (n, r) => Fo(e, n, r), e.brand = () => e, e.register = ((n, r) => (n.add(e, r), e)), e.parse = (n, r) => TU(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => kU(e, n, r), e.parseAsync = async (n, r) => PU(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => DU(e, n, r), e.spa = e.safeParseAsync, e.encode = (n, r) => AU(e, n, r), e.decode = (n, r) => CU(e, n, r), e.encodeAsync = async (n, r) => IU(e, n, r), e.decodeAsync = async (n, r) => NU(e, n, r), e.safeEncode = (n, r) => RU(e, n, r), e.safeDecode = (n, r) => MU(e, n, r), e.safeEncodeAsync = async (n, r) => jU(e, n, r), e.safeDecodeAsync = async (n, r) => FU(e, n, r), e.refine = (n, r) => e.check(Nq(n, r)), e.superRefine = (n) => e.check(Rq(n)), e.overwrite = (n) => e.check(/* @__PURE__ */ cl(n)), e.optional = () => eE(e), e.exactOptional = () => _q(e), e.nullable = () => tE(e), e.nullish = () => eE(tE(e)), e.nonoptional = (n) => $q(e, n), e.array = () => Xn(e), e.or = (n) => za([e, n]), e.and = (n) => hq(e, n), e.transform = (n) => nE(e, yq(n)), e.default = (n) => Eq(e, n), e.prefault = (n) => Oq(e, n), e.catch = (n) => Pq(e, n), e.pipe = (n) => nE(e, n), e.readonly = () => Aq(e), e.describe = (n) => {
  const r = e.clone();
  return Ql.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    var n;
    return (n = Ql.get(e)) == null ? void 0 : n.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return Ql.get(e);
  const r = e.clone();
  return Ql.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (n) => n(e), e)), VD = /* @__PURE__ */ oe("_ZodString", (e, t) => {
  Hb.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (r, i, o) => GB(e, r, i);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(/* @__PURE__ */ CB(...r)), e.includes = (...r) => e.check(/* @__PURE__ */ RB(...r)), e.startsWith = (...r) => e.check(/* @__PURE__ */ MB(...r)), e.endsWith = (...r) => e.check(/* @__PURE__ */ jB(...r)), e.min = (...r) => e.check(/* @__PURE__ */ Td(...r)), e.max = (...r) => e.check(/* @__PURE__ */ RD(...r)), e.length = (...r) => e.check(/* @__PURE__ */ MD(...r)), e.nonempty = (...r) => e.check(/* @__PURE__ */ Td(1, ...r)), e.lowercase = (r) => e.check(/* @__PURE__ */ IB(r)), e.uppercase = (r) => e.check(/* @__PURE__ */ NB(r)), e.trim = () => e.check(/* @__PURE__ */ zB()), e.normalize = (...r) => e.check(/* @__PURE__ */ FB(...r)), e.toLowerCase = () => e.check(/* @__PURE__ */ LB()), e.toUpperCase = () => e.check(/* @__PURE__ */ VB()), e.slugify = () => e.check(/* @__PURE__ */ KB());
}), zU = /* @__PURE__ */ oe("ZodString", (e, t) => {
  Hb.init(e, t), VD.init(e, t), e.email = (n) => e.check(/* @__PURE__ */ eB(LU, n)), e.url = (n) => e.check(/* @__PURE__ */ oB(VU, n)), e.jwt = (n) => e.check(/* @__PURE__ */ _B(nq, n)), e.emoji = (n) => e.check(/* @__PURE__ */ aB(KU, n)), e.guid = (n) => e.check(/* @__PURE__ */ Zx(Jx, n)), e.uuid = (n) => e.check(/* @__PURE__ */ tB(lf, n)), e.uuidv4 = (n) => e.check(/* @__PURE__ */ nB(lf, n)), e.uuidv6 = (n) => e.check(/* @__PURE__ */ rB(lf, n)), e.uuidv7 = (n) => e.check(/* @__PURE__ */ iB(lf, n)), e.nanoid = (n) => e.check(/* @__PURE__ */ sB(BU, n)), e.guid = (n) => e.check(/* @__PURE__ */ Zx(Jx, n)), e.cuid = (n) => e.check(/* @__PURE__ */ lB(UU, n)), e.cuid2 = (n) => e.check(/* @__PURE__ */ uB(qU, n)), e.ulid = (n) => e.check(/* @__PURE__ */ cB(HU, n)), e.base64 = (n) => e.check(/* @__PURE__ */ gB(XU, n)), e.base64url = (n) => e.check(/* @__PURE__ */ yB(eq, n)), e.xid = (n) => e.check(/* @__PURE__ */ fB(WU, n)), e.ksuid = (n) => e.check(/* @__PURE__ */ dB(ZU, n)), e.ipv4 = (n) => e.check(/* @__PURE__ */ pB(GU, n)), e.ipv6 = (n) => e.check(/* @__PURE__ */ hB(YU, n)), e.cidrv4 = (n) => e.check(/* @__PURE__ */ vB(QU, n)), e.cidrv6 = (n) => e.check(/* @__PURE__ */ mB(JU, n)), e.e164 = (n) => e.check(/* @__PURE__ */ bB(tq, n)), e.datetime = (n) => e.check(bU(n)), e.date = (n) => e.check(wU(n)), e.time = (n) => e.check(EU(n)), e.duration = (n) => e.check(OU(n));
});
function ze(e) {
  return /* @__PURE__ */ XK(zU, e);
}
const Gt = /* @__PURE__ */ oe("ZodStringFormat", (e, t) => {
  Bt.init(e, t), VD.init(e, t);
}), LU = /* @__PURE__ */ oe("ZodEmail", (e, t) => {
  iK.init(e, t), Gt.init(e, t);
}), Jx = /* @__PURE__ */ oe("ZodGUID", (e, t) => {
  nK.init(e, t), Gt.init(e, t);
}), lf = /* @__PURE__ */ oe("ZodUUID", (e, t) => {
  rK.init(e, t), Gt.init(e, t);
}), VU = /* @__PURE__ */ oe("ZodURL", (e, t) => {
  oK.init(e, t), Gt.init(e, t);
}), KU = /* @__PURE__ */ oe("ZodEmoji", (e, t) => {
  aK.init(e, t), Gt.init(e, t);
}), BU = /* @__PURE__ */ oe("ZodNanoID", (e, t) => {
  sK.init(e, t), Gt.init(e, t);
}), UU = /* @__PURE__ */ oe("ZodCUID", (e, t) => {
  lK.init(e, t), Gt.init(e, t);
}), qU = /* @__PURE__ */ oe("ZodCUID2", (e, t) => {
  uK.init(e, t), Gt.init(e, t);
}), HU = /* @__PURE__ */ oe("ZodULID", (e, t) => {
  cK.init(e, t), Gt.init(e, t);
}), WU = /* @__PURE__ */ oe("ZodXID", (e, t) => {
  fK.init(e, t), Gt.init(e, t);
}), ZU = /* @__PURE__ */ oe("ZodKSUID", (e, t) => {
  dK.init(e, t), Gt.init(e, t);
}), GU = /* @__PURE__ */ oe("ZodIPv4", (e, t) => {
  gK.init(e, t), Gt.init(e, t);
}), YU = /* @__PURE__ */ oe("ZodIPv6", (e, t) => {
  yK.init(e, t), Gt.init(e, t);
}), QU = /* @__PURE__ */ oe("ZodCIDRv4", (e, t) => {
  bK.init(e, t), Gt.init(e, t);
}), JU = /* @__PURE__ */ oe("ZodCIDRv6", (e, t) => {
  _K.init(e, t), Gt.init(e, t);
}), XU = /* @__PURE__ */ oe("ZodBase64", (e, t) => {
  wK.init(e, t), Gt.init(e, t);
}), eq = /* @__PURE__ */ oe("ZodBase64URL", (e, t) => {
  EK.init(e, t), Gt.init(e, t);
}), tq = /* @__PURE__ */ oe("ZodE164", (e, t) => {
  SK.init(e, t), Gt.init(e, t);
}), nq = /* @__PURE__ */ oe("ZodJWT", (e, t) => {
  $K.init(e, t), Gt.init(e, t);
}), Wb = /* @__PURE__ */ oe("ZodNumber", (e, t) => {
  AD.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (r, i, o) => YB(e, r, i), e.gt = (r, i) => e.check(/* @__PURE__ */ Yx(r, i)), e.gte = (r, i) => e.check(/* @__PURE__ */ Mf(r, i)), e.min = (r, i) => e.check(/* @__PURE__ */ Mf(r, i)), e.lt = (r, i) => e.check(/* @__PURE__ */ Gx(r, i)), e.lte = (r, i) => e.check(/* @__PURE__ */ Rf(r, i)), e.max = (r, i) => e.check(/* @__PURE__ */ Rf(r, i)), e.int = (r) => e.check(hg(r)), e.safe = (r) => e.check(hg(r)), e.positive = (r) => e.check(/* @__PURE__ */ Yx(0, r)), e.nonnegative = (r) => e.check(/* @__PURE__ */ Mf(0, r)), e.negative = (r) => e.check(/* @__PURE__ */ Gx(0, r)), e.nonpositive = (r) => e.check(/* @__PURE__ */ Rf(0, r)), e.multipleOf = (r, i) => e.check(/* @__PURE__ */ Qx(r, i)), e.step = (r, i) => e.check(/* @__PURE__ */ Qx(r, i)), e.finite = () => e;
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function pa(e) {
  return /* @__PURE__ */ OB(Wb, e);
}
const rq = /* @__PURE__ */ oe("ZodNumberFormat", (e, t) => {
  TK.init(e, t), Wb.init(e, t);
});
function hg(e) {
  return /* @__PURE__ */ TB(rq, e);
}
const iq = /* @__PURE__ */ oe("ZodBoolean", (e, t) => {
  PK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => QB(e, n, r);
});
function gn(e) {
  return /* @__PURE__ */ PB(iq, e);
}
const oq = /* @__PURE__ */ oe("ZodUnknown", (e, t) => {
  kK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => XB();
});
function Xx() {
  return /* @__PURE__ */ kB(oq);
}
const aq = /* @__PURE__ */ oe("ZodNever", (e, t) => {
  DK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => JB(e, n, r);
});
function sq(e) {
  return /* @__PURE__ */ DB(aq, e);
}
const lq = /* @__PURE__ */ oe("ZodDate", (e, t) => {
  AK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (r, i, o) => eU(e, r), e.min = (r, i) => e.check(/* @__PURE__ */ Mf(r, i)), e.max = (r, i) => e.check(/* @__PURE__ */ Rf(r, i));
  const n = e._zod.bag;
  e.minDate = n.minimum ? new Date(n.minimum) : null, e.maxDate = n.maximum ? new Date(n.maximum) : null;
});
function uq(e) {
  return /* @__PURE__ */ AB(lq, e);
}
const cq = /* @__PURE__ */ oe("ZodArray", (e, t) => {
  CK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => oU(e, n, r, i), e.element = t.element, e.min = (n, r) => e.check(/* @__PURE__ */ Td(n, r)), e.nonempty = (n) => e.check(/* @__PURE__ */ Td(1, n)), e.max = (n, r) => e.check(/* @__PURE__ */ RD(n, r)), e.length = (n, r) => e.check(/* @__PURE__ */ MD(n, r)), e.unwrap = () => e.element;
});
function Xn(e, t) {
  return /* @__PURE__ */ BB(cq, e, t);
}
const fq = /* @__PURE__ */ oe("ZodObject", (e, t) => {
  NK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => aU(e, n, r, i), lt(e, "shape", () => t.shape), e.keyof = () => KD(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Xx() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Xx() }), e.strict = () => e.clone({ ...e._zod.def, catchall: sq() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => e7(e, n), e.safeExtend = (n) => t7(e, n), e.merge = (n) => n7(e, n), e.pick = (n) => JV(e, n), e.omit = (n) => XV(e, n), e.partial = (...n) => r7(BD, e, n[0]), e.required = (...n) => i7(UD, e, n[0]);
});
function it(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...Be(t)
  };
  return new fq(n);
}
const dq = /* @__PURE__ */ oe("ZodUnion", (e, t) => {
  RK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => sU(e, n, r, i), e.options = t.options;
});
function za(e, t) {
  return new dq({
    type: "union",
    options: e,
    ...Be(t)
  });
}
const pq = /* @__PURE__ */ oe("ZodIntersection", (e, t) => {
  MK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => lU(e, n, r, i);
});
function hq(e, t) {
  return new pq({
    type: "intersection",
    left: e,
    right: t
  });
}
const vq = /* @__PURE__ */ oe("ZodRecord", (e, t) => {
  jK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => uU(e, n, r, i), e.keyType = t.keyType, e.valueType = t.valueType;
});
function kd(e, t, n) {
  return new vq({
    type: "record",
    keyType: e,
    valueType: t,
    ...Be(n)
  });
}
const vg = /* @__PURE__ */ oe("ZodEnum", (e, t) => {
  FK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (r, i, o) => tU(e, r, i), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, i) => {
    const o = {};
    for (const a of r)
      if (n.has(a))
        o[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new vg({
      ...t,
      checks: [],
      ...Be(i),
      entries: o
    });
  }, e.exclude = (r, i) => {
    const o = { ...t.entries };
    for (const a of r)
      if (n.has(a))
        delete o[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new vg({
      ...t,
      checks: [],
      ...Be(i),
      entries: o
    });
  };
});
function KD(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new vg({
    type: "enum",
    entries: n,
    ...Be(t)
  });
}
const mq = /* @__PURE__ */ oe("ZodLiteral", (e, t) => {
  zK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => nU(e, n, r), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function er(e, t) {
  return new mq({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...Be(t)
  });
}
const gq = /* @__PURE__ */ oe("ZodTransform", (e, t) => {
  LK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => iU(e, n), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new vD(e.constructor.name);
    n.addIssue = (o) => {
      if (typeof o == "string")
        n.issues.push(Lu(o, n.value, t));
      else {
        const a = o;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = n.value), a.inst ?? (a.inst = e), n.issues.push(Lu(a));
      }
    };
    const i = t.transform(n.value, n);
    return i instanceof Promise ? i.then((o) => (n.value = o, n)) : (n.value = i, n);
  };
});
function yq(e) {
  return new gq({
    type: "transform",
    transform: e
  });
}
const BD = /* @__PURE__ */ oe("ZodOptional", (e, t) => {
  ND.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => LD(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function eE(e) {
  return new BD({
    type: "optional",
    innerType: e
  });
}
const bq = /* @__PURE__ */ oe("ZodExactOptional", (e, t) => {
  VK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => LD(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function _q(e) {
  return new bq({
    type: "optional",
    innerType: e
  });
}
const wq = /* @__PURE__ */ oe("ZodNullable", (e, t) => {
  KK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => cU(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function tE(e) {
  return new wq({
    type: "nullable",
    innerType: e
  });
}
const xq = /* @__PURE__ */ oe("ZodDefault", (e, t) => {
  BK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => dU(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Eq(e, t) {
  return new xq({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : bD(t);
    }
  });
}
const Sq = /* @__PURE__ */ oe("ZodPrefault", (e, t) => {
  UK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => pU(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Oq(e, t) {
  return new Sq({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : bD(t);
    }
  });
}
const UD = /* @__PURE__ */ oe("ZodNonOptional", (e, t) => {
  qK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => fU(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function $q(e, t) {
  return new UD({
    type: "nonoptional",
    innerType: e,
    ...Be(t)
  });
}
const Tq = /* @__PURE__ */ oe("ZodCatch", (e, t) => {
  HK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => hU(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Pq(e, t) {
  return new Tq({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const kq = /* @__PURE__ */ oe("ZodPipe", (e, t) => {
  WK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => vU(e, n, r, i), e.in = t.in, e.out = t.out;
});
function nE(e, t) {
  return new kq({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const Dq = /* @__PURE__ */ oe("ZodReadonly", (e, t) => {
  ZK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => mU(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Aq(e) {
  return new Dq({
    type: "readonly",
    innerType: e
  });
}
const Cq = /* @__PURE__ */ oe("ZodLazy", (e, t) => {
  GK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => gU(e, n, r, i), e.unwrap = () => e._zod.def.getter();
});
function Zb(e) {
  return new Cq({
    type: "lazy",
    getter: e
  });
}
const Iq = /* @__PURE__ */ oe("ZodCustom", (e, t) => {
  YK.init(e, t), Ft.init(e, t), e._zod.processJSONSchema = (n, r, i) => rU(e, n);
});
function Nq(e, t = {}) {
  return /* @__PURE__ */ UB(Iq, e, t);
}
function Rq(e) {
  return /* @__PURE__ */ qB(e);
}
function Mq(e) {
  return /* @__PURE__ */ $B(Wb, e);
}
const jq = it({
  _type: er("string"),
  _validation: ze().optional(),
  _value: ze().optional(),
  _optional: gn().optional()
}), Fq = it({
  _type: er("boolean"),
  _value: gn().optional(),
  _optional: gn().optional()
}), zq = it({
  _type: er("selection"),
  _options: Xn(ze()),
  _optional: gn().optional(),
  _value: ze().optional()
}), qD = it({
  bucketId: pa(),
  isFolder: gn(),
  path: ze()
}), Lq = KD(Ln), wa = Zb(
  () => za([
    Bq,
    Vq,
    zq,
    jq,
    Kq,
    Fq
  ])
), Vq = it({
  _type: er("path"),
  _value: za([Xn(qD), Xn(ze())]).optional(),
  // _value: z.array(s3PathSchema).optional(),
  _regexp: ze().optional(),
  _optional: gn().optional(),
  _pathType: Lq
}), Kq = Zb(
  () => it({
    _type: er("list"),
    _value: Xn(wa).optional(),
    _optional: gn().optional(),
    _schema: wa
  })
), Bq = Zb(
  () => it({
    _type: er("object"),
    _optional: gn().optional(),
    _fields: kd(ze(), wa),
    _value: kd(ze(), wa).optional(),
    _order: Xn(ze()).optional()
  })
);
kd(
  Mq(),
  wa
);
kd(
  ze(),
  wa
);
const Uq = it({
  type: er("pattern"),
  pattern: ze()
}), qq = it({
  type: er("value"),
  value: za([ze(), pa(), gn(), Xn(qD)])
}), Hq = it({
  type: er("code"),
  codeBase64: ze()
}), Wq = za([
  Uq,
  qq,
  Hq
]);
wa.and(
  it({
    _actionData: Wq.optional()
  })
);
const HD = it({
  permissions: ze(),
  links: ze(),
  owner: ze(),
  group: ze(),
  size: ze(),
  month: ze(),
  date: ze(),
  yearOrTime: ze(),
  name: ze(),
  fullPath: ze()
}), Zq = Xn(HD);
it({
  url: ze()
});
it({
  socketId: ze(),
  hasSavedSession: gn().nullish()
});
it({
  path: ze()
});
it({
  directory: ze(),
  contents: Zq
});
it({
  syncPwd: gn()
});
it({
  defaultDirectory: ze(),
  termState: ze().nullish()
});
it({
  path: ze()
});
it({
  query: ze()
});
it({
  results: Xn(HD),
  date: ze(),
  query: ze()
});
it({
  tinkerBoxId: pa(),
  rows: pa(),
  cols: pa(),
  syncPwd: gn().nullish()
});
it({
  path: ze()
});
it({
  path: ze()
});
it({
  termState: ze()
});
const Gq = it({
  name: ze(),
  type: er("select"),
  options: Xn(ze()),
  optional: gn().optional(),
  allowOther: gn().optional(),
  validate: ze().optional(),
  question: ze().optional()
}), Yq = it({
  name: ze(),
  type: za([er("text"), er("textarea")]),
  optional: gn().optional(),
  validate: ze().optional(),
  question: ze().optional()
}), Qq = it({
  name: ze(),
  type: er("email"),
  optional: gn().optional(),
  validate: ze().optional(),
  question: ze().optional()
}), Jq = it({
  name: ze(),
  type: er("submit"),
  text: ze().optional(),
  optional: gn().optional(),
  validate: ze().optional(),
  question: ze().optional()
});
Xn(
  it({
    name: ze(),
    value: ze()
  })
);
za([
  Gq,
  Yq,
  Qq,
  Jq
]);
const Xq = it({
  id: pa(),
  name: ze(),
  labId: pa(),
  status: ze(),
  ipAddress: ze().nullable(),
  lastLogin: uq().nullable()
});
it({
  tinkerboxes: Xn(Xq)
});
const eH = it({
  key: ze(),
  name: ze(),
  isFolder: gn(),
  bucket: ze(),
  fullPath: ze()
});
it({
  contents: Xn(eH)
});
it({
  buckets: Xn(
    it({
      id: hg(),
      bucket: ze(),
      region: ze(),
      prefix: ze().nullish()
    })
  )
});
var tH = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(t, n) {
    return "Cannot apply '" + t + "' to '" + n.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(t, n) {
    return "[mobx.array] Index out of bounds, " + t + " is larger than " + n;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(t) {
    return "Cannot initialize from classes that inherit from Map: " + t.constructor.name;
  },
  20: function(t) {
    return "Cannot initialize map from " + t;
  },
  21: function(t) {
    return "Cannot convert to map from '" + t + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(t) {
    return "Cannot obtain administration from " + t;
  },
  25: function(t, n) {
    return "the entry '" + t + "' does not exist in the observable map '" + n + "'";
  },
  26: "please specify a property",
  27: function(t, n) {
    return "no observable property '" + t.toString() + "' found on the observable object '" + n + "'";
  },
  28: function(t) {
    return "Cannot obtain atom from " + t;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(t, n) {
    return "Cycle detected in computation " + t + ": " + n;
  },
  33: function(t) {
    return "The setter of computed value '" + t + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(t) {
    return "[ComputedValue '" + t + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(t) {
    return "[mobx] `observableArray." + t + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + t + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, nH = process.env.NODE_ENV !== "production" ? tH : {};
function ke(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if (process.env.NODE_ENV !== "production") {
    var i = typeof e == "string" ? e : nH[e];
    throw typeof i == "function" && (i = i.apply(null, n)), new Error("[MobX] " + i);
  }
  throw new Error(typeof e == "number" ? "[MobX] minified error nr: " + e + (n.length ? " " + n.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e);
}
var rH = {};
function Np() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : rH;
}
var WD = Object.assign, Dd = Object.getOwnPropertyDescriptor, Ti = Object.defineProperty, Rp = Object.prototype, Ad = [];
Object.freeze(Ad);
var ZD = {};
Object.freeze(ZD);
var iH = typeof Proxy < "u", oH = /* @__PURE__ */ Object.toString();
function GD() {
  iH || ke(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function zl(e) {
  process.env.NODE_ENV !== "production" && me.verifyProxies && ke("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + e);
}
function ci() {
  return ++me.mobxGuid;
}
function Gb(e) {
  var t = !1;
  return function() {
    if (!t)
      return t = !0, e.apply(this, arguments);
  };
}
var ds = function() {
};
function hn(e) {
  return typeof e == "function";
}
function xa(e) {
  var t = typeof e;
  switch (t) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function Mp(e) {
  return e !== null && typeof e == "object";
}
function fr(e) {
  if (!Mp(e))
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t == null)
    return !0;
  var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n.toString() === oH;
}
function YD(e) {
  var t = e?.constructor;
  return t ? t.name === "GeneratorFunction" || t.displayName === "GeneratorFunction" : !1;
}
function yc(e, t, n) {
  Ti(e, t, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: n
  });
}
function QD(e, t, n) {
  Ti(e, t, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: n
  });
}
function La(e, t) {
  var n = "isMobX" + e;
  return t.prototype[n] = !0, function(r) {
    return Mp(r) && r[n] === !0;
  };
}
function fl(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Map]";
}
function aH(e) {
  var t = Object.getPrototypeOf(e), n = Object.getPrototypeOf(t), r = Object.getPrototypeOf(n);
  return r === null;
}
function ji(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Set]";
}
var JD = typeof Object.getOwnPropertySymbols < "u";
function sH(e) {
  var t = Object.keys(e);
  if (!JD)
    return t;
  var n = Object.getOwnPropertySymbols(e);
  return n.length ? [].concat(t, n.filter(function(r) {
    return Rp.propertyIsEnumerable.call(e, r);
  })) : t;
}
var zs = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : JD ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function mg(e) {
  return typeof e == "string" ? e : typeof e == "symbol" ? e.toString() : new String(e).toString();
}
function XD(e) {
  return e === null ? null : typeof e == "object" ? "" + e : e;
}
function Ir(e, t) {
  return Rp.hasOwnProperty.call(e, t);
}
var lH = Object.getOwnPropertyDescriptors || function(t) {
  var n = {};
  return zs(t).forEach(function(r) {
    n[r] = Dd(t, r);
  }), n;
};
function sr(e, t) {
  return !!(e & t);
}
function lr(e, t, n) {
  return n ? e |= t : e &= ~t, e;
}
function rE(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function uH(e, t, n) {
  if (e4()) return Reflect.construct.apply(null, arguments);
  var r = [null];
  r.push.apply(r, t);
  var i = new (e.bind.apply(e, r))();
  return n && Vu(i, n.prototype), i;
}
function cH(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, pH(r.key), r);
  }
}
function dl(e, t, n) {
  return t && cH(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ps(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = hH(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[r++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Gi() {
  return Gi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gi.apply(null, arguments);
}
function gg(e) {
  return gg = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, gg(e);
}
function Yb(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Vu(e, t);
}
function fH(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function e4() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (e4 = function() {
    return !!e;
  })();
}
function Vu(e, t) {
  return Vu = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Vu(e, t);
}
function dH(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function pH(e) {
  var t = dH(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function hH(e, t) {
  if (e) {
    if (typeof e == "string") return rE(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? rE(e, t) : void 0;
  }
}
function yg(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return yg = function(n) {
    if (n === null || !fH(n)) return n;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n)) return t.get(n);
      t.set(n, r);
    }
    function r() {
      return uH(n, arguments, gg(this).constructor);
    }
    return r.prototype = Object.create(n.prototype, {
      constructor: {
        value: r,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Vu(r, n);
  }, yg(e);
}
var Zn = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function Pi(e) {
  function t(n, r) {
    if (_c(r))
      return e.decorate_20223_(n, r);
    bc(n, r, e);
  }
  return Object.assign(t, e);
}
function bc(e, t, n) {
  if (Ir(e, Zn) || yc(e, Zn, Gi({}, e[Zn])), process.env.NODE_ENV !== "production" && Id(n) && !Ir(e[Zn], t)) {
    var r = e.constructor.name + ".prototype." + t.toString();
    ke("'" + r + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  vH(e, n, t), Id(n) || (e[Zn][t] = n);
}
function vH(e, t, n) {
  if (process.env.NODE_ENV !== "production" && !Id(t) && Ir(e[Zn], n)) {
    var r = e.constructor.name + ".prototype." + n.toString(), i = e[Zn][n].annotationType_, o = t.annotationType_;
    ke("Cannot apply '@" + o + "' to '" + r + "':" + (`
The field is already decorated with '@` + i + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function mH(e) {
  return Ir(e, Zn) || yc(e, Zn, Gi({}, e[Zn])), e[Zn];
}
function _c(e) {
  return typeof e == "object" && typeof e.kind == "string";
}
function jp(e, t) {
  process.env.NODE_ENV !== "production" && !t.includes(e.kind) && ke("The decorator applied to '" + String(e.name) + "' cannot be used on a " + e.kind + " element");
}
var Ge = /* @__PURE__ */ Symbol("mobx administration"), zo = /* @__PURE__ */ (function() {
  function e(n) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "Atom@" + ci() : "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = /* @__PURE__ */ new Set(), this.lastAccessedBy_ = 0, this.lowestObserverState_ = dt.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = n;
  }
  var t = e.prototype;
  return t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.reportObserved = function() {
    return m4(this);
  }, t.reportChanged = function() {
    Pr(), g4(this), kr();
  }, t.toString = function() {
    return this.name_;
  }, dl(e, [{
    key: "isBeingObserved",
    get: function() {
      return sr(this.flags_, e.isBeingObservedMask_);
    },
    set: function(r) {
      this.flags_ = lr(this.flags_, e.isBeingObservedMask_, r);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return sr(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(r) {
      this.flags_ = lr(this.flags_, e.isPendingUnobservationMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return sr(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = lr(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
})();
zo.isBeingObservedMask_ = 1;
zo.isPendingUnobservationMask_ = 2;
zo.diffValueMask_ = 4;
var Qb = /* @__PURE__ */ La("Atom", zo);
function t4(e, t, n) {
  t === void 0 && (t = ds), n === void 0 && (n = ds);
  var r = new zo(e);
  return t !== ds && DW(r, t), n !== ds && E4(r, n), r;
}
function gH(e, t) {
  return R4(e, t);
}
function yH(e, t) {
  return Object.is ? Object.is(e, t) : e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var Cd = {
  structural: gH,
  default: yH
};
function Ea(e, t, n) {
  return Uu(e) ? e : Array.isArray(e) ? pn.array(e, {
    name: n
  }) : fr(e) ? pn.object(e, void 0, {
    name: n
  }) : fl(e) ? pn.map(e, {
    name: n
  }) : ji(e) ? pn.set(e, {
    name: n
  }) : typeof e == "function" && !$a(e) && !Bu(e) ? YD(e) ? Ls(e) : Ku(n, e) : e;
}
function bH(e, t, n) {
  if (e == null || pl(e) || Up(e) || Lo(e) || wi(e))
    return e;
  if (Array.isArray(e))
    return pn.array(e, {
      name: n,
      deep: !1
    });
  if (fr(e))
    return pn.object(e, void 0, {
      name: n,
      deep: !1
    });
  if (fl(e))
    return pn.map(e, {
      name: n,
      deep: !1
    });
  if (ji(e))
    return pn.set(e, {
      name: n,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && ke("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function Fp(e) {
  return e;
}
function _H(e, t) {
  return process.env.NODE_ENV !== "production" && Uu(e) && ke("observable.struct should not be used with observable values"), R4(e, t) ? t : e;
}
var wH = "override";
function Id(e) {
  return e.annotationType_ === wH;
}
function wc(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: xH,
    extend_: EH,
    decorate_20223_: SH
  };
}
function xH(e, t, n, r) {
  var i;
  if ((i = this.options_) != null && i.bound)
    return this.extend_(e, t, n, !1) === null ? 0 : 1;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if ($a(n.value))
    return 1;
  var o = n4(e, this, t, n, !1);
  return Ti(r, t, o), 2;
}
function EH(e, t, n, r) {
  var i = n4(e, this, t, n);
  return e.defineProperty_(t, i, r);
}
function SH(e, t) {
  process.env.NODE_ENV !== "production" && jp(t, ["method", "field"]);
  var n = t.kind, r = t.name, i = t.addInitializer, o = this, a = function(u) {
    var c, f, d, p;
    return Sa((c = (f = o.options_) == null ? void 0 : f.name) != null ? c : r.toString(), u, (d = (p = o.options_) == null ? void 0 : p.autoAction) != null ? d : !1);
  };
  if (n == "field")
    return function(l) {
      var u, c = l;
      return $a(c) || (c = a(c)), (u = o.options_) != null && u.bound && (c = c.bind(this), c.isMobxAction = !0), c;
    };
  if (n == "method") {
    var s;
    return $a(e) || (e = a(e)), (s = this.options_) != null && s.bound && i(function() {
      var l = this, u = l[r].bind(l);
      u.isMobxAction = !0, l[r] = u;
    }), e;
  }
  ke("Cannot apply '" + o.annotationType_ + "' to '" + String(r) + "' (kind: " + n + "):" + (`
'` + o.annotationType_ + "' can only be used on properties with a function value."));
}
function OH(e, t, n, r) {
  var i = t.annotationType_, o = r.value;
  process.env.NODE_ENV !== "production" && !hn(o) && ke("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on properties with a function value."));
}
function n4(e, t, n, r, i) {
  var o, a, s, l, u, c, f;
  i === void 0 && (i = me.safeDescriptors), OH(e, t, n, r);
  var d = r.value;
  if ((o = t.options_) != null && o.bound) {
    var p;
    d = d.bind((p = e.proxy_) != null ? p : e.target_);
  }
  return {
    value: Sa(
      (a = (s = t.options_) == null ? void 0 : s.name) != null ? a : n.toString(),
      d,
      (l = (u = t.options_) == null ? void 0 : u.autoAction) != null ? l : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (c = t.options_) != null && c.bound ? (f = e.proxy_) != null ? f : e.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: i ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !i
  };
}
function r4(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: $H,
    extend_: TH,
    decorate_20223_: PH
  };
}
function $H(e, t, n, r) {
  var i;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if ((i = this.options_) != null && i.bound && (!Ir(e.target_, t) || !Bu(e.target_[t])) && this.extend_(e, t, n, !1) === null)
    return 0;
  if (Bu(n.value))
    return 1;
  var o = i4(e, this, t, n, !1, !1);
  return Ti(r, t, o), 2;
}
function TH(e, t, n, r) {
  var i, o = i4(e, this, t, n, (i = this.options_) == null ? void 0 : i.bound);
  return e.defineProperty_(t, o, r);
}
function PH(e, t) {
  var n;
  process.env.NODE_ENV !== "production" && jp(t, ["method"]);
  var r = t.name, i = t.addInitializer;
  return Bu(e) || (e = Ls(e)), (n = this.options_) != null && n.bound && i(function() {
    var o = this, a = o[r].bind(o);
    a.isMobXFlow = !0, o[r] = a;
  }), e;
}
function kH(e, t, n, r) {
  var i = t.annotationType_, o = r.value;
  process.env.NODE_ENV !== "production" && !hn(o) && ke("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on properties with a generator function value."));
}
function i4(e, t, n, r, i, o) {
  o === void 0 && (o = me.safeDescriptors), kH(e, t, n, r);
  var a = r.value;
  if (Bu(a) || (a = Ls(a)), i) {
    var s;
    a = a.bind((s = e.proxy_) != null ? s : e.target_), a.isMobXFlow = !0;
  }
  return {
    value: a,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: o ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !o
  };
}
function Jb(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: DH,
    extend_: AH,
    decorate_20223_: CH
  };
}
function DH(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function AH(e, t, n, r) {
  return IH(e, this, t, n), e.defineComputedProperty_(t, Gi({}, this.options_, {
    get: n.get,
    set: n.set
  }), r);
}
function CH(e, t) {
  process.env.NODE_ENV !== "production" && jp(t, ["getter"]);
  var n = this, r = t.name, i = t.addInitializer, o;
  function a(s, l) {
    var u = Gi({}, n.options_, {
      get: e,
      context: s
    });
    return u.name || (u.name = process.env.NODE_ENV !== "production" ? l.name_ + "." + r.toString() : "ObservableObject." + r.toString()), new Gn(u);
  }
  return i(function() {
    var s, l = Ka(this)[Ge], u = this, c = l.values_.get(r);
    c instanceof Gn && c.derivation !== e && l.values_.delete(r), ((s = l.lazyComputedKeys_) != null ? s : l.lazyComputedKeys_ = /* @__PURE__ */ new Map()).set(r, function() {
      return a(u, l);
    });
  }), function() {
    var s = this[Ge], l = s.values_.get(r);
    if (l instanceof Gn && l.derivation !== e) {
      var u, c = (u = o) == null ? void 0 : u.get(this);
      if (!c) {
        var f;
        c = a(this, s), ((f = o) != null ? f : o = /* @__PURE__ */ new WeakMap()).set(this, c);
      }
      return c.get();
    }
    return s.getObservablePropValue_(r);
  };
}
function IH(e, t, n, r) {
  var i = t.annotationType_, o = r.get;
  process.env.NODE_ENV !== "production" && !o && ke("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on getter(+setter) properties."));
}
function zp(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: NH,
    extend_: RH,
    decorate_20223_: MH
  };
}
function NH(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function RH(e, t, n, r) {
  var i, o;
  return jH(e, this, t, n), e.defineObservableProperty_(t, n.value, (i = (o = this.options_) == null ? void 0 : o.enhancer) != null ? i : Ea, r);
}
function MH(e, t) {
  if (process.env.NODE_ENV !== "production") {
    if (t.kind === "field")
      throw ke("Please use `@observable accessor " + String(t.name) + "` instead of `@observable " + String(t.name) + "`");
    jp(t, ["accessor"]);
  }
  var n = this, r = t.kind, i = t.name;
  if (r !== "accessor")
    return;
  function o(a, s) {
    var l, u = Ka(a)[Ge];
    return ((l = u.lazyObservableKeys_) != null ? l : u.lazyObservableKeys_ = /* @__PURE__ */ new Map()).set(i, function() {
      var c, f;
      return new ha(s, (c = (f = n.options_) == null ? void 0 : f.enhancer) != null ? c : Ea, process.env.NODE_ENV !== "production" ? u.name_ + "." + i.toString() : "ObservableObject." + i.toString(), !1);
    }), u;
  }
  return {
    get: function() {
      var s, l = (s = this[Ge]) != null ? s : o(this, e.get.call(this));
      return l.getObservablePropValue_(i);
    },
    set: function(s) {
      var l, u = (l = this[Ge]) != null ? l : o(this, s);
      return u.setObservablePropValue_(i, s);
    },
    init: function(s) {
      return o(this, s), s;
    }
  };
}
function jH(e, t, n, r) {
  var i = t.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in r) && ke("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' cannot be used on getter/setter properties"));
}
var FH = "true", zH = /* @__PURE__ */ o4();
function o4(e) {
  return {
    annotationType_: FH,
    options_: e,
    make_: LH,
    extend_: VH,
    decorate_20223_: KH
  };
}
function LH(e, t, n, r) {
  var i, o;
  if (n.get)
    return Lp.make_(e, t, n, r);
  if (n.set) {
    var a = $a(n.set) ? n.set : Sa(t.toString(), n.set);
    return r === e.target_ ? e.defineProperty_(t, {
      configurable: me.safeDescriptors ? e.isPlainObject_ : !0,
      set: a
    }) === null ? 0 : 2 : (Ti(r, t, {
      configurable: !0,
      set: a
    }), 2);
  }
  if (r !== e.target_ && typeof n.value == "function") {
    var s;
    if (YD(n.value)) {
      var l, u = (l = this.options_) != null && l.autoBind ? Ls.bound : Ls;
      return u.make_(e, t, n, r);
    }
    var c = (s = this.options_) != null && s.autoBind ? Ku.bound : Ku;
    return c.make_(e, t, n, r);
  }
  var f = ((i = this.options_) == null ? void 0 : i.deep) === !1 ? pn.ref : pn;
  if (typeof n.value == "function" && (o = this.options_) != null && o.autoBind) {
    var d;
    n.value = n.value.bind((d = e.proxy_) != null ? d : e.target_);
  }
  return f.make_(e, t, n, r);
}
function VH(e, t, n, r) {
  var i, o;
  if (n.get)
    return Lp.extend_(e, t, n, r);
  if (n.set)
    return e.defineProperty_(t, {
      configurable: me.safeDescriptors ? e.isPlainObject_ : !0,
      set: Sa(t.toString(), n.set)
    }, r);
  if (typeof n.value == "function" && (i = this.options_) != null && i.autoBind) {
    var a;
    n.value = n.value.bind((a = e.proxy_) != null ? a : e.target_);
  }
  var s = ((o = this.options_) == null ? void 0 : o.deep) === !1 ? pn.ref : pn;
  return s.extend_(e, t, n, r);
}
function KH(e, t) {
  ke("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var BH = "observable", UH = "observable.ref", qH = "observable.shallow", HH = "observable.struct", a4 = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(a4);
function uf(e) {
  return e || a4;
}
var bg = /* @__PURE__ */ zp(BH), WH = /* @__PURE__ */ zp(UH, {
  enhancer: Fp
}), ZH = /* @__PURE__ */ zp(qH, {
  enhancer: bH
}), GH = /* @__PURE__ */ zp(HH, {
  enhancer: _H
}), s4 = /* @__PURE__ */ Pi(bg);
function cf(e) {
  return e.deep === !0 ? Ea : e.deep === !1 ? Fp : QH(e.defaultDecorator);
}
function YH(e) {
  var t;
  return e ? (t = e.defaultDecorator) != null ? t : o4(e) : void 0;
}
function QH(e) {
  var t, n;
  return e && (t = (n = e.options_) == null ? void 0 : n.enhancer) != null ? t : Ea;
}
function l4(e, t, n) {
  if (_c(t))
    return bg.decorate_20223_(e, t);
  if (xa(t)) {
    bc(e, t, bg);
    return;
  }
  return Uu(e) ? e : fr(e) ? pn.object(e, t, n) : Array.isArray(e) ? pn.array(e, t) : fl(e) ? pn.map(e, t) : ji(e) ? pn.set(e, t) : typeof e == "object" && e !== null ? e : pn.box(e, t);
}
WD(l4, s4);
var JH = {
  box: function(t, n) {
    var r = uf(n);
    return new ha(t, cf(r), r.name, !0, r.equals);
  },
  array: function(t, n) {
    var r = uf(n);
    return (me.useProxies === !1 || r.proxy === !1 ? rZ : WW)(t, cf(r), r.name);
  },
  map: function(t, n) {
    var r = uf(n);
    return new k4(t, cf(r), r.name);
  },
  set: function(t, n) {
    var r = uf(n);
    return new D4(t, cf(r), r.name);
  },
  object: function(t, n, r) {
    return Vo(function() {
      return O4(me.useProxies === !1 || r?.proxy === !1 ? Ka({}, r) : KW({}, r), t, n);
    });
  },
  ref: /* @__PURE__ */ Pi(WH),
  shallow: /* @__PURE__ */ Pi(ZH),
  deep: s4,
  struct: /* @__PURE__ */ Pi(GH)
}, pn = /* @__PURE__ */ WD(l4, JH), u4 = "computed", XH = "computed.struct", _g = /* @__PURE__ */ Jb(u4), eW = /* @__PURE__ */ Jb(XH, {
  equals: Cd.structural
}), Lp = function(t, n) {
  if (_c(n))
    return _g.decorate_20223_(t, n);
  if (xa(n))
    return bc(t, n, _g);
  if (fr(t))
    return Pi(Jb(u4, t));
  process.env.NODE_ENV !== "production" && (hn(t) || ke("First argument to `computed` should be an expression."), hn(n) && ke("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var r = fr(n) ? n : {};
  return r.get = t, r.name || (r.name = t.name || ""), new Gn(r);
};
Object.assign(Lp, _g);
Lp.struct = /* @__PURE__ */ Pi(eW);
var iE, oE, Nd = 0, tW = 1, nW = (iE = (oE = /* @__PURE__ */ Dd(function() {
}, "name")) == null ? void 0 : oE.configurable) != null ? iE : !1, aE = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function Sa(e, t, n, r) {
  n === void 0 && (n = !1), process.env.NODE_ENV !== "production" && (hn(t) || ke("`action` can only be invoked on functions"), (typeof e != "string" || !e) && ke("actions should have valid names, got: '" + e + "'"));
  function i() {
    return rW(e, n, t, r || this, arguments);
  }
  return i.isMobxAction = !0, i.toString = function() {
    return t.toString();
  }, nW && (aE.value = e, Ti(i, "name", aE)), i;
}
function rW(e, t, n, r, i) {
  var o = iW(e, t, r, i);
  try {
    return n.apply(r, i);
  } catch (a) {
    throw o.error_ = a, a;
  } finally {
    oW(o);
  }
}
function iW(e, t, n, r) {
  var i = process.env.NODE_ENV !== "production" && Sn() && !!e, o = 0;
  if (process.env.NODE_ENV !== "production" && i) {
    o = Date.now();
    var a = r ? Array.from(r) : Ad;
    dr({
      type: e0,
      name: e,
      object: n,
      arguments: a
    });
  }
  var s = me.trackingDerivation, l = !t || !s;
  Pr();
  var u = me.allowStateChanges;
  l && (Va(), u = Vp(!0));
  var c = Xb(!0), f = {
    runAsAction_: l,
    prevDerivation_: s,
    prevAllowStateChanges_: u,
    prevAllowStateReads_: c,
    notifySpy_: i,
    startTime_: o,
    actionId_: tW++,
    parentActionId_: Nd
  };
  return Nd = f.actionId_, f;
}
function oW(e) {
  Nd !== e.actionId_ && ke(30), Nd = e.parentActionId_, e.error_ !== void 0 && (me.suppressReactionErrors = !0), Kp(e.prevAllowStateChanges_), mu(e.prevAllowStateReads_), kr(), e.runAsAction_ && Vi(e.prevDerivation_), process.env.NODE_ENV !== "production" && e.notifySpy_ && pr({
    time: Date.now() - e.startTime_
  }), me.suppressReactionErrors = !1;
}
function aW(e, t) {
  var n = Vp(e);
  try {
    return t();
  } finally {
    Kp(n);
  }
}
function Vp(e) {
  var t = me.allowStateChanges;
  return me.allowStateChanges = e, t;
}
function Kp(e) {
  me.allowStateChanges = e;
}
var sW = "create", ha = /* @__PURE__ */ (function(e) {
  function t(r, i, o, a, s) {
    var l;
    if (o === void 0 && (o = process.env.NODE_ENV !== "production" ? "ObservableValue@" + ci() : "ObservableValue"), a === void 0 && (a = !0), s === void 0 && (s = Cd.default), l = e.call(this, o) || this, l.enhancer = void 0, l.name_ = void 0, l.equals = void 0, l.hasUnreportedChange_ = !1, l.interceptors_ = void 0, l.changeListeners_ = void 0, l.value_ = void 0, l.dehancer = void 0, l.enhancer = i, l.name_ = o, l.equals = s, l.value_ = i(r, void 0, o), process.env.NODE_ENV !== "production" && a && Sn()) {
      var u;
      Oa({
        type: sW,
        object: l,
        observableKind: "value",
        debugObjectName: l.name_,
        newValue: "" + ((u = l.value_) == null ? void 0 : u.toString())
      });
    }
    return l;
  }
  Yb(t, e);
  var n = t.prototype;
  return n.dehanceValue = function(i) {
    return this.dehancer !== void 0 ? this.dehancer(i) : i;
  }, n.set = function(i) {
    var o = this.value_;
    if (i = this.prepareNewValue_(i), i !== me.UNCHANGED) {
      var a = Sn();
      process.env.NODE_ENV !== "production" && a && dr({
        type: Xr,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: i,
        oldValue: o
      }), this.setNewValue_(i), process.env.NODE_ENV !== "production" && a && pr();
    }
  }, n.prepareNewValue_ = function(i) {
    if (Oi(this), $r(this)) {
      var o = Tr(this, {
        object: this,
        type: Xr,
        newValue: i
      });
      if (!o)
        return me.UNCHANGED;
      i = o.newValue;
    }
    return i = this.enhancer(i, this.value_, this.name_), this.equals(this.value_, i) ? me.UNCHANGED : i;
  }, n.setNewValue_ = function(i) {
    var o = this.value_;
    this.value_ = i, this.reportChanged(), ni(this) && ri(this, {
      type: Xr,
      object: this,
      newValue: i,
      oldValue: o
    });
  }, n.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, n.intercept_ = function(i) {
    return xc(this, i);
  }, n.observe_ = function(i, o) {
    return o && i({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: Xr,
      newValue: this.value_,
      oldValue: void 0
    }), Ec(this, i);
  }, n.raw = function() {
    return this.value_;
  }, n.toJSON = function() {
    return this.get();
  }, n.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, n.valueOf = function() {
    return XD(this.get());
  }, n[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, t;
})(zo), Gn = /* @__PURE__ */ (function() {
  function e(n) {
    this.dependenciesState_ = dt.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = /* @__PURE__ */ new Set(), this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = dt.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new Rd(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = Nr.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, n.get || ke(31), this.derivation = n.get, this.name_ = n.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + ci() : "ComputedValue"), n.set && (this.setter_ = Sa(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", n.set)), this.equals_ = n.equals || (n.compareStructural || n.struct ? Cd.structural : Cd.default), this.scope_ = n.context, this.requiresReaction_ = n.requiresReaction, this.keepAlive_ = !!n.keepAlive;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    vW(this);
  }, t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.get = function() {
    if (this.isComputing && ke(32, this.name_, this.derivation), me.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      wg(this) && (this.warnAboutUntrackedRead_(), Pr(), this.value_ = this.computeValue_(!1), kr());
    else if (m4(this), wg(this)) {
      var r = me.trackingContext;
      this.keepAlive_ && !r && (me.trackingContext = this), this.trackAndCompute() && hW(this), me.trackingContext = r;
    }
    var i = this.value_;
    if (jf(i))
      throw i.cause;
    return i;
  }, t.set = function(r) {
    if (this.setter_) {
      this.isRunningSetter && ke(33, this.name_), this.isRunningSetter = !0;
      try {
        this.setter_.call(this.scope_, r);
      } finally {
        this.isRunningSetter = !1;
      }
    } else
      ke(34, this.name_);
  }, t.trackAndCompute = function() {
    var r = this.value_, i = (
      /* see #1208 */
      this.dependenciesState_ === dt.NOT_TRACKING_
    ), o = this.computeValue_(!0), a = i || jf(r) || jf(o) || !this.equals_(r, o);
    return a && (this.value_ = o, process.env.NODE_ENV !== "production" && Sn() && Oa({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: r,
      newValue: o
    })), a;
  }, t.computeValue_ = function(r) {
    this.isComputing = !0;
    var i = Vp(!1), o;
    if (r)
      o = c4(this, this.derivation, this.scope_);
    else if (me.disableErrorBoundaries === !0)
      o = this.derivation.call(this.scope_);
    else
      try {
        o = this.derivation.call(this.scope_);
      } catch (a) {
        o = new Rd(a);
      }
    return Kp(i), this.isComputing = !1, o;
  }, t.suspend_ = function() {
    this.keepAlive_ || (xg(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== Nr.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, t.observe_ = function(r, i) {
    var o = this, a = !0, s = void 0;
    return OW(function() {
      var l = o.get();
      if (!a || i) {
        var u = Va();
        r({
          observableKind: "computed",
          debugObjectName: o.name_,
          type: Xr,
          object: o,
          newValue: l,
          oldValue: s
        }), Vi(u);
      }
      a = !1, s = l;
    });
  }, t.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== Nr.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : me.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, t.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, t.valueOf = function() {
    return XD(this.get());
  }, t[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, dl(e, [{
    key: "isComputing",
    get: function() {
      return sr(this.flags_, e.isComputingMask_);
    },
    set: function(r) {
      this.flags_ = lr(this.flags_, e.isComputingMask_, r);
    }
  }, {
    key: "isRunningSetter",
    get: function() {
      return sr(this.flags_, e.isRunningSetterMask_);
    },
    set: function(r) {
      this.flags_ = lr(this.flags_, e.isRunningSetterMask_, r);
    }
  }, {
    key: "isBeingObserved",
    get: function() {
      return sr(this.flags_, e.isBeingObservedMask_);
    },
    set: function(r) {
      this.flags_ = lr(this.flags_, e.isBeingObservedMask_, r);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return sr(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(r) {
      this.flags_ = lr(this.flags_, e.isPendingUnobservationMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return sr(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = lr(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
})();
Gn.isComputingMask_ = 1;
Gn.isRunningSetterMask_ = 2;
Gn.isBeingObservedMask_ = 4;
Gn.isPendingUnobservationMask_ = 8;
Gn.diffValueMask_ = 16;
var Bp = /* @__PURE__ */ La("ComputedValue", Gn), dt;
(function(e) {
  e[e.NOT_TRACKING_ = -1] = "NOT_TRACKING_", e[e.UP_TO_DATE_ = 0] = "UP_TO_DATE_", e[e.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", e[e.STALE_ = 2] = "STALE_";
})(dt || (dt = {}));
var Nr;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.LOG = 1] = "LOG", e[e.BREAK = 2] = "BREAK";
})(Nr || (Nr = {}));
var Rd = function(t) {
  this.cause = void 0, this.cause = t;
};
function jf(e) {
  return e instanceof Rd;
}
function wg(e) {
  switch (e.dependenciesState_) {
    case dt.UP_TO_DATE_:
      return !1;
    case dt.NOT_TRACKING_:
    case dt.STALE_:
      return !0;
    case dt.POSSIBLY_STALE_: {
      for (var t = Xb(!0), n = Va(), r = e.observing_, i = r.length, o = 0; o < i; o++) {
        var a = r[o];
        if (Bp(a)) {
          if (me.disableErrorBoundaries)
            a.get();
          else
            try {
              a.get();
            } catch {
              return Vi(n), mu(t), !0;
            }
          if (e.dependenciesState_ === dt.STALE_)
            return Vi(n), mu(t), !0;
        }
      }
      return d4(e), Vi(n), mu(t), !1;
    }
  }
}
function Oi(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = e.observers_.size > 0;
    !me.allowStateChanges && (t || me.enforceActions === "always") && console.warn("[MobX] " + (me.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + e.name_);
  }
}
function lW(e) {
  process.env.NODE_ENV !== "production" && !me.allowStateReads && me.observableRequiresReaction && console.warn("[mobx] Observable '" + e.name_ + "' being read outside a reactive context.");
}
function c4(e, t, n) {
  var r = Xb(!0);
  d4(e), e.newObserving_ = new Array(
    // Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    e.runId_ === 0 ? 100 : e.observing_.length
  ), e.unboundDepsCount_ = 0, e.runId_ = ++me.runId;
  var i = me.trackingDerivation;
  me.trackingDerivation = e, me.inBatch++;
  var o;
  if (me.disableErrorBoundaries === !0)
    o = t.call(n);
  else
    try {
      o = t.call(n);
    } catch (a) {
      o = new Rd(a);
    }
  return me.inBatch--, me.trackingDerivation = i, cW(e), uW(e), mu(r), o;
}
function uW(e) {
  process.env.NODE_ENV !== "production" && e.observing_.length === 0 && (typeof e.requiresObservable_ == "boolean" ? e.requiresObservable_ : me.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + e.name_ + "' is created/updated without reading any observable value.");
}
function cW(e) {
  for (var t = e.observing_, n = e.observing_ = e.newObserving_, r = dt.UP_TO_DATE_, i = 0, o = e.unboundDepsCount_, a = 0; a < o; a++) {
    var s = n[a];
    s.diffValue === 0 && (s.diffValue = 1, i !== a && (n[i] = s), i++), s.dependenciesState_ > r && (r = s.dependenciesState_);
  }
  for (n.length = i, e.newObserving_ = null, o = t.length; o--; ) {
    var l = t[o];
    l.diffValue === 0 && h4(l, e), l.diffValue = 0;
  }
  for (; i--; ) {
    var u = n[i];
    u.diffValue === 1 && (u.diffValue = 0, pW(u, e));
  }
  r !== dt.UP_TO_DATE_ && (e.dependenciesState_ = r, e.onBecomeStale_());
}
function xg(e) {
  var t = e.observing_;
  e.observing_ = [];
  for (var n = t.length; n--; )
    h4(t[n], e);
  e.dependenciesState_ = dt.NOT_TRACKING_;
}
function f4(e) {
  var t = Va();
  try {
    return e();
  } finally {
    Vi(t);
  }
}
function Va() {
  var e = me.trackingDerivation;
  return me.trackingDerivation = null, e;
}
function Vi(e) {
  me.trackingDerivation = e;
}
function Xb(e) {
  var t = me.allowStateReads;
  return me.allowStateReads = e, t;
}
function mu(e) {
  me.allowStateReads = e;
}
function d4(e) {
  if (e.dependenciesState_ !== dt.UP_TO_DATE_) {
    e.dependenciesState_ = dt.UP_TO_DATE_;
    for (var t = e.observing_, n = t.length; n--; )
      t[n].lowestObserverState_ = dt.UP_TO_DATE_;
  }
}
var Ff = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, zf = !0, p4 = !1, me = /* @__PURE__ */ (function() {
  var e = /* @__PURE__ */ Np();
  return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (zf = !1), e.__mobxGlobals && e.__mobxGlobals.version !== new Ff().version && (zf = !1), zf ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = /* @__PURE__ */ new Ff()) : (setTimeout(function() {
    p4 || ke(35);
  }, 1), new Ff());
})();
function fW() {
  if ((me.pendingReactions.length || me.inBatch || me.isRunningReactions) && ke(36), p4 = !0, zf) {
    var e = Np();
    --e.__mobxInstanceCount === 0 && (e.__mobxGlobals = void 0), me = new Ff();
  }
}
function dW() {
  return me;
}
function pW(e, t) {
  e.observers_.add(t), e.lowestObserverState_ > t.dependenciesState_ && (e.lowestObserverState_ = t.dependenciesState_);
}
function h4(e, t) {
  e.observers_.delete(t), e.observers_.size === 0 && v4(e);
}
function v4(e) {
  e.isPendingUnobservation === !1 && (e.isPendingUnobservation = !0, me.pendingUnobservations.push(e));
}
function Pr() {
  me.inBatch++;
}
function kr() {
  if (--me.inBatch === 0) {
    _4();
    for (var e = me.pendingUnobservations, t = 0; t < e.length; t++) {
      var n = e[t];
      n.isPendingUnobservation = !1, n.observers_.size === 0 && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBUO()), n instanceof Gn && n.suspend_());
    }
    me.pendingUnobservations = [];
  }
}
function m4(e) {
  lW(e);
  var t = me.trackingDerivation;
  return t !== null ? (t.runId_ !== e.lastAccessedBy_ && (e.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e, !e.isBeingObserved && me.trackingContext && (e.isBeingObserved = !0, e.onBO())), e.isBeingObserved) : (e.observers_.size === 0 && me.inBatch > 0 && v4(e), !1);
}
function g4(e) {
  e.lowestObserverState_ !== dt.STALE_ && (e.lowestObserverState_ = dt.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === dt.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && t.isTracing_ !== Nr.NONE && y4(t, e), t.onBecomeStale_()), t.dependenciesState_ = dt.STALE_;
  }));
}
function hW(e) {
  e.lowestObserverState_ !== dt.STALE_ && (e.lowestObserverState_ = dt.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === dt.POSSIBLY_STALE_ ? (t.dependenciesState_ = dt.STALE_, process.env.NODE_ENV !== "production" && t.isTracing_ !== Nr.NONE && y4(t, e)) : t.dependenciesState_ === dt.UP_TO_DATE_ && (e.lowestObserverState_ = dt.UP_TO_DATE_);
  }));
}
function vW(e) {
  e.lowestObserverState_ === dt.UP_TO_DATE_ && (e.lowestObserverState_ = dt.POSSIBLY_STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === dt.UP_TO_DATE_ && (t.dependenciesState_ = dt.POSSIBLY_STALE_, t.onBecomeStale_());
  }));
}
function y4(e, t) {
  if (console.log("[mobx.trace] '" + e.name_ + "' is invalidated due to a change in: '" + t.name_ + "'"), e.isTracing_ === Nr.BREAK) {
    var n = [];
    b4($4(e), n, 1), new Function(`debugger;
/*
Tracing '` + e.name_ + `'

You are entering this break point because derivation '` + e.name_ + "' is being traced and '" + t.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (e instanceof Gn ? e.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + n.join(`
`) + `
*/
    `)();
  }
}
function b4(e, t, n) {
  if (t.length >= 1e3) {
    t.push("(and many more)");
    return;
  }
  t.push("" + "	".repeat(n - 1) + e.name), e.dependencies && e.dependencies.forEach(function(r) {
    return b4(r, t, n + 1);
  });
}
var ki = /* @__PURE__ */ (function() {
  function e(n, r, i, o) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "Reaction@" + ci() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = dt.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = Nr.NONE, this.name_ = n, this.onInvalidate_ = r, this.errorHandler_ = i, this.requiresObservable_ = o;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    this.schedule_();
  }, t.schedule_ = function() {
    this.isScheduled || (this.isScheduled = !0, me.pendingReactions.push(this), _4());
  }, t.runReaction_ = function() {
    if (!this.isDisposed) {
      Pr(), this.isScheduled = !1;
      var r = me.trackingContext;
      if (me.trackingContext = this, wg(this)) {
        this.isTrackPending = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending && Sn() && Oa({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (i) {
          this.reportExceptionInDerivation_(i);
        }
      }
      me.trackingContext = r, kr();
    }
  }, t.track = function(r) {
    if (!this.isDisposed) {
      Pr();
      var i = Sn(), o;
      process.env.NODE_ENV !== "production" && i && (o = Date.now(), dr({
        name: this.name_,
        type: "reaction"
      })), this.isRunning = !0;
      var a = me.trackingContext;
      me.trackingContext = this;
      var s = c4(this, r, void 0);
      me.trackingContext = a, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && xg(this), jf(s) && this.reportExceptionInDerivation_(s.cause), process.env.NODE_ENV !== "production" && i && pr({
        time: Date.now() - o
      }), kr();
    }
  }, t.reportExceptionInDerivation_ = function(r) {
    var i = this;
    if (this.errorHandler_) {
      this.errorHandler_(r, this);
      return;
    }
    if (me.disableErrorBoundaries)
      throw r;
    var o = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    me.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(o, r), process.env.NODE_ENV !== "production" && Sn() && Oa({
      type: "error",
      name: this.name_,
      message: o,
      error: "" + r
    }), me.globalReactionErrorHandlers.forEach(function(a) {
      return a(r, i);
    });
  }, t.dispose = function() {
    this.isDisposed || (this.isDisposed = !0, this.isRunning || (Pr(), xg(this), kr()));
  }, t.getDisposer_ = function(r) {
    var i = this, o = function a() {
      i.dispose(), r == null || r.removeEventListener == null || r.removeEventListener("abort", a);
    };
    return r == null || r.addEventListener == null || r.addEventListener("abort", o), o[Ge] = this, "dispose" in Symbol && typeof Symbol.dispose == "symbol" && (o[Symbol.dispose] = o), o;
  }, t.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, t.trace = function(r) {
    r === void 0 && (r = !1), zW(this, r);
  }, dl(e, [{
    key: "isDisposed",
    get: function() {
      return sr(this.flags_, e.isDisposedMask_);
    },
    set: function(r) {
      this.flags_ = lr(this.flags_, e.isDisposedMask_, r);
    }
  }, {
    key: "isScheduled",
    get: function() {
      return sr(this.flags_, e.isScheduledMask_);
    },
    set: function(r) {
      this.flags_ = lr(this.flags_, e.isScheduledMask_, r);
    }
  }, {
    key: "isTrackPending",
    get: function() {
      return sr(this.flags_, e.isTrackPendingMask_);
    },
    set: function(r) {
      this.flags_ = lr(this.flags_, e.isTrackPendingMask_, r);
    }
  }, {
    key: "isRunning",
    get: function() {
      return sr(this.flags_, e.isRunningMask_);
    },
    set: function(r) {
      this.flags_ = lr(this.flags_, e.isRunningMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return sr(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = lr(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
})();
ki.isDisposedMask_ = 1;
ki.isScheduledMask_ = 2;
ki.isTrackPendingMask_ = 4;
ki.isRunningMask_ = 8;
ki.diffValueMask_ = 16;
var sE = 100, Eg = function(t) {
  return t();
};
function _4() {
  me.inBatch > 0 || me.isRunningReactions || Eg(mW);
}
function mW() {
  me.isRunningReactions = !0;
  for (var e = me.pendingReactions, t = 0; e.length > 0; ) {
    ++t === sE && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + sE + " iterations." + (" Probably there is a cycle in the reactive function: " + e[0]) : "[mobx] cycle in reaction: " + e[0]), e.splice(0));
    for (var n = e.splice(0), r = 0, i = n.length; r < i; r++)
      n[r].runReaction_();
  }
  me.isRunningReactions = !1;
}
var Md = /* @__PURE__ */ La("Reaction", ki);
function gW(e) {
  var t = Eg;
  Eg = function(r) {
    return e(function() {
      return t(r);
    });
  };
}
function Sn() {
  return process.env.NODE_ENV !== "production" && !!me.spyListeners.length;
}
function Oa(e) {
  if (process.env.NODE_ENV !== "production" && me.spyListeners.length)
    for (var t = me.spyListeners, n = 0, r = t.length; n < r; n++)
      t[n](e);
}
function dr(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = Gi({}, e, {
      spyReportStart: !0
    });
    Oa(t);
  }
}
var yW = {
  type: "report-end",
  spyReportEnd: !0
};
function pr(e) {
  process.env.NODE_ENV !== "production" && Oa(e ? Gi({}, e, {
    type: "report-end",
    spyReportEnd: !0
  }) : yW);
}
function bW(e) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (me.spyListeners.push(e), Gb(function() {
    me.spyListeners = me.spyListeners.filter(function(t) {
      return t !== e;
    });
  }));
}
var e0 = "action", _W = "action.bound", w4 = "autoAction", wW = "autoAction.bound", xW = "<unnamed action>", Sg = /* @__PURE__ */ wc(e0), EW = /* @__PURE__ */ wc(_W, {
  bound: !0
}), Og = /* @__PURE__ */ wc(w4, {
  autoAction: !0
}), SW = /* @__PURE__ */ wc(wW, {
  autoAction: !0,
  bound: !0
});
function x4(e) {
  var t = function(r, i) {
    if (hn(r))
      return Sa(r.name || xW, r, e);
    if (hn(i))
      return Sa(r, i, e);
    if (_c(i))
      return (e ? Og : Sg).decorate_20223_(r, i);
    if (xa(i))
      return bc(r, i, e ? Og : Sg);
    if (xa(r))
      return Pi(wc(e ? w4 : e0, {
        name: r,
        autoAction: e
      }));
    process.env.NODE_ENV !== "production" && ke("Invalid arguments for `action`");
  };
  return t;
}
var hs = /* @__PURE__ */ x4(!1);
Object.assign(hs, Sg);
var Ku = /* @__PURE__ */ x4(!0);
Object.assign(Ku, Og);
hs.bound = /* @__PURE__ */ Pi(EW);
Ku.bound = /* @__PURE__ */ Pi(SW);
function $a(e) {
  return hn(e) && e.isMobxAction === !0;
}
function OW(e, t) {
  var n, r, i, o;
  t === void 0 && (t = ZD), process.env.NODE_ENV !== "production" && (hn(e) || ke("Autorun expects a function as first argument"), $a(e) && ke("Autorun does not accept actions since actions are untrackable"));
  var a = (n = (r = t) == null ? void 0 : r.name) != null ? n : process.env.NODE_ENV !== "production" ? e.name || "Autorun@" + ci() : "Autorun", s = !t.scheduler && !t.delay, l;
  if (s)
    l = new ki(a, function() {
      this.track(f);
    }, t.onError, t.requiresObservable);
  else {
    var u = TW(t), c = !1;
    l = new ki(a, function() {
      c || (c = !0, u(function() {
        c = !1, l.isDisposed || l.track(f);
      }));
    }, t.onError, t.requiresObservable);
  }
  function f() {
    e(l);
  }
  return (i = t) != null && (i = i.signal) != null && i.aborted || l.schedule_(), l.getDisposer_((o = t) == null ? void 0 : o.signal);
}
var $W = function(t) {
  return t();
};
function TW(e) {
  return e.scheduler ? e.scheduler : e.delay ? function(t) {
    return setTimeout(t, e.delay);
  } : $W;
}
var PW = "onBO", kW = "onBUO";
function DW(e, t, n) {
  return S4(PW, e, t, n);
}
function E4(e, t, n) {
  return S4(kW, e, t, n);
}
function S4(e, t, n, r) {
  var i = Vs(t), o = hn(r) ? r : n, a = e + "L";
  return i[a] ? i[a].add(o) : i[a] = /* @__PURE__ */ new Set([o]), function() {
    var s = i[a];
    s && (s.delete(o), s.size === 0 && delete i[a]);
  };
}
var AW = "never", ff = "always", CW = "observed";
function IW(e) {
  e.isolateGlobalState === !0 && fW();
  var t = e.useProxies, n = e.enforceActions;
  if (t !== void 0 && (me.useProxies = t === ff ? !0 : t === AW ? !1 : typeof Proxy < "u"), t === "ifavailable" && (me.verifyProxies = !0), n !== void 0) {
    var r = n === ff ? ff : n === CW;
    me.enforceActions = r, me.allowStateChanges = !(r === !0 || r === ff);
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function(i) {
    i in e && (me[i] = !!e[i]);
  }), me.allowStateReads = !me.observableRequiresReaction, process.env.NODE_ENV !== "production" && me.disableErrorBoundaries === !0 && console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled."), e.reactionScheduler && gW(e.reactionScheduler);
}
function O4(e, t, n, r) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && ke("'extendObservable' expected 2-4 arguments"), typeof e != "object" && ke("'extendObservable' expects an object as first argument"), Lo(e) && ke("'extendObservable' should not be used on maps, use map.merge instead"), fr(t) || ke("'extendObservable' only accepts plain objects as second argument"), (Uu(t) || Uu(n)) && ke("Extending an object with another observable (object) is not supported"));
  var i = lH(t);
  return Vo(function() {
    var o = Ka(e, r)[Ge];
    zs(i).forEach(function(a) {
      o.extend_(
        a,
        i[a],
        // must pass "undefined" for { key: undefined }
        n && a in n ? n[a] : !0
      );
    });
  }), e;
}
function $4(e, t) {
  return T4(Vs(e, t));
}
function T4(e) {
  var t = {
    name: e.name_
  };
  return e.observing_ && e.observing_.length > 0 && (t.dependencies = NW(e.observing_).map(T4)), t;
}
function NW(e) {
  return Array.from(new Set(e));
}
var RW = 0, MW = /* @__PURE__ */ (function(e) {
  function t() {
    var r;
    return r = e.call(this, "FLOW_CANCELLED") || this, Object.setPrototypeOf(r, (this instanceof t ? this.constructor : void 0).prototype), r.name = "FlowCancellationError", r;
  }
  Yb(t, e);
  var n = t.prototype;
  return n.toString = function() {
    return "Error: " + this.message;
  }, t;
})(/* @__PURE__ */ yg(Error)), pv = /* @__PURE__ */ r4("flow"), jW = /* @__PURE__ */ r4("flow.bound", {
  bound: !0
}), Ls = /* @__PURE__ */ Object.assign(function(t, n) {
  if (_c(n))
    return pv.decorate_20223_(t, n);
  if (xa(n))
    return bc(t, n, pv);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && ke("Flow expects single argument with generator function");
  var r = t, i = r.name || "<unnamed flow>", o = function() {
    var s = this, l = arguments, u = ++RW, c = hs(i + " - runid: " + u + " - init", r).apply(s, l), f, d = void 0, p = new Promise(function(h, v) {
      var m = 0;
      f = v;
      function g(x) {
        d = void 0;
        var S;
        try {
          S = hs(i + " - runid: " + u + " - yield " + m++, c.next).call(c, x);
        } catch ($) {
          return v($);
        }
        w(S);
      }
      function _(x) {
        d = void 0;
        var S;
        try {
          S = hs(i + " - runid: " + u + " - yield " + m++, c.throw).call(c, x);
        } catch ($) {
          return v($);
        }
        w(S);
      }
      function w(x) {
        if (hn(x?.then)) {
          x.then(w, v);
          return;
        }
        return x.done ? h(x.value) : (d = Promise.resolve(x.value), d.then(g, _));
      }
      g(void 0);
    });
    return p.cancel = hs(i + " - runid: " + u + " - cancel", function() {
      try {
        d && lE(d);
        var h = c.return(void 0), v = Promise.resolve(h.value);
        v.then(ds, ds), lE(v), f(new MW());
      } catch (m) {
        f(m);
      }
    }), p;
  };
  return o.isMobXFlow = !0, o;
}, pv);
Ls.bound = /* @__PURE__ */ Pi(jW);
function lE(e) {
  hn(e.cancel) && e.cancel();
}
function Bu(e) {
  return e?.isMobXFlow === !0;
}
function FW(e, t) {
  return e ? pl(e) || !!e[Ge] || Qb(e) || Md(e) || Bp(e) : !1;
}
function Uu(e) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && ke("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), FW(e);
}
function zW() {
  if (process.env.NODE_ENV !== "production") {
    for (var e = !1, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    typeof n[n.length - 1] == "boolean" && (e = n.pop());
    var i = LW(n);
    if (!i)
      return ke("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    i.isTracing_ === Nr.NONE && console.log("[mobx.trace] '" + i.name_ + "' tracing enabled"), i.isTracing_ = e ? Nr.BREAK : Nr.LOG;
  }
}
function LW(e) {
  switch (e.length) {
    case 0:
      return me.trackingDerivation;
    case 1:
      return Vs(e[0]);
    case 2:
      return Vs(e[0], e[1]);
  }
}
function Fi(e, t) {
  t === void 0 && (t = void 0), Pr();
  try {
    return e.apply(t);
  } finally {
    kr();
  }
}
function Qo(e) {
  return e[Ge];
}
var VW = {
  has: function(t, n) {
    return process.env.NODE_ENV !== "production" && me.trackingDerivation && zl("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), Qo(t).has_(n);
  },
  get: function(t, n) {
    return Qo(t).get_(n);
  },
  set: function(t, n, r) {
    var i;
    return xa(n) ? (process.env.NODE_ENV !== "production" && !Qo(t).values_.has(n) && zl("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (i = Qo(t).set_(n, r, !0)) != null ? i : !0) : !1;
  },
  deleteProperty: function(t, n) {
    var r;
    return process.env.NODE_ENV !== "production" && zl("delete properties from an observable object. Use 'remove' from 'mobx' instead."), xa(n) ? (r = Qo(t).delete_(n, !0)) != null ? r : !0 : !1;
  },
  defineProperty: function(t, n, r) {
    var i;
    return process.env.NODE_ENV !== "production" && zl("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (i = Qo(t).defineProperty_(n, r)) != null ? i : !0;
  },
  ownKeys: function(t) {
    return process.env.NODE_ENV !== "production" && me.trackingDerivation && zl("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), Qo(t).ownKeys_();
  },
  preventExtensions: function(t) {
    ke(13);
  }
};
function KW(e, t) {
  var n, r;
  return GD(), e = Ka(e, t), (r = (n = e[Ge]).proxy_) != null ? r : n.proxy_ = new Proxy(e, VW);
}
function $r(e) {
  return e.interceptors_ !== void 0 && e.interceptors_.length > 0;
}
function xc(e, t) {
  var n = e.interceptors_ || (e.interceptors_ = []);
  return n.push(t), Gb(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function Tr(e, t) {
  var n = Va();
  try {
    for (var r = [].concat(e.interceptors_ || []), i = 0, o = r.length; i < o && (t = r[i](t), t && !t.type && ke(14), !!t); i++)
      ;
    return t;
  } finally {
    Vi(n);
  }
}
function ni(e) {
  return e.changeListeners_ !== void 0 && e.changeListeners_.length > 0;
}
function Ec(e, t) {
  var n = e.changeListeners_ || (e.changeListeners_ = []);
  return n.push(t), Gb(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function ri(e, t) {
  var n = Va(), r = e.changeListeners_;
  if (r) {
    r = r.slice();
    for (var i = 0, o = r.length; i < o; i++)
      r[i](t);
    Vi(n);
  }
}
function BW(e, t, n) {
  return Vo(function() {
    var r, i = Ka(e, n)[Ge];
    process.env.NODE_ENV !== "production" && t && e[Zn] && ke("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported."), (r = t) != null || (t = mH(e)), zs(t).forEach(function(o) {
      return i.make_(o, t[o]);
    });
  }), e;
}
var hv = /* @__PURE__ */ Symbol("mobx-keys");
function UW(e, t, n) {
  return process.env.NODE_ENV !== "production" && (!fr(e) && !fr(Object.getPrototypeOf(e)) && ke("'makeAutoObservable' can only be used for classes that don't have a superclass"), pl(e) && ke("makeAutoObservable can only be used on objects not already made observable")), fr(e) ? O4(e, e, t, n) : (Vo(function() {
    var r = Ka(e, n)[Ge];
    if (!e[hv]) {
      var i = Object.getPrototypeOf(e), o = new Set([].concat(zs(e), zs(i)));
      o.delete("constructor"), o.delete(Ge), yc(i, hv, o);
    }
    e[hv].forEach(function(a) {
      return r.make_(
        a,
        // must pass "undefined" for { key: undefined }
        t && a in t ? t[a] : !0
      );
    });
  }), e);
}
var uE = "splice", Xr = "update", qW = 1e4, HW = {
  get: function(t, n) {
    var r = t[Ge];
    return n === Ge ? r : n === "length" ? r.getArrayLength_() : typeof n == "string" && !isNaN(n) ? r.get_(parseInt(n)) : Ir(jd, n) ? jd[n] : t[n];
  },
  set: function(t, n, r) {
    var i = t[Ge];
    return n === "length" && i.setArrayLength_(r), typeof n == "symbol" || isNaN(n) ? t[n] = r : i.set_(parseInt(n), r), !0;
  },
  preventExtensions: function() {
    ke(15);
  }
}, t0 = /* @__PURE__ */ (function() {
  function e(n, r, i, o) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ci() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = i, this.legacyMode_ = o, this.atom_ = new zo(n), this.enhancer_ = function(a, s) {
      return r(a, s, process.env.NODE_ENV !== "production" ? n + "[..]" : "ObservableArray[..]");
    };
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.dehanceValues_ = function(r) {
    return this.dehancer !== void 0 && r.length > 0 ? r.map(this.dehancer) : r;
  }, t.intercept_ = function(r) {
    return xc(this, r);
  }, t.observe_ = function(r, i) {
    return i === void 0 && (i = !1), i && r({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), Ec(this, r);
  }, t.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, t.setArrayLength_ = function(r) {
    (typeof r != "number" || isNaN(r) || r < 0) && ke("Out of range: " + r);
    var i = this.values_.length;
    if (r !== i)
      if (r > i) {
        for (var o = new Array(r - i), a = 0; a < r - i; a++)
          o[a] = void 0;
        this.spliceWithArray_(i, 0, o);
      } else
        this.spliceWithArray_(r, i - r);
  }, t.updateArrayLength_ = function(r, i) {
    r !== this.lastKnownLength_ && ke(16), this.lastKnownLength_ += i, this.legacyMode_ && i > 0 && I4(r + i + 1);
  }, t.spliceWithArray_ = function(r, i, o) {
    var a = this;
    Oi(this.atom_);
    var s = this.values_.length;
    if (r === void 0 ? r = 0 : r > s ? r = s : r < 0 && (r = Math.max(0, s + r)), arguments.length === 1 ? i = s - r : i == null ? i = 0 : i = Math.max(0, Math.min(i, s - r)), o === void 0 && (o = Ad), $r(this)) {
      var l = Tr(this, {
        object: this.proxy_,
        type: uE,
        index: r,
        removedCount: i,
        added: o
      });
      if (!l)
        return Ad;
      i = l.removedCount, o = l.added;
    }
    if (o = o.length === 0 ? o : o.map(function(f) {
      return a.enhancer_(f, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var u = o.length - i;
      this.updateArrayLength_(s, u);
    }
    var c = this.spliceItemsIntoValues_(r, i, o);
    return (i !== 0 || o.length !== 0) && this.notifyArraySplice_(r, o, c), this.dehanceValues_(c);
  }, t.spliceItemsIntoValues_ = function(r, i, o) {
    if (o.length < qW) {
      var a;
      return (a = this.values_).splice.apply(a, [r, i].concat(o));
    } else {
      var s = this.values_.slice(r, r + i), l = this.values_.slice(r + i);
      this.values_.length += o.length - i;
      for (var u = 0; u < o.length; u++)
        this.values_[r + u] = o[u];
      for (var c = 0; c < l.length; c++)
        this.values_[r + o.length + c] = l[c];
      return s;
    }
  }, t.notifyArrayChildUpdate_ = function(r, i, o) {
    var a = !this.owned_ && Sn(), s = ni(this), l = s || a ? {
      observableKind: "array",
      object: this.proxy_,
      type: Xr,
      debugObjectName: this.atom_.name_,
      index: r,
      newValue: i,
      oldValue: o
    } : null;
    process.env.NODE_ENV !== "production" && a && dr(l), this.atom_.reportChanged(), s && ri(this, l), process.env.NODE_ENV !== "production" && a && pr();
  }, t.notifyArraySplice_ = function(r, i, o) {
    var a = !this.owned_ && Sn(), s = ni(this), l = s || a ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: uE,
      index: r,
      removed: o,
      added: i,
      removedCount: o.length,
      addedCount: i.length
    } : null;
    process.env.NODE_ENV !== "production" && a && dr(l), this.atom_.reportChanged(), s && ri(this, l), process.env.NODE_ENV !== "production" && a && pr();
  }, t.get_ = function(r) {
    if (this.legacyMode_ && r >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + r + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + r);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[r]);
  }, t.set_ = function(r, i) {
    var o = this.values_;
    if (this.legacyMode_ && r > o.length && ke(17, r, o.length), r < o.length) {
      Oi(this.atom_);
      var a = o[r];
      if ($r(this)) {
        var s = Tr(this, {
          type: Xr,
          object: this.proxy_,
          // since "this" is the real array we need to pass its proxy
          index: r,
          newValue: i
        });
        if (!s)
          return;
        i = s.newValue;
      }
      i = this.enhancer_(i, a);
      var l = i !== a;
      l && (o[r] = i, this.notifyArrayChildUpdate_(r, i, a));
    } else {
      for (var u = new Array(r + 1 - o.length), c = 0; c < u.length - 1; c++)
        u[c] = void 0;
      u[u.length - 1] = i, this.spliceWithArray_(o.length, 0, u);
    }
  }, e;
})();
function WW(e, t, n, r) {
  return n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ci() : "ObservableArray"), r === void 0 && (r = !1), GD(), Vo(function() {
    var i = new t0(n, t, r, !1);
    QD(i.values_, Ge, i);
    var o = new Proxy(i.values_, HW);
    return i.proxy_ = o, e && e.length && i.spliceWithArray_(0, 0, e), o;
  });
}
var jd = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(t) {
    var n = this[Ge];
    return n.spliceWithArray_(0, n.values_.length, t);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(t, n) {
    for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
      i[o - 2] = arguments[o];
    var a = this[Ge];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return a.spliceWithArray_(t);
      case 2:
        return a.spliceWithArray_(t, n);
    }
    return a.spliceWithArray_(t, n, i);
  },
  spliceWithArray: function(t, n, r) {
    return this[Ge].spliceWithArray_(t, n, r);
  },
  push: function() {
    for (var t = this[Ge], n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.spliceWithArray_(t.values_.length, 0, r), t.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[Ge].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var t = this[Ge], n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.spliceWithArray_(0, 0, r), t.values_.length;
  },
  reverse: function() {
    return me.trackingDerivation && ke(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    me.trackingDerivation && ke(37, "sort");
    var t = this.slice();
    return t.sort.apply(t, arguments), this.replace(t), this;
  },
  remove: function(t) {
    var n = this[Ge], r = n.dehanceValues_(n.values_).indexOf(t);
    return r > -1 ? (this.splice(r, 1), !0) : !1;
  }
};
kt("at", br);
kt("concat", br);
kt("flat", br);
kt("includes", br);
kt("indexOf", br);
kt("join", br);
kt("lastIndexOf", br);
kt("slice", br);
kt("toString", br);
kt("toLocaleString", br);
kt("toSorted", br);
kt("toSpliced", br);
kt("with", br);
kt("every", fi);
kt("filter", fi);
kt("find", fi);
kt("findIndex", fi);
kt("findLast", fi);
kt("findLastIndex", fi);
kt("flatMap", fi);
kt("forEach", fi);
kt("map", fi);
kt("some", fi);
kt("toReversed", fi);
kt("reduce", P4);
kt("reduceRight", P4);
function kt(e, t) {
  typeof Array.prototype[e] == "function" && (jd[e] = t(e));
}
function br(e) {
  return function() {
    var t = this[Ge];
    t.atom_.reportObserved();
    var n = t.dehanceValues_(t.values_);
    return n[e].apply(n, arguments);
  };
}
function fi(e) {
  return function(t, n) {
    var r = this, i = this[Ge];
    i.atom_.reportObserved();
    var o = i.dehanceValues_(i.values_);
    return o[e](function(a, s) {
      return t.call(n, a, s, r);
    });
  };
}
function P4(e) {
  return function() {
    var t = this, n = this[Ge];
    n.atom_.reportObserved();
    var r = n.dehanceValues_(n.values_), i = arguments[0];
    return arguments[0] = function(o, a, s) {
      return i(o, a, s, t);
    }, r[e].apply(r, arguments);
  };
}
var ZW = /* @__PURE__ */ La("ObservableArrayAdministration", t0);
function Up(e) {
  return Mp(e) && ZW(e[Ge]);
}
var GW = {}, xo = "add", Fd = "delete", k4 = /* @__PURE__ */ (function() {
  function e(n, r, i) {
    var o = this;
    r === void 0 && (r = Ea), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableMap@" + ci() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[Ge] = GW, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = r, this.name_ = i, hn(Map) || ke(18), Vo(function() {
      o.keysAtom_ = t4(process.env.NODE_ENV !== "production" ? o.name_ + ".keys()" : "ObservableMap.keys()"), o.data_ = /* @__PURE__ */ new Map(), o.hasMap_ = /* @__PURE__ */ new Map(), n && o.merge(n);
    });
  }
  var t = e.prototype;
  return t.has_ = function(r) {
    return this.data_.has(r);
  }, t.has = function(r) {
    var i = this;
    if (!me.trackingDerivation)
      return this.has_(r);
    var o = this.hasMap_.get(r);
    if (!o) {
      var a = o = new ha(this.has_(r), Fp, process.env.NODE_ENV !== "production" ? this.name_ + "." + mg(r) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(r, a), E4(a, function() {
        return i.hasMap_.delete(r);
      });
    }
    return o.get();
  }, t.set = function(r, i) {
    var o = this.has_(r);
    if ($r(this)) {
      var a = Tr(this, {
        type: o ? Xr : xo,
        object: this,
        newValue: i,
        name: r
      });
      if (!a)
        return this;
      i = a.newValue;
    }
    return o ? this.updateValue_(r, i) : this.addValue_(r, i), this;
  }, t.delete = function(r) {
    var i = this;
    if (Oi(this.keysAtom_), $r(this)) {
      var o = Tr(this, {
        type: Fd,
        object: this,
        name: r
      });
      if (!o)
        return !1;
    }
    if (this.has_(r)) {
      var a = Sn(), s = ni(this), l = s || a ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Fd,
        object: this,
        oldValue: this.data_.get(r).value_,
        name: r
      } : null;
      return process.env.NODE_ENV !== "production" && a && dr(l), Fi(function() {
        var u;
        i.keysAtom_.reportChanged(), (u = i.hasMap_.get(r)) == null || u.setNewValue_(!1);
        var c = i.data_.get(r);
        c.setNewValue_(void 0), i.data_.delete(r);
      }), s && ri(this, l), process.env.NODE_ENV !== "production" && a && pr(), !0;
    }
    return !1;
  }, t.updateValue_ = function(r, i) {
    var o = this.data_.get(r);
    if (i = o.prepareNewValue_(i), i !== me.UNCHANGED) {
      var a = Sn(), s = ni(this), l = s || a ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Xr,
        object: this,
        oldValue: o.value_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && a && dr(l), o.setNewValue_(i), s && ri(this, l), process.env.NODE_ENV !== "production" && a && pr();
    }
  }, t.addValue_ = function(r, i) {
    var o = this;
    Oi(this.keysAtom_), Fi(function() {
      var u, c = new ha(i, o.enhancer_, process.env.NODE_ENV !== "production" ? o.name_ + "." + mg(r) : "ObservableMap.key", !1);
      o.data_.set(r, c), i = c.value_, (u = o.hasMap_.get(r)) == null || u.setNewValue_(!0), o.keysAtom_.reportChanged();
    });
    var a = Sn(), s = ni(this), l = s || a ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: xo,
      object: this,
      name: r,
      newValue: i
    } : null;
    process.env.NODE_ENV !== "production" && a && dr(l), s && ri(this, l), process.env.NODE_ENV !== "production" && a && pr();
  }, t.get = function(r) {
    return this.has(r) ? this.dehanceValue_(this.data_.get(r).get()) : this.dehanceValue_(void 0);
  }, t.getOrInsert = function(r, i) {
    return this.has(r) || this.set(r, i), this.get(r);
  }, t.getOrInsertComputed = function(r, i) {
    return this.has(r) || this.set(r, i(r)), this.get(r);
  }, t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, t.values = function() {
    var r = this, i = this.keys();
    return cE({
      next: function() {
        var a = i.next(), s = a.done, l = a.value;
        return {
          done: s,
          value: s ? void 0 : r.get(l)
        };
      }
    });
  }, t.entries = function() {
    var r = this, i = this.keys();
    return cE({
      next: function() {
        var a = i.next(), s = a.done, l = a.value;
        return {
          done: s,
          value: s ? void 0 : [l, r.get(l)]
        };
      }
    });
  }, t[Symbol.iterator] = function() {
    return this.entries();
  }, t.forEach = function(r, i) {
    for (var o = ps(this), a; !(a = o()).done; ) {
      var s = a.value, l = s[0], u = s[1];
      r.call(i, u, l, this);
    }
  }, t.merge = function(r) {
    var i = this;
    return Lo(r) && (r = new Map(r)), Fi(function() {
      fr(r) ? sH(r).forEach(function(o) {
        return i.set(o, r[o]);
      }) : Array.isArray(r) ? r.forEach(function(o) {
        var a = o[0], s = o[1];
        return i.set(a, s);
      }) : fl(r) ? (aH(r) || ke(19, r), r.forEach(function(o, a) {
        return i.set(a, o);
      })) : r != null && ke(20, r);
    }), this;
  }, t.clear = function() {
    var r = this;
    Fi(function() {
      f4(function() {
        for (var i = ps(r.keys()), o; !(o = i()).done; ) {
          var a = o.value;
          r.delete(a);
        }
      });
    });
  }, t.replace = function(r) {
    var i = this;
    return Fi(function() {
      for (var o = YW(r), a = /* @__PURE__ */ new Map(), s = !1, l = ps(i.data_.keys()), u; !(u = l()).done; ) {
        var c = u.value;
        if (!o.has(c)) {
          var f = i.delete(c);
          if (f)
            s = !0;
          else {
            var d = i.data_.get(c);
            a.set(c, d);
          }
        }
      }
      for (var p = ps(o.entries()), h; !(h = p()).done; ) {
        var v = h.value, m = v[0], g = v[1], _ = i.data_.has(m);
        if (i.set(m, g), i.data_.has(m)) {
          var w = i.data_.get(m);
          a.set(m, w), _ || (s = !0);
        }
      }
      if (!s)
        if (i.data_.size !== a.size)
          i.keysAtom_.reportChanged();
        else
          for (var x = i.data_.keys(), S = a.keys(), $ = x.next(), A = S.next(); !$.done; ) {
            if ($.value !== A.value) {
              i.keysAtom_.reportChanged();
              break;
            }
            $ = x.next(), A = S.next();
          }
      i.data_ = a;
    }), this;
  }, t.toString = function() {
    return "[object ObservableMap]";
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && ke("`observe` doesn't support fireImmediately=true in combination with maps."), Ec(this, r);
  }, t.intercept_ = function(r) {
    return xc(this, r);
  }, dl(e, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Map";
    }
  }]);
})(), Lo = /* @__PURE__ */ La("ObservableMap", k4);
function cE(e) {
  return e[Symbol.toStringTag] = "MapIterator", r0(e);
}
function YW(e) {
  if (fl(e) || Lo(e))
    return e;
  if (Array.isArray(e))
    return new Map(e);
  if (fr(e)) {
    var t = /* @__PURE__ */ new Map();
    for (var n in e)
      t.set(n, e[n]);
    return t;
  } else
    return ke(21, e);
}
var QW = {}, D4 = /* @__PURE__ */ (function() {
  function e(n, r, i) {
    var o = this;
    r === void 0 && (r = Ea), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableSet@" + ci() : "ObservableSet"), this.name_ = void 0, this[Ge] = QW, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = i, hn(Set) || ke(22), this.enhancer_ = function(a, s) {
      return r(a, s, i);
    }, Vo(function() {
      o.atom_ = t4(o.name_), n && o.replace(n);
    });
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.clear = function() {
    var r = this;
    Fi(function() {
      f4(function() {
        for (var i = ps(r.data_.values()), o; !(o = i()).done; ) {
          var a = o.value;
          r.delete(a);
        }
      });
    });
  }, t.forEach = function(r, i) {
    for (var o = ps(this), a; !(a = o()).done; ) {
      var s = a.value;
      r.call(i, s, s, this);
    }
  }, t.add = function(r) {
    var i = this;
    if (Oi(this.atom_), $r(this)) {
      var o = Tr(this, {
        type: xo,
        object: this,
        newValue: r
      });
      if (!o)
        return this;
      r = o.newValue;
    }
    if (!this.has(r)) {
      Fi(function() {
        i.data_.add(i.enhancer_(r, void 0)), i.atom_.reportChanged();
      });
      var a = process.env.NODE_ENV !== "production" && Sn(), s = ni(this), l = s || a ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: xo,
        object: this,
        newValue: r
      } : null;
      a && process.env.NODE_ENV !== "production" && dr(l), s && ri(this, l), a && process.env.NODE_ENV !== "production" && pr();
    }
    return this;
  }, t.delete = function(r) {
    var i = this;
    if ($r(this)) {
      var o = Tr(this, {
        type: Fd,
        object: this,
        oldValue: r
      });
      if (!o)
        return !1;
    }
    if (this.has(r)) {
      var a = process.env.NODE_ENV !== "production" && Sn(), s = ni(this), l = s || a ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: Fd,
        object: this,
        oldValue: r
      } : null;
      return a && process.env.NODE_ENV !== "production" && dr(l), Fi(function() {
        i.atom_.reportChanged(), i.data_.delete(r);
      }), s && ri(this, l), a && process.env.NODE_ENV !== "production" && pr(), !0;
    }
    return !1;
  }, t.has = function(r) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(r));
  }, t.entries = function() {
    var r = this.values();
    return fE({
      next: function() {
        var o = r.next(), a = o.value, s = o.done;
        return s ? {
          value: void 0,
          done: s
        } : {
          value: [a, a],
          done: s
        };
      }
    });
  }, t.keys = function() {
    return this.values();
  }, t.values = function() {
    this.atom_.reportObserved();
    var r = this, i = this.data_.values();
    return fE({
      next: function() {
        var a = i.next(), s = a.value, l = a.done;
        return l ? {
          value: void 0,
          done: l
        } : {
          value: r.dehanceValue_(s),
          done: l
        };
      }
    });
  }, t.intersection = function(r) {
    if (ji(r) && !wi(r))
      return r.intersection(this);
    var i = new Set(this);
    return i.intersection(r);
  }, t.union = function(r) {
    if (ji(r) && !wi(r))
      return r.union(this);
    var i = new Set(this);
    return i.union(r);
  }, t.difference = function(r) {
    return new Set(this).difference(r);
  }, t.symmetricDifference = function(r) {
    if (ji(r) && !wi(r))
      return r.symmetricDifference(this);
    var i = new Set(this);
    return i.symmetricDifference(r);
  }, t.isSubsetOf = function(r) {
    return new Set(this).isSubsetOf(r);
  }, t.isSupersetOf = function(r) {
    return new Set(this).isSupersetOf(r);
  }, t.isDisjointFrom = function(r) {
    if (ji(r) && !wi(r))
      return r.isDisjointFrom(this);
    var i = new Set(this);
    return i.isDisjointFrom(r);
  }, t.replace = function(r) {
    var i = this;
    return wi(r) && (r = new Set(r)), Fi(function() {
      Array.isArray(r) ? (i.clear(), r.forEach(function(o) {
        return i.add(o);
      })) : ji(r) ? (i.clear(), r.forEach(function(o) {
        return i.add(o);
      })) : r != null && ke("Cannot initialize set from " + r);
    }), this;
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && ke("`observe` doesn't support fireImmediately=true in combination with sets."), Ec(this, r);
  }, t.intercept_ = function(r) {
    return xc(this, r);
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.toString = function() {
    return "[object ObservableSet]";
  }, t[Symbol.iterator] = function() {
    return this.values();
  }, dl(e, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Set";
    }
  }]);
})(), wi = /* @__PURE__ */ La("ObservableSet", D4);
function fE(e) {
  return e[Symbol.toStringTag] = "SetIterator", r0(e);
}
var dE = /* @__PURE__ */ Object.create(null), pE = "remove", $g = /* @__PURE__ */ (function() {
  function e(n, r, i, o) {
    r === void 0 && (r = /* @__PURE__ */ new Map()), o === void 0 && (o = zH), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.lazyComputedKeys_ = void 0, this.lazyObservableKeys_ = void 0, this.target_ = n, this.values_ = r, this.name_ = i, this.defaultAnnotation_ = o, this.keysAtom_ = new zo(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = fr(this.target_), process.env.NODE_ENV !== "production" && !M4(this.defaultAnnotation_) && ke("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var t = e.prototype;
  return t.getObservablePropValue_ = function(r) {
    var i, o, a = (i = (o = this.values_.get(r)) != null ? o : this.materializeLazyComputed_(r)) != null ? i : this.materializeLazyObservable_(r);
    return a.get();
  }, t.materializeLazyComputed_ = function(r) {
    var i, o = (i = this.lazyComputedKeys_) == null ? void 0 : i.get(r);
    if (o) {
      this.lazyComputedKeys_.delete(r), this.lazyComputedKeys_.size === 0 && (this.lazyComputedKeys_ = void 0);
      var a = o();
      return this.values_.set(r, a), a;
    }
  }, t.materializeLazyObservable_ = function(r) {
    var i, o = (i = this.lazyObservableKeys_) == null ? void 0 : i.get(r);
    if (o) {
      this.lazyObservableKeys_.delete(r), this.lazyObservableKeys_.size === 0 && (this.lazyObservableKeys_ = void 0);
      var a = o();
      return this.values_.set(r, a), a;
    }
  }, t.setObservablePropValue_ = function(r, i) {
    var o, a, s = (o = (a = this.values_.get(r)) != null ? a : this.materializeLazyComputed_(r)) != null ? o : this.materializeLazyObservable_(r);
    if (s instanceof Gn)
      return s.set(i), !0;
    if ($r(this)) {
      var l = Tr(this, {
        type: Xr,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: i
      });
      if (!l)
        return null;
      i = l.newValue;
    }
    if (i = s.prepareNewValue_(i), i !== me.UNCHANGED) {
      var u = ni(this), c = process.env.NODE_ENV !== "production" && Sn(), f = u || c ? {
        type: Xr,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: s.value_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && c && dr(f), s.setNewValue_(i), u && ri(this, f), process.env.NODE_ENV !== "production" && c && pr();
    }
    return !0;
  }, t.get_ = function(r) {
    return me.trackingDerivation && !Ir(this.target_, r) && this.has_(r), this.target_[r];
  }, t.set_ = function(r, i, o) {
    return o === void 0 && (o = !1), Ir(this.target_, r) ? this.values_.has(r) ? this.setObservablePropValue_(r, i) : o ? Reflect.set(this.target_, r, i) : (this.target_[r] = i, !0) : this.extend_(r, {
      value: i,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, o);
  }, t.has_ = function(r) {
    if (!me.trackingDerivation)
      return r in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var i = this.pendingKeys_.get(r);
    return i || (i = new ha(r in this.target_, Fp, process.env.NODE_ENV !== "production" ? this.name_ + "." + mg(r) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(r, i)), i.get();
  }, t.make_ = function(r, i) {
    if (i === !0 && (i = this.defaultAnnotation_), i !== !1) {
      if (mE(this, i, r), !(r in this.target_)) {
        var o;
        if ((o = this.target_[Zn]) != null && o[r])
          return;
        ke(1, i.annotationType_, this.name_ + "." + r.toString());
      }
      for (var a = this.target_; a && a !== Rp; ) {
        var s = Dd(a, r);
        if (s) {
          var l = i.make_(this, r, s, a);
          if (l === 0)
            return;
          if (l === 1)
            break;
        }
        a = Object.getPrototypeOf(a);
      }
      vE(this, i, r);
    }
  }, t.extend_ = function(r, i, o, a) {
    if (a === void 0 && (a = !1), o === !0 && (o = this.defaultAnnotation_), o === !1)
      return this.defineProperty_(r, i, a);
    mE(this, o, r);
    var s = o.extend_(this, r, i, a);
    return s && vE(this, o, r), s;
  }, t.defineProperty_ = function(r, i, o) {
    o === void 0 && (o = !1), Oi(this.keysAtom_);
    try {
      Pr();
      var a = this.delete_(r);
      if (!a)
        return a;
      if ($r(this)) {
        var s = Tr(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: xo,
          newValue: i.value
        });
        if (!s)
          return null;
        var l = s.newValue;
        i.value !== l && (i = Gi({}, i, {
          value: l
        }));
      }
      if (o) {
        if (!Reflect.defineProperty(this.target_, r, i))
          return !1;
      } else
        Ti(this.target_, r, i);
      this.notifyPropertyAddition_(r, i.value);
    } finally {
      kr();
    }
    return !0;
  }, t.defineObservableProperty_ = function(r, i, o, a) {
    a === void 0 && (a = !1), Oi(this.keysAtom_);
    try {
      Pr();
      var s = this.delete_(r);
      if (!s)
        return s;
      if ($r(this)) {
        var l = Tr(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: xo,
          newValue: i
        });
        if (!l)
          return null;
        i = l.newValue;
      }
      var u = hE(r), c = {
        configurable: me.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: u.get,
        set: u.set
      };
      if (a) {
        if (!Reflect.defineProperty(this.target_, r, c))
          return !1;
      } else
        Ti(this.target_, r, c);
      var f = new ha(i, o, process.env.NODE_ENV !== "production" ? this.name_ + "." + r.toString() : "ObservableObject.key", !1);
      this.values_.set(r, f), this.notifyPropertyAddition_(r, f.value_);
    } finally {
      kr();
    }
    return !0;
  }, t.defineComputedProperty_ = function(r, i, o) {
    o === void 0 && (o = !1), Oi(this.keysAtom_);
    try {
      Pr();
      var a = this.delete_(r);
      if (!a)
        return a;
      if ($r(this)) {
        var s = Tr(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: xo,
          newValue: void 0
        });
        if (!s)
          return null;
      }
      i.name || (i.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + r.toString() : "ObservableObject.key"), i.context = this.proxy_ || this.target_;
      var l = hE(r), u = {
        configurable: me.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: l.get,
        set: l.set
      };
      if (o) {
        if (!Reflect.defineProperty(this.target_, r, u))
          return !1;
      } else
        Ti(this.target_, r, u);
      this.values_.set(r, new Gn(i)), this.notifyPropertyAddition_(r, void 0);
    } finally {
      kr();
    }
    return !0;
  }, t.delete_ = function(r, i) {
    if (i === void 0 && (i = !1), Oi(this.keysAtom_), !Ir(this.target_, r))
      return !0;
    if ($r(this)) {
      var o = Tr(this, {
        object: this.proxy_ || this.target_,
        name: r,
        type: pE
      });
      if (!o)
        return null;
    }
    try {
      var a;
      Pr();
      var s = ni(this), l = process.env.NODE_ENV !== "production" && Sn(), u = this.values_.get(r), c = void 0;
      if (!u && (s || l)) {
        var f;
        c = (f = Dd(this.target_, r)) == null ? void 0 : f.value;
      }
      if (i) {
        if (!Reflect.deleteProperty(this.target_, r))
          return !1;
      } else
        delete this.target_[r];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[r], u && (this.values_.delete(r), u instanceof ha && (c = u.value_), g4(u)), this.keysAtom_.reportChanged(), (a = this.pendingKeys_) == null || (a = a.get(r)) == null || a.set(r in this.target_), s || l) {
        var d = {
          type: pE,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: c,
          name: r
        };
        process.env.NODE_ENV !== "production" && l && dr(d), s && ri(this, d), process.env.NODE_ENV !== "production" && l && pr();
      }
    } finally {
      kr();
    }
    return !0;
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && ke("`observe` doesn't support the fire immediately property for observable objects."), Ec(this, r);
  }, t.intercept_ = function(r) {
    return xc(this, r);
  }, t.notifyPropertyAddition_ = function(r, i) {
    var o, a = ni(this), s = process.env.NODE_ENV !== "production" && Sn();
    if (a || s) {
      var l = a || s ? {
        type: xo,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && s && dr(l), a && ri(this, l), process.env.NODE_ENV !== "production" && s && pr();
    }
    (o = this.pendingKeys_) == null || (o = o.get(r)) == null || o.set(!0), this.keysAtom_.reportChanged();
  }, t.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), zs(this.target_);
  }, t.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, e;
})();
function Ka(e, t) {
  var n;
  if (process.env.NODE_ENV !== "production" && t && pl(e) && ke("Options can't be provided for already observable objects."), Ir(e, Ge))
    return process.env.NODE_ENV !== "production" && !(N4(e) instanceof $g) && ke("Cannot convert '" + zd(e) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), e;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(e) && ke("Cannot make the designated object observable; it is not extensible");
  var r = (n = t?.name) != null ? n : process.env.NODE_ENV !== "production" ? (fr(e) ? "ObservableObject" : e.constructor.name) + "@" + ci() : "ObservableObject", i = new $g(e, /* @__PURE__ */ new Map(), String(r), YH(t));
  return yc(e, Ge, i), e;
}
var JW = /* @__PURE__ */ La("ObservableObjectAdministration", $g);
function hE(e) {
  return dE[e] || (dE[e] = {
    get: function() {
      return this[Ge].getObservablePropValue_(e);
    },
    set: function(n) {
      return this[Ge].setObservablePropValue_(e, n);
    }
  });
}
function pl(e) {
  return Mp(e) ? JW(e[Ge]) : !1;
}
function vE(e, t, n) {
  var r;
  process.env.NODE_ENV !== "production" && (e.appliedAnnotations_[n] = t), (r = e.target_[Zn]) == null || delete r[n];
}
function mE(e, t, n) {
  if (process.env.NODE_ENV !== "production" && !M4(t) && ke("Cannot annotate '" + e.name_ + "." + n.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !Id(t) && Ir(e.appliedAnnotations_, n)) {
    var r = e.name_ + "." + n.toString(), i = e.appliedAnnotations_[n].annotationType_, o = t.annotationType_;
    ke("Cannot apply '" + o + "' to '" + r + "':" + (`
The field is already annotated with '` + i + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var XW = /* @__PURE__ */ C4(0), eZ = /* @__PURE__ */ (function() {
  var e = !1, t = {};
  return Object.defineProperty(t, "0", {
    set: function() {
      e = !0;
    }
  }), Object.create(t)[0] = 1, e === !1;
})(), vv = 0, A4 = function() {
};
function tZ(e, t) {
  Object.setPrototypeOf ? Object.setPrototypeOf(e.prototype, t) : e.prototype.__proto__ !== void 0 ? e.prototype.__proto__ = t : e.prototype = t;
}
tZ(A4, Array.prototype);
var n0 = /* @__PURE__ */ (function(e) {
  function t(r, i, o, a) {
    var s;
    return o === void 0 && (o = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ci() : "ObservableArray"), a === void 0 && (a = !1), s = e.call(this) || this, Vo(function() {
      var l = new t0(o, i, a, !0);
      l.proxy_ = s, QD(s, Ge, l), r && r.length && s.spliceWithArray(0, 0, r), eZ && Object.defineProperty(s, "0", XW);
    }), s;
  }
  Yb(t, e);
  var n = t.prototype;
  return n.concat = function() {
    this[Ge].atom_.reportObserved();
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      o.map(function(s) {
        return Up(s) ? s.slice() : s;
      })
    );
  }, n[Symbol.iterator] = function() {
    var r = this, i = 0;
    return r0({
      next: function() {
        return i < r.length ? {
          value: r[i++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, dl(t, [{
    key: "length",
    get: function() {
      return this[Ge].getArrayLength_();
    },
    set: function(i) {
      this[Ge].setArrayLength_(i);
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Array";
    }
  }]);
})(A4);
Object.entries(jd).forEach(function(e) {
  var t = e[0], n = e[1];
  t !== "concat" && yc(n0.prototype, t, n);
});
function C4(e) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[Ge].get_(e);
    },
    set: function(n) {
      this[Ge].set_(e, n);
    }
  };
}
function nZ(e) {
  Ti(n0.prototype, "" + e, C4(e));
}
function I4(e) {
  if (e > vv) {
    for (var t = vv; t < e + 100; t++)
      nZ(t);
    vv = e;
  }
}
I4(1e3);
function rZ(e, t, n) {
  return new n0(e, t, n);
}
function Vs(e, t) {
  if (typeof e == "object" && e !== null) {
    if (Up(e))
      return t !== void 0 && ke(23), e[Ge].atom_;
    if (wi(e))
      return e.atom_;
    if (Lo(e)) {
      if (t === void 0)
        return e.keysAtom_;
      var n = e.data_.get(t) || e.hasMap_.get(t);
      return n || ke(25, t, zd(e)), n;
    }
    if (pl(e)) {
      var r, i;
      if (!t)
        return ke(26);
      var o = e[Ge], a = (r = (i = o.values_.get(t)) != null ? i : o.materializeLazyComputed_(t)) != null ? r : o.materializeLazyObservable_(t);
      return a || ke(27, t, zd(e)), a;
    }
    if (Qb(e) || Bp(e) || Md(e))
      return e;
  } else if (hn(e) && Md(e[Ge]))
    return e[Ge];
  ke(28);
}
function N4(e, t) {
  if (e || ke(29), Qb(e) || Bp(e) || Md(e) || Lo(e) || wi(e))
    return e;
  if (e[Ge])
    return e[Ge];
  ke(24, e);
}
function zd(e, t) {
  var n;
  if (t !== void 0)
    n = Vs(e, t);
  else {
    if ($a(e))
      return e.name;
    pl(e) || Lo(e) || wi(e) ? n = N4(e) : n = Vs(e);
  }
  return n.name_;
}
function Vo(e) {
  var t = Va(), n = Vp(!0);
  Pr();
  try {
    return e();
  } finally {
    kr(), Kp(n), Vi(t);
  }
}
var gE = Rp.toString;
function R4(e, t, n) {
  return n === void 0 && (n = -1), Tg(e, t, n);
}
function Tg(e, t, n, r, i) {
  if (e === t)
    return e !== 0 || 1 / e === 1 / t;
  if (e == null || t == null)
    return !1;
  if (e !== e)
    return t !== t;
  var o = typeof e;
  if (o !== "function" && o !== "object" && typeof t != "object")
    return !1;
  var a = gE.call(e);
  if (a !== gE.call(t))
    return !1;
  switch (a) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      return "" + e == "" + t;
    case "[object Number]":
      return +e != +e ? +t != +t : +e == 0 ? 1 / +e === 1 / t : +e == +t;
    case "[object Date]":
    case "[object Boolean]":
      return +e == +t;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(e) === Symbol.valueOf.call(t);
    case "[object Map]":
    case "[object Set]":
      n >= 0 && n++;
      break;
  }
  e = yE(e), t = yE(t);
  var s = a === "[object Array]";
  if (!s) {
    if (typeof e != "object" || typeof t != "object")
      return !1;
    var l = e.constructor, u = t.constructor;
    if (l !== u && !(hn(l) && l instanceof l && hn(u) && u instanceof u) && "constructor" in e && "constructor" in t)
      return !1;
  }
  if (n === 0)
    return !1;
  n < 0 && (n = -1), r = r || [], i = i || [];
  for (var c = r.length; c--; )
    if (r[c] === e)
      return i[c] === t;
  if (r.push(e), i.push(t), s) {
    if (c = e.length, c !== t.length)
      return !1;
    for (; c--; )
      if (!Tg(e[c], t[c], n - 1, r, i))
        return !1;
  } else {
    var f = Object.keys(e), d = f.length;
    if (Object.keys(t).length !== d)
      return !1;
    for (var p = 0; p < d; p++) {
      var h = f[p];
      if (!(Ir(t, h) && Tg(e[h], t[h], n - 1, r, i)))
        return !1;
    }
  }
  return r.pop(), i.pop(), !0;
}
function yE(e) {
  return Up(e) ? e.slice() : fl(e) || Lo(e) || ji(e) || wi(e) ? Array.from(e.entries()) : e;
}
var bE, iZ = /* @__PURE__ */ Np(), oZ = ((bE = iZ.Iterator) == null ? void 0 : bE.prototype) || {};
function r0(e) {
  return e[Symbol.iterator] = aZ, Object.assign(Object.create(oZ), e);
}
function aZ() {
  return this;
}
function M4(e) {
  return (
    // Can be function
    e instanceof Object && typeof e.annotationType_ == "string" && hn(e.make_) && hn(e.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(e) {
  var t = Np();
  typeof t[e] > "u" && ke("MobX requires global '" + e + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: bW,
  extras: {
    getDebugName: zd
  },
  $mobx: Ge
});
if (!Ve)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!BW)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
function sZ(e) {
  e();
}
function lZ(e) {
  e || (e = sZ, process.env.NODE_ENV !== "production" && console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native")), IW({ reactionScheduler: e });
}
function uZ(e) {
  return $4(e);
}
var cZ = 1e4, fZ = 1e4, dZ = (
  /** @class */
  (function() {
    function e(t) {
      var n = this;
      Object.defineProperty(this, "finalize", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }), Object.defineProperty(this, "registrations", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "sweepTimeout", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "sweep", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(r) {
          r === void 0 && (r = cZ), clearTimeout(n.sweepTimeout), n.sweepTimeout = void 0;
          var i = Date.now();
          n.registrations.forEach(function(o, a) {
            i - o.registeredAt >= r && (n.finalize(o.value), n.registrations.delete(a));
          }), n.registrations.size > 0 && n.scheduleSweep();
        }
      }), Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function() {
          n.sweep(0);
        }
      });
    }
    return Object.defineProperty(e.prototype, "register", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(t, n, r) {
        this.registrations.set(r, {
          value: n,
          registeredAt: Date.now()
        }), this.scheduleSweep();
      }
    }), Object.defineProperty(e.prototype, "unregister", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(t) {
        this.registrations.delete(t);
      }
    }), Object.defineProperty(e.prototype, "scheduleSweep", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, fZ));
      }
    }), e;
  })()
), pZ = typeof FinalizationRegistry < "u" ? FinalizationRegistry : dZ, qu = new pZ(function(e) {
  var t;
  (t = e.reaction) === null || t === void 0 || t.dispose(), e.reaction = null;
});
function _E(e) {
  e.reaction = new ki("observer".concat(e.name), function() {
    var t;
    e.stateVersion = Symbol(), (t = e.onStoreChange) === null || t === void 0 || t.call(e);
  });
}
function hZ(e, t) {
  t === void 0 && (t = "observed");
  var n = H.useRef(null);
  if (!n.current) {
    var r = {
      reaction: null,
      onStoreChange: null,
      stateVersion: Symbol(),
      name: t,
      subscribe: function(s) {
        return qu.unregister(r), r.onStoreChange = s, r.reaction || (_E(r), r.stateVersion = Symbol()), function() {
          var l;
          r.onStoreChange = null, (l = r.reaction) === null || l === void 0 || l.dispose(), r.reaction = null;
        };
      },
      getSnapshot: function() {
        return r.stateVersion;
      }
    };
    n.current = r;
  }
  var i = n.current;
  i.reaction || (_E(i), qu.register(n, i, i)), H.useDebugValue(i.reaction, uZ), dP.useSyncExternalStore(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    i.subscribe,
    i.getSnapshot,
    i.getSnapshot
  );
  var o, a;
  if (i.reaction.track(function() {
    try {
      o = e();
    } catch (s) {
      a = s;
    }
  }), a)
    throw a;
  return o;
}
var mv, gv, vZ = !0, wE = !0, j4 = typeof Symbol == "function" && Symbol.for, mZ = (gv = (mv = Object.getOwnPropertyDescriptor(function() {
}, "name")) === null || mv === void 0 ? void 0 : mv.configurable) !== null && gv !== void 0 ? gv : !1, xE = j4 ? Symbol.for("react.forward_ref") : typeof fn == "function" && fn(function(e) {
  return null;
}).$$typeof, EE = j4 ? Symbol.for("react.memo") : typeof Xf == "function" && Xf(function(e) {
  return null;
}).$$typeof;
function gZ(e, t) {
  var n;
  if (process.env.NODE_ENV, EE && e.$$typeof === EE)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var r = (n = void 0) !== null && n !== void 0 ? n : !1, i = e, o = e.displayName || e.name;
  if (xE && e.$$typeof === xE && (r = !0, i = e.render, typeof i != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var a = function(s, l) {
    return hZ(function() {
      return i(s, l);
    }, o);
  };
  return a.displayName = e.displayName, mZ && Object.defineProperty(a, "name", {
    value: e.name,
    writable: !0,
    configurable: !0
  }), e.contextTypes && (a.contextTypes = e.contextTypes, process.env.NODE_ENV !== "production" && wE && (wE = !1, console.warn("[mobx-react-lite] Support for Legacy Context in function components will be removed in the next major release."))), r && (a = fn(a)), a = Xf(a), bZ(e, a), process.env.NODE_ENV !== "production" && Object.defineProperty(a, "contextTypes", {
    set: function() {
      var s, l;
      throw new Error("[mobx-react-lite] `".concat(this.displayName || ((s = this.type) === null || s === void 0 ? void 0 : s.displayName) || ((l = this.type) === null || l === void 0 ? void 0 : l.name) || "Component", ".contextTypes` must be set before applying `observer`."));
    }
  }), a;
}
var yZ = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: !0
};
function bZ(e, t) {
  Object.keys(e).forEach(function(n) {
    yZ[n] || Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
  });
}
process.env.NODE_ENV;
function _Z(e, t) {
  return Ve(function() {
    return pn(e(), t, { autoBind: !0 });
  })[0];
}
var yv;
lZ(Q3);
yv = qu.finalizeAllImmediately;
function wZ(e, t) {
  if (SE(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (var i = 0; i < n.length; i++)
    if (!Object.hasOwnProperty.call(t, n[i]) || !SE(e[n[i]], t[n[i]]))
      return !1;
  return !0;
}
function SE(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var OE = /* @__PURE__ */ Symbol("patchMixins"), F4 = /* @__PURE__ */ Symbol("patchedDefinition");
function xZ(e, t) {
  var n = e[OE] = e[OE] || {}, r = n[t] = n[t] || {};
  return r.locks = r.locks || 0, r.methods = r.methods || [], r;
}
function $E(e, t) {
  for (var n = this, r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
    i[o - 2] = arguments[o];
  t.locks++;
  try {
    var a;
    return e != null && (a = e.apply(this, i)), a;
  } finally {
    t.locks--, t.locks === 0 && t.methods.forEach(function(s) {
      s.apply(n, i);
    });
  }
}
function TE(e, t) {
  var n = function() {
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    $E.call.apply($E, [this, e, t].concat(o));
  };
  return n;
}
function EZ(e, t, n) {
  var r = xZ(e, t);
  r.methods.indexOf(n) < 0 && r.methods.push(n);
  var i = Object.getOwnPropertyDescriptor(e, t);
  if (!(i && i[F4])) {
    var o = e[t], a = z4(e, t, i ? i.enumerable : void 0, r, o);
    Object.defineProperty(e, t, a);
  }
}
function z4(e, t, n, r, i) {
  var o, a = TE(i, r);
  return o = {}, o[F4] = !0, o.get = function() {
    return a;
  }, o.set = function(l) {
    if (this === e)
      a = TE(l, r);
    else {
      var u = z4(this, t, n, r, l);
      Object.defineProperty(this, t, u);
    }
  }, o.configurable = !0, o.enumerable = n, o;
}
var PE = /* @__PURE__ */ Symbol("ObserverAdministration"), kE = /* @__PURE__ */ Symbol("isMobXReactObserver"), L4;
process.env.NODE_ENV !== "production" && (L4 = {
  props: /* @__PURE__ */ bv("props"),
  state: /* @__PURE__ */ bv("state"),
  context: /* @__PURE__ */ bv("context")
});
function Hu(e) {
  var t;
  return (t = e[PE]) != null ? t : e[PE] = {
    reaction: null,
    mounted: !1,
    reactionInvalidatedBeforeMount: !1,
    forceUpdate: null,
    name: Lf(e.constructor),
    state: void 0,
    props: void 0,
    context: void 0
  };
}
function SZ(e) {
  var t = e.prototype;
  if (e[kE]) {
    var n = Lf(e);
    throw new Error("The provided component class (" + n + ") has already been declared as an observer component.");
  } else
    e[kE] = !0;
  if (t.componentWillReact)
    throw new Error("The componentWillReact life-cycle event is no longer supported");
  if (e.__proto__ !== hO) {
    if (!t.shouldComponentUpdate)
      t.shouldComponentUpdate = DE;
    else if (t.shouldComponentUpdate !== DE)
      throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
  }
  process.env.NODE_ENV !== "production" && Object.defineProperties(t, L4);
  var r = t.render;
  if (typeof r != "function") {
    var i = Lf(e);
    throw new Error("[mobx-react] class component (" + i + ") is missing `render` method.\n`observer` requires `render` being a function defined on prototype.\n`render = () => {}` or `render = function() {}` is not supported.");
  }
  t.render = function() {
    return Object.defineProperty(this, "render", {
      // There is no safe way to replace render, therefore it's forbidden.
      configurable: !1,
      writable: !1,
      value: OZ.call(this, r)
    }), this.render();
  };
  var o = t.componentDidMount;
  return t.componentDidMount = function() {
    var a = this;
    if (process.env.NODE_ENV !== "production" && this.componentDidMount !== Object.getPrototypeOf(this).componentDidMount) {
      var s = Lf(e);
      throw new Error("[mobx-react] `observer(" + s + ").componentDidMount` must be defined on prototype.\n`componentDidMount = () => {}` or `componentDidMount = function() {}` is not supported.");
    }
    var l = Hu(this);
    return l.mounted = !0, qu.unregister(this), l.forceUpdate = function() {
      return a.forceUpdate();
    }, (!l.reaction || l.reactionInvalidatedBeforeMount) && l.forceUpdate(), o?.apply(this, arguments);
  }, EZ(t, "componentWillUnmount", function() {
    var a, s = Hu(this);
    (a = s.reaction) == null || a.dispose(), s.reaction = null, s.forceUpdate = null, s.mounted = !1, s.reactionInvalidatedBeforeMount = !1;
  }), e;
}
function Lf(e) {
  return e.displayName || e.name || "<component>";
}
function OZ(e) {
  var t = e.bind(this), n = Hu(this);
  function r() {
    n.reaction || (n.reaction = $Z(n), n.mounted || qu.register(this, n, this));
    var i = void 0, o = void 0;
    if (n.reaction.track(function() {
      try {
        o = aW(!1, t);
      } catch (a) {
        i = a;
      }
    }), i)
      throw i;
    return o;
  }
  return r;
}
function $Z(e) {
  return new ki(e.name + ".render()", function() {
    if (!e.mounted) {
      e.reactionInvalidatedBeforeMount = !0;
      return;
    }
    try {
      e.forceUpdate == null || e.forceUpdate();
    } catch {
      var t;
      (t = e.reaction) == null || t.dispose(), e.reaction = null;
    }
  });
}
function DE(e, t) {
  return this.state !== t ? !0 : !wZ(this.props, e);
}
function bv(e) {
  return {
    configurable: !0,
    enumerable: !0,
    get: function() {
      var n = Hu(this), r = dW().trackingDerivation;
      if (r && r !== n.reaction)
        throw new Error('[mobx-react] Cannot read "' + n.name + "." + e + `" in a reactive context, as it isn't observable.
                    Please use component lifecycle method to copy the value into a local observable first.
                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations`);
      return n[e];
    },
    set: function(n) {
      Hu(this)[e] = n;
    }
  };
}
function V4(e, t) {
  return e.isMobxInjector === !0 && console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`"), Object.prototype.isPrototypeOf.call(Ey, e) || Object.prototype.isPrototypeOf.call(hO, e) ? SZ(e) : gZ(e);
}
H.version;
if (!Ey)
  throw new Error("mobx-react requires React to be available");
if (!pn)
  throw new Error("mobx-react requires mobx to be available");
const K4 = He({
  dragDropManager: void 0
});
function wr(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var AE = (function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
})(), CE = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, IE = {
  INIT: "@@redux/INIT" + CE(),
  REPLACE: "@@redux/REPLACE" + CE()
};
function TZ(e) {
  if (typeof e != "object" || e === null) return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function PZ(e) {
  if (e === void 0) return "undefined";
  if (e === null) return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e)) return "array";
  if (AZ(e)) return "date";
  if (DZ(e)) return "error";
  var n = kZ(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function kZ(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function DZ(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function AZ(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function Ya(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = PZ(e)), t;
}
function B4(e, t, n) {
  var r;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? wr(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(process.env.NODE_ENV === "production" ? wr(1) : "Expected the enhancer to be a function. Instead, received: '" + Ya(n) + "'");
    return n(B4)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? wr(2) : "Expected the root reducer to be a function. Instead, received: '" + Ya(e) + "'");
  var i = e, o = t, a = [], s = a, l = !1;
  function u() {
    s === a && (s = a.slice());
  }
  function c() {
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? wr(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return o;
  }
  function f(v) {
    if (typeof v != "function")
      throw new Error(process.env.NODE_ENV === "production" ? wr(4) : "Expected the listener to be a function. Instead, received: '" + Ya(v) + "'");
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? wr(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var m = !0;
    return u(), s.push(v), function() {
      if (m) {
        if (l)
          throw new Error(process.env.NODE_ENV === "production" ? wr(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        m = !1, u();
        var _ = s.indexOf(v);
        s.splice(_, 1), a = null;
      }
    };
  }
  function d(v) {
    if (!TZ(v))
      throw new Error(process.env.NODE_ENV === "production" ? wr(7) : "Actions must be plain objects. Instead, the actual type was: '" + Ya(v) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof v.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? wr(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? wr(9) : "Reducers may not dispatch actions.");
    try {
      l = !0, o = i(o, v);
    } finally {
      l = !1;
    }
    for (var m = a = s, g = 0; g < m.length; g++) {
      var _ = m[g];
      _();
    }
    return v;
  }
  function p(v) {
    if (typeof v != "function")
      throw new Error(process.env.NODE_ENV === "production" ? wr(10) : "Expected the nextReducer to be a function. Instead, received: '" + Ya(v));
    i = v, d({
      type: IE.REPLACE
    });
  }
  function h() {
    var v, m = f;
    return v = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(_) {
        if (typeof _ != "object" || _ === null)
          throw new Error(process.env.NODE_ENV === "production" ? wr(11) : "Expected the observer to be an object. Instead, received: '" + Ya(_) + "'");
        function w() {
          _.next && _.next(c());
        }
        w();
        var x = m(w);
        return {
          unsubscribe: x
        };
      }
    }, v[AE] = function() {
      return this;
    }, v;
  }
  return d({
    type: IE.INIT
  }), r = {
    dispatch: d,
    subscribe: f,
    getState: c,
    replaceReducer: p
  }, r[AE] = h, r;
}
function Xe(e, t, ...n) {
  if (CZ() && t === void 0)
    throw new Error("invariant requires an error message argument");
  if (!e) {
    let r;
    if (t === void 0)
      r = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      let i = 0;
      r = new Error(t.replace(/%s/g, function() {
        return n[i++];
      })), r.name = "Invariant Violation";
    }
    throw r.framesToPop = 1, r;
  }
}
function CZ() {
  return typeof process < "u" && process.env.NODE_ENV === "production";
}
function IZ(e, t, n) {
  return t.split(".").reduce(
    (r, i) => r && r[i] ? r[i] : n || null,
    e
  );
}
function NZ(e, t) {
  return e.filter(
    (n) => n !== t
  );
}
function U4(e) {
  return typeof e == "object";
}
function RZ(e, t) {
  const n = /* @__PURE__ */ new Map(), r = (o) => {
    n.set(o, n.has(o) ? n.get(o) + 1 : 1);
  };
  e.forEach(r), t.forEach(r);
  const i = [];
  return n.forEach((o, a) => {
    o === 1 && i.push(a);
  }), i;
}
function MZ(e, t) {
  return e.filter(
    (n) => t.indexOf(n) > -1
  );
}
const i0 = "dnd-core/INIT_COORDS", qp = "dnd-core/BEGIN_DRAG", o0 = "dnd-core/PUBLISH_DRAG_SOURCE", Hp = "dnd-core/HOVER", Wp = "dnd-core/DROP", Zp = "dnd-core/END_DRAG";
function NE(e, t) {
  return {
    type: i0,
    payload: {
      sourceClientOffset: t || null,
      clientOffset: e || null
    }
  };
}
const jZ = {
  type: i0,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function FZ(e) {
  return function(n = [], r = {
    publishSource: !0
  }) {
    const { publishSource: i = !0, clientOffset: o, getSourceClientOffset: a } = r, s = e.getMonitor(), l = e.getRegistry();
    e.dispatch(NE(o)), zZ(n, s, l);
    const u = KZ(n, s);
    if (u == null) {
      e.dispatch(jZ);
      return;
    }
    let c = null;
    if (o) {
      if (!a)
        throw new Error("getSourceClientOffset must be defined");
      LZ(a), c = a(u);
    }
    e.dispatch(NE(o, c));
    const d = l.getSource(u).beginDrag(s, u);
    if (d == null)
      return;
    VZ(d), l.pinSource(u);
    const p = l.getSourceType(u);
    return {
      type: qp,
      payload: {
        itemType: p,
        item: d,
        sourceId: u,
        clientOffset: o || null,
        sourceClientOffset: c || null,
        isSourcePublic: !!i
      }
    };
  };
}
function zZ(e, t, n) {
  Xe(!t.isDragging(), "Cannot call beginDrag while dragging."), e.forEach(function(r) {
    Xe(n.getSource(r), "Expected sourceIds to be registered.");
  });
}
function LZ(e) {
  Xe(typeof e == "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function VZ(e) {
  Xe(U4(e), "Item must be an object.");
}
function KZ(e, t) {
  let n = null;
  for (let r = e.length - 1; r >= 0; r--)
    if (t.canDragSource(e[r])) {
      n = e[r];
      break;
    }
  return n;
}
function BZ(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function UZ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      BZ(e, i, n[i]);
    });
  }
  return e;
}
function qZ(e) {
  return function(n = {}) {
    const r = e.getMonitor(), i = e.getRegistry();
    HZ(r), GZ(r).forEach((a, s) => {
      const l = WZ(a, s, i, r), u = {
        type: Wp,
        payload: {
          dropResult: UZ({}, n, l)
        }
      };
      e.dispatch(u);
    });
  };
}
function HZ(e) {
  Xe(e.isDragging(), "Cannot call drop while not dragging."), Xe(!e.didDrop(), "Cannot call drop twice during one drag operation.");
}
function WZ(e, t, n, r) {
  const i = n.getTarget(e);
  let o = i ? i.drop(r, e) : void 0;
  return ZZ(o), typeof o > "u" && (o = t === 0 ? {} : r.getDropResult()), o;
}
function ZZ(e) {
  Xe(typeof e > "u" || U4(e), "Drop result must either be an object or undefined.");
}
function GZ(e) {
  const t = e.getTargetIds().filter(e.canDropOnTarget, e);
  return t.reverse(), t;
}
function YZ(e) {
  return function() {
    const n = e.getMonitor(), r = e.getRegistry();
    QZ(n);
    const i = n.getSourceId();
    return i != null && (r.getSource(i, !0).endDrag(n, i), r.unpinSource()), {
      type: Zp
    };
  };
}
function QZ(e) {
  Xe(e.isDragging(), "Cannot call endDrag while not dragging.");
}
function Pg(e, t) {
  return t === null ? e === null : Array.isArray(e) ? e.some(
    (n) => n === t
  ) : e === t;
}
function JZ(e) {
  return function(n, { clientOffset: r } = {}) {
    XZ(n);
    const i = n.slice(0), o = e.getMonitor(), a = e.getRegistry(), s = o.getItemType();
    return tG(i, a, s), eG(i, o, a), nG(i, o, a), {
      type: Hp,
      payload: {
        targetIds: i,
        clientOffset: r || null
      }
    };
  };
}
function XZ(e) {
  Xe(Array.isArray(e), "Expected targetIds to be an array.");
}
function eG(e, t, n) {
  Xe(t.isDragging(), "Cannot call hover while not dragging."), Xe(!t.didDrop(), "Cannot call hover after drop.");
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    Xe(e.lastIndexOf(i) === r, "Expected targetIds to be unique in the passed array.");
    const o = n.getTarget(i);
    Xe(o, "Expected targetIds to be registered.");
  }
}
function tG(e, t, n) {
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r], o = t.getTargetType(i);
    Pg(o, n) || e.splice(r, 1);
  }
}
function nG(e, t, n) {
  e.forEach(function(r) {
    n.getTarget(r).hover(t, r);
  });
}
function rG(e) {
  return function() {
    if (e.getMonitor().isDragging())
      return {
        type: o0
      };
  };
}
function iG(e) {
  return {
    beginDrag: FZ(e),
    publishDragSource: rG(e),
    hover: JZ(e),
    drop: qZ(e),
    endDrag: YZ(e)
  };
}
class oG {
  receiveBackend(t) {
    this.backend = t;
  }
  getMonitor() {
    return this.monitor;
  }
  getBackend() {
    return this.backend;
  }
  getRegistry() {
    return this.monitor.registry;
  }
  getActions() {
    const t = this, { dispatch: n } = this.store;
    function r(o) {
      return (...a) => {
        const s = o.apply(t, a);
        typeof s < "u" && n(s);
      };
    }
    const i = iG(this);
    return Object.keys(i).reduce((o, a) => {
      const s = i[a];
      return o[a] = r(s), o;
    }, {});
  }
  dispatch(t) {
    this.store.dispatch(t);
  }
  constructor(t, n) {
    this.isSetUp = !1, this.handleRefCountChange = () => {
      const r = this.store.getState().refCount > 0;
      this.backend && (r && !this.isSetUp ? (this.backend.setup(), this.isSetUp = !0) : !r && this.isSetUp && (this.backend.teardown(), this.isSetUp = !1));
    }, this.store = t, this.monitor = n, t.subscribe(this.handleRefCountChange);
  }
}
function aG(e, t) {
  return {
    x: e.x + t.x,
    y: e.y + t.y
  };
}
function q4(e, t) {
  return {
    x: e.x - t.x,
    y: e.y - t.y
  };
}
function sG(e) {
  const { clientOffset: t, initialClientOffset: n, initialSourceClientOffset: r } = e;
  return !t || !n || !r ? null : q4(aG(t, r), n);
}
function lG(e) {
  const { clientOffset: t, initialClientOffset: n } = e;
  return !t || !n ? null : q4(t, n);
}
const gu = [], a0 = [];
gu.__IS_NONE__ = !0;
a0.__IS_ALL__ = !0;
function uG(e, t) {
  return e === gu ? !1 : e === a0 || typeof t > "u" ? !0 : MZ(t, e).length > 0;
}
class cG {
  subscribeToStateChange(t, n = {}) {
    const { handlerIds: r } = n;
    Xe(typeof t == "function", "listener must be a function."), Xe(typeof r > "u" || Array.isArray(r), "handlerIds, when specified, must be an array of strings.");
    let i = this.store.getState().stateId;
    const o = () => {
      const a = this.store.getState(), s = a.stateId;
      try {
        s === i || s === i + 1 && !uG(a.dirtyHandlerIds, r) || t();
      } finally {
        i = s;
      }
    };
    return this.store.subscribe(o);
  }
  subscribeToOffsetChange(t) {
    Xe(typeof t == "function", "listener must be a function.");
    let n = this.store.getState().dragOffset;
    const r = () => {
      const i = this.store.getState().dragOffset;
      i !== n && (n = i, t());
    };
    return this.store.subscribe(r);
  }
  canDragSource(t) {
    if (!t)
      return !1;
    const n = this.registry.getSource(t);
    return Xe(n, `Expected to find a valid source. sourceId=${t}`), this.isDragging() ? !1 : n.canDrag(this, t);
  }
  canDropOnTarget(t) {
    if (!t)
      return !1;
    const n = this.registry.getTarget(t);
    if (Xe(n, `Expected to find a valid target. targetId=${t}`), !this.isDragging() || this.didDrop())
      return !1;
    const r = this.registry.getTargetType(t), i = this.getItemType();
    return Pg(r, i) && n.canDrop(this, t);
  }
  isDragging() {
    return !!this.getItemType();
  }
  isDraggingSource(t) {
    if (!t)
      return !1;
    const n = this.registry.getSource(t, !0);
    if (Xe(n, `Expected to find a valid source. sourceId=${t}`), !this.isDragging() || !this.isSourcePublic())
      return !1;
    const r = this.registry.getSourceType(t), i = this.getItemType();
    return r !== i ? !1 : n.isDragging(this, t);
  }
  isOverTarget(t, n = {
    shallow: !1
  }) {
    if (!t)
      return !1;
    const { shallow: r } = n;
    if (!this.isDragging())
      return !1;
    const i = this.registry.getTargetType(t), o = this.getItemType();
    if (o && !Pg(i, o))
      return !1;
    const a = this.getTargetIds();
    if (!a.length)
      return !1;
    const s = a.indexOf(t);
    return r ? s === a.length - 1 : s > -1;
  }
  getItemType() {
    return this.store.getState().dragOperation.itemType;
  }
  getItem() {
    return this.store.getState().dragOperation.item;
  }
  getSourceId() {
    return this.store.getState().dragOperation.sourceId;
  }
  getTargetIds() {
    return this.store.getState().dragOperation.targetIds;
  }
  getDropResult() {
    return this.store.getState().dragOperation.dropResult;
  }
  didDrop() {
    return this.store.getState().dragOperation.didDrop;
  }
  isSourcePublic() {
    return !!this.store.getState().dragOperation.isSourcePublic;
  }
  getInitialClientOffset() {
    return this.store.getState().dragOffset.initialClientOffset;
  }
  getInitialSourceClientOffset() {
    return this.store.getState().dragOffset.initialSourceClientOffset;
  }
  getClientOffset() {
    return this.store.getState().dragOffset.clientOffset;
  }
  getSourceClientOffset() {
    return sG(this.store.getState().dragOffset);
  }
  getDifferenceFromInitialOffset() {
    return lG(this.store.getState().dragOffset);
  }
  constructor(t, n) {
    this.store = t, this.registry = n;
  }
}
const RE = typeof global < "u" ? global : self, H4 = RE.MutationObserver || RE.WebKitMutationObserver;
function W4(e) {
  return function() {
    const n = setTimeout(i, 0), r = setInterval(i, 50);
    function i() {
      clearTimeout(n), clearInterval(r), e();
    }
  };
}
function fG(e) {
  let t = 1;
  const n = new H4(e), r = document.createTextNode("");
  return n.observe(r, {
    characterData: !0
  }), function() {
    t = -t, r.data = t;
  };
}
const dG = typeof H4 == "function" ? (
  // reliably everywhere they are implemented.
  // They are implemented in all modern browsers.
  //
  // - Android 4-4.3
  // - Chrome 26-34
  // - Firefox 14-29
  // - Internet Explorer 11
  // - iPad Safari 6-7.1
  // - iPhone Safari 7-7.1
  // - Safari 6-7
  fG
) : (
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
  W4
);
class pG {
  // Use the fastest means possible to execute a task in its own turn, with
  // priority over other events including IO, animation, reflow, and redraw
  // events in browsers.
  //
  // An exception thrown by a task will permanently interrupt the processing of
  // subsequent tasks. The higher level `asap` function ensures that if an
  // exception is thrown by a task, that the task queue will continue flushing as
  // soon as possible, but if you use `rawAsap` directly, you are responsible to
  // either ensure that no exceptions are thrown from your task, or to manually
  // call `rawAsap.requestFlush` if an exception is thrown.
  enqueueTask(t) {
    const { queue: n, requestFlush: r } = this;
    n.length || (r(), this.flushing = !0), n[n.length] = t;
  }
  constructor() {
    this.queue = [], this.pendingErrors = [], this.flushing = !1, this.index = 0, this.capacity = 1024, this.flush = () => {
      const { queue: t } = this;
      for (; this.index < t.length; ) {
        const n = this.index;
        if (this.index++, t[n].call(), this.index > this.capacity) {
          for (let r = 0, i = t.length - this.index; r < i; r++)
            t[r] = t[r + this.index];
          t.length -= this.index, this.index = 0;
        }
      }
      t.length = 0, this.index = 0, this.flushing = !1;
    }, this.registerPendingError = (t) => {
      this.pendingErrors.push(t), this.requestErrorThrow();
    }, this.requestFlush = dG(this.flush), this.requestErrorThrow = W4(() => {
      if (this.pendingErrors.length)
        throw this.pendingErrors.shift();
    });
  }
}
class hG {
  call() {
    try {
      this.task && this.task();
    } catch (t) {
      this.onError(t);
    } finally {
      this.task = null, this.release(this);
    }
  }
  constructor(t, n) {
    this.onError = t, this.release = n, this.task = null;
  }
}
class vG {
  create(t) {
    const n = this.freeTasks, r = n.length ? n.pop() : new hG(
      this.onError,
      (i) => n[n.length] = i
    );
    return r.task = t, r;
  }
  constructor(t) {
    this.onError = t, this.freeTasks = [];
  }
}
const Z4 = new pG(), mG = new vG(Z4.registerPendingError);
function gG(e) {
  Z4.enqueueTask(mG.create(e));
}
const s0 = "dnd-core/ADD_SOURCE", l0 = "dnd-core/ADD_TARGET", u0 = "dnd-core/REMOVE_SOURCE", Gp = "dnd-core/REMOVE_TARGET";
function yG(e) {
  return {
    type: s0,
    payload: {
      sourceId: e
    }
  };
}
function bG(e) {
  return {
    type: l0,
    payload: {
      targetId: e
    }
  };
}
function _G(e) {
  return {
    type: u0,
    payload: {
      sourceId: e
    }
  };
}
function wG(e) {
  return {
    type: Gp,
    payload: {
      targetId: e
    }
  };
}
function xG(e) {
  Xe(typeof e.canDrag == "function", "Expected canDrag to be a function."), Xe(typeof e.beginDrag == "function", "Expected beginDrag to be a function."), Xe(typeof e.endDrag == "function", "Expected endDrag to be a function.");
}
function EG(e) {
  Xe(typeof e.canDrop == "function", "Expected canDrop to be a function."), Xe(typeof e.hover == "function", "Expected hover to be a function."), Xe(typeof e.drop == "function", "Expected beginDrag to be a function.");
}
function kg(e, t) {
  if (t && Array.isArray(e)) {
    e.forEach(
      (n) => kg(n, !1)
    );
    return;
  }
  Xe(typeof e == "string" || typeof e == "symbol", t ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
var Sr;
(function(e) {
  e.SOURCE = "SOURCE", e.TARGET = "TARGET";
})(Sr || (Sr = {}));
let SG = 0;
function OG() {
  return SG++;
}
function $G(e) {
  const t = OG().toString();
  switch (e) {
    case Sr.SOURCE:
      return `S${t}`;
    case Sr.TARGET:
      return `T${t}`;
    default:
      throw new Error(`Unknown Handler Role: ${e}`);
  }
}
function ME(e) {
  switch (e[0]) {
    case "S":
      return Sr.SOURCE;
    case "T":
      return Sr.TARGET;
    default:
      throw new Error(`Cannot parse handler ID: ${e}`);
  }
}
function jE(e, t) {
  const n = e.entries();
  let r = !1;
  do {
    const { done: i, value: [, o] } = n.next();
    if (o === t)
      return !0;
    r = !!i;
  } while (!r);
  return !1;
}
class TG {
  addSource(t, n) {
    kg(t), xG(n);
    const r = this.addHandler(Sr.SOURCE, t, n);
    return this.store.dispatch(yG(r)), r;
  }
  addTarget(t, n) {
    kg(t, !0), EG(n);
    const r = this.addHandler(Sr.TARGET, t, n);
    return this.store.dispatch(bG(r)), r;
  }
  containsHandler(t) {
    return jE(this.dragSources, t) || jE(this.dropTargets, t);
  }
  getSource(t, n = !1) {
    return Xe(this.isSourceId(t), "Expected a valid source ID."), n && t === this.pinnedSourceId ? this.pinnedSource : this.dragSources.get(t);
  }
  getTarget(t) {
    return Xe(this.isTargetId(t), "Expected a valid target ID."), this.dropTargets.get(t);
  }
  getSourceType(t) {
    return Xe(this.isSourceId(t), "Expected a valid source ID."), this.types.get(t);
  }
  getTargetType(t) {
    return Xe(this.isTargetId(t), "Expected a valid target ID."), this.types.get(t);
  }
  isSourceId(t) {
    return ME(t) === Sr.SOURCE;
  }
  isTargetId(t) {
    return ME(t) === Sr.TARGET;
  }
  removeSource(t) {
    Xe(this.getSource(t), "Expected an existing source."), this.store.dispatch(_G(t)), gG(() => {
      this.dragSources.delete(t), this.types.delete(t);
    });
  }
  removeTarget(t) {
    Xe(this.getTarget(t), "Expected an existing target."), this.store.dispatch(wG(t)), this.dropTargets.delete(t), this.types.delete(t);
  }
  pinSource(t) {
    const n = this.getSource(t);
    Xe(n, "Expected an existing source."), this.pinnedSourceId = t, this.pinnedSource = n;
  }
  unpinSource() {
    Xe(this.pinnedSource, "No source is pinned at the time."), this.pinnedSourceId = null, this.pinnedSource = null;
  }
  addHandler(t, n, r) {
    const i = $G(t);
    return this.types.set(i, n), t === Sr.SOURCE ? this.dragSources.set(i, r) : t === Sr.TARGET && this.dropTargets.set(i, r), i;
  }
  constructor(t) {
    this.types = /* @__PURE__ */ new Map(), this.dragSources = /* @__PURE__ */ new Map(), this.dropTargets = /* @__PURE__ */ new Map(), this.pinnedSourceId = null, this.pinnedSource = null, this.store = t;
  }
}
const PG = (e, t) => e === t;
function kG(e, t) {
  return !e && !t ? !0 : !e || !t ? !1 : e.x === t.x && e.y === t.y;
}
function DG(e, t, n = PG) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; ++r)
    if (!n(e[r], t[r]))
      return !1;
  return !0;
}
function AG(e = gu, t) {
  switch (t.type) {
    case Hp:
      break;
    case s0:
    case l0:
    case Gp:
    case u0:
      return gu;
    case qp:
    case o0:
    case Zp:
    case Wp:
    default:
      return a0;
  }
  const { targetIds: n = [], prevTargetIds: r = [] } = t.payload, i = RZ(n, r);
  if (!(i.length > 0 || !DG(n, r)))
    return gu;
  const a = r[r.length - 1], s = n[n.length - 1];
  return a !== s && (a && i.push(a), s && i.push(s)), i;
}
function CG(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function IG(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      CG(e, i, n[i]);
    });
  }
  return e;
}
const FE = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function NG(e = FE, t) {
  const { payload: n } = t;
  switch (t.type) {
    case i0:
    case qp:
      return {
        initialSourceClientOffset: n.sourceClientOffset,
        initialClientOffset: n.clientOffset,
        clientOffset: n.clientOffset
      };
    case Hp:
      return kG(e.clientOffset, n.clientOffset) ? e : IG({}, e, {
        clientOffset: n.clientOffset
      });
    case Zp:
    case Wp:
      return FE;
    default:
      return e;
  }
}
function RG(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Qa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      RG(e, i, n[i]);
    });
  }
  return e;
}
const MG = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: !1,
  isSourcePublic: null
};
function jG(e = MG, t) {
  const { payload: n } = t;
  switch (t.type) {
    case qp:
      return Qa({}, e, {
        itemType: n.itemType,
        item: n.item,
        sourceId: n.sourceId,
        isSourcePublic: n.isSourcePublic,
        dropResult: null,
        didDrop: !1
      });
    case o0:
      return Qa({}, e, {
        isSourcePublic: !0
      });
    case Hp:
      return Qa({}, e, {
        targetIds: n.targetIds
      });
    case Gp:
      return e.targetIds.indexOf(n.targetId) === -1 ? e : Qa({}, e, {
        targetIds: NZ(e.targetIds, n.targetId)
      });
    case Wp:
      return Qa({}, e, {
        dropResult: n.dropResult,
        didDrop: !0,
        targetIds: []
      });
    case Zp:
      return Qa({}, e, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: !1,
        isSourcePublic: null,
        targetIds: []
      });
    default:
      return e;
  }
}
function FG(e = 0, t) {
  switch (t.type) {
    case s0:
    case l0:
      return e + 1;
    case u0:
    case Gp:
      return e - 1;
    default:
      return e;
  }
}
function zG(e = 0) {
  return e + 1;
}
function LG(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function VG(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      LG(e, i, n[i]);
    });
  }
  return e;
}
function KG(e = {}, t) {
  return {
    dirtyHandlerIds: AG(e.dirtyHandlerIds, {
      type: t.type,
      payload: VG({}, t.payload, {
        prevTargetIds: IZ(e, "dragOperation.targetIds", [])
      })
    }),
    dragOffset: NG(e.dragOffset, t),
    refCount: FG(e.refCount, t),
    dragOperation: jG(e.dragOperation, t),
    stateId: zG(e.stateId)
  };
}
function BG(e, t = void 0, n = {}, r = !1) {
  const i = UG(r), o = new cG(i, new TG(i)), a = new oG(i, o), s = e(a, t, n);
  return a.receiveBackend(s), a;
}
function UG(e) {
  const t = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION__;
  return B4(KG, e && t && t({
    name: "dnd-core",
    instanceId: "dnd-core"
  }));
}
function qG(e, t) {
  if (e == null) return {};
  var n = HG(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function HG(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
let zE = 0;
const Vf = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var WG = /* @__PURE__ */ Xf(function(t) {
  var { children: n } = t, r = qG(t, [
    "children"
  ]);
  const [i, o] = ZG(r);
  return Ee(() => {
    if (o) {
      const a = G4();
      return ++zE, () => {
        --zE === 0 && (a[Vf] = null);
      };
    }
  }, []), /* @__PURE__ */ C.jsx(K4.Provider, {
    value: i,
    children: n
  });
});
function ZG(e) {
  if ("manager" in e)
    return [
      {
        dragDropManager: e.manager
      },
      !1
    ];
  const t = GG(e.backend, e.context, e.options, e.debugMode), n = !e.context;
  return [
    t,
    n
  ];
}
function GG(e, t = G4(), n, r) {
  const i = t;
  return i[Vf] || (i[Vf] = {
    dragDropManager: BG(e, t, n, r)
  }), i[Vf];
}
function G4() {
  return typeof global < "u" ? global : window;
}
var _v, LE;
function YG() {
  return LE || (LE = 1, _v = function e(t, n) {
    if (t === n) return !0;
    if (t && n && typeof t == "object" && typeof n == "object") {
      if (t.constructor !== n.constructor) return !1;
      var r, i, o;
      if (Array.isArray(t)) {
        if (r = t.length, r != n.length) return !1;
        for (i = r; i-- !== 0; )
          if (!e(t[i], n[i])) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
      if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
      if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
      if (o = Object.keys(t), r = o.length, r !== Object.keys(n).length) return !1;
      for (i = r; i-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(n, o[i])) return !1;
      for (i = r; i-- !== 0; ) {
        var a = o[i];
        if (!e(t[a], n[a])) return !1;
      }
      return !0;
    }
    return t !== t && n !== n;
  }), _v;
}
var QG = YG();
const JG = /* @__PURE__ */ ip(QG), Ta = typeof window < "u" ? dO : Ee;
function XG(e, t, n) {
  const [r, i] = Ve(
    () => t(e)
  ), o = Le(() => {
    const a = t(e);
    JG(r, a) || (i(a), n && n());
  }, [
    r,
    e,
    n
  ]);
  return Ta(o), [
    r,
    o
  ];
}
function eY(e, t, n) {
  const [r, i] = XG(e, t, n);
  return Ta(function() {
    const a = e.getHandlerId();
    if (a != null)
      return e.subscribeToStateChange(i, {
        handlerIds: [
          a
        ]
      });
  }, [
    e,
    i
  ]), r;
}
function Y4(e, t, n) {
  return eY(
    t,
    e || (() => ({})),
    () => n.reconnect()
  );
}
function Q4(e, t) {
  const n = [];
  return typeof e != "function" && n.push(e), Te(() => typeof e == "function" ? e() : e, n);
}
function tY(e) {
  return Te(
    () => e.hooks.dragSource(),
    [
      e
    ]
  );
}
function nY(e) {
  return Te(
    () => e.hooks.dragPreview(),
    [
      e
    ]
  );
}
let wv = !1, xv = !1;
class rY {
  receiveHandlerId(t) {
    this.sourceId = t;
  }
  getHandlerId() {
    return this.sourceId;
  }
  canDrag() {
    Xe(!wv, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return wv = !0, this.internalMonitor.canDragSource(this.sourceId);
    } finally {
      wv = !1;
    }
  }
  isDragging() {
    if (!this.sourceId)
      return !1;
    Xe(!xv, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return xv = !0, this.internalMonitor.isDraggingSource(this.sourceId);
    } finally {
      xv = !1;
    }
  }
  subscribeToStateChange(t, n) {
    return this.internalMonitor.subscribeToStateChange(t, n);
  }
  isDraggingSource(t) {
    return this.internalMonitor.isDraggingSource(t);
  }
  isOverTarget(t, n) {
    return this.internalMonitor.isOverTarget(t, n);
  }
  getTargetIds() {
    return this.internalMonitor.getTargetIds();
  }
  isSourcePublic() {
    return this.internalMonitor.isSourcePublic();
  }
  getSourceId() {
    return this.internalMonitor.getSourceId();
  }
  subscribeToOffsetChange(t) {
    return this.internalMonitor.subscribeToOffsetChange(t);
  }
  canDragSource(t) {
    return this.internalMonitor.canDragSource(t);
  }
  canDropOnTarget(t) {
    return this.internalMonitor.canDropOnTarget(t);
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(t) {
    this.sourceId = null, this.internalMonitor = t.getMonitor();
  }
}
let Ev = !1;
class iY {
  receiveHandlerId(t) {
    this.targetId = t;
  }
  getHandlerId() {
    return this.targetId;
  }
  subscribeToStateChange(t, n) {
    return this.internalMonitor.subscribeToStateChange(t, n);
  }
  canDrop() {
    if (!this.targetId)
      return !1;
    Xe(!Ev, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
    try {
      return Ev = !0, this.internalMonitor.canDropOnTarget(this.targetId);
    } finally {
      Ev = !1;
    }
  }
  isOver(t) {
    return this.targetId ? this.internalMonitor.isOverTarget(this.targetId, t) : !1;
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(t) {
    this.targetId = null, this.internalMonitor = t.getMonitor();
  }
}
function oY(e, t, n) {
  const r = n.getRegistry(), i = r.addTarget(e, t);
  return [
    i,
    () => r.removeTarget(i)
  ];
}
function aY(e, t, n) {
  const r = n.getRegistry(), i = r.addSource(e, t);
  return [
    i,
    () => r.removeSource(i)
  ];
}
function Dg(e, t, n, r) {
  let i;
  if (i !== void 0)
    return !!i;
  if (e === t)
    return !0;
  if (typeof e != "object" || !e || typeof t != "object" || !t)
    return !1;
  const o = Object.keys(e), a = Object.keys(t);
  if (o.length !== a.length)
    return !1;
  const s = Object.prototype.hasOwnProperty.bind(t);
  for (let l = 0; l < o.length; l++) {
    const u = o[l];
    if (!s(u))
      return !1;
    const c = e[u], f = t[u];
    if (i = void 0, i === !1 || i === void 0 && c !== f)
      return !1;
  }
  return !0;
}
function Ag(e) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    e !== null && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current")
  );
}
function sY(e) {
  if (typeof e.type == "string")
    return;
  const t = e.type.displayName || e.type.name || "the component";
  throw new Error(`Only native element nodes can now be passed to React DnD connectors.You can either wrap ${t} into a <div>, or turn it into a drag source or a drop target itself.`);
}
function lY(e) {
  return (t = null, n = null) => {
    if (!xy(t)) {
      const o = t;
      return e(o, n), o;
    }
    const r = t;
    return sY(r), uY(r, n ? (o) => e(o, n) : e);
  };
}
function J4(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    const r = e[n];
    if (n.endsWith("Ref"))
      t[n] = e[n];
    else {
      const i = lY(r);
      t[n] = () => i;
    }
  }), t;
}
function VE(e, t) {
  typeof e == "function" ? e(t) : e.current = t;
}
function uY(e, t) {
  const n = e.ref;
  return Xe(typeof n != "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs"), n ? Ou(e, {
    ref: (r) => {
      VE(n, r), VE(t, r);
    }
  }) : Ou(e, {
    ref: t
  });
}
class cY {
  receiveHandlerId(t) {
    this.handlerId !== t && (this.handlerId = t, this.reconnect());
  }
  get connectTarget() {
    return this.dragSource;
  }
  get dragSourceOptions() {
    return this.dragSourceOptionsInternal;
  }
  set dragSourceOptions(t) {
    this.dragSourceOptionsInternal = t;
  }
  get dragPreviewOptions() {
    return this.dragPreviewOptionsInternal;
  }
  set dragPreviewOptions(t) {
    this.dragPreviewOptionsInternal = t;
  }
  reconnect() {
    const t = this.reconnectDragSource();
    this.reconnectDragPreview(t);
  }
  reconnectDragSource() {
    const t = this.dragSource, n = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
    return n && this.disconnectDragSource(), this.handlerId ? t ? (n && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragSource = t, this.lastConnectedDragSourceOptions = this.dragSourceOptions, this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, t, this.dragSourceOptions)), n) : (this.lastConnectedDragSource = t, n) : n;
  }
  reconnectDragPreview(t = !1) {
    const n = this.dragPreview, r = t || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
    if (r && this.disconnectDragPreview(), !!this.handlerId) {
      if (!n) {
        this.lastConnectedDragPreview = n;
        return;
      }
      r && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragPreview = n, this.lastConnectedDragPreviewOptions = this.dragPreviewOptions, this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, n, this.dragPreviewOptions));
    }
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didConnectedDragSourceChange() {
    return this.lastConnectedDragSource !== this.dragSource;
  }
  didConnectedDragPreviewChange() {
    return this.lastConnectedDragPreview !== this.dragPreview;
  }
  didDragSourceOptionsChange() {
    return !Dg(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
  }
  didDragPreviewOptionsChange() {
    return !Dg(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
  }
  disconnectDragSource() {
    this.dragSourceUnsubscribe && (this.dragSourceUnsubscribe(), this.dragSourceUnsubscribe = void 0);
  }
  disconnectDragPreview() {
    this.dragPreviewUnsubscribe && (this.dragPreviewUnsubscribe(), this.dragPreviewUnsubscribe = void 0, this.dragPreviewNode = null, this.dragPreviewRef = null);
  }
  get dragSource() {
    return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
  }
  get dragPreview() {
    return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
  }
  clearDragSource() {
    this.dragSourceNode = null, this.dragSourceRef = null;
  }
  clearDragPreview() {
    this.dragPreviewNode = null, this.dragPreviewRef = null;
  }
  constructor(t) {
    this.hooks = J4({
      dragSource: (n, r) => {
        this.clearDragSource(), this.dragSourceOptions = r || null, Ag(n) ? this.dragSourceRef = n : this.dragSourceNode = n, this.reconnectDragSource();
      },
      dragPreview: (n, r) => {
        this.clearDragPreview(), this.dragPreviewOptions = r || null, Ag(n) ? this.dragPreviewRef = n : this.dragPreviewNode = n, this.reconnectDragPreview();
      }
    }), this.handlerId = null, this.dragSourceRef = null, this.dragSourceOptionsInternal = null, this.dragPreviewRef = null, this.dragPreviewOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDragSource = null, this.lastConnectedDragSourceOptions = null, this.lastConnectedDragPreview = null, this.lastConnectedDragPreviewOptions = null, this.backend = t;
  }
}
class fY {
  get connectTarget() {
    return this.dropTarget;
  }
  reconnect() {
    const t = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
    t && this.disconnectDropTarget();
    const n = this.dropTarget;
    if (this.handlerId) {
      if (!n) {
        this.lastConnectedDropTarget = n;
        return;
      }
      t && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDropTarget = n, this.lastConnectedDropTargetOptions = this.dropTargetOptions, this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, n, this.dropTargetOptions));
    }
  }
  receiveHandlerId(t) {
    t !== this.handlerId && (this.handlerId = t, this.reconnect());
  }
  get dropTargetOptions() {
    return this.dropTargetOptionsInternal;
  }
  set dropTargetOptions(t) {
    this.dropTargetOptionsInternal = t;
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didDropTargetChange() {
    return this.lastConnectedDropTarget !== this.dropTarget;
  }
  didOptionsChange() {
    return !Dg(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
  }
  disconnectDropTarget() {
    this.unsubscribeDropTarget && (this.unsubscribeDropTarget(), this.unsubscribeDropTarget = void 0);
  }
  get dropTarget() {
    return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
  }
  clearDropTarget() {
    this.dropTargetRef = null, this.dropTargetNode = null;
  }
  constructor(t) {
    this.hooks = J4({
      dropTarget: (n, r) => {
        this.clearDropTarget(), this.dropTargetOptions = r, Ag(n) ? this.dropTargetRef = n : this.dropTargetNode = n, this.reconnect();
      }
    }), this.handlerId = null, this.dropTargetRef = null, this.dropTargetOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDropTarget = null, this.lastConnectedDropTargetOptions = null, this.backend = t;
  }
}
function hl() {
  const { dragDropManager: e } = Me(K4);
  return Xe(e != null, "Expected drag drop context"), e;
}
function dY(e, t) {
  const n = hl(), r = Te(
    () => new cY(n.getBackend()),
    [
      n
    ]
  );
  return Ta(() => (r.dragSourceOptions = e || null, r.reconnect(), () => r.disconnectDragSource()), [
    r,
    e
  ]), Ta(() => (r.dragPreviewOptions = t || null, r.reconnect(), () => r.disconnectDragPreview()), [
    r,
    t
  ]), r;
}
function pY() {
  const e = hl();
  return Te(
    () => new rY(e),
    [
      e
    ]
  );
}
class hY {
  beginDrag() {
    const t = this.spec, n = this.monitor;
    let r = null;
    return typeof t.item == "object" ? r = t.item : typeof t.item == "function" ? r = t.item(n) : r = {}, r ?? null;
  }
  canDrag() {
    const t = this.spec, n = this.monitor;
    return typeof t.canDrag == "boolean" ? t.canDrag : typeof t.canDrag == "function" ? t.canDrag(n) : !0;
  }
  isDragging(t, n) {
    const r = this.spec, i = this.monitor, { isDragging: o } = r;
    return o ? o(i) : n === t.getSourceId();
  }
  endDrag() {
    const t = this.spec, n = this.monitor, r = this.connector, { end: i } = t;
    i && i(n.getItem(), n), r.reconnect();
  }
  constructor(t, n, r) {
    this.spec = t, this.monitor = n, this.connector = r;
  }
}
function vY(e, t, n) {
  const r = Te(
    () => new hY(e, t, n),
    [
      t,
      n
    ]
  );
  return Ee(() => {
    r.spec = e;
  }, [
    e
  ]), r;
}
function mY(e) {
  return Te(() => {
    const t = e.type;
    return Xe(t != null, "spec.type must be defined"), t;
  }, [
    e
  ]);
}
function gY(e, t, n) {
  const r = hl(), i = vY(e, t, n), o = mY(e);
  Ta(function() {
    if (o != null) {
      const [s, l] = aY(o, i, r);
      return t.receiveHandlerId(s), n.receiveHandlerId(s), l;
    }
  }, [
    r,
    t,
    n,
    i,
    o
  ]);
}
function X4(e, t) {
  const n = Q4(e);
  Xe(!n.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
  const r = pY(), i = dY(n.options, n.previewOptions);
  return gY(n, r, i), [
    Y4(n.collect, r, i),
    tY(i),
    nY(i)
  ];
}
function yY(e) {
  return Te(
    () => e.hooks.dropTarget(),
    [
      e
    ]
  );
}
function bY(e) {
  const t = hl(), n = Te(
    () => new fY(t.getBackend()),
    [
      t
    ]
  );
  return Ta(() => (n.dropTargetOptions = e || null, n.reconnect(), () => n.disconnectDropTarget()), [
    e
  ]), n;
}
function _Y() {
  const e = hl();
  return Te(
    () => new iY(e),
    [
      e
    ]
  );
}
function wY(e) {
  const { accept: t } = e;
  return Te(() => (Xe(e.accept != null, "accept must be defined"), Array.isArray(t) ? t : [
    t
  ]), [
    t
  ]);
}
class xY {
  canDrop() {
    const t = this.spec, n = this.monitor;
    return t.canDrop ? t.canDrop(n.getItem(), n) : !0;
  }
  hover() {
    const t = this.spec, n = this.monitor;
    t.hover && t.hover(n.getItem(), n);
  }
  drop() {
    const t = this.spec, n = this.monitor;
    if (t.drop)
      return t.drop(n.getItem(), n);
  }
  constructor(t, n) {
    this.spec = t, this.monitor = n;
  }
}
function EY(e, t) {
  const n = Te(
    () => new xY(e, t),
    [
      t
    ]
  );
  return Ee(() => {
    n.spec = e;
  }, [
    e
  ]), n;
}
function SY(e, t, n) {
  const r = hl(), i = EY(e, t), o = wY(e);
  Ta(function() {
    const [s, l] = oY(o, i, r);
    return t.receiveHandlerId(s), n.receiveHandlerId(s), l;
  }, [
    r,
    t,
    i,
    n,
    o.map(
      (a) => a.toString()
    ).join("|")
  ]);
}
function OY(e, t) {
  const n = Q4(e), r = _Y(), i = bY(n.options);
  return SY(n, r, i), [
    Y4(n.collect, r, i),
    yY(i)
  ];
}
function eA(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
function $Y(e, t) {
  return e.filter(
    (n) => n !== t
  );
}
function TY(e, t) {
  const n = /* @__PURE__ */ new Set(), r = (o) => n.add(o);
  e.forEach(r), t.forEach(r);
  const i = [];
  return n.forEach(
    (o) => i.push(o)
  ), i;
}
class PY {
  enter(t) {
    const n = this.entered.length, r = (i) => this.isNodeInDocument(i) && (!i.contains || i.contains(t));
    return this.entered = TY(this.entered.filter(r), [
      t
    ]), n === 0 && this.entered.length > 0;
  }
  leave(t) {
    const n = this.entered.length;
    return this.entered = $Y(this.entered.filter(this.isNodeInDocument), t), n > 0 && this.entered.length === 0;
  }
  reset() {
    this.entered = [];
  }
  constructor(t) {
    this.entered = [], this.isNodeInDocument = t;
  }
}
class kY {
  initializeExposedProperties() {
    Object.keys(this.config.exposeProperties).forEach((t) => {
      Object.defineProperty(this.item, t, {
        configurable: !0,
        enumerable: !0,
        get() {
          return console.warn(`Browser doesn't allow reading "${t}" until the drop event.`), null;
        }
      });
    });
  }
  loadDataTransfer(t) {
    if (t) {
      const n = {};
      Object.keys(this.config.exposeProperties).forEach((r) => {
        const i = this.config.exposeProperties[r];
        i != null && (n[r] = {
          value: i(t, this.config.matchesTypes),
          configurable: !0,
          enumerable: !0
        });
      }), Object.defineProperties(this.item, n);
    }
  }
  canDrag() {
    return !0;
  }
  beginDrag() {
    return this.item;
  }
  isDragging(t, n) {
    return n === t.getSourceId();
  }
  endDrag() {
  }
  constructor(t) {
    this.config = t, this.item = {}, this.initializeExposedProperties();
  }
}
const tA = "__NATIVE_FILE__", nA = "__NATIVE_URL__", rA = "__NATIVE_TEXT__", iA = "__NATIVE_HTML__", KE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FILE: tA,
  HTML: iA,
  TEXT: rA,
  URL: nA
}, Symbol.toStringTag, { value: "Module" }));
function Sv(e, t, n) {
  const r = t.reduce(
    (i, o) => i || e.getData(o),
    ""
  );
  return r ?? n;
}
const Cg = {
  [tA]: {
    exposeProperties: {
      files: (e) => Array.prototype.slice.call(e.files),
      items: (e) => e.items,
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Files"
    ]
  },
  [iA]: {
    exposeProperties: {
      html: (e, t) => Sv(e, t, ""),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Html",
      "text/html"
    ]
  },
  [nA]: {
    exposeProperties: {
      urls: (e, t) => Sv(e, t, "").split(`
`),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Url",
      "text/uri-list"
    ]
  },
  [rA]: {
    exposeProperties: {
      text: (e, t) => Sv(e, t, ""),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Text",
      "text/plain"
    ]
  }
};
function DY(e, t) {
  const n = Cg[e];
  if (!n)
    throw new Error(`native type ${e} has no configuration`);
  const r = new kY(n);
  return r.loadDataTransfer(t), r;
}
function Ov(e) {
  if (!e)
    return null;
  const t = Array.prototype.slice.call(e.types || []);
  return Object.keys(Cg).filter((n) => {
    const r = Cg[n];
    return r?.matchesTypes ? r.matchesTypes.some(
      (i) => t.indexOf(i) > -1
    ) : !1;
  })[0] || null;
}
const AY = eA(
  () => /firefox/i.test(navigator.userAgent)
), oA = eA(
  () => !!window.safari
);
class BE {
  interpolate(t) {
    const { xs: n, ys: r, c1s: i, c2s: o, c3s: a } = this;
    let s = n.length - 1;
    if (t === n[s])
      return r[s];
    let l = 0, u = a.length - 1, c;
    for (; l <= u; ) {
      c = Math.floor(0.5 * (l + u));
      const p = n[c];
      if (p < t)
        l = c + 1;
      else if (p > t)
        u = c - 1;
      else
        return r[c];
    }
    s = Math.max(0, u);
    const f = t - n[s], d = f * f;
    return r[s] + i[s] * f + o[s] * d + a[s] * f * d;
  }
  constructor(t, n) {
    const { length: r } = t, i = [];
    for (let p = 0; p < r; p++)
      i.push(p);
    i.sort(
      (p, h) => t[p] < t[h] ? -1 : 1
    );
    const o = [], a = [];
    let s, l;
    for (let p = 0; p < r - 1; p++)
      s = t[p + 1] - t[p], l = n[p + 1] - n[p], o.push(s), a.push(l / s);
    const u = [
      a[0]
    ];
    for (let p = 0; p < o.length - 1; p++) {
      const h = a[p], v = a[p + 1];
      if (h * v <= 0)
        u.push(0);
      else {
        s = o[p];
        const m = o[p + 1], g = s + m;
        u.push(3 * g / ((g + m) / h + (g + s) / v));
      }
    }
    u.push(a[a.length - 1]);
    const c = [], f = [];
    let d;
    for (let p = 0; p < u.length - 1; p++) {
      d = a[p];
      const h = u[p], v = 1 / o[p], m = h + u[p + 1] - d - d;
      c.push((d - h - m) * v), f.push(m * v * v);
    }
    this.xs = t, this.ys = n, this.c1s = u, this.c2s = c, this.c3s = f;
  }
}
const CY = 1;
function aA(e) {
  const t = e.nodeType === CY ? e : e.parentElement;
  if (!t)
    return null;
  const { top: n, left: r } = t.getBoundingClientRect();
  return {
    x: r,
    y: n
  };
}
function df(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function IY(e) {
  var t;
  return e.nodeName === "IMG" && (AY() || !(!((t = document.documentElement) === null || t === void 0) && t.contains(e)));
}
function NY(e, t, n, r) {
  let i = e ? t.width : n, o = e ? t.height : r;
  return oA() && e && (o /= window.devicePixelRatio, i /= window.devicePixelRatio), {
    dragPreviewWidth: i,
    dragPreviewHeight: o
  };
}
function RY(e, t, n, r, i) {
  const o = IY(t), s = aA(o ? e : t), l = {
    x: n.x - s.x,
    y: n.y - s.y
  }, { offsetWidth: u, offsetHeight: c } = e, { anchorX: f, anchorY: d } = r, { dragPreviewWidth: p, dragPreviewHeight: h } = NY(o, t, u, c), v = () => {
    let $ = new BE([
      0,
      0.5,
      1
    ], [
      // Dock to the top
      l.y,
      // Align at the center
      l.y / c * h,
      // Dock to the bottom
      l.y + h - c
    ]).interpolate(d);
    return oA() && o && ($ += (window.devicePixelRatio - 1) * h), $;
  }, m = () => new BE([
    0,
    0.5,
    1
  ], [
    // Dock to the left
    l.x,
    // Align at the center
    l.x / u * p,
    // Dock to the right
    l.x + p - u
  ]).interpolate(f), { offsetX: g, offsetY: _ } = i, w = g === 0 || g, x = _ === 0 || _;
  return {
    x: w ? g : m(),
    y: x ? _ : v()
  };
}
class MY {
  get window() {
    if (this.globalContext)
      return this.globalContext;
    if (typeof window < "u")
      return window;
  }
  get document() {
    var t;
    return !((t = this.globalContext) === null || t === void 0) && t.document ? this.globalContext.document : this.window ? this.window.document : void 0;
  }
  get rootElement() {
    var t;
    return ((t = this.optionsArgs) === null || t === void 0 ? void 0 : t.rootElement) || this.window;
  }
  constructor(t, n) {
    this.ownerDocument = null, this.globalContext = t, this.optionsArgs = n;
  }
}
function jY(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function UE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      jY(e, i, n[i]);
    });
  }
  return e;
}
class FY {
  /**
  * Generate profiling statistics for the HTML5Backend.
  */
  profile() {
    var t, n;
    return {
      sourcePreviewNodes: this.sourcePreviewNodes.size,
      sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
      sourceNodeOptions: this.sourceNodeOptions.size,
      sourceNodes: this.sourceNodes.size,
      dragStartSourceIds: ((t = this.dragStartSourceIds) === null || t === void 0 ? void 0 : t.length) || 0,
      dropTargetIds: this.dropTargetIds.length,
      dragEnterTargetIds: this.dragEnterTargetIds.length,
      dragOverTargetIds: ((n = this.dragOverTargetIds) === null || n === void 0 ? void 0 : n.length) || 0
    };
  }
  // public for test
  get window() {
    return this.options.window;
  }
  get document() {
    return this.options.document;
  }
  /**
  * Get the root element to use for event subscriptions
  */
  get rootElement() {
    return this.options.rootElement;
  }
  setup() {
    const t = this.rootElement;
    if (t !== void 0) {
      if (t.__isReactDndBackendSetUp)
        throw new Error("Cannot have two HTML5 backends at the same time.");
      t.__isReactDndBackendSetUp = !0, this.addEventListeners(t);
    }
  }
  teardown() {
    const t = this.rootElement;
    if (t !== void 0 && (t.__isReactDndBackendSetUp = !1, this.removeEventListeners(this.rootElement), this.clearCurrentDragSourceNode(), this.asyncEndDragFrameId)) {
      var n;
      (n = this.window) === null || n === void 0 || n.cancelAnimationFrame(this.asyncEndDragFrameId);
    }
  }
  connectDragPreview(t, n, r) {
    return this.sourcePreviewNodeOptions.set(t, r), this.sourcePreviewNodes.set(t, n), () => {
      this.sourcePreviewNodes.delete(t), this.sourcePreviewNodeOptions.delete(t);
    };
  }
  connectDragSource(t, n, r) {
    this.sourceNodes.set(t, n), this.sourceNodeOptions.set(t, r);
    const i = (a) => this.handleDragStart(a, t), o = (a) => this.handleSelectStart(a);
    return n.setAttribute("draggable", "true"), n.addEventListener("dragstart", i), n.addEventListener("selectstart", o), () => {
      this.sourceNodes.delete(t), this.sourceNodeOptions.delete(t), n.removeEventListener("dragstart", i), n.removeEventListener("selectstart", o), n.setAttribute("draggable", "false");
    };
  }
  connectDropTarget(t, n) {
    const r = (a) => this.handleDragEnter(a, t), i = (a) => this.handleDragOver(a, t), o = (a) => this.handleDrop(a, t);
    return n.addEventListener("dragenter", r), n.addEventListener("dragover", i), n.addEventListener("drop", o), () => {
      n.removeEventListener("dragenter", r), n.removeEventListener("dragover", i), n.removeEventListener("drop", o);
    };
  }
  addEventListeners(t) {
    t.addEventListener && (t.addEventListener("dragstart", this.handleTopDragStart), t.addEventListener("dragstart", this.handleTopDragStartCapture, !0), t.addEventListener("dragend", this.handleTopDragEndCapture, !0), t.addEventListener("dragenter", this.handleTopDragEnter), t.addEventListener("dragenter", this.handleTopDragEnterCapture, !0), t.addEventListener("dragleave", this.handleTopDragLeaveCapture, !0), t.addEventListener("dragover", this.handleTopDragOver), t.addEventListener("dragover", this.handleTopDragOverCapture, !0), t.addEventListener("drop", this.handleTopDrop), t.addEventListener("drop", this.handleTopDropCapture, !0));
  }
  removeEventListeners(t) {
    t.removeEventListener && (t.removeEventListener("dragstart", this.handleTopDragStart), t.removeEventListener("dragstart", this.handleTopDragStartCapture, !0), t.removeEventListener("dragend", this.handleTopDragEndCapture, !0), t.removeEventListener("dragenter", this.handleTopDragEnter), t.removeEventListener("dragenter", this.handleTopDragEnterCapture, !0), t.removeEventListener("dragleave", this.handleTopDragLeaveCapture, !0), t.removeEventListener("dragover", this.handleTopDragOver), t.removeEventListener("dragover", this.handleTopDragOverCapture, !0), t.removeEventListener("drop", this.handleTopDrop), t.removeEventListener("drop", this.handleTopDropCapture, !0));
  }
  getCurrentSourceNodeOptions() {
    const t = this.monitor.getSourceId(), n = this.sourceNodeOptions.get(t);
    return UE({
      dropEffect: this.altKeyPressed ? "copy" : "move"
    }, n || {});
  }
  getCurrentDropEffect() {
    return this.isDraggingNativeItem() ? "copy" : this.getCurrentSourceNodeOptions().dropEffect;
  }
  getCurrentSourcePreviewNodeOptions() {
    const t = this.monitor.getSourceId(), n = this.sourcePreviewNodeOptions.get(t);
    return UE({
      anchorX: 0.5,
      anchorY: 0.5,
      captureDraggingState: !1
    }, n || {});
  }
  isDraggingNativeItem() {
    const t = this.monitor.getItemType();
    return Object.keys(KE).some(
      (n) => KE[n] === t
    );
  }
  beginDragNativeItem(t, n) {
    this.clearCurrentDragSourceNode(), this.currentNativeSource = DY(t, n), this.currentNativeHandle = this.registry.addSource(t, this.currentNativeSource), this.actions.beginDrag([
      this.currentNativeHandle
    ]);
  }
  setCurrentDragSourceNode(t) {
    this.clearCurrentDragSourceNode(), this.currentDragSourceNode = t;
    const n = 1e3;
    this.mouseMoveTimeoutTimer = setTimeout(() => {
      var r;
      return (r = this.rootElement) === null || r === void 0 ? void 0 : r.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
    }, n);
  }
  clearCurrentDragSourceNode() {
    if (this.currentDragSourceNode) {
      if (this.currentDragSourceNode = null, this.rootElement) {
        var t;
        (t = this.window) === null || t === void 0 || t.clearTimeout(this.mouseMoveTimeoutTimer || void 0), this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
      }
      return this.mouseMoveTimeoutTimer = null, !0;
    }
    return !1;
  }
  handleDragStart(t, n) {
    t.defaultPrevented || (this.dragStartSourceIds || (this.dragStartSourceIds = []), this.dragStartSourceIds.unshift(n));
  }
  handleDragEnter(t, n) {
    this.dragEnterTargetIds.unshift(n);
  }
  handleDragOver(t, n) {
    this.dragOverTargetIds === null && (this.dragOverTargetIds = []), this.dragOverTargetIds.unshift(n);
  }
  handleDrop(t, n) {
    this.dropTargetIds.unshift(n);
  }
  constructor(t, n, r) {
    this.sourcePreviewNodes = /* @__PURE__ */ new Map(), this.sourcePreviewNodeOptions = /* @__PURE__ */ new Map(), this.sourceNodes = /* @__PURE__ */ new Map(), this.sourceNodeOptions = /* @__PURE__ */ new Map(), this.dragStartSourceIds = null, this.dropTargetIds = [], this.dragEnterTargetIds = [], this.currentNativeSource = null, this.currentNativeHandle = null, this.currentDragSourceNode = null, this.altKeyPressed = !1, this.mouseMoveTimeoutTimer = null, this.asyncEndDragFrameId = null, this.dragOverTargetIds = null, this.lastClientOffset = null, this.hoverRafId = null, this.getSourceClientOffset = (i) => {
      const o = this.sourceNodes.get(i);
      return o && aA(o) || null;
    }, this.endDragNativeItem = () => {
      this.isDraggingNativeItem() && (this.actions.endDrag(), this.currentNativeHandle && this.registry.removeSource(this.currentNativeHandle), this.currentNativeHandle = null, this.currentNativeSource = null);
    }, this.isNodeInDocument = (i) => !!(i && this.document && this.document.body && this.document.body.contains(i)), this.endDragIfSourceWasRemovedFromDOM = () => {
      const i = this.currentDragSourceNode;
      i == null || this.isNodeInDocument(i) || (this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover());
    }, this.scheduleHover = (i) => {
      this.hoverRafId === null && typeof requestAnimationFrame < "u" && (this.hoverRafId = requestAnimationFrame(() => {
        this.monitor.isDragging() && this.actions.hover(i || [], {
          clientOffset: this.lastClientOffset
        }), this.hoverRafId = null;
      }));
    }, this.cancelHover = () => {
      this.hoverRafId !== null && typeof cancelAnimationFrame < "u" && (cancelAnimationFrame(this.hoverRafId), this.hoverRafId = null);
    }, this.handleTopDragStartCapture = () => {
      this.clearCurrentDragSourceNode(), this.dragStartSourceIds = [];
    }, this.handleTopDragStart = (i) => {
      if (i.defaultPrevented)
        return;
      const { dragStartSourceIds: o } = this;
      this.dragStartSourceIds = null;
      const a = df(i);
      this.monitor.isDragging() && (this.actions.endDrag(), this.cancelHover()), this.actions.beginDrag(o || [], {
        publishSource: !1,
        getSourceClientOffset: this.getSourceClientOffset,
        clientOffset: a
      });
      const { dataTransfer: s } = i, l = Ov(s);
      if (this.monitor.isDragging()) {
        if (s && typeof s.setDragImage == "function") {
          const c = this.monitor.getSourceId(), f = this.sourceNodes.get(c), d = this.sourcePreviewNodes.get(c) || f;
          if (d) {
            const { anchorX: p, anchorY: h, offsetX: v, offsetY: m } = this.getCurrentSourcePreviewNodeOptions(), w = RY(f, d, a, {
              anchorX: p,
              anchorY: h
            }, {
              offsetX: v,
              offsetY: m
            });
            s.setDragImage(d, w.x, w.y);
          }
        }
        try {
          s?.setData("application/json", {});
        } catch {
        }
        this.setCurrentDragSourceNode(i.target);
        const { captureDraggingState: u } = this.getCurrentSourcePreviewNodeOptions();
        u ? this.actions.publishDragSource() : setTimeout(
          () => this.actions.publishDragSource(),
          0
        );
      } else if (l)
        this.beginDragNativeItem(l);
      else {
        if (s && !s.types && (i.target && !i.target.hasAttribute || !i.target.hasAttribute("draggable")))
          return;
        i.preventDefault();
      }
    }, this.handleTopDragEndCapture = () => {
      this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleTopDragEnterCapture = (i) => {
      if (this.dragEnterTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      }
      if (!this.enterLeaveCounter.enter(i.target) || this.monitor.isDragging())
        return;
      const { dataTransfer: s } = i, l = Ov(s);
      l && this.beginDragNativeItem(l, s);
    }, this.handleTopDragEnter = (i) => {
      const { dragEnterTargetIds: o } = this;
      if (this.dragEnterTargetIds = [], !this.monitor.isDragging())
        return;
      this.altKeyPressed = i.altKey, o.length > 0 && this.actions.hover(o, {
        clientOffset: df(i)
      }), o.some(
        (s) => this.monitor.canDropOnTarget(s)
      ) && (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = this.getCurrentDropEffect()));
    }, this.handleTopDragOverCapture = (i) => {
      if (this.dragOverTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      }
    }, this.handleTopDragOver = (i) => {
      const { dragOverTargetIds: o } = this;
      if (this.dragOverTargetIds = [], !this.monitor.isDragging()) {
        i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = "none");
        return;
      }
      this.altKeyPressed = i.altKey, this.lastClientOffset = df(i), this.scheduleHover(o), (o || []).some(
        (s) => this.monitor.canDropOnTarget(s)
      ) ? (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = this.getCurrentDropEffect())) : this.isDraggingNativeItem() ? i.preventDefault() : (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = "none"));
    }, this.handleTopDragLeaveCapture = (i) => {
      this.isDraggingNativeItem() && i.preventDefault(), this.enterLeaveCounter.leave(i.target) && (this.isDraggingNativeItem() && setTimeout(
        () => this.endDragNativeItem(),
        0
      ), this.cancelHover());
    }, this.handleTopDropCapture = (i) => {
      if (this.dropTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        i.preventDefault(), (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      } else Ov(i.dataTransfer) && i.preventDefault();
      this.enterLeaveCounter.reset();
    }, this.handleTopDrop = (i) => {
      const { dropTargetIds: o } = this;
      this.dropTargetIds = [], this.actions.hover(o, {
        clientOffset: df(i)
      }), this.actions.drop({
        dropEffect: this.getCurrentDropEffect()
      }), this.isDraggingNativeItem() ? this.endDragNativeItem() : this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleSelectStart = (i) => {
      const o = i.target;
      typeof o.dragDrop == "function" && (o.tagName === "INPUT" || o.tagName === "SELECT" || o.tagName === "TEXTAREA" || o.isContentEditable || (i.preventDefault(), o.dragDrop()));
    }, this.options = new MY(n, r), this.actions = t.getActions(), this.monitor = t.getMonitor(), this.registry = t.getRegistry(), this.enterLeaveCounter = new PY(this.isNodeInDocument);
  }
}
const zY = function(t, n, r) {
  return new FY(t, n, r);
}, LY = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function Ks(e, t, n) {
  const r = VY(e), { webkitRelativePath: i } = e, o = typeof t == "string" ? t : typeof i == "string" && i.length > 0 ? i : `./${e.name}`;
  return typeof r.path != "string" && qE(r, "path", o), qE(r, "relativePath", o), r;
}
function VY(e) {
  const { name: t } = e;
  if (t && t.lastIndexOf(".") !== -1 && !e.type) {
    const r = t.split(".").pop().toLowerCase(), i = LY.get(r);
    i && Object.defineProperty(e, "type", {
      value: i,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
function qE(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !1,
    configurable: !1,
    enumerable: !0
  });
}
const KY = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function BY(e) {
  return Ia(this, void 0, void 0, function* () {
    return Ld(e) && UY(e.dataTransfer) ? ZY(e.dataTransfer, e.type) : qY(e) ? HY(e) : Array.isArray(e) && e.every((t) => "getFile" in t && typeof t.getFile == "function") ? WY(e) : [];
  });
}
function UY(e) {
  return Ld(e);
}
function qY(e) {
  return Ld(e) && Ld(e.target);
}
function Ld(e) {
  return typeof e == "object" && e !== null;
}
function HY(e) {
  return Ig(e.target.files).map((t) => Ks(t));
}
function WY(e) {
  return Ia(this, void 0, void 0, function* () {
    return (yield Promise.all(e.map((n) => n.getFile()))).map((n) => Ks(n));
  });
}
function ZY(e, t) {
  return Ia(this, void 0, void 0, function* () {
    if (e.items) {
      const n = Ig(e.items).filter((i) => i.kind === "file");
      if (t !== "drop")
        return n;
      const r = yield Promise.all(n.map(GY));
      return HE(sA(r));
    }
    return HE(Ig(e.files).map((n) => Ks(n)));
  });
}
function HE(e) {
  return e.filter((t) => KY.indexOf(t.name) === -1);
}
function Ig(e) {
  if (e === null)
    return [];
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    t.push(r);
  }
  return t;
}
function GY(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return WE(e);
  const t = e.webkitGetAsEntry();
  return t && t.isDirectory ? lA(t) : WE(e, t);
}
function sA(e) {
  return e.reduce((t, n) => [
    ...t,
    ...Array.isArray(n) ? sA(n) : [n]
  ], []);
}
function WE(e, t) {
  return Ia(this, void 0, void 0, function* () {
    var n;
    if (globalThis.isSecureContext && typeof e.getAsFileSystemHandle == "function") {
      const o = yield e.getAsFileSystemHandle();
      if (o === null)
        throw new Error(`${e} is not a File`);
      if (o !== void 0) {
        const a = yield o.getFile();
        return a.handle = o, Ks(a);
      }
    }
    const r = e.getAsFile();
    if (!r)
      throw new Error(`${e} is not a File`);
    return Ks(r, (n = t?.fullPath) !== null && n !== void 0 ? n : void 0);
  });
}
function YY(e) {
  return Ia(this, void 0, void 0, function* () {
    return e.isDirectory ? lA(e) : QY(e);
  });
}
function lA(e) {
  const t = e.createReader();
  return new Promise((n, r) => {
    const i = [];
    function o() {
      t.readEntries((a) => Ia(this, void 0, void 0, function* () {
        if (a.length) {
          const s = Promise.all(a.map(YY));
          i.push(s), o();
        } else
          try {
            const s = yield Promise.all(i);
            n(s);
          } catch (s) {
            r(s);
          }
      }), (a) => {
        r(a);
      });
    }
    o();
  });
}
function QY(e) {
  return Ia(this, void 0, void 0, function* () {
    return new Promise((t, n) => {
      e.file((r) => {
        const i = Ks(r, e.fullPath);
        t(i);
      }, (r) => {
        n(r);
      });
    });
  });
}
var pf = {}, ZE;
function JY() {
  return ZE || (ZE = 1, pf.__esModule = !0, pf.default = function(e, t) {
    if (e && t) {
      var n = Array.isArray(t) ? t : t.split(",");
      if (n.length === 0)
        return !0;
      var r = e.name || "", i = (e.type || "").toLowerCase(), o = i.replace(/\/.*$/, "");
      return n.some(function(a) {
        var s = a.trim().toLowerCase();
        return s.charAt(0) === "." ? r.toLowerCase().endsWith(s) : s.endsWith("/*") ? o === s.replace(/\/.*$/, "") : i === s;
      });
    }
    return !0;
  }), pf;
}
var XY = JY();
const $v = /* @__PURE__ */ ip(XY);
function GE(e) {
  return nQ(e) || tQ(e) || cA(e) || eQ();
}
function eQ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tQ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function nQ(e) {
  if (Array.isArray(e)) return Ng(e);
}
function YE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function QE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? YE(Object(n), !0).forEach(function(r) {
      uA(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : YE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function uA(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Wu(e, t) {
  return oQ(e) || iQ(e, t) || cA(e, t) || rQ();
}
function rQ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cA(e, t) {
  if (e) {
    if (typeof e == "string") return Ng(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Ng(e, t);
  }
}
function Ng(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function iQ(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, o = !1, a, s;
    try {
      for (n = n.call(e); !(i = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); i = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
    return r;
  }
}
function oQ(e) {
  if (Array.isArray(e)) return e;
}
var aQ = typeof $v == "function" ? $v : $v.default, sQ = "file-invalid-type", lQ = "file-too-large", uQ = "file-too-small", cQ = "too-many-files", fQ = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = t.split(","), r = n.length > 1 ? "one of ".concat(n.join(", ")) : n[0];
  return {
    code: sQ,
    message: "File type must be ".concat(r)
  };
}, JE = function(t) {
  return {
    code: lQ,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, XE = function(t) {
  return {
    code: uQ,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, dQ = {
  code: cQ,
  message: "Too many files"
};
function pQ(e) {
  return e.type === "" && typeof e.getAsFile == "function";
}
function fA(e, t) {
  var n = e.type === "application/x-moz-file" || aQ(e, t) || pQ(e);
  return [n, n ? null : fQ(t)];
}
function dA(e, t, n) {
  if (ta(e.size))
    if (ta(t) && ta(n)) {
      if (e.size > n) return [!1, JE(n)];
      if (e.size < t) return [!1, XE(t)];
    } else {
      if (ta(t) && e.size < t) return [!1, XE(t)];
      if (ta(n) && e.size > n) return [!1, JE(n)];
    }
  return [!0, null];
}
function ta(e) {
  return e != null;
}
function hQ(e) {
  var t = e.files, n = e.accept, r = e.minSize, i = e.maxSize, o = e.multiple, a = e.maxFiles, s = e.validator;
  return !o && t.length > 1 || o && a >= 1 && t.length > a ? !1 : t.every(function(l) {
    var u = fA(l, n), c = Wu(u, 1), f = c[0], d = dA(l, r, i), p = Wu(d, 1), h = p[0], v = s ? s(l) : null;
    return f && h && !v;
  });
}
function Vd(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function Ll(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function eS(e) {
  e.preventDefault();
}
function vQ(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function mQ(e) {
  return e.indexOf("Edge/") !== -1;
}
function gQ() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return vQ(e) || mQ(e);
}
function gi() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)
      o[a - 1] = arguments[a];
    return t.some(function(s) {
      return !Vd(r) && s && s.apply(void 0, [r].concat(o)), Vd(r);
    });
  };
}
function yQ() {
  return "showOpenFilePicker" in window;
}
function bQ(e) {
  if (ta(e)) {
    var t = Object.entries(e).filter(function(n) {
      var r = Wu(n, 2), i = r[0], o = r[1], a = !0;
      return pA(i) || (console.warn('Skipped "'.concat(i, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), a = !1), (!Array.isArray(o) || !o.every(hA)) && (console.warn('Skipped "'.concat(i, '" because an invalid file extension was provided.')), a = !1), a;
    }).reduce(function(n, r) {
      var i = Wu(r, 2), o = i[0], a = i[1];
      return QE(QE({}, n), {}, uA({}, o, a));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function _Q(e) {
  if (ta(e))
    return Object.entries(e).reduce(function(t, n) {
      var r = Wu(n, 2), i = r[0], o = r[1];
      return [].concat(GE(t), [i], GE(o));
    }, []).filter(function(t) {
      return pA(t) || hA(t);
    }).join(",");
}
function wQ(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function xQ(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function pA(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || e === "application/*" || /\w+\/[-+.\w]+/g.test(e);
}
function hA(e) {
  return /^.*\.[\w]+$/.test(e);
}
var EQ = ["children"], SQ = ["open"], OQ = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], $Q = ["refKey", "onChange", "onClick"];
function tS(e) {
  return kQ(e) || PQ(e) || vA(e) || TQ();
}
function TQ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function PQ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function kQ(e) {
  if (Array.isArray(e)) return Rg(e);
}
function Tv(e, t) {
  return CQ(e) || AQ(e, t) || vA(e, t) || DQ();
}
function DQ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vA(e, t) {
  if (e) {
    if (typeof e == "string") return Rg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Rg(e, t);
  }
}
function Rg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function AQ(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, o = !1, a, s;
    try {
      for (n = n.call(e); !(i = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); i = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
    return r;
  }
}
function CQ(e) {
  if (Array.isArray(e)) return e;
}
function nS(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ct(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nS(Object(n), !0).forEach(function(r) {
      Mg(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nS(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Mg(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Kd(e, t) {
  if (e == null) return {};
  var n = IQ(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function IQ(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var c0 = /* @__PURE__ */ fn(function(e, t) {
  var n = e.children, r = Kd(e, EQ), i = gA(r), o = i.open, a = Kd(i, SQ);
  return Z3(t, function() {
    return {
      open: o
    };
  }, [o]), /* @__PURE__ */ H.createElement(G3, null, n(Ct(Ct({}, a), {}, {
    open: o
  })));
});
c0.displayName = "Dropzone";
var mA = {
  disabled: !1,
  getFilesFromEvent: BY,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
c0.defaultProps = mA;
c0.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {boolean} params.isDragGlobal Files are being dragged anywhere on the document
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: Fe.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: Fe.objectOf(Fe.arrayOf(Fe.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: Fe.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: Fe.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: Fe.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: Fe.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: Fe.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: Fe.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: Fe.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: Fe.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: Fe.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: Fe.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: Fe.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: Fe.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: Fe.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: Fe.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: Fe.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: Fe.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: Fe.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: Fe.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: Fe.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: Fe.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: Fe.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: Fe.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: Fe.func
};
var jg = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  isDragGlobal: !1,
  acceptedFiles: [],
  fileRejections: []
};
function gA() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = Ct(Ct({}, mA), e), n = t.accept, r = t.disabled, i = t.getFilesFromEvent, o = t.maxSize, a = t.minSize, s = t.multiple, l = t.maxFiles, u = t.onDragEnter, c = t.onDragLeave, f = t.onDragOver, d = t.onDrop, p = t.onDropAccepted, h = t.onDropRejected, v = t.onFileDialogCancel, m = t.onFileDialogOpen, g = t.useFsAccessApi, _ = t.autoFocus, w = t.preventDropOnDocument, x = t.noClick, S = t.noKeyboard, $ = t.noDrag, A = t.noDragEventsBubbling, E = t.onError, y = t.validator, b = Te(function() {
    return _Q(n);
  }, [n]), O = Te(function() {
    return bQ(n);
  }, [n]), k = Te(function() {
    return typeof m == "function" ? m : rS;
  }, [m]), I = Te(function() {
    return typeof v == "function" ? v : rS;
  }, [v]), T = _e(null), V = _e(null), z = pO(NQ, jg), B = Tv(z, 2), q = B[0], M = B[1], N = q.isFocused, Y = q.isFileDialogActive, ee = _e(typeof window < "u" && window.isSecureContext && g && yQ()), Q = function() {
    !ee.current && Y && setTimeout(function() {
      if (V.current) {
        var Ne = V.current.files;
        Ne.length || (M({
          type: "closeDialog"
        }), I());
      }
    }, 300);
  };
  Ee(function() {
    return window.addEventListener("focus", Q, !1), function() {
      window.removeEventListener("focus", Q, !1);
    };
  }, [V, Y, I, ee]);
  var K = _e([]), ne = _e([]), se = function(Ne) {
    T.current && T.current.contains(Ne.target) || (Ne.preventDefault(), K.current = []);
  };
  Ee(function() {
    return w && (document.addEventListener("dragover", eS, !1), document.addEventListener("drop", se, !1)), function() {
      w && (document.removeEventListener("dragover", eS), document.removeEventListener("drop", se));
    };
  }, [T, w]), Ee(function() {
    var ge = function(F) {
      ne.current = [].concat(tS(ne.current), [F.target]), Ll(F) && M({
        isDragGlobal: !0,
        type: "setDragGlobal"
      });
    }, Ne = function(F) {
      ne.current = ne.current.filter(function(U) {
        return U !== F.target && U !== null;
      }), !(ne.current.length > 0) && M({
        isDragGlobal: !1,
        type: "setDragGlobal"
      });
    }, Ye = function() {
      ne.current = [], M({
        isDragGlobal: !1,
        type: "setDragGlobal"
      });
    }, et = function() {
      ne.current = [], M({
        isDragGlobal: !1,
        type: "setDragGlobal"
      });
    };
    return document.addEventListener("dragenter", ge, !1), document.addEventListener("dragleave", Ne, !1), document.addEventListener("dragend", Ye, !1), document.addEventListener("drop", et, !1), function() {
      document.removeEventListener("dragenter", ge), document.removeEventListener("dragleave", Ne), document.removeEventListener("dragend", Ye), document.removeEventListener("drop", et);
    };
  }, [T]), Ee(function() {
    return !r && _ && T.current && T.current.focus(), function() {
    };
  }, [T, _, r]);
  var ce = Le(function(ge) {
    E ? E(ge) : console.error(ge);
  }, [E]), X = Le(function(ge) {
    ge.preventDefault(), ge.persist(), de(ge), K.current = [].concat(tS(K.current), [ge.target]), Ll(ge) && Promise.resolve(i(ge)).then(function(Ne) {
      if (!(Vd(ge) && !A)) {
        var Ye = Ne.length, et = Ye > 0 && hQ({
          files: Ne,
          accept: b,
          minSize: a,
          maxSize: o,
          multiple: s,
          maxFiles: l,
          validator: y
        }), ct = Ye > 0 && !et;
        M({
          isDragAccept: et,
          isDragReject: ct,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), u && u(ge);
      }
    }).catch(function(Ne) {
      return ce(Ne);
    });
  }, [i, u, ce, A, b, a, o, s, l, y]), D = Le(function(ge) {
    ge.preventDefault(), ge.persist(), de(ge);
    var Ne = Ll(ge);
    if (Ne && ge.dataTransfer)
      try {
        ge.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return Ne && f && f(ge), !1;
  }, [f, A]), P = Le(function(ge) {
    ge.preventDefault(), ge.persist(), de(ge);
    var Ne = K.current.filter(function(et) {
      return T.current && T.current.contains(et);
    }), Ye = Ne.indexOf(ge.target);
    Ye !== -1 && Ne.splice(Ye, 1), K.current = Ne, !(Ne.length > 0) && (M({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), Ll(ge) && c && c(ge));
  }, [T, c, A]), R = Le(function(ge, Ne) {
    var Ye = [], et = [];
    ge.forEach(function(ct) {
      var F = fA(ct, b), U = Tv(F, 2), Z = U[0], ue = U[1], ve = dA(ct, a, o), Se = Tv(ve, 2), xe = Se[0], $e = Se[1], We = y ? y(ct) : null;
      if (Z && xe && !We)
        Ye.push(ct);
      else {
        var pt = [ue, $e];
        We && (pt = pt.concat(We)), et.push({
          file: ct,
          errors: pt.filter(function(Qt) {
            return Qt;
          })
        });
      }
    }), (!s && Ye.length > 1 || s && l >= 1 && Ye.length > l) && (Ye.forEach(function(ct) {
      et.push({
        file: ct,
        errors: [dQ]
      });
    }), Ye.splice(0)), M({
      acceptedFiles: Ye,
      fileRejections: et,
      isDragReject: et.length > 0,
      type: "setFiles"
    }), d && d(Ye, et, Ne), et.length > 0 && h && h(et, Ne), Ye.length > 0 && p && p(Ye, Ne);
  }, [M, s, b, a, o, l, d, p, h, y]), j = Le(function(ge) {
    ge.preventDefault(), ge.persist(), de(ge), K.current = [], Ll(ge) && Promise.resolve(i(ge)).then(function(Ne) {
      Vd(ge) && !A || R(Ne, ge);
    }).catch(function(Ne) {
      return ce(Ne);
    }), M({
      type: "reset"
    });
  }, [i, R, ce, A]), W = Le(function() {
    if (ee.current) {
      M({
        type: "openDialog"
      }), k();
      var ge = {
        multiple: s,
        types: O
      };
      window.showOpenFilePicker(ge).then(function(Ne) {
        return i(Ne);
      }).then(function(Ne) {
        R(Ne, null), M({
          type: "closeDialog"
        });
      }).catch(function(Ne) {
        wQ(Ne) ? (I(Ne), M({
          type: "closeDialog"
        })) : xQ(Ne) ? (ee.current = !1, V.current ? (V.current.value = null, V.current.click()) : ce(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : ce(Ne);
      });
      return;
    }
    V.current && (M({
      type: "openDialog"
    }), k(), V.current.value = null, V.current.click());
  }, [M, k, I, g, R, ce, O, s]), J = Le(function(ge) {
    !T.current || !T.current.isEqualNode(ge.target) || (ge.key === " " || ge.key === "Enter" || ge.keyCode === 32 || ge.keyCode === 13) && (ge.preventDefault(), W());
  }, [T, W]), le = Le(function() {
    M({
      type: "focus"
    });
  }, []), te = Le(function() {
    M({
      type: "blur"
    });
  }, []), fe = Le(function() {
    x || (gQ() ? setTimeout(W, 0) : W());
  }, [x, W]), De = function(Ne) {
    return r ? null : Ne;
  }, he = function(Ne) {
    return S ? null : De(Ne);
  }, Oe = function(Ne) {
    return $ ? null : De(Ne);
  }, de = function(Ne) {
    A && Ne.stopPropagation();
  }, Ue = Te(function() {
    return function() {
      var ge = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ne = ge.refKey, Ye = Ne === void 0 ? "ref" : Ne, et = ge.role, ct = ge.onKeyDown, F = ge.onFocus, U = ge.onBlur, Z = ge.onClick, ue = ge.onDragEnter, ve = ge.onDragOver, Se = ge.onDragLeave, xe = ge.onDrop, $e = Kd(ge, OQ);
      return Ct(Ct(Mg({
        onKeyDown: he(gi(ct, J)),
        onFocus: he(gi(F, le)),
        onBlur: he(gi(U, te)),
        onClick: De(gi(Z, fe)),
        onDragEnter: Oe(gi(ue, X)),
        onDragOver: Oe(gi(ve, D)),
        onDragLeave: Oe(gi(Se, P)),
        onDrop: Oe(gi(xe, j)),
        role: typeof et == "string" && et !== "" ? et : "presentation"
      }, Ye, T), !r && !S ? {
        tabIndex: 0
      } : {}), $e);
    };
  }, [T, J, le, te, fe, X, D, P, j, S, $, r]), tt = Le(function(ge) {
    ge.stopPropagation();
  }, []), vn = Te(function() {
    return function() {
      var ge = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ne = ge.refKey, Ye = Ne === void 0 ? "ref" : Ne, et = ge.onChange, ct = ge.onClick, F = Kd(ge, $Q), U = Mg({
        accept: b,
        multiple: s,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: De(gi(et, j)),
        onClick: De(gi(ct, tt)),
        tabIndex: -1
      }, Ye, V);
      return Ct(Ct({}, U), F);
    };
  }, [V, n, s, j, r]);
  return Ct(Ct({}, q), {}, {
    isFocused: N && !r,
    getRootProps: Ue,
    getInputProps: vn,
    rootRef: T,
    inputRef: V,
    open: De(W)
  });
}
function NQ(e, t) {
  switch (t.type) {
    case "focus":
      return Ct(Ct({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return Ct(Ct({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return Ct(Ct({}, jg), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return Ct(Ct({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return Ct(Ct({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return Ct(Ct({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections,
        isDragReject: t.isDragReject
      });
    case "setDragGlobal":
      return Ct(Ct({}, e), {}, {
        isDragGlobal: t.isDragGlobal
      });
    case "reset":
      return Ct({}, jg);
    default:
      return e;
  }
}
function rS() {
}
const yA = (e) => /* @__PURE__ */ C.jsx("input", { type: "checkbox", ...e, className: "bg-neutral-600 checkbox" });
var Sc = (e) => e.type === "checkbox", ua = (e) => e instanceof Date, xn = (e) => e == null;
const bA = (e) => typeof e == "object";
var Wt = (e) => !xn(e) && !Array.isArray(e) && bA(e) && !ua(e), RQ = (e) => Wt(e) && e.target ? Sc(e.target) ? e.target.checked : e.target.value : e, MQ = (e, t) => t.split(".").some((n, r, i) => !isNaN(Number(n)) && e.has(i.slice(0, r).join("."))), _A = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Wt(t) && t.hasOwnProperty("isPrototypeOf");
}, Yp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function tn(e) {
  if (e instanceof Date)
    return new Date(e);
  const t = typeof FileList < "u" && e instanceof FileList;
  if (Yp && (e instanceof Blob || t))
    return e;
  const n = Array.isArray(e);
  if (!n && !(Wt(e) && _A(e)))
    return e;
  const r = n ? [] : Object.create(Object.getPrototypeOf(e));
  for (const i in e)
    Object.prototype.hasOwnProperty.call(e, i) && (r[i] = tn(e[i]));
  return r;
}
const Ja = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  SUBMIT: "submit",
  TRIGGER: "trigger",
  VALID: "valid"
}, Qr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Wr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, wA = "root", xA = ["__proto__", "constructor", "prototype"], jQ = /^\w*$/;
var Oc = (e) => jQ.test(e), It = (e) => e === void 0;
const FQ = /[.[\]'"]/;
var Qp = (e) => e.split(FQ).filter(Boolean), Re = (e, t, n) => {
  if (!t || !Wt(e))
    return n;
  const r = Oc(t) ? [t] : Qp(t);
  if (r.some((o) => xA.includes(o)))
    return n;
  const i = r.reduce((o, a) => xn(o) ? void 0 : o[a], e);
  return It(i) || i === e ? It(e[t]) ? n : e[t] : i;
}, bi = (e) => typeof e == "boolean", Or = (e) => typeof e == "function", At = (e, t, n) => {
  let r = -1;
  const i = Oc(t) ? [t] : Qp(t), o = i.length, a = o - 1;
  for (; ++r < o; ) {
    const s = i[r];
    let l = n;
    if (r !== a) {
      const u = e[s];
      l = Wt(u) || Array.isArray(u) ? u : isNaN(+i[r + 1]) ? {} : [];
    }
    if (xA.includes(s))
      return;
    e[s] = l, e = e[s];
  }
};
const zQ = H.createContext(null);
zQ.displayName = "HookFormControlContext";
var LQ = (e, t, n, r = !0) => {
  const i = {};
  for (const o in e)
    Object.defineProperty(i, o, {
      get: () => {
        const a = o;
        return t._proxyFormState[a] !== Qr.all && (t._proxyFormState[a] = !r || Qr.all), e[a];
      }
    });
  return i;
};
const VQ = Yp ? H.useLayoutEffect : H.useEffect;
var Cn = (e) => typeof e == "string", KQ = (e, t, n, r, i) => Cn(e) ? (r && t.watch.add(e), Re(n, e, i)) : Array.isArray(e) ? e.map((o) => (r && t.watch.add(o), Re(n, o))) : (r && (t.watchAll = !0), n), Fg = (e) => xn(e) || !bA(e);
const iS = (e, t) => t.length === 0 && !Array.isArray(e) && !_A(e);
function _i(e, t, n = /* @__PURE__ */ new WeakMap()) {
  if (e === t)
    return !0;
  if (Fg(e) || Fg(t))
    return Object.is(e, t);
  if (ua(e) && ua(t))
    return Object.is(e.getTime(), t.getTime());
  const r = Object.keys(e), i = Object.keys(t);
  if (r.length !== i.length)
    return !1;
  if (iS(e, r) || iS(t, i))
    return Object.is(e, t);
  if (!r.length && Array.isArray(e) !== Array.isArray(t))
    return !1;
  const o = n.get(e);
  if (o && o.has(t))
    return !0;
  if (o)
    o.add(t);
  else {
    const a = /* @__PURE__ */ new WeakSet();
    a.add(t), n.set(e, a);
  }
  for (const a of r) {
    const s = e[a];
    if (!(a in t))
      return !1;
    if (a !== "ref") {
      const l = t[a];
      if (ua(s) && ua(l) || (Wt(s) || Array.isArray(s)) && (Wt(l) || Array.isArray(l)) ? !_i(s, l, n) : !Object.is(s, l))
        return !1;
    }
  }
  return !0;
}
const BQ = H.createContext(null);
BQ.displayName = "HookFormContext";
var UQ = (e, t, n, r, i) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [r]: i || !0
  }
} : {}, EA = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Kf = (e) => Array.isArray(e) ? e : [e], oS = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (i) => {
      for (const o of e)
        o.next && o.next(i);
    },
    subscribe: (i) => (e.push(i), {
      unsubscribe: () => {
        e = e.filter((o) => o !== i);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
};
function SA(e, t) {
  const n = {};
  for (const r in e)
    if (e.hasOwnProperty(r)) {
      const i = e[r], o = t[r];
      if (i && Wt(i) && o) {
        const a = SA(i, o);
        Wt(a) && (n[r] = a);
      } else e[r] && (n[r] = o);
    }
  return n;
}
var wn = (e) => Wt(e) && !Object.keys(e).length, f0 = (e) => e.type === "file", Bd = (e) => {
  if (!Yp)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, OA = (e) => e.type === "select-multiple", d0 = (e) => e.type === "radio", qQ = (e) => d0(e) || Sc(e), Pv = (e) => Bd(e) && e.isConnected;
function HQ(e, t) {
  const n = t.slice(0, -1).length;
  let r = 0;
  for (; r < n; ) {
    if (xn(e)) {
      e = void 0;
      break;
    }
    e = e[t[r]], r++;
  }
  return e;
}
function WQ(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !It(e[t]))
      return !1;
  return !0;
}
function un(e, t) {
  if (Cn(t) && Object.prototype.hasOwnProperty.call(e, t))
    return delete e[t], e;
  const n = Array.isArray(t) ? t : Oc(t) ? [t] : Qp(t), r = n.length === 1 ? e : HQ(e, n), i = n.length - 1, o = n[i];
  return r && delete r[o], i !== 0 && (Wt(r) && wn(r) || Array.isArray(r) && WQ(r)) && un(e, n.slice(0, -1)), e;
}
var ZQ = (e) => {
  for (const t in e)
    if (Or(e[t]))
      return !0;
  return !1;
};
function $A(e) {
  return Array.isArray(e) || Wt(e) && !ZQ(e);
}
function zg(e, t = {}) {
  for (const n in e) {
    const r = e[n];
    $A(r) ? (t[n] = Array.isArray(r) ? [] : {}, zg(r, t[n])) : It(r) || (t[n] = !0);
  }
  return t;
}
function Lg(e) {
  if (e !== !1) {
    if (e === !0)
      return !0;
    if (Array.isArray(e)) {
      const t = e.map((n) => Lg(n));
      return t.some((n) => n !== void 0) ? t : void 0;
    }
    if (Wt(e)) {
      const t = {};
      for (const n in e) {
        const r = Lg(e[n]);
        It(r) || (t[n] = r);
      }
      return Object.keys(t).length ? t : void 0;
    }
  }
}
function Jo(e, t, n) {
  n || (n = zg(t));
  for (const r in e) {
    const i = e[r];
    if ($A(i))
      It(t) || Fg(n[r]) ? n[r] = zg(i, Array.isArray(i) ? [] : {}) : Jo(i, xn(t) ? {} : t[r], n[r]);
    else {
      const o = t[r];
      n[r] = !_i(i, o);
    }
  }
  return Lg(n) || {};
}
const aS = {
  value: !1,
  isValid: !1
}, sS = { value: !0, isValid: !0 };
var TA = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !It(e[0].attributes.value) ? It(e[0].value) || e[0].value === "" ? sS : { value: e[0].value, isValid: !0 } : sS
    ) : aS;
  }
  return aS;
}, PA = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => It(e) ? e : t ? e === "" ? NaN : e && +e : n && Cn(e) ? new Date(e) : r ? r(e) : e;
const lS = {
  isValid: !1,
  value: null
};
var kA = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, lS) : lS;
function uS(e) {
  const t = e.ref;
  return f0(t) ? t.files : d0(t) ? kA(e.refs).value : OA(t) ? [...t.selectedOptions].map(({ value: n }) => n) : Sc(t) ? TA(e.refs).value : PA(It(t.value) ? e.ref.value : t.value, e);
}
var GQ = (e, t, n, r) => {
  const i = {};
  for (const o of e) {
    const a = Re(t, o);
    a && At(i, o, a._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: i,
    shouldUseNativeValidation: r
  };
}, Ud = (e) => e instanceof RegExp, Vl = (e) => It(e) ? e : Ud(e) ? e.source : Wt(e) ? Ud(e.value) ? e.value.source : e.value : e, hf = (e) => ({
  isOnSubmit: !e || e === Qr.onSubmit,
  isOnBlur: e === Qr.onBlur,
  isOnChange: e === Qr.onChange,
  isOnAll: e === Qr.all,
  isOnTouch: e === Qr.onTouched
});
const cS = "AsyncFunction";
var YQ = (e) => {
  if (!e || !e.validate)
    return !1;
  if (Or(e.validate))
    return e.validate.constructor.name === cS;
  if (Wt(e.validate)) {
    for (const t in e.validate)
      if (e.validate[t].constructor.name === cS)
        return !0;
  }
  return !1;
}, QQ = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), kv = (e, t, n) => {
  if (n)
    return !1;
  if (t.watchAll || t.watch.has(e))
    return !0;
  for (const r of t.watch)
    if (e.startsWith(r) && e.charAt(r.length) === ".")
      return !0;
  return !1;
};
const yu = (e, t, n, r) => {
  for (const i of n || Object.keys(e)) {
    const o = Re(e, i);
    if (o) {
      const { _f: a, ...s } = o;
      if (a) {
        if (a.refs && a.refs[0] && t(a.refs[0], i) && !r)
          return !0;
        if (a.ref && t(a.ref, a.name) && !r)
          return !0;
        if (yu(s, t))
          break;
      } else if (Wt(s) && yu(s, t))
        break;
    }
  }
};
function fS(e, t, n) {
  const r = Re(e, n);
  if (r || Oc(n))
    return {
      error: r,
      name: n
    };
  const i = n.split(".");
  for (; i.length; ) {
    const o = i.join("."), a = Re(t, o), s = Re(e, o);
    if (a && !Array.isArray(a) && n !== o)
      return { name: n };
    if (s && s.type)
      return {
        name: o,
        error: s
      };
    if (s && s.root && s.root.type)
      return {
        name: `${o}.root`,
        error: s.root
      };
    i.pop();
  }
  return {
    name: n
  };
}
var JQ = (e, t, n, r) => {
  n(e);
  const { name: i, ...o } = e, a = Object.keys(o);
  return !a.length || r && a.length >= Object.keys(t).length || a.find((s) => t[s] === (!r || Qr.all));
}, XQ = (e, t, n) => !e || !t || e === t || Kf(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r))), eJ = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, tJ = (e, t) => !EA(Re(e, t)).length && un(e, t), dS = (e, t, n) => {
  const r = Re(e, n), i = Array.isArray(r) ? r : [];
  return At(i, wA, t[n]), At(e, n, i), e;
};
function pS(e, t, n = "validate") {
  if (Cn(e) || Array.isArray(e) && e.every(Cn) || bi(e) && !e)
    return {
      type: n,
      message: Cn(e) ? e : "",
      ref: t
    };
}
var Xa = (e) => Wt(e) && !Ud(e) ? e : {
  value: e,
  message: ""
}, hS = async (e, t, n, r, i, o) => {
  const { ref: a, refs: s, required: l, maxLength: u, minLength: c, min: f, max: d, pattern: p, validate: h, name: v, valueAsNumber: m, mount: g } = e._f, _ = Re(n, v);
  if (!g || t.has(v))
    return {};
  const w = s ? s[0] : a, x = (k) => {
    if (i && w.reportValidity) {
      const I = bi(k) ? "" : k || "";
      s ? s.forEach((T) => T.setCustomValidity(I)) : w.setCustomValidity(I), w.reportValidity();
    }
  }, S = {}, $ = d0(a), A = Sc(a), E = $ || A, y = (m || f0(a)) && It(a.value) && It(_) || Bd(a) && a.value === "" || _ === "" || Array.isArray(_) && !_.length, b = UQ.bind(null, v, r, S), O = (k, I, T, V = Wr.maxLength, z = Wr.minLength) => {
    const B = k ? I : T;
    S[v] = {
      type: k ? V : z,
      message: B,
      ref: a,
      ...b(k ? V : z, B)
    };
  };
  if (o ? !Array.isArray(_) || !_.length : l && (!E && (y || xn(_)) || bi(_) && !_ || A && !TA(s).isValid || $ && !kA(s).isValid)) {
    const { value: k, message: I } = Cn(l) ? { value: !!l, message: l } : Xa(l);
    if (k && (S[v] = {
      type: Wr.required,
      message: I,
      ref: w,
      ...b(Wr.required, I)
    }, !r))
      return x(I), S;
  }
  if (!y && (!xn(f) || !xn(d))) {
    let k, I;
    const T = Xa(d), V = Xa(f);
    if (!xn(_) && !isNaN(_)) {
      const z = a.valueAsNumber || _ && +_;
      xn(T.value) || (k = z > T.value), xn(V.value) || (I = z < V.value);
    } else {
      const z = a.valueAsDate || new Date(_), B = (N) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + N), q = a.type == "time", M = a.type == "week";
      Cn(T.value) && _ && (k = q ? B(_) > B(T.value) : M ? _ > T.value : z > new Date(T.value)), Cn(V.value) && _ && (I = q ? B(_) < B(V.value) : M ? _ < V.value : z < new Date(V.value));
    }
    if ((k || I) && (O(!!k, T.message, V.message, Wr.max, Wr.min), !r))
      return x(S[v].message), S;
  }
  if ((u || c) && !y && (Cn(_) || o && Array.isArray(_))) {
    const k = Xa(u), I = Xa(c), T = !xn(k.value) && _.length > +k.value, V = !xn(I.value) && _.length < +I.value;
    if ((T || V) && (O(T, k.message, I.message), !r))
      return x(S[v].message), S;
  }
  if (p && !y && Cn(_)) {
    const { value: k, message: I } = Xa(p);
    if (Ud(k) && !_.match(k) && (S[v] = {
      type: Wr.pattern,
      message: I,
      ref: a,
      ...b(Wr.pattern, I)
    }, !r))
      return x(I), S;
  }
  if (h) {
    if (Or(h)) {
      const k = await h(_, n), I = pS(k, w);
      if (I && (S[v] = {
        ...I,
        ...b(Wr.validate, I.message)
      }, !r))
        return x(I.message), S;
    } else if (Wt(h)) {
      let k = {};
      for (const I in h) {
        if (!wn(k) && !r)
          break;
        const T = pS(await h[I](_, n), w, I);
        T && (k = {
          ...T,
          ...b(I, T.message)
        }, x(T.message), r && (S[v] = k));
      }
      if (!wn(k) && (S[v] = {
        ref: w,
        ...k
      }, !r))
        return S;
    }
  }
  return x(!0), S;
};
const nJ = {
  mode: Qr.onSubmit,
  reValidateMode: Qr.onChange,
  shouldFocusError: !0
}, Dv = "form", DA = {
  submitCount: 0,
  isDirty: !1,
  isReady: !1,
  isValidating: !1,
  isSubmitted: !1,
  isSubmitting: !1,
  isSubmitSuccessful: !1,
  isValid: !1,
  touchedFields: {},
  dirtyFields: {},
  validatingFields: {}
};
function rJ(e = {}) {
  let t = {
    ...nJ,
    ...e
  }, n = {
    ...tn(DA),
    isLoading: Or(t.defaultValues),
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, r = {}, i = Wt(t.defaultValues) || Wt(t.values) ? tn(t.defaultValues || t.values) || {} : {}, o = t.shouldUnregister ? {} : tn(i), a = {
    action: !1,
    mount: !1,
    watch: !1,
    keepIsValid: !1
  }, s = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set(),
    registerName: /* @__PURE__ */ new Set()
  }, l, u = 0, c = 0, f = hf(t.mode), d = hf(t.reValidateMode);
  const p = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, h = {
    ...p
  };
  let v = {
    ...h
  };
  const m = {
    array: oS(),
    state: oS()
  }, g = t.criteriaMode === Qr.all, _ = (F) => (U) => {
    clearTimeout(u), u = setTimeout(F, U);
  }, w = async (F) => {
    if (!a.keepIsValid && !t.disabled && (h.isValid || v.isValid || F)) {
      let U;
      t.resolver ? (U = wn((await I()).errors), x()) : U = await z({
        fields: r,
        onlyCheckValid: !0,
        eventType: Ja.VALID
      }), U !== n.isValid && m.state.next({
        isValid: U
      });
    }
  }, x = (F, U) => {
    !t.disabled && (h.isValidating || h.validatingFields || v.isValidating || v.validatingFields) && ((F || Array.from(s.mount)).forEach((Z) => {
      Z && (U ? At(n.validatingFields, Z, U) : un(n.validatingFields, Z));
    }), m.state.next({
      validatingFields: n.validatingFields,
      isValidating: !wn(n.validatingFields)
    }));
  }, S = () => {
    n.dirtyFields = Jo(i, o);
  }, $ = (F, U = [], Z, ue, ve = !0, Se = !0) => {
    if (ue && Z && !t.disabled) {
      if (a.action = !0, Se && Array.isArray(Re(r, F))) {
        const xe = Z(Re(r, F), ue.argA, ue.argB);
        ve && At(r, F, xe);
      }
      if (Se && Array.isArray(Re(n.errors, F))) {
        const xe = Z(Re(n.errors, F), ue.argA, ue.argB);
        ve && At(n.errors, F, xe), tJ(n.errors, F);
      }
      if ((h.touchedFields || v.touchedFields) && Se && Array.isArray(Re(n.touchedFields, F))) {
        const xe = Z(Re(n.touchedFields, F), ue.argA, ue.argB);
        ve && At(n.touchedFields, F, xe);
      }
      (h.dirtyFields || v.dirtyFields) && S(), m.state.next({
        name: F,
        isDirty: q(F, U),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      At(o, F, U);
  }, A = (F, U) => {
    At(n.errors, F, U), n.errors = { ...n.errors }, m.state.next({
      errors: n.errors
    });
  }, E = (F) => {
    n.errors = F, m.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, y = (F) => {
    const U = Oc(F) ? [F] : Qp(F);
    let Z = o, ue = i;
    for (let ve = 0; ve < U.length - 1; ve++) {
      const Se = U[ve];
      if (Z = xn(Z) ? Z : Z[Se], ue = xn(ue) ? ue : ue[Se], Z === null && ue !== null)
        return !0;
    }
    return !1;
  }, b = (F, U, Z, ue) => {
    const ve = Re(r, F);
    if (ve) {
      if (y(F))
        return;
      const Se = It(Re(o, F)), xe = Re(o, F, It(Z) ? Re(i, F) : Z);
      It(xe) || ue && ue.defaultChecked || U ? At(o, F, U ? xe : uS(ve._f)) : Y(F, xe), a.mount && !a.action && (w(), Se && n.isDirty && (h.isDirty || v.isDirty) && (q() || (n.isDirty = !1, m.state.next({ ...n }))), e.shouldUnregister && Se && !It(Re(o, F)) && kv(F, s) && (a.watch = !0));
    }
  }, O = (F, U, Z, ue, ve) => {
    let Se = !1, xe = !1;
    const $e = {
      name: F
    };
    if (!t.disabled) {
      if (!Z || ue) {
        const We = _i(Re(i, F), U);
        (h.isDirty || v.isDirty) && (xe = n.isDirty, n.isDirty = $e.isDirty = !We || q(), Se = xe !== $e.isDirty), xe = !!Re(n.dirtyFields, F), We !== n.isDirty ? n.dirtyFields = Jo(i, o) : We ? un(n.dirtyFields, F) : At(n.dirtyFields, F, !0), $e.dirtyFields = n.dirtyFields, Se = Se || (h.dirtyFields || v.dirtyFields) && xe !== !We;
      }
      if (Z) {
        const We = Re(n.touchedFields, F);
        We || (At(n.touchedFields, F, Z), $e.touchedFields = n.touchedFields, Se = Se || (h.touchedFields || v.touchedFields) && We !== Z);
      }
      Se && ve && m.state.next($e);
    }
    return Se ? $e : {};
  }, k = (F, U, Z, ue) => {
    const ve = Re(n.errors, F), Se = (h.isValid || v.isValid) && bi(U) && n.isValid !== U;
    if (t.delayError && Z ? (l = _(() => A(F, Z)), l(t.delayError)) : (clearTimeout(u), l = null, Z ? At(n.errors, F, Z) : un(n.errors, F), n.errors = { ...n.errors }), (Z ? !_i(ve, Z) : ve) || !wn(ue) || Se) {
      const xe = {
        ...ue,
        ...Se && bi(U) ? { isValid: U } : {},
        errors: n.errors,
        name: F
      };
      n = {
        ...n,
        ...xe
      }, m.state.next(xe);
    }
  }, I = async (F) => (x(F, !0), await t.resolver(o, t.context, GQ(F || s.mount, r, t.criteriaMode, t.shouldUseNativeValidation))), T = async (F) => {
    const { errors: U } = await I(F);
    if (x(F), F) {
      for (const Z of F) {
        const ue = Re(U, Z);
        ue ? s.array.has(Z) && Wt(ue) && !Object.keys(ue).some((ve) => !Number.isNaN(Number(ve))) ? dS(n.errors, { [Z]: ue }, Z) : At(n.errors, Z, ue) : un(n.errors, Z);
      }
      n.errors = { ...n.errors };
    } else
      n.errors = U;
    return U;
  }, V = async ({ name: F, eventType: U }) => {
    if (e.validate) {
      const Z = await e.validate({
        formValues: o,
        formState: n,
        name: F,
        eventType: U
      });
      if (Wt(Z))
        for (const ue in Z) {
          const ve = Z[ue];
          ve && j(`${Dv}.${ue}`, {
            message: Cn(ve.message) ? ve.message : "",
            type: ve.type || Wr.validate
          });
        }
      else Cn(Z) || !Z ? j(Dv, {
        message: Z || "",
        type: Wr.validate
      }) : R(Dv);
      return Z;
    }
    return !0;
  }, z = async ({ fields: F, onlyCheckValid: U, name: Z, eventType: ue, context: ve = {
    valid: !0,
    runRootValidation: !1
  } }) => {
    if (e.validate && (ve.runRootValidation = !0, !await V({
      name: Z,
      eventType: ue
    }) && (ve.valid = !1, U)))
      return ve.valid;
    for (const Se in F) {
      const xe = F[Se];
      if (xe) {
        const { _f: $e, ...We } = xe;
        if ($e) {
          const pt = s.array.has($e.name), Qt = xe._f && YQ(xe._f), hi = h.validatingFields || h.isValidating || v.validatingFields || v.isValidating;
          Qt && hi && x([$e.name], !0);
          const or = await hS(xe, s.disabled, o, g, t.shouldUseNativeValidation && !U, pt);
          if (Qt && hi && x([$e.name]), or[$e.name] && (ve.valid = !1, U) || (!U && (Re(or, $e.name) ? pt ? dS(n.errors, or, $e.name) : At(n.errors, $e.name, or[$e.name]) : un(n.errors, $e.name)), e.shouldUseNativeValidation && or[$e.name]))
            break;
        }
        !wn(We) && await z({
          context: ve,
          onlyCheckValid: U,
          fields: We,
          name: Se,
          eventType: ue
        });
      }
    }
    return ve.valid;
  }, B = () => {
    for (const F of s.unMount) {
      const U = Re(r, F);
      U && (U._f.refs ? U._f.refs.every((Z) => !Pv(Z)) : !Pv(U._f.ref)) && te(F);
    }
    s.unMount = /* @__PURE__ */ new Set();
  }, q = (F, U) => !t.disabled && (F && U && At(o, F, U), !_i(a.mount ? o : i, i)), M = (F, U, Z) => KQ(F, s, {
    ...a.mount ? o : It(U) ? i : Cn(F) ? { [F]: U } : U
  }, Z, U), N = (F) => EA(Re(a.mount ? o : i, F, t.shouldUnregister ? Re(i, F, []) : [])), Y = (F, U, Z = {}, ue = !1, ve = !1) => {
    const Se = Re(r, F);
    let xe = U;
    if (Se) {
      const $e = Se._f;
      $e && (!$e.disabled && At(o, F, PA(U, $e)), xe = Bd($e.ref) && xn(U) ? "" : U, OA($e.ref) ? [...$e.ref.options].forEach((We) => We.selected = xe.includes(We.value)) : $e.refs ? Sc($e.ref) ? $e.refs.forEach((We) => {
        (!We.defaultChecked || !We.disabled) && (Array.isArray(xe) ? We.checked = !!xe.find((pt) => pt === We.value) : We.checked = xe === We.value || !!xe);
      }) : $e.refs.forEach((We) => We.checked = We.value === xe) : f0($e.ref) ? $e.ref.value = "" : ($e.ref.value = xe, !$e.ref.type && !ve && m.state.next({
        name: F,
        values: ue ? o : tn(o)
      })));
    }
    (Z.shouldDirty || Z.shouldTouch) && O(F, xe, Z.shouldTouch, Z.shouldDirty, !ve), Z.shouldValidate && X(F);
  }, ee = (F, U, Z, ue = !1, ve = !1) => {
    for (const Se in U) {
      if (!U.hasOwnProperty(Se))
        return;
      const xe = U[Se], $e = F + "." + Se, We = Re(r, $e);
      (s.array.has(F) || Wt(xe) || We && !We._f) && !ua(xe) ? ee($e, xe, Z, ue, ve) : Y($e, xe, Z, ue, ve);
    }
  }, Q = (F, U, Z, ue, ve = !1) => {
    const Se = Re(r, F), xe = s.array.has(F), $e = ue ? U : tn(U), We = Re(o, F), pt = _i(We, $e);
    if (pt || At(o, F, $e), xe)
      m.array.next({
        name: F,
        values: ue ? o : tn(o)
      }), (h.isDirty || h.dirtyFields || v.isDirty || v.dirtyFields) && Z.shouldDirty && (S(), ve || m.state.next({
        name: F,
        dirtyFields: n.dirtyFields,
        isDirty: q(F, $e)
      }));
    else {
      const Qt = Array.isArray($e) && !$e.length || wn($e);
      !Se || Se._f || xn($e) || Qt ? Y(F, $e, Z, ue, ve) : ee(F, $e, Z, ue, ve);
    }
    if (!pt && !ve) {
      const Qt = kv(F, s), hi = ue ? o : tn(o);
      m.state.next({
        ...Qt && n,
        name: a.mount || Qt ? F : void 0,
        values: hi
      });
    }
  }, K = (F, U, Z = {}) => Q(F, U, Z, !1), ne = (F, U = {}) => {
    const Z = Or(F) ? F(o) : F;
    if (!_i(o, Z)) {
      o = {
        ...o,
        ...Z
      };
      for (const ue of s.mount)
        Q(ue, Re(Z, ue), U, !0, !0);
      m.state.next({
        ...n,
        name: void 0,
        type: void 0,
        ...c ? { values: o } : {}
      }), U.shouldValidate && w();
    }
  }, se = async (F) => {
    a.mount = !0;
    const U = F.target;
    let Z = U.name, ue = !0;
    const ve = Re(r, Z), Se = (xe) => {
      ue = Number.isNaN(xe) || ua(xe) && isNaN(xe.getTime()) || _i(xe, Re(o, Z, xe));
    };
    if (ve) {
      let xe, $e;
      const We = U.type ? uS(ve._f) : RQ(F), pt = F.type === Ja.BLUR || F.type === Ja.FOCUS_OUT, Qt = !QQ(ve._f) && !e.validate && !t.resolver && !Re(n.errors, Z) && !ve._f.deps, hi = Qt || eJ(pt, Re(n.touchedFields, Z), n.isSubmitted, d, f), or = kv(Z, s, pt);
      At(o, Z, We), pt ? (!U || !U.readOnly) && (ve._f.onBlur && ve._f.onBlur(F), l && l(0)) : ve._f.onChange && ve._f.onChange(F);
      const ro = O(Z, We, pt), xh = !wn(ro) || or;
      if (!pt && m.state.next({
        name: Z,
        type: F.type,
        ...c ? { values: tn(o) } : {}
      }), hi)
        return (!Qt || !n.isValid) && (h.isValid || v.isValid) && (t.mode === "onBlur" ? pt && w() : pt || w()), xh && m.state.next({ name: Z, ...or ? {} : ro });
      if (!t.resolver && e.validate && await V({
        name: Z,
        eventType: F.type
      }), !pt && or && m.state.next({ ...n }), t.resolver) {
        const { errors: kl } = await I([Z]);
        if (x([Z]), Se(We), !ue) {
          !wn(ro) && m.state.next(ro);
          return;
        }
        const Eh = fS(n.errors, r, Z), Dl = fS(kl, r, Eh.name || Z);
        xe = Dl.error, Z = Dl.name, $e = wn(kl);
      } else
        x([Z], !0), xe = (await hS(ve, s.disabled, o, g, t.shouldUseNativeValidation))[Z], x([Z]), Se(We), ue && (xe ? $e = !1 : (h.isValid || v.isValid) && ($e = await z({
          fields: r,
          onlyCheckValid: !0,
          name: Z,
          eventType: F.type
        })));
      ue && (ve._f.deps && (!Array.isArray(ve._f.deps) || ve._f.deps.length > 0) && X(ve._f.deps), k(Z, $e, xe, ro));
    }
  }, ce = (F, U) => {
    if (Re(n.errors, U) && F.focus)
      return F.focus(), 1;
  }, X = async (F, U = {}) => {
    let Z, ue;
    const ve = Kf(F);
    if (t.resolver) {
      const Se = await T(It(F) ? F : ve);
      Z = wn(Se), ue = F ? !ve.some((xe) => Re(Se, xe)) : Z;
    } else F ? (ue = (await Promise.all(ve.map(async (Se) => {
      const xe = Re(r, Se);
      return await z({
        fields: xe && xe._f ? { [Se]: xe } : xe,
        eventType: Ja.TRIGGER
      });
    }))).every(Boolean), !(!ue && !n.isValid) && w()) : ue = Z = await z({
      fields: r,
      name: F,
      eventType: Ja.TRIGGER
    });
    return m.state.next({
      ...!Cn(F) || (h.isValid || v.isValid) && Z !== n.isValid ? {} : { name: F },
      ...t.resolver || !F ? { isValid: Z } : {},
      errors: n.errors
    }), U.shouldFocus && !ue && yu(r, ce, F ? ve : s.mount), ue;
  }, D = (F, U) => {
    let Z = {
      ...a.mount ? o : i
    };
    return U && (Z = SA(U.dirtyFields ? n.dirtyFields : n.touchedFields, Z)), It(F) ? Z : Cn(F) ? Re(Z, F) : F.map((ue) => Re(Z, ue));
  }, P = (F, U) => ({
    invalid: !!Re((U || n).errors, F),
    isDirty: !!Re((U || n).dirtyFields, F),
    error: Re((U || n).errors, F),
    isValidating: !!Re(n.validatingFields, F),
    isTouched: !!Re((U || n).touchedFields, F)
  }), R = (F) => {
    const U = F ? Kf(F) : void 0;
    U?.forEach((Z) => un(n.errors, Z)), U ? U.forEach((Z) => {
      m.state.next({
        name: Z,
        errors: n.errors
      });
    }) : m.state.next({
      errors: {}
    });
  }, j = (F, U, Z) => {
    const ue = (Re(r, F, { _f: {} })._f || {}).ref, ve = Re(n.errors, F) || {}, { ref: Se, message: xe, type: $e, ...We } = ve;
    At(n.errors, F, {
      ...We,
      ...U,
      ref: ue
    }), m.state.next({
      name: F,
      errors: n.errors,
      isValid: !1
    }), Z && Z.shouldFocus && ue && ue.focus && ue.focus();
  }, W = (F, U) => {
    if (Or(F)) {
      c++;
      const { unsubscribe: Z } = m.state.subscribe({
        next: (ve) => "values" in ve && F(ve.values || M(void 0, U), ve)
      });
      let ue = !1;
      return {
        unsubscribe: () => {
          ue || (ue = !0, c--, Z());
        }
      };
    }
    return M(F, U, !0);
  }, J = (F) => {
    var U;
    const Z = !!(!((U = F.formState) === null || U === void 0) && U.values);
    Z && c++;
    const { unsubscribe: ue } = m.state.subscribe({
      next: (Se) => {
        if (XQ(F.name, Se.name, F.exact) && JQ(Se, F.formState || h, Ne, F.reRenderRoot)) {
          const xe = { ...o };
          F.callback({
            values: xe,
            ...n,
            ...Se,
            defaultValues: i
          });
        }
      }
    });
    if (!Z)
      return ue;
    let ve = !1;
    return () => {
      ve || (ve = !0, c--, ue());
    };
  }, le = (F) => (a.mount = !0, v = {
    ...v,
    ...F.formState
  }, J({
    ...F,
    formState: {
      ...p,
      ...F.formState
    }
  })), te = (F, U = {}) => {
    for (const Z of F ? Kf(F) : s.mount)
      s.mount.delete(Z), s.array.delete(Z), U.keepValue || (un(r, Z), un(o, Z)), !U.keepError && un(n.errors, Z), !U.keepDirty && un(n.dirtyFields, Z), !U.keepTouched && un(n.touchedFields, Z), !U.keepIsValidating && un(n.validatingFields, Z), !t.shouldUnregister && !U.keepDefaultValue && un(i, Z);
    m.state.next({
      values: tn(o)
    }), m.state.next({
      ...n,
      ...U.keepDirty ? { isDirty: q() } : {}
    }), !U.keepIsValid && w();
  }, fe = ({ disabled: F, name: U }) => {
    if (bi(F) && a.mount || F || s.disabled.has(U)) {
      const ve = s.disabled.has(U) !== !!F;
      F ? s.disabled.add(U) : s.disabled.delete(U), ve && a.mount && !a.action && w();
    }
  }, De = (F, U = {}) => {
    let Z = Re(r, F);
    const ue = bi(U.disabled) || bi(t.disabled), ve = !s.registerName.has(F) && Z && Z._f && !Z._f.mount;
    return At(r, F, {
      ...Z || {},
      _f: {
        ...Z && Z._f ? Z._f : { ref: { name: F } },
        name: F,
        mount: !0,
        ...U
      }
    }), s.mount.add(F), Z && !ve ? fe({
      disabled: bi(U.disabled) ? U.disabled : t.disabled,
      name: F
    }) : b(F, !0, U.value), {
      ...ue ? { disabled: U.disabled || t.disabled } : {},
      ...t.progressive ? {
        required: !!U.required,
        min: Vl(U.min),
        max: Vl(U.max),
        minLength: Vl(U.minLength),
        maxLength: Vl(U.maxLength),
        pattern: Vl(U.pattern)
      } : {},
      name: F,
      onChange: se,
      onBlur: se,
      ref: (Se) => {
        if (Se) {
          s.registerName.add(F), De(F, U), s.registerName.delete(F), Z = Re(r, F);
          const xe = It(Se.value) && Se.querySelectorAll && Se.querySelectorAll("input,select,textarea")[0] || Se, $e = qQ(xe), We = Z._f.refs || [];
          if ($e ? We.find((pt) => pt === xe) : xe === Z._f.ref)
            return;
          At(r, F, {
            _f: {
              ...Z._f,
              ...$e ? {
                refs: [
                  ...We.filter(Pv),
                  xe,
                  ...Array.isArray(Re(i, F)) ? [{}] : []
                ],
                ref: { type: xe.type, name: F }
              } : { ref: xe }
            }
          }), b(F, !1, void 0, xe);
        } else
          Z = Re(r, F, {}), Z._f && (Z._f.mount = !1), (t.shouldUnregister || U.shouldUnregister) && !(MQ(s.array, F) && a.action) && s.unMount.add(F);
      }
    };
  }, he = () => t.shouldFocusError && !t.shouldUseNativeValidation && yu(r, ce, s.mount), Oe = (F) => {
    bi(F) && (m.state.next({ disabled: F }), yu(r, (U, Z) => {
      const ue = Re(r, Z);
      ue && (U.disabled = ue._f.disabled || F, Array.isArray(ue._f.refs) && ue._f.refs.forEach((ve) => {
        ve.disabled = ue._f.disabled || F;
      }));
    }, 0, !1));
  }, de = (F, U) => async (Z) => {
    let ue;
    Z && (Z.preventDefault && Z.preventDefault(), Z.persist && Z.persist());
    let ve = tn(o);
    if (m.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: Se, values: xe } = await I();
      x(), n.errors = Se, ve = tn(xe);
    } else
      await z({
        fields: r,
        eventType: Ja.SUBMIT
      });
    if (s.disabled.size)
      for (const Se of s.disabled)
        un(ve, Se);
    if (un(n.errors, wA), wn(n.errors)) {
      m.state.next({
        errors: {}
      });
      try {
        await F(ve, Z);
      } catch (Se) {
        ue = Se;
      }
    } else
      U && await U({ ...n.errors }, Z), he(), setTimeout(he);
    if (m.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: wn(n.errors) && !ue,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), ue)
      throw ue;
  }, Ue = (F, U = {}) => {
    Re(r, F) && (It(U.defaultValue) ? K(F, tn(Re(i, F))) : (K(F, U.defaultValue), At(i, F, tn(U.defaultValue))), U.keepTouched || un(n.touchedFields, F), U.keepDirty || (un(n.dirtyFields, F), n.isDirty = U.defaultValue ? q(F, tn(Re(i, F))) : q()), U.keepError || (un(n.errors, F), h.isValid && w()), m.state.next({ ...n }));
  }, tt = (F, U = {}) => {
    const Z = F ? tn(F) : i, ue = tn(Z), ve = wn(F), Se = ue;
    if (U.keepDefaultValues || (i = Z), !U.keepValues) {
      if (U.keepDirtyValues) {
        const xe = /* @__PURE__ */ new Set([
          ...s.mount,
          ...Object.keys(Jo(i, o))
        ]);
        for (const $e of Array.from(xe)) {
          const We = Re(n.dirtyFields, $e), pt = Re(o, $e), Qt = Re(Se, $e);
          We && !It(pt) ? At(Se, $e, pt) : !We && !It(Qt) && K($e, Qt);
        }
      } else {
        if (Yp && It(F))
          for (const xe of s.mount) {
            const $e = Re(r, xe);
            if ($e && $e._f) {
              const We = Array.isArray($e._f.refs) ? $e._f.refs[0] : $e._f.ref;
              if (Bd(We)) {
                const pt = We.closest("form");
                if (pt) {
                  pt.reset();
                  break;
                }
              }
            }
          }
        if (U.keepFieldsRef)
          for (const xe of s.mount)
            K(xe, Re(Se, xe));
        else
          r = {};
      }
      if (t.shouldUnregister) {
        if (o = U.keepDefaultValues ? tn(i) : {}, U.keepFieldsRef)
          for (const xe of s.mount)
            At(o, xe, Re(Se, xe));
      } else
        o = tn(Se);
      m.array.next({
        values: { ...Se }
      }), m.state.next({
        values: { ...Se }
      });
    }
    s = {
      mount: U.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      registerName: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, a.mount = !h.isValid || !!U.keepIsValid || !!U.keepDirtyValues || !t.shouldUnregister && !wn(Se), a.watch = !!t.shouldUnregister, a.keepIsValid = !!U.keepIsValid, a.action = !1, U.keepErrors || (n.errors = {}), m.state.next({
      submitCount: U.keepSubmitCount ? n.submitCount : 0,
      isDirty: ve ? !1 : U.keepDirty ? n.isDirty : U.keepValues ? q() : !!(U.keepDefaultValues && !_i(F, i)),
      isSubmitted: U.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: ve ? {} : U.keepDirtyValues ? U.keepDefaultValues && o ? Jo(i, o) : n.dirtyFields : U.keepDefaultValues && F ? Jo(i, F) : U.keepDirty ? n.dirtyFields : {},
      touchedFields: U.keepTouched ? n.touchedFields : {},
      errors: U.keepErrors ? n.errors : {},
      isSubmitSuccessful: U.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1,
      defaultValues: i
    });
  }, vn = (F, U) => tt(Or(F) ? F(o) : F, { ...t.resetOptions, ...U }), ge = (F, U = {}) => {
    const Z = Re(r, F), ue = Z && Z._f;
    if (ue) {
      const ve = ue.refs ? ue.refs[0] : ue.ref;
      ve.focus && setTimeout(() => {
        ve.focus(), U.shouldSelect && Or(ve.select) && ve.select();
      });
    }
  }, Ne = (F) => {
    n = {
      ...n,
      ...F
    };
  }, ct = {
    control: {
      register: De,
      unregister: te,
      getFieldState: P,
      handleSubmit: de,
      setError: j,
      _subscribe: J,
      _runSchema: I,
      _updateIsValidating: x,
      _focusError: he,
      _getWatch: M,
      _getDirty: q,
      _setValid: w,
      _setFieldArray: $,
      _setDisabledField: fe,
      _setErrors: E,
      _getFieldArray: N,
      _reset: tt,
      _resetDefaultValues: () => Or(t.defaultValues) && t.defaultValues().then((F) => {
        vn(F, t.resetOptions), m.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Oe,
      _subjects: m,
      _proxyFormState: h,
      get _fields() {
        return r;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return a;
      },
      set _state(F) {
        a = F;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return s;
      },
      set _names(F) {
        s = F;
      },
      get _formState() {
        return n;
      },
      get _options() {
        return t;
      },
      set _options(F) {
        t = {
          ...t,
          ...F
        }, f = hf(t.mode), d = hf(t.reValidateMode);
      }
    },
    subscribe: le,
    trigger: X,
    register: De,
    handleSubmit: de,
    watch: W,
    setValue: K,
    setValues: ne,
    getValues: D,
    reset: vn,
    resetField: Ue,
    resetDefaultValues: (F, U = {}) => {
      if (i = tn(F), !U.keepDirty) {
        const Z = Jo(i, o);
        n.dirtyFields = Z, n.isDirty = !wn(Z);
      }
      U.keepIsValid || w(), m.state.next({
        ...n,
        defaultValues: i
      });
    },
    clearErrors: R,
    unregister: te,
    setError: j,
    setFocus: ge,
    getFieldState: P
  };
  return {
    ...ct,
    formControl: ct
  };
}
function iJ(e = {}) {
  const t = H.useRef(void 0), n = H.useRef(void 0), r = H.useRef(e.formControl), [i, o] = H.useState(() => ({
    ...tn(DA),
    isLoading: Or(e.defaultValues),
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Or(e.defaultValues) ? void 0 : e.defaultValues
  }));
  if (!t.current || e.formControl && r.current !== e.formControl)
    if (r.current = e.formControl, e.formControl)
      t.current = {
        ...e.formControl,
        formState: i
      }, e.defaultValues && !Or(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions);
    else {
      const { formControl: s, ...l } = rJ(e);
      t.current = {
        ...l,
        formState: i
      };
    }
  const a = t.current.control;
  return a._options = e, VQ(() => {
    const s = a._subscribe({
      formState: a._proxyFormState,
      callback: () => o({
        ...a._formState,
        defaultValues: a._defaultValues
      }),
      reRenderRoot: !0
    });
    return o((l) => ({
      ...l,
      isReady: !0
    })), a._formState.isReady = !0, s;
  }, [a]), H.useEffect(() => a._disableForm(e.disabled), [a, e.disabled]), H.useEffect(() => {
    e.mode && (a._options.mode = e.mode), e.reValidateMode && (a._options.reValidateMode = e.reValidateMode);
  }, [a, e.mode, e.reValidateMode]), H.useEffect(() => {
    e.errors && (a._setErrors(e.errors), a._focusError());
  }, [a, e.errors]), H.useEffect(() => {
    e.shouldUnregister && a._subjects.state.next({
      values: a._getWatch()
    });
  }, [a, e.shouldUnregister]), H.useEffect(() => {
    if (a._proxyFormState.isDirty) {
      const s = a._getDirty();
      s !== i.isDirty && a._subjects.state.next({
        isDirty: s
      });
    }
  }, [a, i.isDirty]), H.useEffect(() => {
    var s;
    e.values && !_i(e.values, n.current) ? (a._reset(e.values, {
      keepFieldsRef: !0,
      ...a._options.resetOptions
    }), !((s = a._options.resetOptions) === null || s === void 0) && s.keepIsValid || a._setValid(), n.current = e.values, o((l) => ({ ...l }))) : a._resetDefaultValues();
  }, [a, e.values]), H.useEffect(() => {
    a._state.mount || (a._setValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
  }), t.current.formState = H.useMemo(() => LQ(i, a), [a, i]), t.current;
}
const oJ = fn(
  ({ className: e, ...t }, n) => /* @__PURE__ */ C.jsx(
    "input",
    {
      ref: n,
      ...t,
      className: Qn(
        "dark:bg-neutral-800 dark:text-neutral-200 bg-white text-black px-2 border-black border font-body",
        e
      )
    }
  )
), aJ = (e, t) => {
  const n = (r) => {
    e.current && !e.current.contains(r.target) && t();
  };
  Ee(() => (document.addEventListener("click", n), () => {
    document.removeEventListener("click", n);
  }));
};
function sJ(e, t, n = 250) {
  const [r, i] = Ve(0);
  return Ee(() => {
    const o = setTimeout(() => {
      i(0);
    }, n);
    return r === 2 && t(), () => clearTimeout(o);
  }, [r]), () => i((o) => o + 1);
}
var $c = "delete", Nt = 5, Dr = 1 << Nt, Kn = Dr - 1, ot = {};
function Vg() {
  return { value: !1 };
}
function Ar(e) {
  e && (e.value = !0);
}
function p0() {
}
function Bs(e) {
  return e.size === void 0 && (e.size = e.__iterate(AA)), e.size;
}
function Ao(e, t) {
  if (typeof t != "number") {
    var n = t >>> 0;
    if ("" + n !== t || n === 4294967295)
      return NaN;
    t = n;
  }
  return t < 0 ? Bs(e) + t : t;
}
function AA() {
  return !0;
}
function Jp(e, t, n) {
  return (e === 0 && !IA(e) || n !== void 0 && e <= -n) && (t === void 0 || n !== void 0 && t >= n);
}
function Tc(e, t) {
  return CA(e, t, 0);
}
function Xp(e, t) {
  return CA(e, t, t);
}
function CA(e, t, n) {
  return e === void 0 ? n : IA(e) ? t === 1 / 0 ? t : Math.max(0, t + e) | 0 : t === void 0 || t === e ? e : Math.min(t, e) | 0;
}
function IA(e) {
  return e < 0 || e === 0 && 1 / e === -1 / 0;
}
var NA = "@@__IMMUTABLE_ITERABLE__@@";
function tr(e) {
  return !!(e && e[NA]);
}
var RA = "@@__IMMUTABLE_KEYED__@@";
function zt(e) {
  return !!(e && e[RA]);
}
var MA = "@@__IMMUTABLE_INDEXED__@@";
function Yn(e) {
  return !!(e && e[MA]);
}
function eh(e) {
  return zt(e) || Yn(e);
}
var on = function(e) {
  return tr(e) ? e : vr(e);
}, Vr = /* @__PURE__ */ (function(e) {
  function t(n) {
    return zt(n) ? n : Ko(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
})(on), Ba = /* @__PURE__ */ (function(e) {
  function t(n) {
    return Yn(n) ? n : di(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
})(on), vl = /* @__PURE__ */ (function(e) {
  function t(n) {
    return tr(n) && !eh(n) ? n : bl(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
})(on);
on.Keyed = Vr;
on.Indexed = Ba;
on.Set = vl;
var jA = "@@__IMMUTABLE_SEQ__@@";
function h0(e) {
  return !!(e && e[jA]);
}
var FA = "@@__IMMUTABLE_RECORD__@@";
function ml(e) {
  return !!(e && e[FA]);
}
function Ci(e) {
  return tr(e) || ml(e);
}
var gl = "@@__IMMUTABLE_ORDERED__@@";
function ii(e) {
  return !!(e && e[gl]);
}
var Pc = 0, ai = 1, jr = 2, Kg = typeof Symbol == "function" && Symbol.iterator, zA = "@@iterator", th = Kg || zA, vt = function(e) {
  this.next = e;
};
vt.prototype.toString = function() {
  return "[Iterator]";
};
vt.KEYS = Pc;
vt.VALUES = ai;
vt.ENTRIES = jr;
vt.prototype.inspect = vt.prototype.toSource = function() {
  return this.toString();
};
vt.prototype[th] = function() {
  return this;
};
function Kt(e, t, n, r) {
  var i = e === 0 ? t : e === 1 ? n : [t, n];
  return r ? r.value = i : r = {
    value: i,
    done: !1
  }, r;
}
function nr() {
  return { value: void 0, done: !0 };
}
function LA(e) {
  return Array.isArray(e) ? !0 : !!nh(e);
}
function vS(e) {
  return e && typeof e.next == "function";
}
function Bg(e) {
  var t = nh(e);
  return t && t.call(e);
}
function nh(e) {
  var t = e && (Kg && e[Kg] || e[zA]);
  if (typeof t == "function")
    return t;
}
function lJ(e) {
  var t = nh(e);
  return t && t === e.entries;
}
function uJ(e) {
  var t = nh(e);
  return t && t === e.keys;
}
var yl = Object.prototype.hasOwnProperty;
function VA(e) {
  return Array.isArray(e) || typeof e == "string" ? !0 : e && typeof e == "object" && Number.isInteger(e.length) && e.length >= 0 && (e.length === 0 ? Object.keys(e).length === 1 : e.hasOwnProperty(e.length - 1));
}
var vr = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? m0() : Ci(n) ? n.toSeq() : fJ(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toSeq = function() {
    return this;
  }, t.prototype.toString = function() {
    return this.__toString("Seq {", "}");
  }, t.prototype.cacheResult = function() {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, t.prototype.__iterate = function(n, r) {
    var i = this._cache;
    if (i) {
      for (var o = i.length, a = 0; a !== o; ) {
        var s = i[r ? o - ++a : a++];
        if (n(s[1], s[0], this) === !1)
          break;
      }
      return a;
    }
    return this.__iterateUncached(n, r);
  }, t.prototype.__iterator = function(n, r) {
    var i = this._cache;
    if (i) {
      var o = i.length, a = 0;
      return new vt(function() {
        if (a === o)
          return nr();
        var s = i[r ? o - ++a : a++];
        return Kt(n, s[0], s[1]);
      });
    }
    return this.__iteratorUncached(n, r);
  }, t;
})(on), Ko = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? m0().toKeyedSeq() : tr(n) ? zt(n) ? n.toSeq() : n.fromEntrySeq() : ml(n) ? n.toSeq() : g0(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toKeyedSeq = function() {
    return this;
  }, t;
})(vr), di = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? m0() : tr(n) ? zt(n) ? n.entrySeq() : n.toIndexedSeq() : ml(n) ? n.toSeq().entrySeq() : KA(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return t(arguments);
  }, t.prototype.toIndexedSeq = function() {
    return this;
  }, t.prototype.toString = function() {
    return this.__toString("Seq [", "]");
  }, t;
})(vr), bl = /* @__PURE__ */ (function(e) {
  function t(n) {
    return (tr(n) && !eh(n) ? n : di(n)).toSetSeq();
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return t(arguments);
  }, t.prototype.toSetSeq = function() {
    return this;
  }, t;
})(vr);
vr.isSeq = h0;
vr.Keyed = Ko;
vr.Set = bl;
vr.Indexed = di;
vr.prototype[jA] = !0;
var Pa = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._array = n, this.size = n.length;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, r) {
    return this.has(n) ? this._array[Ao(this, n)] : r;
  }, t.prototype.__iterate = function(n, r) {
    for (var i = this._array, o = i.length, a = 0; a !== o; ) {
      var s = r ? o - ++a : a++;
      if (n(i[s], s, this) === !1)
        break;
    }
    return a;
  }, t.prototype.__iterator = function(n, r) {
    var i = this._array, o = i.length, a = 0;
    return new vt(function() {
      if (a === o)
        return nr();
      var s = r ? o - ++a : a++;
      return Kt(n, s, i[s]);
    });
  }, t;
})(di), v0 = /* @__PURE__ */ (function(e) {
  function t(n) {
    var r = Object.keys(n).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(n) : []
    );
    this._object = n, this._keys = r, this.size = r.length;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, r) {
    return r !== void 0 && !this.has(n) ? r : this._object[n];
  }, t.prototype.has = function(n) {
    return yl.call(this._object, n);
  }, t.prototype.__iterate = function(n, r) {
    for (var i = this._object, o = this._keys, a = o.length, s = 0; s !== a; ) {
      var l = o[r ? a - ++s : s++];
      if (n(i[l], l, this) === !1)
        break;
    }
    return s;
  }, t.prototype.__iterator = function(n, r) {
    var i = this._object, o = this._keys, a = o.length, s = 0;
    return new vt(function() {
      if (s === a)
        return nr();
      var l = o[r ? a - ++s : s++];
      return Kt(n, l, i[l]);
    });
  }, t;
})(Ko);
v0.prototype[gl] = !0;
var cJ = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._collection = n, this.size = n.length || n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.__iterateUncached = function(n, r) {
    if (r)
      return this.cacheResult().__iterate(n, r);
    var i = this._collection, o = Bg(i), a = 0;
    if (vS(o))
      for (var s; !(s = o.next()).done && n(s.value, a++, this) !== !1; )
        ;
    return a;
  }, t.prototype.__iteratorUncached = function(n, r) {
    if (r)
      return this.cacheResult().__iterator(n, r);
    var i = this._collection, o = Bg(i);
    if (!vS(o))
      return new vt(nr);
    var a = 0;
    return new vt(function() {
      var s = o.next();
      return s.done ? s : Kt(n, a++, s.value);
    });
  }, t;
})(di), mS;
function m0() {
  return mS || (mS = new Pa([]));
}
function g0(e) {
  var t = y0(e);
  if (t)
    return t.fromEntrySeq();
  if (typeof e == "object")
    return new v0(e);
  throw new TypeError(
    "Expected Array or collection object of [k, v] entries, or keyed object: " + e
  );
}
function KA(e) {
  var t = y0(e);
  if (t)
    return t;
  throw new TypeError(
    "Expected Array or collection object of values: " + e
  );
}
function fJ(e) {
  var t = y0(e);
  if (t)
    return lJ(e) ? t.fromEntrySeq() : uJ(e) ? t.toSetSeq() : t;
  if (typeof e == "object")
    return new v0(e);
  throw new TypeError(
    "Expected Array or collection object of values, or keyed object: " + e
  );
}
function y0(e) {
  return VA(e) ? new Pa(e) : LA(e) ? new cJ(e) : void 0;
}
var BA = "@@__IMMUTABLE_MAP__@@";
function b0(e) {
  return !!(e && e[BA]);
}
function UA(e) {
  return b0(e) && ii(e);
}
function gS(e) {
  return !!(e && typeof e.equals == "function" && typeof e.hashCode == "function");
}
function cr(e, t) {
  if (e === t || e !== e && t !== t)
    return !0;
  if (!e || !t)
    return !1;
  if (typeof e.valueOf == "function" && typeof t.valueOf == "function") {
    if (e = e.valueOf(), t = t.valueOf(), e === t || e !== e && t !== t)
      return !0;
    if (!e || !t)
      return !1;
  }
  return !!(gS(e) && gS(t) && e.equals(t));
}
var Kl = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(e, t) {
  e |= 0, t |= 0;
  var n = e & 65535, r = t & 65535;
  return n * r + ((e >>> 16) * r + n * (t >>> 16) << 16 >>> 0) | 0;
};
function rh(e) {
  return e >>> 1 & 1073741824 | e & 3221225471;
}
var dJ = Object.prototype.valueOf;
function ar(e) {
  if (e == null)
    return yS(e);
  if (typeof e.hashCode == "function")
    return rh(e.hashCode(e));
  var t = yJ(e);
  if (t == null)
    return yS(t);
  switch (typeof t) {
    case "boolean":
      return t ? 1108378657 : 1108378656;
    case "number":
      return pJ(t);
    case "string":
      return t.length > bJ ? hJ(t) : Ug(t);
    case "object":
    case "function":
      return mJ(t);
    case "symbol":
      return vJ(t);
    default:
      if (typeof t.toString == "function")
        return Ug(t.toString());
      throw new Error("Value type " + typeof t + " cannot be hashed.");
  }
}
function yS(e) {
  return e === null ? 1108378658 : 1108378659;
}
function pJ(e) {
  if (e !== e || e === 1 / 0)
    return 0;
  var t = e | 0;
  for (t !== e && (t ^= e * 4294967295); e > 4294967295; )
    e /= 4294967295, t ^= e;
  return rh(t);
}
function hJ(e) {
  var t = Iv[e];
  return t === void 0 && (t = Ug(e), Cv === _J && (Cv = 0, Iv = {}), Cv++, Iv[e] = t), t;
}
function Ug(e) {
  for (var t = 0, n = 0; n < e.length; n++)
    t = 31 * t + e.charCodeAt(n) | 0;
  return rh(t);
}
function vJ(e) {
  var t = wS[e];
  return t !== void 0 || (t = qA(), wS[e] = t), t;
}
function mJ(e) {
  var t;
  if (qg && (t = Hg.get(e), t !== void 0) || (t = e[na], t !== void 0) || !_S && (t = e.propertyIsEnumerable && e.propertyIsEnumerable[na], t !== void 0 || (t = gJ(e), t !== void 0)))
    return t;
  if (t = qA(), qg)
    Hg.set(e, t);
  else {
    if (bS !== void 0 && bS(e) === !1)
      throw new Error("Non-extensible objects are not allowed as keys.");
    if (_S)
      Object.defineProperty(e, na, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: t
      });
    else if (e.propertyIsEnumerable !== void 0 && e.propertyIsEnumerable === e.constructor.prototype.propertyIsEnumerable)
      e.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(
          this,
          arguments
        );
      }, e.propertyIsEnumerable[na] = t;
    else if (e.nodeType !== void 0)
      e[na] = t;
    else
      throw new Error("Unable to set a non-enumerable property on object.");
  }
  return t;
}
var bS = Object.isExtensible, _S = (function() {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch {
    return !1;
  }
})();
function gJ(e) {
  if (e && e.nodeType > 0)
    switch (e.nodeType) {
      case 1:
        return e.uniqueID;
      case 9:
        return e.documentElement && e.documentElement.uniqueID;
    }
}
function yJ(e) {
  return e.valueOf !== dJ && typeof e.valueOf == "function" ? e.valueOf(e) : e;
}
function qA() {
  var e = ++Av;
  return Av & 1073741824 && (Av = 0), e;
}
var qg = typeof WeakMap == "function", Hg;
qg && (Hg = /* @__PURE__ */ new WeakMap());
var wS = /* @__PURE__ */ Object.create(null), Av = 0, na = "__immutablehash__";
typeof Symbol == "function" && (na = Symbol(na));
var bJ = 16, _J = 255, Cv = 0, Iv = {}, ih = /* @__PURE__ */ (function(e) {
  function t(n, r) {
    this._iter = n, this._useKeys = r, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, r) {
    return this._iter.get(n, r);
  }, t.prototype.has = function(n) {
    return this._iter.has(n);
  }, t.prototype.valueSeq = function() {
    return this._iter.valueSeq();
  }, t.prototype.reverse = function() {
    var n = this, r = _0(this, !0);
    return this._useKeys || (r.valueSeq = function() {
      return n._iter.toSeq().reverse();
    }), r;
  }, t.prototype.map = function(n, r) {
    var i = this, o = YA(this, n, r);
    return this._useKeys || (o.valueSeq = function() {
      return i._iter.toSeq().map(n, r);
    }), o;
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._iter.__iterate(function(o, a) {
      return n(o, a, i);
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    return this._iter.__iterator(n, r);
  }, t;
})(Ko);
ih.prototype[gl] = !0;
var HA = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._iter = n, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.includes = function(n) {
    return this._iter.includes(n);
  }, t.prototype.__iterate = function(n, r) {
    var i = this, o = 0;
    return r && Bs(this), this._iter.__iterate(
      function(a) {
        return n(a, r ? i.size - ++o : o++, i);
      },
      r
    );
  }, t.prototype.__iterator = function(n, r) {
    var i = this, o = this._iter.__iterator(ai, r), a = 0;
    return r && Bs(this), new vt(function() {
      var s = o.next();
      return s.done ? s : Kt(
        n,
        r ? i.size - ++a : a++,
        s.value,
        s
      );
    });
  }, t;
})(di), WA = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._iter = n, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.has = function(n) {
    return this._iter.includes(n);
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._iter.__iterate(function(o) {
      return n(o, o, i);
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    var i = this._iter.__iterator(ai, r);
    return new vt(function() {
      var o = i.next();
      return o.done ? o : Kt(n, o.value, o.value, o);
    });
  }, t;
})(bl), ZA = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._iter = n, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.entrySeq = function() {
    return this._iter.toSeq();
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._iter.__iterate(function(o) {
      if (o) {
        ES(o);
        var a = tr(o);
        return n(
          a ? o.get(1) : o[1],
          a ? o.get(0) : o[0],
          i
        );
      }
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    var i = this._iter.__iterator(ai, r);
    return new vt(function() {
      for (; ; ) {
        var o = i.next();
        if (o.done)
          return o;
        var a = o.value;
        if (a) {
          ES(a);
          var s = tr(a);
          return Kt(
            n,
            s ? a.get(0) : a[0],
            s ? a.get(1) : a[1],
            o
          );
        }
      }
    });
  }, t;
})(Ko);
HA.prototype.cacheResult = ih.prototype.cacheResult = WA.prototype.cacheResult = ZA.prototype.cacheResult = E0;
function GA(e) {
  var t = Ii(e);
  return t._iter = e, t.size = e.size, t.flip = function() {
    return e;
  }, t.reverse = function() {
    var n = e.reverse.apply(this);
    return n.flip = function() {
      return e.reverse();
    }, n;
  }, t.has = function(n) {
    return e.includes(n);
  }, t.includes = function(n) {
    return e.has(n);
  }, t.cacheResult = E0, t.__iterateUncached = function(n, r) {
    var i = this;
    return e.__iterate(function(o, a) {
      return n(a, o, i) !== !1;
    }, r);
  }, t.__iteratorUncached = function(n, r) {
    if (n === jr) {
      var i = e.__iterator(n, r);
      return new vt(function() {
        var o = i.next();
        if (!o.done) {
          var a = o.value[0];
          o.value[0] = o.value[1], o.value[1] = a;
        }
        return o;
      });
    }
    return e.__iterator(
      n === ai ? Pc : ai,
      r
    );
  }, t;
}
function YA(e, t, n) {
  var r = Ii(e);
  return r.size = e.size, r.has = function(i) {
    return e.has(i);
  }, r.get = function(i, o) {
    var a = e.get(i, ot);
    return a === ot ? o : t.call(n, a, i, e);
  }, r.__iterateUncached = function(i, o) {
    var a = this;
    return e.__iterate(
      function(s, l, u) {
        return i(t.call(n, s, l, u), l, a) !== !1;
      },
      o
    );
  }, r.__iteratorUncached = function(i, o) {
    var a = e.__iterator(jr, o);
    return new vt(function() {
      var s = a.next();
      if (s.done)
        return s;
      var l = s.value, u = l[0];
      return Kt(
        i,
        u,
        t.call(n, l[1], u, e),
        s
      );
    });
  }, r;
}
function _0(e, t) {
  var n = this, r = Ii(e);
  return r._iter = e, r.size = e.size, r.reverse = function() {
    return e;
  }, e.flip && (r.flip = function() {
    var i = GA(e);
    return i.reverse = function() {
      return e.flip();
    }, i;
  }), r.get = function(i, o) {
    return e.get(t ? i : -1 - i, o);
  }, r.has = function(i) {
    return e.has(t ? i : -1 - i);
  }, r.includes = function(i) {
    return e.includes(i);
  }, r.cacheResult = E0, r.__iterate = function(i, o) {
    var a = this, s = 0;
    return o && Bs(e), e.__iterate(
      function(l, u) {
        return i(l, t ? u : o ? a.size - ++s : s++, a);
      },
      !o
    );
  }, r.__iterator = function(i, o) {
    var a = 0;
    o && Bs(e);
    var s = e.__iterator(jr, !o);
    return new vt(function() {
      var l = s.next();
      if (l.done)
        return l;
      var u = l.value;
      return Kt(
        i,
        t ? u[0] : o ? n.size - ++a : a++,
        u[1],
        l
      );
    });
  }, r;
}
function QA(e, t, n, r) {
  var i = Ii(e);
  return r && (i.has = function(o) {
    var a = e.get(o, ot);
    return a !== ot && !!t.call(n, a, o, e);
  }, i.get = function(o, a) {
    var s = e.get(o, ot);
    return s !== ot && t.call(n, s, o, e) ? s : a;
  }), i.__iterateUncached = function(o, a) {
    var s = this, l = 0;
    return e.__iterate(function(u, c, f) {
      if (t.call(n, u, c, f))
        return l++, o(u, r ? c : l - 1, s);
    }, a), l;
  }, i.__iteratorUncached = function(o, a) {
    var s = e.__iterator(jr, a), l = 0;
    return new vt(function() {
      for (; ; ) {
        var u = s.next();
        if (u.done)
          return u;
        var c = u.value, f = c[0], d = c[1];
        if (t.call(n, d, f, e))
          return Kt(o, r ? f : l++, d, u);
      }
    });
  }, i;
}
function wJ(e, t, n) {
  var r = wl().asMutable();
  return e.__iterate(function(i, o) {
    r.update(t.call(n, i, o, e), 0, function(a) {
      return a + 1;
    });
  }), r.asImmutable();
}
function xJ(e, t, n) {
  var r = zt(e), i = (ii(e) ? Qi() : wl()).asMutable();
  e.__iterate(function(a, s) {
    i.update(
      t.call(n, a, s, e),
      function(l) {
        return l = l || [], l.push(r ? [s, a] : a), l;
      }
    );
  });
  var o = x0(e);
  return i.map(function(a) {
    return Et(e, o(a));
  }).asImmutable();
}
function EJ(e, t, n) {
  var r = zt(e), i = [[], []];
  e.__iterate(function(a, s) {
    i[t.call(n, a, s, e) ? 1 : 0].push(
      r ? [s, a] : a
    );
  });
  var o = x0(e);
  return i.map(function(a) {
    return Et(e, o(a));
  });
}
function w0(e, t, n, r) {
  var i = e.size;
  if (Jp(t, n, i))
    return e;
  if (typeof i > "u" && (t < 0 || n < 0))
    return w0(e.toSeq().cacheResult(), t, n, r);
  var o = Tc(t, i), a = Xp(n, i), s = a - o, l;
  s === s && (l = s < 0 ? 0 : s);
  var u = Ii(e);
  return u.size = l === 0 ? l : e.size && l || void 0, !r && h0(e) && l >= 0 && (u.get = function(c, f) {
    return c = Ao(this, c), c >= 0 && c < l ? e.get(c + o, f) : f;
  }), u.__iterateUncached = function(c, f) {
    var d = this;
    if (l === 0)
      return 0;
    if (f)
      return this.cacheResult().__iterate(c, f);
    var p = 0, h = !0, v = 0;
    return e.__iterate(function(m, g) {
      if (!(h && (h = p++ < o)))
        return v++, c(m, r ? g : v - 1, d) !== !1 && v !== l;
    }), v;
  }, u.__iteratorUncached = function(c, f) {
    if (l !== 0 && f)
      return this.cacheResult().__iterator(c, f);
    if (l === 0)
      return new vt(nr);
    var d = e.__iterator(c, f), p = 0, h = 0;
    return new vt(function() {
      for (; p++ < o; )
        d.next();
      if (++h > l)
        return nr();
      var v = d.next();
      return r || c === ai || v.done ? v : c === Pc ? Kt(c, h - 1, void 0, v) : Kt(c, h - 1, v.value[1], v);
    });
  }, u;
}
function SJ(e, t, n) {
  var r = Ii(e);
  return r.__iterateUncached = function(i, o) {
    var a = this;
    if (o)
      return this.cacheResult().__iterate(i, o);
    var s = 0;
    return e.__iterate(
      function(l, u, c) {
        return t.call(n, l, u, c) && ++s && i(l, u, a);
      }
    ), s;
  }, r.__iteratorUncached = function(i, o) {
    var a = this;
    if (o)
      return this.cacheResult().__iterator(i, o);
    var s = e.__iterator(jr, o), l = !0;
    return new vt(function() {
      if (!l)
        return nr();
      var u = s.next();
      if (u.done)
        return u;
      var c = u.value, f = c[0], d = c[1];
      return t.call(n, d, f, a) ? i === jr ? u : Kt(i, f, d, u) : (l = !1, nr());
    });
  }, r;
}
function JA(e, t, n, r) {
  var i = Ii(e);
  return i.__iterateUncached = function(o, a) {
    var s = this;
    if (a)
      return this.cacheResult().__iterate(o, a);
    var l = !0, u = 0;
    return e.__iterate(function(c, f, d) {
      if (!(l && (l = t.call(n, c, f, d))))
        return u++, o(c, r ? f : u - 1, s);
    }), u;
  }, i.__iteratorUncached = function(o, a) {
    var s = this;
    if (a)
      return this.cacheResult().__iterator(o, a);
    var l = e.__iterator(jr, a), u = !0, c = 0;
    return new vt(function() {
      var f, d, p;
      do {
        if (f = l.next(), f.done)
          return r || o === ai ? f : o === Pc ? Kt(o, c++, void 0, f) : Kt(o, c++, f.value[1], f);
        var h = f.value;
        d = h[0], p = h[1], u && (u = t.call(n, p, d, s));
      } while (u);
      return o === jr ? f : Kt(o, d, p, f);
    });
  }, i;
}
function OJ(e, t) {
  var n = zt(e), r = [e].concat(t).map(function(a) {
    return tr(a) ? n && (a = Vr(a)) : a = n ? g0(a) : KA(Array.isArray(a) ? a : [a]), a;
  }).filter(function(a) {
    return a.size !== 0;
  });
  if (r.length === 0)
    return e;
  if (r.length === 1) {
    var i = r[0];
    if (i === e || n && zt(i) || Yn(e) && Yn(i))
      return i;
  }
  var o = new Pa(r);
  return n ? o = o.toKeyedSeq() : Yn(e) || (o = o.toSetSeq()), o = o.flatten(!0), o.size = r.reduce(function(a, s) {
    if (a !== void 0) {
      var l = s.size;
      if (l !== void 0)
        return a + l;
    }
  }, 0), o;
}
function XA(e, t, n) {
  var r = Ii(e);
  return r.__iterateUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterate(i, o);
    var a = 0, s = !1;
    function l(u, c) {
      u.__iterate(function(f, d) {
        return (!t || c < t) && tr(f) ? l(f, c + 1) : (a++, i(f, n ? d : a - 1, r) === !1 && (s = !0)), !s;
      }, o);
    }
    return l(e, 0), a;
  }, r.__iteratorUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterator(i, o);
    var a = e.__iterator(i, o), s = [], l = 0;
    return new vt(function() {
      for (; a; ) {
        var u = a.next();
        if (u.done !== !1) {
          a = s.pop();
          continue;
        }
        var c = u.value;
        if (i === jr && (c = c[1]), (!t || s.length < t) && tr(c))
          s.push(a), a = c.__iterator(i, o);
        else
          return n ? u : Kt(i, l++, c, u);
      }
      return nr();
    });
  }, r;
}
function $J(e, t, n) {
  var r = x0(e);
  return e.toSeq().map(function(i, o) {
    return r(t.call(n, i, o, e));
  }).flatten(!0);
}
function TJ(e, t) {
  var n = Ii(e);
  return n.size = e.size && e.size * 2 - 1, n.__iterateUncached = function(r, i) {
    var o = this, a = 0;
    return e.__iterate(
      function(s) {
        return (!a || r(t, a++, o) !== !1) && r(s, a++, o) !== !1;
      },
      i
    ), a;
  }, n.__iteratorUncached = function(r, i) {
    var o = e.__iterator(ai, i), a = 0, s;
    return new vt(function() {
      return (!s || a % 2) && (s = o.next(), s.done) ? s : a % 2 ? Kt(r, a++, t) : Kt(r, a++, s.value, s);
    });
  }, n;
}
function Us(e, t, n) {
  t || (t = eC);
  var r = zt(e), i = 0, o = e.toSeq().map(function(a, s) {
    return [s, a, i++, n ? n(a, s, e) : a];
  }).valueSeq().toArray();
  return o.sort(function(a, s) {
    return t(a[3], s[3]) || a[2] - s[2];
  }).forEach(
    r ? function(a, s) {
      o[s].length = 2;
    } : function(a, s) {
      o[s] = a[1];
    }
  ), r ? Ko(o) : Yn(e) ? di(o) : bl(o);
}
function vf(e, t, n) {
  if (t || (t = eC), n) {
    var r = e.toSeq().map(function(i, o) {
      return [i, n(i, o, e)];
    }).reduce(function(i, o) {
      return xS(t, i[1], o[1]) ? o : i;
    });
    return r && r[0];
  }
  return e.reduce(function(i, o) {
    return xS(t, i, o) ? o : i;
  });
}
function xS(e, t, n) {
  var r = e(n, t);
  return r === 0 && n !== t && (n == null || n !== n) || r > 0;
}
function mf(e, t, n, r) {
  var i = Ii(e), o = new Pa(n).map(function(a) {
    return a.size;
  });
  return i.size = r ? o.max() : o.min(), i.__iterate = function(a, s) {
    for (var l = this.__iterator(ai, s), u, c = 0; !(u = l.next()).done && a(u.value, c++, this) !== !1; )
      ;
    return c;
  }, i.__iteratorUncached = function(a, s) {
    var l = n.map(
      function(f) {
        return f = on(f), Bg(s ? f.reverse() : f);
      }
    ), u = 0, c = !1;
    return new vt(function() {
      var f;
      return c || (f = l.map(function(d) {
        return d.next();
      }), c = r ? f.every(function(d) {
        return d.done;
      }) : f.some(function(d) {
        return d.done;
      })), c ? nr() : Kt(
        a,
        u++,
        t.apply(
          null,
          f.map(function(d) {
            return d.value;
          })
        )
      );
    });
  }, i;
}
function Et(e, t) {
  return e === t ? e : h0(e) ? t : e.constructor(t);
}
function ES(e) {
  if (e !== Object(e))
    throw new TypeError("Expected [K, V] tuple: " + e);
}
function x0(e) {
  return zt(e) ? Vr : Yn(e) ? Ba : vl;
}
function Ii(e) {
  return Object.create(
    (zt(e) ? Ko : Yn(e) ? di : bl).prototype
  );
}
function E0() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : vr.prototype.cacheResult.call(this);
}
function eC(e, t) {
  return e === void 0 && t === void 0 ? 0 : e === void 0 ? 1 : t === void 0 ? -1 : e > t ? 1 : e < t ? -1 : 0;
}
function xi(e, t) {
  t = t || 0;
  for (var n = Math.max(0, e.length - t), r = new Array(n), i = 0; i < n; i++)
    r[i] = e[i + t];
  return r;
}
function S0(e, t) {
  if (!e)
    throw new Error(t);
}
function ur(e) {
  S0(
    e !== 1 / 0,
    "Cannot perform this action with an infinite size."
  );
}
function tC(e) {
  if (VA(e) && typeof e != "string")
    return e;
  if (ii(e))
    return e.toArray();
  throw new TypeError(
    "Invalid keyPath: expected Ordered Collection or Array: " + e
  );
}
var PJ = Object.prototype.toString;
function kJ(e) {
  if (!e || typeof e != "object" || PJ.call(e) !== "[object Object]")
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var n = t, r = Object.getPrototypeOf(t); r !== null; )
    n = r, r = Object.getPrototypeOf(n);
  return n === t;
}
function Co(e) {
  return typeof e == "object" && (Ci(e) || Array.isArray(e) || kJ(e));
}
function Zu(e) {
  try {
    return typeof e == "string" ? JSON.stringify(e) : String(e);
  } catch {
    return JSON.stringify(e);
  }
}
function DJ(e, t) {
  return Ci(e) ? e.has(t) : Co(e) && yl.call(e, t);
}
function nC(e, t, n) {
  return Ci(e) ? e.get(t, n) : DJ(e, t) ? typeof e.get == "function" ? e.get(t) : e[t] : n;
}
function kc(e) {
  return typeof e == "string" && (e === "__proto__" || e === "constructor");
}
function qd(e) {
  if (Array.isArray(e))
    return xi(e);
  var t = {};
  for (var n in e)
    kc(n) || yl.call(e, n) && (t[n] = e[n]);
  return t;
}
function AJ(e, t) {
  if (!Co(e))
    throw new TypeError(
      "Cannot update non-data-structure value: " + e
    );
  if (Ci(e)) {
    if (!e.remove)
      throw new TypeError(
        "Cannot update immutable value without .remove() method: " + e
      );
    return e.remove(t);
  }
  if (!yl.call(e, t))
    return e;
  var n = qd(e);
  return Array.isArray(n) ? n.splice(t, 1) : delete n[t], n;
}
function CJ(e, t, n) {
  if (kc(t))
    return e;
  if (!Co(e))
    throw new TypeError(
      "Cannot update non-data-structure value: " + e
    );
  if (Ci(e)) {
    if (!e.set)
      throw new TypeError(
        "Cannot update immutable value without .set() method: " + e
      );
    return e.set(t, n);
  }
  if (yl.call(e, t) && n === e[t])
    return e;
  var r = qd(e);
  return r[t] = n, r;
}
function _l(e, t, n, r) {
  r || (r = n, n = void 0);
  var i = rC(
    Ci(e),
    e,
    tC(t),
    0,
    n,
    r
  );
  return i === ot ? n : i;
}
function rC(e, t, n, r, i, o) {
  var a = t === ot;
  if (r === n.length) {
    var s = a ? i : t, l = o(s);
    return l === s ? t : l;
  }
  if (!a && !Co(t))
    throw new TypeError(
      "Cannot update within non-data-structure value in path [" + n.slice(0, r).map(Zu) + "]: " + t
    );
  var u = n[r], c = a ? ot : nC(t, u, ot), f = rC(
    c === ot ? e : Ci(c),
    c,
    n,
    r + 1,
    i,
    o
  );
  return f === c ? t : f === ot ? AJ(t, u) : CJ(
    a ? e ? Jr() : {} : t,
    u,
    f
  );
}
function IJ(e, t, n) {
  return _l(e, t, ot, function() {
    return n;
  });
}
function O0(e, t) {
  return IJ(this, e, t);
}
function NJ(e, t) {
  return _l(e, t, function() {
    return ot;
  });
}
function $0(e) {
  return NJ(this, e);
}
function iC(e, t, n, r) {
  return _l(e, [t], n, r);
}
function T0(e, t, n) {
  return arguments.length === 1 ? e(this) : iC(this, e, t, n);
}
function P0(e, t, n) {
  return _l(this, e, t, n);
}
function oC() {
  for (var e = [], t = arguments.length; t--; )
    e[t] = arguments[t];
  return sC(this, e);
}
function aC(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  if (typeof e != "function")
    throw new TypeError("Invalid merger function: " + e);
  return sC(this, t, e);
}
function sC(e, t, n) {
  for (var r = [], i = 0; i < t.length; i++) {
    var o = Vr(t[i]);
    o.size !== 0 && r.push(o);
  }
  return r.length === 0 ? e : e.toSeq().size === 0 && !e.__ownerID && r.length === 1 ? e.constructor(r[0]) : e.withMutations(function(a) {
    for (var s = n ? function(u, c) {
      iC(
        a,
        c,
        ot,
        function(f) {
          return f === ot ? u : n(f, u, c);
        }
      );
    } : function(u, c) {
      a.set(c, u);
    }, l = 0; l < r.length; l++)
      r[l].forEach(s);
  });
}
function k0(e, t, n) {
  return D0(e, t, RJ(n));
}
function D0(e, t, n) {
  if (!Co(e))
    throw new TypeError(
      "Cannot merge into non-data-structure value: " + e
    );
  if (Ci(e))
    return typeof n == "function" && e.mergeWith ? e.mergeWith.apply(e, [n].concat(t)) : e.merge ? e.merge.apply(e, t) : e.concat.apply(e, t);
  for (var r = Array.isArray(e), i = e, o = r ? Ba : Vr, a = r ? function(l) {
    i === e && (i = qd(i)), i.push(l);
  } : function(l, u) {
    if (!kc(u)) {
      var c = yl.call(i, u), f = c && n ? n(i[u], l, u) : l;
      (!c || f !== i[u]) && (i === e && (i = qd(i)), i[u] = f);
    }
  }, s = 0; s < t.length; s++)
    o(t[s]).forEach(a);
  return i;
}
function RJ(e) {
  function t(n, r, i) {
    return Co(n) && Co(r) && MJ(n, r) ? D0(n, [r], t) : e ? e(n, r, i) : r;
  }
  return t;
}
function MJ(e, t) {
  var n = vr(e), r = vr(t);
  return Yn(n) === Yn(r) && zt(n) === zt(r);
}
function lC() {
  for (var e = [], t = arguments.length; t--; )
    e[t] = arguments[t];
  return k0(this, e);
}
function uC(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  return k0(this, t, e);
}
function A0(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  return _l(this, e, Jr(), function(r) {
    return D0(r, t);
  });
}
function C0(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  return _l(
    this,
    e,
    Jr(),
    function(r) {
      return k0(r, t);
    }
  );
}
function Dc(e) {
  var t = this.asMutable();
  return e(t), t.wasAltered() ? t.__ensureOwner(this.__ownerID) : this;
}
function Ac() {
  return this.__ownerID ? this : this.__ensureOwner(new p0());
}
function Cc() {
  return this.__ensureOwner();
}
function I0() {
  return this.__altered;
}
var wl = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Jr() : b0(n) && !ii(n) ? n : Jr().withMutations(function(r) {
      var i = e(n);
      ur(i.size), i.forEach(function(o, a) {
        return r.set(a, o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    return Jr().withMutations(function(i) {
      for (var o = 0; o < n.length; o += 2) {
        if (o + 1 >= n.length)
          throw new Error("Missing value for key: " + n[o]);
        i.set(n[o], n[o + 1]);
      }
    });
  }, t.prototype.toString = function() {
    return this.__toString("Map {", "}");
  }, t.prototype.get = function(n, r) {
    return this._root ? this._root.get(0, void 0, n, r) : r;
  }, t.prototype.set = function(n, r) {
    return $S(this, n, r);
  }, t.prototype.remove = function(n) {
    return $S(this, n, ot);
  }, t.prototype.deleteAll = function(n) {
    var r = on(n);
    return r.size === 0 ? this : this.withMutations(function(i) {
      r.forEach(function(o) {
        return i.remove(o);
      });
    });
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : Jr();
  }, t.prototype.sort = function(n) {
    return Qi(Us(this, n));
  }, t.prototype.sortBy = function(n, r) {
    return Qi(Us(this, r, n));
  }, t.prototype.map = function(n, r) {
    var i = this;
    return this.withMutations(function(o) {
      o.forEach(function(a, s) {
        o.set(s, n.call(r, a, s, i));
      });
    });
  }, t.prototype.__iterator = function(n, r) {
    return new jJ(this, n, r);
  }, t.prototype.__iterate = function(n, r) {
    var i = this, o = 0;
    return this._root && this._root.iterate(function(a) {
      return o++, n(a[1], a[0], i);
    }, r), o;
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? N0(this.size, this._root, n, this.__hash) : this.size === 0 ? Jr() : (this.__ownerID = n, this.__altered = !1, this);
  }, t;
})(Vr);
wl.isMap = b0;
var Mt = wl.prototype;
Mt[BA] = !0;
Mt[$c] = Mt.remove;
Mt.removeAll = Mt.deleteAll;
Mt.setIn = O0;
Mt.removeIn = Mt.deleteIn = $0;
Mt.update = T0;
Mt.updateIn = P0;
Mt.merge = Mt.concat = oC;
Mt.mergeWith = aC;
Mt.mergeDeep = lC;
Mt.mergeDeepWith = uC;
Mt.mergeIn = A0;
Mt.mergeDeepIn = C0;
Mt.withMutations = Dc;
Mt.wasAltered = I0;
Mt.asImmutable = Cc;
Mt["@@transducer/init"] = Mt.asMutable = Ac;
Mt["@@transducer/step"] = function(e, t) {
  return e.set(t[0], t[1]);
};
Mt["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
var Gu = function(e, t) {
  this.ownerID = e, this.entries = t;
};
Gu.prototype.get = function(e, t, n, r) {
  for (var i = this.entries, o = 0, a = i.length; o < a; o++)
    if (cr(n, i[o][0]))
      return i[o][1];
  return r;
};
Gu.prototype.update = function(e, t, n, r, i, o, a) {
  for (var s = i === ot, l = this.entries, u = 0, c = l.length; u < c && !cr(r, l[u][0]); u++)
    ;
  var f = u < c;
  if (f ? l[u][1] === i : s)
    return this;
  if (Ar(a), (s || !f) && Ar(o), !(s && l.length === 1)) {
    if (!f && !s && l.length >= BJ)
      return FJ(e, l, r, i);
    var d = e && e === this.ownerID, p = d ? l : xi(l);
    return f ? s ? u === c - 1 ? p.pop() : p[u] = p.pop() : p[u] = [r, i] : p.push([r, i]), d ? (this.entries = p, this) : new Gu(e, p);
  }
};
var qs = function(e, t, n) {
  this.ownerID = e, this.bitmap = t, this.nodes = n;
};
qs.prototype.get = function(e, t, n, r) {
  t === void 0 && (t = ar(n));
  var i = 1 << ((e === 0 ? t : t >>> e) & Kn), o = this.bitmap;
  return (o & i) === 0 ? r : this.nodes[cC(o & i - 1)].get(
    e + Nt,
    t,
    n,
    r
  );
};
qs.prototype.update = function(e, t, n, r, i, o, a) {
  n === void 0 && (n = ar(r));
  var s = (t === 0 ? n : n >>> t) & Kn, l = 1 << s, u = this.bitmap, c = (u & l) !== 0;
  if (!c && i === ot)
    return this;
  var f = cC(u & l - 1), d = this.nodes, p = c ? d[f] : void 0, h = R0(
    p,
    e,
    t + Nt,
    n,
    r,
    i,
    o,
    a
  );
  if (h === p)
    return this;
  if (!c && h && d.length >= UJ)
    return LJ(e, d, u, s, h);
  if (c && !h && d.length === 2 && TS(d[f ^ 1]))
    return d[f ^ 1];
  if (c && h && d.length === 1 && TS(h))
    return h;
  var v = e && e === this.ownerID, m = c ? h ? u : u ^ l : u | l, g = c ? h ? fC(d, f, h, v) : KJ(d, f, v) : VJ(d, f, h, v);
  return v ? (this.bitmap = m, this.nodes = g, this) : new qs(e, m, g);
};
var Yu = function(e, t, n) {
  this.ownerID = e, this.count = t, this.nodes = n;
};
Yu.prototype.get = function(e, t, n, r) {
  t === void 0 && (t = ar(n));
  var i = (e === 0 ? t : t >>> e) & Kn, o = this.nodes[i];
  return o ? o.get(e + Nt, t, n, r) : r;
};
Yu.prototype.update = function(e, t, n, r, i, o, a) {
  n === void 0 && (n = ar(r));
  var s = (t === 0 ? n : n >>> t) & Kn, l = i === ot, u = this.nodes, c = u[s];
  if (l && !c)
    return this;
  var f = R0(
    c,
    e,
    t + Nt,
    n,
    r,
    i,
    o,
    a
  );
  if (f === c)
    return this;
  var d = this.count;
  if (!c)
    d++;
  else if (!f && (d--, d < qJ))
    return zJ(e, u, d, s);
  var p = e && e === this.ownerID, h = fC(u, s, f, p);
  return p ? (this.count = d, this.nodes = h, this) : new Yu(e, d, h);
};
var Hs = function(e, t, n) {
  this.ownerID = e, this.keyHash = t, this.entries = n;
};
Hs.prototype.get = function(e, t, n, r) {
  for (var i = this.entries, o = 0, a = i.length; o < a; o++)
    if (cr(n, i[o][0]))
      return i[o][1];
  return r;
};
Hs.prototype.update = function(e, t, n, r, i, o, a) {
  n === void 0 && (n = ar(r));
  var s = i === ot;
  if (n !== this.keyHash)
    return s ? this : (Ar(a), Ar(o), M0(this, e, t, n, [r, i]));
  for (var l = this.entries, u = 0, c = l.length; u < c && !cr(r, l[u][0]); u++)
    ;
  var f = u < c;
  if (f ? l[u][1] === i : s)
    return this;
  if (Ar(a), (s || !f) && Ar(o), s && c === 2)
    return new Yi(e, this.keyHash, l[u ^ 1]);
  var d = e && e === this.ownerID, p = d ? l : xi(l);
  return f ? s ? u === c - 1 ? p.pop() : p[u] = p.pop() : p[u] = [r, i] : p.push([r, i]), d ? (this.entries = p, this) : new Hs(e, this.keyHash, p);
};
var Yi = function(e, t, n) {
  this.ownerID = e, this.keyHash = t, this.entry = n;
};
Yi.prototype.get = function(e, t, n, r) {
  return cr(n, this.entry[0]) ? this.entry[1] : r;
};
Yi.prototype.update = function(e, t, n, r, i, o, a) {
  var s = i === ot, l = cr(r, this.entry[0]);
  if (l ? i === this.entry[1] : s)
    return this;
  if (Ar(a), s) {
    Ar(o);
    return;
  }
  return l ? e && e === this.ownerID ? (this.entry[1] = i, this) : new Yi(e, this.keyHash, [r, i]) : (Ar(o), M0(this, e, t, ar(r), [r, i]));
};
Gu.prototype.iterate = Hs.prototype.iterate = function(e, t) {
  for (var n = this.entries, r = 0, i = n.length - 1; r <= i; r++)
    if (e(n[t ? i - r : r]) === !1)
      return !1;
};
qs.prototype.iterate = Yu.prototype.iterate = function(e, t) {
  for (var n = this.nodes, r = 0, i = n.length - 1; r <= i; r++) {
    var o = n[t ? i - r : r];
    if (o && o.iterate(e, t) === !1)
      return !1;
  }
};
Yi.prototype.iterate = function(e, t) {
  return e(this.entry);
};
var jJ = /* @__PURE__ */ (function(e) {
  function t(n, r, i) {
    this._type = r, this._reverse = i, this._stack = n._root && SS(n._root);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.next = function() {
    for (var n = this._type, r = this._stack; r; ) {
      var i = r.node, o = r.index++, a = void 0;
      if (i.entry) {
        if (o === 0)
          return Nv(n, i.entry);
      } else if (i.entries) {
        if (a = i.entries.length - 1, o <= a)
          return Nv(
            n,
            i.entries[this._reverse ? a - o : o]
          );
      } else if (a = i.nodes.length - 1, o <= a) {
        var s = i.nodes[this._reverse ? a - o : o];
        if (s) {
          if (s.entry)
            return Nv(n, s.entry);
          r = this._stack = SS(s, r);
        }
        continue;
      }
      r = this._stack = this._stack.__prev;
    }
    return nr();
  }, t;
})(vt);
function Nv(e, t) {
  return Kt(e, t[0], t[1]);
}
function SS(e, t) {
  return {
    node: e,
    index: 0,
    __prev: t
  };
}
function N0(e, t, n, r) {
  var i = Object.create(Mt);
  return i.size = e, i._root = t, i.__ownerID = n, i.__hash = r, i.__altered = !1, i;
}
var OS;
function Jr() {
  return OS || (OS = N0(0));
}
function $S(e, t, n) {
  var r, i;
  if (e._root) {
    var o = Vg(), a = Vg();
    if (r = R0(
      e._root,
      e.__ownerID,
      0,
      void 0,
      t,
      n,
      o,
      a
    ), !a.value)
      return e;
    i = e.size + (o.value ? n === ot ? -1 : 1 : 0);
  } else {
    if (n === ot)
      return e;
    i = 1, r = new Gu(e.__ownerID, [[t, n]]);
  }
  return e.__ownerID ? (e.size = i, e._root = r, e.__hash = void 0, e.__altered = !0, e) : r ? N0(i, r) : Jr();
}
function R0(e, t, n, r, i, o, a, s) {
  return e ? e.update(
    t,
    n,
    r,
    i,
    o,
    a,
    s
  ) : o === ot ? e : (Ar(s), Ar(a), new Yi(t, r, [i, o]));
}
function TS(e) {
  return e.constructor === Yi || e.constructor === Hs;
}
function M0(e, t, n, r, i) {
  if (e.keyHash === r)
    return new Hs(t, r, [e.entry, i]);
  var o = (n === 0 ? e.keyHash : e.keyHash >>> n) & Kn, a = (n === 0 ? r : r >>> n) & Kn, s, l = o === a ? [M0(e, t, n + Nt, r, i)] : (s = new Yi(t, r, i), o < a ? [e, s] : [s, e]);
  return new qs(t, 1 << o | 1 << a, l);
}
function FJ(e, t, n, r) {
  e || (e = new p0());
  for (var i = new Yi(e, ar(n), [n, r]), o = 0; o < t.length; o++) {
    var a = t[o];
    i = i.update(e, 0, void 0, a[0], a[1]);
  }
  return i;
}
function zJ(e, t, n, r) {
  for (var i = 0, o = 0, a = new Array(n), s = 0, l = 1, u = t.length; s < u; s++, l <<= 1) {
    var c = t[s];
    c !== void 0 && s !== r && (i |= l, a[o++] = c);
  }
  return new qs(e, i, a);
}
function LJ(e, t, n, r, i) {
  for (var o = 0, a = new Array(Dr), s = 0; n !== 0; s++, n >>>= 1)
    a[s] = n & 1 ? t[o++] : void 0;
  return a[r] = i, new Yu(e, o + 1, a);
}
function cC(e) {
  return e -= e >> 1 & 1431655765, e = (e & 858993459) + (e >> 2 & 858993459), e = e + (e >> 4) & 252645135, e += e >> 8, e += e >> 16, e & 127;
}
function fC(e, t, n, r) {
  var i = r ? e : xi(e);
  return i[t] = n, i;
}
function VJ(e, t, n, r) {
  var i = e.length + 1;
  if (r && t + 1 === i)
    return e[t] = n, e;
  for (var o = new Array(i), a = 0, s = 0; s < i; s++)
    s === t ? (o[s] = n, a = -1) : o[s] = e[s + a];
  return o;
}
function KJ(e, t, n) {
  var r = e.length - 1;
  if (n && t === r)
    return e.pop(), e;
  for (var i = new Array(r), o = 0, a = 0; a < r; a++)
    a === t && (o = 1), i[a] = e[a + o];
  return i;
}
var BJ = Dr / 4, UJ = Dr / 2, qJ = Dr / 4, dC = "@@__IMMUTABLE_LIST__@@";
function pC(e) {
  return !!(e && e[dC]);
}
var oh = /* @__PURE__ */ (function(e) {
  function t(n) {
    var r = Bf();
    if (n == null)
      return r;
    if (pC(n))
      return n;
    var i = e(n), o = i.size;
    return o === 0 ? r : (ur(o), o > 0 && o < Dr ? Qu(0, o, Nt, null, new So(i.toArray())) : r.withMutations(function(a) {
      a.setSize(o), i.forEach(function(s, l) {
        return a.set(l, s);
      });
    }));
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("List [", "]");
  }, t.prototype.get = function(n, r) {
    if (n = Ao(this, n), n >= 0 && n < this.size) {
      n += this._origin;
      var i = hC(this, n);
      return i && i.array[n & Kn];
    }
    return r;
  }, t.prototype.set = function(n, r) {
    return HJ(this, n, r);
  }, t.prototype.remove = function(n) {
    return this.has(n) ? n === 0 ? this.shift() : n === this.size - 1 ? this.pop() : this.splice(n, 1) : this;
  }, t.prototype.insert = function(n, r) {
    return this.splice(n, 0, r);
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = Nt, this._root = this._tail = this.__hash = void 0, this.__altered = !0, this) : Bf();
  }, t.prototype.push = function() {
    var n = arguments, r = this.size;
    return this.withMutations(function(i) {
      fo(i, 0, r + n.length);
      for (var o = 0; o < n.length; o++)
        i.set(r + o, n[o]);
    });
  }, t.prototype.pop = function() {
    return fo(this, 0, -1);
  }, t.prototype.unshift = function() {
    var n = arguments;
    return this.withMutations(function(r) {
      fo(r, -n.length);
      for (var i = 0; i < n.length; i++)
        r.set(i, n[i]);
    });
  }, t.prototype.shift = function() {
    return fo(this, 1);
  }, t.prototype.concat = function() {
    for (var n = arguments, r = [], i = 0; i < arguments.length; i++) {
      var o = n[i], a = e(
        typeof o != "string" && LA(o) ? o : [o]
      );
      a.size !== 0 && r.push(a);
    }
    return r.length === 0 ? this : this.size === 0 && !this.__ownerID && r.length === 1 ? this.constructor(r[0]) : this.withMutations(function(s) {
      r.forEach(function(l) {
        return l.forEach(function(u) {
          return s.push(u);
        });
      });
    });
  }, t.prototype.setSize = function(n) {
    return fo(this, 0, n);
  }, t.prototype.map = function(n, r) {
    var i = this;
    return this.withMutations(function(o) {
      for (var a = 0; a < i.size; a++)
        o.set(a, n.call(r, o.get(a), a, i));
    });
  }, t.prototype.slice = function(n, r) {
    var i = this.size;
    return Jp(n, r, i) ? this : fo(
      this,
      Tc(n, i),
      Xp(r, i)
    );
  }, t.prototype.__iterator = function(n, r) {
    var i = r ? this.size : 0, o = PS(this, r);
    return new vt(function() {
      var a = o();
      return a === bu ? nr() : Kt(n, r ? --i : i++, a);
    });
  }, t.prototype.__iterate = function(n, r) {
    for (var i = r ? this.size : 0, o = PS(this, r), a; (a = o()) !== bu && n(a, r ? --i : i++, this) !== !1; )
      ;
    return i;
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? Qu(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      n,
      this.__hash
    ) : this.size === 0 ? Bf() : (this.__ownerID = n, this.__altered = !1, this);
  }, t;
})(Ba);
oh.isList = pC;
var dn = oh.prototype;
dn[dC] = !0;
dn[$c] = dn.remove;
dn.merge = dn.concat;
dn.setIn = O0;
dn.deleteIn = dn.removeIn = $0;
dn.update = T0;
dn.updateIn = P0;
dn.mergeIn = A0;
dn.mergeDeepIn = C0;
dn.withMutations = Dc;
dn.wasAltered = I0;
dn.asImmutable = Cc;
dn["@@transducer/init"] = dn.asMutable = Ac;
dn["@@transducer/step"] = function(e, t) {
  return e.push(t);
};
dn["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
var So = function(e, t) {
  this.array = e, this.ownerID = t;
};
So.prototype.removeBefore = function(e, t, n) {
  if (n === t ? 1 << t : this.array.length === 0)
    return this;
  var r = n >>> t & Kn;
  if (r >= this.array.length)
    return new So([], e);
  var i = r === 0, o;
  if (t > 0) {
    var a = this.array[r];
    if (o = a && a.removeBefore(e, t - Nt, n), o === a && i)
      return this;
  }
  if (i && !o)
    return this;
  var s = Ws(this, e);
  if (!i)
    for (var l = 0; l < r; l++)
      s.array[l] = void 0;
  return o && (s.array[r] = o), s;
};
So.prototype.removeAfter = function(e, t, n) {
  if (n === (t ? 1 << t : 0) || this.array.length === 0)
    return this;
  var r = n - 1 >>> t & Kn;
  if (r >= this.array.length)
    return this;
  var i;
  if (t > 0) {
    var o = this.array[r];
    if (i = o && o.removeAfter(e, t - Nt, n), i === o && r === this.array.length - 1)
      return this;
  }
  var a = Ws(this, e);
  return a.array.splice(r + 1), i && (a.array[r] = i), a;
};
var bu = {};
function PS(e, t) {
  var n = e._origin, r = e._capacity, i = Ju(r), o = e._tail;
  return a(e._root, e._level, 0);
  function a(u, c, f) {
    return c === 0 ? s(u, f) : l(u, c, f);
  }
  function s(u, c) {
    var f = c === i ? o && o.array : u && u.array, d = c > n ? 0 : n - c, p = r - c;
    return p > Dr && (p = Dr), function() {
      if (d === p)
        return bu;
      var h = t ? --p : d++;
      return f && f[h];
    };
  }
  function l(u, c, f) {
    var d, p = u && u.array, h = f > n ? 0 : n - f >> c, v = (r - f >> c) + 1;
    return v > Dr && (v = Dr), function() {
      for (; ; ) {
        if (d) {
          var m = d();
          if (m !== bu)
            return m;
          d = null;
        }
        if (h === v)
          return bu;
        var g = t ? --v : h++;
        d = a(
          p && p[g],
          c - Nt,
          f + (g << c)
        );
      }
    };
  }
}
function Qu(e, t, n, r, i, o, a) {
  var s = Object.create(dn);
  return s.size = t - e, s._origin = e, s._capacity = t, s._level = n, s._root = r, s._tail = i, s.__ownerID = o, s.__hash = a, s.__altered = !1, s;
}
var kS;
function Bf() {
  return kS || (kS = Qu(0, 0, Nt));
}
function HJ(e, t, n) {
  if (t = Ao(e, t), t !== t)
    return e;
  if (t >= e.size || t < 0)
    return e.withMutations(function(a) {
      t < 0 ? fo(a, t).set(0, n) : fo(a, 0, t + 1).set(t, n);
    });
  t += e._origin;
  var r = e._tail, i = e._root, o = Vg();
  return t >= Ju(e._capacity) ? r = Wg(r, e.__ownerID, 0, t, n, o) : i = Wg(
    i,
    e.__ownerID,
    e._level,
    t,
    n,
    o
  ), o.value ? e.__ownerID ? (e._root = i, e._tail = r, e.__hash = void 0, e.__altered = !0, e) : Qu(e._origin, e._capacity, e._level, i, r) : e;
}
function Wg(e, t, n, r, i, o) {
  var a = r >>> n & Kn, s = e && a < e.array.length;
  if (!s && i === void 0)
    return e;
  var l;
  if (n > 0) {
    var u = e && e.array[a], c = Wg(
      u,
      t,
      n - Nt,
      r,
      i,
      o
    );
    return c === u ? e : (l = Ws(e, t), l.array[a] = c, l);
  }
  return s && e.array[a] === i ? e : (o && Ar(o), l = Ws(e, t), i === void 0 && a === l.array.length - 1 ? l.array.pop() : l.array[a] = i, l);
}
function Ws(e, t) {
  return t && e && t === e.ownerID ? e : new So(e ? e.array.slice() : [], t);
}
function hC(e, t) {
  if (t >= Ju(e._capacity))
    return e._tail;
  if (t < 1 << e._level + Nt) {
    for (var n = e._root, r = e._level; n && r > 0; )
      n = n.array[t >>> r & Kn], r -= Nt;
    return n;
  }
}
function fo(e, t, n) {
  t !== void 0 && (t |= 0), n !== void 0 && (n |= 0);
  var r = e.__ownerID || new p0(), i = e._origin, o = e._capacity, a = i + t, s = n === void 0 ? o : n < 0 ? o + n : i + n;
  if (a === i && s === o)
    return e;
  if (a >= s)
    return e.clear();
  for (var l = e._level, u = e._root, c = 0; a + c < 0; )
    u = new So(
      u && u.array.length ? [void 0, u] : [],
      r
    ), l += Nt, c += 1 << l;
  c && (a += c, i += c, s += c, o += c);
  for (var f = Ju(o), d = Ju(s); d >= 1 << l + Nt; )
    u = new So(
      u && u.array.length ? [u] : [],
      r
    ), l += Nt;
  var p = e._tail, h = d < f ? hC(e, s - 1) : d > f ? new So([], r) : p;
  if (p && d > f && a < o && p.array.length) {
    u = Ws(u, r);
    for (var v = u, m = l; m > Nt; m -= Nt) {
      var g = f >>> m & Kn;
      v = v.array[g] = Ws(v.array[g], r);
    }
    v.array[f >>> Nt & Kn] = p;
  }
  if (s < o && (h = h && h.removeAfter(r, 0, s)), a >= d)
    a -= d, s -= d, l = Nt, u = null, h = h && h.removeBefore(r, 0, a);
  else if (a > i || d < f) {
    for (c = 0; u; ) {
      var _ = a >>> l & Kn;
      if (_ !== d >>> l & Kn)
        break;
      _ && (c += (1 << l) * _), l -= Nt, u = u.array[_];
    }
    u && a > i && (u = u.removeBefore(r, l, a - c)), u && d < f && (u = u.removeAfter(
      r,
      l,
      d - c
    )), c && (a -= c, s -= c);
  }
  return e.__ownerID ? (e.size = s - a, e._origin = a, e._capacity = s, e._level = l, e._root = u, e._tail = h, e.__hash = void 0, e.__altered = !0, e) : Qu(a, s, l, u, h);
}
function Ju(e) {
  return e < Dr ? 0 : e - 1 >>> Nt << Nt;
}
var Qi = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Jl() : UA(n) ? n : Jl().withMutations(function(r) {
      var i = Vr(n);
      ur(i.size), i.forEach(function(o, a) {
        return r.set(a, o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("OrderedMap {", "}");
  }, t.prototype.get = function(n, r) {
    var i = this._map.get(n);
    return i !== void 0 ? this._list.get(i)[1] : r;
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this.__altered = !0, this) : Jl();
  }, t.prototype.set = function(n, r) {
    return AS(this, n, r);
  }, t.prototype.remove = function(n) {
    return AS(this, n, ot);
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._list.__iterate(
      function(o) {
        return o && n(o[1], o[0], i);
      },
      r
    );
  }, t.prototype.__iterator = function(n, r) {
    return this._list.fromEntrySeq().__iterator(n, r);
  }, t.prototype.__ensureOwner = function(n) {
    if (n === this.__ownerID)
      return this;
    var r = this._map.__ensureOwner(n), i = this._list.__ensureOwner(n);
    return n ? j0(r, i, n, this.__hash) : this.size === 0 ? Jl() : (this.__ownerID = n, this.__altered = !1, this._map = r, this._list = i, this);
  }, t;
})(wl);
Qi.isOrderedMap = UA;
Qi.prototype[gl] = !0;
Qi.prototype[$c] = Qi.prototype.remove;
function j0(e, t, n, r) {
  var i = Object.create(Qi.prototype);
  return i.size = e ? e.size : 0, i._map = e, i._list = t, i.__ownerID = n, i.__hash = r, i.__altered = !1, i;
}
var DS;
function Jl() {
  return DS || (DS = j0(Jr(), Bf()));
}
function AS(e, t, n) {
  var r = e._map, i = e._list, o = r.get(t), a = o !== void 0, s, l;
  if (n === ot) {
    if (!a)
      return e;
    i.size >= Dr && i.size >= r.size * 2 ? (l = i.filter(function(u, c) {
      return u !== void 0 && o !== c;
    }), s = l.toKeyedSeq().map(function(u) {
      return u[0];
    }).flip().toMap(), e.__ownerID && (s.__ownerID = l.__ownerID = e.__ownerID)) : (s = r.remove(t), l = o === i.size - 1 ? i.pop() : i.set(o, void 0));
  } else if (a) {
    if (n === i.get(o)[1])
      return e;
    s = r, l = i.set(o, [t, n]);
  } else
    s = r.set(t, i.size), l = i.set(i.size, [t, n]);
  return e.__ownerID ? (e.size = s.size, e._map = s, e._list = l, e.__hash = void 0, e.__altered = !0, e) : j0(s, l);
}
var vC = "@@__IMMUTABLE_STACK__@@";
function Zg(e) {
  return !!(e && e[vC]);
}
var F0 = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? gf() : Zg(n) ? n : gf().pushAll(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("Stack [", "]");
  }, t.prototype.get = function(n, r) {
    var i = this._head;
    for (n = Ao(this, n); i && n--; )
      i = i.next;
    return i ? i.value : r;
  }, t.prototype.peek = function() {
    return this._head && this._head.value;
  }, t.prototype.push = function() {
    var n = arguments;
    if (arguments.length === 0)
      return this;
    for (var r = this.size + arguments.length, i = this._head, o = arguments.length - 1; o >= 0; o--)
      i = {
        value: n[o],
        next: i
      };
    return this.__ownerID ? (this.size = r, this._head = i, this.__hash = void 0, this.__altered = !0, this) : Xl(r, i);
  }, t.prototype.pushAll = function(n) {
    if (n = e(n), n.size === 0)
      return this;
    if (this.size === 0 && Zg(n))
      return n;
    ur(n.size);
    var r = this.size, i = this._head;
    return n.__iterate(function(o) {
      r++, i = {
        value: o,
        next: i
      };
    }, !0), this.__ownerID ? (this.size = r, this._head = i, this.__hash = void 0, this.__altered = !0, this) : Xl(r, i);
  }, t.prototype.pop = function() {
    return this.slice(1);
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : gf();
  }, t.prototype.slice = function(n, r) {
    if (Jp(n, r, this.size))
      return this;
    var i = Tc(n, this.size), o = Xp(r, this.size);
    if (o !== this.size)
      return e.prototype.slice.call(this, n, r);
    for (var a = this.size - i, s = this._head; i--; )
      s = s.next;
    return this.__ownerID ? (this.size = a, this._head = s, this.__hash = void 0, this.__altered = !0, this) : Xl(a, s);
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? Xl(this.size, this._head, n, this.__hash) : this.size === 0 ? gf() : (this.__ownerID = n, this.__altered = !1, this);
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    if (r)
      return new Pa(this.toArray()).__iterate(
        function(s, l) {
          return n(s, l, i);
        },
        r
      );
    for (var o = 0, a = this._head; a && n(a.value, o++, this) !== !1; )
      a = a.next;
    return o;
  }, t.prototype.__iterator = function(n, r) {
    if (r)
      return new Pa(this.toArray()).__iterator(n, r);
    var i = 0, o = this._head;
    return new vt(function() {
      if (o) {
        var a = o.value;
        return o = o.next, Kt(n, i++, a);
      }
      return nr();
    });
  }, t;
})(Ba);
F0.isStack = Zg;
var Un = F0.prototype;
Un[vC] = !0;
Un.shift = Un.pop;
Un.unshift = Un.push;
Un.unshiftAll = Un.pushAll;
Un.withMutations = Dc;
Un.wasAltered = I0;
Un.asImmutable = Cc;
Un["@@transducer/init"] = Un.asMutable = Ac;
Un["@@transducer/step"] = function(e, t) {
  return e.unshift(t);
};
Un["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
function Xl(e, t, n, r) {
  var i = Object.create(Un);
  return i.size = e, i._head = t, i.__ownerID = n, i.__hash = r, i.__altered = !1, i;
}
var CS;
function gf() {
  return CS || (CS = Xl(0));
}
var mC = "@@__IMMUTABLE_SET__@@";
function z0(e) {
  return !!(e && e[mC]);
}
function gC(e) {
  return z0(e) && ii(e);
}
function yC(e, t) {
  if (e === t)
    return !0;
  if (!tr(t) || e.size !== void 0 && t.size !== void 0 && e.size !== t.size || e.__hash !== void 0 && t.__hash !== void 0 && e.__hash !== t.__hash || zt(e) !== zt(t) || Yn(e) !== Yn(t) || ii(e) !== ii(t))
    return !1;
  if (e.size === 0 && t.size === 0)
    return !0;
  var n = !eh(e);
  if (ii(e)) {
    var r = e.entries();
    return t.every(function(l, u) {
      var c = r.next().value;
      return c && cr(c[1], l) && (n || cr(c[0], u));
    }) && r.next().done;
  }
  var i = !1;
  if (e.size === void 0)
    if (t.size === void 0)
      typeof e.cacheResult == "function" && e.cacheResult();
    else {
      i = !0;
      var o = e;
      e = t, t = o;
    }
  var a = !0, s = t.__iterate(function(l, u) {
    if (n ? !e.has(l) : i ? !cr(l, e.get(u, ot)) : !cr(e.get(u, ot), l))
      return a = !1, !1;
  });
  return a && e.size === s;
}
function Ua(e, t) {
  var n = function(r) {
    e.prototype[r] = t[r];
  };
  return Object.keys(t).forEach(n), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(t).forEach(n), e;
}
function Hd(e) {
  if (!e || typeof e != "object")
    return e;
  if (!tr(e)) {
    if (!Co(e))
      return e;
    e = vr(e);
  }
  if (zt(e)) {
    var t = {};
    return e.__iterate(function(r, i) {
      kc(i) || (t[i] = Hd(r));
    }), t;
  }
  var n = [];
  return e.__iterate(function(r) {
    n.push(Hd(r));
  }), n;
}
var ah = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? eu() : z0(n) && !ii(n) ? n : eu().withMutations(function(r) {
      var i = e(n);
      ur(i.size), i.forEach(function(o) {
        return r.add(o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.fromKeys = function(n) {
    return this(Vr(n).keySeq());
  }, t.intersect = function(n) {
    return n = on(n).toArray(), n.length ? On.intersect.apply(t(n.pop()), n) : eu();
  }, t.union = function(n) {
    return n = on(n).toArray(), n.length ? On.union.apply(t(n.pop()), n) : eu();
  }, t.prototype.toString = function() {
    return this.__toString("Set {", "}");
  }, t.prototype.has = function(n) {
    return this._map.has(n);
  }, t.prototype.add = function(n) {
    return yf(this, this._map.set(n, n));
  }, t.prototype.remove = function(n) {
    return yf(this, this._map.remove(n));
  }, t.prototype.clear = function() {
    return yf(this, this._map.clear());
  }, t.prototype.map = function(n, r) {
    var i = this, o = !1, a = yf(
      this,
      this._map.mapEntries(function(s) {
        var l = s[1], u = n.call(r, l, l, i);
        return u !== l && (o = !0), [u, u];
      }, r)
    );
    return o ? a : this;
  }, t.prototype.union = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    return n = n.filter(function(i) {
      return i.size !== 0;
    }), n.length === 0 ? this : this.size === 0 && !this.__ownerID && n.length === 1 ? this.constructor(n[0]) : this.withMutations(function(i) {
      for (var o = 0; o < n.length; o++)
        typeof n[o] == "string" ? i.add(n[o]) : e(n[o]).forEach(function(a) {
          return i.add(a);
        });
    });
  }, t.prototype.intersect = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    if (n.length === 0)
      return this;
    n = n.map(function(o) {
      return e(o);
    });
    var i = [];
    return this.forEach(function(o) {
      n.every(function(a) {
        return a.includes(o);
      }) || i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(a) {
        o.remove(a);
      });
    });
  }, t.prototype.subtract = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    if (n.length === 0)
      return this;
    n = n.map(function(o) {
      return e(o);
    });
    var i = [];
    return this.forEach(function(o) {
      n.some(function(a) {
        return a.includes(o);
      }) && i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(a) {
        o.remove(a);
      });
    });
  }, t.prototype.sort = function(n) {
    return Xu(Us(this, n));
  }, t.prototype.sortBy = function(n, r) {
    return Xu(Us(this, r, n));
  }, t.prototype.wasAltered = function() {
    return this._map.wasAltered();
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._map.__iterate(function(o) {
      return n(o, o, i);
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    return this._map.__iterator(n, r);
  }, t.prototype.__ensureOwner = function(n) {
    if (n === this.__ownerID)
      return this;
    var r = this._map.__ensureOwner(n);
    return n ? this.__make(r, n) : this.size === 0 ? this.__empty() : (this.__ownerID = n, this._map = r, this);
  }, t;
})(vl);
ah.isSet = z0;
var On = ah.prototype;
On[mC] = !0;
On[$c] = On.remove;
On.merge = On.concat = On.union;
On.withMutations = Dc;
On.asImmutable = Cc;
On["@@transducer/init"] = On.asMutable = Ac;
On["@@transducer/step"] = function(e, t) {
  return e.add(t);
};
On["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
On.__empty = eu;
On.__make = bC;
function yf(e, t) {
  return e.__ownerID ? (e.size = t.size, e._map = t, e) : t === e._map ? e : t.size === 0 ? e.__empty() : e.__make(t);
}
function bC(e, t) {
  var n = Object.create(On);
  return n.size = e ? e.size : 0, n._map = e, n.__ownerID = t, n;
}
var IS;
function eu() {
  return IS || (IS = bC(Jr()));
}
var WJ = /* @__PURE__ */ (function(e) {
  function t(n, r, i) {
    if (!(this instanceof t))
      return new t(n, r, i);
    if (S0(i !== 0, "Cannot step a Range by 0"), n = n || 0, r === void 0 && (r = 1 / 0), i = i === void 0 ? 1 : Math.abs(i), r < n && (i = -i), this._start = n, this._end = r, this._step = i, this.size = Math.max(0, Math.ceil((r - n) / i - 1) + 1), this.size === 0) {
      if (Rv)
        return Rv;
      Rv = this;
    }
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toString = function() {
    return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
  }, t.prototype.get = function(n, r) {
    return this.has(n) ? this._start + Ao(this, n) * this._step : r;
  }, t.prototype.includes = function(n) {
    var r = (n - this._start) / this._step;
    return r >= 0 && r < this.size && r === Math.floor(r);
  }, t.prototype.slice = function(n, r) {
    return Jp(n, r, this.size) ? this : (n = Tc(n, this.size), r = Xp(r, this.size), r <= n ? new t(0, 0) : new t(
      this.get(n, this._end),
      this.get(r, this._end),
      this._step
    ));
  }, t.prototype.indexOf = function(n) {
    var r = n - this._start;
    if (r % this._step === 0) {
      var i = r / this._step;
      if (i >= 0 && i < this.size)
        return i;
    }
    return -1;
  }, t.prototype.lastIndexOf = function(n) {
    return this.indexOf(n);
  }, t.prototype.__iterate = function(n, r) {
    for (var i = this.size, o = this._step, a = r ? this._start + (i - 1) * o : this._start, s = 0; s !== i && n(a, r ? i - ++s : s++, this) !== !1; )
      a += r ? -o : o;
    return s;
  }, t.prototype.__iterator = function(n, r) {
    var i = this.size, o = this._step, a = r ? this._start + (i - 1) * o : this._start, s = 0;
    return new vt(function() {
      if (s === i)
        return nr();
      var l = a;
      return a += r ? -o : o, Kt(n, r ? i - ++s : s++, l);
    });
  }, t.prototype.equals = function(n) {
    return n instanceof t ? this._start === n._start && this._end === n._end && this._step === n._step : yC(this, n);
  }, t;
})(di), Rv;
function _C(e, t, n) {
  for (var r = tC(t), i = 0; i !== r.length; )
    if (e = nC(e, r[i++], ot), e === ot)
      return n;
  return e;
}
function wC(e, t) {
  return _C(this, e, t);
}
function ZJ(e, t) {
  return _C(e, t, ot) !== ot;
}
function GJ(e) {
  return ZJ(this, e);
}
function xC() {
  ur(this.size);
  var e = {};
  return this.__iterate(function(t, n) {
    kc(n) || (e[n] = t);
  }), e;
}
on.isIterable = tr;
on.isKeyed = zt;
on.isIndexed = Yn;
on.isAssociative = eh;
on.isOrdered = ii;
on.Iterator = vt;
Ua(on, {
  toArray: function() {
    ur(this.size);
    var e = new Array(this.size || 0), t = zt(this), n = 0;
    return this.__iterate(function(r, i) {
      e[n++] = t ? [i, r] : r;
    }), e;
  },
  toIndexedSeq: function() {
    return new HA(this);
  },
  toJS: function() {
    return Hd(this);
  },
  toKeyedSeq: function() {
    return new ih(this, !0);
  },
  toMap: function() {
    return wl(this.toKeyedSeq());
  },
  toObject: xC,
  toOrderedMap: function() {
    return Qi(this.toKeyedSeq());
  },
  toOrderedSet: function() {
    return Xu(zt(this) ? this.valueSeq() : this);
  },
  toSet: function() {
    return ah(zt(this) ? this.valueSeq() : this);
  },
  toSetSeq: function() {
    return new WA(this);
  },
  toSeq: function() {
    return Yn(this) ? this.toIndexedSeq() : zt(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function() {
    return F0(zt(this) ? this.valueSeq() : this);
  },
  toList: function() {
    return oh(zt(this) ? this.valueSeq() : this);
  },
  toString: function() {
    return "[Collection]";
  },
  __toString: function(e, t) {
    return this.size === 0 ? e + t : e + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + t;
  },
  concat: function() {
    for (var e = [], t = arguments.length; t--; )
      e[t] = arguments[t];
    return Et(this, OJ(this, e));
  },
  includes: function(e) {
    return this.some(function(t) {
      return cr(t, e);
    });
  },
  entries: function() {
    return this.__iterator(jr);
  },
  every: function(e, t) {
    ur(this.size);
    var n = !0;
    return this.__iterate(function(r, i, o) {
      if (!e.call(t, r, i, o))
        return n = !1, !1;
    }), n;
  },
  filter: function(e, t) {
    return Et(this, QA(this, e, t, !0));
  },
  partition: function(e, t) {
    return EJ(this, e, t);
  },
  find: function(e, t, n) {
    var r = this.findEntry(e, t);
    return r ? r[1] : n;
  },
  forEach: function(e, t) {
    return ur(this.size), this.__iterate(t ? e.bind(t) : e);
  },
  join: function(e) {
    ur(this.size), e = e !== void 0 ? "" + e : ",";
    var t = "", n = !0;
    return this.__iterate(function(r) {
      n ? n = !1 : t += e, t += r != null ? r.toString() : "";
    }), t;
  },
  keys: function() {
    return this.__iterator(Pc);
  },
  map: function(e, t) {
    return Et(this, YA(this, e, t));
  },
  reduce: function(e, t, n) {
    return NS(
      this,
      e,
      t,
      n,
      arguments.length < 2,
      !1
    );
  },
  reduceRight: function(e, t, n) {
    return NS(
      this,
      e,
      t,
      n,
      arguments.length < 2,
      !0
    );
  },
  reverse: function() {
    return Et(this, _0(this, !0));
  },
  slice: function(e, t) {
    return Et(this, w0(this, e, t, !0));
  },
  some: function(e, t) {
    ur(this.size);
    var n = !1;
    return this.__iterate(function(r, i, o) {
      if (e.call(t, r, i, o))
        return n = !0, !1;
    }), n;
  },
  sort: function(e) {
    return Et(this, Us(this, e));
  },
  values: function() {
    return this.__iterator(ai);
  },
  butLast: function() {
    return this.slice(0, -1);
  },
  isEmpty: function() {
    return this.size !== void 0 ? this.size === 0 : !this.some(function() {
      return !0;
    });
  },
  count: function(e, t) {
    return Bs(
      e ? this.toSeq().filter(e, t) : this
    );
  },
  countBy: function(e, t) {
    return wJ(this, e, t);
  },
  equals: function(e) {
    return yC(this, e);
  },
  entrySeq: function() {
    var e = this;
    if (e._cache)
      return new Pa(e._cache);
    var t = e.toSeq().map(QJ).toIndexedSeq();
    return t.fromEntrySeq = function() {
      return e.toSeq();
    }, t;
  },
  filterNot: function(e, t) {
    return this.filter(Mv(e), t);
  },
  findEntry: function(e, t, n) {
    var r = n;
    return this.__iterate(function(i, o, a) {
      if (e.call(t, i, o, a))
        return r = [o, i], !1;
    }), r;
  },
  findKey: function(e, t) {
    var n = this.findEntry(e, t);
    return n && n[0];
  },
  findLast: function(e, t, n) {
    return this.toKeyedSeq().reverse().find(e, t, n);
  },
  findLastEntry: function(e, t, n) {
    return this.toKeyedSeq().reverse().findEntry(e, t, n);
  },
  findLastKey: function(e, t) {
    return this.toKeyedSeq().reverse().findKey(e, t);
  },
  first: function(e) {
    return this.find(AA, null, e);
  },
  flatMap: function(e, t) {
    return Et(this, $J(this, e, t));
  },
  flatten: function(e) {
    return Et(this, XA(this, e, !0));
  },
  fromEntrySeq: function() {
    return new ZA(this);
  },
  get: function(e, t) {
    return this.find(function(n, r) {
      return cr(r, e);
    }, void 0, t);
  },
  getIn: wC,
  groupBy: function(e, t) {
    return xJ(this, e, t);
  },
  has: function(e) {
    return this.get(e, ot) !== ot;
  },
  hasIn: GJ,
  isSubset: function(e) {
    return e = typeof e.includes == "function" ? e : on(e), this.every(function(t) {
      return e.includes(t);
    });
  },
  isSuperset: function(e) {
    return e = typeof e.isSubset == "function" ? e : on(e), e.isSubset(this);
  },
  keyOf: function(e) {
    return this.findKey(function(t) {
      return cr(t, e);
    });
  },
  keySeq: function() {
    return this.toSeq().map(YJ).toIndexedSeq();
  },
  last: function(e) {
    return this.toSeq().reverse().first(e);
  },
  lastKeyOf: function(e) {
    return this.toKeyedSeq().reverse().keyOf(e);
  },
  max: function(e) {
    return vf(this, e);
  },
  maxBy: function(e, t) {
    return vf(this, t, e);
  },
  min: function(e) {
    return vf(
      this,
      e ? RS(e) : jS
    );
  },
  minBy: function(e, t) {
    return vf(
      this,
      t ? RS(t) : jS,
      e
    );
  },
  rest: function() {
    return this.slice(1);
  },
  skip: function(e) {
    return e === 0 ? this : this.slice(Math.max(0, e));
  },
  skipLast: function(e) {
    return e === 0 ? this : this.slice(0, -Math.max(0, e));
  },
  skipWhile: function(e, t) {
    return Et(this, JA(this, e, t, !0));
  },
  skipUntil: function(e, t) {
    return this.skipWhile(Mv(e), t);
  },
  sortBy: function(e, t) {
    return Et(this, Us(this, t, e));
  },
  take: function(e) {
    return this.slice(0, Math.max(0, e));
  },
  takeLast: function(e) {
    return this.slice(-Math.max(0, e));
  },
  takeWhile: function(e, t) {
    return Et(this, SJ(this, e, t));
  },
  takeUntil: function(e, t) {
    return this.takeWhile(Mv(e), t);
  },
  update: function(e) {
    return e(this);
  },
  valueSeq: function() {
    return this.toIndexedSeq();
  },
  hashCode: function() {
    return this.__hash || (this.__hash = JJ(this));
  }
});
var Nn = on.prototype;
Nn[NA] = !0;
Nn[th] = Nn.values;
Nn.toJSON = Nn.toArray;
Nn.__toStringMapper = Zu;
Nn.inspect = Nn.toSource = function() {
  return this.toString();
};
Nn.chain = Nn.flatMap;
Nn.contains = Nn.includes;
Ua(Vr, {
  flip: function() {
    return Et(this, GA(this));
  },
  mapEntries: function(e, t) {
    var n = this, r = 0;
    return Et(
      this,
      this.toSeq().map(function(i, o) {
        return e.call(t, [o, i], r++, n);
      }).fromEntrySeq()
    );
  },
  mapKeys: function(e, t) {
    var n = this;
    return Et(
      this,
      this.toSeq().flip().map(function(r, i) {
        return e.call(t, r, i, n);
      }).flip()
    );
  }
});
var Ic = Vr.prototype;
Ic[RA] = !0;
Ic[th] = Nn.entries;
Ic.toJSON = xC;
Ic.__toStringMapper = function(e, t) {
  return Zu(t) + ": " + Zu(e);
};
Ua(Ba, {
  toKeyedSeq: function() {
    return new ih(this, !1);
  },
  filter: function(e, t) {
    return Et(this, QA(this, e, t, !1));
  },
  findIndex: function(e, t) {
    var n = this.findEntry(e, t);
    return n ? n[0] : -1;
  },
  indexOf: function(e) {
    var t = this.keyOf(e);
    return t === void 0 ? -1 : t;
  },
  lastIndexOf: function(e) {
    var t = this.lastKeyOf(e);
    return t === void 0 ? -1 : t;
  },
  reverse: function() {
    return Et(this, _0(this, !1));
  },
  slice: function(e, t) {
    return Et(this, w0(this, e, t, !1));
  },
  splice: function(e, t) {
    var n = arguments.length;
    if (t = Math.max(t || 0, 0), n === 0 || n === 2 && !t)
      return this;
    e = Tc(e, e < 0 ? this.count() : this.size);
    var r = this.slice(0, e);
    return Et(
      this,
      n === 1 ? r : r.concat(xi(arguments, 2), this.slice(e + t))
    );
  },
  findLastIndex: function(e, t) {
    var n = this.findLastEntry(e, t);
    return n ? n[0] : -1;
  },
  first: function(e) {
    return this.get(0, e);
  },
  flatten: function(e) {
    return Et(this, XA(this, e, !1));
  },
  get: function(e, t) {
    return e = Ao(this, e), e < 0 || this.size === 1 / 0 || this.size !== void 0 && e > this.size ? t : this.find(function(n, r) {
      return r === e;
    }, void 0, t);
  },
  has: function(e) {
    return e = Ao(this, e), e >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || e < this.size : this.indexOf(e) !== -1);
  },
  interpose: function(e) {
    return Et(this, TJ(this, e));
  },
  interleave: function() {
    var e = [this].concat(xi(arguments)), t = mf(this.toSeq(), di.of, e), n = t.flatten(!0);
    return t.size && (n.size = t.size * e.length), Et(this, n);
  },
  keySeq: function() {
    return WJ(0, this.size);
  },
  last: function(e) {
    return this.get(-1, e);
  },
  skipWhile: function(e, t) {
    return Et(this, JA(this, e, t, !1));
  },
  zip: function() {
    var e = [this].concat(xi(arguments));
    return Et(this, mf(this, MS, e));
  },
  zipAll: function() {
    var e = [this].concat(xi(arguments));
    return Et(this, mf(this, MS, e, !0));
  },
  zipWith: function(e) {
    var t = xi(arguments);
    return t[0] = this, Et(this, mf(this, e, t));
  }
});
var xl = Ba.prototype;
xl[MA] = !0;
xl[gl] = !0;
Ua(vl, {
  get: function(e, t) {
    return this.has(e) ? e : t;
  },
  includes: function(e) {
    return this.has(e);
  },
  keySeq: function() {
    return this.valueSeq();
  }
});
var Zs = vl.prototype;
Zs.has = Nn.includes;
Zs.contains = Zs.includes;
Zs.keys = Zs.values;
Ua(Ko, Ic);
Ua(di, xl);
Ua(bl, Zs);
function NS(e, t, n, r, i, o) {
  return ur(e.size), e.__iterate(function(a, s, l) {
    i ? (i = !1, n = a) : n = t.call(r, n, a, s, l);
  }, o), n;
}
function YJ(e, t) {
  return t;
}
function QJ(e, t) {
  return [t, e];
}
function Mv(e) {
  return function() {
    return !e.apply(this, arguments);
  };
}
function RS(e) {
  return function() {
    return -e.apply(this, arguments);
  };
}
function MS() {
  return xi(arguments);
}
function jS(e, t) {
  return e < t ? 1 : e > t ? -1 : 0;
}
function JJ(e) {
  if (e.size === 1 / 0)
    return 0;
  var t = ii(e), n = zt(e), r = t ? 1 : 0, i = e.__iterate(
    n ? t ? function(o, a) {
      r = 31 * r + FS(ar(o), ar(a)) | 0;
    } : function(o, a) {
      r = r + FS(ar(o), ar(a)) | 0;
    } : t ? function(o) {
      r = 31 * r + ar(o) | 0;
    } : function(o) {
      r = r + ar(o) | 0;
    }
  );
  return XJ(i, r);
}
function XJ(e, t) {
  return t = Kl(t, 3432918353), t = Kl(t << 15 | t >>> -15, 461845907), t = Kl(t << 13 | t >>> -13, 5), t = (t + 3864292196 | 0) ^ e, t = Kl(t ^ t >>> 16, 2246822507), t = Kl(t ^ t >>> 13, 3266489909), t = rh(t ^ t >>> 16), t;
}
function FS(e, t) {
  return e ^ t + 2654435769 + (e << 6) + (e >> 2) | 0;
}
var Xu = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Gg() : gC(n) ? n : Gg().withMutations(function(r) {
      var i = vl(n);
      ur(i.size), i.forEach(function(o) {
        return r.add(o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.fromKeys = function(n) {
    return this(Vr(n).keySeq());
  }, t.prototype.toString = function() {
    return this.__toString("OrderedSet {", "}");
  }, t;
})(ah);
Xu.isOrderedSet = gC;
var qa = Xu.prototype;
qa[gl] = !0;
qa.zip = xl.zip;
qa.zipWith = xl.zipWith;
qa.zipAll = xl.zipAll;
qa.__empty = Gg;
qa.__make = EC;
function EC(e, t) {
  var n = Object.create(qa);
  return n.size = e ? e.size : 0, n._map = e, n.__ownerID = t, n;
}
var zS;
function Gg() {
  return zS || (zS = EC(Jl()));
}
function eX(e) {
  if (ml(e))
    throw new Error(
      "Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead."
    );
  if (Ci(e))
    throw new Error(
      "Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead."
    );
  if (e === null || typeof e != "object")
    throw new Error(
      "Can not call `Record` with a non-object as default values. Use a plain javascript object instead."
    );
}
var yn = function(e, t) {
  var n;
  eX(e);
  var r = function(o) {
    var a = this;
    if (o instanceof r)
      return o;
    if (!(this instanceof r))
      return new r(o);
    if (!n) {
      n = !0;
      var s = Object.keys(e), l = i._indices = {};
      i._name = t, i._keys = s, i._defaultValues = e;
      for (var u = 0; u < s.length; u++) {
        var c = s[u];
        l[c] = u, i[c] ? typeof console == "object" && console.warn && console.warn(
          "Cannot define " + V0(this) + ' with property "' + c + '" since that property name is part of the Record API.'
        ) : tX(i, c);
      }
    }
    return this.__ownerID = void 0, this._values = oh().withMutations(function(f) {
      f.setSize(a._keys.length), Vr(o).forEach(function(d, p) {
        f.set(a._indices[p], d === a._defaultValues[p] ? void 0 : d);
      });
    }), this;
  }, i = r.prototype = Object.create(Pt);
  return i.constructor = r, t && (r.displayName = t), r;
};
yn.prototype.toString = function() {
  for (var e = V0(this) + " { ", t = this._keys, n, r = 0, i = t.length; r !== i; r++)
    n = t[r], e += (r ? ", " : "") + n + ": " + Zu(this.get(n));
  return e + " }";
};
yn.prototype.equals = function(e) {
  return this === e || ml(e) && Gs(this).equals(Gs(e));
};
yn.prototype.hashCode = function() {
  return Gs(this).hashCode();
};
yn.prototype.has = function(e) {
  return this._indices.hasOwnProperty(e);
};
yn.prototype.get = function(e, t) {
  if (!this.has(e))
    return t;
  var n = this._indices[e], r = this._values.get(n);
  return r === void 0 ? this._defaultValues[e] : r;
};
yn.prototype.set = function(e, t) {
  if (this.has(e)) {
    var n = this._values.set(
      this._indices[e],
      t === this._defaultValues[e] ? void 0 : t
    );
    if (n !== this._values && !this.__ownerID)
      return L0(this, n);
  }
  return this;
};
yn.prototype.remove = function(e) {
  return this.set(e);
};
yn.prototype.clear = function() {
  var e = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : L0(this, e);
};
yn.prototype.wasAltered = function() {
  return this._values.wasAltered();
};
yn.prototype.toSeq = function() {
  return Gs(this);
};
yn.prototype.toJS = function() {
  return Hd(this);
};
yn.prototype.entries = function() {
  return this.__iterator(jr);
};
yn.prototype.__iterator = function(e, t) {
  return Gs(this).__iterator(e, t);
};
yn.prototype.__iterate = function(e, t) {
  return Gs(this).__iterate(e, t);
};
yn.prototype.__ensureOwner = function(e) {
  if (e === this.__ownerID)
    return this;
  var t = this._values.__ensureOwner(e);
  return e ? L0(this, t, e) : (this.__ownerID = e, this._values = t, this);
};
yn.isRecord = ml;
yn.getDescriptiveName = V0;
var Pt = yn.prototype;
Pt[FA] = !0;
Pt[$c] = Pt.remove;
Pt.deleteIn = Pt.removeIn = $0;
Pt.getIn = wC;
Pt.hasIn = Nn.hasIn;
Pt.merge = oC;
Pt.mergeWith = aC;
Pt.mergeIn = A0;
Pt.mergeDeep = lC;
Pt.mergeDeepWith = uC;
Pt.mergeDeepIn = C0;
Pt.setIn = O0;
Pt.update = T0;
Pt.updateIn = P0;
Pt.withMutations = Dc;
Pt.asMutable = Ac;
Pt.asImmutable = Cc;
Pt[th] = Pt.entries;
Pt.toJSON = Pt.toObject = Nn.toObject;
Pt.inspect = Pt.toSource = function() {
  return this.toString();
};
function L0(e, t, n) {
  var r = Object.create(Object.getPrototypeOf(e));
  return r._values = t, r.__ownerID = n, r;
}
function V0(e) {
  return e.constructor.displayName || e.constructor.name || "Record";
}
function Gs(e) {
  return g0(e._keys.map(function(t) {
    return [t, e.get(t)];
  }));
}
function tX(e, t) {
  try {
    Object.defineProperty(e, t, {
      get: function() {
        return this.get(t);
      },
      set: function(n) {
        S0(this.__ownerID, "Cannot set on an immutable record."), this.set(t, n);
      }
    });
  } catch {
  }
}
const SC = (e, t) => {
  Ee(() => (document.addEventListener("keydown", (n) => {
    e[n.key] && e[n.key]();
  }), () => {
    document.removeEventListener("keydown", () => null);
  }), t || []);
}, nX = ui(
  [
    "dark:bg-neutral-900",
    "dark:text-neutral-200",
    "absolute",
    "transform",
    "shadow-sm",
    "border",
    "border-black",
    "top-1/2",
    "left-1/2",
    "bg-neutral-100",
    "max-h-[75vh]",
    "z-50"
  ],
  {
    variants: {
      size: {
        fit: ["w-auto", "h-auto"],
        sm: ["w-sm", "h-[50vh]"],
        md: ["w-md", "h-[50vh]"],
        lg: ["w-lg", "h-[50vh]"]
      }
    }
  }
), rX = ({
  children: e,
  visible: t,
  onClose: n,
  className: r,
  containerClassName: i = "modal-root",
  variant: o = "lg"
}) => {
  const a = _e(null), { root: s } = iX();
  return SC({
    Escape: n
  }), s ? t ? va(
    /* @__PURE__ */ C.jsx(Bm, { children: /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      /* @__PURE__ */ C.jsx(
        Vn.div,
        {
          className: Qn(
            "fixed top-0 left-0 w-screen h-screen opacity-80 bg-neutral-700 z-40 overlay",
            r
          ),
          onClick: () => n(),
          initial: { opacity: 0 },
          animate: { opacity: 0.8 }
        }
      ),
      /* @__PURE__ */ C.jsx(
        Vn.div,
        {
          className: Qn(
            nX({ size: o }),
            i
          ),
          ref: a,
          initial: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) translateY(-50%)",
            top: "100vh"
          },
          animate: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) translateY(-50%)",
            top: "50vh"
          },
          exit: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) ",
            top: "100vh"
          },
          children: e
        }
      )
    ] }) }),
    s
  ) : null : (console.error("No root element found"), null);
}, OC = He({ root: null }), iX = () => H.useContext(OC), fue = ({
  className: e = "modal-root",
  children: t
}) => {
  const [n, r] = H.useState(null);
  return /* @__PURE__ */ C.jsxs(OC.Provider, { value: { root: n }, children: [
    t,
    /* @__PURE__ */ C.jsx("div", { ref: r, className: e })
  ] });
}, oX = ({
  visible: e,
  onClose: t,
  onCreateFolder: n
}) => {
  const { register: r, handleSubmit: i, reset: o } = iJ({ defaultValues: { name: "" } }), { ref: a, ...s } = r("name"), [l, u] = Ve(null);
  return Ee(() => {
    l && l.focus();
  }, [l]), /* @__PURE__ */ C.jsx(
    rX,
    {
      visible: e,
      onClose: () => t(!1),
      variant: "fit",
      children: /* @__PURE__ */ C.jsxs("div", { className: "border-black border w-full h-full bg-white p-4", children: [
        /* @__PURE__ */ C.jsx("h1", { children: "create folder" }),
        /* @__PURE__ */ C.jsxs(
          "form",
          {
            className: "flex flex-col items-center justify-center gap-4",
            onSubmit: i((c) => {
              o(), n(c.name);
            }),
            children: [
              /* @__PURE__ */ C.jsx(
                oJ,
                {
                  ref: (c) => {
                    a(c), u(c);
                  },
                  className: "block",
                  ...s,
                  type: "text",
                  placeholder: "folder name"
                }
              ),
              /* @__PURE__ */ C.jsx(Ty, { children: "Create" })
            ]
          }
        )
      ] })
    }
  );
}, aX = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216.49,79.52l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.52ZM160,57l23,23H160ZM60,212V44h76V92a12,12,0,0,0,12,12h48V212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M208,88H152V32Z", opacity: "0.2" }), /* @__PURE__ */ ie.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM152,88V44l44,44Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM200,218H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216A2,2,0,0,1,200,218Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM200,220H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216A4,4,0,0,1,200,220Z" }))
  ]
]), sX = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM44,56H90.61l10.67,12H44ZM212,196H44V92H212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement(
      "path",
      {
        d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ ie.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40ZM216,200H40V88H216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM36,56a4,4,0,0,1,4-4H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4Z" }))
  ]
]), lX = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM90.61,56l10.67,12H44V56ZM212,196H44V92H212Zm-72-76v12h12a12,12,0,0,1,0,24H140v12a12,12,0,0,1-24,0V156H104a12,12,0,0,1,0-24h12V120a12,12,0,0,1,24,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement(
      "path",
      {
        d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ ie.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Zm112,96H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2ZM158,144a6,6,0,0,1-6,6H134v18a6,6,0,0,1-12,0V150H104a6,6,0,0,1,0-12h18V120a6,6,0,0,1,12,0v18h18A6,6,0,0,1,158,144Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM40,52H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36V56A4,4,0,0,1,40,52ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4ZM156,144a4,4,0,0,1-4,4H132v20a4,4,0,0,1-8,0V148H104a4,4,0,0,1,0-8h20V120a4,4,0,0,1,8,0v20h20A4,4,0,0,1,156,144Z" }))
  ]
]), uX = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM40,76H216a12,12,0,0,0,0-24H40a12,12,0,0,0,0,24ZM216,180H40a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,64V192H40V64Z", opacity: "0.2" }), /* @__PURE__ */ ie.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM192,184H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M222,128a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM40,70H216a6,6,0,0,0,0-12H40a6,6,0,0,0,0,12ZM216,186H40a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM40,68H216a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8ZM216,188H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Z" }))
  ]
]), cX = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M228,144v64a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V144a12,12,0,0,1,24,0v52H204V144a12,12,0,0,1,24,0ZM96.49,80.49,116,61v83a12,12,0,0,0,24,0V61l19.51,19.52a12,12,0,1,0,17-17l-40-40a12,12,0,0,0-17,0l-40,40a12,12,0,1,0,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement(
      "path",
      {
        d: "M216,48V208H40V48A16,16,0,0,1,56,32H200A16,16,0,0,1,216,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ ie.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM88,80h32v64a8,8,0,0,0,16,0V80h32a8,8,0,0,0,5.66-13.66l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,88,80Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M222,144v64a6,6,0,0,1-6,6H40a6,6,0,0,1-6-6V144a6,6,0,0,1,12,0v58H210V144a6,6,0,0,1,12,0ZM92.24,76.24,122,46.49V144a6,6,0,0,0,12,0V46.49l29.76,29.75a6,6,0,0,0,8.48-8.48l-40-40a6,6,0,0,0-8.48,0l-40,40a6,6,0,0,0,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M220,144v64a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V144a4,4,0,0,1,8,0v60H212V144a4,4,0,0,1,8,0ZM90.83,74.83,124,41.66V144a4,4,0,0,0,8,0V41.66l33.17,33.17a4,4,0,1,0,5.66-5.66l-40-40a4,4,0,0,0-5.66,0l-40,40a4,4,0,0,0,5.66,5.66Z" }))
  ]
]), fX = He({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
}), El = ie.forwardRef(
  (e, t) => {
    const {
      alt: n,
      color: r,
      size: i,
      weight: o,
      mirrored: a,
      children: s,
      weights: l,
      ...u
    } = e, {
      color: c = "currentColor",
      size: f,
      weight: d = "regular",
      mirrored: p = !1,
      ...h
    } = ie.useContext(fX);
    return /* @__PURE__ */ ie.createElement(
      "svg",
      {
        ref: t,
        xmlns: "http://www.w3.org/2000/svg",
        width: i ?? f,
        height: i ?? f,
        fill: r ?? c,
        viewBox: "0 0 256 256",
        transform: a || p ? "scale(-1, 1)" : void 0,
        ...h,
        ...u
      },
      !!n && /* @__PURE__ */ ie.createElement("title", null, n),
      s,
      l.get(o ?? d)
    );
  }
);
El.displayName = "IconBase";
const $C = ie.forwardRef((e, t) => /* @__PURE__ */ ie.createElement(El, { ref: t, ...e, weights: aX }));
$C.displayName = "FileIcon";
const dX = $C, sh = ie.forwardRef((e, t) => /* @__PURE__ */ ie.createElement(El, { ref: t, ...e, weights: sX }));
sh.displayName = "FolderIcon";
const pX = sh, TC = ie.forwardRef((e, t) => /* @__PURE__ */ ie.createElement(El, { ref: t, ...e, weights: lX }));
TC.displayName = "FolderPlusIcon";
const hX = TC, PC = ie.forwardRef((e, t) => /* @__PURE__ */ ie.createElement(El, { ref: t, ...e, weights: uX }));
PC.displayName = "ListIcon";
const vX = PC, kC = ie.forwardRef((e, t) => /* @__PURE__ */ ie.createElement(El, { ref: t, ...e, weights: cX }));
kC.displayName = "UploadSimpleIcon";
const mX = kC;
var jv, LS;
function gX() {
  if (LS) return jv;
  LS = 1;
  function e(i) {
    if (typeof i != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(i));
  }
  function t(i, o) {
    for (var a = "", s = 0, l = -1, u = 0, c, f = 0; f <= i.length; ++f) {
      if (f < i.length)
        c = i.charCodeAt(f);
      else {
        if (c === 47)
          break;
        c = 47;
      }
      if (c === 47) {
        if (!(l === f - 1 || u === 1)) if (l !== f - 1 && u === 2) {
          if (a.length < 2 || s !== 2 || a.charCodeAt(a.length - 1) !== 46 || a.charCodeAt(a.length - 2) !== 46) {
            if (a.length > 2) {
              var d = a.lastIndexOf("/");
              if (d !== a.length - 1) {
                d === -1 ? (a = "", s = 0) : (a = a.slice(0, d), s = a.length - 1 - a.lastIndexOf("/")), l = f, u = 0;
                continue;
              }
            } else if (a.length === 2 || a.length === 1) {
              a = "", s = 0, l = f, u = 0;
              continue;
            }
          }
          o && (a.length > 0 ? a += "/.." : a = "..", s = 2);
        } else
          a.length > 0 ? a += "/" + i.slice(l + 1, f) : a = i.slice(l + 1, f), s = f - l - 1;
        l = f, u = 0;
      } else c === 46 && u !== -1 ? ++u : u = -1;
    }
    return a;
  }
  function n(i, o) {
    var a = o.dir || o.root, s = o.base || (o.name || "") + (o.ext || "");
    return a ? a === o.root ? a + s : a + i + s : s;
  }
  var r = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var o = "", a = !1, s, l = arguments.length - 1; l >= -1 && !a; l--) {
        var u;
        l >= 0 ? u = arguments[l] : (s === void 0 && (s = process.cwd()), u = s), e(u), u.length !== 0 && (o = u + "/" + o, a = u.charCodeAt(0) === 47);
      }
      return o = t(o, !a), a ? o.length > 0 ? "/" + o : "/" : o.length > 0 ? o : ".";
    },
    normalize: function(o) {
      if (e(o), o.length === 0) return ".";
      var a = o.charCodeAt(0) === 47, s = o.charCodeAt(o.length - 1) === 47;
      return o = t(o, !a), o.length === 0 && !a && (o = "."), o.length > 0 && s && (o += "/"), a ? "/" + o : o;
    },
    isAbsolute: function(o) {
      return e(o), o.length > 0 && o.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var o, a = 0; a < arguments.length; ++a) {
        var s = arguments[a];
        e(s), s.length > 0 && (o === void 0 ? o = s : o += "/" + s);
      }
      return o === void 0 ? "." : r.normalize(o);
    },
    relative: function(o, a) {
      if (e(o), e(a), o === a || (o = r.resolve(o), a = r.resolve(a), o === a)) return "";
      for (var s = 1; s < o.length && o.charCodeAt(s) === 47; ++s)
        ;
      for (var l = o.length, u = l - s, c = 1; c < a.length && a.charCodeAt(c) === 47; ++c)
        ;
      for (var f = a.length, d = f - c, p = u < d ? u : d, h = -1, v = 0; v <= p; ++v) {
        if (v === p) {
          if (d > p) {
            if (a.charCodeAt(c + v) === 47)
              return a.slice(c + v + 1);
            if (v === 0)
              return a.slice(c + v);
          } else u > p && (o.charCodeAt(s + v) === 47 ? h = v : v === 0 && (h = 0));
          break;
        }
        var m = o.charCodeAt(s + v), g = a.charCodeAt(c + v);
        if (m !== g)
          break;
        m === 47 && (h = v);
      }
      var _ = "";
      for (v = s + h + 1; v <= l; ++v)
        (v === l || o.charCodeAt(v) === 47) && (_.length === 0 ? _ += ".." : _ += "/..");
      return _.length > 0 ? _ + a.slice(c + h) : (c += h, a.charCodeAt(c) === 47 && ++c, a.slice(c));
    },
    _makeLong: function(o) {
      return o;
    },
    dirname: function(o) {
      if (e(o), o.length === 0) return ".";
      for (var a = o.charCodeAt(0), s = a === 47, l = -1, u = !0, c = o.length - 1; c >= 1; --c)
        if (a = o.charCodeAt(c), a === 47) {
          if (!u) {
            l = c;
            break;
          }
        } else
          u = !1;
      return l === -1 ? s ? "/" : "." : s && l === 1 ? "//" : o.slice(0, l);
    },
    basename: function(o, a) {
      if (a !== void 0 && typeof a != "string") throw new TypeError('"ext" argument must be a string');
      e(o);
      var s = 0, l = -1, u = !0, c;
      if (a !== void 0 && a.length > 0 && a.length <= o.length) {
        if (a.length === o.length && a === o) return "";
        var f = a.length - 1, d = -1;
        for (c = o.length - 1; c >= 0; --c) {
          var p = o.charCodeAt(c);
          if (p === 47) {
            if (!u) {
              s = c + 1;
              break;
            }
          } else
            d === -1 && (u = !1, d = c + 1), f >= 0 && (p === a.charCodeAt(f) ? --f === -1 && (l = c) : (f = -1, l = d));
        }
        return s === l ? l = d : l === -1 && (l = o.length), o.slice(s, l);
      } else {
        for (c = o.length - 1; c >= 0; --c)
          if (o.charCodeAt(c) === 47) {
            if (!u) {
              s = c + 1;
              break;
            }
          } else l === -1 && (u = !1, l = c + 1);
        return l === -1 ? "" : o.slice(s, l);
      }
    },
    extname: function(o) {
      e(o);
      for (var a = -1, s = 0, l = -1, u = !0, c = 0, f = o.length - 1; f >= 0; --f) {
        var d = o.charCodeAt(f);
        if (d === 47) {
          if (!u) {
            s = f + 1;
            break;
          }
          continue;
        }
        l === -1 && (u = !1, l = f + 1), d === 46 ? a === -1 ? a = f : c !== 1 && (c = 1) : a !== -1 && (c = -1);
      }
      return a === -1 || l === -1 || // We saw a non-dot character immediately before the dot
      c === 0 || // The (right-most) trimmed path component is exactly '..'
      c === 1 && a === l - 1 && a === s + 1 ? "" : o.slice(a, l);
    },
    format: function(o) {
      if (o === null || typeof o != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof o);
      return n("/", o);
    },
    parse: function(o) {
      e(o);
      var a = { root: "", dir: "", base: "", ext: "", name: "" };
      if (o.length === 0) return a;
      var s = o.charCodeAt(0), l = s === 47, u;
      l ? (a.root = "/", u = 1) : u = 0;
      for (var c = -1, f = 0, d = -1, p = !0, h = o.length - 1, v = 0; h >= u; --h) {
        if (s = o.charCodeAt(h), s === 47) {
          if (!p) {
            f = h + 1;
            break;
          }
          continue;
        }
        d === -1 && (p = !1, d = h + 1), s === 46 ? c === -1 ? c = h : v !== 1 && (v = 1) : c !== -1 && (v = -1);
      }
      return c === -1 || d === -1 || // We saw a non-dot character immediately before the dot
      v === 0 || // The (right-most) trimmed path component is exactly '..'
      v === 1 && c === d - 1 && c === f + 1 ? d !== -1 && (f === 0 && l ? a.base = a.name = o.slice(1, d) : a.base = a.name = o.slice(f, d)) : (f === 0 && l ? (a.name = o.slice(1, c), a.base = o.slice(1, d)) : (a.name = o.slice(f, c), a.base = o.slice(f, d)), a.ext = o.slice(c, d)), f > 0 ? a.dir = o.slice(0, f - 1) : l && (a.dir = "/"), a;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return r.posix = r, jv = r, jv;
}
var $s = gX();
const DC = ui([
  "dark:hover:bg-neutral-300",
  "dark:hover:text-neutral-700",
  "hover:bg-neutral-100",
  "p-1",
  "items-center",
  "gap-2",
  "whitespace-nowrap",
  "w-full",
  "flex",
  "text-left",
  "text-sm",
  "disabled:text-neutral-500",
  "disabled:hover:bg-none",
  "cursor-default"
]);
function ca({ className: e = "", ...t }) {
  return /* @__PURE__ */ C.jsx(AV, { ...t, className: DC({}) });
}
const yX = ui([
  "bg-white",
  "text-black",
  "border-b",
  "border",
  "shadow-md",
  "p-2"
]);
function K0({ children: e, button: t, className: n, isOpen: r, setOpen: i }) {
  return /* @__PURE__ */ C.jsxs(OV, { isOpen: r, onOpenChange: i, children: [
    /* @__PURE__ */ C.jsx($b, { children: t || /* @__PURE__ */ C.jsx(
      hr,
      {
        className: "dark:text-neutral-300 text-neutral-700",
        icon: I6
      }
    ) }),
    /* @__PURE__ */ C.jsx(Pk, { children: /* @__PURE__ */ C.jsx(TV, { className: Qn(yX({}), n), children: e }) })
  ] });
}
const bX = V4(
  ({
    store: e,
    homeDirectory: t,
    searchDisabled: n,
    searchBarExtras: r
  }) => /* @__PURE__ */ C.jsxs("header", { className: "row-start-1 w-full", children: [
    /* @__PURE__ */ C.jsxs("div", { className: "px-2 flex w-full gap-4 border border-black", children: [
      /* @__PURE__ */ C.jsx("div", { className: "flex w-full", children: /* @__PURE__ */ C.jsx(
        "input",
        {
          disabled: n,
          value: e.searchQuery ?? "",
          onChange: (i) => e.setSearchQuery(i.target.value),
          className: "w-full p-1 rounded border-none h-6 my-auto flex-grow bg-white dark:bg-neutral-300 text-neutral-600 focus:outline-none",
          type: "text",
          placeholder: "search..."
        }
      ) }),
      /* @__PURE__ */ C.jsxs("div", { className: "flex gap-2", children: [
        /* @__PURE__ */ C.jsx(
          CV,
          {
            onSelect: (i) => {
              i && e.onDrop(Array.from(i));
            },
            children: /* @__PURE__ */ C.jsx($b, { className: DC(), children: /* @__PURE__ */ C.jsx(mX, { size: 18 }) })
          }
        ),
        r && r(e.searchQuery ?? ""),
        /* @__PURE__ */ C.jsx(K0, { children: /* @__PURE__ */ C.jsxs(ca, { onAction: () => {
          e.setCreateFolderModalVisible(!0);
        }, children: [
          /* @__PURE__ */ C.jsx(hX, { size: 18 }),
          " Create Folder"
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ C.jsxs(
      "button",
      {
        className: "inline text-black pb-2 hover:text-neutral-300 hover:fill-neutral-300",
        onClick: () => e.popToRoot(),
        children: [
          t,
          "/"
        ]
      }
    ),
    e.currentPath.map((i, o) => /* @__PURE__ */ C.jsxs(
      "button",
      {
        className: "inline text-black pb-2 hover:text-neutral-300",
        onClick: () => {
          o !== e.currentPath.length - 1 && e.popFolderHistoryToIndex(o);
        },
        children: [
          $s.basename(i),
          "/"
        ]
      },
      `${i}-${o}`
    ))
  ] })
);
function _X({ files: e }) {
  return /* @__PURE__ */ C.jsxs("div", { children: [
    /* @__PURE__ */ C.jsx("p", { className: "m-2", children: "Uploading:" }),
    /* @__PURE__ */ C.jsx("ul", { children: e.map((t) => /* @__PURE__ */ C.jsx("li", { className: "pl-4 list-none", children: t.name }, t.name)) })
  ] });
}
class wX {
  constructor(t) {
    vi(this, "searchQuery", null);
    vi(this, "currentPath", []);
    vi(this, "searchResults", null);
    vi(this, "createFolderModalVisible", !1);
    vi(this, "onSearch");
    vi(this, "onUpload");
    vi(this, "onNavigate");
    vi(this, "searchLoading", !1);
    t ? this.currentPath = t : this.currentPath = [], UW(this), this.onDrop = this.onDrop.bind(this), this.pushPathPart = this.pushPathPart.bind(this), this.setCreateFolderModalVisible = this.setCreateFolderModalVisible.bind(this), this.setSearchQuery = this.setSearchQuery.bind(this), this.popFolderHistory = this.popFolderHistory.bind(this), this.popFolderHistoryToIndex = this.popFolderHistoryToIndex.bind(this), this.setSearchResults = this.setSearchResults.bind(this);
  }
  setCreateFolderModalVisible(t) {
    this.createFolderModalVisible = t;
  }
  pushPathPart(t) {
    this.currentPath.push(t);
  }
  popFolderHistory() {
    this.currentPath.pop(), this.onNavigate?.(
      this.currentPath
    );
  }
  popToRoot() {
    this.currentPath = [], this.onNavigate?.([]);
  }
  popFolderHistoryToIndex(t) {
    this.currentPath = this.currentPath.slice(0, t + 1), this.onNavigate?.(
      this.currentPath
    );
  }
  async setSearchResults(t) {
    this.searchResults = t;
  }
  async setSearchQuery(t) {
    if (this.searchQuery = t, t) {
      if (!this.onSearch)
        return;
    } else {
      this.searchResults = null, this.searchLoading = !1;
      return;
    }
    this.onSearch(t);
  }
  // get currentFolderPath() {
  //     if (this.currentPath.length === 0) {
  //         return "";
  //     }
  //     // return this.folderHistory.reduce((acc, f) => acc + f, "");
  //     return this.currentPath[this.currentPath.length - 1];
  // }
  async onDrop(t) {
    if (t[0].size / (1024 * 1024 * 1024) > 1)
      throw En("File cannot be bigger than 1GB"), new Error("File cannot be bigger than 1GB");
    if (this.onUpload)
      try {
        const i = await this.onUpload(t);
        if (!i)
          return;
        const o = En(/* @__PURE__ */ C.jsx(_X, { files: t }), {
          progress: 0
        });
        i.subscribe({
          onProgress: (a) => {
            En.update(o, {
              progress: a
            });
          },
          onError: (a) => {
            En.error("Something went wrong!: " + a.message);
          },
          onComplete: () => {
            En.dismiss(o);
          }
        });
      } catch (i) {
        En.error("Something went wrong!: " + i);
      }
  }
}
function tu(e, t) {
  return !!t.find(
    ({ path: n, isFolder: r }) => e.path === n && r === e.isFolder
  );
}
function xX(e, t, n) {
  switch (n) {
    case Ln.ALL:
      return tu(t, e) ? e.filter((r) => r.path !== t.path) : [...e, t];
    case Ln.FILE:
      return t.isFolder ? e : tu(t, e) ? [] : [t];
    case Ln.DIR:
      return t.isFolder ? tu(t, e) ? [] : [t] : e;
    case Ln.FILE_LIST:
      return t.isFolder ? e : tu(t, e) ? e.filter((r) => r.path !== t.path) : [...e, t];
    case Ln.NONE:
    default:
      return e;
  }
}
const Wd = () => /* @__PURE__ */ C.jsx("div", { className: "flex-grow" });
function AC({
  onDelete: e,
  path: t,
  onPreview: n,
  onDownload: r,
  onMoveUpAFolder: i,
  className: o = "",
  isOpen: a,
  setOpen: s
}) {
  return /* @__PURE__ */ C.jsxs(
    K0,
    {
      button: /* @__PURE__ */ C.jsx(vX, { className: o, size: 18, "data-testid": `path-actions-${t.path}` }),
      isOpen: a,
      setOpen: s,
      children: [
        !t.isFolder && r && /* @__PURE__ */ C.jsx(
          ca,
          {
            onAction: async () => {
              r(t);
            },
            children: "Download"
          }
        ),
        i && /* @__PURE__ */ C.jsx(
          ca,
          {
            onAction: async () => {
              const l = $s.dirname($s.dirname(t.path)), u = $s.basename(t.path), c = `${l}/${u}`;
              i(l === "." ? null : { path: t, parent: l, newPath: c });
            },
            children: "Move Up a Folder"
          }
        ),
        e && /* @__PURE__ */ C.jsx(ca, { onAction: () => e(), children: "Delete" }),
        !t.isFolder && n && /* @__PURE__ */ C.jsx(ca, { onAction: () => n(t), children: "Preview" })
      ]
    }
  );
}
const EX = ui(
  [
    "relative",
    "flex",
    "gap-2",
    "p-1",
    "select-none",
    "hover:bg-neutral-200",
    "dark:hover:bg-neutral-600",
    "items-center",
    "w-full",
    "group"
  ],
  {
    variants: {
      selected: {
        true: ["text-blue-500", "hover:after:h-0"],
        false: ["text-neutral-800", "dark:text-neutral-200"]
      },
      isOver: {
        true: ["bg-neutral-300", "dark:bg-neutral-600"],
        false: ["bg-transparent"]
      }
    }
  }
), CC = fn(
  (e, t) => {
    const {
      children: n,
      selected: r,
      showCheckbox: i = !0,
      style: o,
      onCheckboxValueChange: a,
      onClick: s,
      isOver: l,
      path: u
    } = e;
    return /* @__PURE__ */ C.jsxs(
      Vn.div,
      {
        "data-testid": `file-${u}`,
        className: EX({ selected: r, isOver: l }),
        ref: t,
        style: o,
        onClick: (c) => {
          c.stopPropagation, s?.(c);
        },
        layout: !0,
        children: [
          i && /* @__PURE__ */ C.jsx(
            yA,
            {
              onClick: (c) => c.stopPropagation(),
              onChange: (c) => {
                a(c.currentTarget.checked);
              },
              className: "mr-2",
              checked: r
            }
          ),
          n
        ]
      }
    );
  }
), SX = ({
  path: e,
  onClick: t,
  selected: n,
  readOnly: r = !1,
  showFullPath: i = !1,
  onDelete: o,
  style: a,
  onPreview: s,
  onDownload: l,
  onMoveUpAFolder: u,
  showCheckbox: c = !0
}) => {
  const [, f] = X4({
    canDrag: !r,
    type: "S3File",
    item: { ...e },
    collect: (v) => ({
      isDragging: v.isDragging()
    })
  }), d = $s.basename(e.path), [p, h] = Ve(!1);
  return /* @__PURE__ */ C.jsxs(
    CC,
    {
      path: e.path,
      style: { ...a },
      onClick: (v) => {
        v.stopPropagation();
      },
      showCheckbox: c,
      onCheckboxValueChange: () => t(e),
      selected: n,
      ref: f,
      children: [
        /* @__PURE__ */ C.jsx(dX, { size: 18, className: "pr-1 flex-shrink-0" }),
        /* @__PURE__ */ C.jsx("div", { className: "flex flex-col justify-around flex-shrink h-full overflow-hidden", children: /* @__PURE__ */ C.jsx("p", { children: i ? e.path : d }) }),
        /* @__PURE__ */ C.jsx(Wd, {}),
        /* @__PURE__ */ C.jsx(
          AC,
          {
            className: `${p ? "" : "opacity-0 focus:opacity-100"} group-hover:opacity-100 focus:opacity-100`,
            onPreview: s,
            path: e,
            onDelete: o ? () => o?.(e) : void 0,
            onMoveUpAFolder: u,
            onDownload: l,
            isOpen: p,
            setOpen: h
          }
        )
      ]
    }
  );
}, OX = ({
  path: e,
  onClick: t,
  onDblClick: n,
  selected: r,
  onDrop: i,
  readOnly: o = !1,
  style: a,
  onDelete: s,
  showActions: l,
  onPreview: u,
  showFullPath: c,
  showCheckbox: f = !0
}) => {
  const d = sJ(
    () => {
    },
    () => n(e)
  ), [, p] = X4({
    canDrag: !o,
    type: "S3Folder",
    item: { ...e },
    collect: (g) => ({
      isDragging: g.isDragging()
    })
  }), [h] = Ve(!1), [{ isOver: v }, m] = OY({
    canDrop: () => !o,
    accept: ["S3Folder", "S3File"],
    drop: (g) => i(g),
    collect: (g) => ({
      isOver: g.isOver()
    })
  });
  return /* @__PURE__ */ C.jsx("div", { ref: m, style: a, children: /* @__PURE__ */ C.jsxs(
    CC,
    {
      path: e.path,
      selected: r,
      isOver: v,
      onClick: (g) => {
        g.stopPropagation(), d();
      },
      ref: p,
      showCheckbox: f,
      onCheckboxValueChange: () => t(e),
      children: [
        /* @__PURE__ */ C.jsx(pX, { size: 18, className: "pr-1 flex-shrink-0" }),
        /* @__PURE__ */ C.jsx("div", { className: "flex flex-col justify-around h-full", children: /* @__PURE__ */ C.jsx("p", { children: c ? e.path : $s.basename(e.path) }) }),
        /* @__PURE__ */ C.jsx(Wd, {}),
        l && u && s && h && /* @__PURE__ */ C.jsx(
          AC,
          {
            onPreview: u,
            path: e,
            onDelete: s ? () => s(e) : void 0
          }
        )
      ]
    }
  ) });
};
function $X(e, t) {
  Ee(() => {
    for (const n in e)
      e.hasOwnProperty(n) && e[n] && (t[n] = e[n]);
  }, [e, t]);
}
const IC = V4(
  ({
    selectionMode: e = Ln.NONE,
    // files,
    selection: t,
    onSelectionChange: n,
    readOnly: r = !1,
    className: i,
    showActions: o = !0,
    onDownload: a,
    onMoveUpAFolder: s,
    style: l,
    onPreview: u,
    onDelete: c,
    onMove: f,
    onCreateFolder: d,
    loading: p = !1,
    onSearch: h,
    searchDisabled: v = !1,
    onNavigate: m,
    filePathHomeDirectory: g = "~",
    onUpload: _,
    searchBarExtras: w,
    files: x,
    // getFiles,
    path: S
  }) => {
    const $ = _Z(() => new wX(S)), { getRootProps: A, getInputProps: E, isDragActive: y } = gA({
      noClick: !0,
      onDrop: $.onDrop
    }), b = Le(
      (T) => xX(t, T, e),
      [t, e]
    ), O = Le(async () => {
      $.searchLoading = !0;
      const T = $.searchQuery;
      if (!h || !T) {
        $.searchLoading = !1;
        return;
      }
      $.setSearchResults([]), setTimeout(async () => {
        if ($.searchQuery === T && T) {
          const V = await h(T);
          if (!V) return;
          $.setSearchResults(V), $.searchLoading = !1;
        }
      }, 500);
    }, [h, $.searchQuery]);
    Ee(() => {
      $.onSearch = O;
    }, [O]), $X(
      {
        onUpload: _,
        onNavigate: m,
        currentPath: S
      },
      $
    );
    const k = $.searchResults || x || [], I = _e(null);
    return /* @__PURE__ */ C.jsxs(
      "div",
      {
        className: Qn(
          "grid-rows-[2rem 1fr] box-border relative flex flex-col justify-start flex-grow w-full gap-2 overflow-auto text-neutral-800 bg-white",
          i
        ),
        style: l,
        ...A(),
        children: [
          y && /* @__PURE__ */ C.jsx(
            "div",
            {
              style: { zIndex: 999 },
              className: "w-full h-full absolute top-0 left-0 flex justify-center items-center z-[999] bg-opacity-20 text-orange-2 pointer-events-none bg-white text-4xl",
              children: "Drop files here"
            }
          ),
          /* @__PURE__ */ C.jsx("input", { className: "z-50 bg-purple-500", ...E() }),
          /* @__PURE__ */ C.jsx("div", { children: /* @__PURE__ */ C.jsx(
            bX,
            {
              searchDisabled: v,
              selection: t,
              store: $,
              homeDirectory: g,
              searchBarExtras: w
            }
          ) }),
          e !== Ln.NONE && /* @__PURE__ */ C.jsxs("div", { className: "mr-auto ml-1 flex items-center gap-2 text-neutral-400", children: [
            /* @__PURE__ */ C.jsx(
              yA,
              {
                checked: t.length > 0,
                onChange: () => {
                  k && (t.length === 0 ? n?.([...t, ...k]) : n?.([]));
                }
              }
            ),
            /* @__PURE__ */ C.jsxs("p", { className: "text-xs", children: [
              t.length,
              " file",
              t.length !== 1 && "s",
              " selected"
            ] })
          ] }),
          /* @__PURE__ */ C.jsx(
            "div",
            {
              ref: I,
              className: "relative flex-grow overflow-auto",
              children: /* @__PURE__ */ C.jsx(WG, { backend: zY, children: /* @__PURE__ */ C.jsxs("div", { className: "row-start-2 row-span-1 flex-grow relative", children: [
                p ? /* @__PURE__ */ C.jsx("p", { className: "py-2 italic text-neutral-600", children: "Loading..." }) : null,
                k?.length === 0 && !$.searchLoading && !p && /* @__PURE__ */ C.jsx("p", { className: "py-2 italic text-neutral-600", children: "No files" }),
                $.searchLoading && /* @__PURE__ */ C.jsx("p", { className: "py-2 italic text-neutral-600", children: "Searching..." }),
                k && k.length > 0 && k.map((T) => {
                  const V = {
                    key: TX(T),
                    showActions: o,
                    readOnly: r,
                    onDelete: c ? () => {
                      c([T]), n?.([]);
                    } : void 0,
                    onClick: (z) => {
                      const B = b(z);
                      n?.(B);
                    },
                    showFullPath: !!$.searchQuery,
                    // show full path if searching
                    path: T,
                    selected: tu(T, t),
                    onPreview: u
                  };
                  return T.isFolder ? /* @__PURE__ */ C.jsx(
                    OX,
                    {
                      ...V,
                      showCheckbox: e !== Ln.NONE && e !== Ln.FILE && e !== Ln.FILE_LIST,
                      onDblClick: (z) => {
                        const B = z.path.split("/").filter(Boolean).pop();
                        B && ($.pushPathPart(B), m?.($.currentPath));
                      },
                      onDrop: (z) => f?.(z, T)
                    }
                  ) : /* @__PURE__ */ C.jsx(
                    SX,
                    {
                      ...V,
                      showCheckbox: e !== Ln.NONE && e !== Ln.DIR && e !== Ln.DIR_LIST,
                      onMoveUpAFolder: s,
                      onDownload: a
                    }
                  );
                })
              ] }) })
            }
          ),
          /* @__PURE__ */ C.jsx(
            oX,
            {
              visible: $.createFolderModalVisible,
              onClose: () => $.setCreateFolderModalVisible(!1),
              onCreateFolder: async (T) => {
                d?.(T, $.currentPath), $.setCreateFolderModalVisible(!1);
              }
            }
          )
        ]
      }
    );
  }
), TX = (e) => `${e.isFolder ? "folder" : "file"}-${e.path}`;
var PX = Object.defineProperty, kX = (e, t, n) => t in e ? PX(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, NC = (e, t, n) => kX(e, t + "", n), Yg = function(e, t) {
  return Yg = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, Yg(e, t);
};
function pi(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Yg(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var G = function() {
  return G = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, G.apply(this, arguments);
};
function Ki(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function po(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(c) {
      try {
        u(r.next(c));
      } catch (f) {
        a(f);
      }
    }
    function l(c) {
      try {
        u(r.throw(c));
      } catch (f) {
        a(f);
      }
    }
    function u(c) {
      c.done ? o(c.value) : i(c.value).then(s, l);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function ho(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = s(0), a.throw = s(1), a.return = s(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, u[0] && (n = 0)), n; ) try {
      if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done) return o;
      switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = u;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(u);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function $n(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var Fv = "Invariant Violation", VS = Object.setPrototypeOf, DX = VS === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : VS, RC = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n) {
      n === void 0 && (n = Fv);
      var r = e.call(this, typeof n == "number" ? Fv + ": " + n + " (see https://github.com/apollographql/invariant-packages)" : n) || this;
      return r.framesToPop = 1, r.name = Fv, DX(r, t.prototype), r;
    }
    return t;
  })(Error)
);
function ra(e, t) {
  if (!e)
    throw new RC(t);
}
var MC = ["debug", "log", "warn", "error", "silent"], AX = MC.indexOf("log");
function bf(e) {
  return function() {
    if (MC.indexOf(e) >= AX) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = bf("debug"), e.log = bf("log"), e.warn = bf("warn"), e.error = bf("error");
})(ra || (ra = {}));
var B0 = "3.14.1";
function Yr(e) {
  try {
    return e();
  } catch {
  }
}
const Zd = Yr(function() {
  return globalThis;
}) || Yr(function() {
  return window;
}) || Yr(function() {
  return self;
}) || Yr(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Yr(function() {
  return Yr.constructor("return this")();
});
var KS = /* @__PURE__ */ new Map();
function Qg(e) {
  var t = KS.get(e) || 1;
  return KS.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function jC(e, t) {
  t === void 0 && (t = 0);
  var n = Qg("stringifyForDisplay");
  return JSON.stringify(e, function(r, i) {
    return i === void 0 ? n : i;
  }, t).split(JSON.stringify(n)).join("<undefined>");
}
function _f(e) {
  return function(t) {
    for (var n = [], r = 1; r < arguments.length; r++)
      n[r - 1] = arguments[r];
    if (typeof t == "number") {
      var i = t;
      t = U0(i), t || (t = q0(i, n), n = []);
    }
    e.apply(void 0, [t].concat(n));
  };
}
var Pe = Object.assign(function(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  e || ra(e, U0(t, n) || q0(t, n));
}, {
  debug: _f(ra.debug),
  log: _f(ra.log),
  warn: _f(ra.warn),
  error: _f(ra.error)
});
function qn(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return new RC(U0(e, t) || q0(e, t));
}
var BS = Symbol.for("ApolloErrorMessageHandler_" + B0);
function FC(e) {
  if (typeof e == "string")
    return e;
  try {
    return jC(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function U0(e, t) {
  if (t === void 0 && (t = []), !!e)
    return Zd[BS] && Zd[BS](e, t.map(FC));
}
function q0(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: B0,
      message: e,
      args: t.map(FC)
    })));
}
var Ht = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function CX(e, t) {
  throw new Error("Unexpected invariant triggered.");
}
var Jg = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
function zC(e) {
  var t = e.prototype.toJSON;
  typeof t == "function" || CX(), e.prototype.inspect = t, Jg && (e.prototype[Jg] = t);
}
var IX = /* @__PURE__ */ (function() {
  function e(n, r, i) {
    this.start = n.start, this.end = r.end, this.startToken = n, this.endToken = r, this.source = i;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      start: this.start,
      end: this.end
    };
  }, e;
})();
zC(IX);
var NX = /* @__PURE__ */ (function() {
  function e(n, r, i, o, a, s, l) {
    this.kind = n, this.start = r, this.end = i, this.line = o, this.column = a, this.value = l, this.prev = s, this.next = null;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, e;
})();
zC(NX);
function US(e) {
  return e != null && typeof e.kind == "string";
}
function Uf(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Uf = function(t) {
    return typeof t;
  } : Uf = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Uf(e);
}
var RX = 10, LC = 2;
function MX(e) {
  return lh(e, []);
}
function lh(e, t) {
  switch (Uf(e)) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? "[function ".concat(e.name, "]") : "[function]";
    case "object":
      return e === null ? "null" : jX(e, t);
    default:
      return String(e);
  }
}
function jX(e, t) {
  if (t.indexOf(e) !== -1)
    return "[Circular]";
  var n = [].concat(t, [e]), r = LX(e);
  if (r !== void 0) {
    var i = r.call(e);
    if (i !== e)
      return typeof i == "string" ? i : lh(i, n);
  } else if (Array.isArray(e))
    return zX(e, n);
  return FX(e, n);
}
function FX(e, t) {
  var n = Object.keys(e);
  if (n.length === 0)
    return "{}";
  if (t.length > LC)
    return "[" + VX(e) + "]";
  var r = n.map(function(i) {
    var o = lh(e[i], t);
    return i + ": " + o;
  });
  return "{ " + r.join(", ") + " }";
}
function zX(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > LC)
    return "[Array]";
  for (var n = Math.min(RX, e.length), r = e.length - n, i = [], o = 0; o < n; ++o)
    i.push(lh(e[o], t));
  return r === 1 ? i.push("... 1 more item") : r > 1 && i.push("... ".concat(r, " more items")), "[" + i.join(", ") + "]";
}
function LX(e) {
  var t = e[String(Jg)];
  if (typeof t == "function")
    return t;
  if (typeof e.inspect == "function")
    return e.inspect;
}
function VX(e) {
  var t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    var n = e.constructor.name;
    if (typeof n == "string" && n !== "")
      return n;
  }
  return t;
}
function KX(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = e.indexOf(`
`) === -1, i = e[0] === " " || e[0] === "	", o = e[e.length - 1] === '"', a = e[e.length - 1] === "\\", s = !r || o || a || n, l = "";
  return s && !(r && i) && (l += `
` + t), l += t ? e.replace(/\n/g, `
` + t) : e, s && (l += `
`), '"""' + l.replace(/"""/g, '\\"""') + '"""';
}
var BX = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, uh = Object.freeze({});
function si(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : BX, r = void 0, i = Array.isArray(e), o = [e], a = -1, s = [], l = void 0, u = void 0, c = void 0, f = [], d = [], p = e;
  do {
    a++;
    var h = a === o.length, v = h && s.length !== 0;
    if (h) {
      if (u = d.length === 0 ? void 0 : f[f.length - 1], l = c, c = d.pop(), v) {
        if (i)
          l = l.slice();
        else {
          for (var m = {}, g = 0, _ = Object.keys(l); g < _.length; g++) {
            var w = _[g];
            m[w] = l[w];
          }
          l = m;
        }
        for (var x = 0, S = 0; S < s.length; S++) {
          var $ = s[S][0], A = s[S][1];
          i && ($ -= x), i && A === null ? (l.splice($, 1), x++) : l[$] = A;
        }
      }
      a = r.index, o = r.keys, s = r.edits, i = r.inArray, r = r.prev;
    } else {
      if (u = c ? i ? a : o[a] : void 0, l = c ? c[u] : p, l == null)
        continue;
      c && f.push(u);
    }
    var E = void 0;
    if (!Array.isArray(l)) {
      if (!US(l))
        throw new Error("Invalid AST Node: ".concat(MX(l), "."));
      var y = UX(t, l.kind, h);
      if (y) {
        if (E = y.call(t, l, u, c, f, d), E === uh)
          break;
        if (E === !1) {
          if (!h) {
            f.pop();
            continue;
          }
        } else if (E !== void 0 && (s.push([u, E]), !h))
          if (US(E))
            l = E;
          else {
            f.pop();
            continue;
          }
      }
    }
    if (E === void 0 && v && s.push([u, l]), h)
      f.pop();
    else {
      var b;
      r = {
        inArray: i,
        index: a,
        keys: o,
        edits: s,
        prev: r
      }, i = Array.isArray(l), o = i ? l : (b = n[l.kind]) !== null && b !== void 0 ? b : [], a = -1, s = [], c && d.push(c), c = l;
    }
  } while (r !== void 0);
  return s.length !== 0 && (p = s[s.length - 1][1]), p;
}
function UX(e, t, n) {
  var r = e[t];
  if (r) {
    if (!n && typeof r == "function")
      return r;
    var i = n ? r.leave : r.enter;
    if (typeof i == "function")
      return i;
  } else {
    var o = n ? e.leave : e.enter;
    if (o) {
      if (typeof o == "function")
        return o;
      var a = o[t];
      if (typeof a == "function")
        return a;
    }
  }
}
function qX(e) {
  return si(e, {
    leave: WX
  });
}
var HX = 80, WX = {
  Name: function(e) {
    return e.value;
  },
  Variable: function(e) {
    return "$" + e.name;
  },
  // Document
  Document: function(e) {
    return je(e.definitions, `

`) + `
`;
  },
  OperationDefinition: function(e) {
    var t = e.operation, n = e.name, r = qt("(", je(e.variableDefinitions, ", "), ")"), i = je(e.directives, " "), o = e.selectionSet;
    return !n && !i && !r && t === "query" ? o : je([t, je([n, r]), i, o], " ");
  },
  VariableDefinition: function(e) {
    var t = e.variable, n = e.type, r = e.defaultValue, i = e.directives;
    return t + ": " + n + qt(" = ", r) + qt(" ", je(i, " "));
  },
  SelectionSet: function(e) {
    var t = e.selections;
    return Hr(t);
  },
  Field: function(e) {
    var t = e.alias, n = e.name, r = e.arguments, i = e.directives, o = e.selectionSet, a = qt("", t, ": ") + n, s = a + qt("(", je(r, ", "), ")");
    return s.length > HX && (s = a + qt(`(
`, qf(je(r, `
`)), `
)`)), je([s, je(i, " "), o], " ");
  },
  Argument: function(e) {
    var t = e.name, n = e.value;
    return t + ": " + n;
  },
  // Fragments
  FragmentSpread: function(e) {
    var t = e.name, n = e.directives;
    return "..." + t + qt(" ", je(n, " "));
  },
  InlineFragment: function(e) {
    var t = e.typeCondition, n = e.directives, r = e.selectionSet;
    return je(["...", qt("on ", t), je(n, " "), r], " ");
  },
  FragmentDefinition: function(e) {
    var t = e.name, n = e.typeCondition, r = e.variableDefinitions, i = e.directives, o = e.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(t).concat(qt("(", je(r, ", "), ")"), " ") + "on ".concat(n, " ").concat(qt("", je(i, " "), " ")) + o
    );
  },
  // Value
  IntValue: function(e) {
    var t = e.value;
    return t;
  },
  FloatValue: function(e) {
    var t = e.value;
    return t;
  },
  StringValue: function(e, t) {
    var n = e.value, r = e.block;
    return r ? KX(n, t === "description" ? "" : "  ") : JSON.stringify(n);
  },
  BooleanValue: function(e) {
    var t = e.value;
    return t ? "true" : "false";
  },
  NullValue: function() {
    return "null";
  },
  EnumValue: function(e) {
    var t = e.value;
    return t;
  },
  ListValue: function(e) {
    var t = e.values;
    return "[" + je(t, ", ") + "]";
  },
  ObjectValue: function(e) {
    var t = e.fields;
    return "{" + je(t, ", ") + "}";
  },
  ObjectField: function(e) {
    var t = e.name, n = e.value;
    return t + ": " + n;
  },
  // Directive
  Directive: function(e) {
    var t = e.name, n = e.arguments;
    return "@" + t + qt("(", je(n, ", "), ")");
  },
  // Type
  NamedType: function(e) {
    var t = e.name;
    return t;
  },
  ListType: function(e) {
    var t = e.type;
    return "[" + t + "]";
  },
  NonNullType: function(e) {
    var t = e.type;
    return t + "!";
  },
  // Type System Definitions
  SchemaDefinition: qr(function(e) {
    var t = e.directives, n = e.operationTypes;
    return je(["schema", je(t, " "), Hr(n)], " ");
  }),
  OperationTypeDefinition: function(e) {
    var t = e.operation, n = e.type;
    return t + ": " + n;
  },
  ScalarTypeDefinition: qr(function(e) {
    var t = e.name, n = e.directives;
    return je(["scalar", t, je(n, " ")], " ");
  }),
  ObjectTypeDefinition: qr(function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return je(["type", t, qt("implements ", je(n, " & ")), je(r, " "), Hr(i)], " ");
  }),
  FieldDefinition: qr(function(e) {
    var t = e.name, n = e.arguments, r = e.type, i = e.directives;
    return t + (qS(n) ? qt(`(
`, qf(je(n, `
`)), `
)`) : qt("(", je(n, ", "), ")")) + ": " + r + qt(" ", je(i, " "));
  }),
  InputValueDefinition: qr(function(e) {
    var t = e.name, n = e.type, r = e.defaultValue, i = e.directives;
    return je([t + ": " + n, qt("= ", r), je(i, " ")], " ");
  }),
  InterfaceTypeDefinition: qr(function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return je(["interface", t, qt("implements ", je(n, " & ")), je(r, " "), Hr(i)], " ");
  }),
  UnionTypeDefinition: qr(function(e) {
    var t = e.name, n = e.directives, r = e.types;
    return je(["union", t, je(n, " "), r && r.length !== 0 ? "= " + je(r, " | ") : ""], " ");
  }),
  EnumTypeDefinition: qr(function(e) {
    var t = e.name, n = e.directives, r = e.values;
    return je(["enum", t, je(n, " "), Hr(r)], " ");
  }),
  EnumValueDefinition: qr(function(e) {
    var t = e.name, n = e.directives;
    return je([t, je(n, " ")], " ");
  }),
  InputObjectTypeDefinition: qr(function(e) {
    var t = e.name, n = e.directives, r = e.fields;
    return je(["input", t, je(n, " "), Hr(r)], " ");
  }),
  DirectiveDefinition: qr(function(e) {
    var t = e.name, n = e.arguments, r = e.repeatable, i = e.locations;
    return "directive @" + t + (qS(n) ? qt(`(
`, qf(je(n, `
`)), `
)`) : qt("(", je(n, ", "), ")")) + (r ? " repeatable" : "") + " on " + je(i, " | ");
  }),
  SchemaExtension: function(e) {
    var t = e.directives, n = e.operationTypes;
    return je(["extend schema", je(t, " "), Hr(n)], " ");
  },
  ScalarTypeExtension: function(e) {
    var t = e.name, n = e.directives;
    return je(["extend scalar", t, je(n, " ")], " ");
  },
  ObjectTypeExtension: function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return je(["extend type", t, qt("implements ", je(n, " & ")), je(r, " "), Hr(i)], " ");
  },
  InterfaceTypeExtension: function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return je(["extend interface", t, qt("implements ", je(n, " & ")), je(r, " "), Hr(i)], " ");
  },
  UnionTypeExtension: function(e) {
    var t = e.name, n = e.directives, r = e.types;
    return je(["extend union", t, je(n, " "), r && r.length !== 0 ? "= " + je(r, " | ") : ""], " ");
  },
  EnumTypeExtension: function(e) {
    var t = e.name, n = e.directives, r = e.values;
    return je(["extend enum", t, je(n, " "), Hr(r)], " ");
  },
  InputObjectTypeExtension: function(e) {
    var t = e.name, n = e.directives, r = e.fields;
    return je(["extend input", t, je(n, " "), Hr(r)], " ");
  }
};
function qr(e) {
  return function(t) {
    return je([t.description, e(t)], `
`);
  };
}
function je(e) {
  var t, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (t = e?.filter(function(r) {
    return r;
  }).join(n)) !== null && t !== void 0 ? t : "";
}
function Hr(e) {
  return qt(`{
`, qf(je(e, `
`)), `
}`);
}
function qt(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return t != null && t !== "" ? e + t + n : "";
}
function qf(e) {
  return qt("  ", e.replace(/\n/g, `
  `));
}
function ZX(e) {
  return e.indexOf(`
`) !== -1;
}
function qS(e) {
  return e != null && e.some(ZX);
}
function HS(e) {
  return e.kind === Ht.FIELD || e.kind === Ht.FRAGMENT_SPREAD || e.kind === Ht.INLINE_FRAGMENT;
}
function Nc(e, t) {
  var n = e.directives;
  return !n || !n.length ? !0 : QX(n).every(function(r) {
    var i = r.directive, o = r.ifArgument, a = !1;
    return o.value.kind === "Variable" ? (a = t && t[o.value.name.value], Pe(a !== void 0, 105, i.name.value)) : a = o.value.value, i.name.value === "skip" ? !a : a;
  });
}
function ec(e, t, n) {
  var r = new Set(e), i = r.size;
  return si(t, {
    Directive: function(o) {
      if (r.delete(o.name.value) && (!n || !r.size))
        return uh;
    }
  }), n ? !r.size : r.size < i;
}
function GX(e) {
  return e && ec(["client", "export"], e, !0);
}
function YX(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function QX(e) {
  var t = [];
  return e && e.length && e.forEach(function(n) {
    if (YX(n)) {
      var r = n.arguments, i = n.name.value;
      Pe(r && r.length === 1, 106, i);
      var o = r[0];
      Pe(o.name && o.name.value === "if", 107, i);
      var a = o.value;
      Pe(a && (a.kind === "Variable" || a.kind === "BooleanValue"), 108, i), t.push({ directive: n, ifArgument: o });
    }
  }), t;
}
function JX(e) {
  var t, n, r = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(o) {
    var a = o.name;
    return a.value === "unmask";
  });
  if (!r)
    return "mask";
  var i = (n = r.arguments) === null || n === void 0 ? void 0 : n.find(function(o) {
    var a = o.name;
    return a.value === "mode";
  });
  return globalThis.__DEV__ !== !1 && i && (i.value.kind === Ht.VARIABLE ? globalThis.__DEV__ !== !1 && Pe.warn(109) : i.value.kind !== Ht.STRING ? globalThis.__DEV__ !== !1 && Pe.warn(110) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && Pe.warn(111, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const XX = () => /* @__PURE__ */ Object.create(null), { forEach: eee, slice: WS } = Array.prototype, { hasOwnProperty: tee } = Object.prototype;
class no {
  constructor(t = !0, n = XX) {
    this.weakness = t, this.makeData = n;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(t) {
    let n = this;
    return eee.call(t, (r) => n = n.getChildTrie(r)), tee.call(n, "data") ? n.data : n.data = this.makeData(WS.call(t));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(t) {
    let n = this;
    for (let r = 0, i = t.length; n && r < i; ++r) {
      const o = n.mapFor(t[r], !1);
      n = o && o.get(t[r]);
    }
    return n && n.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(t) {
    let n;
    if (t.length) {
      const r = t[0], i = this.mapFor(r, !1), o = i && i.get(r);
      o && (n = o.removeArray(WS.call(t, 1)), !o.data && !o.weak && !(o.strong && o.strong.size) && i.delete(r));
    } else
      n = this.data, delete this.data;
    return n;
  }
  getChildTrie(t) {
    const n = this.mapFor(t, !0);
    let r = n.get(t);
    return r || n.set(t, r = new no(this.weakness, this.makeData)), r;
  }
  mapFor(t, n) {
    return this.weakness && nee(t) ? this.weak || (n ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (n ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function nee(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var ree = Yr(function() {
  return navigator.product;
}) == "ReactNative", Ha = typeof WeakMap == "function" && !(ree && !global.HermesInternal), H0 = typeof WeakSet == "function", VC = typeof Symbol == "function" && typeof Symbol.for == "function", ch = VC && Symbol.asyncIterator;
Yr(function() {
  return window.document.createElement;
});
Yr(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function Lt(e) {
  return e !== null && typeof e == "object";
}
function iee(e, t) {
  var n = t, r = [];
  e.definitions.forEach(function(o) {
    if (o.kind === "OperationDefinition")
      throw qn(
        112,
        o.operation,
        o.name ? " named '".concat(o.name.value, "'") : ""
      );
    o.kind === "FragmentDefinition" && r.push(o);
  }), typeof n > "u" && (Pe(r.length === 1, 113, r.length), n = r[0].name.value);
  var i = G(G({}, e), { definitions: $n([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: n
            }
          }
        ]
      }
    }
  ], e.definitions, !0) });
  return i;
}
function Sl(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(n) {
    t[n.name.value] = n;
  }), t;
}
function fh(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var n = e.name.value;
      if (typeof t == "function")
        return t(n);
      var r = t && t[n];
      return Pe(r, 114, n), r || null;
    }
    default:
      return null;
  }
}
function oee(e) {
  var t = !0;
  return si(e, {
    FragmentSpread: function(n) {
      if (t = !!n.directives && n.directives.some(function(r) {
        return r.name.value === "unmask";
      }), !t)
        return uh;
    }
  }), t;
}
function aee() {
}
class Xg {
  constructor(t = 1 / 0, n = aee) {
    this.max = t, this.dispose = n, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const n = this.getNode(t);
    return n && n.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const n = this.map.get(t);
    if (n && n !== this.newest) {
      const { older: r, newer: i } = n;
      i && (i.older = r), r && (r.newer = i), n.older = this.newest, n.older.newer = n, n.newer = null, this.newest = n, n === this.oldest && (this.oldest = i);
    }
    return n;
  }
  set(t, n) {
    let r = this.getNode(t);
    return r ? r.value = n : (r = {
      key: t,
      value: n,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = r), this.newest = r, this.oldest = this.oldest || r, this.map.set(t, r), r.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const n = this.map.get(t);
    return n ? (n === this.newest && (this.newest = n.older), n === this.oldest && (this.oldest = n.newer), n.newer && (n.newer.older = n.older), n.older && (n.older.newer = n.newer), this.map.delete(t), this.dispose(n.value, t), !0) : !1;
  }
}
function ey() {
}
const see = ey, lee = typeof WeakRef < "u" ? WeakRef : function(e) {
  return { deref: () => e };
}, uee = typeof WeakMap < "u" ? WeakMap : Map, cee = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: ey,
    unregister: ey
  };
}, fee = 10024;
class Gd {
  constructor(t = 1 / 0, n = see) {
    this.max = t, this.dispose = n, this.map = new uee(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const r = this.unfinalizedNodes.values();
      for (let i = 0; i < fee; i++) {
        const o = r.next().value;
        if (!o)
          break;
        this.unfinalizedNodes.delete(o);
        const a = o.key;
        delete o.key, o.keyRef = new lee(a), this.registry.register(a, o, o);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new cee(this.deleteNode.bind(this));
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const n = this.getNode(t);
    return n && n.value;
  }
  getNode(t) {
    const n = this.map.get(t);
    if (n && n !== this.newest) {
      const { older: r, newer: i } = n;
      i && (i.older = r), r && (r.newer = i), n.older = this.newest, n.older.newer = n, n.newer = null, this.newest = n, n === this.oldest && (this.oldest = i);
    }
    return n;
  }
  set(t, n) {
    let r = this.getNode(t);
    return r ? r.value = n : (r = {
      key: t,
      value: n,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = r), this.newest = r, this.oldest = this.oldest || r, this.scheduleFinalization(r), this.map.set(t, r), this.size++, r.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(t) {
    t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
    const n = t.key || t.keyRef && t.keyRef.deref();
    this.dispose(t.value, n), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), n && this.map.delete(n);
  }
  delete(t) {
    const n = this.map.get(t);
    return n ? (this.deleteNode(n), !0) : !1;
  }
  scheduleFinalization(t) {
    this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var zv = /* @__PURE__ */ new WeakSet();
function KC(e) {
  e.size <= (e.max || -1) || zv.has(e) || (zv.add(e), setTimeout(function() {
    e.clean(), zv.delete(e);
  }, 100));
}
var BC = function(e, t) {
  var n = new Gd(e, t);
  return n.set = function(r, i) {
    var o = Gd.prototype.set.call(this, r, i);
    return KC(this), o;
  }, n;
}, dee = function(e, t) {
  var n = new Xg(e, t);
  return n.set = function(r, i) {
    var o = Xg.prototype.set.call(this, r, i);
    return KC(this), o;
  }, n;
}, pee = Symbol.for("apollo.cacheSize"), Ji = G({}, Zd[pee]), Xo = {};
function UC(e, t) {
  Xo[e] = t;
}
var hee = globalThis.__DEV__ !== !1 ? yee : void 0, vee = globalThis.__DEV__ !== !1 ? bee : void 0, mee = globalThis.__DEV__ !== !1 ? qC : void 0;
function gee() {
  var e = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(e).map(function(t) {
    var n = t[0], r = t[1];
    return [
      n,
      Ji[n] || r
    ];
  }));
}
function yee() {
  var e, t, n, r, i;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: gee(),
    sizes: G({ print: (e = Xo.print) === null || e === void 0 ? void 0 : e.call(Xo), parser: (t = Xo.parser) === null || t === void 0 ? void 0 : t.call(Xo), canonicalStringify: (n = Xo.canonicalStringify) === null || n === void 0 ? void 0 : n.call(Xo), links: ny(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: WC(this.queryManager.documentTransform)
    } }, (i = (r = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(r))
  };
}
function qC() {
  return {
    cache: {
      fragmentQueryDocuments: vo(this.getFragmentDoc)
    }
  };
}
function bee() {
  var e = this.config.fragments;
  return G(G({}, qC.apply(this)), { addTypenameDocumentTransform: WC(this.addTypenameTransform), inMemoryCache: {
    executeSelectionSet: vo(this.storeReader.executeSelectionSet),
    executeSubSelectedArray: vo(this.storeReader.executeSubSelectedArray),
    maybeBroadcastWatch: vo(this.maybeBroadcastWatch)
  }, fragmentRegistry: {
    findFragmentSpreads: vo(e?.findFragmentSpreads),
    lookup: vo(e?.lookup),
    transform: vo(e?.transform)
  } });
}
function _ee(e) {
  return !!e && "dirtyKey" in e;
}
function vo(e) {
  return _ee(e) ? e.size : void 0;
}
function HC(e) {
  return e != null;
}
function WC(e) {
  return ty(e).map(function(t) {
    return { cache: t };
  });
}
function ty(e) {
  return e ? $n($n([
    vo(e?.performWork)
  ], ty(e?.left), !0), ty(e?.right), !0).filter(HC) : [];
}
function ny(e) {
  var t;
  return e ? $n($n([
    (t = e?.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
  ], ny(e?.left), !0), ny(e?.right), !0).filter(HC) : [];
}
var Oo = Object.assign(function(e) {
  return JSON.stringify(e, wee);
}, {
  reset: function() {
    vs = new dee(
      Ji.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && UC("canonicalStringify", function() {
  return vs.size;
});
var vs;
Oo.reset();
function wee(e, t) {
  if (t && typeof t == "object") {
    var n = Object.getPrototypeOf(t);
    if (n === Object.prototype || n === null) {
      var r = Object.keys(t);
      if (r.every(xee))
        return t;
      var i = JSON.stringify(r), o = vs.get(i);
      if (!o) {
        r.sort();
        var a = JSON.stringify(r);
        o = vs.get(a) || r, vs.set(i, o), vs.set(a, o);
      }
      var s = Object.create(n);
      return o.forEach(function(l) {
        s[l] = t[l];
      }), s;
    }
  }
  return t;
}
function xee(e, t, n) {
  return t === 0 || n[t - 1] <= e;
}
function Ts(e) {
  return { __ref: String(e) };
}
function _t(e) {
  return !!(e && typeof e == "object" && typeof e.__ref == "string");
}
function Eee(e) {
  return Lt(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function See(e) {
  return e.kind === "StringValue";
}
function Oee(e) {
  return e.kind === "BooleanValue";
}
function $ee(e) {
  return e.kind === "IntValue";
}
function Tee(e) {
  return e.kind === "FloatValue";
}
function Pee(e) {
  return e.kind === "Variable";
}
function kee(e) {
  return e.kind === "ObjectValue";
}
function Dee(e) {
  return e.kind === "ListValue";
}
function Aee(e) {
  return e.kind === "EnumValue";
}
function Cee(e) {
  return e.kind === "NullValue";
}
function Ys(e, t, n, r) {
  if ($ee(n) || Tee(n))
    e[t.value] = Number(n.value);
  else if (Oee(n) || See(n))
    e[t.value] = n.value;
  else if (kee(n)) {
    var i = {};
    n.fields.map(function(a) {
      return Ys(i, a.name, a.value, r);
    }), e[t.value] = i;
  } else if (Pee(n)) {
    var o = (r || {})[n.name.value];
    e[t.value] = o;
  } else if (Dee(n))
    e[t.value] = n.values.map(function(a) {
      var s = {};
      return Ys(s, t, a, r), s[t.value];
    });
  else if (Aee(n))
    e[t.value] = n.value;
  else if (Cee(n))
    e[t.value] = null;
  else
    throw qn(123, t.value, n.kind);
}
function Iee(e, t) {
  var n = null;
  e.directives && (n = {}, e.directives.forEach(function(i) {
    n[i.name.value] = {}, i.arguments && i.arguments.forEach(function(o) {
      var a = o.name, s = o.value;
      return Ys(n[i.name.value], a, s, t);
    });
  }));
  var r = null;
  return e.arguments && e.arguments.length && (r = {}, e.arguments.forEach(function(i) {
    var o = i.name, a = i.value;
    return Ys(r, o, a, t);
  })), ZC(e.name.value, r, n);
}
var Nee = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], Bl = Oo, ZC = Object.assign(function(e, t, n) {
  if (t && n && n.connection && n.connection.key)
    if (n.connection.filter && n.connection.filter.length > 0) {
      var r = n.connection.filter ? n.connection.filter : [];
      r.sort();
      var i = {};
      return r.forEach(function(s) {
        i[s] = t[s];
      }), "".concat(n.connection.key, "(").concat(Bl(i), ")");
    } else
      return n.connection.key;
  var o = e;
  if (t) {
    var a = Bl(t);
    o += "(".concat(a, ")");
  }
  return n && Object.keys(n).forEach(function(s) {
    Nee.indexOf(s) === -1 && (n[s] && Object.keys(n[s]).length ? o += "@".concat(s, "(").concat(Bl(n[s]), ")") : o += "@".concat(s));
  }), o;
}, {
  setStringify: function(e) {
    var t = Bl;
    return Bl = e, t;
  }
});
function dh(e, t) {
  if (e.arguments && e.arguments.length) {
    var n = {};
    return e.arguments.forEach(function(r) {
      var i = r.name, o = r.value;
      return Ys(n, i, o, t);
    }), n;
  }
  return null;
}
function Xi(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function ry(e, t, n) {
  for (var r, i = 0, o = t.selections; i < o.length; i++) {
    var a = o[i];
    if (Io(a)) {
      if (a.name.value === "__typename")
        return e[Xi(a)];
    } else r ? r.push(a) : r = [a];
  }
  if (typeof e.__typename == "string")
    return e.__typename;
  if (r)
    for (var s = 0, l = r; s < l.length; s++) {
      var a = l[s], u = ry(e, fh(a, n).selectionSet, n);
      if (typeof u == "string")
        return u;
    }
}
function Io(e) {
  return e.kind === "Field";
}
function Ree(e) {
  return e.kind === "InlineFragment";
}
function Ol(e) {
  Pe(e && e.kind === "Document", 115);
  var t = e.definitions.filter(function(n) {
    return n.kind !== "FragmentDefinition";
  }).map(function(n) {
    if (n.kind !== "OperationDefinition")
      throw qn(116, n.kind);
    return n;
  });
  return Pe(t.length <= 1, 117, t.length), e;
}
function ka(e) {
  return Ol(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function nu(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function $l(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function GC(e) {
  var t = ka(e);
  return Pe(t && t.operation === "query", 118), t;
}
function YC(e) {
  Pe(e.kind === "Document", 119), Pe(e.definitions.length <= 1, 120);
  var t = e.definitions[0];
  return Pe(t.kind === "FragmentDefinition", 121), t;
}
function Rc(e) {
  Ol(e);
  for (var t, n = 0, r = e.definitions; n < r.length; n++) {
    var i = r[n];
    if (i.kind === "OperationDefinition") {
      var o = i.operation;
      if (o === "query" || o === "mutation" || o === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !t && (t = i);
  }
  if (t)
    return t;
  throw qn(122);
}
function W0(e) {
  var t = /* @__PURE__ */ Object.create(null), n = e && e.variableDefinitions;
  return n && n.length && n.forEach(function(r) {
    r.defaultValue && Ys(t, r.variable.name, r.defaultValue);
  }), t;
}
let bn = null;
const ZS = {};
let Mee = 1;
const jee = () => class {
  constructor() {
    this.id = [
      "slot",
      Mee++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let e = bn; e; e = e.parent)
      if (this.id in e.slots) {
        const t = e.slots[this.id];
        if (t === ZS)
          break;
        return e !== bn && (bn.slots[this.id] = t), !0;
      }
    return bn && (bn.slots[this.id] = ZS), !1;
  }
  getValue() {
    if (this.hasValue())
      return bn.slots[this.id];
  }
  withValue(e, t, n, r) {
    const i = {
      __proto__: null,
      [this.id]: e
    }, o = bn;
    bn = { parent: o, slots: i };
    try {
      return t.apply(r, n);
    } finally {
      bn = o;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(e) {
    const t = bn;
    return function() {
      const n = bn;
      try {
        return bn = t, e.apply(this, arguments);
      } finally {
        bn = n;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(e, t, n) {
    if (bn) {
      const r = bn;
      try {
        return bn = null, e.apply(n, t);
      } finally {
        bn = r;
      }
    } else
      return e.apply(n, t);
  }
};
function GS(e) {
  try {
    return e();
  } catch {
  }
}
const Lv = "@wry/context:Slot", Fee = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  GS(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  GS(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), YS = Fee, Tl = YS[Lv] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Lv] || (function(e) {
  try {
    Object.defineProperty(YS, Lv, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
})(jee()), { bind: due, noContext: pue } = Tl, ph = new Tl(), { hasOwnProperty: zee } = Object.prototype, Z0 = Array.from || function(e) {
  const t = [];
  return e.forEach((n) => t.push(n)), t;
};
function G0(e) {
  const { unsubscribe: t } = e;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
const tc = [], Lee = 100;
function Qs(e, t) {
  if (!e)
    throw new Error(t || "assertion failure");
}
function QC(e, t) {
  const n = e.length;
  return (
    // Unknown values are not equal to each other.
    n > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    n === t.length && // The underlying value or exception must be the same.
    e[n - 1] === t[n - 1]
  );
}
function JC(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function XC(e) {
  return e.slice(0);
}
class hh {
  constructor(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++hh.count;
  }
  peek() {
    if (this.value.length === 1 && !No(this))
      return QS(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(t) {
    return Qs(!this.recomputing, "already recomputing"), QS(this), No(this) ? Vee(this, t) : JC(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, eI(this), G0(this));
  }
  dispose() {
    this.setDirty(), oI(this), Y0(this, (t, n) => {
      t.setDirty(), aI(t, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(t) {
    t.add(this), this.deps || (this.deps = tc.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }
  forgetDeps() {
    this.deps && (Z0(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), tc.push(this.deps), this.deps = null);
  }
}
hh.count = 0;
function QS(e) {
  const t = ph.getValue();
  if (t)
    return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), No(e) ? nI(t, e) : rI(t, e), t;
}
function Vee(e, t) {
  return oI(e), ph.withValue(e, Kee, [e, t]), Uee(e, t) && Bee(e), JC(e.value);
}
function Kee(e, t) {
  e.recomputing = !0;
  const { normalizeResult: n } = e;
  let r;
  n && e.value.length === 1 && (r = XC(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, t), n && r && !QC(r, e.value))
      try {
        e.value[0] = n(e.value[0], r[0]);
      } catch {
      }
  } catch (i) {
    e.value[1] = i;
  }
  e.recomputing = !1;
}
function No(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function Bee(e) {
  e.dirty = !1, !No(e) && tI(e);
}
function eI(e) {
  Y0(e, nI);
}
function tI(e) {
  Y0(e, rI);
}
function Y0(e, t) {
  const n = e.parents.size;
  if (n) {
    const r = Z0(e.parents);
    for (let i = 0; i < n; ++i)
      t(r[i], e);
  }
}
function nI(e, t) {
  Qs(e.childValues.has(t)), Qs(No(t));
  const n = !No(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = tc.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(t))
    return;
  e.dirtyChildren.add(t), n && eI(e);
}
function rI(e, t) {
  Qs(e.childValues.has(t)), Qs(!No(t));
  const n = e.childValues.get(t);
  n.length === 0 ? e.childValues.set(t, XC(t.value)) : QC(n, t.value) || e.setDirty(), iI(e, t), !No(e) && tI(e);
}
function iI(e, t) {
  const n = e.dirtyChildren;
  n && (n.delete(t), n.size === 0 && (tc.length < Lee && tc.push(n), e.dirtyChildren = null));
}
function oI(e) {
  e.childValues.size > 0 && e.childValues.forEach((t, n) => {
    aI(e, n);
  }), e.forgetDeps(), Qs(e.dirtyChildren === null);
}
function aI(e, t) {
  t.parents.delete(e), e.childValues.delete(t), iI(e, t);
}
function Uee(e, t) {
  if (typeof e.subscribe == "function")
    try {
      G0(e), e.unsubscribe = e.subscribe.apply(null, t);
    } catch {
      return e.setDirty(), !1;
    }
  return !0;
}
const qee = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function sI(e) {
  const t = /* @__PURE__ */ new Map();
  function n(r) {
    const i = ph.getValue();
    if (i) {
      let o = t.get(r);
      o || t.set(r, o = /* @__PURE__ */ new Set()), i.dependOn(o);
    }
  }
  return n.dirty = function(r, i) {
    const o = t.get(r);
    if (o) {
      const a = i && zee.call(qee, i) ? i : "setDirty";
      Z0(o).forEach((s) => s[a]()), t.delete(r), G0(o);
    }
  }, n;
}
let JS;
function Hee(...e) {
  return (JS || (JS = new no(typeof WeakMap == "function"))).lookupArray(e);
}
const Vv = /* @__PURE__ */ new Set();
function nc(e, { max: t = Math.pow(2, 16), keyArgs: n, makeCacheKey: r = Hee, normalizeResult: i, subscribe: o, cache: a = Xg } = /* @__PURE__ */ Object.create(null)) {
  const s = typeof a == "function" ? new a(t, (d) => d.dispose()) : a, l = function() {
    const d = r.apply(null, n ? n.apply(null, arguments) : arguments);
    if (d === void 0)
      return e.apply(null, arguments);
    let p = s.get(d);
    p || (s.set(d, p = new hh(e)), p.normalizeResult = i, p.subscribe = o, p.forget = () => s.delete(d));
    const h = p.recompute(Array.prototype.slice.call(arguments));
    return s.set(d, p), Vv.add(s), ph.hasValue() || (Vv.forEach((v) => v.clean()), Vv.clear()), h;
  };
  Object.defineProperty(l, "size", {
    get: () => s.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(l.options = {
    max: t,
    keyArgs: n,
    makeCacheKey: r,
    normalizeResult: i,
    subscribe: o,
    cache: s
  });
  function u(d) {
    const p = d && s.get(d);
    p && p.setDirty();
  }
  l.dirtyKey = u, l.dirty = function() {
    u(r.apply(null, arguments));
  };
  function c(d) {
    const p = d && s.get(d);
    if (p)
      return p.peek();
  }
  l.peekKey = c, l.peek = function() {
    return c(r.apply(null, arguments));
  };
  function f(d) {
    return d ? s.delete(d) : !1;
  }
  return l.forgetKey = f, l.forget = function() {
    return f(r.apply(null, arguments));
  }, l.makeCacheKey = r, l.getKey = n ? function() {
    return r.apply(null, n.apply(null, arguments));
  } : r, Object.freeze(l);
}
function Wee(e) {
  return e;
}
var lI = (
  /** @class */
  (function() {
    function e(t, n) {
      n === void 0 && (n = /* @__PURE__ */ Object.create(null)), this.resultCache = H0 ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, n.getCacheKey && (this.getCacheKey = n.getCacheKey), this.cached = n.cache !== !1, this.resetCache();
    }
    return e.prototype.getCacheKey = function(t) {
      return [t];
    }, e.identity = function() {
      return new e(Wee, { cache: !1 });
    }, e.split = function(t, n, r) {
      return r === void 0 && (r = e.identity()), Object.assign(new e(
        function(i) {
          var o = t(i) ? n : r;
          return o.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: n, right: r });
    }, e.prototype.resetCache = function() {
      var t = this;
      if (this.cached) {
        var n = new no(Ha);
        this.performWork = nc(e.prototype.performWork.bind(this), {
          makeCacheKey: function(r) {
            var i = t.getCacheKey(r);
            if (i)
              return Pe(Array.isArray(i), 104), n.lookupArray(i);
          },
          max: Ji["documentTransform.cache"],
          cache: Gd
        });
      }
    }, e.prototype.performWork = function(t) {
      return Ol(t), this.transform(t);
    }, e.prototype.transformDocument = function(t) {
      if (this.resultCache.has(t))
        return t;
      var n = this.performWork(t);
      return this.resultCache.add(n), n;
    }, e.prototype.concat = function(t) {
      var n = this;
      return Object.assign(new e(
        function(r) {
          return t.transformDocument(n.transformDocument(r));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: t
      });
    }, e;
  })()
), _u, Eo = Object.assign(function(e) {
  var t = _u.get(e);
  return t || (t = qX(e), _u.set(e, t)), t;
}, {
  reset: function() {
    _u = new BC(
      Ji.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
Eo.reset();
globalThis.__DEV__ !== !1 && UC("print", function() {
  return _u ? _u.size : 0;
});
var Xt = Array.isArray;
function Di(e) {
  return Array.isArray(e) && e.length > 0;
}
var XS = {
  kind: Ht.FIELD,
  name: {
    kind: Ht.NAME,
    value: "__typename"
  }
};
function uI(e, t) {
  return !e || e.selectionSet.selections.every(function(n) {
    return n.kind === Ht.FRAGMENT_SPREAD && uI(t[n.name.value], t);
  });
}
function Zee(e) {
  return uI(ka(e) || YC(e), Sl($l(e))) ? null : e;
}
function Gee(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  return e.forEach(function(r) {
    r && (r.name ? t.set(r.name, r) : r.test && n.set(r.test, r));
  }), function(r) {
    var i = t.get(r.name.value);
    return !i && n.size && n.forEach(function(o, a) {
      a(r) && (i = o);
    }), i;
  };
}
function e2(e) {
  var t = /* @__PURE__ */ new Map();
  return function(n) {
    n === void 0 && (n = e);
    var r = t.get(n);
    return r || t.set(n, r = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), r;
  };
}
function cI(e, t) {
  Ol(t);
  for (var n = e2(""), r = e2(""), i = function(g) {
    for (var _ = 0, w = void 0; _ < g.length && (w = g[_]); ++_)
      if (!Xt(w)) {
        if (w.kind === Ht.OPERATION_DEFINITION)
          return n(w.name && w.name.value);
        if (w.kind === Ht.FRAGMENT_DEFINITION)
          return r(w.name.value);
      }
    return globalThis.__DEV__ !== !1 && Pe.error(124), null;
  }, o = 0, a = t.definitions.length - 1; a >= 0; --a)
    t.definitions[a].kind === Ht.OPERATION_DEFINITION && ++o;
  var s = Gee(e), l = function(g) {
    return Di(g) && g.map(s).some(function(_) {
      return _ && _.remove;
    });
  }, u = /* @__PURE__ */ new Map(), c = !1, f = {
    enter: function(g) {
      if (l(g.directives))
        return c = !0, null;
    }
  }, d = si(t, {
    // These two AST node types share the same implementation, defined above.
    Field: f,
    InlineFragment: f,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(g, _, w, x, S) {
        var $ = i(S);
        $ && $.variables.add(g.name.value);
      }
    },
    FragmentSpread: {
      enter: function(g, _, w, x, S) {
        if (l(g.directives))
          return c = !0, null;
        var $ = i(S);
        $ && $.fragmentSpreads.add(g.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(g, _, w, x) {
        u.set(JSON.stringify(x), g);
      },
      leave: function(g, _, w, x) {
        var S = u.get(JSON.stringify(x));
        if (g === S)
          return g;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          o > 0 && g.selectionSet.selections.every(function($) {
            return $.kind === Ht.FIELD && $.name.value === "__typename";
          })
        )
          return r(g.name.value).removed = !0, c = !0, null;
      }
    },
    Directive: {
      leave: function(g) {
        if (s(g))
          return c = !0, null;
      }
    }
  });
  if (!c)
    return t;
  var p = function(g) {
    return g.transitiveVars || (g.transitiveVars = new Set(g.variables), g.removed || g.fragmentSpreads.forEach(function(_) {
      p(r(_)).transitiveVars.forEach(function(w) {
        g.transitiveVars.add(w);
      });
    })), g;
  }, h = /* @__PURE__ */ new Set();
  d.definitions.forEach(function(g) {
    g.kind === Ht.OPERATION_DEFINITION ? p(n(g.name && g.name.value)).fragmentSpreads.forEach(function(_) {
      h.add(_);
    }) : g.kind === Ht.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    o === 0 && !r(g.name.value).removed && h.add(g.name.value);
  }), h.forEach(function(g) {
    p(r(g)).fragmentSpreads.forEach(function(_) {
      h.add(_);
    });
  });
  var v = function(g) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!h.has(g) || r(g).removed);
  }, m = {
    enter: function(g) {
      if (v(g.name.value))
        return null;
    }
  };
  return Zee(si(d, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: m,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: m,
    OperationDefinition: {
      leave: function(g) {
        if (g.variableDefinitions) {
          var _ = p(
            // If an operation is anonymous, we use the empty string as its key.
            n(g.name && g.name.value)
          ).transitiveVars;
          if (_.size < g.variableDefinitions.length)
            return G(G({}, g), { variableDefinitions: g.variableDefinitions.filter(function(w) {
              return _.has(w.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var Q0 = Object.assign(function(e) {
  return si(e, {
    SelectionSet: {
      enter: function(t, n, r) {
        if (!(r && r.kind === Ht.OPERATION_DEFINITION)) {
          var i = t.selections;
          if (i) {
            var o = i.some(function(s) {
              return Io(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!o) {
              var a = r;
              if (!(Io(a) && a.directives && a.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return G(G({}, t), { selections: $n($n([], i, !0), [XS], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === XS;
  }
});
function Yee(e) {
  var t = Rc(e), n = t.operation;
  if (n === "query")
    return e;
  var r = si(e, {
    OperationDefinition: {
      enter: function(i) {
        return G(G({}, i), { operation: "query" });
      }
    }
  });
  return r;
}
function fI(e) {
  Ol(e);
  var t = cI([
    {
      test: function(n) {
        return n.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return t;
}
function Qee(e) {
  return Ol(e), si(e, {
    FragmentSpread: function(t) {
      var n;
      if (!(!((n = t.directives) === null || n === void 0) && n.some(function(r) {
        return r.name.value === "unmask";
      })))
        return G(G({}, t), { directives: $n($n([], t.directives || [], !0), [
          {
            kind: Ht.DIRECTIVE,
            name: { kind: Ht.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var Jee = Object.prototype.hasOwnProperty;
function t2() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return vh(e);
}
function vh(e) {
  var t = e[0] || {}, n = e.length;
  if (n > 1)
    for (var r = new Ro(), i = 1; i < n; ++i)
      t = r.merge(t, e[i]);
  return t;
}
var Xee = function(e, t, n) {
  return this.merge(e[n], t[n]);
}, Ro = (
  /** @class */
  (function() {
    function e(t) {
      t === void 0 && (t = Xee), this.reconciler = t, this.isObject = Lt, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(t, n) {
      for (var r = this, i = [], o = 2; o < arguments.length; o++)
        i[o - 2] = arguments[o];
      return Lt(n) && Lt(t) ? (Object.keys(n).forEach(function(a) {
        if (Jee.call(t, a)) {
          var s = t[a];
          if (n[a] !== s) {
            var l = r.reconciler.apply(r, $n([
              t,
              n,
              a
            ], i, !1));
            l !== s && (t = r.shallowCopyForMerge(t), t[a] = l);
          }
        } else
          t = r.shallowCopyForMerge(t), t[a] = n[a];
      }), t) : n;
    }, e.prototype.shallowCopyForMerge = function(t) {
      return Lt(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = G({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
    }, e;
  })()
);
function ete(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = tte(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function tte(e, t) {
  if (e) {
    if (typeof e == "string") return n2(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return n2(e, t);
  }
}
function n2(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function r2(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function J0(e, t, n) {
  return t && r2(e.prototype, t), n && r2(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var X0 = function() {
  return typeof Symbol == "function";
}, e_ = function(e) {
  return X0() && !!Symbol[e];
}, t_ = function(e) {
  return e_(e) ? Symbol[e] : "@@" + e;
};
X0() && !e_("observable") && (Symbol.observable = Symbol("observable"));
var nte = t_("iterator"), iy = t_("observable"), dI = t_("species");
function Yd(e, t) {
  var n = e[t];
  if (n != null) {
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    return n;
  }
}
function Ul(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[dI], t === null && (t = void 0)), t !== void 0 ? t : St;
}
function rte(e) {
  return e instanceof St;
}
function Js(e) {
  Js.log ? Js.log(e) : setTimeout(function() {
    throw e;
  });
}
function Hf(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      Js(t);
    }
  });
}
function pI(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var n = Yd(t, "unsubscribe");
        n && n.call(t);
      }
    } catch (r) {
      Js(r);
    }
}
function oy(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function ite(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var n = 0; n < t.length && (hI(e, t[n].type, t[n].value), e._state !== "closed"); ++n)
      ;
  }
}
function hI(e, t, n) {
  e._state = "running";
  var r = e._observer;
  try {
    var i = Yd(r, t);
    switch (t) {
      case "next":
        i && i.call(r, n);
        break;
      case "error":
        if (oy(e), i) i.call(r, n);
        else throw n;
        break;
      case "complete":
        oy(e), i && i.call(r);
        break;
    }
  } catch (o) {
    Js(o);
  }
  e._state === "closed" ? pI(e) : e._state === "running" && (e._state = "ready");
}
function Kv(e, t, n) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: n
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: n
      }], Hf(function() {
        return ite(e);
      });
      return;
    }
    hI(e, t, n);
  }
}
var ote = /* @__PURE__ */ (function() {
  function e(n, r) {
    this._cleanup = void 0, this._observer = n, this._queue = void 0, this._state = "initializing";
    var i = new ate(this);
    try {
      this._cleanup = r.call(void 0, i);
    } catch (o) {
      i.error(o);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (oy(this), pI(this));
  }, J0(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
})(), ate = /* @__PURE__ */ (function() {
  function e(n) {
    this._subscription = n;
  }
  var t = e.prototype;
  return t.next = function(n) {
    Kv(this._subscription, "next", n);
  }, t.error = function(n) {
    Kv(this._subscription, "error", n);
  }, t.complete = function() {
    Kv(this._subscription, "complete");
  }, J0(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
})(), St = /* @__PURE__ */ (function() {
  function e(n) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof n != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = n;
  }
  var t = e.prototype;
  return t.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new ote(n, this._subscriber);
  }, t.forEach = function(n) {
    var r = this;
    return new Promise(function(i, o) {
      if (typeof n != "function") {
        o(new TypeError(n + " is not a function"));
        return;
      }
      function a() {
        s.unsubscribe(), i();
      }
      var s = r.subscribe({
        next: function(l) {
          try {
            n(l, a);
          } catch (u) {
            o(u), s.unsubscribe();
          }
        },
        error: o,
        complete: i
      });
    });
  }, t.map = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Ul(this);
    return new i(function(o) {
      return r.subscribe({
        next: function(a) {
          try {
            a = n(a);
          } catch (s) {
            return o.error(s);
          }
          o.next(a);
        },
        error: function(a) {
          o.error(a);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.filter = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Ul(this);
    return new i(function(o) {
      return r.subscribe({
        next: function(a) {
          try {
            if (!n(a)) return;
          } catch (s) {
            return o.error(s);
          }
          o.next(a);
        },
        error: function(a) {
          o.error(a);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.reduce = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Ul(this), o = arguments.length > 1, a = !1, s = arguments[1], l = s;
    return new i(function(u) {
      return r.subscribe({
        next: function(c) {
          var f = !a;
          if (a = !0, !f || o)
            try {
              l = n(l, c);
            } catch (d) {
              return u.error(d);
            }
          else
            l = c;
        },
        error: function(c) {
          u.error(c);
        },
        complete: function() {
          if (!a && !o) return u.error(new TypeError("Cannot reduce an empty sequence"));
          u.next(l), u.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var n = this, r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    var a = Ul(this);
    return new a(function(s) {
      var l, u = 0;
      function c(f) {
        l = f.subscribe({
          next: function(d) {
            s.next(d);
          },
          error: function(d) {
            s.error(d);
          },
          complete: function() {
            u === i.length ? (l = void 0, s.complete()) : c(a.from(i[u++]));
          }
        });
      }
      return c(n), function() {
        l && (l.unsubscribe(), l = void 0);
      };
    });
  }, t.flatMap = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Ul(this);
    return new i(function(o) {
      var a = [], s = r.subscribe({
        next: function(u) {
          if (n)
            try {
              u = n(u);
            } catch (f) {
              return o.error(f);
            }
          var c = i.from(u).subscribe({
            next: function(f) {
              o.next(f);
            },
            error: function(f) {
              o.error(f);
            },
            complete: function() {
              var f = a.indexOf(c);
              f >= 0 && a.splice(f, 1), l();
            }
          });
          a.push(c);
        },
        error: function(u) {
          o.error(u);
        },
        complete: function() {
          l();
        }
      });
      function l() {
        s.closed && a.length === 0 && o.complete();
      }
      return function() {
        a.forEach(function(u) {
          return u.unsubscribe();
        }), s.unsubscribe();
      };
    });
  }, t[iy] = function() {
    return this;
  }, e.from = function(n) {
    var r = typeof this == "function" ? this : e;
    if (n == null) throw new TypeError(n + " is not an object");
    var i = Yd(n, iy);
    if (i) {
      var o = i.call(n);
      if (Object(o) !== o) throw new TypeError(o + " is not an object");
      return rte(o) && o.constructor === r ? o : new r(function(a) {
        return o.subscribe(a);
      });
    }
    if (e_("iterator") && (i = Yd(n, nte), i))
      return new r(function(a) {
        Hf(function() {
          if (!a.closed) {
            for (var s = ete(i.call(n)), l; !(l = s()).done; ) {
              var u = l.value;
              if (a.next(u), a.closed) return;
            }
            a.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new r(function(a) {
        Hf(function() {
          if (!a.closed) {
            for (var s = 0; s < n.length; ++s)
              if (a.next(n[s]), a.closed) return;
            a.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, e.of = function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    var o = typeof this == "function" ? this : e;
    return new o(function(a) {
      Hf(function() {
        if (!a.closed) {
          for (var s = 0; s < r.length; ++s)
            if (a.next(r[s]), a.closed) return;
          a.complete();
        }
      });
    });
  }, J0(e, null, [{
    key: dI,
    get: function() {
      return this;
    }
  }]), e;
})();
X0() && Object.defineProperty(St, Symbol("extensions"), {
  value: {
    symbol: iy,
    hostReportError: Js
  },
  configurable: !0
});
function ste(e) {
  var t, n = e.Symbol;
  if (typeof n == "function")
    if (n.observable)
      t = n.observable;
    else {
      typeof n.for == "function" ? t = n.for("https://github.com/benlesh/symbol-observable") : t = n("https://github.com/benlesh/symbol-observable");
      try {
        n.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var rs;
typeof self < "u" ? rs = self : typeof window < "u" ? rs = window : typeof global < "u" ? rs = global : typeof module < "u" ? rs = module : rs = Function("return this")();
ste(rs);
var i2 = St.prototype, o2 = "@@observable";
i2[o2] || (i2[o2] = function() {
  return this;
});
function lte(e) {
  return e.catch(function() {
  }), e;
}
var ute = Object.prototype.toString;
function vI(e) {
  return ay(e);
}
function ay(e, t) {
  switch (ute.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var n = e.slice(0);
      return t.set(e, n), n.forEach(function(i, o) {
        n[o] = ay(i, t);
      }), n;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = Object.create(Object.getPrototypeOf(e));
      return t.set(e, r), Object.keys(e).forEach(function(i) {
        r[i] = ay(e[i], t);
      }), r;
    }
    default:
      return e;
  }
}
function cte(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(n) {
    Lt(n) && fte(n) === n && Object.getOwnPropertyNames(n).forEach(function(r) {
      Lt(n[r]) && t.add(n[r]);
    });
  }), e;
}
function fte(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function Qd(e) {
  return globalThis.__DEV__ !== !1 && cte(e), e;
}
function wu(e, t, n) {
  var r = [];
  e.forEach(function(i) {
    return i[t] && r.push(i);
  }), r.forEach(function(i) {
    return i[t](n);
  });
}
function Bv(e, t, n) {
  return new St(function(r) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(l) {
        return new Promise(function(u) {
          return u(l());
        });
      }
    };
    function o(l, u) {
      return function(c) {
        if (l) {
          var f = function() {
            return r.closed ? (
              /* will be swallowed */
              0
            ) : l(c);
          };
          i = i.then(f, f).then(function(d) {
            return r.next(d);
          }, function(d) {
            return r.error(d);
          });
        } else
          r[u](c);
      };
    }
    var a = {
      next: o(t, "next"),
      error: o(n, "error"),
      complete: function() {
        i.then(function() {
          return r.complete();
        });
      }
    }, s = e.subscribe(a);
    return function() {
      return s.unsubscribe();
    };
  });
}
function mI(e) {
  function t(n) {
    Object.defineProperty(e, n, { value: St });
  }
  return VC && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function a2(e) {
  return e && typeof e.then == "function";
}
var is = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n) {
      var r = e.call(this, function(i) {
        return r.addObserver(i), function() {
          return r.removeObserver(i);
        };
      }) || this;
      return r.observers = /* @__PURE__ */ new Set(), r.promise = new Promise(function(i, o) {
        r.resolve = i, r.reject = o;
      }), r.handlers = {
        next: function(i) {
          r.sub !== null && (r.latest = ["next", i], r.notify("next", i), wu(r.observers, "next", i));
        },
        error: function(i) {
          var o = r.sub;
          o !== null && (o && setTimeout(function() {
            return o.unsubscribe();
          }), r.sub = null, r.latest = ["error", i], r.reject(i), r.notify("error", i), wu(r.observers, "error", i));
        },
        complete: function() {
          var i = r, o = i.sub, a = i.sources, s = a === void 0 ? [] : a;
          if (o !== null) {
            var l = s.shift();
            l ? a2(l) ? l.then(function(u) {
              return r.sub = u.subscribe(r.handlers);
            }, r.handlers.error) : r.sub = l.subscribe(r.handlers) : (o && setTimeout(function() {
              return o.unsubscribe();
            }), r.sub = null, r.latest && r.latest[0] === "next" ? r.resolve(r.latest[1]) : r.resolve(), r.notify("complete"), wu(r.observers, "complete"));
          }
        }
      }, r.nextResultListeners = /* @__PURE__ */ new Set(), r.cancel = function(i) {
        r.reject(i), r.sources = [], r.handlers.error(i);
      }, r.promise.catch(function(i) {
      }), typeof n == "function" && (n = [new St(n)]), a2(n) ? n.then(function(i) {
        return r.start(i);
      }, r.handlers.error) : r.start(n), r;
    }
    return t.prototype.start = function(n) {
      this.sub === void 0 && (this.sources = Array.from(n), this.handlers.complete());
    }, t.prototype.deliverLastMessage = function(n) {
      if (this.latest) {
        var r = this.latest[0], i = n[r];
        i && i.call(n, this.latest[1]), this.sub === null && r === "next" && n.complete && n.complete();
      }
    }, t.prototype.addObserver = function(n) {
      this.observers.has(n) || (this.deliverLastMessage(n), this.observers.add(n));
    }, t.prototype.removeObserver = function(n) {
      this.observers.delete(n) && this.observers.size < 1 && this.handlers.complete();
    }, t.prototype.notify = function(n, r) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(o) {
        return o(n, r);
      }));
    }, t.prototype.beforeNext = function(n) {
      var r = !1;
      this.nextResultListeners.add(function(i, o) {
        r || (r = !0, n(i, o));
      });
    }, t;
  })(St)
);
mI(is);
function Ps(e) {
  return "incremental" in e;
}
function dte(e) {
  return "hasNext" in e && "data" in e;
}
function pte(e) {
  return Ps(e) || dte(e);
}
function hte(e) {
  return Lt(e) && "payload" in e;
}
function gI(e, t) {
  var n = e, r = new Ro();
  return Ps(t) && Di(t.incremental) && t.incremental.forEach(function(i) {
    for (var o = i.data, a = i.path, s = a.length - 1; s >= 0; --s) {
      var l = a[s], u = !isNaN(+l), c = u ? [] : {};
      c[l] = o, o = c;
    }
    n = r.merge(n, o);
  }), n;
}
function Wf(e) {
  var t = sy(e);
  return Di(t);
}
function sy(e) {
  var t = Di(e.errors) ? e.errors.slice(0) : [];
  return Ps(e) && Di(e.incremental) && e.incremental.forEach(function(n) {
    n.errors && t.push.apply(t, n.errors);
  }), t;
}
function Xs() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(r) {
    r && Object.keys(r).forEach(function(i) {
      var o = r[i];
      o !== void 0 && (n[i] = o);
    });
  }), n;
}
function Uv(e, t) {
  return Xs(e, t, t.variables && {
    variables: Xs(G(G({}, e && e.variables), t.variables))
  });
}
var qv, vte = Symbol.for("apollo.deprecations"), s2 = Symbol.for("apollo.deprecations.slot"), ly = Zd, uy = (qv = ly[s2]) !== null && qv !== void 0 ? qv : ly[s2] = new Tl();
function mte(e) {
  return ly[vte] || (uy.getValue() || []).includes(e);
}
function An(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return uy.withValue.apply(uy, $n([Array.isArray(e) ? e : [e]], t, !1));
}
function nn(e, t, n, r) {
  r === void 0 && (r = "Please remove this option."), ia(t, function() {
    t in e && globalThis.__DEV__ !== !1 && Pe.warn(103, n, t, r);
  });
}
function ia(e, t) {
  mte(e) || t();
}
function Hv(e) {
  return new St(function(t) {
    t.error(e);
  });
}
var yI = function(e, t, n) {
  var r = new Error(n);
  throw r.name = "ServerError", r.response = e, r.statusCode = e.status, r.result = t, r;
};
function gte(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], n = 0, r = Object.keys(e); n < r.length; n++) {
    var i = r[n];
    if (t.indexOf(i) < 0)
      throw qn(58, i);
  }
  return e;
}
function yte(e, t) {
  var n = G({}, e), r = function(o) {
    typeof o == "function" ? n = G(G({}, n), o(n)) : n = G(G({}, n), o);
  }, i = function() {
    return G({}, n);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: r
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: i
  }), t;
}
function bte(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? nu(t.query) || void 0 : ""), t;
}
function _te(e, t) {
  var n = G({}, e), r = new Set(Object.keys(e));
  return si(t, {
    Variable: function(i, o, a) {
      a && a.kind !== "VariableDefinition" && r.delete(i.name.value);
    }
  }), r.forEach(function(i) {
    delete n[i];
  }), n;
}
function l2(e, t) {
  return t ? t(e) : St.of();
}
function ql(e) {
  return typeof e == "function" ? new Bo(e) : e;
}
function wf(e) {
  return e.request.length <= 1;
}
var Bo = (
  /** @class */
  (function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return St.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(ql).reduce(function(n, r) {
        return n.concat(r);
      });
    }, e.split = function(t, n, r) {
      var i = ql(n), o = ql(r || new e(l2)), a;
      return wf(i) && wf(o) ? a = new e(function(s) {
        return t(s) ? i.request(s) || St.of() : o.request(s) || St.of();
      }) : a = new e(function(s, l) {
        return t(s) ? i.request(s, l) || St.of() : o.request(s, l) || St.of();
      }), Object.assign(a, { left: i, right: o });
    }, e.execute = function(t, n) {
      return t.request(yte(n.context, bte(gte(n)))) || St.of();
    }, e.concat = function(t, n) {
      var r = ql(t);
      if (wf(r))
        return globalThis.__DEV__ !== !1 && Pe.warn(47, r), r;
      var i = ql(n), o;
      return wf(i) ? o = new e(function(a) {
        return r.request(a, function(s) {
          return i.request(s) || St.of();
        }) || St.of();
      }) : o = new e(function(a, s) {
        return r.request(a, function(l) {
          return i.request(l, s) || St.of();
        }) || St.of();
      }), Object.assign(o, { left: r, right: i });
    }, e.prototype.split = function(t, n, r) {
      return this.concat(e.split(t, n, r || new e(l2)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, n) {
      throw qn(48);
    }, e.prototype.onError = function(t, n) {
      if (globalThis.__DEV__ !== !1 && ia("onError", function() {
        globalThis.__DEV__ !== !1 && Pe.warn(49);
      }), n && n.error)
        return n.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Pe.warn(50), this.onError = t, this;
    }, e;
  })()
);
Bo.from;
Bo.split;
var cy = Bo.execute;
function wte(e) {
  var t, n = e[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return n.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function xte(e) {
  var t = null, n = null, r = !1, i = [], o = [];
  function a(f) {
    if (!n) {
      if (o.length) {
        var d = o.shift();
        if (Array.isArray(d) && d[0])
          return d[0]({ value: f, done: !1 });
      }
      i.push(f);
    }
  }
  function s(f) {
    n = f;
    var d = o.slice();
    d.forEach(function(p) {
      p[1](f);
    }), !t || t();
  }
  function l() {
    r = !0;
    var f = o.slice();
    f.forEach(function(d) {
      d[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, e.removeListener("data", a), e.removeListener("error", s), e.removeListener("end", l), e.removeListener("finish", l), e.removeListener("close", l);
  }, e.on("data", a), e.on("error", s), e.on("end", l), e.on("finish", l), e.on("close", l);
  function u() {
    return new Promise(function(f, d) {
      if (n)
        return d(n);
      if (i.length)
        return f({ value: i.shift(), done: !1 });
      if (r)
        return f({ value: void 0, done: !0 });
      o.push([f, d]);
    });
  }
  var c = {
    next: function() {
      return u();
    }
  };
  return ch && (c[Symbol.asyncIterator] = function() {
    return this;
  }), c;
}
function Ete(e) {
  var t = !1, n = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(r, i) {
        e.then(function(o) {
          r({ value: o, done: !1 });
        }).catch(i);
      }));
    }
  };
  return ch && (n[Symbol.asyncIterator] = function() {
    return this;
  }), n;
}
function u2(e) {
  var t = {
    next: function() {
      return e.read();
    }
  };
  return ch && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function Ste(e) {
  return !!e.body;
}
function Ote(e) {
  return !!e.getReader;
}
function $te(e) {
  return !!(ch && e[Symbol.asyncIterator]);
}
function Tte(e) {
  return !!e.stream;
}
function Pte(e) {
  return !!e.arrayBuffer;
}
function kte(e) {
  return !!e.pipe;
}
function Dte(e) {
  var t = e;
  if (Ste(e) && (t = e.body), $te(t))
    return wte(t);
  if (Ote(t))
    return u2(t.getReader());
  if (Tte(t))
    return u2(t.stream().getReader());
  if (Pte(t))
    return Ete(t.arrayBuffer());
  if (kte(t))
    return xte(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var n_ = Symbol();
function Ate(e) {
  return e.extensions ? Array.isArray(e.extensions[n_]) : !1;
}
function bI(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var Cte = function(e) {
  var t = $n($n($n([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(n) {
    return Lt(n) && n.message || "Error message not found.";
  }).join(`
`);
}, mo = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n) {
      var r = n.graphQLErrors, i = n.protocolErrors, o = n.clientErrors, a = n.networkError, s = n.errorMessage, l = n.extraInfo, u = e.call(this, s) || this;
      return u.name = "ApolloError", u.graphQLErrors = r || [], u.protocolErrors = i || [], u.clientErrors = o || [], u.networkError = a || null, u.message = s || Cte(u), u.extraInfo = l, u.cause = $n($n($n([
        a
      ], r || [], !0), i || [], !0), o || [], !0).find(function(c) {
        return !!c;
      }) || null, u.__proto__ = t.prototype, u;
    }
    return t;
  })(Error)
), c2 = Object.prototype.hasOwnProperty;
function Ite(e, t) {
  return po(this, void 0, void 0, function() {
    var n, r, i, o, a, s, l, u, c, f, d, p, h, v, m, g, _, w, x, S, $, A, E, y;
    return ho(this, function(b) {
      switch (b.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          n = new TextDecoder("utf-8"), r = (y = e.headers) === null || y === void 0 ? void 0 : y.get("content-type"), i = "boundary=", o = r != null && r.includes(i) ? r?.substring(r?.indexOf(i) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", a = `\r
--`.concat(o), s = "", l = Dte(e), u = !0, b.label = 1;
        case 1:
          return u ? [4, l.next()] : [3, 3];
        case 2:
          for (c = b.sent(), f = c.value, d = c.done, p = typeof f == "string" ? f : n.decode(f), h = s.length - a.length + 1, u = !d, s += p, v = s.indexOf(a, h); v > -1; ) {
            if (m = void 0, A = [
              s.slice(0, v),
              s.slice(v + a.length)
            ], m = A[0], s = A[1], g = m.indexOf(`\r
\r
`), _ = Nte(m.slice(0, g)), w = _["content-type"], w && w.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (x = m.slice(g), x) {
              if (S = _I(e, x), Object.keys(S).length > 1 || "data" in S || "incremental" in S || "errors" in S || "payload" in S)
                if (hte(S)) {
                  if ($ = {}, "payload" in S) {
                    if (Object.keys(S).length === 1 && S.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    $ = G({}, S.payload);
                  }
                  "errors" in S && ($ = G(G({}, $), { extensions: G(G({}, "extensions" in $ ? $.extensions : null), (E = {}, E[n_] = S.errors, E)) })), t($);
                } else
                  t(S);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(S).length === 1 && "hasNext" in S && !S.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            v = s.indexOf(a);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function Nte(e) {
  var t = {};
  return e.split(`
`).forEach(function(n) {
    var r = n.indexOf(":");
    if (r > -1) {
      var i = n.slice(0, r).trim().toLowerCase(), o = n.slice(r + 1).trim();
      t[i] = o;
    }
  }), t;
}
function _I(e, t) {
  if (e.status >= 300) {
    var n = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    yI(e, n(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (i) {
    var r = i;
    throw r.name = "ServerParseError", r.response = e, r.statusCode = e.status, r.bodyText = t, r;
  }
}
function Rte(e, t) {
  e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
}
function Mte(e) {
  return function(t) {
    return t.text().then(function(n) {
      return _I(t, n);
    }).then(function(n) {
      return !Array.isArray(n) && !c2.call(n, "data") && !c2.call(n, "errors") && yI(t, n, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(r) {
        return r.operationName;
      }) : e.operationName, "'.")), n;
    });
  };
}
var fy = function(e, t) {
  var n;
  try {
    n = JSON.stringify(e);
  } catch (i) {
    var r = qn(54, t, i.message);
    throw r.parseError = i, r;
  }
  return n;
}, jte = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, Fte = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, zte = {
  method: "POST"
}, Lte = {
  http: jte,
  headers: Fte,
  options: zte
}, Vte = function(e, t) {
  return t(e);
};
function Kte(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var i = {}, o = {};
  n.forEach(function(f) {
    i = G(G(G({}, i), f.options), { headers: G(G({}, i.headers), f.headers) }), f.credentials && (i.credentials = f.credentials), o = G(G({}, o), f.http);
  }), i.headers && (i.headers = Bte(i.headers, o.preserveHeaderCase));
  var a = e.operationName, s = e.extensions, l = e.variables, u = e.query, c = { operationName: a, variables: l };
  return o.includeExtensions && (c.extensions = s), o.includeQuery && (c.query = t(u, Eo)), {
    options: i,
    body: c
  };
}
function Bte(e, t) {
  if (!t) {
    var n = {};
    return Object.keys(Object(e)).forEach(function(o) {
      n[o.toLowerCase()] = e[o];
    }), n;
  }
  var r = {};
  Object.keys(Object(e)).forEach(function(o) {
    r[o.toLowerCase()] = {
      originalName: o,
      value: e[o]
    };
  });
  var i = {};
  return Object.keys(r).forEach(function(o) {
    i[r[o].originalName] = r[o].value;
  }), i;
}
var Ute = function(e) {
  if (!e && typeof fetch > "u")
    throw qn(51);
}, qte = function(e, t) {
  var n = e.getContext(), r = n.uri;
  return r || (typeof t == "function" ? t(e) : t || "/graphql");
};
function Hte(e, t) {
  var n = [], r = function(f, d) {
    n.push("".concat(f, "=").concat(encodeURIComponent(d)));
  };
  if ("query" in t && r("query", t.query), t.operationName && r("operationName", t.operationName), t.variables) {
    var i = void 0;
    try {
      i = fy(t.variables, "Variables map");
    } catch (f) {
      return { parseError: f };
    }
    r("variables", i);
  }
  if (t.extensions) {
    var o = void 0;
    try {
      o = fy(t.extensions, "Extensions map");
    } catch (f) {
      return { parseError: f };
    }
    r("extensions", o);
  }
  var a = "", s = e, l = e.indexOf("#");
  l !== -1 && (a = e.substr(l), s = e.substr(0, l));
  var u = s.indexOf("?") === -1 ? "?" : "&", c = s + u + n.join("&") + a;
  return { newURI: c };
}
var f2 = Yr(function() {
  return fetch;
}), Wte = function(e) {
  e === void 0 && (e = {});
  var t = e.uri, n = t === void 0 ? "/graphql" : t, r = e.fetch, i = e.print, o = i === void 0 ? Vte : i, a = e.includeExtensions, s = e.preserveHeaderCase, l = e.useGETForQueries, u = e.includeUnusedVariables, c = u === void 0 ? !1 : u, f = Ki(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && Ute(r || f2);
  var d = {
    http: { includeExtensions: a, preserveHeaderCase: s },
    options: f.fetchOptions,
    credentials: f.credentials,
    headers: f.headers
  };
  return new Bo(function(p) {
    var h = qte(p, n), v = p.getContext(), m = {};
    if (v.clientAwareness) {
      var g = v.clientAwareness, _ = g.name, w = g.version;
      _ && (m["apollographql-client-name"] = _), w && (m["apollographql-client-version"] = w);
    }
    var x = G(G({}, m), v.headers), S = {
      http: v.http,
      options: v.fetchOptions,
      credentials: v.credentials,
      headers: x
    };
    if (ec(["client"], p.query)) {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Pe.warn(52);
      var $ = fI(p.query);
      if (!$)
        return Hv(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      p.query = $;
    }
    var A = Kte(p, o, Lte, d, S), E = A.options, y = A.body;
    y.variables && !c && (y.variables = _te(y.variables, p.query));
    var b;
    !E.signal && typeof AbortController < "u" && (b = new AbortController(), E.signal = b.signal);
    var O = function(M) {
      return M.kind === "OperationDefinition" && M.operation === "mutation";
    }, k = function(M) {
      return M.kind === "OperationDefinition" && M.operation === "subscription";
    }, I = k(Rc(p.query)), T = ec(["defer"], p.query);
    if (l && !p.query.definitions.some(O) && (E.method = "GET"), T || I) {
      E.headers = E.headers || {};
      var V = "multipart/mixed;";
      I && T && globalThis.__DEV__ !== !1 && Pe.warn(53), I ? V += "boundary=graphql;subscriptionSpec=1.0,application/json" : T && (V += "deferSpec=20220824,application/json"), E.headers.accept = V;
    }
    if (E.method === "GET") {
      var z = Hte(h, y), B = z.newURI, q = z.parseError;
      if (q)
        return Hv(q);
      h = B;
    } else
      try {
        E.body = fy(y, "Payload");
      } catch (M) {
        return Hv(M);
      }
    return new St(function(M) {
      var N = r || Yr(function() {
        return fetch;
      }) || f2, Y = M.next.bind(M);
      return N(h, E).then(function(ee) {
        var Q;
        p.setContext({ response: ee });
        var K = (Q = ee.headers) === null || Q === void 0 ? void 0 : Q.get("content-type");
        return K !== null && /^multipart\/mixed/i.test(K) ? Ite(ee, Y) : Mte(p)(ee).then(Y);
      }).then(function() {
        b = void 0, M.complete();
      }).catch(function(ee) {
        b = void 0, Rte(ee, M);
      }), function() {
        b && b.abort();
      };
    });
  });
}, Zte = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this, Wte(n).request) || this;
      return r.options = n, r;
    }
    return t;
  })(Bo)
);
const { toString: d2, hasOwnProperty: Gte } = Object.prototype, p2 = Function.prototype.toString, dy = /* @__PURE__ */ new Map();
function Ot(e, t) {
  try {
    return py(e, t);
  } finally {
    dy.clear();
  }
}
function py(e, t) {
  if (e === t)
    return !0;
  const n = d2.call(e), r = d2.call(t);
  if (n !== r)
    return !1;
  switch (n) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (v2(e, t))
        return !0;
      const i = h2(e), o = h2(t), a = i.length;
      if (a !== o.length)
        return !1;
      for (let s = 0; s < a; ++s)
        if (!Gte.call(t, i[s]))
          return !1;
      for (let s = 0; s < a; ++s) {
        const l = i[s];
        if (!py(e[l], t[l]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (v2(e, t))
        return !0;
      const i = e.entries(), o = n === "[object Map]";
      for (; ; ) {
        const a = i.next();
        if (a.done)
          break;
        const [s, l] = a.value;
        if (!t.has(s) || o && !py(l, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    // Fall through...
    case "[object DataView]": {
      let i = e.byteLength;
      if (i === t.byteLength)
        for (; i-- && e[i] === t[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = p2.call(e);
      return i !== p2.call(t) ? !1 : !Jte(i, Qte);
    }
  }
  return !1;
}
function h2(e) {
  return Object.keys(e).filter(Yte, e);
}
function Yte(e) {
  return this[e] !== void 0;
}
const Qte = "{ [native code] }";
function Jte(e, t) {
  const n = e.length - t.length;
  return n >= 0 && e.indexOf(t, n) === n;
}
function v2(e, t) {
  let n = dy.get(e);
  if (n) {
    if (n.has(t))
      return !0;
  } else
    dy.set(e, n = /* @__PURE__ */ new Set());
  return n.add(t), !1;
}
function wI(e, t, n, r) {
  var i = t.data, o = Ki(t, ["data"]), a = n.data, s = Ki(n, ["data"]);
  return Ot(o, s) && Zf(Rc(e).selectionSet, i, a, {
    fragmentMap: Sl($l(e)),
    variables: r
  });
}
function Zf(e, t, n, r) {
  if (t === n)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return e.selections.every(function(o) {
    if (i.has(o) || (i.add(o), !Nc(o, r.variables)) || m2(o))
      return !0;
    if (Io(o)) {
      var a = Xi(o), s = t && t[a], l = n && n[a], u = o.selectionSet;
      if (!u)
        return Ot(s, l);
      var c = Array.isArray(s), f = Array.isArray(l);
      if (c !== f)
        return !1;
      if (c && f) {
        var d = s.length;
        if (l.length !== d)
          return !1;
        for (var p = 0; p < d; ++p)
          if (!Zf(u, s[p], l[p], r))
            return !1;
        return !0;
      }
      return Zf(u, s, l, r);
    } else {
      var h = fh(o, r.fragmentMap);
      if (h)
        return m2(h) ? !0 : Zf(
          h.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          n,
          r
        );
    }
  });
}
function m2(e) {
  return !!e.directives && e.directives.some(Xte);
}
function Xte(e) {
  return e.name.value === "nonreactive";
}
var xI = Ha ? WeakMap : Map, EI = H0 ? WeakSet : Set, r_ = new Tl(), g2 = !1;
function SI() {
  g2 || (g2 = !0, globalThis.__DEV__ !== !1 && Pe.warn(64));
}
function OI(e, t, n) {
  return r_.withValue(!0, function() {
    var r = ru(e, t, n, !1);
    return Object.isFrozen(e) && Qd(r), r;
  });
}
function ene(e, t) {
  if (t.has(e))
    return t.get(e);
  var n = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
  return t.set(e, n), n;
}
function ru(e, t, n, r, i) {
  var o, a = n.knownChanged, s = ene(e, n.mutableTargets);
  if (Array.isArray(e)) {
    for (var l = 0, u = Array.from(e.entries()); l < u.length; l++) {
      var c = u[l], f = c[0], d = c[1];
      if (d === null) {
        s[f] = null;
        continue;
      }
      var p = ru(d, t, n, r, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(f, "]") : void 0);
      a.has(p) && a.add(s), s[f] = p;
    }
    return a.has(s) ? s : e;
  }
  for (var h = 0, v = t.selections; h < v.length; h++) {
    var m = v[h], g = void 0;
    if (r && a.add(s), m.kind === Ht.FIELD) {
      var _ = Xi(m), w = m.selectionSet;
      if (g = s[_] || e[_], g === void 0)
        continue;
      if (w && g !== null) {
        var p = ru(e[_], w, n, r, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat(_) : void 0);
        a.has(p) && (g = p);
      }
      globalThis.__DEV__ === !1 && (s[_] = g), globalThis.__DEV__ !== !1 && (r && _ !== "__typename" && // either the field is not present in the memo object
      // or it has a `get` descriptor, not a `value` descriptor
      // => it is a warning accessor and we can overwrite it
      // with another accessor
      !(!((o = Object.getOwnPropertyDescriptor(s, _)) === null || o === void 0) && o.value) ? Object.defineProperty(s, _, tne(_, g, i || "", n.operationName, n.operationType)) : (delete s[_], s[_] = g));
    }
    if (m.kind === Ht.INLINE_FRAGMENT && (!m.typeCondition || n.cache.fragmentMatches(m, e.__typename)) && (g = ru(e, m.selectionSet, n, r, i)), m.kind === Ht.FRAGMENT_SPREAD) {
      var x = m.name.value, S = n.fragmentMap[x] || (n.fragmentMap[x] = n.cache.lookupFragment(x));
      Pe(S, 59, x);
      var $ = JX(m);
      $ !== "mask" && (g = ru(e, S.selectionSet, n, $ === "migrate", i));
    }
    a.has(g) && a.add(s);
  }
  return "__typename" in e && !("__typename" in s) && (s.__typename = e.__typename), Object.keys(s).length !== Object.keys(e).length && a.add(s), a.has(s) ? s : e;
}
function tne(e, t, n, r, i) {
  var o = function() {
    return r_.getValue() || (globalThis.__DEV__ !== !1 && Pe.warn(60, r ? "".concat(i, " '").concat(r, "'") : "anonymous ".concat(i), "".concat(n, ".").concat(e).replace(/^\./, "")), o = function() {
      return t;
    }), t;
  };
  return {
    get: function() {
      return o();
    },
    set: function(a) {
      o = function() {
        return a;
      };
    },
    enumerable: !0,
    configurable: !0
  };
}
function $I(e, t, n, r) {
  if (!n.fragmentMatches)
    return globalThis.__DEV__ !== !1 && SI(), e;
  var i = t.definitions.filter(function(a) {
    return a.kind === Ht.FRAGMENT_DEFINITION;
  });
  typeof r > "u" && (Pe(i.length === 1, 61, i.length), r = i[0].name.value);
  var o = i.find(function(a) {
    return a.name.value === r;
  });
  return Pe(!!o, 62, r), e == null || Ot(e, {}) ? e : OI(e, o.selectionSet, {
    operationType: "fragment",
    operationName: o.name.value,
    fragmentMap: Sl($l(t)),
    cache: n,
    mutableTargets: new xI(),
    knownChanged: new EI()
  });
}
function nne(e, t, n) {
  var r;
  if (!n.fragmentMatches)
    return globalThis.__DEV__ !== !1 && SI(), e;
  var i = ka(t);
  return Pe(i, 63), e == null ? e : OI(e, i.selectionSet, {
    operationType: i.operation,
    operationName: (r = i.name) === null || r === void 0 ? void 0 : r.value,
    fragmentMap: Sl($l(t)),
    cache: n,
    mutableTargets: new xI(),
    knownChanged: new EI()
  });
}
var TI = (
  /** @class */
  (function() {
    function e() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = nc(iee, {
        max: Ji["cache.fragmentQueryDocuments"] || 1e3,
        cache: Gd
      });
    }
    return e.prototype.lookupFragment = function(t) {
      return null;
    }, e.prototype.batch = function(t) {
      var n = this, r = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0, i;
      return this.performTransaction(function() {
        return i = t.update(n);
      }, r), i;
    }, e.prototype.recordOptimisticTransaction = function(t, n) {
      this.performTransaction(t, n);
    }, e.prototype.transformDocument = function(t) {
      return t;
    }, e.prototype.transformForLink = function(t) {
      return t;
    }, e.prototype.identify = function(t) {
    }, e.prototype.gc = function() {
      return [];
    }, e.prototype.modify = function(t) {
      return !1;
    }, e.prototype.readQuery = function(t, n) {
      var r = this;
      return n === void 0 && (n = !!t.optimistic), globalThis.__DEV__ !== !1 && nn(t, "canonizeResults", "cache.readQuery"), An("canonizeResults", function() {
        return r.read(G(G({}, t), { rootId: t.id || "ROOT_QUERY", optimistic: n }));
      });
    }, e.prototype.watchFragment = function(t) {
      var n = this, r = t.fragment, i = t.fragmentName, o = t.from, a = t.optimistic, s = a === void 0 ? !0 : a, l = Ki(t, ["fragment", "fragmentName", "from", "optimistic"]), u = this.getFragmentDoc(r, i), c = typeof o > "u" || typeof o == "string" ? o : this.identify(o), f = !!t[Symbol.for("apollo.dataMasking")];
      if (globalThis.__DEV__ !== !1) {
        var d = i || YC(r).name.value;
        c || globalThis.__DEV__ !== !1 && Pe.warn(1, d);
      }
      var p = G(G({}, l), { returnPartialData: !0, id: c, query: u, optimistic: s }), h;
      return new St(function(v) {
        return n.watch(G(G({}, p), { immediate: !0, callback: function(m) {
          var g = f ? $I(m.result, r, n, i) : m.result;
          if (
            // Always ensure we deliver the first result
            !(h && wI(
              u,
              { data: h.result },
              { data: g },
              // TODO: Fix the type on WatchFragmentOptions so that TVars
              // extends OperationVariables
              t.variables
            ))
          ) {
            var _ = {
              data: g,
              complete: !!m.complete
            };
            m.missing && (_.missing = vh(m.missing.map(function(w) {
              return w.missing;
            }))), h = G(G({}, m), { result: g }), v.next(_);
          }
        } }));
      });
    }, e.prototype.readFragment = function(t, n) {
      var r = this;
      return n === void 0 && (n = !!t.optimistic), globalThis.__DEV__ !== !1 && nn(t, "canonizeResults", "cache.readFragment"), An("canonizeResults", function() {
        return r.read(G(G({}, t), { query: r.getFragmentDoc(t.fragment, t.fragmentName), rootId: t.id, optimistic: n }));
      });
    }, e.prototype.writeQuery = function(t) {
      var n = t.id, r = t.data, i = Ki(t, ["id", "data"]);
      return this.write(Object.assign(i, {
        dataId: n || "ROOT_QUERY",
        result: r
      }));
    }, e.prototype.writeFragment = function(t) {
      var n = t.id, r = t.data, i = t.fragment, o = t.fragmentName, a = Ki(t, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(a, {
        query: this.getFragmentDoc(i, o),
        dataId: n,
        result: r
      }));
    }, e.prototype.updateQuery = function(t, n) {
      return globalThis.__DEV__ !== !1 && nn(t, "canonizeResults", "cache.updateQuery"), this.batch({
        update: function(r) {
          var i = An("canonizeResults", function() {
            return r.readQuery(t);
          }), o = n(i);
          return o == null ? i : (r.writeQuery(G(G({}, t), { data: o })), o);
        }
      });
    }, e.prototype.updateFragment = function(t, n) {
      return globalThis.__DEV__ !== !1 && nn(t, "canonizeResults", "cache.updateFragment"), this.batch({
        update: function(r) {
          var i = An("canonizeResults", function() {
            return r.readFragment(t);
          }), o = n(i);
          return o == null ? i : (r.writeFragment(G(G({}, t), { data: o })), o);
        }
      });
    }, e;
  })()
);
globalThis.__DEV__ !== !1 && (TI.prototype.getMemoryInternals = mee);
var PI = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n, r, i, o) {
      var a, s = e.call(this, n) || this;
      if (s.message = n, s.path = r, s.query = i, s.variables = o, Array.isArray(s.path)) {
        s.missing = s.message;
        for (var l = s.path.length - 1; l >= 0; --l)
          s.missing = (a = {}, a[s.path[l]] = s.missing, a);
      } else
        s.missing = s.path;
      return s.__proto__ = t.prototype, s;
    }
    return t;
  })(Error)
), mn = Object.prototype.hasOwnProperty;
function Hl(e) {
  return e == null;
}
function kI(e, t) {
  var n = e.__typename, r = e.id, i = e._id;
  if (typeof n == "string" && (t && (t.keyObject = Hl(r) ? Hl(i) ? void 0 : { _id: i } : { id: r }), Hl(r) && !Hl(i) && (r = i), !Hl(r)))
    return "".concat(n, ":").concat(typeof r == "number" || typeof r == "string" ? r : JSON.stringify(r));
}
var DI = {
  dataIdFromObject: kI,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function rne(e) {
  return Xs(DI, e);
}
function AI(e) {
  var t = e.canonizeResults;
  return t === void 0 ? DI.canonizeResults : t;
}
function ine(e, t) {
  return _t(t) ? e.get(t.__ref, "__typename") : t && t.__typename;
}
var CI = /^[_a-z][_0-9a-z]*/i;
function Mo(e) {
  var t = e.match(CI);
  return t ? t[0] : e;
}
function hy(e, t, n) {
  return Lt(t) ? Xt(t) ? t.every(function(r) {
    return hy(e, r, n);
  }) : e.selections.every(function(r) {
    if (Io(r) && Nc(r, n)) {
      var i = Xi(r);
      return mn.call(t, i) && (!r.selectionSet || hy(r.selectionSet, t[i], n));
    }
    return !0;
  }) : !1;
}
function ms(e) {
  return Lt(e) && !_t(e) && !Xt(e);
}
function one() {
  return new Ro();
}
function II(e, t) {
  var n = Sl($l(e));
  return {
    fragmentMap: n,
    lookupFragment: function(r) {
      var i = n[r];
      return !i && t && (i = t.lookup(r)), i || null;
    }
  };
}
var Gf = /* @__PURE__ */ Object.create(null), Wv = function() {
  return Gf;
}, y2 = /* @__PURE__ */ Object.create(null), rc = (
  /** @class */
  (function() {
    function e(t, n) {
      var r = this;
      this.policies = t, this.group = n, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, o) {
        return Qd(_t(i) ? r.get(i.__ref, o) : i && i[o]);
      }, this.canRead = function(i) {
        return _t(i) ? r.has(i.__ref) : typeof i == "object";
      }, this.toReference = function(i, o) {
        if (typeof i == "string")
          return Ts(i);
        if (_t(i))
          return i;
        var a = r.policies.identify(i)[0];
        if (a) {
          var s = Ts(a);
          return o && r.merge(a, i), s;
        }
      };
    }
    return e.prototype.toObject = function() {
      return G({}, this.data);
    }, e.prototype.has = function(t) {
      return this.lookup(t, !0) !== void 0;
    }, e.prototype.get = function(t, n) {
      if (this.group.depend(t, n), mn.call(this.data, t)) {
        var r = this.data[t];
        if (r && mn.call(r, n))
          return r[n];
      }
      if (n === "__typename" && mn.call(this.policies.rootTypenamesById, t))
        return this.policies.rootTypenamesById[t];
      if (this instanceof uo)
        return this.parent.get(t, n);
    }, e.prototype.lookup = function(t, n) {
      if (n && this.group.depend(t, "__exists"), mn.call(this.data, t))
        return this.data[t];
      if (this instanceof uo)
        return this.parent.lookup(t, n);
      if (this.policies.rootTypenamesById[t])
        return /* @__PURE__ */ Object.create(null);
    }, e.prototype.merge = function(t, n) {
      var r = this, i;
      _t(t) && (t = t.__ref), _t(n) && (n = n.__ref);
      var o = typeof t == "string" ? this.lookup(i = t) : t, a = typeof n == "string" ? this.lookup(i = n) : n;
      if (a) {
        Pe(typeof i == "string", 2);
        var s = new Ro(sne).merge(o, a);
        if (this.data[i] = s, s !== o && (delete this.refs[i], this.group.caching)) {
          var l = /* @__PURE__ */ Object.create(null);
          o || (l.__exists = 1), Object.keys(a).forEach(function(u) {
            if (!o || o[u] !== s[u]) {
              l[u] = 1;
              var c = Mo(u);
              c !== u && !r.policies.hasKeyArgs(s.__typename, c) && (l[c] = 1), s[u] === void 0 && !(r instanceof uo) && delete s[u];
            }
          }), l.__typename && !(o && o.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[i] === s.__typename && delete l.__typename, Object.keys(l).forEach(function(u) {
            return r.group.dirty(i, u);
          });
        }
      }
    }, e.prototype.modify = function(t, n) {
      var r = this, i = this.lookup(t);
      if (i) {
        var o = /* @__PURE__ */ Object.create(null), a = !1, s = !0, l = {
          DELETE: Gf,
          INVALIDATE: y2,
          isReference: _t,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(u, c) {
            return r.policies.readField(typeof u == "string" ? {
              fieldName: u,
              from: c || Ts(t)
            } : u, { store: r });
          }
        };
        if (Object.keys(i).forEach(function(u) {
          var c = Mo(u), f = i[u];
          if (f !== void 0) {
            var d = typeof n == "function" ? n : n[u] || n[c];
            if (d) {
              var p = d === Wv ? Gf : d(Qd(f), G(G({}, l), { fieldName: c, storeFieldName: u, storage: r.getStorage(t, u) }));
              if (p === y2)
                r.group.dirty(t, u);
              else if (p === Gf && (p = void 0), p !== f && (o[u] = p, a = !0, f = p, globalThis.__DEV__ !== !1)) {
                var h = function(S) {
                  if (r.lookup(S.__ref) === void 0)
                    return globalThis.__DEV__ !== !1 && Pe.warn(3, S), !0;
                };
                if (_t(p))
                  h(p);
                else if (Array.isArray(p))
                  for (var v = !1, m = void 0, g = 0, _ = p; g < _.length; g++) {
                    var w = _[g];
                    if (_t(w)) {
                      if (v = !0, h(w))
                        break;
                    } else if (typeof w == "object" && w) {
                      var x = r.policies.identify(w)[0];
                      x && (m = w);
                    }
                    if (v && m !== void 0) {
                      globalThis.__DEV__ !== !1 && Pe.warn(4, m);
                      break;
                    }
                  }
              }
            }
            f !== void 0 && (s = !1);
          }
        }), a)
          return this.merge(t, o), s && (this instanceof uo ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
      }
      return !1;
    }, e.prototype.delete = function(t, n, r) {
      var i, o = this.lookup(t);
      if (o) {
        var a = this.getFieldValue(o, "__typename"), s = n && r ? this.policies.getStoreFieldName({ typename: a, fieldName: n, args: r }) : n;
        return this.modify(t, s ? (i = {}, i[s] = Wv, i) : Wv);
      }
      return !1;
    }, e.prototype.evict = function(t, n) {
      var r = !1;
      return t.id && (mn.call(this.data, t.id) && (r = this.delete(t.id, t.fieldName, t.args)), this instanceof uo && this !== n && (r = this.parent.evict(t, n) || r), (t.fieldName || r) && this.group.dirty(t.id, t.fieldName || "__exists")), r;
    }, e.prototype.clear = function() {
      this.replace(null);
    }, e.prototype.extract = function() {
      var t = this, n = this.toObject(), r = [];
      return this.getRootIdSet().forEach(function(i) {
        mn.call(t.policies.rootTypenamesById, i) || r.push(i);
      }), r.length && (n.__META = { extraRootIds: r.sort() }), n;
    }, e.prototype.replace = function(t) {
      var n = this;
      if (Object.keys(this.data).forEach(function(o) {
        t && mn.call(t, o) || n.delete(o);
      }), t) {
        var r = t.__META, i = Ki(t, ["__META"]);
        Object.keys(i).forEach(function(o) {
          n.merge(o, i[o]);
        }), r && r.extraRootIds.forEach(this.retain, this);
      }
    }, e.prototype.retain = function(t) {
      return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
    }, e.prototype.release = function(t) {
      if (this.rootIds[t] > 0) {
        var n = --this.rootIds[t];
        return n || delete this.rootIds[t], n;
      }
      return 0;
    }, e.prototype.getRootIdSet = function(t) {
      return t === void 0 && (t = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof uo ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
    }, e.prototype.gc = function() {
      var t = this, n = this.getRootIdSet(), r = this.toObject();
      n.forEach(function(a) {
        mn.call(r, a) && (Object.keys(t.findChildRefIds(a)).forEach(n.add, n), delete r[a]);
      });
      var i = Object.keys(r);
      if (i.length) {
        for (var o = this; o instanceof uo; )
          o = o.parent;
        i.forEach(function(a) {
          return o.delete(a);
        });
      }
      return i;
    }, e.prototype.findChildRefIds = function(t) {
      if (!mn.call(this.refs, t)) {
        var n = this.refs[t] = /* @__PURE__ */ Object.create(null), r = this.data[t];
        if (!r)
          return n;
        var i = /* @__PURE__ */ new Set([r]);
        i.forEach(function(o) {
          _t(o) && (n[o.__ref] = !0), Lt(o) && Object.keys(o).forEach(function(a) {
            var s = o[a];
            Lt(s) && i.add(s);
          });
        });
      }
      return this.refs[t];
    }, e.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, e;
  })()
), NI = (
  /** @class */
  (function() {
    function e(t, n) {
      n === void 0 && (n = null), this.caching = t, this.parent = n, this.d = null, this.resetCaching();
    }
    return e.prototype.resetCaching = function() {
      this.d = this.caching ? sI() : null, this.keyMaker = new no(Ha);
    }, e.prototype.depend = function(t, n) {
      if (this.d) {
        this.d(Zv(t, n));
        var r = Mo(n);
        r !== n && this.d(Zv(t, r)), this.parent && this.parent.depend(t, n);
      }
    }, e.prototype.dirty = function(t, n) {
      this.d && this.d.dirty(
        Zv(t, n),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        n === "__exists" ? "forget" : "setDirty"
      );
    }, e;
  })()
);
function Zv(e, t) {
  return t + "#" + e;
}
function b2(e, t) {
  xu(e) && e.group.depend(t, "__exists");
}
(function(e) {
  var t = (
    /** @class */
    (function(n) {
      pi(r, n);
      function r(i) {
        var o = i.policies, a = i.resultCaching, s = a === void 0 ? !0 : a, l = i.seed, u = n.call(this, o, new NI(s)) || this;
        return u.stump = new ane(u), u.storageTrie = new no(Ha), l && u.replace(l), u;
      }
      return r.prototype.addLayer = function(i, o) {
        return this.stump.addLayer(i, o);
      }, r.prototype.removeLayer = function() {
        return this;
      }, r.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, r;
    })(e)
  );
  e.Root = t;
})(rc || (rc = {}));
var uo = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n, r, i, o) {
      var a = e.call(this, r.policies, o) || this;
      return a.id = n, a.parent = r, a.replay = i, a.group = o, i(a), a;
    }
    return t.prototype.addLayer = function(n, r) {
      return new t(n, this, r, this.group);
    }, t.prototype.removeLayer = function(n) {
      var r = this, i = this.parent.removeLayer(n);
      return n === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(o) {
        var a = r.data[o], s = i.lookup(o);
        s ? a ? a !== s && Object.keys(a).forEach(function(l) {
          Ot(a[l], s[l]) || r.group.dirty(o, l);
        }) : (r.group.dirty(o, "__exists"), Object.keys(s).forEach(function(l) {
          r.group.dirty(o, l);
        })) : r.delete(o);
      }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
    }, t.prototype.toObject = function() {
      return G(G({}, this.parent.toObject()), this.data);
    }, t.prototype.findChildRefIds = function(n) {
      var r = this.parent.findChildRefIds(n);
      return mn.call(this.data, n) ? G(G({}, r), e.prototype.findChildRefIds.call(this, n)) : r;
    }, t.prototype.getStorage = function() {
      for (var n = this.parent; n.parent; )
        n = n.parent;
      return n.getStorage.apply(
        n,
        // @ts-expect-error
        arguments
      );
    }, t;
  })(rc)
), ane = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n) {
      return e.call(this, "EntityStore.Stump", n, function() {
      }, new NI(n.group.caching, n.group)) || this;
    }
    return t.prototype.removeLayer = function() {
      return this;
    }, t.prototype.merge = function(n, r) {
      return this.parent.merge(n, r);
    }, t;
  })(uo)
);
function sne(e, t, n) {
  var r = e[n], i = t[n];
  return Ot(r, i) ? r : i;
}
function xu(e) {
  return !!(e instanceof rc && e.group.caching);
}
function lne(e) {
  return Lt(e) ? Xt(e) ? e.slice(0) : G({ __proto__: Object.getPrototypeOf(e) }, e) : e;
}
var _2 = (
  /** @class */
  (function() {
    function e() {
      this.known = new (H0 ? WeakSet : Set)(), this.pool = new no(Ha), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return e.prototype.isKnown = function(t) {
      return Lt(t) && this.known.has(t);
    }, e.prototype.pass = function(t) {
      if (Lt(t)) {
        var n = lne(t);
        return this.passes.set(n, t), n;
      }
      return t;
    }, e.prototype.admit = function(t) {
      var n = this;
      if (Lt(t)) {
        var r = this.passes.get(t);
        if (r)
          return r;
        var i = Object.getPrototypeOf(t);
        switch (i) {
          case Array.prototype: {
            if (this.known.has(t))
              return t;
            var o = t.map(this.admit, this), a = this.pool.lookupArray(o);
            return a.array || (this.known.add(a.array = o), globalThis.__DEV__ !== !1 && Object.freeze(o)), a.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(t))
              return t;
            var s = Object.getPrototypeOf(t), l = [s], u = this.sortedKeys(t);
            l.push(u.json);
            var c = l.length;
            u.sorted.forEach(function(p) {
              l.push(n.admit(t[p]));
            });
            var a = this.pool.lookupArray(l);
            if (!a.object) {
              var f = a.object = Object.create(s);
              this.known.add(f), u.sorted.forEach(function(p, h) {
                f[p] = l[c + h];
              }), globalThis.__DEV__ !== !1 && Object.freeze(f);
            }
            return a.object;
          }
        }
      }
      return t;
    }, e.prototype.sortedKeys = function(t) {
      var n = Object.keys(t), r = this.pool.lookupArray(n);
      if (!r.keys) {
        n.sort();
        var i = JSON.stringify(n);
        (r.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, r.keys = { sorted: n, json: i });
      }
      return r.keys;
    }, e;
  })()
);
function w2(e) {
  return [
    e.selectionSet,
    e.objectOrReference,
    e.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    e.context.canonizeResults
  ];
}
var une = (
  /** @class */
  (function() {
    function e(t) {
      var n = this;
      this.knownResults = new (Ha ? WeakMap : Map)(), this.config = Xs(t, {
        addTypename: t.addTypename !== !1,
        canonizeResults: AI(t)
      }), this.canon = t.canon || new _2(), this.executeSelectionSet = nc(function(r) {
        var i, o = r.context.canonizeResults, a = w2(r);
        a[3] = !o;
        var s = (i = n.executeSelectionSet).peek.apply(i, a);
        return s ? o ? G(G({}, s), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: n.canon.admit(s.result)
        }) : s : (b2(r.context.store, r.enclosingRef.__ref), n.execSelectionSetImpl(r));
      }, {
        max: this.config.resultCacheMaxSize || Ji["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: w2,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(r, i, o, a) {
          if (xu(o.store))
            return o.store.makeCacheKey(r, _t(i) ? i.__ref : i, o.varString, a);
        }
      }), this.executeSubSelectedArray = nc(function(r) {
        return b2(r.context.store, r.enclosingRef.__ref), n.execSubSelectedArrayImpl(r);
      }, {
        max: this.config.resultCacheMaxSize || Ji["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(r) {
          var i = r.field, o = r.array, a = r.context;
          if (xu(a.store))
            return a.store.makeCacheKey(i, o, a.varString);
        }
      });
    }
    return e.prototype.resetCanon = function() {
      this.canon = new _2();
    }, e.prototype.diffQueryAgainstStore = function(t) {
      var n = t.store, r = t.query, i = t.rootId, o = i === void 0 ? "ROOT_QUERY" : i, a = t.variables, s = t.returnPartialData, l = s === void 0 ? !0 : s, u = t.canonizeResults, c = u === void 0 ? this.config.canonizeResults : u, f = this.config.cache.policies;
      a = G(G({}, W0(GC(r))), a);
      var d = Ts(o), p = this.executeSelectionSet({
        selectionSet: Rc(r).selectionSet,
        objectOrReference: d,
        enclosingRef: d,
        context: G({ store: n, query: r, policies: f, variables: a, varString: Oo(a), canonizeResults: c }, II(r, this.config.fragments))
      }), h;
      if (p.missing && (h = [
        new PI(cne(p.missing), p.missing, r, a)
      ], !l))
        throw h[0];
      return {
        result: p.result,
        complete: !h,
        missing: h
      };
    }, e.prototype.isFresh = function(t, n, r, i) {
      if (xu(i.store) && this.knownResults.get(t) === r) {
        var o = this.executeSelectionSet.peek(
          r,
          n,
          i,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(t)
        );
        if (o && t === o.result)
          return !0;
      }
      return !1;
    }, e.prototype.execSelectionSetImpl = function(t) {
      var n = this, r = t.selectionSet, i = t.objectOrReference, o = t.enclosingRef, a = t.context;
      if (_t(i) && !a.policies.rootTypenamesById[i.__ref] && !a.store.has(i.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(i.__ref, " object")
        };
      var s = a.variables, l = a.policies, u = a.store, c = u.getFieldValue(i, "__typename"), f = [], d, p = new Ro();
      this.config.addTypename && typeof c == "string" && !l.rootIdsByTypename[c] && f.push({ __typename: c });
      function h(w, x) {
        var S;
        return w.missing && (d = p.merge(d, (S = {}, S[x] = w.missing, S))), w.result;
      }
      var v = new Set(r.selections);
      v.forEach(function(w) {
        var x, S;
        if (Nc(w, s))
          if (Io(w)) {
            var $ = l.readField({
              fieldName: w.name.value,
              field: w,
              variables: a.variables,
              from: i
            }, a), A = Xi(w);
            $ === void 0 ? Q0.added(w) || (d = p.merge(d, (x = {}, x[A] = "Can't find field '".concat(w.name.value, "' on ").concat(_t(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), x))) : Xt($) ? $.length > 0 && ($ = h(n.executeSubSelectedArray({
              field: w,
              array: $,
              enclosingRef: o,
              context: a
            }), A)) : w.selectionSet ? $ != null && ($ = h(n.executeSelectionSet({
              selectionSet: w.selectionSet,
              objectOrReference: $,
              enclosingRef: _t($) ? $ : o,
              context: a
            }), A)) : a.canonizeResults && ($ = n.canon.pass($)), $ !== void 0 && f.push((S = {}, S[A] = $, S));
          } else {
            var E = fh(w, a.lookupFragment);
            if (!E && w.kind === Ht.FRAGMENT_SPREAD)
              throw qn(10, w.name.value);
            E && l.fragmentMatches(E, c) && E.selectionSet.selections.forEach(v.add, v);
          }
      });
      var m = vh(f), g = { result: m, missing: d }, _ = a.canonizeResults ? this.canon.admit(g) : Qd(g);
      return _.result && this.knownResults.set(_.result, r), _;
    }, e.prototype.execSubSelectedArrayImpl = function(t) {
      var n = this, r = t.field, i = t.array, o = t.enclosingRef, a = t.context, s, l = new Ro();
      function u(c, f) {
        var d;
        return c.missing && (s = l.merge(s, (d = {}, d[f] = c.missing, d))), c.result;
      }
      return r.selectionSet && (i = i.filter(a.store.canRead)), i = i.map(function(c, f) {
        return c === null ? null : Xt(c) ? u(n.executeSubSelectedArray({
          field: r,
          array: c,
          enclosingRef: o,
          context: a
        }), f) : r.selectionSet ? u(n.executeSelectionSet({
          selectionSet: r.selectionSet,
          objectOrReference: c,
          enclosingRef: _t(c) ? c : o,
          context: a
        }), f) : (globalThis.__DEV__ !== !1 && fne(a.store, r, c), c);
      }), {
        result: a.canonizeResults ? this.canon.admit(i) : i,
        missing: s
      };
    }, e;
  })()
);
function cne(e) {
  try {
    JSON.stringify(e, function(t, n) {
      if (typeof n == "string")
        throw n;
      return n;
    });
  } catch (t) {
    return t;
  }
}
function fne(e, t, n) {
  if (!t.selectionSet) {
    var r = /* @__PURE__ */ new Set([n]);
    r.forEach(function(i) {
      Lt(i) && (Pe(
        !_t(i),
        11,
        ine(e, i),
        t.name.value
      ), Object.values(i).forEach(r.add, r));
    });
  }
}
var i_ = new Tl(), x2 = /* @__PURE__ */ new WeakMap();
function Eu(e) {
  var t = x2.get(e);
  return t || x2.set(e, t = {
    vars: /* @__PURE__ */ new Set(),
    dep: sI()
  }), t;
}
function E2(e) {
  Eu(e).vars.forEach(function(t) {
    return t.forgetCache(e);
  });
}
function dne(e) {
  Eu(e).vars.forEach(function(t) {
    return t.attachCache(e);
  });
}
function pne(e) {
  var t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = function(o) {
    if (arguments.length > 0) {
      if (e !== o) {
        e = o, t.forEach(function(l) {
          Eu(l).dep.dirty(r), hne(l);
        });
        var a = Array.from(n);
        n.clear(), a.forEach(function(l) {
          return l(e);
        });
      }
    } else {
      var s = i_.getValue();
      s && (i(s), Eu(s).dep(r));
    }
    return e;
  };
  r.onNextChange = function(o) {
    return n.add(o), function() {
      n.delete(o);
    };
  };
  var i = r.attachCache = function(o) {
    return t.add(o), Eu(o).vars.add(r), r;
  };
  return r.forgetCache = function(o) {
    return t.delete(o);
  }, r;
}
function hne(e) {
  e.broadcastWatches && e.broadcastWatches();
}
var S2 = /* @__PURE__ */ Object.create(null);
function o_(e) {
  var t = JSON.stringify(e);
  return S2[t] || (S2[t] = /* @__PURE__ */ Object.create(null));
}
function O2(e) {
  var t = o_(e);
  return t.keyFieldsFn || (t.keyFieldsFn = function(n, r) {
    var i = function(a, s) {
      return r.readField(s, a);
    }, o = r.keyObject = a_(e, function(a) {
      var s = ks(
        r.storeObject,
        a,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        i
      );
      return s === void 0 && n !== r.storeObject && mn.call(n, a[0]) && (s = ks(n, a, MI)), Pe(s !== void 0, 5, a.join("."), n), s;
    });
    return "".concat(r.typename, ":").concat(JSON.stringify(o));
  });
}
function $2(e) {
  var t = o_(e);
  return t.keyArgsFn || (t.keyArgsFn = function(n, r) {
    var i = r.field, o = r.variables, a = r.fieldName, s = a_(e, function(u) {
      var c = u[0], f = c.charAt(0);
      if (f === "@") {
        if (i && Di(i.directives)) {
          var d = c.slice(1), p = i.directives.find(function(g) {
            return g.name.value === d;
          }), h = p && dh(p, o);
          return h && ks(
            h,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            u.slice(1)
          );
        }
        return;
      }
      if (f === "$") {
        var v = c.slice(1);
        if (o && mn.call(o, v)) {
          var m = u.slice(0);
          return m[0] = v, ks(o, m);
        }
        return;
      }
      if (n)
        return ks(n, u);
    }), l = JSON.stringify(s);
    return (n || l !== "{}") && (a += ":" + l), a;
  });
}
function a_(e, t) {
  var n = new Ro();
  return RI(e).reduce(function(r, i) {
    var o, a = t(i);
    if (a !== void 0) {
      for (var s = i.length - 1; s >= 0; --s)
        a = (o = {}, o[i[s]] = a, o);
      r = n.merge(r, a);
    }
    return r;
  }, /* @__PURE__ */ Object.create(null));
}
function RI(e) {
  var t = o_(e);
  if (!t.paths) {
    var n = t.paths = [], r = [];
    e.forEach(function(i, o) {
      Xt(i) ? (RI(i).forEach(function(a) {
        return n.push(r.concat(a));
      }), r.length = 0) : (r.push(i), Xt(e[o + 1]) || (n.push(r.slice(0)), r.length = 0));
    });
  }
  return t.paths;
}
function MI(e, t) {
  return e[t];
}
function ks(e, t, n) {
  return n = n || MI, jI(t.reduce(function r(i, o) {
    return Xt(i) ? i.map(function(a) {
      return r(a, o);
    }) : i && n(i, o);
  }, e));
}
function jI(e) {
  return Lt(e) ? Xt(e) ? e.map(jI) : a_(Object.keys(e).sort(), function(t) {
    return ks(e, t);
  }) : e;
}
function vy(e) {
  return e.args !== void 0 ? e.args : e.field ? dh(e.field, e.variables) : null;
}
var vne = function() {
}, T2 = function(e, t) {
  return t.fieldName;
}, P2 = function(e, t, n) {
  var r = n.mergeObjects;
  return r(e, t);
}, k2 = function(e, t) {
  return t;
}, mne = (
  /** @class */
  (function() {
    function e(t) {
      this.config = t, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = G({ dataIdFromObject: kI }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
    }
    return e.prototype.identify = function(t, n) {
      var r, i = this, o = n && (n.typename || ((r = n.storeObject) === null || r === void 0 ? void 0 : r.__typename)) || t.__typename;
      if (o === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      var a = n && n.storeObject || t, s = G(G({}, n), { typename: o, storeObject: a, readField: n && n.readField || function() {
        var f = s_(arguments, a);
        return i.readField(f, {
          store: i.cache.data,
          variables: f.variables
        });
      } }), l, u = o && this.getTypePolicy(o), c = u && u.keyFn || this.config.dataIdFromObject;
      return r_.withValue(!0, function() {
        for (; c; ) {
          var f = c(G(G({}, t), a), s);
          if (Xt(f))
            c = O2(f);
          else {
            l = f;
            break;
          }
        }
      }), l = l ? String(l) : void 0, s.keyObject ? [l, s.keyObject] : [l];
    }, e.prototype.addTypePolicies = function(t) {
      var n = this;
      Object.keys(t).forEach(function(r) {
        var i = t[r], o = i.queryType, a = i.mutationType, s = i.subscriptionType, l = Ki(i, ["queryType", "mutationType", "subscriptionType"]);
        o && n.setRootTypename("Query", r), a && n.setRootTypename("Mutation", r), s && n.setRootTypename("Subscription", r), mn.call(n.toBeAdded, r) ? n.toBeAdded[r].push(l) : n.toBeAdded[r] = [l];
      });
    }, e.prototype.updateTypePolicy = function(t, n, r) {
      var i = this.getTypePolicy(t), o = n.keyFields, a = n.fields;
      function s(l, u) {
        l.merge = typeof u == "function" ? u : u === !0 ? P2 : u === !1 ? k2 : l.merge;
      }
      s(i, n.merge), i.keyFn = // Pass false to disable normalization for this typename.
      o === !1 ? vne : Xt(o) ? O2(o) : typeof o == "function" ? o : i.keyFn, a && Object.keys(a).forEach(function(l) {
        var u = r[l];
        (!u || u?.typename !== t) && (u = r[l] = { typename: t });
        var c = a[l];
        if (typeof c == "function")
          u.read = c;
        else {
          var f = c.keyArgs, d = c.read, p = c.merge;
          u.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          f === !1 ? T2 : Xt(f) ? $2(f) : typeof f == "function" ? f : u.keyFn, typeof d == "function" && (u.read = d), s(u, p);
        }
        u.read && u.merge && (u.keyFn = u.keyFn || T2);
      });
    }, e.prototype.setRootTypename = function(t, n) {
      n === void 0 && (n = t);
      var r = "ROOT_" + t.toUpperCase(), i = this.rootTypenamesById[r];
      n !== i && (Pe(!i || i === t, 6, t), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[n] = r, this.rootTypenamesById[r] = n);
    }, e.prototype.addPossibleTypes = function(t) {
      var n = this;
      this.usingPossibleTypes = !0, Object.keys(t).forEach(function(r) {
        n.getSupertypeSet(r, !0), t[r].forEach(function(i) {
          n.getSupertypeSet(i, !0).add(r);
          var o = i.match(CI);
          (!o || o[0] !== i) && n.fuzzySubtypes.set(i, new RegExp(i));
        });
      });
    }, e.prototype.getTypePolicy = function(t) {
      var n = this;
      if (!mn.call(this.typePolicies, t)) {
        var r = this.typePolicies[t] = /* @__PURE__ */ Object.create(null);
        r.fields = /* @__PURE__ */ Object.create(null);
        var i = this.supertypeMap.get(t);
        !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(t, !0), this.fuzzySubtypes.forEach(function(a, s) {
          if (a.test(t)) {
            var l = n.supertypeMap.get(s);
            l && l.forEach(function(u) {
              return i.add(u);
            });
          }
        })), i && i.size && i.forEach(function(a) {
          var s = n.getTypePolicy(a), l = s.fields, u = Ki(s, ["fields"]);
          Object.assign(r, u), Object.assign(r.fields, l);
        });
      }
      var o = this.toBeAdded[t];
      return o && o.length && o.splice(0).forEach(function(a) {
        n.updateTypePolicy(t, a, n.typePolicies[t].fields);
      }), this.typePolicies[t];
    }, e.prototype.getFieldPolicy = function(t, n) {
      if (t)
        return this.getTypePolicy(t).fields[n];
    }, e.prototype.getSupertypeSet = function(t, n) {
      var r = this.supertypeMap.get(t);
      return !r && n && this.supertypeMap.set(t, r = /* @__PURE__ */ new Set()), r;
    }, e.prototype.fragmentMatches = function(t, n, r, i) {
      var o = this;
      if (!t.typeCondition)
        return !0;
      if (!n)
        return !1;
      var a = t.typeCondition.name.value;
      if (n === a)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(a))
        for (var s = this.getSupertypeSet(n, !0), l = [s], u = function(h) {
          var v = o.getSupertypeSet(h, !1);
          v && v.size && l.indexOf(v) < 0 && l.push(v);
        }, c = !!(r && this.fuzzySubtypes.size), f = !1, d = 0; d < l.length; ++d) {
          var p = l[d];
          if (p.has(a))
            return s.has(a) || (f && globalThis.__DEV__ !== !1 && Pe.warn(7, n, a), s.add(a)), !0;
          p.forEach(u), c && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          d === l.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          hy(t.selectionSet, r, i) && (c = !1, f = !0, this.fuzzySubtypes.forEach(function(h, v) {
            var m = n.match(h);
            m && m[0] === n && u(v);
          }));
        }
      return !1;
    }, e.prototype.hasKeyArgs = function(t, n) {
      var r = this.getFieldPolicy(t, n);
      return !!(r && r.keyFn);
    }, e.prototype.getStoreFieldName = function(t) {
      var n = t.typename, r = t.fieldName, i = this.getFieldPolicy(n, r), o, a = i && i.keyFn;
      if (a && n)
        for (var s = {
          typename: n,
          fieldName: r,
          field: t.field || null,
          variables: t.variables
        }, l = vy(t); a; ) {
          var u = a(l, s);
          if (Xt(u))
            a = $2(u);
          else {
            o = u || r;
            break;
          }
        }
      return o === void 0 && (o = t.field ? Iee(t.field, t.variables) : ZC(r, vy(t))), o === !1 ? r : r === Mo(o) ? o : r + ":" + o;
    }, e.prototype.readField = function(t, n) {
      var r = t.from;
      if (r) {
        var i = t.field || t.fieldName;
        if (i) {
          if (t.typename === void 0) {
            var o = n.store.getFieldValue(r, "__typename");
            o && (t.typename = o);
          }
          var a = this.getStoreFieldName(t), s = Mo(a), l = n.store.getFieldValue(r, a), u = this.getFieldPolicy(t.typename, s), c = u && u.read;
          if (c) {
            var f = D2(this, r, t, n, n.store.getStorage(_t(r) ? r.__ref : r, a));
            return i_.withValue(this.cache, c, [
              l,
              f
            ]);
          }
          return l;
        }
      }
    }, e.prototype.getReadFunction = function(t, n) {
      var r = this.getFieldPolicy(t, n);
      return r && r.read;
    }, e.prototype.getMergeFunction = function(t, n, r) {
      var i = this.getFieldPolicy(t, n), o = i && i.merge;
      return !o && r && (i = this.getTypePolicy(r), o = i && i.merge), o;
    }, e.prototype.runMergeFunction = function(t, n, r, i, o) {
      var a = r.field, s = r.typename, l = r.merge;
      return l === P2 ? FI(i.store)(t, n) : l === k2 ? n : (i.overwrite && (t = void 0), l(t, n, D2(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: s,
          fieldName: a.name.value,
          field: a,
          variables: i.variables
        },
        i,
        o || /* @__PURE__ */ Object.create(null)
      )));
    }, e;
  })()
);
function D2(e, t, n, r, i) {
  var o = e.getStoreFieldName(n), a = Mo(o), s = n.variables || r.variables, l = r.store, u = l.toReference, c = l.canRead;
  return {
    args: vy(n),
    field: n.field || null,
    fieldName: a,
    storeFieldName: o,
    variables: s,
    isReference: _t,
    toReference: u,
    storage: i,
    cache: e.cache,
    canRead: c,
    readField: function() {
      return e.readField(s_(arguments, t, s), r);
    },
    mergeObjects: FI(r.store)
  };
}
function s_(e, t, n) {
  var r = e[0], i = e[1], o = e.length, a;
  return typeof r == "string" ? a = {
    fieldName: r,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: o > 1 ? i : t
  } : (a = G({}, r), mn.call(a, "from") || (a.from = t)), globalThis.__DEV__ !== !1 && a.from === void 0 && globalThis.__DEV__ !== !1 && Pe.warn(8, jC(Array.from(e))), a.variables === void 0 && (a.variables = n), a;
}
function FI(e) {
  return function(t, n) {
    if (Xt(t) || Xt(n))
      throw qn(9);
    if (Lt(t) && Lt(n)) {
      var r = e.getFieldValue(t, "__typename"), i = e.getFieldValue(n, "__typename"), o = r && i && r !== i;
      if (o)
        return n;
      if (_t(t) && ms(n))
        return e.merge(t.__ref, n), t;
      if (ms(t) && _t(n))
        return e.merge(t, n.__ref), n;
      if (ms(t) && ms(n))
        return G(G({}, t), n);
    }
    return n;
  };
}
function Gv(e, t, n) {
  var r = "".concat(t).concat(n), i = e.flavors.get(r);
  return i || e.flavors.set(r, i = e.clientOnly === t && e.deferred === n ? e : G(G({}, e), { clientOnly: t, deferred: n })), i;
}
var gne = (
  /** @class */
  (function() {
    function e(t, n, r) {
      this.cache = t, this.reader = n, this.fragments = r;
    }
    return e.prototype.writeToStore = function(t, n) {
      var r = this, i = n.query, o = n.result, a = n.dataId, s = n.variables, l = n.overwrite, u = ka(i), c = one();
      s = G(G({}, W0(u)), s);
      var f = G(G({ store: t, written: /* @__PURE__ */ Object.create(null), merge: function(p, h) {
        return c.merge(p, h);
      }, variables: s, varString: Oo(s) }, II(i, this.fragments)), { overwrite: !!l, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), d = this.processSelectionSet({
        result: o || /* @__PURE__ */ Object.create(null),
        dataId: a,
        selectionSet: u.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: f
      });
      if (!_t(d))
        throw qn(12, o);
      return f.incomingById.forEach(function(p, h) {
        var v = p.storeObject, m = p.mergeTree, g = p.fieldNodeSet, _ = Ts(h);
        if (m && m.map.size) {
          var w = r.applyMerges(m, _, v, f);
          if (_t(w))
            return;
          v = w;
        }
        if (globalThis.__DEV__ !== !1 && !f.overwrite) {
          var x = /* @__PURE__ */ Object.create(null);
          g.forEach(function(A) {
            A.selectionSet && (x[A.name.value] = !0);
          });
          var S = function(A) {
            return x[Mo(A)] === !0;
          }, $ = function(A) {
            var E = m && m.map.get(A);
            return !!(E && E.info && E.info.merge);
          };
          Object.keys(v).forEach(function(A) {
            S(A) && !$(A) && yne(_, v, A, f.store);
          });
        }
        t.merge(h, v);
      }), t.retain(d.__ref), d;
    }, e.prototype.processSelectionSet = function(t) {
      var n = this, r = t.dataId, i = t.result, o = t.selectionSet, a = t.context, s = t.mergeTree, l = this.cache.policies, u = /* @__PURE__ */ Object.create(null), c = r && l.rootTypenamesById[r] || ry(i, o, a.fragmentMap) || r && a.store.get(r, "__typename");
      typeof c == "string" && (u.__typename = c);
      var f = function() {
        var w = s_(arguments, u, a.variables);
        if (_t(w.from)) {
          var x = a.incomingById.get(w.from.__ref);
          if (x) {
            var S = l.readField(G(G({}, w), { from: x.storeObject }), a);
            if (S !== void 0)
              return S;
          }
        }
        return l.readField(w, a);
      }, d = /* @__PURE__ */ new Set();
      this.flattenFields(
        o,
        i,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        a,
        c
      ).forEach(function(w, x) {
        var S, $ = Xi(x), A = i[$];
        if (d.add(x), A !== void 0) {
          var E = l.getStoreFieldName({
            typename: c,
            fieldName: x.name.value,
            field: x,
            variables: w.variables
          }), y = A2(s, E), b = n.processFieldValue(
            A,
            x,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            x.selectionSet ? Gv(w, !1, !1) : w,
            y
          ), O = void 0;
          x.selectionSet && (_t(b) || ms(b)) && (O = f("__typename", b));
          var k = l.getMergeFunction(c, x.name.value, O);
          k ? y.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: x,
            typename: c,
            merge: k
          } : C2(s, E), u = w.merge(u, (S = {}, S[E] = b, S));
        } else globalThis.__DEV__ !== !1 && !w.clientOnly && !w.deferred && !Q0.added(x) && // If the field has a read function, it may be a synthetic field or
        // provide a default value, so its absence from the written data should
        // not be cause for alarm.
        !l.getReadFunction(c, x.name.value) && globalThis.__DEV__ !== !1 && Pe.error(13, Xi(x), i);
      });
      try {
        var p = l.identify(i, {
          typename: c,
          selectionSet: o,
          fragmentMap: a.fragmentMap,
          storeObject: u,
          readField: f
        }), h = p[0], v = p[1];
        r = r || h, v && (u = a.merge(u, v));
      } catch (w) {
        if (!r)
          throw w;
      }
      if (typeof r == "string") {
        var m = Ts(r), g = a.written[r] || (a.written[r] = []);
        if (g.indexOf(o) >= 0 || (g.push(o), this.reader && this.reader.isFresh(i, m, o, a)))
          return m;
        var _ = a.incomingById.get(r);
        return _ ? (_.storeObject = a.merge(_.storeObject, u), _.mergeTree = my(_.mergeTree, s), d.forEach(function(w) {
          return _.fieldNodeSet.add(w);
        })) : a.incomingById.set(r, {
          storeObject: u,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: Jd(s) ? void 0 : s,
          fieldNodeSet: d
        }), m;
      }
      return u;
    }, e.prototype.processFieldValue = function(t, n, r, i) {
      var o = this;
      return !n.selectionSet || t === null ? globalThis.__DEV__ !== !1 ? vI(t) : t : Xt(t) ? t.map(function(a, s) {
        var l = o.processFieldValue(a, n, r, A2(i, s));
        return C2(i, s), l;
      }) : this.processSelectionSet({
        result: t,
        selectionSet: n.selectionSet,
        context: r,
        mergeTree: i
      });
    }, e.prototype.flattenFields = function(t, n, r, i) {
      i === void 0 && (i = ry(n, t, r.fragmentMap));
      var o = /* @__PURE__ */ new Map(), a = this.cache.policies, s = new no(!1);
      return (function l(u, c) {
        var f = s.lookup(
          u,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          c.clientOnly,
          c.deferred
        );
        f.visited || (f.visited = !0, u.selections.forEach(function(d) {
          if (Nc(d, r.variables)) {
            var p = c.clientOnly, h = c.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(p && h) && Di(d.directives) && d.directives.forEach(function(g) {
                var _ = g.name.value;
                if (_ === "client" && (p = !0), _ === "defer") {
                  var w = dh(g, r.variables);
                  (!w || w.if !== !1) && (h = !0);
                }
              }), Io(d)
            ) {
              var v = o.get(d);
              v && (p = p && v.clientOnly, h = h && v.deferred), o.set(d, Gv(r, p, h));
            } else {
              var m = fh(d, r.lookupFragment);
              if (!m && d.kind === Ht.FRAGMENT_SPREAD)
                throw qn(14, d.name.value);
              m && a.fragmentMatches(m, i, n, r.variables) && l(m.selectionSet, Gv(r, p, h));
            }
          }
        }));
      })(t, r), o;
    }, e.prototype.applyMerges = function(t, n, r, i, o) {
      var a, s = this;
      if (t.map.size && !_t(r)) {
        var l = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !Xt(r) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (_t(n) || ms(n)) ? n : void 0
        ), u = r;
        l && !o && (o = [_t(l) ? l.__ref : l]);
        var c, f = function(d, p) {
          return Xt(d) ? typeof p == "number" ? d[p] : void 0 : i.store.getFieldValue(d, String(p));
        };
        t.map.forEach(function(d, p) {
          var h = f(l, p), v = f(u, p);
          if (v !== void 0) {
            o && o.push(p);
            var m = s.applyMerges(d, h, v, i, o);
            m !== v && (c = c || /* @__PURE__ */ new Map(), c.set(p, m)), o && Pe(o.pop() === p);
          }
        }), c && (r = Xt(u) ? u.slice(0) : G({}, u), c.forEach(function(d, p) {
          r[p] = d;
        }));
      }
      return t.info ? this.cache.policies.runMergeFunction(n, r, t.info, i, o && (a = i.store).getStorage.apply(a, o)) : r;
    }, e;
  })()
), zI = [];
function A2(e, t) {
  var n = e.map;
  return n.has(t) || n.set(t, zI.pop() || { map: /* @__PURE__ */ new Map() }), n.get(t);
}
function my(e, t) {
  if (e === t || !t || Jd(t))
    return e;
  if (!e || Jd(e))
    return t;
  var n = e.info && t.info ? G(G({}, e.info), t.info) : e.info || t.info, r = e.map.size && t.map.size, i = r ? /* @__PURE__ */ new Map() : e.map.size ? e.map : t.map, o = { info: n, map: i };
  if (r) {
    var a = new Set(t.map.keys());
    e.map.forEach(function(s, l) {
      o.map.set(l, my(s, t.map.get(l))), a.delete(l);
    }), a.forEach(function(s) {
      o.map.set(s, my(t.map.get(s), e.map.get(s)));
    });
  }
  return o;
}
function Jd(e) {
  return !e || !(e.info || e.map.size);
}
function C2(e, t) {
  var n = e.map, r = n.get(t);
  r && Jd(r) && (zI.push(r), n.delete(t));
}
var I2 = /* @__PURE__ */ new Set();
function yne(e, t, n, r) {
  var i = function(f) {
    var d = r.getFieldValue(f, n);
    return typeof d == "object" && d;
  }, o = i(e);
  if (o) {
    var a = i(t);
    if (a && !_t(o) && !Ot(o, a) && !Object.keys(o).every(function(f) {
      return r.getFieldValue(a, f) !== void 0;
    })) {
      var s = r.getFieldValue(e, "__typename") || r.getFieldValue(t, "__typename"), l = Mo(n), u = "".concat(s, ".").concat(l);
      if (!I2.has(u)) {
        I2.add(u);
        var c = [];
        !Xt(o) && !Xt(a) && [o, a].forEach(function(f) {
          var d = r.getFieldValue(f, "__typename");
          typeof d == "string" && !c.includes(d) && c.push(d);
        }), globalThis.__DEV__ !== !1 && Pe.warn(15, l, s, c.length ? "either ensure all objects of type " + c.join(" and ") + " have an ID or a custom merge function, or " : "", u, G({}, o), G({}, a));
      }
    }
  }
}
var bne = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this) || this;
      return r.watches = /* @__PURE__ */ new Set(), r.addTypenameTransform = new lI(Q0), r.assumeImmutableResults = !0, r.makeVar = pne, r.txCount = 0, globalThis.__DEV__ !== !1 && (nn(n, "addTypename", "InMemoryCache", "Please remove the `addTypename` option when initializing `InMemoryCache`."), nn(n, "canonizeResults", "InMemoryCache", "Please remove the `canonizeResults` option when initializing `InMemoryCache`.")), r.config = rne(n), r.addTypename = !!r.config.addTypename, r.policies = new mne({
        cache: r,
        dataIdFromObject: r.config.dataIdFromObject,
        possibleTypes: r.config.possibleTypes,
        typePolicies: r.config.typePolicies
      }), r.init(), r;
    }
    return t.prototype.init = function() {
      var n = this.data = new rc.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = n.stump, this.resetResultCache();
    }, t.prototype.resetResultCache = function(n) {
      var r = this, i = this.storeReader, o = this.config.fragments;
      this.addTypenameTransform.resetCache(), o?.resetCaches(), this.storeWriter = new gne(this, this.storeReader = new une({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: AI(this.config),
        canon: n ? void 0 : i && i.canon,
        fragments: o
      }), o), this.maybeBroadcastWatch = nc(function(a, s) {
        return r.broadcastWatch(a, s);
      }, {
        max: this.config.resultCacheMaxSize || Ji["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(a) {
          var s = a.optimistic ? r.optimisticData : r.data;
          if (xu(s)) {
            var l = a.optimistic, u = a.id, c = a.variables;
            return s.makeCacheKey(
              a.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              a.callback,
              Oo({ optimistic: l, id: u, variables: c })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(a) {
        return a.resetCaching();
      });
    }, t.prototype.restore = function(n) {
      return this.init(), n && this.data.replace(n), this;
    }, t.prototype.extract = function(n) {
      return n === void 0 && (n = !1), (n ? this.optimisticData : this.data).extract();
    }, t.prototype.read = function(n) {
      globalThis.__DEV__ !== !1 && nn(n, "canonizeResults", "cache.read");
      var r = n.returnPartialData, i = r === void 0 ? !1 : r;
      try {
        return this.storeReader.diffQueryAgainstStore(G(G({}, n), { store: n.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
      } catch (o) {
        if (o instanceof PI)
          return null;
        throw o;
      }
    }, t.prototype.write = function(n) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, n);
      } finally {
        !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.modify = function(n) {
      if (mn.call(n, "id") && !n.id)
        return !1;
      var r = n.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, r.modify(n.id || "ROOT_QUERY", n.fields);
      } finally {
        !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.diff = function(n) {
      return globalThis.__DEV__ !== !1 && nn(n, "canonizeResults", "cache.diff"), this.storeReader.diffQueryAgainstStore(G(G({}, n), { store: n.optimistic ? this.optimisticData : this.data, rootId: n.id || "ROOT_QUERY", config: this.config }));
    }, t.prototype.watch = function(n) {
      var r = this;
      return this.watches.size || dne(this), this.watches.add(n), n.immediate && this.maybeBroadcastWatch(n), function() {
        r.watches.delete(n) && !r.watches.size && E2(r), r.maybeBroadcastWatch.forget(n);
      };
    }, t.prototype.gc = function(n) {
      globalThis.__DEV__ !== !1 && nn(n || {}, "resetResultIdentities", "cache.gc", "First ensure all usages of `canonizeResults` are removed, then remove this option."), Oo.reset(), Eo.reset();
      var r = this.optimisticData.gc();
      return n && !this.txCount && (n.resetResultCache ? this.resetResultCache(n.resetResultIdentities) : n.resetResultIdentities && this.storeReader.resetCanon()), r;
    }, t.prototype.retain = function(n, r) {
      return (r ? this.optimisticData : this.data).retain(n);
    }, t.prototype.release = function(n, r) {
      return (r ? this.optimisticData : this.data).release(n);
    }, t.prototype.identify = function(n) {
      if (_t(n))
        return n.__ref;
      try {
        return this.policies.identify(n)[0];
      } catch (r) {
        globalThis.__DEV__ !== !1 && Pe.warn(r);
      }
    }, t.prototype.evict = function(n) {
      if (!n.id) {
        if (mn.call(n, "id"))
          return !1;
        n = G(G({}, n), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(n, this.data);
      } finally {
        !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.reset = function(n) {
      var r = this;
      return this.init(), Oo.reset(), n && n.discardWatches ? (this.watches.forEach(function(i) {
        return r.maybeBroadcastWatch.forget(i);
      }), this.watches.clear(), E2(this)) : this.broadcastWatches(), Promise.resolve();
    }, t.prototype.removeOptimistic = function(n) {
      var r = this.optimisticData.removeLayer(n);
      r !== this.optimisticData && (this.optimisticData = r, this.broadcastWatches());
    }, t.prototype.batch = function(n) {
      var r = this, i = n.update, o = n.optimistic, a = o === void 0 ? !0 : o, s = n.removeOptimistic, l = n.onWatchUpdated, u, c = function(d) {
        var p = r, h = p.data, v = p.optimisticData;
        ++r.txCount, d && (r.data = r.optimisticData = d);
        try {
          return u = i(r);
        } finally {
          --r.txCount, r.data = h, r.optimisticData = v;
        }
      }, f = /* @__PURE__ */ new Set();
      return l && !this.txCount && this.broadcastWatches(G(G({}, n), { onWatchUpdated: function(d) {
        return f.add(d), !1;
      } })), typeof a == "string" ? this.optimisticData = this.optimisticData.addLayer(a, c) : a === !1 ? c(this.data) : c(), typeof s == "string" && (this.optimisticData = this.optimisticData.removeLayer(s)), l && f.size ? (this.broadcastWatches(G(G({}, n), { onWatchUpdated: function(d, p) {
        var h = l.call(this, d, p);
        return h !== !1 && f.delete(d), h;
      } })), f.size && f.forEach(function(d) {
        return r.maybeBroadcastWatch.dirty(d);
      })) : this.broadcastWatches(n), u;
    }, t.prototype.performTransaction = function(n, r) {
      return this.batch({
        update: n,
        optimistic: r || r !== null
      });
    }, t.prototype.transformDocument = function(n) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(n));
    }, t.prototype.fragmentMatches = function(n, r) {
      return this.policies.fragmentMatches(n, r);
    }, t.prototype.lookupFragment = function(n) {
      var r;
      return ((r = this.config.fragments) === null || r === void 0 ? void 0 : r.lookup(n)) || null;
    }, t.prototype.broadcastWatches = function(n) {
      var r = this;
      this.txCount || this.watches.forEach(function(i) {
        return r.maybeBroadcastWatch(i, n);
      });
    }, t.prototype.addFragmentsToDocument = function(n) {
      var r = this.config.fragments;
      return r ? r.transform(n) : n;
    }, t.prototype.addTypenameToDocument = function(n) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(n) : n;
    }, t.prototype.broadcastWatch = function(n, r) {
      var i = this, o = n.lastDiff, a = An("canonizeResults", function() {
        return i.diff(n);
      });
      r && (n.optimistic && typeof r.optimistic == "string" && (a.fromOptimisticTransaction = !0), r.onWatchUpdated && r.onWatchUpdated.call(this, n, a, o) === !1) || (!o || !Ot(o.result, a.result)) && n.callback(n.lastDiff = a, o);
    }, t;
  })(TI)
);
globalThis.__DEV__ !== !1 && (bne.prototype.getMemoryInternals = vee);
var bt;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(bt || (bt = {}));
function gs(e) {
  return e ? e < 7 : !1;
}
var N2 = Object.assign, _ne = Object.hasOwnProperty, Yf = (
  /** @class */
  (function(e) {
    pi(t, e);
    function t(n) {
      var r = n.queryManager, i = n.queryInfo, o = n.options, a = this, s = t.inactiveOnCreation.getValue();
      a = e.call(this, function(g) {
        a._getOrCreateQuery();
        try {
          var _ = g._subscription._observer;
          _ && !_.error && (_.error = wne);
        } catch {
        }
        var w = !a.observers.size;
        a.observers.add(g);
        var x = a.last;
        return x && x.error ? g.error && g.error(x.error) : x && x.result && g.next && g.next(a.maskResult(x.result)), w && a.reobserve().catch(function() {
        }), function() {
          a.observers.delete(g) && !a.observers.size && a.tearDownQuery();
        };
      }) || this, a.observers = /* @__PURE__ */ new Set(), a.subscriptions = /* @__PURE__ */ new Set(), a.dirty = !1, a._getOrCreateQuery = function() {
        return s && (r.queries.set(a.queryId, i), s = !1), a.queryManager.getOrCreateQuery(a.queryId);
      }, a.queryInfo = i, a.queryManager = r, a.waitForOwnResult = Yv(o.fetchPolicy), a.isTornDown = !1, a.subscribeToMore = a.subscribeToMore.bind(a), a.maskResult = a.maskResult.bind(a);
      var l = r.defaultOptions.watchQuery, u = l === void 0 ? {} : l, c = u.fetchPolicy, f = c === void 0 ? "cache-first" : c, d = o.fetchPolicy, p = d === void 0 ? f : d, h = o.initialFetchPolicy, v = h === void 0 ? p === "standby" ? f : p : h;
      a.options = G(G({}, o), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: v,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: p
      }), a.queryId = i.queryId || r.generateQueryId();
      var m = ka(a.query);
      return a.queryName = m && m.name && m.name.value, a;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var n = this;
      return globalThis.__DEV__ !== !1 && ia("observableQuery.result", function() {
        globalThis.__DEV__ !== !1 && Pe.warn(23);
      }), new Promise(function(r, i) {
        var o = {
          next: function(s) {
            r(s), n.observers.delete(o), n.observers.size || n.queryManager.removeQuery(n.queryId), setTimeout(function() {
              a.unsubscribe();
            }, 0);
          },
          error: i
        }, a = n.subscribe(o);
      });
    }, t.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, t.prototype.getCurrentFullResult = function(n) {
      var r = this;
      n === void 0 && (n = !0);
      var i = An("getLastResult", function() {
        return r.getLastResult(!0);
      }), o = this.queryInfo.networkStatus || i && i.networkStatus || bt.ready, a = G(G({}, i), { loading: gs(o), networkStatus: o }), s = this.options.fetchPolicy, l = s === void 0 ? "cache-first" : s;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(Yv(l) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var u = this.queryInfo.getDiff();
        (u.complete || this.options.returnPartialData) && (a.data = u.result), Ot(a.data, {}) && (a.data = void 0), u.complete ? (delete a.partial, u.complete && a.networkStatus === bt.loading && (l === "cache-first" || l === "cache-only") && (a.networkStatus = bt.ready, a.loading = !1)) : a.partial = !0, a.networkStatus === bt.ready && (a.error || a.errors) && (a.networkStatus = bt.error), globalThis.__DEV__ !== !1 && !u.complete && !this.options.partialRefetch && !a.loading && !a.data && !a.error && LI(u.missing);
      }
      return n && this.updateLastResult(a), a;
    }, t.prototype.getCurrentResult = function(n) {
      return n === void 0 && (n = !0), this.maskResult(this.getCurrentFullResult(n));
    }, t.prototype.isDifferentFromLastResult = function(n, r) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), o = this.queryManager.dataMasking, a = o ? i.nonReactiveQuery : this.query, s = o || i.hasNonreactiveDirective ? !wI(a, this.last.result, n, this.variables) : !Ot(this.last.result, n);
      return s || r && !Ot(this.last.variables, r);
    }, t.prototype.getLast = function(n, r) {
      var i = this.last;
      if (i && i[n] && (!r || Ot(i.variables, this.variables)))
        return i[n];
    }, t.prototype.getLastResult = function(n) {
      return globalThis.__DEV__ !== !1 && ia("getLastResult", function() {
        globalThis.__DEV__ !== !1 && Pe.warn(24);
      }), this.getLast("result", n);
    }, t.prototype.getLastError = function(n) {
      return globalThis.__DEV__ !== !1 && ia("getLastError", function() {
        globalThis.__DEV__ !== !1 && Pe.warn(25);
      }), this.getLast("error", n);
    }, t.prototype.resetLastResults = function() {
      globalThis.__DEV__ !== !1 && ia("resetLastResults", function() {
        globalThis.__DEV__ !== !1 && Pe.warn(26);
      }), delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Pe.warn(27), this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(n) {
      var r, i = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, o = this.options.fetchPolicy;
      if (o === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && n && _ne.call(n, "variables")) {
        var a = GC(this.query), s = a.variableDefinitions;
        (!s || !s.some(function(l) {
          return l.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && Pe.warn(
          28,
          n,
          ((r = a.name) === null || r === void 0 ? void 0 : r.value) || a
        );
      }
      return n && !Ot(this.options.variables, n) && (i.variables = this.options.variables = G(G({}, this.options.variables), n)), this.queryInfo.resetLastWrite(), this.reobserve(i, bt.refetch);
    }, t.prototype.fetchMore = function(n) {
      var r = this, i = G(G({}, n.query ? n : G(G(G(G({}, this.options), { query: this.options.query }), n), { variables: G(G({}, this.options.variables), n.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var o = this.queryManager.generateQueryId();
      this.lastQuery = n.query ? this.transformDocument(this.options.query) : i.query;
      var a = this.queryInfo, s = a.networkStatus;
      a.networkStatus = bt.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var l = /* @__PURE__ */ new Set(), u = n?.updateQuery, c = this.options.fetchPolicy !== "no-cache";
      return c || Pe(u, 29), this.queryManager.fetchQuery(o, i, bt.fetchMore).then(function(f) {
        if (r.queryManager.removeQuery(o), a.networkStatus === bt.fetchMore && (a.networkStatus = s), c)
          r.queryManager.cache.batch({
            update: function(h) {
              var v = n.updateQuery;
              v ? h.updateQuery({
                query: r.query,
                variables: r.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(m) {
                return v(m, {
                  fetchMoreResult: f.data,
                  variables: i.variables
                });
              }) : h.writeQuery({
                query: i.query,
                variables: i.variables,
                data: f.data
              });
            },
            onWatchUpdated: function(h) {
              l.add(h.query);
            }
          });
        else {
          var d = r.getLast("result"), p = u(d.data, {
            fetchMoreResult: f.data,
            variables: i.variables
          });
          r.reportResult(G(G({}, d), { networkStatus: s, loading: gs(s), data: p }), r.variables);
        }
        return r.maskResult(f);
      }).finally(function() {
        c && !l.has(r.query) && r.reobserveCacheFirst();
      });
    }, t.prototype.subscribeToMore = function(n) {
      var r = this, i = this.queryManager.startGraphQLSubscription({
        query: n.document,
        variables: n.variables,
        context: n.context
      }).subscribe({
        next: function(o) {
          var a = n.updateQuery;
          a && r.updateQuery(function(s, l) {
            return a(s, G({ subscriptionData: o }, l));
          });
        },
        error: function(o) {
          if (n.onError) {
            n.onError(o);
            return;
          }
          globalThis.__DEV__ !== !1 && Pe.error(30, o);
        }
      });
      return this.subscriptions.add(i), function() {
        r.subscriptions.delete(i) && i.unsubscribe();
      };
    }, t.prototype.setOptions = function(n) {
      return globalThis.__DEV__ !== !1 && (nn(n, "canonizeResults", "setOptions"), ia("setOptions", function() {
        globalThis.__DEV__ !== !1 && Pe.warn(31);
      })), this.reobserve(n);
    }, t.prototype.silentSetOptions = function(n) {
      var r = Xs(this.options, n || {});
      N2(this.options, r);
    }, t.prototype.setVariables = function(n) {
      var r = this;
      return Ot(this.variables, n) ? this.observers.size ? An("observableQuery.result", function() {
        return r.result();
      }) : Promise.resolve() : (this.options.variables = n, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: n
      }, bt.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(n) {
      var r = this.queryManager, i = r.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), o = i.result, a = i.complete, s = n(o, {
        variables: this.variables,
        complete: !!a,
        previousData: o
      });
      s && (r.cache.writeQuery({
        query: this.options.query,
        data: s,
        variables: this.variables
      }), r.broadcastQueries());
    }, t.prototype.startPolling = function(n) {
      this.options.pollInterval = n, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(n, r) {
      if (r.nextFetchPolicy) {
        var i = r.fetchPolicy, o = i === void 0 ? "cache-first" : i, a = r.initialFetchPolicy, s = a === void 0 ? o : a;
        o === "standby" || (typeof r.nextFetchPolicy == "function" ? r.fetchPolicy = r.nextFetchPolicy(o, {
          reason: n,
          options: r,
          observable: this,
          initialFetchPolicy: s
        }) : n === "variables-changed" ? r.fetchPolicy = s : r.fetchPolicy = r.nextFetchPolicy);
      }
      return r.fetchPolicy;
    }, t.prototype.fetch = function(n, r, i) {
      var o = this._getOrCreateQuery();
      return o.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(o, n, r, i);
    }, t.prototype.updatePolling = function() {
      var n = this;
      if (!this.queryManager.ssrMode) {
        var r = this, i = r.pollingInfo, o = r.options.pollInterval;
        if (!o || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === o)) {
          Pe(o, 32);
          var a = i || (this.pollingInfo = {});
          a.interval = o;
          var s = function() {
            var u, c;
            n.pollingInfo && (!gs(n.queryInfo.networkStatus) && !(!((c = (u = n.options).skipPollAttempt) === null || c === void 0) && c.call(u)) ? n.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: n.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, bt.poll).then(l, l) : l());
          }, l = function() {
            var u = n.pollingInfo;
            u && (clearTimeout(u.timeout), u.timeout = setTimeout(s, u.interval));
          };
          l();
        }
      }
    }, t.prototype.updateLastResult = function(n, r) {
      var i = this;
      r === void 0 && (r = this.variables);
      var o = An("getLastError", function() {
        return i.getLastError();
      });
      return o && this.last && !Ot(r, this.last.variables) && (o = void 0), this.last = G({ result: this.queryManager.assumeImmutableResults ? n : vI(n), variables: r }, o ? { error: o } : null);
    }, t.prototype.reobserveAsConcast = function(n, r) {
      var i = this;
      this.isTornDown = !1;
      var o = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        r === bt.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        r === bt.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        r === bt.poll
      ), a = this.options.variables, s = this.options.fetchPolicy, l = Xs(this.options, n || {}), u = o ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        l
      ) : N2(this.options, l), c = this.transformDocument(u.query);
      this.lastQuery = c, o || (this.updatePolling(), n && n.variables && !Ot(n.variables, a) && // Don't mess with the fetchPolicy if it's currently "standby".
      u.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (u.fetchPolicy === s || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof u.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", u), r === void 0 && (r = bt.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = Yv(u.fetchPolicy));
      var f = function() {
        i.concast === h && (i.waitForOwnResult = !1);
      }, d = u.variables && G({}, u.variables), p = this.fetch(u, r, c), h = p.concast, v = p.fromLink, m = {
        next: function(g) {
          Ot(i.variables, d) && (f(), i.reportResult(g, d));
        },
        error: function(g) {
          Ot(i.variables, d) && (bI(g) || (g = new mo({ networkError: g })), f(), i.reportError(g, d));
        }
      };
      return !o && (v || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = h, this.observer = m), h.addObserver(m), h;
    }, t.prototype.reobserve = function(n, r) {
      return lte(this.reobserveAsConcast(n, r).promise.then(this.maskResult));
    }, t.prototype.resubscribeAfterError = function() {
      for (var n = this, r = [], i = 0; i < arguments.length; i++)
        r[i] = arguments[i];
      var o = this.last;
      An("resetLastResults", function() {
        return n.resetLastResults();
      });
      var a = this.subscribe.apply(this, r);
      return this.last = o, a;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(n, r) {
      var i = this, o = An("getLastError", function() {
        return i.getLastError();
      }), a = this.isDifferentFromLastResult(n, r);
      (o || !n.partial || this.options.returnPartialData) && this.updateLastResult(n, r), (o || a) && wu(this.observers, "next", this.maskResult(n));
    }, t.prototype.reportError = function(n, r) {
      var i = this, o = G(G({}, An("getLastResult", function() {
        return i.getLastResult();
      })), { error: n, errors: n.graphQLErrors, networkStatus: bt.error, loading: !1 });
      this.updateLastResult(o, r), wu(this.observers, "error", this.last.error = n);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(n) {
        return n.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(n) {
      return this.queryManager.transform(n);
    }, t.prototype.maskResult = function(n) {
      return n && "data" in n ? G(G({}, n), { data: this.queryManager.maskOperation({
        document: this.query,
        data: n.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : n;
    }, t.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, t.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, t.prototype.scheduleNotify = function() {
      var n = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return n.notify();
      }, 0)));
    }, t.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !gs(this.queryInfo.networkStatus))) {
        var n = this.queryInfo.getDiff();
        n.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, t.prototype.reobserveCacheFirst = function() {
      var n = this.options, r = n.fetchPolicy, i = n.nextFetchPolicy;
      return r === "cache-and-network" || r === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(o, a) {
          return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(o, a) : r;
        }
      }) : this.reobserve();
    }, t.inactiveOnCreation = new Tl(), t;
  })(St)
);
mI(Yf);
function wne(e) {
  globalThis.__DEV__ !== !1 && Pe.error(33, e.message, e.stack);
}
function LI(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && Pe.debug(34, e);
}
function Yv(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var ys = new (Ha ? WeakMap : Map)();
function Qv(e, t) {
  var n = e[t];
  typeof n == "function" && (e[t] = function() {
    return ys.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (ys.get(e) + 1) % 1e15
    ), n.apply(this, arguments);
  });
}
var Jv = (
  /** @class */
  (function() {
    function e(t, n) {
      n === void 0 && (n = t.generateQueryId()), this.queryId = n, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
      var r = this.cache = t.cache;
      ys.has(r) || (ys.set(r, 0), Qv(r, "evict"), Qv(r, "modify"), Qv(r, "reset"));
    }
    return e.prototype.init = function(t) {
      var n = t.networkStatus || bt.loading;
      return this.variables && this.networkStatus !== bt.loading && !Ot(this.variables, t.variables) && (n = bt.setVariables), Ot(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: t.document,
        variables: t.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: n
      }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
    }, e.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, e.prototype.getDiff = function() {
      var t = this, n = this.getDiffOptions();
      if (this.lastDiff && Ot(n, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var r = this.observableQuery;
      if (r && r.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = An("canonizeResults", function() {
        return t.cache.diff(n);
      });
      return this.updateLastDiff(i, n), i;
    }, e.prototype.updateLastDiff = function(t, n) {
      this.lastDiff = t ? {
        diff: t,
        options: n || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(t) {
      var n;
      return t === void 0 && (t = this.variables), {
        query: this.document,
        variables: t,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (n = this.observableQuery) === null || n === void 0 ? void 0 : n.options.canonizeResults
      };
    }, e.prototype.setDiff = function(t) {
      var n = this, r, i = this.lastDiff && this.lastDiff.diff;
      t && !t.complete && An("getLastError", function() {
        var o;
        return (o = n.observableQuery) === null || o === void 0 ? void 0 : o.getLastError();
      }) || (this.updateLastDiff(t), Ot(i && i.result, t && t.result) || (r = this.observableQuery) === null || r === void 0 || r.scheduleNotify());
    }, e.prototype.setObservableQuery = function(t) {
      t !== this.observableQuery && (this.observableQuery = t, t && (t.queryInfo = this));
    }, e.prototype.stop = function() {
      var t;
      if (!this.stopped) {
        this.stopped = !0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), this.cancel();
        var n = this.observableQuery;
        n && n.stopPolling();
      }
    }, e.prototype.cancel = function() {
      var t;
      (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
    }, e.prototype.updateWatch = function(t) {
      var n = this;
      t === void 0 && (t = this.variables);
      var r = this.observableQuery;
      if (!(r && r.options.fetchPolicy === "no-cache")) {
        var i = G(G({}, this.getDiffOptions(t)), { watcher: this, callback: function(o) {
          return n.setDiff(o);
        } });
        (!this.lastWatch || !Ot(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(t, n) {
      var r = this.lastWrite;
      return !(r && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      r.dmCount === ys.get(this.cache) && Ot(n, r.variables) && Ot(t.data, r.result.data));
    }, e.prototype.markResult = function(t, n, r, i) {
      var o = this, a, s = new Ro(), l = Di(t.errors) ? t.errors.slice(0) : [];
      if ((a = this.observableQuery) === null || a === void 0 || a.resetNotifications(), "incremental" in t && Di(t.incremental)) {
        var u = gI(this.getDiff().result, t);
        t.data = u;
      } else if ("hasNext" in t && t.hasNext) {
        var c = this.getDiff();
        t.data = s.merge(c.result, t.data);
      }
      this.graphQLErrors = l, r.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(r.variables)) : i !== 0 && (gy(t, r.errorPolicy) ? this.cache.performTransaction(function(f) {
        if (o.shouldWrite(t, r.variables))
          f.writeQuery({
            query: n,
            data: t.data,
            variables: r.variables,
            overwrite: i === 1
          }), o.lastWrite = {
            result: t,
            variables: r.variables,
            dmCount: ys.get(o.cache)
          };
        else if (o.lastDiff && o.lastDiff.diff.complete) {
          t.data = o.lastDiff.diff.result;
          return;
        }
        var d = o.getDiffOptions(r.variables), p = An("canonizeResults", function() {
          return f.diff(d);
        });
        !o.stopped && Ot(o.variables, r.variables) && o.updateWatch(r.variables), o.updateLastDiff(p, d), p.complete && (t.data = p.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = bt.ready;
    }, e.prototype.markError = function(t) {
      var n;
      return this.networkStatus = bt.error, this.lastWrite = void 0, (n = this.observableQuery) === null || n === void 0 || n.resetNotifications(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
    }, e;
  })()
);
function gy(e, t) {
  t === void 0 && (t = "none");
  var n = t === "ignore" || t === "all", r = !Wf(e);
  return !r && n && e.data && (r = !0), r;
}
var xne = Object.prototype.hasOwnProperty, R2 = /* @__PURE__ */ Object.create(null), Ene = (
  /** @class */
  (function() {
    function e(t) {
      var n = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new BC(
        Ji["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new no(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var r = new lI(
        function(o) {
          return n.cache.transformDocument(o);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
      var i = t.documentTransform;
      this.documentTransform = i ? r.concat(i).concat(r) : r, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var t = this;
      this.queries.forEach(function(n, r) {
        t.stopQueryNoBroadcast(r);
      }), this.cancelPendingFetches(qn(35));
    }, e.prototype.cancelPendingFetches = function(t) {
      this.fetchCancelFns.forEach(function(n) {
        return n(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(t) {
      return po(this, arguments, void 0, function(n) {
        var r, i, o, a, s, l, u, c = n.mutation, f = n.variables, d = n.optimisticResponse, p = n.updateQueries, h = n.refetchQueries, v = h === void 0 ? [] : h, m = n.awaitRefetchQueries, g = m === void 0 ? !1 : m, _ = n.update, w = n.onQueryUpdated, x = n.fetchPolicy, S = x === void 0 ? ((l = this.defaultOptions.mutate) === null || l === void 0 ? void 0 : l.fetchPolicy) || "network-only" : x, $ = n.errorPolicy, A = $ === void 0 ? ((u = this.defaultOptions.mutate) === null || u === void 0 ? void 0 : u.errorPolicy) || "none" : $, E = n.keepRootFields, y = n.context;
        return ho(this, function(b) {
          switch (b.label) {
            case 0:
              return Pe(c, 36), Pe(S === "network-only" || S === "no-cache", 37), r = this.generateMutationId(), c = this.cache.transformForLink(this.transform(c)), i = this.getDocumentInfo(c).hasClientExports, f = this.getVariables(c, f), i ? [4, this.localState.addExportedVariables(c, f, y)] : [3, 2];
            case 1:
              f = b.sent(), b.label = 2;
            case 2:
              return o = this.mutationStore && (this.mutationStore[r] = {
                mutation: c,
                variables: f,
                loading: !0,
                error: null
              }), a = d && this.markMutationOptimistic(d, {
                mutationId: r,
                document: c,
                variables: f,
                fetchPolicy: S,
                errorPolicy: A,
                context: y,
                updateQueries: p,
                update: _,
                keepRootFields: E
              }), this.broadcastQueries(), s = this, [2, new Promise(function(O, k) {
                return Bv(s.getObservableFromLink(c, G(G({}, y), { optimisticResponse: a ? d : void 0 }), f, {}, !1), function(I) {
                  if (Wf(I) && A === "none")
                    throw new mo({
                      graphQLErrors: sy(I)
                    });
                  o && (o.loading = !1, o.error = null);
                  var T = G({}, I);
                  return typeof v == "function" && (v = v(T)), A === "ignore" && Wf(T) && delete T.errors, s.markMutationResult({
                    mutationId: r,
                    result: T,
                    document: c,
                    variables: f,
                    fetchPolicy: S,
                    errorPolicy: A,
                    context: y,
                    update: _,
                    updateQueries: p,
                    awaitRefetchQueries: g,
                    refetchQueries: v,
                    removeOptimistic: a ? r : void 0,
                    onQueryUpdated: w,
                    keepRootFields: E
                  });
                }).subscribe({
                  next: function(I) {
                    s.broadcastQueries(), (!("hasNext" in I) || I.hasNext === !1) && O(G(G({}, I), { data: s.maskOperation({
                      document: c,
                      data: I.data,
                      fetchPolicy: S,
                      id: r
                    }) }));
                  },
                  error: function(I) {
                    o && (o.loading = !1, o.error = I), a && s.cache.removeOptimistic(r), s.broadcastQueries(), k(I instanceof mo ? I : new mo({
                      networkError: I
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(t, n) {
      var r = this;
      n === void 0 && (n = this.cache);
      var i = t.result, o = [], a = t.fetchPolicy === "no-cache";
      if (!a && gy(i, t.errorPolicy)) {
        if (Ps(i) || o.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), Ps(i) && Di(i.incremental)) {
          var s = n.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(t.document).asQuery,
            variables: t.variables,
            optimistic: !1,
            returnPartialData: !0
          }), l = void 0;
          s.result && (l = gI(s.result, i)), typeof l < "u" && (i.data = l, o.push({
            result: l,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var u = t.updateQueries;
        u && this.queries.forEach(function(f, d) {
          var p = f.observableQuery, h = p && p.queryName;
          if (!(!h || !xne.call(u, h))) {
            var v = u[h], m = r.queries.get(d), g = m.document, _ = m.variables, w = n.diff({
              query: g,
              variables: _,
              returnPartialData: !0,
              optimistic: !1
            }), x = w.result, S = w.complete;
            if (S && x) {
              var $ = v(x, {
                mutationResult: i,
                queryName: g && nu(g) || void 0,
                queryVariables: _
              });
              $ && o.push({
                result: $,
                dataId: "ROOT_QUERY",
                query: g,
                variables: _
              });
            }
          }
        });
      }
      if (o.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var c = [];
        if (this.refetchQueries({
          updateCache: function(f) {
            a || o.forEach(function(v) {
              return f.write(v);
            });
            var d = t.update, p = !pte(i) || Ps(i) && !i.hasNext;
            if (d) {
              if (!a) {
                var h = f.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: r.getDocumentInfo(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                h.complete && (i = G(G({}, i), { data: h.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              p && d(f, i, {
                context: t.context,
                variables: t.variables
              });
            }
            !a && !t.keepRootFields && p && f.modify({
              id: "ROOT_MUTATION",
              fields: function(v, m) {
                var g = m.fieldName, _ = m.DELETE;
                return g === "__typename" ? v : _;
              }
            });
          },
          include: t.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: t.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function(f) {
          return c.push(f);
        }), t.awaitRefetchQueries || t.onQueryUpdated)
          return Promise.all(c).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, e.prototype.markMutationOptimistic = function(t, n) {
      var r = this, i = typeof t == "function" ? t(n.variables, { IGNORE: R2 }) : t;
      return i === R2 ? !1 : (this.cache.recordOptimisticTransaction(function(o) {
        try {
          r.markMutationResult(G(G({}, n), { result: { data: i } }), o);
        } catch (a) {
          globalThis.__DEV__ !== !1 && Pe.error(a);
        }
      }, n.mutationId), !0);
    }, e.prototype.fetchQuery = function(t, n, r) {
      return this.fetchConcastWithInfo(this.getOrCreateQuery(t), n, r).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var t = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(n, r) {
        t[r] = {
          variables: n.variables,
          networkStatus: n.networkStatus,
          networkError: n.networkError,
          graphQLErrors: n.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function(t) {
      var n = this.queries.get(t);
      n && (n.networkError = void 0, n.graphQLErrors = []);
    }, e.prototype.transform = function(t) {
      return this.documentTransform.transformDocument(t);
    }, e.prototype.getDocumentInfo = function(t) {
      var n = this.transformCache;
      if (!n.has(t)) {
        var r = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: GX(t),
          hasForcedResolvers: this.localState.shouldForceResolvers(t),
          hasNonreactiveDirective: ec(["nonreactive"], t),
          nonReactiveQuery: Qee(t),
          clientQuery: this.localState.clientQuery(t),
          serverQuery: cI([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], t),
          defaultVars: W0(ka(t)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: G(G({}, t), { definitions: t.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? G(G({}, i), { operation: "query" }) : i;
          }) })
        };
        n.set(t, r);
      }
      return n.get(t);
    }, e.prototype.getVariables = function(t, n) {
      return G(G({}, this.getDocumentInfo(t).defaultVars), n);
    }, e.prototype.watchQuery = function(t) {
      var n = this.transform(t.query);
      t = G(G({}, t), { variables: this.getVariables(n, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var r = new Jv(this), i = new Yf({
        queryManager: this,
        queryInfo: r,
        options: t
      });
      return i.lastQuery = n, Yf.inactiveOnCreation.getValue() || this.queries.set(i.queryId, r), r.init({
        document: n,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, e.prototype.query = function(t, n) {
      var r = this;
      n === void 0 && (n = this.generateQueryId()), Pe(t.query, 38), Pe(t.query.kind === "Document", 39), Pe(!t.returnPartialData, 40), Pe(!t.pollInterval, 41);
      var i = this.transform(t.query);
      return this.fetchQuery(n, G(G({}, t), { query: i })).then(function(o) {
        return o && G(G({}, o), { data: r.maskOperation({
          document: i,
          data: o.data,
          fetchPolicy: t.fetchPolicy,
          id: n
        }) });
      }).finally(function() {
        return r.stopQuery(n);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
      var n = this.queries.get(t);
      n && n.stop();
    }, e.prototype.clearStore = function(t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(qn(42)), this.queries.forEach(function(n) {
        n.observableQuery ? n.networkStatus = bt.loading : n.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function(t) {
      var n = this;
      t === void 0 && (t = "active");
      var r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set();
      return Array.isArray(t) && t.forEach(function(s) {
        if (typeof s == "string")
          i.set(s, s), o.set(s, !1);
        else if (Eee(s)) {
          var l = Eo(n.transform(s));
          i.set(l, nu(s)), o.set(l, !1);
        } else Lt(s) && s.query && a.add(s);
      }), this.queries.forEach(function(s, l) {
        var u = s.observableQuery, c = s.document;
        if (u) {
          if (t === "all") {
            r.set(l, u);
            return;
          }
          var f = u.queryName, d = u.options.fetchPolicy;
          if (d === "standby" || t === "active" && !u.hasObservers())
            return;
          (t === "active" || f && o.has(f) || c && o.has(Eo(c))) && (r.set(l, u), f && o.set(f, !0), c && o.set(Eo(c), !0));
        }
      }), a.size && a.forEach(function(s) {
        var l = Qg("legacyOneTimeQuery"), u = n.getOrCreateQuery(l).init({
          document: s.query,
          variables: s.variables
        }), c = new Yf({
          queryManager: n,
          queryInfo: u,
          options: G(G({}, s), { fetchPolicy: "network-only" })
        });
        Pe(c.queryId === l), u.setObservableQuery(c), r.set(l, c);
      }), globalThis.__DEV__ !== !1 && o.size && o.forEach(function(s, l) {
        if (!s) {
          var u = i.get(l);
          u ? globalThis.__DEV__ !== !1 && Pe.warn(43, u) : globalThis.__DEV__ !== !1 && Pe.warn(44);
        }
      }), r;
    }, e.prototype.reFetchObservableQueries = function(t) {
      var n = this;
      t === void 0 && (t = !1);
      var r = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function(i, o) {
        var a = i.options.fetchPolicy;
        An("resetLastResults", function() {
          return i.resetLastResults();
        }), (t || a !== "standby" && a !== "cache-only") && r.push(i.refetch()), (n.queries.get(o) || i.queryInfo).setDiff(null);
      }), this.broadcastQueries(), Promise.all(r);
    }, e.prototype.startGraphQLSubscription = function(t) {
      var n = this, r = t.query, i = t.variables, o = t.fetchPolicy, a = t.errorPolicy, s = a === void 0 ? "none" : a, l = t.context, u = l === void 0 ? {} : l, c = t.extensions, f = c === void 0 ? {} : c;
      r = this.transform(r), i = this.getVariables(r, i);
      var d = function(h) {
        return n.getObservableFromLink(r, u, h, f).map(function(v) {
          o !== "no-cache" && (gy(v, s) && n.cache.write({
            query: r,
            result: v.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: h
          }), n.broadcastQueries());
          var m = Wf(v), g = Ate(v);
          if (m || g) {
            var _ = {};
            if (m && (_.graphQLErrors = v.errors), g && (_.protocolErrors = v.extensions[n_]), s === "none" || g)
              throw new mo(_);
          }
          return s === "ignore" && delete v.errors, v;
        });
      };
      if (this.getDocumentInfo(r).hasClientExports) {
        var p = this.localState.addExportedVariables(r, i, u).then(d);
        return new St(function(h) {
          var v = null;
          return p.then(function(m) {
            return v = m.subscribe(h);
          }, h.error), function() {
            return v && v.unsubscribe();
          };
        });
      }
      return d(i);
    }, e.prototype.stopQuery = function(t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function(t) {
      var n;
      this.fetchCancelFns.delete(t), this.queries.has(t) && ((n = this.queries.get(t)) === null || n === void 0 || n.stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
        var n;
        return (n = t.observableQuery) === null || n === void 0 ? void 0 : n.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(t, n, r, i, o) {
      var a = this, s;
      o === void 0 && (o = (s = n?.queryDeduplication) !== null && s !== void 0 ? s : this.queryDeduplication);
      var l, u = this.getDocumentInfo(t), c = u.serverQuery, f = u.clientQuery;
      if (c) {
        var d = this, p = d.inFlightLinkObservables, h = d.link, v = {
          query: c,
          variables: r,
          operationName: nu(c) || void 0,
          context: this.prepareContext(G(G({}, n), { forceFetch: !o })),
          extensions: i
        };
        if (n = v.context, o) {
          var m = Eo(c), g = Oo(r), _ = p.lookup(m, g);
          if (l = _.observable, !l) {
            var w = new is([
              cy(h, v)
            ]);
            l = _.observable = w, w.beforeNext(function x(S, $) {
              S === "next" && "hasNext" in $ && $.hasNext ? w.beforeNext(x) : p.remove(m, g);
            });
          }
        } else
          l = new is([
            cy(h, v)
          ]);
      } else
        l = new is([St.of({ data: {} })]), n = this.prepareContext(n);
      return f && (l = Bv(l, function(x) {
        return a.localState.runResolvers({
          document: f,
          remoteResult: x,
          context: n,
          variables: r
        });
      })), l;
    }, e.prototype.getResultsFromLink = function(t, n, r) {
      var i = t.lastRequestId = this.generateRequestId(), o = this.cache.transformForLink(r.query);
      return Bv(this.getObservableFromLink(o, r.context, r.variables), function(a) {
        var s = sy(a), l = s.length > 0, u = r.errorPolicy;
        if (i >= t.lastRequestId) {
          if (l && u === "none")
            throw t.markError(new mo({
              graphQLErrors: s
            }));
          t.markResult(a, o, r, n), t.markReady();
        }
        var c = {
          data: a.data,
          loading: !1,
          networkStatus: bt.ready
        };
        return l && u === "none" && (c.data = void 0), l && u !== "ignore" && (c.errors = s, c.networkStatus = bt.error), c;
      }, function(a) {
        var s = bI(a) ? a : new mo({ networkError: a });
        throw i >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchConcastWithInfo = function(t, n, r, i) {
      var o = this;
      r === void 0 && (r = bt.loading), i === void 0 && (i = n.query);
      var a = this.getVariables(i, n.variables), s = this.defaultOptions.watchQuery, l = n.fetchPolicy, u = l === void 0 ? s && s.fetchPolicy || "cache-first" : l, c = n.errorPolicy, f = c === void 0 ? s && s.errorPolicy || "none" : c, d = n.returnPartialData, p = d === void 0 ? !1 : d, h = n.notifyOnNetworkStatusChange, v = h === void 0 ? !1 : h, m = n.context, g = m === void 0 ? {} : m, _ = Object.assign({}, n, {
        query: i,
        variables: a,
        fetchPolicy: u,
        errorPolicy: f,
        returnPartialData: p,
        notifyOnNetworkStatusChange: v,
        context: g
      }), w = function(E) {
        _.variables = E;
        var y = o.fetchQueryByPolicy(t, _, r);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          _.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          y.sources.length > 0 && t.observableQuery && t.observableQuery.applyNextFetchPolicy("after-fetch", n), y
        );
      }, x = function() {
        return o.fetchCancelFns.delete(t.queryId);
      };
      this.fetchCancelFns.set(t.queryId, function(E) {
        x(), setTimeout(function() {
          return S.cancel(E);
        });
      });
      var S, $;
      if (this.getDocumentInfo(_.query).hasClientExports)
        S = new is(this.localState.addExportedVariables(_.query, _.variables, _.context).then(w).then(function(E) {
          return E.sources;
        })), $ = !0;
      else {
        var A = w(_.variables);
        $ = A.fromLink, S = new is(A.sources);
      }
      return S.promise.then(x, x), {
        concast: S,
        fromLink: $
      };
    }, e.prototype.refetchQueries = function(t) {
      var n = this, r = t.updateCache, i = t.include, o = t.optimistic, a = o === void 0 ? !1 : o, s = t.removeOptimistic, l = s === void 0 ? a ? Qg("refetchQueries") : void 0 : s, u = t.onQueryUpdated, c = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(d, p) {
        c.set(p, {
          oq: d,
          lastDiff: (n.queries.get(p) || d.queryInfo).getDiff()
        });
      });
      var f = /* @__PURE__ */ new Map();
      return r && this.cache.batch({
        update: r,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: a && l || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: l,
        onWatchUpdated: function(d, p, h) {
          var v = d.watcher instanceof Jv && d.watcher.observableQuery;
          if (v) {
            if (u) {
              c.delete(v.queryId);
              var m = u(v, p, h);
              return m === !0 && (m = v.refetch()), m !== !1 && f.set(v, m), m;
            }
            u !== null && c.set(v.queryId, { oq: v, lastDiff: h, diff: p });
          }
        }
      }), c.size && c.forEach(function(d, p) {
        var h = d.oq, v = d.lastDiff, m = d.diff, g;
        u && (m || (m = An("canonizeResults", function() {
          return n.cache.diff(h.queryInfo.getDiffOptions());
        })), g = u(h, m, v)), (!u || g === !0) && (g = h.refetch()), g !== !1 && f.set(h, g), p.indexOf("legacyOneTimeQuery") >= 0 && n.stopQueryNoBroadcast(p);
      }), l && this.cache.removeOptimistic(l), f;
    }, e.prototype.maskOperation = function(t) {
      var n, r, i, o = t.document, a = t.data;
      if (globalThis.__DEV__ !== !1) {
        var s = t.fetchPolicy, l = t.id, u = (n = ka(o)) === null || n === void 0 ? void 0 : n.operation, c = ((r = u?.[0]) !== null && r !== void 0 ? r : "o") + l;
        this.dataMasking && s === "no-cache" && !oee(o) && !this.noCacheWarningsByQueryId.has(c) && (this.noCacheWarningsByQueryId.add(c), globalThis.__DEV__ !== !1 && Pe.warn(
          45,
          (i = nu(o)) !== null && i !== void 0 ? i : "Unnamed ".concat(u ?? "operation")
        ));
      }
      return this.dataMasking ? nne(a, o, this.cache) : a;
    }, e.prototype.maskFragment = function(t) {
      var n = t.data, r = t.fragment, i = t.fragmentName;
      return this.dataMasking ? $I(n, r, this.cache, i) : n;
    }, e.prototype.fetchQueryByPolicy = function(t, n, r) {
      var i = this, o = n.query, a = n.variables, s = n.fetchPolicy, l = n.refetchWritePolicy, u = n.errorPolicy, c = n.returnPartialData, f = n.context, d = n.notifyOnNetworkStatusChange, p = t.networkStatus;
      t.init({
        document: o,
        variables: a,
        networkStatus: r
      });
      var h = function() {
        return t.getDiff();
      }, v = function(x, S) {
        S === void 0 && (S = t.networkStatus || bt.loading);
        var $ = x.result;
        globalThis.__DEV__ !== !1 && !c && !Ot($, {}) && LI(x.missing);
        var A = function(E) {
          return St.of(G({ data: E, loading: gs(S), networkStatus: S }, x.complete ? null : { partial: !0 }));
        };
        return $ && i.getDocumentInfo(o).hasForcedResolvers ? i.localState.runResolvers({
          document: o,
          remoteResult: { data: $ },
          context: f,
          variables: a,
          onlyRunForcedResolvers: !0
        }).then(function(E) {
          return A(E.data || void 0);
        }) : u === "none" && S === bt.refetch && Array.isArray(x.missing) ? A(void 0) : A($);
      }, m = s === "no-cache" ? 0 : r === bt.refetch && l !== "merge" ? 1 : 2, g = function() {
        return i.getResultsFromLink(t, m, {
          query: o,
          variables: a,
          context: f,
          fetchPolicy: s,
          errorPolicy: u
        });
      }, _ = d && typeof p == "number" && p !== r && gs(r);
      switch (s) {
        default:
        case "cache-first": {
          var w = h();
          return w.complete ? {
            fromLink: !1,
            sources: [v(w, t.markReady())]
          } : c || _ ? {
            fromLink: !0,
            sources: [v(w), g()]
          } : { fromLink: !0, sources: [g()] };
        }
        case "cache-and-network": {
          var w = h();
          return w.complete || c || _ ? {
            fromLink: !0,
            sources: [v(w), g()]
          } : { fromLink: !0, sources: [g()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [v(h(), t.markReady())]
          };
        case "network-only":
          return _ ? {
            fromLink: !0,
            sources: [v(h()), g()]
          } : { fromLink: !0, sources: [g()] };
        case "no-cache":
          return _ ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [v(t.getDiff()), g()]
          } : { fromLink: !0, sources: [g()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getOrCreateQuery = function(t) {
      return t && !this.queries.has(t) && this.queries.set(t, new Jv(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function(t) {
      t === void 0 && (t = {});
      var n = this.localState.prepareContext(t);
      return G(G(G({}, this.defaultContext), n), { clientAwareness: this.clientAwareness });
    }, e;
  })()
), Sne = (
  /** @class */
  (function() {
    function e(t) {
      var n = t.cache, r = t.client, i = t.resolvers, o = t.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = n, r && (this.client = r), i && this.addResolvers(i), o && this.setFragmentMatcher(o);
    }
    return e.prototype.addResolvers = function(t) {
      var n = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(r) {
        n.resolvers = t2(n.resolvers, r);
      }) : this.resolvers = t2(this.resolvers, t);
    }, e.prototype.setResolvers = function(t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(t) {
      return po(this, arguments, void 0, function(n) {
        var r = n.document, i = n.remoteResult, o = n.context, a = n.variables, s = n.onlyRunForcedResolvers, l = s === void 0 ? !1 : s;
        return ho(this, function(u) {
          return r ? [2, this.resolveDocument(r, i.data, o, a, this.fragmentMatcher, l).then(function(c) {
            return G(G({}, i), { data: c.result });
          })] : [2, i];
        });
      });
    }, e.prototype.setFragmentMatcher = function(t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(t) {
      return ec(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function(t) {
      return fI(t);
    }, e.prototype.prepareContext = function(t) {
      var n = this.cache;
      return G(G({}, t), {
        cache: n,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(r) {
          return n.identify(r);
        }
      });
    }, e.prototype.addExportedVariables = function(t) {
      return po(this, arguments, void 0, function(n, r, i) {
        return r === void 0 && (r = {}), i === void 0 && (i = {}), ho(this, function(o) {
          return n ? [2, this.resolveDocument(n, this.buildRootValueFromCache(n, r) || {}, this.prepareContext(i), r).then(function(a) {
            return G(G({}, r), a.exportedVariables);
          })] : [2, G({}, r)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(t) {
      var n = !1;
      return si(t, {
        Directive: {
          enter: function(r) {
            if (r.name.value === "client" && r.arguments && (n = r.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), n))
              return uh;
          }
        }
      }), n;
    }, e.prototype.buildRootValueFromCache = function(t, n) {
      return this.cache.diff({
        query: Yee(t),
        variables: n,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(t, n) {
      return po(this, arguments, void 0, function(r, i, o, a, s, l) {
        var u, c, f, d, p, h, v, m, g, _, w;
        return o === void 0 && (o = {}), a === void 0 && (a = {}), s === void 0 && (s = function() {
          return !0;
        }), l === void 0 && (l = !1), ho(this, function(x) {
          return u = Rc(r), c = $l(r), f = Sl(c), d = this.collectSelectionsToResolve(u, f), p = u.operation, h = p ? p.charAt(0).toUpperCase() + p.slice(1) : "Query", v = this, m = v.cache, g = v.client, _ = {
            fragmentMap: f,
            context: G(G({}, o), { cache: m, client: g }),
            variables: a,
            fragmentMatcher: s,
            defaultOperationType: h,
            exportedVariables: {},
            selectionsToResolve: d,
            onlyRunForcedResolvers: l
          }, w = !1, [2, this.resolveSelectionSet(u.selectionSet, w, i, _).then(function(S) {
            return {
              result: S,
              exportedVariables: _.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(t, n, r, i) {
      return po(this, void 0, void 0, function() {
        var o, a, s, l, u, c = this;
        return ho(this, function(f) {
          return o = i.fragmentMap, a = i.context, s = i.variables, l = [r], u = function(d) {
            return po(c, void 0, void 0, function() {
              var p, h;
              return ho(this, function(v) {
                return !n && !i.selectionsToResolve.has(d) ? [
                  2
                  /*return*/
                ] : Nc(d, s) ? Io(d) ? [2, this.resolveField(d, n, r, i).then(function(m) {
                  var g;
                  typeof m < "u" && l.push((g = {}, g[Xi(d)] = m, g));
                })] : (Ree(d) ? p = d : (p = o[d.name.value], Pe(p, 21, d.name.value)), p && p.typeCondition && (h = p.typeCondition.name.value, i.fragmentMatcher(r, h, a)) ? [2, this.resolveSelectionSet(p.selectionSet, n, r, i).then(function(m) {
                  l.push(m);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(t.selections.map(u)).then(function() {
            return vh(l);
          })];
        });
      });
    }, e.prototype.resolveField = function(t, n, r, i) {
      return po(this, void 0, void 0, function() {
        var o, a, s, l, u, c, f, d, p, h = this;
        return ho(this, function(v) {
          return r ? (o = i.variables, a = t.name.value, s = Xi(t), l = a !== s, u = r[s] || r[a], c = Promise.resolve(u), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (f = r.__typename || i.defaultOperationType, d = this.resolvers && this.resolvers[f], d && (p = d[l ? a : s], p && (c = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            i_.withValue(this.cache, p, [
              r,
              dh(t, o),
              i.context,
              { field: t, fragmentMap: i.fragmentMap }
            ])
          )))), [2, c.then(function(m) {
            var g, _;
            if (m === void 0 && (m = u), t.directives && t.directives.forEach(function(x) {
              x.name.value === "export" && x.arguments && x.arguments.forEach(function(S) {
                S.name.value === "as" && S.value.kind === "StringValue" && (i.exportedVariables[S.value.value] = m);
              });
            }), !t.selectionSet || m == null)
              return m;
            var w = (_ = (g = t.directives) === null || g === void 0 ? void 0 : g.some(function(x) {
              return x.name.value === "client";
            })) !== null && _ !== void 0 ? _ : !1;
            if (Array.isArray(m))
              return h.resolveSubSelectedArray(t, n || w, m, i);
            if (t.selectionSet)
              return h.resolveSelectionSet(t.selectionSet, n || w, m, i);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(t, n, r, i) {
      var o = this;
      return Promise.all(r.map(function(a) {
        if (a === null)
          return null;
        if (Array.isArray(a))
          return o.resolveSubSelectedArray(t, n, a, i);
        if (t.selectionSet)
          return o.resolveSelectionSet(t.selectionSet, n, a, i);
      }));
    }, e.prototype.collectSelectionsToResolve = function(t, n) {
      var r = function(a) {
        return !Array.isArray(a);
      }, i = this.selectionsToResolveCache;
      function o(a) {
        if (!i.has(a)) {
          var s = /* @__PURE__ */ new Set();
          i.set(a, s), si(a, {
            Directive: function(l, u, c, f, d) {
              l.name.value === "client" && d.forEach(function(p) {
                r(p) && HS(p) && s.add(p);
              });
            },
            FragmentSpread: function(l, u, c, f, d) {
              var p = n[l.name.value];
              Pe(p, 22, l.name.value);
              var h = o(p);
              h.size > 0 && (d.forEach(function(v) {
                r(v) && HS(v) && s.add(v);
              }), s.add(l), h.forEach(function(v) {
                s.add(v);
              }));
            }
          });
        }
        return i.get(a);
      }
      return o(t);
    }, e;
  })()
), M2 = !1, One = (
  /** @class */
  (function() {
    function e(t) {
      var n = this, r, i, o;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
        throw qn(16);
      var a = t.uri, s = t.credentials, l = t.headers, u = t.cache, c = t.documentTransform, f = t.ssrMode, d = f === void 0 ? !1 : f, p = t.ssrForceFetchDelay, h = p === void 0 ? 0 : p, v = t.connectToDevTools, m = t.queryDeduplication, g = m === void 0 ? !0 : m, _ = t.defaultOptions, w = t.defaultContext, x = t.assumeImmutableResults, S = x === void 0 ? u.assumeImmutableResults : x, $ = t.resolvers, A = t.typeDefs, E = t.fragmentMatcher, y = t.clientAwareness, b = t.name, O = t.version, k = t.devtools, I = t.dataMasking;
      globalThis.__DEV__ !== !1 && (nn(t, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead."), nn(t, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead."), nn(t, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead."), nn(t, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead."), nn(t, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead."), nn(t, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead."), nn(t, "typeDefs", "ApolloClient"), t.link || globalThis.__DEV__ !== !1 && Pe.warn(17));
      var T = t.link;
      T || (T = a ? new Zte({ uri: a, credentials: s, headers: l }) : Bo.empty()), this.link = T, this.cache = u, this.disableNetworkFetches = d || h > 0, this.queryDeduplication = g, this.defaultOptions = _ || /* @__PURE__ */ Object.create(null), this.typeDefs = A, this.devtoolsConfig = G(G({}, k), { enabled: (r = k?.enabled) !== null && r !== void 0 ? r : v }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), h && setTimeout(function() {
        return n.disableNetworkFetches = !1;
      }, h), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = B0, this.localState = new Sne({
        cache: u,
        client: this,
        resolvers: $,
        fragmentMatcher: E
      }), this.queryManager = new Ene({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: w,
        documentTransform: c,
        queryDeduplication: g,
        ssrMode: d,
        dataMasking: !!I,
        clientAwareness: {
          name: (i = y?.name) !== null && i !== void 0 ? i : b,
          version: (o = y?.version) !== null && o !== void 0 ? o : O
        },
        localState: this.localState,
        assumeImmutableResults: S,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          n.devToolsHookCb && n.devToolsHookCb({
            action: {},
            state: {
              queries: n.queryManager.getQueryStore(),
              mutations: n.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: n.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return Object.defineProperty(e.prototype, "prioritizeCacheValues", {
      /**
       * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
       * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
       * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
       *
       * This can e.g. be used to prioritize the cache during the first render after SSR.
       */
      get: function() {
        return this.disableNetworkFetches;
      },
      set: function(t) {
        this.disableNetworkFetches = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var t = window, n = Symbol.for("apollo.devtools");
        (t[n] = t[n] || []).push(this), t.__APOLLO_CLIENT__ = this, !M2 && globalThis.__DEV__ !== !1 && (M2 = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var r = window.navigator, i = r && r.userAgent, o = void 0;
            typeof i == "string" && (i.indexOf("Chrome/") > -1 ? o = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (o = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), o && globalThis.__DEV__ !== !1 && Pe.log("Download the Apollo DevTools for a better development experience: %s", o);
          }
        }, 1e4));
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(t) {
      return this.defaultOptions.watchQuery && (t = Uv(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = G(G({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (nn(t, "canonizeResults", "client.watchQuery"), nn(t, "partialRefetch", "client.watchQuery")), this.queryManager.watchQuery(t);
    }, e.prototype.query = function(t) {
      return this.defaultOptions.query && (t = Uv(this.defaultOptions.query, t)), Pe(t.fetchPolicy !== "cache-and-network", 18), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = G(G({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (nn(t, "canonizeResults", "client.query"), nn(t, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed."), t.fetchPolicy === "standby" && globalThis.__DEV__ !== !1 && Pe.warn(19)), this.queryManager.query(t);
    }, e.prototype.mutate = function(t) {
      return this.defaultOptions.mutate && (t = Uv(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function(t) {
      var n = this, r = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(t).map(function(i) {
        return G(G({}, i), { data: n.queryManager.maskOperation({
          document: t.query,
          data: i.data,
          fetchPolicy: t.fetchPolicy,
          id: r
        }) });
      });
    }, e.prototype.readQuery = function(t, n) {
      return n === void 0 && (n = !1), this.cache.readQuery(t, n);
    }, e.prototype.watchFragment = function(t) {
      var n;
      return this.cache.watchFragment(G(G({}, t), (n = {}, n[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, n)));
    }, e.prototype.readFragment = function(t, n) {
      return n === void 0 && (n = !1), this.cache.readFragment(t, n);
    }, e.prototype.writeQuery = function(t) {
      var n = this.cache.writeQuery(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), n;
    }, e.prototype.writeFragment = function(t) {
      var n = this.cache.writeFragment(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), n;
    }, e.prototype.__actionHookForDevTools = function(t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function(t) {
      return cy(this.link, t);
    }, e.prototype.resetStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(t.resetStoreCallbacks.map(function(n) {
          return n();
        }));
      }).then(function() {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(t.clearStoreCallbacks.map(function(n) {
          return n();
        }));
      });
    }, e.prototype.onResetStore = function(t) {
      var n = this;
      return this.resetStoreCallbacks.push(t), function() {
        n.resetStoreCallbacks = n.resetStoreCallbacks.filter(function(r) {
          return r !== t;
        });
      };
    }, e.prototype.onClearStore = function(t) {
      var n = this;
      return this.clearStoreCallbacks.push(t), function() {
        n.clearStoreCallbacks = n.clearStoreCallbacks.filter(function(r) {
          return r !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function(t) {
      var n = this.queryManager.refetchQueries(t), r = [], i = [];
      n.forEach(function(a, s) {
        r.push(s), i.push(a);
      });
      var o = Promise.all(i);
      return o.queries = r, o.results = i, o.catch(function(a) {
        globalThis.__DEV__ !== !1 && Pe.debug(20, a);
      }), o;
    }, e.prototype.getObservableQueries = function(t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function(t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function(t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function(t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function(t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function(t) {
      this.link = this.queryManager.link = t;
    }, Object.defineProperty(e.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })()
);
globalThis.__DEV__ !== !1 && (One.prototype.getMemoryInternals = hee);
function $ne(e) {
  return Lt(e) && "code" in e && "reason" in e;
}
function Tne(e) {
  var t;
  return Lt(e) && ((t = e.target) === null || t === void 0 ? void 0 : t.readyState) === WebSocket.CLOSED;
}
/** @class */
(function(e) {
  pi(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.client = n, r;
  }
  return t.prototype.request = function(n) {
    var r = this;
    return new St(function(i) {
      return r.client.subscribe(G(G({}, n), { query: Eo(n.query) }), {
        next: i.next.bind(i),
        complete: i.complete.bind(i),
        error: function(o) {
          if (o instanceof Error)
            return i.error(o);
          var a = $ne(o);
          return a || Tne(o) ? i.error(
            // reason will be available on clean closes
            new Error("Socket closed".concat(a ? " with event ".concat(o.code) : "").concat(a ? " ".concat(o.reason) : ""))
          ) : i.error(new mo({
            graphQLErrors: Array.isArray(o) ? o : [o]
          }));
        }
        // casting around a wrong type in graphql-ws, which incorrectly expects `Sink<ExecutionResult>`
      });
    });
  }, t;
})(Bo);
var j2;
(function(e) {
  e[e.InternalServerError = 4500] = "InternalServerError", e[e.InternalClientError = 4005] = "InternalClientError", e[e.BadRequest = 4400] = "BadRequest", e[e.BadResponse = 4004] = "BadResponse", e[e.Unauthorized = 4401] = "Unauthorized", e[e.Forbidden = 4403] = "Forbidden", e[e.SubprotocolNotAcceptable = 4406] = "SubprotocolNotAcceptable", e[e.ConnectionInitialisationTimeout = 4408] = "ConnectionInitialisationTimeout", e[e.ConnectionAcknowledgementTimeout = 4504] = "ConnectionAcknowledgementTimeout", e[e.SubscriberAlreadyExists = 4409] = "SubscriberAlreadyExists", e[e.TooManyInitialisationRequests = 4429] = "TooManyInitialisationRequests";
})(j2 || (j2 = {}));
var F2;
(function(e) {
  e.ConnectionInit = "connection_init", e.ConnectionAck = "connection_ack", e.Ping = "ping", e.Pong = "pong", e.Subscribe = "subscribe", e.Next = "next", e.Error = "error", e.Complete = "complete";
})(F2 || (F2 = {}));
function ae(e, t, n) {
  function r(s, l) {
    if (s._zod || Object.defineProperty(s, "_zod", {
      value: {
        def: l,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), s._zod.traits.has(e))
      return;
    s._zod.traits.add(e), t(s, l);
    const u = a.prototype, c = Object.keys(u);
    for (let f = 0; f < c.length; f++) {
      const d = c[f];
      d in s || (s[d] = u[d].bind(s));
    }
  }
  const i = n?.Parent ?? Object;
  class o extends i {
  }
  Object.defineProperty(o, "name", { value: e });
  function a(s) {
    var l;
    const u = n != null && n.Parent ? new o() : this;
    r(u, s), (l = u._zod).deferred ?? (l.deferred = []);
    for (const c of u._zod.deferred)
      c();
    return u;
  }
  return Object.defineProperty(a, "init", { value: r }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (s) => {
      var l, u;
      return n != null && n.Parent && s instanceof n.Parent ? !0 : (u = (l = s?._zod) == null ? void 0 : l.traits) == null ? void 0 : u.has(e);
    }
  }), Object.defineProperty(a, "name", { value: e }), a;
}
class Ds extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class VI extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const KI = {};
function Da(e) {
  return KI;
}
function BI(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, r]) => t.indexOf(+n) === -1).map(([n, r]) => r);
}
function yy(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function l_(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function u_(e) {
  return e == null;
}
function c_(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function Pne(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = t.toString();
  let i = (r.split(".")[1] || "").length;
  if (i === 0 && /\d?e-\d?/.test(r)) {
    const l = r.match(/\d?e-(\d?)/);
    l != null && l[1] && (i = Number.parseInt(l[1]));
  }
  const o = n > i ? n : i, a = Number.parseInt(e.toFixed(o).replace(".", "")), s = Number.parseInt(t.toFixed(o).replace(".", ""));
  return a % s / 10 ** o;
}
const z2 = Symbol("evaluating");
function wt(e, t, n) {
  let r;
  Object.defineProperty(e, t, {
    get() {
      if (r !== z2)
        return r === void 0 && (r = z2, r = n()), r;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Wa(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Uo(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function L2(e) {
  return JSON.stringify(e);
}
function kne(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const UI = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Xd(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Dne = l_(() => {
  var e;
  if (typeof navigator < "u" && (e = navigator?.userAgent) != null && e.includes("Cloudflare"))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function ic(e) {
  if (Xd(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(Xd(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function qI(e) {
  return ic(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const Ane = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function mh(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function qo(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (r._zod.parent = e), r;
}
function qe(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Cne(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const Ine = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function Nne(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const i = Uo(e._zod.def, {
    get shape() {
      const o = {};
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && (o[a] = n.shape[a]);
      }
      return Wa(this, "shape", o), o;
    },
    checks: []
  });
  return qo(e, i);
}
function Rne(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const i = Uo(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape };
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && delete o[a];
      }
      return Wa(this, "shape", o), o;
    },
    checks: []
  });
  return qo(e, i);
}
function Mne(e, t) {
  if (!ic(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const i = e._zod.def.shape;
    for (const o in t)
      if (Object.getOwnPropertyDescriptor(i, o) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const r = Uo(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape, ...t };
      return Wa(this, "shape", i), i;
    }
  });
  return qo(e, r);
}
function jne(e, t) {
  if (!ic(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = Uo(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return Wa(this, "shape", r), r;
    }
  });
  return qo(e, n);
}
function Fne(e, t) {
  const n = Uo(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Wa(this, "shape", r), r;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return qo(e, n);
}
function zne(e, t, n) {
  const r = t._zod.def.checks;
  if (r && r.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const i = Uo(t._zod.def, {
    get shape() {
      const o = t._zod.def.shape, a = { ...o };
      if (n)
        for (const s in n) {
          if (!(s in o))
            throw new Error(`Unrecognized key: "${s}"`);
          n[s] && (a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s]);
        }
      else
        for (const s in o)
          a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s];
      return Wa(this, "shape", a), a;
    },
    checks: []
  });
  return qo(t, i);
}
function Lne(e, t, n) {
  const r = Uo(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, o = { ...i };
      if (n)
        for (const a in n) {
          if (!(a in o))
            throw new Error(`Unrecognized key: "${a}"`);
          n[a] && (o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          }));
        }
      else
        for (const a in i)
          o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          });
      return Wa(this, "shape", o), o;
    }
  });
  return qo(t, r);
}
function bs(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let r = t; r < e.issues.length; r++)
    if (((n = e.issues[r]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function HI(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function xf(e) {
  return typeof e == "string" ? e : e?.message;
}
function Aa(e, t, n) {
  var r, i, o, a, s, l;
  const u = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const c = xf((o = (i = (r = e.inst) == null ? void 0 : r._zod.def) == null ? void 0 : i.error) == null ? void 0 : o.call(i, e)) ?? xf((a = t?.error) == null ? void 0 : a.call(t, e)) ?? xf((s = n.customError) == null ? void 0 : s.call(n, e)) ?? xf((l = n.localeError) == null ? void 0 : l.call(n, e)) ?? "Invalid input";
    u.message = c;
  }
  return delete u.inst, delete u.continue, t != null && t.reportInput || delete u.input, u;
}
function f_(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function oc(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const WI = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, yy, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, ZI = ae("$ZodError", WI), GI = ae("$ZodError", WI, { Parent: Error });
function Vne(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const i of e.issues)
    i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
  return { formErrors: r, fieldErrors: n };
}
function Kne(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (i) => {
    for (const o of i.issues)
      if (o.code === "invalid_union" && o.errors.length)
        o.errors.map((a) => r({ issues: a }));
      else if (o.code === "invalid_key")
        r({ issues: o.issues });
      else if (o.code === "invalid_element")
        r({ issues: o.issues });
      else if (o.path.length === 0)
        n._errors.push(t(o));
      else {
        let a = n, s = 0;
        for (; s < o.path.length; ) {
          const l = o.path[s];
          s === o.path.length - 1 ? (a[l] = a[l] || { _errors: [] }, a[l]._errors.push(t(o))) : a[l] = a[l] || { _errors: [] }, a = a[l], s++;
        }
      }
  };
  return r(e), n;
}
const d_ = (e) => (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !1 }) : { async: !1 }, a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise)
    throw new Ds();
  if (a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => Aa(l, o, Da())));
    throw UI(s, i?.callee), s;
  }
  return a.value;
}, p_ = (e) => async (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => Aa(l, o, Da())));
    throw UI(s, i?.callee), s;
  }
  return a.value;
}, gh = (e) => (t, n, r) => {
  const i = r ? { ...r, async: !1 } : { async: !1 }, o = t._zod.run({ value: n, issues: [] }, i);
  if (o instanceof Promise)
    throw new Ds();
  return o.issues.length ? {
    success: !1,
    error: new (e ?? ZI)(o.issues.map((a) => Aa(a, i, Da())))
  } : { success: !0, data: o.value };
}, Bne = /* @__PURE__ */ gh(GI), yh = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let o = t._zod.run({ value: n, issues: [] }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? {
    success: !1,
    error: new e(o.issues.map((a) => Aa(a, i, Da())))
  } : { success: !0, data: o.value };
}, Une = /* @__PURE__ */ yh(GI), qne = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return d_(e)(t, n, i);
}, Hne = (e) => (t, n, r) => d_(e)(t, n, r), Wne = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return p_(e)(t, n, i);
}, Zne = (e) => async (t, n, r) => p_(e)(t, n, r), Gne = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return gh(e)(t, n, i);
}, Yne = (e) => (t, n, r) => gh(e)(t, n, r), Qne = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return yh(e)(t, n, i);
}, Jne = (e) => async (t, n, r) => yh(e)(t, n, r), Xne = /^[cC][^\s-]{8,}$/, ere = /^[0-9a-z]+$/, tre = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, nre = /^[0-9a-vA-V]{20}$/, rre = /^[A-Za-z0-9]{27}$/, ire = /^[a-zA-Z0-9_-]{21}$/, ore = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, are = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, V2 = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, sre = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, lre = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function ure() {
  return new RegExp(lre, "u");
}
const cre = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, fre = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, dre = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, pre = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, hre = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, YI = /^[A-Za-z0-9_-]*$/, vre = /^\+[1-9]\d{6,14}$/, QI = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", mre = /* @__PURE__ */ new RegExp(`^${QI}$`);
function JI(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function gre(e) {
  return new RegExp(`^${JI(e)}$`);
}
function yre(e) {
  const t = JI({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${QI}T(?:${r})$`);
}
const bre = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, _re = /^-?\d+$/, wre = /^-?\d+(?:\.\d+)?$/, xre = /^(?:true|false)$/i, Ere = /^[^A-Z]*$/, Sre = /^[^a-z]*$/, ir = /* @__PURE__ */ ae("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), XI = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, e3 = /* @__PURE__ */ ae("$ZodCheckLessThan", (e, t) => {
  ir.init(e, t);
  const n = XI[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.maximum : i.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < o && (t.inclusive ? i.maximum = t.value : i.exclusiveMaximum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), t3 = /* @__PURE__ */ ae("$ZodCheckGreaterThan", (e, t) => {
  ir.init(e, t);
  const n = XI[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.minimum : i.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > o && (t.inclusive ? i.minimum = t.value : i.exclusiveMinimum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Ore = /* @__PURE__ */ ae("$ZodCheckMultipleOf", (e, t) => {
  ir.init(e, t), e._zod.onattach.push((n) => {
    var r;
    (r = n._zod.bag).multipleOf ?? (r.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : Pne(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), $re = /* @__PURE__ */ ae("$ZodCheckNumberFormat", (e, t) => {
  var n;
  ir.init(e, t), t.format = t.format || "float64";
  const r = (n = t.format) == null ? void 0 : n.includes("int"), i = r ? "int" : "number", [o, a] = Ine[t.format];
  e._zod.onattach.push((s) => {
    const l = s._zod.bag;
    l.format = t.format, l.minimum = o, l.maximum = a, r && (l.pattern = _re);
  }), e._zod.check = (s) => {
    const l = s.value;
    if (r) {
      if (!Number.isInteger(l)) {
        s.issues.push({
          expected: i,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: l,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(l)) {
        l > 0 ? s.issues.push({
          input: l,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        }) : s.issues.push({
          input: l,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    l < o && s.issues.push({
      origin: "number",
      input: l,
      code: "too_small",
      minimum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), l > a && s.issues.push({
      origin: "number",
      input: l,
      code: "too_big",
      maximum: a,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), Tre = /* @__PURE__ */ ae("$ZodCheckMaxLength", (e, t) => {
  var n;
  ir.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !u_(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length <= t.maximum)
      return;
    const o = f_(i);
    r.issues.push({
      origin: o,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), Pre = /* @__PURE__ */ ae("$ZodCheckMinLength", (e, t) => {
  var n;
  ir.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !u_(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length >= t.minimum)
      return;
    const o = f_(i);
    r.issues.push({
      origin: o,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), kre = /* @__PURE__ */ ae("$ZodCheckLengthEquals", (e, t) => {
  var n;
  ir.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !u_(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (r) => {
    const i = r.value, o = i.length;
    if (o === t.length)
      return;
    const a = f_(i), s = o > t.length;
    r.issues.push({
      origin: a,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), bh = /* @__PURE__ */ ae("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  ir.init(e, t), e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.format = t.format, t.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), Dre = /* @__PURE__ */ ae("$ZodCheckRegex", (e, t) => {
  bh.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Are = /* @__PURE__ */ ae("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Ere), bh.init(e, t);
}), Cre = /* @__PURE__ */ ae("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Sre), bh.init(e, t);
}), Ire = /* @__PURE__ */ ae("$ZodCheckIncludes", (e, t) => {
  ir.init(e, t);
  const n = mh(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(r);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Nre = /* @__PURE__ */ ae("$ZodCheckStartsWith", (e, t) => {
  ir.init(e, t);
  const n = new RegExp(`^${mh(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Rre = /* @__PURE__ */ ae("$ZodCheckEndsWith", (e, t) => {
  ir.init(e, t);
  const n = new RegExp(`.*${mh(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Mre = /* @__PURE__ */ ae("$ZodCheckOverwrite", (e, t) => {
  ir.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class jre {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((o) => o), r = Math.min(...n.map((o) => o.length - o.trimStart().length)), i = n.map((o) => o.slice(r)).map((o) => " ".repeat(this.indent * 2) + o);
    for (const o of i)
      this.content.push(o);
  }
  compile() {
    const t = Function, n = this == null ? void 0 : this.args, r = [...((this == null ? void 0 : this.content) ?? [""]).map((i) => `  ${i}`)];
    return new t(...n, r.join(`
`));
  }
}
const Fre = {
  major: 4,
  minor: 3,
  patch: 6
}, an = /* @__PURE__ */ ae("$ZodType", (e, t) => {
  var n, r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Fre;
  const i = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && i.unshift(e);
  for (const o of i)
    for (const a of o._zod.onattach)
      a(e);
  if (i.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (n = e._zod.deferred) == null || n.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (s, l, u) => {
      let c = bs(s), f;
      for (const d of l) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(s))
            continue;
        } else if (c)
          continue;
        const p = s.issues.length, h = d._zod.check(s);
        if (h instanceof Promise && u?.async === !1)
          throw new Ds();
        if (f || h instanceof Promise)
          f = (f ?? Promise.resolve()).then(async () => {
            await h, s.issues.length !== p && (c || (c = bs(s, p)));
          });
        else {
          if (s.issues.length === p)
            continue;
          c || (c = bs(s, p));
        }
      }
      return f ? f.then(() => s) : s;
    }, a = (s, l, u) => {
      if (bs(s))
        return s.aborted = !0, s;
      const c = o(l, i, u);
      if (c instanceof Promise) {
        if (u.async === !1)
          throw new Ds();
        return c.then((f) => e._zod.parse(f, u));
      }
      return e._zod.parse(c, u);
    };
    e._zod.run = (s, l) => {
      if (l.skipChecks)
        return e._zod.parse(s, l);
      if (l.direction === "backward") {
        const c = e._zod.parse({ value: s.value, issues: [] }, { ...l, skipChecks: !0 });
        return c instanceof Promise ? c.then((f) => a(f, s, l)) : a(c, s, l);
      }
      const u = e._zod.parse(s, l);
      if (u instanceof Promise) {
        if (l.async === !1)
          throw new Ds();
        return u.then((c) => o(c, i, l));
      }
      return o(u, i, l);
    };
  }
  wt(e, "~standard", () => ({
    validate: (o) => {
      var a;
      try {
        const s = Bne(e, o);
        return s.success ? { value: s.data } : { issues: (a = s.error) == null ? void 0 : a.issues };
      } catch {
        return Une(e, o).then((s) => {
          var l;
          return s.success ? { value: s.data } : { issues: (l = s.error) == null ? void 0 : l.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), h_ = /* @__PURE__ */ ae("$ZodString", (e, t) => {
  var n;
  an.init(e, t), e._zod.pattern = [...((n = e?._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? bre(e._zod.bag), e._zod.parse = (r, i) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), Ut = /* @__PURE__ */ ae("$ZodStringFormat", (e, t) => {
  bh.init(e, t), h_.init(e, t);
}), zre = /* @__PURE__ */ ae("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = are), Ut.init(e, t);
}), Lre = /* @__PURE__ */ ae("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = V2(n));
  } else
    t.pattern ?? (t.pattern = V2());
  Ut.init(e, t);
}), Vre = /* @__PURE__ */ ae("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = sre), Ut.init(e, t);
}), Kre = /* @__PURE__ */ ae("$ZodURL", (e, t) => {
  Ut.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value.trim(), i = new URL(r);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = i.href : n.value = r;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Bre = /* @__PURE__ */ ae("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = ure()), Ut.init(e, t);
}), Ure = /* @__PURE__ */ ae("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = ire), Ut.init(e, t);
}), qre = /* @__PURE__ */ ae("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = Xne), Ut.init(e, t);
}), Hre = /* @__PURE__ */ ae("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = ere), Ut.init(e, t);
}), Wre = /* @__PURE__ */ ae("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = tre), Ut.init(e, t);
}), Zre = /* @__PURE__ */ ae("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = nre), Ut.init(e, t);
}), Gre = /* @__PURE__ */ ae("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = rre), Ut.init(e, t);
}), Yre = /* @__PURE__ */ ae("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = yre(t)), Ut.init(e, t);
}), Qre = /* @__PURE__ */ ae("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = mre), Ut.init(e, t);
}), Jre = /* @__PURE__ */ ae("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = gre(t)), Ut.init(e, t);
}), Xre = /* @__PURE__ */ ae("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = ore), Ut.init(e, t);
}), eie = /* @__PURE__ */ ae("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = cre), Ut.init(e, t), e._zod.bag.format = "ipv4";
}), tie = /* @__PURE__ */ ae("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = fre), Ut.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), nie = /* @__PURE__ */ ae("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = dre), Ut.init(e, t);
}), rie = /* @__PURE__ */ ae("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = pre), Ut.init(e, t), e._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [i, o] = r;
      if (!o)
        throw new Error();
      const a = Number(o);
      if (`${a}` !== o)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function n3(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const iie = /* @__PURE__ */ ae("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = hre), Ut.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
    n3(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function oie(e) {
  if (!YI.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return n3(n);
}
const aie = /* @__PURE__ */ ae("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = YI), Ut.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
    oie(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), sie = /* @__PURE__ */ ae("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = vre), Ut.init(e, t);
});
function lie(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const i = JSON.parse(atob(r));
    return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const uie = /* @__PURE__ */ ae("$ZodJWT", (e, t) => {
  Ut.init(e, t), e._zod.check = (n) => {
    lie(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), r3 = /* @__PURE__ */ ae("$ZodNumber", (e, t) => {
  an.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? wre, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const i = n.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return n;
    const o = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...o ? { received: o } : {}
    }), n;
  };
}), cie = /* @__PURE__ */ ae("$ZodNumberFormat", (e, t) => {
  $re.init(e, t), r3.init(e, t);
}), fie = /* @__PURE__ */ ae("$ZodBoolean", (e, t) => {
  an.init(e, t), e._zod.pattern = xre, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const i = n.value;
    return typeof i == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), n;
  };
}), die = /* @__PURE__ */ ae("$ZodUnknown", (e, t) => {
  an.init(e, t), e._zod.parse = (n) => n;
}), pie = /* @__PURE__ */ ae("$ZodNever", (e, t) => {
  an.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function K2(e, t, n) {
  e.issues.length && t.issues.push(...HI(n, e.issues)), t.value[n] = e.value;
}
const hie = /* @__PURE__ */ ae("$ZodArray", (e, t) => {
  an.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Array.isArray(i))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    n.value = Array(i.length);
    const o = [];
    for (let a = 0; a < i.length; a++) {
      const s = i[a], l = t.element._zod.run({
        value: s,
        issues: []
      }, r);
      l instanceof Promise ? o.push(l.then((u) => K2(u, n, a))) : K2(l, n, a);
    }
    return o.length ? Promise.all(o).then(() => n) : n;
  };
});
function ep(e, t, n, r, i) {
  if (e.issues.length) {
    if (i && !(n in r))
      return;
    t.issues.push(...HI(n, e.issues));
  }
  e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
function i3(e) {
  var t, n, r, i;
  const o = Object.keys(e.shape);
  for (const s of o)
    if (!((i = (r = (n = (t = e.shape) == null ? void 0 : t[s]) == null ? void 0 : n._zod) == null ? void 0 : r.traits) != null && i.has("$ZodType")))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const a = Cne(e.shape);
  return {
    ...e,
    keys: o,
    keySet: new Set(o),
    numKeys: o.length,
    optionalKeys: new Set(a)
  };
}
function o3(e, t, n, r, i, o) {
  const a = [], s = i.keySet, l = i.catchall._zod, u = l.def.type, c = l.optout === "optional";
  for (const f in t) {
    if (s.has(f))
      continue;
    if (u === "never") {
      a.push(f);
      continue;
    }
    const d = l.run({ value: t[f], issues: [] }, r);
    d instanceof Promise ? e.push(d.then((p) => ep(p, n, f, t, c))) : ep(d, n, f, t, c);
  }
  return a.length && n.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: t,
    inst: o
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const vie = /* @__PURE__ */ ae("$ZodObject", (e, t) => {
  an.init(e, t);
  const n = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(n != null && n.get)) {
    const s = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const l = { ...s };
        return Object.defineProperty(t, "shape", {
          value: l
        }), l;
      }
    });
  }
  const r = l_(() => i3(t));
  wt(e._zod, "propValues", () => {
    const s = t.shape, l = {};
    for (const u in s) {
      const c = s[u]._zod;
      if (c.values) {
        l[u] ?? (l[u] = /* @__PURE__ */ new Set());
        for (const f of c.values)
          l[u].add(f);
      }
    }
    return l;
  });
  const i = Xd, o = t.catchall;
  let a;
  e._zod.parse = (s, l) => {
    a ?? (a = r.value);
    const u = s.value;
    if (!i(u))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: u,
        inst: e
      }), s;
    s.value = {};
    const c = [], f = a.shape;
    for (const d of a.keys) {
      const p = f[d], h = p._zod.optout === "optional", v = p._zod.run({ value: u[d], issues: [] }, l);
      v instanceof Promise ? c.push(v.then((m) => ep(m, s, d, u, h))) : ep(v, s, d, u, h);
    }
    return o ? o3(c, u, s, l, r.value, e) : c.length ? Promise.all(c).then(() => s) : s;
  };
}), mie = /* @__PURE__ */ ae("$ZodObjectJIT", (e, t) => {
  vie.init(e, t);
  const n = e._zod.parse, r = l_(() => i3(t)), i = (f) => {
    var d;
    const p = new jre(["shape", "payload", "ctx"]), h = r.value, v = (w) => {
      const x = L2(w);
      return `shape[${x}]._zod.run({ value: input[${x}], issues: [] }, ctx)`;
    };
    p.write("const input = payload.value;");
    const m = /* @__PURE__ */ Object.create(null);
    let g = 0;
    for (const w of h.keys)
      m[w] = `key_${g++}`;
    p.write("const newResult = {};");
    for (const w of h.keys) {
      const x = m[w], S = L2(w), $ = f[w], A = ((d = $?._zod) == null ? void 0 : d.optout) === "optional";
      p.write(`const ${x} = ${v(w)};`), A ? p.write(`
        if (${x}.issues.length) {
          if (${S} in input) {
            payload.issues = payload.issues.concat(${x}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${S}, ...iss.path] : [${S}]
            })));
          }
        }
        
        if (${x}.value === undefined) {
          if (${S} in input) {
            newResult[${S}] = undefined;
          }
        } else {
          newResult[${S}] = ${x}.value;
        }
        
      `) : p.write(`
        if (${x}.issues.length) {
          payload.issues = payload.issues.concat(${x}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${S}, ...iss.path] : [${S}]
          })));
        }
        
        if (${x}.value === undefined) {
          if (${S} in input) {
            newResult[${S}] = undefined;
          }
        } else {
          newResult[${S}] = ${x}.value;
        }
        
      `);
    }
    p.write("payload.value = newResult;"), p.write("return payload;");
    const _ = p.compile();
    return (w, x) => _(f, w, x);
  };
  let o;
  const a = Xd, s = !KI.jitless, l = s && Dne.value, u = t.catchall;
  let c;
  e._zod.parse = (f, d) => {
    c ?? (c = r.value);
    const p = f.value;
    return a(p) ? s && l && d?.async === !1 && d.jitless !== !0 ? (o || (o = i(t.shape)), f = o(f, d), u ? o3([], p, f, d, c, e) : f) : n(f, d) : (f.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), f);
  };
});
function B2(e, t, n, r) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  const i = e.filter((o) => !bs(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((o) => o.issues.map((a) => Aa(a, r, Da())))
  }), t);
}
const gie = /* @__PURE__ */ ae("$ZodUnion", (e, t) => {
  an.init(e, t), wt(e._zod, "optin", () => t.options.some((i) => i._zod.optin === "optional") ? "optional" : void 0), wt(e._zod, "optout", () => t.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), wt(e._zod, "values", () => {
    if (t.options.every((i) => i._zod.values))
      return new Set(t.options.flatMap((i) => Array.from(i._zod.values)));
  }), wt(e._zod, "pattern", () => {
    if (t.options.every((i) => i._zod.pattern)) {
      const i = t.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${i.map((o) => c_(o.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, r = t.options[0]._zod.run;
  e._zod.parse = (i, o) => {
    if (n)
      return r(i, o);
    let a = !1;
    const s = [];
    for (const l of t.options) {
      const u = l._zod.run({
        value: i.value,
        issues: []
      }, o);
      if (u instanceof Promise)
        s.push(u), a = !0;
      else {
        if (u.issues.length === 0)
          return u;
        s.push(u);
      }
    }
    return a ? Promise.all(s).then((l) => B2(l, i, e, o)) : B2(s, i, e, o);
  };
}), yie = /* @__PURE__ */ ae("$ZodIntersection", (e, t) => {
  an.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value, o = t.left._zod.run({ value: i, issues: [] }, r), a = t.right._zod.run({ value: i, issues: [] }, r);
    return o instanceof Promise || a instanceof Promise ? Promise.all([o, a]).then(([s, l]) => U2(n, s, l)) : U2(n, o, a);
  };
});
function by(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (ic(e) && ic(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((o) => n.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of r) {
      const a = by(e[o], t[o]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...a.mergeErrorPath]
        };
      i[o] = a.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const i = e[r], o = t[r], a = by(i, o);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...a.mergeErrorPath]
        };
      n.push(a.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function U2(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  let i;
  for (const s of t.issues)
    if (s.code === "unrecognized_keys") {
      i ?? (i = s);
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).l = !0;
    } else
      e.issues.push(s);
  for (const s of n.issues)
    if (s.code === "unrecognized_keys")
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).r = !0;
    else
      e.issues.push(s);
  const o = [...r].filter(([, s]) => s.l && s.r).map(([s]) => s);
  if (o.length && i && e.issues.push({ ...i, keys: o }), bs(e))
    return e;
  const a = by(t.value, n.value);
  if (!a.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(a.mergeErrorPath)}`);
  return e.value = a.data, e;
}
const bie = /* @__PURE__ */ ae("$ZodEnum", (e, t) => {
  an.init(e, t);
  const n = BI(t.entries), r = new Set(n);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.filter((i) => Ane.has(typeof i)).map((i) => typeof i == "string" ? mh(i) : i.toString()).join("|")})$`), e._zod.parse = (i, o) => {
    const a = i.value;
    return r.has(a) || i.issues.push({
      code: "invalid_value",
      values: n,
      input: a,
      inst: e
    }), i;
  };
}), _ie = /* @__PURE__ */ ae("$ZodTransform", (e, t) => {
  an.init(e, t), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new VI(e.constructor.name);
    const i = t.transform(n.value, n);
    if (r.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((o) => (n.value = o, n));
    if (i instanceof Promise)
      throw new Ds();
    return n.value = i, n;
  };
});
function q2(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const a3 = /* @__PURE__ */ ae("$ZodOptional", (e, t) => {
  an.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", wt(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), wt(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${c_(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (t.innerType._zod.optin === "optional") {
      const i = t.innerType._zod.run(n, r);
      return i instanceof Promise ? i.then((o) => q2(o, n.value)) : q2(i, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, r);
  };
}), wie = /* @__PURE__ */ ae("$ZodExactOptional", (e, t) => {
  a3.init(e, t), wt(e._zod, "values", () => t.innerType._zod.values), wt(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (n, r) => t.innerType._zod.run(n, r);
}), xie = /* @__PURE__ */ ae("$ZodNullable", (e, t) => {
  an.init(e, t), wt(e._zod, "optin", () => t.innerType._zod.optin), wt(e._zod, "optout", () => t.innerType._zod.optout), wt(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${c_(n.source)}|null)$`) : void 0;
  }), wt(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), Eie = /* @__PURE__ */ ae("$ZodDefault", (e, t) => {
  an.init(e, t), e._zod.optin = "optional", wt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => H2(o, t)) : H2(i, t);
  };
});
function H2(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Sie = /* @__PURE__ */ ae("$ZodPrefault", (e, t) => {
  an.init(e, t), e._zod.optin = "optional", wt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), Oie = /* @__PURE__ */ ae("$ZodNonOptional", (e, t) => {
  an.init(e, t), wt(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => W2(o, e)) : W2(i, e);
  };
});
function W2(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const $ie = /* @__PURE__ */ ae("$ZodCatch", (e, t) => {
  an.init(e, t), wt(e._zod, "optin", () => t.innerType._zod.optin), wt(e._zod, "optout", () => t.innerType._zod.optout), wt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((a) => Aa(a, r, Da()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((o) => Aa(o, r, Da()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), Tie = /* @__PURE__ */ ae("$ZodPipe", (e, t) => {
  an.init(e, t), wt(e._zod, "values", () => t.in._zod.values), wt(e._zod, "optin", () => t.in._zod.optin), wt(e._zod, "optout", () => t.out._zod.optout), wt(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const o = t.out._zod.run(n, r);
      return o instanceof Promise ? o.then((a) => Ef(a, t.in, r)) : Ef(o, t.in, r);
    }
    const i = t.in._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => Ef(o, t.out, r)) : Ef(i, t.out, r);
  };
});
function Ef(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const Pie = /* @__PURE__ */ ae("$ZodReadonly", (e, t) => {
  an.init(e, t), wt(e._zod, "propValues", () => t.innerType._zod.propValues), wt(e._zod, "values", () => t.innerType._zod.values), wt(e._zod, "optin", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin;
  }), wt(e._zod, "optout", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout;
  }), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then(Z2) : Z2(i);
  };
});
function Z2(e) {
  return e.value = Object.freeze(e.value), e;
}
const kie = /* @__PURE__ */ ae("$ZodCustom", (e, t) => {
  ir.init(e, t), an.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, i = t.fn(r);
    if (i instanceof Promise)
      return i.then((o) => G2(o, n, r, e));
    G2(i, n, r, e);
  };
});
function G2(e, t, n, r) {
  if (!e) {
    const i = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (i.params = r._zod.def.params), t.issues.push(oc(i));
  }
}
var Y2;
class Die {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    return this._map.set(t, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const i = { ...r, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Aie() {
  return new Die();
}
(Y2 = globalThis).__zod_globalRegistry ?? (Y2.__zod_globalRegistry = Aie());
const iu = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function Cie(e, t) {
  return new e({
    type: "string",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Iie(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Q2(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Nie(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Rie(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Mie(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function jie(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Fie(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function zie(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Lie(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Vie(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Kie(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Bie(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Uie(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qie(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Hie(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Wie(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Zie(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Gie(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Yie(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Qie(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Jie(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Xie(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function eoe(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function toe(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function noe(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function roe(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ioe(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ooe(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function aoe(e, t) {
  return new e({
    type: "boolean",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function soe(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function loe(e, t) {
  return new e({
    type: "never",
    ...qe(t)
  });
}
// @__NO_SIDE_EFFECTS__
function J2(e, t) {
  return new e3({
    check: "less_than",
    ...qe(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Xv(e, t) {
  return new e3({
    check: "less_than",
    ...qe(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function X2(e, t) {
  return new t3({
    check: "greater_than",
    ...qe(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function em(e, t) {
  return new t3({
    check: "greater_than",
    ...qe(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function eO(e, t) {
  return new Ore({
    check: "multiple_of",
    ...qe(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function s3(e, t) {
  return new Tre({
    check: "max_length",
    ...qe(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function tp(e, t) {
  return new Pre({
    check: "min_length",
    ...qe(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function l3(e, t) {
  return new kre({
    check: "length_equals",
    ...qe(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function uoe(e, t) {
  return new Dre({
    check: "string_format",
    format: "regex",
    ...qe(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function coe(e) {
  return new Are({
    check: "string_format",
    format: "lowercase",
    ...qe(e)
  });
}
// @__NO_SIDE_EFFECTS__
function foe(e) {
  return new Cre({
    check: "string_format",
    format: "uppercase",
    ...qe(e)
  });
}
// @__NO_SIDE_EFFECTS__
function doe(e, t) {
  return new Ire({
    check: "string_format",
    format: "includes",
    ...qe(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function poe(e, t) {
  return new Nre({
    check: "string_format",
    format: "starts_with",
    ...qe(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function hoe(e, t) {
  return new Rre({
    check: "string_format",
    format: "ends_with",
    ...qe(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function Pl(e) {
  return new Mre({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function voe(e) {
  return /* @__PURE__ */ Pl((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function moe() {
  return /* @__PURE__ */ Pl((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function goe() {
  return /* @__PURE__ */ Pl((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function yoe() {
  return /* @__PURE__ */ Pl((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function boe() {
  return /* @__PURE__ */ Pl((e) => kne(e));
}
// @__NO_SIDE_EFFECTS__
function _oe(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...qe(n)
  });
}
// @__NO_SIDE_EFFECTS__
function woe(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...qe(n)
  });
}
// @__NO_SIDE_EFFECTS__
function xoe(e) {
  const t = /* @__PURE__ */ Eoe((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(oc(r, n.value, t._zod.def));
    else {
      const i = r;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = t), i.continue ?? (i.continue = !t._zod.def.abort), n.issues.push(oc(i));
    }
  }, e(n.value, n)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function Eoe(e, t) {
  const n = new ir({
    check: "custom",
    ...qe(t)
  });
  return n._zod.check = e, n;
}
function u3(e) {
  let t = e?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: e?.metadata ?? iu,
    target: t,
    unrepresentable: e?.unrepresentable ?? "throw",
    override: e?.override ?? (() => {
    }),
    io: e?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: e?.cycles ?? "ref",
    reused: e?.reused ?? "inline",
    external: e?.external ?? void 0
  };
}
function Pn(e, t, n = { path: [], schemaPath: [] }) {
  var r, i, o;
  const a = e._zod.def, s = t.seen.get(e);
  if (s)
    return s.count++, n.schemaPath.includes(e) && (s.cycle = n.path), s.schema;
  const l = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, l);
  const u = (i = (r = e._zod).toJSONSchema) == null ? void 0 : i.call(r);
  if (u)
    l.schema = u;
  else {
    const f = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, l.schema, f);
    else {
      const p = l.schema, h = t.processors[a.type];
      if (!h)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${a.type}`);
      h(e, t, p, f);
    }
    const d = e._zod.parent;
    d && (l.ref || (l.ref = d), Pn(d, t, f), t.seen.get(d).isParent = !0);
  }
  const c = t.metadataRegistry.get(e);
  return c && Object.assign(l.schema, c), t.io === "input" && Fn(e) && (delete l.schema.examples, delete l.schema.default), t.io === "input" && l.schema._prefault && ((o = l.schema).default ?? (o.default = l.schema._prefault)), delete l.schema._prefault, t.seen.get(e).schema;
}
function c3(e, t) {
  var n, r, i, o;
  const a = e.seen.get(t);
  if (!a)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const s = /* @__PURE__ */ new Map();
  for (const c of e.seen.entries()) {
    const f = (n = e.metadataRegistry.get(c[0])) == null ? void 0 : n.id;
    if (f) {
      const d = s.get(f);
      if (d && d !== c[0])
        throw new Error(`Duplicate schema id "${f}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      s.set(f, c[0]);
    }
  }
  const l = (c) => {
    var f;
    const d = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const v = (f = e.external.registry.get(c[0])) == null ? void 0 : f.id, m = e.external.uri ?? ((_) => _);
      if (v)
        return { ref: m(v) };
      const g = c[1].defId ?? c[1].schema.id ?? `schema${e.counter++}`;
      return c[1].defId = g, { defId: g, ref: `${m("__shared")}#/${d}/${g}` };
    }
    if (c[1] === a)
      return { ref: "#" };
    const p = `#/${d}/`, h = c[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: h, ref: p + h };
  }, u = (c) => {
    if (c[1].schema.$ref)
      return;
    const f = c[1], { ref: d, defId: p } = l(c);
    f.def = { ...f.schema }, p && (f.defId = p);
    const h = f.schema;
    for (const v in h)
      delete h[v];
    h.$ref = d;
  };
  if (e.cycles === "throw")
    for (const c of e.seen.entries()) {
      const f = c[1];
      if (f.cycle)
        throw new Error(`Cycle detected: #/${(r = f.cycle) == null ? void 0 : r.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const c of e.seen.entries()) {
    const f = c[1];
    if (t === c[0]) {
      u(c);
      continue;
    }
    if (e.external) {
      const d = (i = e.external.registry.get(c[0])) == null ? void 0 : i.id;
      if (t !== c[0] && d) {
        u(c);
        continue;
      }
    }
    if ((o = e.metadataRegistry.get(c[0])) != null && o.id) {
      u(c);
      continue;
    }
    if (f.cycle) {
      u(c);
      continue;
    }
    if (f.count > 1 && e.reused === "ref") {
      u(c);
      continue;
    }
  }
}
function f3(e, t) {
  var n, r, i;
  const o = e.seen.get(t);
  if (!o)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = (u) => {
    const c = e.seen.get(u);
    if (c.ref === null)
      return;
    const f = c.def ?? c.schema, d = { ...f }, p = c.ref;
    if (c.ref = null, p) {
      a(p);
      const v = e.seen.get(p), m = v.schema;
      if (m.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (f.allOf = f.allOf ?? [], f.allOf.push(m)) : Object.assign(f, m), Object.assign(f, d), u._zod.parent === p)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in d || delete f[g];
      if (m.$ref && v.def)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in v.def && JSON.stringify(f[g]) === JSON.stringify(v.def[g]) && delete f[g];
    }
    const h = u._zod.parent;
    if (h && h !== p) {
      a(h);
      const v = e.seen.get(h);
      if (v != null && v.schema.$ref && (f.$ref = v.schema.$ref, v.def))
        for (const m in f)
          m === "$ref" || m === "allOf" || m in v.def && JSON.stringify(f[m]) === JSON.stringify(v.def[m]) && delete f[m];
    }
    e.override({
      zodSchema: u,
      jsonSchema: f,
      path: c.path ?? []
    });
  };
  for (const u of [...e.seen.entries()].reverse())
    a(u[0]);
  const s = {};
  if (e.target === "draft-2020-12" ? s.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? s.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? s.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (n = e.external) != null && n.uri) {
    const u = (r = e.external.registry.get(t)) == null ? void 0 : r.id;
    if (!u)
      throw new Error("Schema is missing an `id` property");
    s.$id = e.external.uri(u);
  }
  Object.assign(s, o.def ?? o.schema);
  const l = ((i = e.external) == null ? void 0 : i.defs) ?? {};
  for (const u of e.seen.entries()) {
    const c = u[1];
    c.def && c.defId && (l[c.defId] = c.def);
  }
  e.external || Object.keys(l).length > 0 && (e.target === "draft-2020-12" ? s.$defs = l : s.definitions = l);
  try {
    const u = JSON.parse(JSON.stringify(s));
    return Object.defineProperty(u, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: np(t, "input", e.processors),
          output: np(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), u;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function Fn(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const r = e._zod.def;
  if (r.type === "transform")
    return !0;
  if (r.type === "array")
    return Fn(r.element, n);
  if (r.type === "set")
    return Fn(r.valueType, n);
  if (r.type === "lazy")
    return Fn(r.getter(), n);
  if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault")
    return Fn(r.innerType, n);
  if (r.type === "intersection")
    return Fn(r.left, n) || Fn(r.right, n);
  if (r.type === "record" || r.type === "map")
    return Fn(r.keyType, n) || Fn(r.valueType, n);
  if (r.type === "pipe")
    return Fn(r.in, n) || Fn(r.out, n);
  if (r.type === "object") {
    for (const i in r.shape)
      if (Fn(r.shape[i], n))
        return !0;
    return !1;
  }
  if (r.type === "union") {
    for (const i of r.options)
      if (Fn(i, n))
        return !0;
    return !1;
  }
  if (r.type === "tuple") {
    for (const i of r.items)
      if (Fn(i, n))
        return !0;
    return !!(r.rest && Fn(r.rest, n));
  }
  return !1;
}
const Soe = (e, t = {}) => (n) => {
  const r = u3({ ...n, processors: t });
  return Pn(e, r), c3(r, e), f3(r, e);
}, np = (e, t, n = {}) => (r) => {
  const { libraryOptions: i, target: o } = r ?? {}, a = u3({ ...i ?? {}, target: o, io: t, processors: n });
  return Pn(e, a), c3(a, e), f3(a, e);
}, Ooe = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, $oe = (e, t, n, r) => {
  const i = n;
  i.type = "string";
  const { minimum: o, maximum: a, format: s, patterns: l, contentEncoding: u } = e._zod.bag;
  if (typeof o == "number" && (i.minLength = o), typeof a == "number" && (i.maxLength = a), s && (i.format = Ooe[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), u && (i.contentEncoding = u), l && l.size > 0) {
    const c = [...l];
    c.length === 1 ? i.pattern = c[0].source : c.length > 1 && (i.allOf = [
      ...c.map((f) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: f.source
      }))
    ]);
  }
}, Toe = (e, t, n, r) => {
  const i = n, { minimum: o, maximum: a, format: s, multipleOf: l, exclusiveMaximum: u, exclusiveMinimum: c } = e._zod.bag;
  typeof s == "string" && s.includes("int") ? i.type = "integer" : i.type = "number", typeof c == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.minimum = c, i.exclusiveMinimum = !0) : i.exclusiveMinimum = c), typeof o == "number" && (i.minimum = o, typeof c == "number" && t.target !== "draft-04" && (c >= o ? delete i.minimum : delete i.exclusiveMinimum)), typeof u == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.maximum = u, i.exclusiveMaximum = !0) : i.exclusiveMaximum = u), typeof a == "number" && (i.maximum = a, typeof u == "number" && t.target !== "draft-04" && (u <= a ? delete i.maximum : delete i.exclusiveMaximum)), typeof l == "number" && (i.multipleOf = l);
}, Poe = (e, t, n, r) => {
  n.type = "boolean";
}, koe = (e, t, n, r) => {
  n.not = {};
}, Doe = (e, t, n, r) => {
}, Aoe = (e, t, n, r) => {
  const i = e._zod.def, o = BI(i.entries);
  o.every((a) => typeof a == "number") && (n.type = "number"), o.every((a) => typeof a == "string") && (n.type = "string"), n.enum = o;
}, Coe = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, Ioe = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, Noe = (e, t, n, r) => {
  const i = n, o = e._zod.def, { minimum: a, maximum: s } = e._zod.bag;
  typeof a == "number" && (i.minItems = a), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = Pn(o.element, t, { ...r, path: [...r.path, "items"] });
}, Roe = (e, t, n, r) => {
  var i;
  const o = n, a = e._zod.def;
  o.type = "object", o.properties = {};
  const s = a.shape;
  for (const c in s)
    o.properties[c] = Pn(s[c], t, {
      ...r,
      path: [...r.path, "properties", c]
    });
  const l = new Set(Object.keys(s)), u = new Set([...l].filter((c) => {
    const f = a.shape[c]._zod;
    return t.io === "input" ? f.optin === void 0 : f.optout === void 0;
  }));
  u.size > 0 && (o.required = Array.from(u)), ((i = a.catchall) == null ? void 0 : i._zod.def.type) === "never" ? o.additionalProperties = !1 : a.catchall ? a.catchall && (o.additionalProperties = Pn(a.catchall, t, {
    ...r,
    path: [...r.path, "additionalProperties"]
  })) : t.io === "output" && (o.additionalProperties = !1);
}, Moe = (e, t, n, r) => {
  const i = e._zod.def, o = i.inclusive === !1, a = i.options.map((s, l) => Pn(s, t, {
    ...r,
    path: [...r.path, o ? "oneOf" : "anyOf", l]
  }));
  o ? n.oneOf = a : n.anyOf = a;
}, joe = (e, t, n, r) => {
  const i = e._zod.def, o = Pn(i.left, t, {
    ...r,
    path: [...r.path, "allOf", 0]
  }), a = Pn(i.right, t, {
    ...r,
    path: [...r.path, "allOf", 1]
  }), s = (u) => "allOf" in u && Object.keys(u).length === 1, l = [
    ...s(o) ? o.allOf : [o],
    ...s(a) ? a.allOf : [a]
  ];
  n.allOf = l;
}, Foe = (e, t, n, r) => {
  const i = e._zod.def, o = Pn(i.innerType, t, r), a = t.seen.get(e);
  t.target === "openapi-3.0" ? (a.ref = i.innerType, n.nullable = !0) : n.anyOf = [o, { type: "null" }];
}, zoe = (e, t, n, r) => {
  const i = e._zod.def;
  Pn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, Loe = (e, t, n, r) => {
  const i = e._zod.def;
  Pn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.default = JSON.parse(JSON.stringify(i.defaultValue));
}, Voe = (e, t, n, r) => {
  const i = e._zod.def;
  Pn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, Koe = (e, t, n, r) => {
  const i = e._zod.def;
  Pn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  let a;
  try {
    a = i.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = a;
}, Boe = (e, t, n, r) => {
  const i = e._zod.def, o = t.io === "input" ? i.in._zod.def.type === "transform" ? i.out : i.in : i.out;
  Pn(o, t, r);
  const a = t.seen.get(e);
  a.ref = o;
}, Uoe = (e, t, n, r) => {
  const i = e._zod.def;
  Pn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.readOnly = !0;
}, d3 = (e, t, n, r) => {
  const i = e._zod.def;
  Pn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, qoe = /* @__PURE__ */ ae("ZodISODateTime", (e, t) => {
  Yre.init(e, t), Yt.init(e, t);
});
function Hoe(e) {
  return /* @__PURE__ */ eoe(qoe, e);
}
const Woe = /* @__PURE__ */ ae("ZodISODate", (e, t) => {
  Qre.init(e, t), Yt.init(e, t);
});
function Zoe(e) {
  return /* @__PURE__ */ toe(Woe, e);
}
const Goe = /* @__PURE__ */ ae("ZodISOTime", (e, t) => {
  Jre.init(e, t), Yt.init(e, t);
});
function Yoe(e) {
  return /* @__PURE__ */ noe(Goe, e);
}
const Qoe = /* @__PURE__ */ ae("ZodISODuration", (e, t) => {
  Xre.init(e, t), Yt.init(e, t);
});
function Joe(e) {
  return /* @__PURE__ */ roe(Qoe, e);
}
const Xoe = (e, t) => {
  ZI.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => Kne(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => Vne(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, yy, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, yy, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Kr = ae("ZodError", Xoe, {
  Parent: Error
}), eae = /* @__PURE__ */ d_(Kr), tae = /* @__PURE__ */ p_(Kr), nae = /* @__PURE__ */ gh(Kr), rae = /* @__PURE__ */ yh(Kr), iae = /* @__PURE__ */ qne(Kr), oae = /* @__PURE__ */ Hne(Kr), aae = /* @__PURE__ */ Wne(Kr), sae = /* @__PURE__ */ Zne(Kr), lae = /* @__PURE__ */ Gne(Kr), uae = /* @__PURE__ */ Yne(Kr), cae = /* @__PURE__ */ Qne(Kr), fae = /* @__PURE__ */ Jne(Kr), sn = /* @__PURE__ */ ae("ZodType", (e, t) => (an.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: np(e, "input"),
    output: np(e, "output")
  }
}), e.toJSONSchema = Soe(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(Uo(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (n, r) => qo(e, n, r), e.brand = () => e, e.register = ((n, r) => (n.add(e, r), e)), e.parse = (n, r) => eae(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => nae(e, n, r), e.parseAsync = async (n, r) => tae(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => rae(e, n, r), e.spa = e.safeParseAsync, e.encode = (n, r) => iae(e, n, r), e.decode = (n, r) => oae(e, n, r), e.encodeAsync = async (n, r) => aae(e, n, r), e.decodeAsync = async (n, r) => sae(e, n, r), e.safeEncode = (n, r) => lae(e, n, r), e.safeDecode = (n, r) => uae(e, n, r), e.safeEncodeAsync = async (n, r) => cae(e, n, r), e.safeDecodeAsync = async (n, r) => fae(e, n, r), e.refine = (n, r) => e.check(rse(n, r)), e.superRefine = (n) => e.check(ise(n)), e.overwrite = (n) => e.check(/* @__PURE__ */ Pl(n)), e.optional = () => rO(e), e.exactOptional = () => Uae(e), e.nullable = () => iO(e), e.nullish = () => rO(iO(e)), e.nonoptional = (n) => Yae(e, n), e.array = () => ft(e), e.or = (n) => Fae([e, n]), e.and = (n) => Lae(e, n), e.transform = (n) => oO(e, Kae(n)), e.default = (n) => Wae(e, n), e.prefault = (n) => Gae(e, n), e.catch = (n) => Jae(e, n), e.pipe = (n) => oO(e, n), e.readonly = () => tse(e), e.describe = (n) => {
  const r = e.clone();
  return iu.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    var n;
    return (n = iu.get(e)) == null ? void 0 : n.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return iu.get(e);
  const r = e.clone();
  return iu.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (n) => n(e), e)), p3 = /* @__PURE__ */ ae("_ZodString", (e, t) => {
  h_.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (r, i, o) => $oe(e, r, i);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(/* @__PURE__ */ uoe(...r)), e.includes = (...r) => e.check(/* @__PURE__ */ doe(...r)), e.startsWith = (...r) => e.check(/* @__PURE__ */ poe(...r)), e.endsWith = (...r) => e.check(/* @__PURE__ */ hoe(...r)), e.min = (...r) => e.check(/* @__PURE__ */ tp(...r)), e.max = (...r) => e.check(/* @__PURE__ */ s3(...r)), e.length = (...r) => e.check(/* @__PURE__ */ l3(...r)), e.nonempty = (...r) => e.check(/* @__PURE__ */ tp(1, ...r)), e.lowercase = (r) => e.check(/* @__PURE__ */ coe(r)), e.uppercase = (r) => e.check(/* @__PURE__ */ foe(r)), e.trim = () => e.check(/* @__PURE__ */ moe()), e.normalize = (...r) => e.check(/* @__PURE__ */ voe(...r)), e.toLowerCase = () => e.check(/* @__PURE__ */ goe()), e.toUpperCase = () => e.check(/* @__PURE__ */ yoe()), e.slugify = () => e.check(/* @__PURE__ */ boe());
}), dae = /* @__PURE__ */ ae("ZodString", (e, t) => {
  h_.init(e, t), p3.init(e, t), e.email = (n) => e.check(/* @__PURE__ */ Iie(pae, n)), e.url = (n) => e.check(/* @__PURE__ */ Fie(hae, n)), e.jwt = (n) => e.check(/* @__PURE__ */ Xie(kae, n)), e.emoji = (n) => e.check(/* @__PURE__ */ zie(vae, n)), e.guid = (n) => e.check(/* @__PURE__ */ Q2(tO, n)), e.uuid = (n) => e.check(/* @__PURE__ */ Nie(Sf, n)), e.uuidv4 = (n) => e.check(/* @__PURE__ */ Rie(Sf, n)), e.uuidv6 = (n) => e.check(/* @__PURE__ */ Mie(Sf, n)), e.uuidv7 = (n) => e.check(/* @__PURE__ */ jie(Sf, n)), e.nanoid = (n) => e.check(/* @__PURE__ */ Lie(mae, n)), e.guid = (n) => e.check(/* @__PURE__ */ Q2(tO, n)), e.cuid = (n) => e.check(/* @__PURE__ */ Vie(gae, n)), e.cuid2 = (n) => e.check(/* @__PURE__ */ Kie(yae, n)), e.ulid = (n) => e.check(/* @__PURE__ */ Bie(bae, n)), e.base64 = (n) => e.check(/* @__PURE__ */ Yie($ae, n)), e.base64url = (n) => e.check(/* @__PURE__ */ Qie(Tae, n)), e.xid = (n) => e.check(/* @__PURE__ */ Uie(_ae, n)), e.ksuid = (n) => e.check(/* @__PURE__ */ qie(wae, n)), e.ipv4 = (n) => e.check(/* @__PURE__ */ Hie(xae, n)), e.ipv6 = (n) => e.check(/* @__PURE__ */ Wie(Eae, n)), e.cidrv4 = (n) => e.check(/* @__PURE__ */ Zie(Sae, n)), e.cidrv6 = (n) => e.check(/* @__PURE__ */ Gie(Oae, n)), e.e164 = (n) => e.check(/* @__PURE__ */ Jie(Pae, n)), e.datetime = (n) => e.check(Hoe(n)), e.date = (n) => e.check(Zoe(n)), e.time = (n) => e.check(Yoe(n)), e.duration = (n) => e.check(Joe(n));
});
function re(e) {
  return /* @__PURE__ */ Cie(dae, e);
}
const Yt = /* @__PURE__ */ ae("ZodStringFormat", (e, t) => {
  Ut.init(e, t), p3.init(e, t);
}), pae = /* @__PURE__ */ ae("ZodEmail", (e, t) => {
  Vre.init(e, t), Yt.init(e, t);
}), tO = /* @__PURE__ */ ae("ZodGUID", (e, t) => {
  zre.init(e, t), Yt.init(e, t);
}), Sf = /* @__PURE__ */ ae("ZodUUID", (e, t) => {
  Lre.init(e, t), Yt.init(e, t);
}), hae = /* @__PURE__ */ ae("ZodURL", (e, t) => {
  Kre.init(e, t), Yt.init(e, t);
}), vae = /* @__PURE__ */ ae("ZodEmoji", (e, t) => {
  Bre.init(e, t), Yt.init(e, t);
}), mae = /* @__PURE__ */ ae("ZodNanoID", (e, t) => {
  Ure.init(e, t), Yt.init(e, t);
}), gae = /* @__PURE__ */ ae("ZodCUID", (e, t) => {
  qre.init(e, t), Yt.init(e, t);
}), yae = /* @__PURE__ */ ae("ZodCUID2", (e, t) => {
  Hre.init(e, t), Yt.init(e, t);
}), bae = /* @__PURE__ */ ae("ZodULID", (e, t) => {
  Wre.init(e, t), Yt.init(e, t);
}), _ae = /* @__PURE__ */ ae("ZodXID", (e, t) => {
  Zre.init(e, t), Yt.init(e, t);
}), wae = /* @__PURE__ */ ae("ZodKSUID", (e, t) => {
  Gre.init(e, t), Yt.init(e, t);
}), xae = /* @__PURE__ */ ae("ZodIPv4", (e, t) => {
  eie.init(e, t), Yt.init(e, t);
}), Eae = /* @__PURE__ */ ae("ZodIPv6", (e, t) => {
  tie.init(e, t), Yt.init(e, t);
}), Sae = /* @__PURE__ */ ae("ZodCIDRv4", (e, t) => {
  nie.init(e, t), Yt.init(e, t);
}), Oae = /* @__PURE__ */ ae("ZodCIDRv6", (e, t) => {
  rie.init(e, t), Yt.init(e, t);
}), $ae = /* @__PURE__ */ ae("ZodBase64", (e, t) => {
  iie.init(e, t), Yt.init(e, t);
}), Tae = /* @__PURE__ */ ae("ZodBase64URL", (e, t) => {
  aie.init(e, t), Yt.init(e, t);
}), Pae = /* @__PURE__ */ ae("ZodE164", (e, t) => {
  sie.init(e, t), Yt.init(e, t);
}), kae = /* @__PURE__ */ ae("ZodJWT", (e, t) => {
  uie.init(e, t), Yt.init(e, t);
}), h3 = /* @__PURE__ */ ae("ZodNumber", (e, t) => {
  r3.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (r, i, o) => Toe(e, r, i), e.gt = (r, i) => e.check(/* @__PURE__ */ X2(r, i)), e.gte = (r, i) => e.check(/* @__PURE__ */ em(r, i)), e.min = (r, i) => e.check(/* @__PURE__ */ em(r, i)), e.lt = (r, i) => e.check(/* @__PURE__ */ J2(r, i)), e.lte = (r, i) => e.check(/* @__PURE__ */ Xv(r, i)), e.max = (r, i) => e.check(/* @__PURE__ */ Xv(r, i)), e.int = (r) => e.check(nO(r)), e.safe = (r) => e.check(nO(r)), e.positive = (r) => e.check(/* @__PURE__ */ X2(0, r)), e.nonnegative = (r) => e.check(/* @__PURE__ */ em(0, r)), e.negative = (r) => e.check(/* @__PURE__ */ J2(0, r)), e.nonpositive = (r) => e.check(/* @__PURE__ */ Xv(0, r)), e.multipleOf = (r, i) => e.check(/* @__PURE__ */ eO(r, i)), e.step = (r, i) => e.check(/* @__PURE__ */ eO(r, i)), e.finite = () => e;
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function Ce(e) {
  return /* @__PURE__ */ ioe(h3, e);
}
const Dae = /* @__PURE__ */ ae("ZodNumberFormat", (e, t) => {
  cie.init(e, t), h3.init(e, t);
});
function nO(e) {
  return /* @__PURE__ */ ooe(Dae, e);
}
const Aae = /* @__PURE__ */ ae("ZodBoolean", (e, t) => {
  fie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => Poe(e, n, r);
});
function mr(e) {
  return /* @__PURE__ */ aoe(Aae, e);
}
const Cae = /* @__PURE__ */ ae("ZodUnknown", (e, t) => {
  die.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => Doe();
});
function ac() {
  return /* @__PURE__ */ soe(Cae);
}
const Iae = /* @__PURE__ */ ae("ZodNever", (e, t) => {
  pie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => koe(e, n, r);
});
function Nae(e) {
  return /* @__PURE__ */ loe(Iae, e);
}
const Rae = /* @__PURE__ */ ae("ZodArray", (e, t) => {
  hie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => Noe(e, n, r, i), e.element = t.element, e.min = (n, r) => e.check(/* @__PURE__ */ tp(n, r)), e.nonempty = (n) => e.check(/* @__PURE__ */ tp(1, n)), e.max = (n, r) => e.check(/* @__PURE__ */ s3(n, r)), e.length = (n, r) => e.check(/* @__PURE__ */ l3(n, r)), e.unwrap = () => e.element;
});
function ft(e, t) {
  return /* @__PURE__ */ _oe(Rae, e, t);
}
const Mae = /* @__PURE__ */ ae("ZodObject", (e, t) => {
  mie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => Roe(e, n, r, i), wt(e, "shape", () => t.shape), e.keyof = () => Ni(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: ac() }), e.loose = () => e.clone({ ...e._zod.def, catchall: ac() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Nae() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => Mne(e, n), e.safeExtend = (n) => jne(e, n), e.merge = (n) => Fne(e, n), e.pick = (n) => Nne(e, n), e.omit = (n) => Rne(e, n), e.partial = (...n) => zne(v3, e, n[0]), e.required = (...n) => Lne(m3, e, n[0]);
});
function pe(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...qe(t)
  };
  return new Mae(n);
}
const jae = /* @__PURE__ */ ae("ZodUnion", (e, t) => {
  gie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => Moe(e, n, r, i), e.options = t.options;
});
function Fae(e, t) {
  return new jae({
    type: "union",
    options: e,
    ...qe(t)
  });
}
const zae = /* @__PURE__ */ ae("ZodIntersection", (e, t) => {
  yie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => joe(e, n, r, i);
});
function Lae(e, t) {
  return new zae({
    type: "intersection",
    left: e,
    right: t
  });
}
const _y = /* @__PURE__ */ ae("ZodEnum", (e, t) => {
  bie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (r, i, o) => Aoe(e, r, i), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, i) => {
    const o = {};
    for (const a of r)
      if (n.has(a))
        o[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new _y({
      ...t,
      checks: [],
      ...qe(i),
      entries: o
    });
  }, e.exclude = (r, i) => {
    const o = { ...t.entries };
    for (const a of r)
      if (n.has(a))
        delete o[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new _y({
      ...t,
      checks: [],
      ...qe(i),
      entries: o
    });
  };
});
function Ni(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new _y({
    type: "enum",
    entries: n,
    ...qe(t)
  });
}
const Vae = /* @__PURE__ */ ae("ZodTransform", (e, t) => {
  _ie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => Ioe(e, n), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new VI(e.constructor.name);
    n.addIssue = (o) => {
      if (typeof o == "string")
        n.issues.push(oc(o, n.value, t));
      else {
        const a = o;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = n.value), a.inst ?? (a.inst = e), n.issues.push(oc(a));
      }
    };
    const i = t.transform(n.value, n);
    return i instanceof Promise ? i.then((o) => (n.value = o, n)) : (n.value = i, n);
  };
});
function Kae(e) {
  return new Vae({
    type: "transform",
    transform: e
  });
}
const v3 = /* @__PURE__ */ ae("ZodOptional", (e, t) => {
  a3.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => d3(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function rO(e) {
  return new v3({
    type: "optional",
    innerType: e
  });
}
const Bae = /* @__PURE__ */ ae("ZodExactOptional", (e, t) => {
  wie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => d3(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Uae(e) {
  return new Bae({
    type: "optional",
    innerType: e
  });
}
const qae = /* @__PURE__ */ ae("ZodNullable", (e, t) => {
  xie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => Foe(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function iO(e) {
  return new qae({
    type: "nullable",
    innerType: e
  });
}
const Hae = /* @__PURE__ */ ae("ZodDefault", (e, t) => {
  Eie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => Loe(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Wae(e, t) {
  return new Hae({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : qI(t);
    }
  });
}
const Zae = /* @__PURE__ */ ae("ZodPrefault", (e, t) => {
  Sie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => Voe(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Gae(e, t) {
  return new Zae({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : qI(t);
    }
  });
}
const m3 = /* @__PURE__ */ ae("ZodNonOptional", (e, t) => {
  Oie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => zoe(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Yae(e, t) {
  return new m3({
    type: "nonoptional",
    innerType: e,
    ...qe(t)
  });
}
const Qae = /* @__PURE__ */ ae("ZodCatch", (e, t) => {
  $ie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => Koe(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Jae(e, t) {
  return new Qae({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const Xae = /* @__PURE__ */ ae("ZodPipe", (e, t) => {
  Tie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => Boe(e, n, r, i), e.in = t.in, e.out = t.out;
});
function oO(e, t) {
  return new Xae({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const ese = /* @__PURE__ */ ae("ZodReadonly", (e, t) => {
  Pie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => Uoe(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function tse(e) {
  return new ese({
    type: "readonly",
    innerType: e
  });
}
const nse = /* @__PURE__ */ ae("ZodCustom", (e, t) => {
  kie.init(e, t), sn.init(e, t), e._zod.processJSONSchema = (n, r, i) => Coe(e, n);
});
function rse(e, t = {}) {
  return /* @__PURE__ */ woe(nse, e, t);
}
function ise(e) {
  return /* @__PURE__ */ xoe(e);
}
const ose = pe({
  id: re(),
  name: re(),
  slug: re(),
  status: Ni(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  input: pe({}).partial().passthrough(),
  output: pe({}).partial().passthrough().nullable(),
  createdAt: re(),
  startedAt: re().nullable(),
  endedAt: re().nullable()
}).passthrough();
pe({ analyses: ft(ose) }).passthrough();
pe({
  name: re().min(1).max(100),
  outputLocation: pe({ s3BucketId: Ce(), path: re().optional() }).passthrough(),
  analysisSchemaId: Ce().int().gt(0).lte(9007199254740991),
  version: Ce(),
  input: ac(),
  labId: Ce().optional()
}).passthrough();
pe({
  analysisId: re().nullable(),
  analysisSlug: re().nullable(),
  success: mr()
}).passthrough();
const ase = pe({ id: Ce(), name: re(), versions: ft(Ce()) }).passthrough();
pe({ analysisSchemas: ft(ase) }).passthrough();
const g3 = pe({
  id: Ce(),
  name: re(),
  schema: pe({}).partial().passthrough()
}).passthrough(), aO = pe({ id: Ce(), name: re(), valueSchema: g3 }).passthrough(), sse = pe({
  analysisSchemaId: Ce(),
  version: Ce(),
  createdAt: re(),
  description: pe({ short: re().nullable(), long: re().nullable() }).partial().passthrough(),
  inputs: ft(aO),
  outputs: ft(aO)
}).passthrough();
pe({ versions: ft(sse) }).passthrough();
pe({ logs: ft(re()) }).passthrough();
const lse = pe({
  id: re(),
  name: re(),
  status: re(),
  analysisId: re(),
  startedAt: re(),
  endedAt: re(),
  memory: Ce(),
  vcpus: Ce(),
  cost: Ce()
}).passthrough();
pe({ tasks: ft(lse) }).passthrough();
pe({
  totalCost: Ce(),
  tasks: ft(
    pe({ name: re(), cost: Ce(), index: Ce() }).passthrough()
  ),
  runner: Ce()
}).passthrough();
const use = pe({
  analysisSchemaId: Ce(),
  version: Ce(),
  name: re()
}).passthrough();
pe({ next: ft(use) }).passthrough();
pe({ valueSchemas: ft(g3) }).passthrough();
const cse = Ni([
  "ADMIN",
  "USER",
  "PROFESSOR",
  "PREMIUM_USER",
  "FREE_USER"
]), y3 = Ni([
  "admin",
  "credits_unlimited",
  "files_read",
  "keypair_read",
  "lab_create",
  "labmember_read",
  "labmember_write",
  "lab_read",
  "plexus_read",
  "plexus_write",
  "tinkerbox_launch",
  "tinkerbox_read",
  "user_update"
]), b3 = pe({
  id: re(),
  firstname: re().nullable(),
  lastname: re().nullable(),
  email: re().nullable(),
  keyPairId: Ce(),
  roles: ft(cse),
  permissions: ft(y3)
}).passthrough();
pe({ user: b3 }).partial().passthrough();
pe({ email: re() }).passthrough();
pe({ success: mr() }).passthrough();
pe({ otp: re() }).passthrough();
pe({ success: mr() }).passthrough();
const fse = pe({ success: mr() }).passthrough();
pe({ token: re() }).passthrough();
pe({ token: re() }).passthrough();
pe({ valid: mr() }).passthrough();
pe({ name: re(), permissions: ft(y3) }).passthrough();
const dse = pe({
  id: Ce(),
  instanceProfile: re().nullable(),
  securityGroup: re().nullable()
}).passthrough(), _h = pe({
  id: Ce(),
  name: re(),
  labId: Ce().nullish(),
  userId: re().nullish(),
  status: Ni([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  ipAddress: re().nullish(),
  lastLogin: re().nullish(),
  keypairId: Ce().nullish()
}).passthrough();
pe({
  infra: ft(dse),
  keyPairs: ft(re()),
  tinkerBoxes: ft(_h)
}).passthrough();
pe({ count: Ce().gte(1).lte(15) }).passthrough();
pe({
  firstname: re().min(1),
  lastname: re().min(1),
  email: re().regex(
    /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/
  ).email(),
  password: re().min(8)
}).passthrough();
pe({ users: ft(b3) }).passthrough();
pe({
  firstname: re().nullable(),
  lastname: re().nullable(),
  email: re().nullable()
}).partial().passthrough();
const pse = pe({ tinkerBox: _h, keyMaterial: re() }).passthrough();
pe({ tinkerBoxes: ft(pse) }).passthrough();
const hse = pe({
  labName: re(),
  ec2Cost: Ce(),
  s3Cost: Ce(),
  efsCost: Ce(),
  totalCost: Ce()
}).passthrough();
pe({ clients: ft(hse) }).passthrough();
const vse = pe({
  name: re(),
  labName: re(),
  usage: re(),
  cost: Ce()
}).passthrough();
pe({ tinkerBoxes: ft(vse) }).passthrough();
pe({ tinkerboxes: ft(_h) }).passthrough();
pe({ tinkerBox: _h }).passthrough();
pe({ name: re() }).passthrough();
const mse = pe({
  id: Ce(),
  date: re(),
  tinkerBoxName: re(),
  lastLoginDate: re().nullable(),
  lastCommandDate: re().nullable(),
  lastCommand: re().nullable(),
  activeProcesses: mr(),
  status: Ni([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  tinkerBoxId: Ce(),
  autoStopTime: re().nullable()
}).passthrough();
pe({ allLastActivity: ft(mse) }).passthrough();
pe({ name: re().nullable() }).partial().passthrough();
const gse = pe({ id: re(), name: re(), isReadOnly: mr() }).passthrough(), yse = pe({
  id: Ce(),
  name: re(),
  fileSystems: ft(gse),
  keyPairId: Ce()
}).passthrough(), bse = pe({ labs: ft(yse) }).passthrough();
pe({
  name: re(),
  numTinkerBoxes: Ce().optional().default(1)
}).passthrough();
pe({ labId: Ce(), taskId: re() }).passthrough();
pe({ id: re(), labId: Ce(), logs: re() }).passthrough();
const _3 = pe({
  id: Ce(),
  labId: Ce(),
  userId: re(),
  role: Ni(["OWNER", "MEMBER"]),
  user: pe({
    firstname: re().nullable(),
    lastname: re().nullable(),
    email: re().nullable(),
    id: re()
  }).partial().passthrough()
}).passthrough();
pe({ labMember: _3.nullable() }).passthrough();
pe({ labMembers: ft(_3) }).passthrough();
const _se = pe({
  id: Ce(),
  labId: Ce(),
  userId: re(),
  role: Ni(["OWNER", "MEMBER"])
}).passthrough();
pe({ labMember: _se }).passthrough();
pe({ role: re() }).passthrough();
pe({ labMemberId: Ce(), role: re() }).passthrough();
pe({ success: mr() }).passthrough();
pe({
  client_secret: re().nullable(),
  status: re().nullable(),
  payment_status: re()
}).passthrough();
pe({
  name: re(),
  email: re().regex(
    /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/
  ).email(),
  message: re()
}).passthrough();
pe({
  path: re(),
  fsId: re().optional(),
  s3BucketId: Ce().optional()
}).passthrough();
const wse = pe({ success: mr() }).passthrough(), xse = pe({ url: re() }).passthrough(), Ese = pe({
  isFolder: mr(),
  bucketId: Ce().optional(),
  path: re()
}).passthrough(), Sse = pe({ contents: ft(Ese) }).passthrough(), Ose = pe({ files: ft(re()) }).passthrough();
pe({
  buckets: ft(
    pe({
      id: Ce().int().gte(-9007199254740991).lte(9007199254740991),
      bucket: re(),
      region: re(),
      prefix: re().nullish()
    }).passthrough()
  )
}).passthrough();
pe({
  fsId: re().optional(),
  source: pe({
    isFolder: mr(),
    bucketId: Ce().optional(),
    path: re()
  }).passthrough(),
  target: pe({
    isFolder: mr(),
    bucketId: Ce().optional(),
    path: re()
  }).passthrough()
}).passthrough();
const $se = pe({
  fileTransfers: ft(
    pe({
      id: Ce().int().gte(-9007199254740991).lte(9007199254740991),
      name: re(),
      userId: re(),
      progress: Ce(),
      user: ac()
    })
  )
}).passthrough(), Tse = pe({
  id: Ce(),
  name: re(),
  analysisSchemaId: Ce(),
  analysisSchemaVersion: Ce(),
  config: pe({}).partial().passthrough()
}).passthrough();
pe({ templates: ft(Tse) }).passthrough();
pe({
  name: re().min(1).max(255),
  analysisSchemaId: Ce().int().gte(-9007199254740991).lte(9007199254740991),
  analysisSchemaVersion: Ce().int().gt(0).lte(9007199254740991),
  triggerLocation: pe({
    bucketId: Ce().int().gt(0).lte(9007199254740991),
    folderPath: re().max(2048)
  }).passthrough(),
  config: ac()
}).passthrough();
pe({
  id: Ce(),
  name: re(),
  s3BucketId: Ce(),
  triggerFolder: re(),
  analysisSchemaId: Ce(),
  analysisSchemaVersion: Ce(),
  config: pe({}).partial().passthrough()
}).passthrough();
pe({
  id: Ce(),
  name: re(),
  schema: pe({}).partial().passthrough()
}).passthrough();
pe({
  id: Ce(),
  formId: Ce(),
  data: pe({}).partial().passthrough(),
  dateCreated: re()
}).passthrough();
pe({
  id: Ce(),
  name: re(),
  displayName: re(),
  hichip: re(),
  source: re(),
  bucket: re(),
  bedpeKey: re(),
  hicKey: re(),
  category: re()
}).passthrough();
pe({
  id: Ce(),
  sampleId: Ce(),
  cluster: re(),
  chr: re(),
  start: Ce(),
  end: Ce(),
  size: Ce(),
  genes: re()
}).passthrough();
pe({
  plotId: re(),
  status: Ni(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  outputBucket: re(),
  outputKey: re(),
  inputs: pe({}).partial().passthrough(),
  endedAt: re().nullable(),
  downloadUrl: re().nullable()
}).passthrough();
pe({
  sample: re(),
  range: re(),
  genomeBuild: Ni(["hg19", "hg38"]),
  color: re().regex(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
  inherent: re(),
  flank: Ce(),
  bedpe: re()
}).passthrough();
const w3 = pe({
  id: Ce(),
  title: re(),
  content: re(),
  createdAt: re(),
  updatedAt: re(),
  isActive: mr()
}).passthrough();
pe({ announcements: ft(w3) }).passthrough();
pe({ announcement: w3.nullable() }).passthrough();
const gr = {
  SuccessDto: fse,
  LabsResponse: bse,
  CreateDirectoryResponse: wse,
  PresignedUrlResponse: xse,
  ContentsResponse: Sse,
  DeleteFilesResponse: Ose,
  FileTransfersResponse: $se
};
class tm {
  constructor(t) {
    NC(this, "fetch"), this.fetch = t;
  }
  async download(t, n, r = null, i = !0) {
    let o = `/files/presigned/${encodeURIComponent(n)}/url?method=download`;
    t && (o += `&bucket=${t}`), r && (o += `&limit=${r}`);
    const a = (await this.fetch(
      o,
      { method: "GET" },
      gr.PresignedUrlResponse
    )).url;
    if (i) {
      const s = document.createElement("a");
      s.href = a, s.download = "", s.target = "_blank", s.click(), document.body.appendChild(s), s.click(), setTimeout(() => {
        document.body.removeChild(s);
      });
    }
    return a;
  }
  async upload(t, n, r) {
    const i = [];
    let o = `/files/presigned/${encodeURIComponent(r)}/url?method=upload`;
    n && (o = o += `&bucket=${n}`);
    const a = (await this.fetch(
      o,
      { method: "GET" },
      gr.PresignedUrlResponse
    )).url, s = new XMLHttpRequest();
    return s.open("PUT", a), s.addEventListener("error", () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }), s.onerror = () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }, s.upload.addEventListener("progress", (l) => {
      const u = l.loaded / l.total;
      for (const c of i)
        c.onProgress(u);
    }), s.upload.addEventListener("load", () => {
      for (const l of i)
        l.onComplete();
      s.upload.removeEventListener("progress", () => null);
    }), s.send(t), {
      subscribe(l) {
        i.push(l);
      }
    };
  }
}
class Pse {
  constructor(t) {
    NC(this, "fetch"), this.fetch = t;
  }
  async download(t, n, r = null, i = !0) {
    let o = `/files/presigned/${encodeURIComponent(n)}/url?method=download&fsId=${t}`;
    r && (o += `&limit=${r}`);
    const a = (await this.fetch(
      o,
      { method: "GET" },
      gr.PresignedUrlResponse
    )).url;
    if (i) {
      const s = document.createElement("a");
      s.href = a, s.download = "", s.target = "_blank", s.click(), document.body.appendChild(s), s.click(), setTimeout(() => {
        document.body.removeChild(s);
      });
    }
    return a;
  }
  async upload(t, n, r) {
    const i = [];
    let o = `/files/presigned/${encodeURIComponent(r)}/url?method=upload&fsId=${n}`;
    const a = (await this.fetch(
      o,
      { method: "GET" },
      gr.PresignedUrlResponse
    )).url, s = new XMLHttpRequest();
    return s.open("PUT", a), s.addEventListener("error", () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }), s.onerror = () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }, s.upload.addEventListener("progress", (l) => {
      const u = l.loaded / l.total;
      for (const c of i)
        c.onProgress(u);
    }), s.upload.addEventListener("load", () => {
      for (const l of i)
        l.onComplete();
      s.upload.removeEventListener("progress", () => null);
    }), s.send(t), {
      subscribe(l) {
        i.push(l);
      }
    };
  }
}
const v_ = ({ className: e = "" }) => /* @__PURE__ */ C.jsx(
  "svg",
  {
    className: `${e} block`,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.81 296.2",
    children: /* @__PURE__ */ C.jsx("g", { children: /* @__PURE__ */ C.jsx("path", { d: "M64.3,112.5C28.5,174.6-.4,225.4,0,225.6s34.7-9.2,76.2-20.7,76.3-21.1,77.4-21.3c1.8-.3,2.3,2.8,9.6,56,4.2,31,7.8,56.5,8,56.6s20.5-15.2,45.2-34.3c29.3-22.7,44.6-35.1,44.4-36.1C260.2,223.6,131.2.4,130.2,0,129.8-.1,100.1,50.5,64.3,112.5Z" }) })
  }
);
function Su(e) {
  Ee(() => {
    e && En.error(e.toString());
  }, [e]);
}
async function kse(e, t, n) {
  await e(
    "/files/directory",
    {
      method: "POST",
      body: JSON.stringify({ ...n, path: t })
    },
    gr.CreateDirectoryResponse
  );
}
const x3 = (e) => {
  const t = Oy({
    mutationKey: ["createFolder"],
    mutationFn: async (n) => kse(e, n.path, n)
  });
  return { ...t, createFolder: t.mutateAsync };
};
async function Dse(e, t, n) {
  let i = `/files/${encodeURIComponent(t)}?`;
  return n.fsId ? i += `&fsId=${n.fsId}` : n.s3BucketId && (i += `&bucket=${n.s3BucketId}`), await e(
    i,
    { method: "DELETE" },
    gr.DeleteFilesResponse
  );
}
const E3 = (e) => {
  const t = Oy({
    mutationKey: ["deleteFiles"],
    mutationFn: (n) => Dse(e, n.path, n)
  });
  return { ...t, deleteFiles: t.mutateAsync };
};
async function Ase(e) {
  return e(
    "/file-transfer",
    { method: "GET" },
    gr.FileTransfersResponse
  );
}
const S3 = (e, t) => rp({
  queryKey: ["file-transfers"],
  queryFn: () => Ase(t),
  refetchInterval: 500,
  enabled: e
}), Cse = async (e, t, n) => await n(
  `/files/?search=${t}&bucket=${e}`,
  {},
  gr.ContentsResponse
), Ise = async (e, t, n) => {
  let i = `/files/${encodeURIComponent(t || "")}?`;
  return e && (i += `bucket=${e}`), await n(i, { method: "GET" }, gr.ContentsResponse);
}, Nse = (e, t, n) => rp({
  queryKey: ["files", e, t],
  queryFn: async () => Ise(e, t, n),
  refetchInterval: 2e3
});
async function Rse(e, t, n, r) {
  return n(
    "/files/move",
    {
      method: "POST",
      body: JSON.stringify({ fsId: r, source: e, target: t })
    },
    gr.SuccessDto
  );
}
function O3(e) {
  const t = Oy({
    mutationKey: ["moveFiles"],
    mutationFn: ({
      src: n,
      dest: r,
      fsId: i
    }) => Rse(n, r, e, i)
  });
  return { ...t, moveFiles: t.mutateAsync };
}
function Mse({
  s3BucketId: e,
  fetch: t,
  selectionMode: n,
  onSelectionChange: r,
  path: i,
  setPath: o,
  readOnly: a = !1,
  selection: s = [],
  className: l = ""
}) {
  const {
    data: u,
    error: c,
    refetch: f
  } = Nse(e, i.join("/"), t), [d, p] = Ve(!1), { createFolder: h } = x3(t), { deleteFiles: v, error: m } = E3(t), { moveFiles: g, error: _ } = O3(t), { data: w, error: x } = S3(d, t);
  Ee(() => {
    w?.fileTransfers && w.fileTransfers.length > 0;
  }, [w]), Su(_), Su(x), jse(w), Ee(() => {
    c && En.error(c.message), m && En.error(m.message);
  }, [c, m]);
  const S = u?.contents ?? [], $ = i.length > 0 ? `/${i.join("/")}` : "/";
  return /* @__PURE__ */ C.jsx(
    IC,
    {
      className: l,
      selectionMode: n,
      filePathHomeDirectory: /* @__PURE__ */ C.jsx(v_, { className: "inline w-3 h-3" }),
      files: S,
      selection: s,
      readOnly: a,
      onSelectionChange: r,
      onDownload: async (A) => {
        await new tm(t).download(e, A.path, null, !0), f();
      },
      onMoveUpAFolder: async (A) => {
        if (!A) {
          En.error("Already at root folder");
          return;
        }
        const { path: E, parent: y } = A;
        await g({
          src: E,
          dest: { isFolder: !0, path: y, bucketId: E.bucketId }
        }), p(!0), await f();
      },
      path: i,
      onNavigate: (A) => {
        o(A);
      },
      onMove: async (A, E) => {
        if (!E.isFolder) {
          En.error("Target must be a folder");
          return;
        }
        await g({ src: A, dest: E }), await f(), p(!0);
      },
      onSearch: async (A) => (await Cse(e, A, t)).contents,
      onUpload: function(A) {
        const E = new tm(t), y = `${$}/${A[0].name}`;
        return E.upload(A[0], e, y);
      },
      onDelete: async (A) => {
        await v({ s3BucketId: e, path: A[0].path }), await f();
      },
      onCreateFolder: async (A) => {
        await h({ s3BucketId: e, path: A }), await f();
      },
      onPreview: async (A) => {
        await new tm(t).download(e, A.path), f();
      }
    }
  );
}
const jse = (e) => {
  Ee(() => {
    if (e?.fileTransfers.length)
      for (const t of e.fileTransfers)
        En(t.name, {
          progress: t.progress,
          toastId: t.id
        });
  }, [e]);
};
function hue(e) {
  return /* @__PURE__ */ C.jsx(vO, { client: e.queryClient, children: /* @__PURE__ */ C.jsx(Mse, { ...e }) });
}
const Fse = async (e, t, n) => await n(
  `/files/?search=${t}&fsId=${e}`,
  {},
  gr.ContentsResponse
), zse = async (e, t, n) => {
  let i = `/files/${encodeURIComponent(t || "")}?fsId=${e}`;
  return await n(i, { method: "GET" }, gr.ContentsResponse);
}, Lse = (e, t, n) => rp({
  queryKey: ["files", e, t],
  queryFn: async () => zse(e, t, n),
  refetchInterval: 2e3
});
function Vse({
  fsId: e,
  fetch: t,
  selectionMode: n,
  onSelectionChange: r,
  path: i,
  setPath: o,
  readOnly: a = !1,
  selection: s = [],
  className: l = ""
}) {
  const u = Te(() => new Pse(t), [t]), {
    data: c,
    error: f,
    refetch: d
  } = Lse(e, i.join("/"), t), [p, h] = Ve(!1), { createFolder: v, error: m } = x3(t), { deleteFiles: g, error: _ } = E3(t), { moveFiles: w, error: x } = O3(t), { data: S, error: $ } = S3(p, t);
  Ee(() => {
    S?.fileTransfers && S.fileTransfers.length > 0;
  }, [S]), Su(x), Su(m), Su($), Kse(S), Ee(() => {
    f && En.error(f.message), _ && En.error(_.message);
  }, [f, _]);
  const A = c?.contents ?? [], E = i.length > 0 ? `/${i.join("/")}` : "/";
  return /* @__PURE__ */ C.jsx(
    IC,
    {
      className: l,
      selectionMode: n,
      filePathHomeDirectory: /* @__PURE__ */ C.jsx(v_, { className: "inline w-3 h-3" }),
      files: A,
      selection: s,
      readOnly: a,
      onSelectionChange: r,
      onDownload: async (y) => {
        await u.download(e, y.path, null, !0), d();
      },
      onMoveUpAFolder: async (y) => {
        if (!y) {
          En.error("Already at root folder");
          return;
        }
        const { path: b, parent: O } = y;
        await w({
          src: b,
          dest: { isFolder: !0, path: O },
          fsId: e
        }), h(!0), await d();
      },
      path: i,
      onNavigate: (y) => {
        o(y);
      },
      onMove: async (y, b) => {
        if (!b.isFolder) {
          En.error("Target must be a folder");
          return;
        }
        await w({ src: y, dest: b, fsId: e }), await d(), h(!0);
      },
      onSearch: async (y) => (await Fse(e, y, t)).contents,
      onUpload: function(y) {
        const b = `${E}/${y[0].name}`;
        return u.upload(y[0], e, b);
      },
      onDelete: async (y) => {
        await g({ fsId: e, path: y[0].path }), await d();
      },
      onCreateFolder: async (y, b) => {
        await v({ fsId: e, path: [...b, y].join("/") }), await d();
      },
      onPreview: async (y) => {
        await u.download(e, y.path), d();
      }
    }
  );
}
const Kse = (e) => {
  Ee(() => {
    if (e?.fileTransfers.length)
      for (const t of e.fileTransfers)
        En(t.name, {
          progress: t.progress,
          toastId: t.id
        });
  }, [e]);
};
function $3(e) {
  return /* @__PURE__ */ C.jsx(vO, { client: e.queryClient, children: /* @__PURE__ */ C.jsx(Vse, { ...e }) });
}
async function Bse(e) {
  return e("/labs", { method: "get" }, gr.LabsResponse);
}
const Use = (e) => rp({
  queryKey: ["labs"],
  retry: !1,
  queryFn: async () => await Bse(e)
}), T3 = He(
  {}
);
function qse(e) {
  return /* @__PURE__ */ C.jsx(T3.Provider, { value: e.value, children: e.children });
}
const m_ = () => Me(T3);
function Hse({ items: e }) {
  const { activeTab: t, setActiveTab: n } = m_();
  return /* @__PURE__ */ C.jsx(
    "div",
    {
      className: "flex w-full bg-black overflow-x-scroll self-baseline tabs-list overflow-y-hidden",
      children: e.map((r) => /* @__PURE__ */ C.jsx(
        Zse,
        {
          label: r.label,
          active: t === r.value,
          value: r.value,
          onClick: (i) => {
            n(i);
          }
        },
        `tab-${r.value}`
      ))
    }
  );
}
const Wse = ui(
  [
    "last:border-none",
    "border-r",
    "flex-shrink-0",
    "px-4",
    "pb-4",
    "hover:bg-gray-200",
    "whitespace-nowrap",
    "overflow-hidden",
    "text-ellipsis",
    "self-baseline"
  ],
  {
    variants: {
      active: {
        false: "bg-black text-white",
        true: "bg-white text-black"
      }
    }
  }
);
function Zse(e) {
  return /* @__PURE__ */ C.jsx(
    "button",
    {
      onClick: () => e.onClick(e.value),
      className: Wse({ active: e.active }),
      children: e.label
    }
  );
}
function Gse({
  children: e,
  className: t,
  value: n
}) {
  const { activeTab: r, contentRef: i } = m_();
  return r !== n || !i ? null : va(
    /* @__PURE__ */ C.jsx("div", { className: `flex flex-col flex-grow h-full w-full ${t || ""} overflow-hidden`, children: e }),
    i
  );
}
const wy = (({
  children: e,
  items: t,
  onChange: n,
  activeTab: r
}) => {
  const [i, o] = Ve(null);
  return /* @__PURE__ */ C.jsx(
    qse,
    {
      value: {
        activeTab: r,
        setActiveTab: (a) => {
          n?.(a);
        },
        contentRef: i
      },
      children: /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col tabs h-full overflow-hidden", children: [
        /* @__PURE__ */ C.jsx(Hse, { items: t }),
        /* @__PURE__ */ C.jsx(
          "div",
          {
            className: "flex flex-col flex-grow-[2] h-full w-full overflow-hidden",
            ref: o,
            children: e
          }
        )
      ] })
    }
  );
});
wy.Tab = Gse;
function vue(e) {
  return /* @__PURE__ */ C.jsx(
    Yse,
    {
      ...e,
      fsId: e.fsId,
      path: e.path,
      setPath: e.setPath
    }
  );
}
function Yse(e) {
  const t = Use(e.fetch), n = t.data?.labs, r = n?.map((a) => ({
    label: a.name,
    value: a.id
  })) ?? [], i = n?.find((a) => a.fileSystems.some((s) => s.id === e.fsId)) ?? (e.fsId ? void 0 : n?.[0]);
  if (Ee(() => {
    if (!n?.length || e.fsId)
      return;
    const a = n[0]?.fileSystems[0]?.id;
    a && e.setFsId(a);
  }, [n, e.fsId, e.setFsId]), t.error)
    return /* @__PURE__ */ C.jsxs("div", { children: [
      "Error loading labs: ",
      t.error.message
    ] });
  if (!n) return /* @__PURE__ */ C.jsx("div", { children: "Loading labs..." });
  if (!i)
    return null;
  const o = i.fileSystems.find((a) => a.id === e.fsId);
  return /* @__PURE__ */ C.jsx(
    wy,
    {
      activeTab: i.id,
      items: r,
      onChange: (a) => {
        e.setPath([]);
        const l = n.find((u) => u.id === a)?.fileSystems[0]?.id;
        e.setFsId(l ?? "");
      },
      className: "mb-4",
      children: n.map((a) => /* @__PURE__ */ C.jsx(wy.Tab, { value: a.id, children: /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col h-full overflow-hidden", children: [
        /* @__PURE__ */ C.jsx("div", { className: "flex-shrink-0 border-b border-neutral-200 bg-white py-1", children: a.fileSystems.map((s) => /* @__PURE__ */ C.jsxs(
          "button",
          {
            type: "button",
            className: `relative flex w-full select-none items-center gap-2 p-1 text-left hover:bg-neutral-200 ${e.fsId === s.id ? "text-orange-2" : "text-neutral-800"}`,
            onClick: () => {
              e.fsId !== s.id && (e.setPath([]), e.setFsId(s.id));
            },
            children: [
              /* @__PURE__ */ C.jsx(sh, { size: 18, className: "flex-shrink-0 pr-1" }),
              /* @__PURE__ */ C.jsx("span", { className: "truncate", children: s.name })
            ]
          },
          s.id
        )) }),
        e.fsId && /* @__PURE__ */ C.jsx("div", { className: "flex-grow p-2 bg-white", children: /* @__PURE__ */ C.jsx(
          $3,
          {
            queryClient: e.queryClient,
            fsId: e.fsId,
            fetch,
            className: "h-full overflow-scroll",
            readOnly: o?.isReadOnly ?? !1,
            path: e.path,
            setPath: e.setPath,
            selection: e.selection ?? [],
            selectionMode: e.pathType,
            onSelectionChange: (s) => {
              e.onSelectionChange(s, {
                name: a.name,
                id: a.id
              });
            }
          }
        ) })
      ] }) }, a.id))
    }
  );
}
function mue(e) {
  const t = e.fileSystems.find((n) => n.id === e.fsId);
  return /* @__PURE__ */ C.jsxs("div", { children: [
    /* @__PURE__ */ C.jsxs(
      "div",
      {
        className: Qn(
          "flex-shrink-0 border-b border-neutral-200 bg-white py-1",
          e.className
        ),
        children: [
          e.fileSystems.map((n) => /* @__PURE__ */ C.jsxs(
            "button",
            {
              type: "button",
              className: `relative flex w-full select-none items-center gap-2 p-1 text-left hover:bg-neutral-200 ${e.fsId === n.id ? "text-orange-2" : "text-neutral-800"}`,
              onClick: () => {
                e.fsId !== n.id && (e.setPath([]), e.setFsId(n.id));
              },
              children: [
                " ",
                /* @__PURE__ */ C.jsx(sh, { size: 18, className: "flex-shrink-0 pr-1" }),
                " ",
                /* @__PURE__ */ C.jsx("span", { className: "truncate", children: n.name }),
                " "
              ]
            },
            n.id
          )),
          " "
        ]
      }
    ),
    e.fsId && /* @__PURE__ */ C.jsxs("div", { className: "flex-grow p-2 bg-white", children: [
      " ",
      /* @__PURE__ */ C.jsx(
        $3,
        {
          queryClient: e.queryClient,
          fsId: e.fsId,
          fetch,
          className: "h-full overflow-scroll",
          readOnly: t?.isReadOnly ?? !1,
          path: e.path,
          setPath: e.setPath,
          selection: e.selection ?? [],
          selectionMode: e.pathType,
          onSelectionChange: (n) => {
            e.onSelectionChange(n, {
              name: e.lab.name,
              id: e.lab.id
            });
          }
        }
      ),
      " "
    ] })
  ] });
}
var Of, Qse = new Uint8Array(16);
function Jse() {
  if (!Of && (Of = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Of))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Of(Qse);
}
const Xse = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function ele(e) {
  return typeof e == "string" && Xse.test(e);
}
var _n = [];
for (var nm = 0; nm < 256; ++nm)
  _n.push((nm + 256).toString(16).substr(1));
function tle(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (_n[e[t + 0]] + _n[e[t + 1]] + _n[e[t + 2]] + _n[e[t + 3]] + "-" + _n[e[t + 4]] + _n[e[t + 5]] + "-" + _n[e[t + 6]] + _n[e[t + 7]] + "-" + _n[e[t + 8]] + _n[e[t + 9]] + "-" + _n[e[t + 10]] + _n[e[t + 11]] + _n[e[t + 12]] + _n[e[t + 13]] + _n[e[t + 14]] + _n[e[t + 15]]).toLowerCase();
  if (!ele(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
function nle(e, t, n) {
  e = e || {};
  var r = e.random || (e.rng || Jse)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, tle(r);
}
const rle = (e) => {
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const r = e.item(n);
    r && t.push(r);
  }
  return t;
}, gue = ({
  children: e,
  onChange: t,
  className: n
}) => {
  const r = _e(nle());
  return /* @__PURE__ */ C.jsxs("div", { className: `${n} cursor-pointer`, children: [
    /* @__PURE__ */ C.jsx(
      "label",
      {
        htmlFor: r.current,
        onClick: (i) => i.stopPropagation(),
        className: "cursor-pointer",
        onKeyDown: (i) => {
          i.key === "Enter" && i.stopPropagation();
        },
        children: e
      }
    ),
    /* @__PURE__ */ C.jsx(
      "input",
      {
        onClick: (i) => i.stopPropagation(),
        onChange: (i) => {
          t(i.target.files ? rle(i.target.files) : []);
        },
        className: "absolute w-0 h-0",
        type: "file",
        id: r.current
      }
    )
  ] });
}, yue = ({ name: e, ...t }) => {
  const [n, r] = e6(e), { capture: i, ...o } = t;
  return /* @__PURE__ */ C.jsxs("div", { children: [
    /* @__PURE__ */ C.jsx(Sd, { ...o, ...n, placeholder: t.placeholder || e }),
    r.touched && r.error && /* @__PURE__ */ C.jsx(qV, { children: r.error })
  ] });
};
function bue({ area: e, children: t, className: n }) {
  return /* @__PURE__ */ C.jsx("div", { className: `${n || ""}`, style: { gridArea: e }, children: t });
}
var Qf = { exports: {} }, ile = Qf.exports, sO;
function ole() {
  return sO || (sO = 1, (function(e, t) {
    (function(r, i) {
      e.exports = i(H);
    })(ile, (n) => (
      /******/
      (() => {
        var r = {
          /***/
          "./node_modules/css-mediaquery/index.js": (
            /*!**********************************************!*\
              !*** ./node_modules/css-mediaquery/index.js ***!
              \**********************************************/
            /***/
            ((s, l) => {
              l.match = h, l.parse = v;
              var u = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, c = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, f = /^(?:(min|max)-)?(.+)/, d = /(em|rem|px|cm|mm|in|pt|pc)?$/, p = /(dpi|dpcm|dppx)?$/;
              function h(w, x) {
                return v(w).some(function(S) {
                  var $ = S.inverse, A = S.type === "all" || x.type === S.type;
                  if (A && $ || !(A || $))
                    return !1;
                  var E = S.expressions.every(function(y) {
                    var b = y.feature, O = y.modifier, k = y.value, I = x[b];
                    if (!I)
                      return !1;
                    switch (b) {
                      case "orientation":
                      case "scan":
                        return I.toLowerCase() === k.toLowerCase();
                      case "width":
                      case "height":
                      case "device-width":
                      case "device-height":
                        k = _(k), I = _(I);
                        break;
                      case "resolution":
                        k = g(k), I = g(I);
                        break;
                      case "aspect-ratio":
                      case "device-aspect-ratio":
                      case /* Deprecated */
                      "device-pixel-ratio":
                        k = m(k), I = m(I);
                        break;
                      case "grid":
                      case "color":
                      case "color-index":
                      case "monochrome":
                        k = parseInt(k, 10) || 1, I = parseInt(I, 10) || 0;
                        break;
                    }
                    switch (O) {
                      case "min":
                        return I >= k;
                      case "max":
                        return I <= k;
                      default:
                        return I === k;
                    }
                  });
                  return E && !$ || !E && $;
                });
              }
              function v(w) {
                return w.split(",").map(function(x) {
                  x = x.trim();
                  var S = x.match(u), $ = S[1], A = S[2], E = S[3] || "", y = {};
                  return y.inverse = !!$ && $.toLowerCase() === "not", y.type = A ? A.toLowerCase() : "all", E = E.match(/\([^\)]+\)/g) || [], y.expressions = E.map(function(b) {
                    var O = b.match(c), k = O[1].toLowerCase().match(f);
                    return {
                      modifier: k[1],
                      feature: k[2],
                      value: O[2]
                    };
                  }), y;
                });
              }
              function m(w) {
                var x = Number(w), S;
                return x || (S = w.match(/^(\d+)\s*\/\s*(\d+)$/), x = S[1] / S[2]), x;
              }
              function g(w) {
                var x = parseFloat(w), S = String(w).match(p)[1];
                switch (S) {
                  case "dpcm":
                    return x / 2.54;
                  case "dppx":
                    return x * 96;
                  default:
                    return x;
                }
              }
              function _(w) {
                var x = parseFloat(w), S = String(w).match(d)[1];
                switch (S) {
                  case "em":
                    return x * 16;
                  case "rem":
                    return x * 16;
                  case "cm":
                    return x * 96 / 2.54;
                  case "mm":
                    return x * 96 / 2.54 / 10;
                  case "in":
                    return x * 96;
                  case "pt":
                    return x * 72;
                  case "pc":
                    return x * 72 / 12;
                  default:
                    return x;
                }
              }
            })
          ),
          /***/
          "./node_modules/hyphenate-style-name/index.js": (
            /*!****************************************************!*\
              !*** ./node_modules/hyphenate-style-name/index.js ***!
              \****************************************************/
            /***/
            ((s, l, u) => {
              u.r(l), u.d(l, {
                /* harmony export */
                default: () => v
                /* harmony export */
              });
              var c = /[A-Z]/g, f = /^ms-/, d = {};
              function p(m) {
                return "-" + m.toLowerCase();
              }
              function h(m) {
                if (d.hasOwnProperty(m))
                  return d[m];
                var g = m.replace(c, p);
                return d[m] = f.test(g) ? "-" + g : g;
              }
              const v = h;
            })
          ),
          /***/
          "./node_modules/matchmediaquery/index.js": (
            /*!***********************************************!*\
              !*** ./node_modules/matchmediaquery/index.js ***!
              \***********************************************/
            /***/
            ((s, l, u) => {
              var c = u(
                /*! css-mediaquery */
                "./node_modules/css-mediaquery/index.js"
              ).match, f = typeof window < "u" ? window.matchMedia : null;
              function d(h, v, m) {
                var g = this;
                if (f && !m) {
                  var _ = f.call(window, h);
                  this.matches = _.matches, this.media = _.media, _.addListener(S);
                } else
                  this.matches = c(h, v), this.media = h;
                this.addListener = w, this.removeListener = x, this.dispose = $;
                function w(A) {
                  _ && _.addListener(A);
                }
                function x(A) {
                  _ && _.removeListener(A);
                }
                function S(A) {
                  g.matches = A.matches, g.media = A.media;
                }
                function $() {
                  _ && _.removeListener(S);
                }
              }
              function p(h, v, m) {
                return new d(h, v, m);
              }
              s.exports = p;
            })
          ),
          /***/
          "./node_modules/object-assign/index.js": (
            /*!*********************************************!*\
              !*** ./node_modules/object-assign/index.js ***!
              \*********************************************/
            /***/
            ((s) => {
              /*
              object-assign
              (c) Sindre Sorhus
              @license MIT
              */
              var l = Object.getOwnPropertySymbols, u = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
              function f(p) {
                if (p == null)
                  throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(p);
              }
              function d() {
                try {
                  if (!Object.assign)
                    return !1;
                  var p = new String("abc");
                  if (p[5] = "de", Object.getOwnPropertyNames(p)[0] === "5")
                    return !1;
                  for (var h = {}, v = 0; v < 10; v++)
                    h["_" + String.fromCharCode(v)] = v;
                  var m = Object.getOwnPropertyNames(h).map(function(_) {
                    return h[_];
                  });
                  if (m.join("") !== "0123456789")
                    return !1;
                  var g = {};
                  return "abcdefghijklmnopqrst".split("").forEach(function(_) {
                    g[_] = _;
                  }), Object.keys(Object.assign({}, g)).join("") === "abcdefghijklmnopqrst";
                } catch {
                  return !1;
                }
              }
              s.exports = d() ? Object.assign : function(p, h) {
                for (var v, m = f(p), g, _ = 1; _ < arguments.length; _++) {
                  v = Object(arguments[_]);
                  for (var w in v)
                    u.call(v, w) && (m[w] = v[w]);
                  if (l) {
                    g = l(v);
                    for (var x = 0; x < g.length; x++)
                      c.call(v, g[x]) && (m[g[x]] = v[g[x]]);
                  }
                }
                return m;
              };
            })
          ),
          /***/
          "./node_modules/prop-types/checkPropTypes.js": (
            /*!***************************************************!*\
              !*** ./node_modules/prop-types/checkPropTypes.js ***!
              \***************************************************/
            /***/
            ((s, l, u) => {
              var c = function() {
              };
              {
                var f = u(
                  /*! ./lib/ReactPropTypesSecret */
                  "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
                ), d = {}, p = u(
                  /*! ./lib/has */
                  "./node_modules/prop-types/lib/has.js"
                );
                c = function(v) {
                  var m = "Warning: " + v;
                  typeof console < "u" && console.error(m);
                  try {
                    throw new Error(m);
                  } catch {
                  }
                };
              }
              function h(v, m, g, _, w) {
                for (var x in v)
                  if (p(v, x)) {
                    var S;
                    try {
                      if (typeof v[x] != "function") {
                        var $ = Error(
                          (_ || "React class") + ": " + g + " type `" + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[x] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                        );
                        throw $.name = "Invariant Violation", $;
                      }
                      S = v[x](m, x, _, g, null, f);
                    } catch (E) {
                      S = E;
                    }
                    if (S && !(S instanceof Error) && c(
                      (_ || "React class") + ": type specification of " + g + " `" + x + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof S + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                    ), S instanceof Error && !(S.message in d)) {
                      d[S.message] = !0;
                      var A = w ? w() : "";
                      c(
                        "Failed " + g + " type: " + S.message + (A ?? "")
                      );
                    }
                  }
              }
              h.resetWarningCache = function() {
                d = {};
              }, s.exports = h;
            })
          ),
          /***/
          "./node_modules/prop-types/factoryWithTypeCheckers.js": (
            /*!************************************************************!*\
              !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
              \************************************************************/
            /***/
            ((s, l, u) => {
              var c = u(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), f = u(
                /*! object-assign */
                "./node_modules/object-assign/index.js"
              ), d = u(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), p = u(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              ), h = u(
                /*! ./checkPropTypes */
                "./node_modules/prop-types/checkPropTypes.js"
              ), v = function() {
              };
              v = function(g) {
                var _ = "Warning: " + g;
                typeof console < "u" && console.error(_);
                try {
                  throw new Error(_);
                } catch {
                }
              };
              function m() {
                return null;
              }
              s.exports = function(g, _) {
                var w = typeof Symbol == "function" && Symbol.iterator, x = "@@iterator";
                function S(P) {
                  var R = P && (w && P[w] || P[x]);
                  if (typeof R == "function")
                    return R;
                }
                var $ = "<<anonymous>>", A = {
                  array: O("array"),
                  bigint: O("bigint"),
                  bool: O("boolean"),
                  func: O("function"),
                  number: O("number"),
                  object: O("object"),
                  string: O("string"),
                  symbol: O("symbol"),
                  any: k(),
                  arrayOf: I,
                  element: T(),
                  elementType: V(),
                  instanceOf: z,
                  node: N(),
                  objectOf: q,
                  oneOf: B,
                  oneOfType: M,
                  shape: ee,
                  exact: Q
                };
                function E(P, R) {
                  return P === R ? P !== 0 || 1 / P === 1 / R : P !== P && R !== R;
                }
                function y(P, R) {
                  this.message = P, this.data = R && typeof R == "object" ? R : {}, this.stack = "";
                }
                y.prototype = Error.prototype;
                function b(P) {
                  var R = {}, j = 0;
                  function W(le, te, fe, De, he, Oe, de) {
                    if (De = De || $, Oe = Oe || fe, de !== d) {
                      if (_) {
                        var Ue = new Error(
                          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                        );
                        throw Ue.name = "Invariant Violation", Ue;
                      } else if (typeof console < "u") {
                        var tt = De + ":" + fe;
                        !R[tt] && // Avoid spamming the console because they are often not actionable except for lib authors
                        j < 3 && (v(
                          "You are manually calling a React.PropTypes validation function for the `" + Oe + "` prop on `" + De + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                        ), R[tt] = !0, j++);
                      }
                    }
                    return te[fe] == null ? le ? te[fe] === null ? new y("The " + he + " `" + Oe + "` is marked as required " + ("in `" + De + "`, but its value is `null`.")) : new y("The " + he + " `" + Oe + "` is marked as required in " + ("`" + De + "`, but its value is `undefined`.")) : null : P(te, fe, De, he, Oe);
                  }
                  var J = W.bind(null, !1);
                  return J.isRequired = W.bind(null, !0), J;
                }
                function O(P) {
                  function R(j, W, J, le, te, fe) {
                    var De = j[W], he = se(De);
                    if (he !== P) {
                      var Oe = ce(De);
                      return new y(
                        "Invalid " + le + " `" + te + "` of type " + ("`" + Oe + "` supplied to `" + J + "`, expected ") + ("`" + P + "`."),
                        { expectedType: P }
                      );
                    }
                    return null;
                  }
                  return b(R);
                }
                function k() {
                  return b(m);
                }
                function I(P) {
                  function R(j, W, J, le, te) {
                    if (typeof P != "function")
                      return new y("Property `" + te + "` of component `" + J + "` has invalid PropType notation inside arrayOf.");
                    var fe = j[W];
                    if (!Array.isArray(fe)) {
                      var De = se(fe);
                      return new y("Invalid " + le + " `" + te + "` of type " + ("`" + De + "` supplied to `" + J + "`, expected an array."));
                    }
                    for (var he = 0; he < fe.length; he++) {
                      var Oe = P(fe, he, J, le, te + "[" + he + "]", d);
                      if (Oe instanceof Error)
                        return Oe;
                    }
                    return null;
                  }
                  return b(R);
                }
                function T() {
                  function P(R, j, W, J, le) {
                    var te = R[j];
                    if (!g(te)) {
                      var fe = se(te);
                      return new y("Invalid " + J + " `" + le + "` of type " + ("`" + fe + "` supplied to `" + W + "`, expected a single ReactElement."));
                    }
                    return null;
                  }
                  return b(P);
                }
                function V() {
                  function P(R, j, W, J, le) {
                    var te = R[j];
                    if (!c.isValidElementType(te)) {
                      var fe = se(te);
                      return new y("Invalid " + J + " `" + le + "` of type " + ("`" + fe + "` supplied to `" + W + "`, expected a single ReactElement type."));
                    }
                    return null;
                  }
                  return b(P);
                }
                function z(P) {
                  function R(j, W, J, le, te) {
                    if (!(j[W] instanceof P)) {
                      var fe = P.name || $, De = D(j[W]);
                      return new y("Invalid " + le + " `" + te + "` of type " + ("`" + De + "` supplied to `" + J + "`, expected ") + ("instance of `" + fe + "`."));
                    }
                    return null;
                  }
                  return b(R);
                }
                function B(P) {
                  if (!Array.isArray(P))
                    return arguments.length > 1 ? v(
                      "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                    ) : v("Invalid argument supplied to oneOf, expected an array."), m;
                  function R(j, W, J, le, te) {
                    for (var fe = j[W], De = 0; De < P.length; De++)
                      if (E(fe, P[De]))
                        return null;
                    var he = JSON.stringify(P, function(de, Ue) {
                      var tt = ce(Ue);
                      return tt === "symbol" ? String(Ue) : Ue;
                    });
                    return new y("Invalid " + le + " `" + te + "` of value `" + String(fe) + "` " + ("supplied to `" + J + "`, expected one of " + he + "."));
                  }
                  return b(R);
                }
                function q(P) {
                  function R(j, W, J, le, te) {
                    if (typeof P != "function")
                      return new y("Property `" + te + "` of component `" + J + "` has invalid PropType notation inside objectOf.");
                    var fe = j[W], De = se(fe);
                    if (De !== "object")
                      return new y("Invalid " + le + " `" + te + "` of type " + ("`" + De + "` supplied to `" + J + "`, expected an object."));
                    for (var he in fe)
                      if (p(fe, he)) {
                        var Oe = P(fe, he, J, le, te + "." + he, d);
                        if (Oe instanceof Error)
                          return Oe;
                      }
                    return null;
                  }
                  return b(R);
                }
                function M(P) {
                  if (!Array.isArray(P))
                    return v("Invalid argument supplied to oneOfType, expected an instance of array."), m;
                  for (var R = 0; R < P.length; R++) {
                    var j = P[R];
                    if (typeof j != "function")
                      return v(
                        "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + X(j) + " at index " + R + "."
                      ), m;
                  }
                  function W(J, le, te, fe, De) {
                    for (var he = [], Oe = 0; Oe < P.length; Oe++) {
                      var de = P[Oe], Ue = de(J, le, te, fe, De, d);
                      if (Ue == null)
                        return null;
                      Ue.data && p(Ue.data, "expectedType") && he.push(Ue.data.expectedType);
                    }
                    var tt = he.length > 0 ? ", expected one of type [" + he.join(", ") + "]" : "";
                    return new y("Invalid " + fe + " `" + De + "` supplied to " + ("`" + te + "`" + tt + "."));
                  }
                  return b(W);
                }
                function N() {
                  function P(R, j, W, J, le) {
                    return K(R[j]) ? null : new y("Invalid " + J + " `" + le + "` supplied to " + ("`" + W + "`, expected a ReactNode."));
                  }
                  return b(P);
                }
                function Y(P, R, j, W, J) {
                  return new y(
                    (P || "React class") + ": " + R + " type `" + j + "." + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + J + "`."
                  );
                }
                function ee(P) {
                  function R(j, W, J, le, te) {
                    var fe = j[W], De = se(fe);
                    if (De !== "object")
                      return new y("Invalid " + le + " `" + te + "` of type `" + De + "` " + ("supplied to `" + J + "`, expected `object`."));
                    for (var he in P) {
                      var Oe = P[he];
                      if (typeof Oe != "function")
                        return Y(J, le, te, he, ce(Oe));
                      var de = Oe(fe, he, J, le, te + "." + he, d);
                      if (de)
                        return de;
                    }
                    return null;
                  }
                  return b(R);
                }
                function Q(P) {
                  function R(j, W, J, le, te) {
                    var fe = j[W], De = se(fe);
                    if (De !== "object")
                      return new y("Invalid " + le + " `" + te + "` of type `" + De + "` " + ("supplied to `" + J + "`, expected `object`."));
                    var he = f({}, j[W], P);
                    for (var Oe in he) {
                      var de = P[Oe];
                      if (p(P, Oe) && typeof de != "function")
                        return Y(J, le, te, Oe, ce(de));
                      if (!de)
                        return new y(
                          "Invalid " + le + " `" + te + "` key `" + Oe + "` supplied to `" + J + "`.\nBad object: " + JSON.stringify(j[W], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(P), null, "  ")
                        );
                      var Ue = de(fe, Oe, J, le, te + "." + Oe, d);
                      if (Ue)
                        return Ue;
                    }
                    return null;
                  }
                  return b(R);
                }
                function K(P) {
                  switch (typeof P) {
                    case "number":
                    case "string":
                    case "undefined":
                      return !0;
                    case "boolean":
                      return !P;
                    case "object":
                      if (Array.isArray(P))
                        return P.every(K);
                      if (P === null || g(P))
                        return !0;
                      var R = S(P);
                      if (R) {
                        var j = R.call(P), W;
                        if (R !== P.entries) {
                          for (; !(W = j.next()).done; )
                            if (!K(W.value))
                              return !1;
                        } else
                          for (; !(W = j.next()).done; ) {
                            var J = W.value;
                            if (J && !K(J[1]))
                              return !1;
                          }
                      } else
                        return !1;
                      return !0;
                    default:
                      return !1;
                  }
                }
                function ne(P, R) {
                  return P === "symbol" ? !0 : R ? R["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && R instanceof Symbol : !1;
                }
                function se(P) {
                  var R = typeof P;
                  return Array.isArray(P) ? "array" : P instanceof RegExp ? "object" : ne(R, P) ? "symbol" : R;
                }
                function ce(P) {
                  if (typeof P > "u" || P === null)
                    return "" + P;
                  var R = se(P);
                  if (R === "object") {
                    if (P instanceof Date)
                      return "date";
                    if (P instanceof RegExp)
                      return "regexp";
                  }
                  return R;
                }
                function X(P) {
                  var R = ce(P);
                  switch (R) {
                    case "array":
                    case "object":
                      return "an " + R;
                    case "boolean":
                    case "date":
                    case "regexp":
                      return "a " + R;
                    default:
                      return R;
                  }
                }
                function D(P) {
                  return !P.constructor || !P.constructor.name ? $ : P.constructor.name;
                }
                return A.checkPropTypes = h, A.resetWarningCache = h.resetWarningCache, A.PropTypes = A, A;
              };
            })
          ),
          /***/
          "./node_modules/prop-types/index.js": (
            /*!******************************************!*\
              !*** ./node_modules/prop-types/index.js ***!
              \******************************************/
            /***/
            ((s, l, u) => {
              {
                var c = u(
                  /*! react-is */
                  "./node_modules/react-is/index.js"
                ), f = !0;
                s.exports = u(
                  /*! ./factoryWithTypeCheckers */
                  "./node_modules/prop-types/factoryWithTypeCheckers.js"
                )(c.isElement, f);
              }
            })
          ),
          /***/
          "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
            /*!*************************************************************!*\
              !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
              \*************************************************************/
            /***/
            ((s) => {
              var l = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
              s.exports = l;
            })
          ),
          /***/
          "./node_modules/prop-types/lib/has.js": (
            /*!********************************************!*\
              !*** ./node_modules/prop-types/lib/has.js ***!
              \********************************************/
            /***/
            ((s) => {
              s.exports = Function.call.bind(Object.prototype.hasOwnProperty);
            })
          ),
          /***/
          "./node_modules/react-is/cjs/react-is.development.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/react-is/cjs/react-is.development.js ***!
              \***********************************************************/
            /***/
            ((s, l) => {
              /** @license React v16.13.1
               * react-is.development.js
               *
               * Copyright (c) Facebook, Inc. and its affiliates.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */
              (function() {
                var u = typeof Symbol == "function" && Symbol.for, c = u ? Symbol.for("react.element") : 60103, f = u ? Symbol.for("react.portal") : 60106, d = u ? Symbol.for("react.fragment") : 60107, p = u ? Symbol.for("react.strict_mode") : 60108, h = u ? Symbol.for("react.profiler") : 60114, v = u ? Symbol.for("react.provider") : 60109, m = u ? Symbol.for("react.context") : 60110, g = u ? Symbol.for("react.async_mode") : 60111, _ = u ? Symbol.for("react.concurrent_mode") : 60111, w = u ? Symbol.for("react.forward_ref") : 60112, x = u ? Symbol.for("react.suspense") : 60113, S = u ? Symbol.for("react.suspense_list") : 60120, $ = u ? Symbol.for("react.memo") : 60115, A = u ? Symbol.for("react.lazy") : 60116, E = u ? Symbol.for("react.block") : 60121, y = u ? Symbol.for("react.fundamental") : 60117, b = u ? Symbol.for("react.responder") : 60118, O = u ? Symbol.for("react.scope") : 60119;
                function k(de) {
                  return typeof de == "string" || typeof de == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                  de === d || de === _ || de === h || de === p || de === x || de === S || typeof de == "object" && de !== null && (de.$$typeof === A || de.$$typeof === $ || de.$$typeof === v || de.$$typeof === m || de.$$typeof === w || de.$$typeof === y || de.$$typeof === b || de.$$typeof === O || de.$$typeof === E);
                }
                function I(de) {
                  if (typeof de == "object" && de !== null) {
                    var Ue = de.$$typeof;
                    switch (Ue) {
                      case c:
                        var tt = de.type;
                        switch (tt) {
                          case g:
                          case _:
                          case d:
                          case h:
                          case p:
                          case x:
                            return tt;
                          default:
                            var vn = tt && tt.$$typeof;
                            switch (vn) {
                              case m:
                              case w:
                              case A:
                              case $:
                              case v:
                                return vn;
                              default:
                                return Ue;
                            }
                        }
                      case f:
                        return Ue;
                    }
                  }
                }
                var T = g, V = _, z = m, B = v, q = c, M = w, N = d, Y = A, ee = $, Q = f, K = h, ne = p, se = x, ce = !1;
                function X(de) {
                  return ce || (ce = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), D(de) || I(de) === g;
                }
                function D(de) {
                  return I(de) === _;
                }
                function P(de) {
                  return I(de) === m;
                }
                function R(de) {
                  return I(de) === v;
                }
                function j(de) {
                  return typeof de == "object" && de !== null && de.$$typeof === c;
                }
                function W(de) {
                  return I(de) === w;
                }
                function J(de) {
                  return I(de) === d;
                }
                function le(de) {
                  return I(de) === A;
                }
                function te(de) {
                  return I(de) === $;
                }
                function fe(de) {
                  return I(de) === f;
                }
                function De(de) {
                  return I(de) === h;
                }
                function he(de) {
                  return I(de) === p;
                }
                function Oe(de) {
                  return I(de) === x;
                }
                l.AsyncMode = T, l.ConcurrentMode = V, l.ContextConsumer = z, l.ContextProvider = B, l.Element = q, l.ForwardRef = M, l.Fragment = N, l.Lazy = Y, l.Memo = ee, l.Portal = Q, l.Profiler = K, l.StrictMode = ne, l.Suspense = se, l.isAsyncMode = X, l.isConcurrentMode = D, l.isContextConsumer = P, l.isContextProvider = R, l.isElement = j, l.isForwardRef = W, l.isFragment = J, l.isLazy = le, l.isMemo = te, l.isPortal = fe, l.isProfiler = De, l.isStrictMode = he, l.isSuspense = Oe, l.isValidElementType = k, l.typeOf = I;
              })();
            })
          ),
          /***/
          "./node_modules/react-is/index.js": (
            /*!****************************************!*\
              !*** ./node_modules/react-is/index.js ***!
              \****************************************/
            /***/
            ((s, l, u) => {
              s.exports = u(
                /*! ./cjs/react-is.development.js */
                "./node_modules/react-is/cjs/react-is.development.js"
              );
            })
          ),
          /***/
          "./node_modules/shallow-equal/dist/index.esm.js": (
            /*!******************************************************!*\
              !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
              \******************************************************/
            /***/
            ((s, l, u) => {
              u.r(l), u.d(l, {
                /* harmony export */
                shallowEqualArrays: () => (
                  /* binding */
                  f
                ),
                /* harmony export */
                shallowEqualObjects: () => (
                  /* binding */
                  c
                )
                /* harmony export */
              });
              function c(d, p) {
                if (d === p)
                  return !0;
                if (!d || !p)
                  return !1;
                var h = Object.keys(d), v = Object.keys(p), m = h.length;
                if (v.length !== m)
                  return !1;
                for (var g = 0; g < m; g++) {
                  var _ = h[g];
                  if (d[_] !== p[_] || !Object.prototype.hasOwnProperty.call(p, _))
                    return !1;
                }
                return !0;
              }
              function f(d, p) {
                if (d === p)
                  return !0;
                if (!d || !p)
                  return !1;
                var h = d.length;
                if (p.length !== h)
                  return !1;
                for (var v = 0; v < h; v++)
                  if (d[v] !== p[v])
                    return !1;
                return !0;
              }
            })
          ),
          /***/
          "./src/Component.ts": (
            /*!**************************!*\
              !*** ./src/Component.ts ***!
              \**************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__rest || function(h, v) {
                var m = {};
                for (var g in h) Object.prototype.hasOwnProperty.call(h, g) && v.indexOf(g) < 0 && (m[g] = h[g]);
                if (h != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var _ = 0, g = Object.getOwnPropertySymbols(h); _ < g.length; _++)
                    v.indexOf(g[_]) < 0 && Object.prototype.propertyIsEnumerable.call(h, g[_]) && (m[g[_]] = h[g[_]]);
                return m;
              }, f = this && this.__importDefault || function(h) {
                return h && h.__esModule ? h : { default: h };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var d = f(u(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              )), p = function(h) {
                var v = h.children, m = h.device, g = h.onChange, _ = c(h, ["children", "device", "onChange"]), w = (0, d.default)(_, m, g);
                return typeof v == "function" ? v(w) : w ? v : null;
              };
              l.default = p;
            })
          ),
          /***/
          "./src/Context.ts": (
            /*!************************!*\
              !*** ./src/Context.ts ***!
              \************************/
            /***/
            ((s, l, u) => {
              Object.defineProperty(l, "__esModule", { value: !0 });
              var c = u(
                /*! react */
                "react"
              ), f = (0, c.createContext)(void 0);
              l.default = f;
            })
          ),
          /***/
          "./src/index.ts": (
            /*!**********************!*\
              !*** ./src/index.ts ***!
              \**********************/
            /***/
            (function(s, l, u) {
              var c = this && this.__importDefault || function(v) {
                return v && v.__esModule ? v : { default: v };
              };
              Object.defineProperty(l, "__esModule", { value: !0 }), l.Context = l.toQuery = l.useMediaQuery = l.default = void 0;
              var f = c(u(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              ));
              l.useMediaQuery = f.default;
              var d = c(u(
                /*! ./Component */
                "./src/Component.ts"
              ));
              l.default = d.default;
              var p = c(u(
                /*! ./toQuery */
                "./src/toQuery.ts"
              ));
              l.toQuery = p.default;
              var h = c(u(
                /*! ./Context */
                "./src/Context.ts"
              ));
              l.Context = h.default;
            })
          ),
          /***/
          "./src/mediaQuery.ts": (
            /*!***************************!*\
              !*** ./src/mediaQuery.ts ***!
              \***************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__assign || function() {
                return c = Object.assign || function(x) {
                  for (var S, $ = 1, A = arguments.length; $ < A; $++) {
                    S = arguments[$];
                    for (var E in S) Object.prototype.hasOwnProperty.call(S, E) && (x[E] = S[E]);
                  }
                  return x;
                }, c.apply(this, arguments);
              }, f = this && this.__rest || function(x, S) {
                var $ = {};
                for (var A in x) Object.prototype.hasOwnProperty.call(x, A) && S.indexOf(A) < 0 && ($[A] = x[A]);
                if (x != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var E = 0, A = Object.getOwnPropertySymbols(x); E < A.length; E++)
                    S.indexOf(A[E]) < 0 && Object.prototype.propertyIsEnumerable.call(x, A[E]) && ($[A[E]] = x[A[E]]);
                return $;
              }, d = this && this.__importDefault || function(x) {
                return x && x.__esModule ? x : { default: x };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var p = d(u(
                /*! prop-types */
                "./node_modules/prop-types/index.js"
              )), h = p.default.oneOfType([
                p.default.string,
                p.default.number
              ]), v = {
                all: p.default.bool,
                grid: p.default.bool,
                aural: p.default.bool,
                braille: p.default.bool,
                handheld: p.default.bool,
                print: p.default.bool,
                projection: p.default.bool,
                screen: p.default.bool,
                tty: p.default.bool,
                tv: p.default.bool,
                embossed: p.default.bool
              }, m = {
                orientation: p.default.oneOf([
                  "portrait",
                  "landscape"
                ]),
                scan: p.default.oneOf([
                  "progressive",
                  "interlace"
                ]),
                aspectRatio: p.default.string,
                deviceAspectRatio: p.default.string,
                height: h,
                deviceHeight: h,
                width: h,
                deviceWidth: h,
                color: p.default.bool,
                colorIndex: p.default.bool,
                monochrome: p.default.bool,
                resolution: h,
                type: Object.keys(v)
              };
              m.type;
              var g = f(
                m,
                ["type"]
              ), _ = c({ minAspectRatio: p.default.string, maxAspectRatio: p.default.string, minDeviceAspectRatio: p.default.string, maxDeviceAspectRatio: p.default.string, minHeight: h, maxHeight: h, minDeviceHeight: h, maxDeviceHeight: h, minWidth: h, maxWidth: h, minDeviceWidth: h, maxDeviceWidth: h, minColor: p.default.number, maxColor: p.default.number, minColorIndex: p.default.number, maxColorIndex: p.default.number, minMonochrome: p.default.number, maxMonochrome: p.default.number, minResolution: h, maxResolution: h }, g), w = c(c({}, v), _);
              l.default = {
                all: w,
                types: v,
                matchers: m,
                features: _
              };
            })
          ),
          /***/
          "./src/toQuery.ts": (
            /*!************************!*\
              !*** ./src/toQuery.ts ***!
              \************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__importDefault || function(g) {
                return g && g.__esModule ? g : { default: g };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var f = c(u(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), d = c(u(
                /*! ./mediaQuery */
                "./src/mediaQuery.ts"
              )), p = function(g) {
                return "not ".concat(g);
              }, h = function(g, _) {
                var w = (0, f.default)(g);
                return typeof _ == "number" && (_ = "".concat(_, "px")), _ === !0 ? w : _ === !1 ? p(w) : "(".concat(w, ": ").concat(_, ")");
              }, v = function(g) {
                return g.join(" and ");
              }, m = function(g) {
                var _ = [];
                return Object.keys(d.default.all).forEach(function(w) {
                  var x = g[w];
                  x != null && _.push(h(w, x));
                }), v(_);
              };
              l.default = m;
            })
          ),
          /***/
          "./src/useMediaQuery.ts": (
            /*!******************************!*\
              !*** ./src/useMediaQuery.ts ***!
              \******************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__importDefault || function(y) {
                return y && y.__esModule ? y : { default: y };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var f = u(
                /*! react */
                "react"
              ), d = c(u(
                /*! matchmediaquery */
                "./node_modules/matchmediaquery/index.js"
              )), p = c(u(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), h = u(
                /*! shallow-equal */
                "./node_modules/shallow-equal/dist/index.esm.js"
              ), v = c(u(
                /*! ./toQuery */
                "./src/toQuery.ts"
              )), m = c(u(
                /*! ./Context */
                "./src/Context.ts"
              )), g = function(y) {
                return y.query || (0, v.default)(y);
              }, _ = function(y) {
                if (y) {
                  var b = Object.keys(y);
                  return b.reduce(function(O, k) {
                    return O[(0, p.default)(k)] = y[k], O;
                  }, {});
                }
              }, w = function() {
                var y = (0, f.useRef)(!1);
                return (0, f.useEffect)(function() {
                  y.current = !0;
                }, []), y.current;
              }, x = function(y) {
                var b = (0, f.useContext)(m.default), O = function() {
                  return _(y) || _(b);
                }, k = (0, f.useState)(O), I = k[0], T = k[1];
                return (0, f.useEffect)(function() {
                  var V = O();
                  (0, h.shallowEqualObjects)(I, V) || T(V);
                }, [y, b]), I;
              }, S = function(y) {
                var b = function() {
                  return g(y);
                }, O = (0, f.useState)(b), k = O[0], I = O[1];
                return (0, f.useEffect)(function() {
                  var T = b();
                  k !== T && I(T);
                }, [y]), k;
              }, $ = function(y, b) {
                var O = function() {
                  return (0, d.default)(y, b || {}, !!b);
                }, k = (0, f.useState)(O), I = k[0], T = k[1], V = w();
                return (0, f.useEffect)(function() {
                  if (V) {
                    var z = O();
                    return T(z), function() {
                      z && z.dispose();
                    };
                  }
                }, [y, b]), I;
              }, A = function(y) {
                var b = (0, f.useState)(y.matches), O = b[0], k = b[1];
                return (0, f.useEffect)(function() {
                  var I = function(T) {
                    k(T.matches);
                  };
                  return y.addListener(I), k(y.matches), function() {
                    y.removeListener(I);
                  };
                }, [y]), O;
              }, E = function(y, b, O) {
                var k = x(b), I = S(y);
                if (!I)
                  throw new Error("Invalid or missing MediaQuery!");
                var T = $(I, k), V = A(T), z = w();
                return (0, f.useEffect)(function() {
                  z && O && O(V);
                }, [V]), (0, f.useEffect)(function() {
                  return function() {
                    T && T.dispose();
                  };
                }, []), V;
              };
              l.default = E;
            })
          ),
          /***/
          react: (
            /*!**************************************************************************************!*\
              !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
              \**************************************************************************************/
            /***/
            ((s) => {
              s.exports = n;
            })
          )
          /******/
        }, i = {};
        function o(s) {
          var l = i[s];
          if (l !== void 0)
            return l.exports;
          var u = i[s] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return r[s].call(u.exports, u, u.exports, o), u.exports;
        }
        o.d = (s, l) => {
          for (var u in l)
            o.o(l, u) && !o.o(s, u) && Object.defineProperty(s, u, { enumerable: !0, get: l[u] });
        }, o.o = (s, l) => Object.prototype.hasOwnProperty.call(s, l), o.r = (s) => {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
        };
        var a = o("./src/index.ts");
        return a;
      })()
    ));
  })(Qf)), Qf.exports;
}
var ale = /* @__PURE__ */ ole();
const sle = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, P3 = (e) => ale.useMediaQuery({ minWidth: sle[e] }), k3 = He({}), g_ = () => Me(k3), lle = ({
  children: e,
  className: t = "",
  style: n = {},
  hideDrawerButton: r = !0
}) => {
  const { menuVisible: i, onMenuToggle: o, layoutRef: a } = g_(), s = P3("sm");
  return a ? va(
    /* @__PURE__ */ C.jsxs(
      "nav",
      {
        className: Qn(
          "col-span-full bg-blue-500 flex justify-start items-center text-white px-4 col-start-1 row-span-1 w-full h-full",
          t
        ),
        style: n,
        children: [
          s && !r && /* @__PURE__ */ C.jsx(
            Um,
            {
              className: "mr-8",
              sideBarVisible: i,
              onClick: () => o?.(!i)
            }
          ),
          e,
          !s && /* @__PURE__ */ C.jsx(C.Fragment, { children: /* @__PURE__ */ C.jsx(
            Um,
            {
              sideBarVisible: i,
              onClick: () => o?.(!i)
            }
          ) })
        ]
      }
    ),
    a
  ) : null;
}, ule = ({ children: e }) => {
  const { layoutRef: t } = g_();
  return t ? va(
    /* @__PURE__ */ C.jsx("main", { className: "w-full h-full overflow-hidden row-start-2 col-start-2 col-span-full", children: e }),
    t
  ) : null;
}, lO = ui(
  [
    "bg-neutral-200",
    "h-full",
    "overflow-auto",
    "row-start-2",
    "col-span-1",
    "col-start-1"
  ],
  {
    variants: {
      size: {
        sm: ["sm:hidden", "block", "z-50"],
        lg: ["sm:block"]
      }
    }
  }
), cle = ({ children: e }) => {
  const { onMenuToggle: t, menuVisible: n, layoutRef: r } = g_(), i = P3("sm");
  return r ? i ? n ? va(
    /* @__PURE__ */ C.jsx(
      "aside",
      {
        className: lO({ size: "lg" }),
        children: e
      },
      "app-layout-menu"
    ),
    r
  ) : null : n ? va(
    /* @__PURE__ */ C.jsxs(
      "aside",
      {
        className: lO({ size: "sm" }),
        children: [
          /* @__PURE__ */ C.jsx(
            "button",
            {
              onClick: () => t?.(!1),
              className: "ml-auto text-neutral-700",
              children: /* @__PURE__ */ C.jsx(hr, { icon: F6, size: "sm" })
            }
          ),
          e
        ]
      },
      "app-layout-menu"
    ),
    r
  ) : null : null;
};
function fle({
  to: e,
  icon: t,
  name: n,
  hasNotifications: r,
  children: i,
  href: o,
  linkProps: a
}) {
  if (!o && !e)
    throw new Error("to or href is required");
  return /* @__PURE__ */ C.jsx(U8, { children: /* @__PURE__ */ C.jsx("div", { className: "flex flex-col my-2", children: o ? /* @__PURE__ */ C.jsxs(
    "a",
    {
      className: "flex p-2 my-2 list-none rounded-md cursor-pointer hover:bg-neutral-500",
      href: o,
      target: "_blank",
      rel: "noreferrer",
      children: [
        /* @__PURE__ */ C.jsxs("div", { className: "flex align-middle ", children: [
          r && /* @__PURE__ */ C.jsx("div", { className: "absolute w-2.5 h-2.5 transform -translate-x-2 -translate-y-2 bg-red-400 rounded-full" }),
          /* @__PURE__ */ C.jsx(
            hr,
            {
              icon: t,
              color: "gray",
              className: "my-auto mr-6",
              size: "1x"
            }
          ),
          /* @__PURE__ */ C.jsx("p", { children: n })
        ] }),
        /* @__PURE__ */ C.jsx(Wd, {}),
        i
      ]
    }
  ) : /* @__PURE__ */ C.jsxs(
    es,
    {
      to: e,
      ...a || {},
      className: "flex p-2 my-2 list-none rounded-md cursor-pointer hover:bg-neutral-500",
      children: [
        /* @__PURE__ */ C.jsxs("div", { className: "flex align-middle ", children: [
          r && /* @__PURE__ */ C.jsx("div", { className: "absolute w-2.5 h-2.5 transform -translate-x-2 -translate-y-2 bg-red-400 rounded-full" }),
          /* @__PURE__ */ C.jsx(
            hr,
            {
              icon: t,
              color: "gray",
              className: "my-auto mr-6",
              size: "1x"
            }
          ),
          /* @__PURE__ */ C.jsx("p", { children: n })
        ] }),
        /* @__PURE__ */ C.jsx(Wd, {}),
        i
      ]
    }
  ) }) });
}
const dle = ui([
  "grid",
  "w-screen",
  "h-screen",
  "overflow-hidden",
  "bg-neutral-100",
  "flex-col",
  "app-layout",
  "grid-cols-[min-content_minmax(0,1fr)]",
  "grid-rows-[6rem_minmax(0,1fr)]"
]), wh = ({
  menuVisible: e = !1,
  children: t,
  onMenuToggle: n
}) => {
  const [r, i] = H.useState(null), [o, a] = H.useState(null), [s, l] = H.useState(null);
  return /* @__PURE__ */ C.jsx(
    k3.Provider,
    {
      value: {
        menuVisible: e,
        menuRef: s,
        onMenuToggle: n,
        layoutRef: r,
        headerRef: o
      },
      children: /* @__PURE__ */ C.jsx(
        "div",
        {
          className: dle(),
          ref: i,
          children: t
        }
      )
    }
  );
};
wh.Header = lle;
wh.Body = ule;
wh.Menu = cle;
wh.Link = fle;
const ple = ({
  onClick: e,
  sideBarVisible: t,
  className: n,
  showMenu: r = !0,
  isLoggedIn: i = !1,
  children: o
}) => /* @__PURE__ */ C.jsxs(
  "nav",
  {
    className: Qn(
      "w-screen h-full flex justify-between col-span-12 row-span-1 px-4 bg-blue-500",
      n
    ),
    children: [
      /* @__PURE__ */ C.jsxs("div", { className: "flex", children: [
        r && /* @__PURE__ */ C.jsx(
          Um,
          {
            sideBarVisible: t,
            onClick: e || (() => null)
          }
        ),
        /* @__PURE__ */ C.jsx(es, { to: "/app", className: "block mx-4 my-auto h-1/2", children: /* @__PURE__ */ C.jsx(v_, { className: "w-8 h-8" }) }),
        /* @__PURE__ */ C.jsx("h1", { className: "my-auto text-xl text-white uppercase font-terminal ", children: o })
      ] }),
      /* @__PURE__ */ C.jsxs(
        K0,
        {
          className: "my-auto",
          button: /* @__PURE__ */ C.jsx(hr, { color: "white", size: "1x", icon: j6 }),
          children: [
            i && /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
              /* @__PURE__ */ C.jsx("p", { className: "mb-8 border-b border-opacity-30 border-b-black" }),
              /* @__PURE__ */ C.jsx(es, { className: "menu-item", to: "/app/account", children: "Account" }),
              /* @__PURE__ */ C.jsx(es, { className: "menu-item", to: "/app/account/change-password", children: "Change Password" }),
              /* @__PURE__ */ C.jsx(es, { className: "menu-item", to: "/app/account/tokens", children: "CLI Tokens" }),
              /* @__PURE__ */ C.jsx(
                ca,
                {
                  onAction: async () => {
                  },
                  children: "Logout"
                }
              )
            ] }),
            !i && /* @__PURE__ */ C.jsx(es, { to: "/login", children: /* @__PURE__ */ C.jsx(ca, { children: "Login" }) })
          ]
        }
      )
    ]
  }
), Mc = {};
li`
    mutation CreateFolder($newFolder: String!, $currentFolder: String!, $s3BucketId: Float) {
  createFolder(
    newFolder: $newFolder
    currentFolder: $currentFolder
    s3BucketId: $s3BucketId
  )
}
    `;
li`
    mutation DeleteFiles($paths: [S3ObjectInput!]!) {
  deleteFilesResolver(paths: $paths)
}
    `;
li`
    mutation MoveS3Files($target: S3ObjectInput!, $source: S3ObjectInput!) {
  moveS3Files(target: $target, source: $source)
}
    `;
li`
    mutation MoveUpAFolder($moveUpAFolderPath: S3ObjectInput!) {
  moveUpAFolder(path: $moveUpAFolderPath)
}
    `;
li`
    query FileTransfers {
  fileTransfers {
    name
    progress
    id
  }
}
    `;
li`
    query FolderContents($s3BucketId: Float, $folder: String) {
  folderContents(s3BucketId: $s3BucketId, folder: $folder) {
    contents {
      key
      name
      isFolder
      fullPath
      bucket
    }
    errors
  }
  me {
    id
    awsUsername
  }
}
    `;
li`
    query folderContentsSearch($search: String!, $s3BucketId: Int) {
  fileSearch(search: $search, s3BucketId: $s3BucketId) {
    results {
      fullPath
      key
      name
      isFolder
      bucket
    }
    errors
  }
}
    `;
const D3 = li`
    query Me {
  me {
    id
    email
    awsUsername
    firstname
    lastname
    roles {
      role
    }
  }
}
    `;
function hle(e) {
  const t = { ...Mc, ...e };
  return sc.useQuery(D3, t);
}
function vle(e) {
  const t = { ...Mc, ...e };
  return sc.useLazyQuery(D3, t);
}
const A3 = li`
    query PresignedDownloadUrl($bucket: String!, $key: String!, $limit: Float) {
  presignedDownloadUrl(bucket: $bucket, key: $key, limit: $limit)
}
    `;
function mle(e) {
  const t = { ...Mc, ...e };
  return sc.useQuery(A3, t);
}
function gle(e) {
  const t = { ...Mc, ...e };
  return sc.useLazyQuery(A3, t);
}
li`
    subscription FileTranfersUpdated {
  fileTransfersUpdated {
    progress
    id
    name
  }
}
    `;
const yle = li`
    subscription TaskQueueLogs($jobId: String!) {
  taskQueueLogs(jobId: $jobId) {
    message
    timestamp
  }
}
    `;
function ble(e) {
  const t = { ...Mc, ...e };
  return sc.useSubscription(yle, t);
}
const _ue = ({ appBarTitle: e }) => {
  const { data: t } = hle();
  return /* @__PURE__ */ C.jsxs(Vn.div, { className: "grid w-screen h-screen bg-neutral-300 grid-rows-[4rem minmax(0, 1fr)] grid-cols-1", children: [
    /* @__PURE__ */ C.jsx(
      ple,
      {
        className: "h-16 bg-blue-600 ",
        onClick: () => null,
        sideBarVisible: !1,
        showMenu: !1,
        isLoggedIn: !!t?.me,
        children: e
      }
    ),
    /* @__PURE__ */ C.jsx("div", { className: "flex justify-around w-full h-full ", children: /* @__PURE__ */ C.jsx("div", { className: "w-full h-full max-w-6xl p-4 overflow-scroll bg-neutral-100", children: /* @__PURE__ */ C.jsx(t6, {}) }) })
  ] });
}, _le = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}, wle = ({
  children: e,
  className: t
}) => /* @__PURE__ */ C.jsx(
  Vn.div,
  {
    className: Qn("w-full min-h-full overflow-scroll", t),
    initial: "initial",
    animate: "in",
    exit: "out",
    variants: _le,
    children: e
  }
), xle = (e) => /* @__PURE__ */ C.jsx("h1", { className: "text-2xl flex-grow border-opacity-25", children: e.children }), C3 = ({ children: e, title: t, className: n }) => /* @__PURE__ */ C.jsx("div", { className: `flex py-2 mb-4 border-b border-black ${n}`, children: /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
  typeof t == "string" ? /* @__PURE__ */ C.jsx(xle, { children: t }) : t,
  e
] }) }), wue = () => /* @__PURE__ */ C.jsx(wle, { children: /* @__PURE__ */ C.jsx(C3, { title: "Page not found" }) }), Ele = ({ data: e }) => {
  const t = URL.createObjectURL(e);
  return /* @__PURE__ */ C.jsx("div", { children: /* @__PURE__ */ C.jsx("img", { src: t, alt: "" }) });
}, Sle = () => /* @__PURE__ */ C.jsx("div", { className: "loader" }), xue = () => /* @__PURE__ */ C.jsx("p", { children: "Loading..." });
async function I3(e, t, n, r) {
  const i = await e.getPage(n), o = i.getViewport({ scale: 5 });
  t.height = o.height, t.width = o.width;
  const a = t.getContext("2d");
  if (!a)
    return;
  const s = {
    canvasContext: a,
    viewport: o
  }, l = o.height * (n - 1);
  await i.render(s).promise, a.setTransform(1, 0, 0, 1, 0, 0), r.push({
    data: t.toDataURL(),
    offset: l,
    page: n
  }), n + 1 <= e.numPages && await I3(e, t, n + 1, r);
}
const Ole = ({ url: e, canvas: t }) => {
  const [n, r] = Ve(null), [i, o] = Ve([]), [a, s] = Ve(!1), l = Le(
    async (u) => {
      if (!t || !n) return;
      const c = { data: [] };
      await I3(n, t, u, c.data), o(c.data), s(!0);
    },
    [n, s]
  );
  return Ee(() => {
    l(1);
  }, [n, l]), Ee(() => {
    $h.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${$h.version}/pdf.worker.js`, $h.getDocument({ url: e }).promise.then((c) => {
      r(c);
    });
  }, []), {
    ready: a,
    pageData: i,
    totalPages: n?.numPages
  };
}, $le = ({ url: e }) => {
  const t = _e(null), { ready: n, pageData: r } = Ole({
    url: e,
    canvas: t.current
  });
  return /* @__PURE__ */ C.jsxs("div", { children: [
    !n && /* @__PURE__ */ C.jsx("canvas", { ref: t }),
    r.map(({ data: i }, o) => /* @__PURE__ */ C.jsx(
      "img",
      {
        className: "mb-2 max-w-xl",
        src: i
      },
      `pdf-preview-${e}=${o}`
    ))
  ] });
}, Tle = ({ data: e }) => {
  const [t, n] = Ve(null), r = async () => {
    const i = await e.text();
    n(i);
  };
  return Ee(() => {
    r();
  }, [e]), t ? /* @__PURE__ */ C.jsx("div", { children: /* @__PURE__ */ C.jsx("div", { dangerouslySetInnerHTML: { __html: t } }) }) : null;
};
var Jf = { exports: {} };
/* @license
Papa Parse
v5.5.4
https://github.com/mholt/PapaParse
License: MIT
*/
var Ple = Jf.exports, uO;
function kle() {
  return uO || (uO = 1, (function(e, t) {
    ((n, r) => {
      e.exports = r();
    })(Ple, function n() {
      var r = typeof self < "u" ? self : typeof window < "u" ? window : r !== void 0 ? r : {}, i, o = !r.document && !!r.postMessage, a = r.IS_PAPA_WORKER || !1, s = {}, l = 0, u = {};
      function c(y) {
        return y.charCodeAt(0) === 65279 ? y.slice(1) : y;
      }
      function f(y) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, function(b) {
          var O = $(b);
          O.chunkSize = parseInt(O.chunkSize), b.step || b.chunk || (O.chunkSize = null), this._handle = new m(O), (this._handle.streamer = this)._config = O;
        }.call(this, y), this.parseChunk = function(b, O) {
          var k = parseInt(this._config.skipFirstNLines) || 0;
          if (this.isFirstChunk && 0 < k) {
            let T = this._config.newline;
            T || (I = this._config.quoteChar || '"', T = this._handle.guessLineEndings(b, I)), b = [...b.split(T).slice(k)].join(T);
          }
          this.isFirstChunk && E(this._config.beforeFirstChunk) && (I = this._config.beforeFirstChunk(b)) !== void 0 && (b = I), this.isFirstChunk = !1, this._halted = !1;
          var k = this._partialLine + b, I = (this._partialLine = "", this._handle.parse(k, this._baseIndex, !this._finished));
          if (!this._handle.paused() && !this._handle.aborted()) {
            if (b = I.meta.cursor, k = (this._finished || (this._partialLine = k.substring(b - this._baseIndex), this._baseIndex = b), I && I.data && (this._rowCount += I.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview), a) r.postMessage({ results: I, workerId: u.WORKER_ID, finished: k });
            else if (E(this._config.chunk) && !O) {
              if (this._config.chunk(I, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
              this._completeResults = I = void 0;
            }
            return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(I.data), this._completeResults.errors = this._completeResults.errors.concat(I.errors), this._completeResults.meta = I.meta), this._completed || !k || !E(this._config.complete) || I && I.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), k || I && I.meta.paused || this._nextChunk(), I;
          }
          this._halted = !0;
        }, this._sendError = function(b) {
          E(this._config.error) ? this._config.error(b) : a && this._config.error && r.postMessage({ workerId: u.WORKER_ID, error: b, finished: !1 });
        };
      }
      function d(y) {
        var b;
        (y = y || {}).chunkSize || (y.chunkSize = u.RemoteChunkSize), f.call(this, y), this._nextChunk = o ? function() {
          this._readChunk(), this._chunkLoaded();
        } : function() {
          this._readChunk();
        }, this.stream = function(O) {
          this._input = O, this._nextChunk();
        }, this._readChunk = function() {
          if (this._finished) this._chunkLoaded();
          else {
            if (b = new XMLHttpRequest(), this._config.withCredentials && (b.withCredentials = this._config.withCredentials), o || (b.onload = A(this._chunkLoaded, this), b.onerror = A(this._chunkError, this)), b.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !o), this._config.downloadRequestHeaders) {
              var O, k = this._config.downloadRequestHeaders;
              for (O in k) b.setRequestHeader(O, k[O]);
            }
            var I;
            this._config.chunkSize && (I = this._start + this._config.chunkSize - 1, b.setRequestHeader("Range", "bytes=" + this._start + "-" + I));
            try {
              b.send(this._config.downloadRequestBody);
            } catch (T) {
              this._chunkError(T.message);
            }
            o && b.status === 0 && this._chunkError();
          }
        }, this._chunkLoaded = function() {
          b.readyState === 4 && (b.status < 200 || 400 <= b.status ? this._chunkError() : (this._start += this._config.chunkSize || b.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((O) => (O = O.getResponseHeader("Content-Range")) !== null ? parseInt(O.substring(O.lastIndexOf("/") + 1)) : -1)(b), this.parseChunk(b.responseText)));
        }, this._chunkError = function(O) {
          O = b.statusText || O, this._sendError(new Error(O));
        };
      }
      function p(y) {
        (y = y || {}).chunkSize || (y.chunkSize = u.LocalChunkSize), f.call(this, y);
        var b, O, k = typeof FileReader < "u";
        this.stream = function(I) {
          this._input = I, O = I.slice || I.webkitSlice || I.mozSlice, k ? ((b = new FileReader()).onload = A(this._chunkLoaded, this), b.onerror = A(this._chunkError, this)) : b = new FileReaderSync(), this._nextChunk();
        }, this._nextChunk = function() {
          this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
          var I = this._input, T = (this._config.chunkSize && (T = Math.min(this._start + this._config.chunkSize, this._input.size), I = O.call(I, this._start, T)), b.readAsText(I, this._config.encoding));
          k || this._chunkLoaded({ target: { result: T } });
        }, this._chunkLoaded = function(I) {
          this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(I.target.result);
        }, this._chunkError = function() {
          this._sendError(b.error);
        };
      }
      function h(y) {
        var b;
        f.call(this, y = y || {}), this.stream = function(O) {
          return b = O, this._nextChunk();
        }, this._nextChunk = function() {
          var O, k;
          if (!this._finished) return O = this._config.chunkSize, b = O ? (k = b.substring(0, O), b.substring(O)) : (k = b, ""), this._finished = !b, this.parseChunk(k);
        };
      }
      function v(y) {
        f.call(this, y = y || {});
        var b = [], O = !0, k = !1;
        this.pause = function() {
          f.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
          f.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(I) {
          this._input = I, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
          k && b.length === 1 && (this._finished = !0);
        }, this._nextChunk = function() {
          this._checkIsFinished(), b.length ? this.parseChunk(b.shift()) : O = !0;
        }, this._streamData = A(function(I) {
          try {
            b.push(typeof I == "string" ? I : I.toString(this._config.encoding)), O && (O = !1, this._checkIsFinished(), this.parseChunk(b.shift()));
          } catch (T) {
            this._streamError(T);
          }
        }, this), this._streamError = A(function(I) {
          this._streamCleanUp(), this._sendError(I);
        }, this), this._streamEnd = A(function() {
          this._streamCleanUp(), k = !0, this._streamData("");
        }, this), this._streamCleanUp = A(function() {
          this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
      }
      function m(y) {
        var b, O, k, I, T = Math.pow(2, 53), V = -T, z = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, B = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, q = this, M = 0, N = 0, Y = !1, ee = !1, Q = [], K = { data: [], errors: [], meta: {} };
        function ne(D) {
          return y.skipEmptyLines === "greedy" ? D.join("").trim() === "" : D.length === 1 && D[0].length === 0;
        }
        function se() {
          if (K && k && (X("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + u.DefaultDelimiter + "'"), k = !1), y.skipEmptyLines && (K.data = K.data.filter(function(j) {
            return !ne(j);
          })), ce()) {
            let j = function(W, J) {
              W = c(W), E(y.transformHeader) && (W = y.transformHeader(W, J)), Q.push(W);
            };
            if (K) if (Array.isArray(K.data[0])) {
              for (var D = 0; ce() && D < K.data.length; D++) K.data[D].forEach(j);
              K.data.splice(0, 1);
            } else K.data.forEach(j);
          }
          function P(j, W) {
            for (var J = y.header ? {} : [], le = 0; le < j.length; le++) {
              var te = le, fe = j[le], fe = ((De, he) => ((Oe) => (y.dynamicTypingFunction && y.dynamicTyping[Oe] === void 0 && (y.dynamicTyping[Oe] = y.dynamicTypingFunction(Oe)), (y.dynamicTyping[Oe] || y.dynamicTyping) === !0))(De) ? he === "true" || he === "TRUE" || he !== "false" && he !== "FALSE" && (((Oe) => {
                if (z.test(Oe) && (Oe = parseFloat(Oe), V < Oe && Oe < T))
                  return 1;
              })(he) ? parseFloat(he) : B.test(he) ? new Date(he) : he === "" ? null : he) : he)(te = y.header ? le >= Q.length ? "__parsed_extra" : Q[le] : te, fe = y.transform ? y.transform(fe, te) : fe);
              te === "__parsed_extra" ? (J[te] = J[te] || [], J[te].push(fe)) : J[te] = fe;
            }
            return y.header && (le > Q.length ? X("FieldMismatch", "TooManyFields", "Too many fields: expected " + Q.length + " fields but parsed " + le, N + W) : le < Q.length && X("FieldMismatch", "TooFewFields", "Too few fields: expected " + Q.length + " fields but parsed " + le, N + W)), J;
          }
          var R;
          K && (y.header || y.dynamicTyping || y.transform) && (R = 1, !K.data.length || Array.isArray(K.data[0]) ? (K.data = K.data.map(P), R = K.data.length) : K.data = P(K.data, 0), y.header && K.meta && (K.meta.fields = Q), N += R);
        }
        function ce() {
          return y.header && Q.length === 0;
        }
        function X(D, P, R, j) {
          D = { type: D, code: P, message: R }, j !== void 0 && (D.row = j), K.errors.push(D);
        }
        E(y.step) && (I = y.step, y.step = function(D) {
          K = D, ce() ? se() : (se(), K.data.length !== 0 && (M += D.data.length, y.preview && M > y.preview ? O.abort() : (K.data = K.data[0], I(K, q))));
        }), this.parse = function(D, P, R) {
          var j = y.quoteChar || '"', j = (y.newline || (y.newline = this.guessLineEndings(D, j)), k = !1, y.delimiter ? E(y.delimiter) && (y.delimiter = y.delimiter(D), K.meta.delimiter = y.delimiter) : ((j = ((W, J, le, te, fe) => {
            var De, he, Oe, de;
            fe = fe || [",", "	", "|", ";", u.RECORD_SEP, u.UNIT_SEP];
            for (var Ue = 0; Ue < fe.length; Ue++) {
              for (var tt, vn = fe[Ue], ge = 0, Ne = 0, Ye = 0, et = (Oe = void 0, new _({ comments: te, delimiter: vn, newline: J, preview: 10 }).parse(W)), ct = 0; ct < et.data.length; ct++) le && ne(et.data[ct]) ? Ye++ : (tt = et.data[ct].length, Ne += tt, Oe === void 0 ? Oe = tt : 0 < tt && (ge += Math.abs(tt - Oe), Oe = tt));
              0 < et.data.length && (Ne /= et.data.length - Ye), (he === void 0 || ge <= he) && (de === void 0 || de < Ne) && 1.99 < Ne && (he = ge, De = vn, de = Ne);
            }
            return { successful: !!(y.delimiter = De), bestDelimiter: De };
          })(D, y.newline, y.skipEmptyLines, y.comments, y.delimitersToGuess)).successful ? y.delimiter = j.bestDelimiter : (k = !0, y.delimiter = u.DefaultDelimiter), K.meta.delimiter = y.delimiter), $(y));
          return y.preview && y.header && j.preview++, b = D, O = new _(j), K = O.parse(b, P, R), se(), Y ? { meta: { paused: !0 } } : K || { meta: { paused: !1 } };
        }, this.paused = function() {
          return Y;
        }, this.pause = function() {
          Y = !0, O.abort(), b = E(y.chunk) ? "" : b.substring(O.getCharIndex());
        }, this.resume = function() {
          q.streamer._halted ? (Y = !1, q.streamer.parseChunk(b, !0)) : setTimeout(q.resume, 3);
        }, this.aborted = function() {
          return ee;
        }, this.abort = function() {
          ee = !0, O.abort(), K.meta.aborted = !0, E(y.complete) && y.complete(K), b = "";
        }, this.guessLineEndings = function(W, j) {
          W = W.substring(0, 1048576);
          var j = new RegExp(g(j) + "([^]*?)" + g(j), "gm"), R = (W = W.replace(j, "")).split("\r"), j = W.split(`
`), W = 1 < j.length && j[0].length < R[0].length;
          if (R.length === 1 || W) return `
`;
          for (var J = 0, le = 0; le < R.length; le++) R[le][0] === `
` && J++;
          return J >= R.length / 2 ? `\r
` : "\r";
        };
      }
      function g(y) {
        return y.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }
      function _(y) {
        var b = (y = y || {}).delimiter, O = y.newline, k = y.comments, I = y.step, T = y.preview, V = y.fastMode, z = null, B = !1, q = y.quoteChar == null ? '"' : y.quoteChar, M = q;
        if (y.escapeChar !== void 0 && (M = y.escapeChar), (typeof b != "string" || -1 < u.BAD_DELIMITERS.indexOf(b)) && (b = ","), k === b) throw new Error("Comment character same as delimiter");
        k === !0 ? k = "#" : (typeof k != "string" || -1 < u.BAD_DELIMITERS.indexOf(k)) && (k = !1), O !== `
` && O !== "\r" && O !== `\r
` && (O = `
`);
        var N = 0, Y = !1;
        this.parse = function(ee, Q, K) {
          if (typeof ee != "string") throw new Error("Input must be a string");
          var ne = ee.length, se = b.length, ce = O.length, X = k.length, D = E(I), P = [], R = [], j = [], W = N = 0;
          if (!ee) return ge();
          if (V || V !== !1 && ee.indexOf(q) === -1) {
            for (var J = ee.split(O), le = 0; le < J.length; le++) {
              if (j = J[le], N += j.length, le !== J.length - 1) N += O.length;
              else if (K) return ge();
              if (!k || j.substring(0, X) !== k) {
                if (D) {
                  if (P = [], de(j.split(b)), Ne(), Y) return ge();
                } else de(j.split(b));
                if (T && T <= le) return P = P.slice(0, T), ge(!0);
              }
            }
            return ge();
          }
          for (var te = ee.indexOf(b, N), fe = ee.indexOf(O, N), De = new RegExp(g(M) + g(q), "g"), he = ee.indexOf(q, N); ; ) if (ee[N] === q) for (he = N, N++; ; ) {
            if ((he = ee.indexOf(q, he + 1)) === -1) return K || R.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: P.length, index: N }), tt();
            if (he === ne - 1) return tt(ee.substring(N, he).replace(De, q));
            if (q === M && ee[he + 1] === M) he++;
            else if (q === M || he === 0 || ee[he - 1] !== M) {
              te !== -1 && te < he + 1 && (te = ee.indexOf(b, he + 1));
              var Oe = Ue((fe = fe !== -1 && fe < he + 1 ? ee.indexOf(O, he + 1) : fe) === -1 ? te : Math.min(te, fe));
              if (ee.substr(he + 1 + Oe, se) === b) {
                j.push(ee.substring(N, he).replace(De, q)), ee[N = he + 1 + Oe + se] !== q && (he = ee.indexOf(q, N)), te = ee.indexOf(b, N), fe = ee.indexOf(O, N);
                break;
              }
              if (Oe = Ue(fe), ee.substring(he + 1 + Oe, he + 1 + Oe + ce) === O) {
                if (j.push(ee.substring(N, he).replace(De, q)), vn(he + 1 + Oe + ce), te = ee.indexOf(b, N), he = ee.indexOf(q, N), D && (Ne(), Y)) return ge();
                if (T && P.length >= T) return ge(!0);
                break;
              }
              R.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: P.length, index: N }), he++;
            }
          }
          else if (k && j.length === 0 && ee.substring(N, N + X) === k) {
            if (fe === -1) return ge();
            N = fe + ce, fe = ee.indexOf(O, N), te = ee.indexOf(b, N);
          } else if (te !== -1 && (te < fe || fe === -1)) j.push(ee.substring(N, te)), N = te + se, te = ee.indexOf(b, N);
          else {
            if (fe === -1) break;
            if (j.push(ee.substring(N, fe)), vn(fe + ce), D && (Ne(), Y)) return ge();
            if (T && P.length >= T) return ge(!0);
          }
          return tt();
          function de(Ye) {
            P.push(Ye), W = N;
          }
          function Ue(Ye) {
            var et = 0;
            return et = Ye !== -1 && (Ye = ee.substring(he + 1, Ye)) && Ye.trim() === "" ? Ye.length : et;
          }
          function tt(Ye) {
            return K || (Ye === void 0 && (Ye = ee.substring(N)), j.push(Ye), N = ne, de(j), D && Ne()), ge();
          }
          function vn(Ye) {
            N = Ye, de(j), j = [], fe = ee.indexOf(O, N);
          }
          function ge(Ye) {
            if (y.header && !Q && P.length && !B) {
              var et = P[0], ct = /* @__PURE__ */ Object.create(null), F = new Set(et);
              let U = !1;
              for (let Z = 0; Z < et.length; Z++) {
                let ue = c(et[Z]);
                if (ct[ue = E(y.transformHeader) ? y.transformHeader(ue, Z) : ue]) {
                  let ve, Se = ct[ue];
                  for (; ve = ue + "_" + Se, Se++, F.has(ve); ) ;
                  F.add(ve), et[Z] = ve, ct[ue]++, U = !0, (z = z === null ? {} : z)[ve] = ue;
                } else ct[ue] = 1, et[Z] = ue;
                F.add(ue);
              }
              U && console.warn("Duplicate headers found and renamed."), B = !0;
            }
            return { data: P, errors: R, meta: { delimiter: b, linebreak: O, aborted: Y, truncated: !!Ye, cursor: W + (Q || 0), renamedHeaders: z } };
          }
          function Ne() {
            I(ge()), P = [], R = [];
          }
        }, this.abort = function() {
          Y = !0;
        }, this.getCharIndex = function() {
          return N;
        };
      }
      function w(y) {
        var b = y.data, O = s[b.workerId], k = !1;
        if (b.error) O.userError(b.error, b.file);
        else if (b.results && b.results.data) {
          var I = { abort: function() {
            k = !0, x(b.workerId, { data: [], errors: [], meta: { aborted: !0 } });
          }, pause: S, resume: S };
          if (E(O.userStep)) {
            for (var T = 0; T < b.results.data.length && (O.userStep({ data: b.results.data[T], errors: b.results.errors, meta: b.results.meta }, I), !k); T++) ;
            delete b.results;
          } else E(O.userChunk) && (O.userChunk(b.results, I, b.file), delete b.results);
        }
        b.finished && !k && x(b.workerId, b.results);
      }
      function x(y, b) {
        var O = s[y];
        E(O.userComplete) && O.userComplete(b), O.terminate(), delete s[y];
      }
      function S() {
        throw new Error("Not implemented.");
      }
      function $(y) {
        if (typeof y != "object" || y === null) return y;
        var b, O = Array.isArray(y) ? [] : {};
        for (b in y) O[b] = $(y[b]);
        return O;
      }
      function A(y, b) {
        return function() {
          y.apply(b, arguments);
        };
      }
      function E(y) {
        return typeof y == "function";
      }
      return u.parse = function(y, b) {
        var O = (b = b || {}).dynamicTyping || !1;
        if (E(O) && (b.dynamicTypingFunction = O, O = {}), b.dynamicTyping = O, b.transform = !!E(b.transform) && b.transform, !b.worker || !u.WORKERS_SUPPORTED) return O = null, u.NODE_STREAM_INPUT, typeof y == "string" ? (y = c(y), O = new (b.download ? d : h)(b)) : y.readable === !0 && E(y.read) && E(y.on) ? O = new v(b) : (r.File && y instanceof File || y instanceof Object) && (O = new p(b)), O.stream(y);
        (O = (() => {
          var k;
          return !!u.WORKERS_SUPPORTED && (k = (() => {
            var I = r.URL || r.webkitURL || null, T = n.toString();
            return u.BLOB_URL || (u.BLOB_URL = I.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", T, ")();"], { type: "text/javascript" })));
          })(), (k = new r.Worker(k)).onmessage = w, k.id = l++, s[k.id] = k);
        })()).userStep = b.step, O.userChunk = b.chunk, O.userComplete = b.complete, O.userError = b.error, b.step = E(b.step), b.chunk = E(b.chunk), b.complete = E(b.complete), b.error = E(b.error), delete b.worker, O.postMessage({ input: y, config: b, workerId: O.id });
      }, u.unparse = function(y, b) {
        var O = !1, k = !0, I = ",", T = `\r
`, V = '"', z = V + V, B = !1, q = null, M = !1, N = ((() => {
          if (typeof b == "object") {
            if (typeof b.delimiter != "string" || u.BAD_DELIMITERS.filter(function(Q) {
              return b.delimiter.indexOf(Q) !== -1;
            }).length || (I = b.delimiter), typeof b.quotes != "boolean" && typeof b.quotes != "function" && !Array.isArray(b.quotes) || (O = b.quotes), typeof b.skipEmptyLines != "boolean" && typeof b.skipEmptyLines != "string" || (B = b.skipEmptyLines), typeof b.newline == "string" && (T = b.newline), typeof b.quoteChar == "string" && (V = b.quoteChar, z = V + V), typeof b.header == "boolean" && (k = b.header), Array.isArray(b.columns)) {
              if (b.columns.length === 0) throw new Error("Option columns is empty");
              q = b.columns;
            }
            b.escapeChar !== void 0 && (z = b.escapeChar + V), b.escapeFormulae instanceof RegExp ? M = b.escapeFormulae : typeof b.escapeFormulae == "boolean" && b.escapeFormulae && (M = /^[=+\-@\t\r].*$/);
          }
        })(), new RegExp(g(V), "g"));
        if (typeof y == "string" && (y = JSON.parse(y)), Array.isArray(y)) {
          if (!y.length || Array.isArray(y[0])) return Y(null, y, B);
          if (typeof y[0] == "object") return Y(q || Object.keys(y[0]), y, B);
        } else if (typeof y == "object") return typeof y.data == "string" && (y.data = JSON.parse(y.data)), Array.isArray(y.data) && (y.fields || (y.fields = y.meta && y.meta.fields || q), y.fields || (y.fields = Array.isArray(y.data[0]) ? y.fields : typeof y.data[0] == "object" ? Object.keys(y.data[0]) : []), Array.isArray(y.data[0]) || typeof y.data[0] == "object" || (y.data = [y.data])), Y(y.fields || [], y.data || [], B);
        throw new Error("Unable to serialize unrecognized input");
        function Y(Q, K, ne) {
          var se = "", ce = (typeof Q == "string" && (Q = JSON.parse(Q)), typeof K == "string" && (K = JSON.parse(K)), Array.isArray(Q) && 0 < Q.length), X = !Array.isArray(K[0]);
          if (ce && k) {
            for (var D = 0; D < Q.length; D++) 0 < D && (se += I), se += ee(Q[D], D);
            0 < K.length && (se += T);
          }
          for (var P = 0; P < K.length; P++) {
            var R = (ce ? Q : K[P]).length, j = !1, W = ce ? Object.keys(K[P]).length === 0 : K[P].length === 0;
            if (ne && !ce && (j = ne === "greedy" ? K[P].join("").trim() === "" : K[P].length === 1 && K[P][0].length === 0), ne === "greedy" && ce) {
              for (var J = [], le = 0; le < R; le++) {
                var te = X ? Q[le] : le;
                J.push(K[P][te]);
              }
              j = J.join("").trim() === "";
            }
            if (!j) {
              for (var fe = 0; fe < R; fe++) {
                0 < fe && !W && (se += I);
                var De = ce && X ? Q[fe] : fe;
                se += ee(K[P][De], fe);
              }
              P < K.length - 1 && (!ne || 0 < R && !W) && (se += T);
            }
          }
          return se;
        }
        function ee(Q, K) {
          var ne, se, ce;
          return Q == null ? "" : Q.constructor === Date ? JSON.stringify(Q).slice(1, 25) : (ce = !1, M && typeof Q == "string" && M.test(Q) && (Q = "'" + Q, ce = !0), se = (ne = Q.toString()).replace(N, z), (ce = ce || O === !0 || typeof O == "function" && O(Q, K) || Array.isArray(O) && O[K] || ((X, D) => {
            for (var P = 0; P < D.length; P++) if (-1 < X.indexOf(D[P])) return !0;
            return !1;
          })(se, u.BAD_DELIMITERS) || -1 < se.indexOf(I) || -1 < ne.indexOf(V) || se.charAt(0) === " " || se.charAt(se.length - 1) === " ") ? V + se + V : se);
        }
      }, u.RECORD_SEP = "", u.UNIT_SEP = "", u.BYTE_ORDER_MARK = "\uFEFF", u.BAD_DELIMITERS = ["\r", `
`, '"', u.BYTE_ORDER_MARK], u.WORKERS_SUPPORTED = !o && !!r.Worker, u.NODE_STREAM_INPUT = 1, u.LocalChunkSize = 10485760, u.RemoteChunkSize = 5242880, u.DefaultDelimiter = ",", u.Parser = _, u.ParserHandle = m, u.NetworkStreamer = d, u.FileStreamer = p, u.StringStreamer = h, u.ReadableStreamStreamer = v, r.jQuery && ((i = r.jQuery).fn.parse = function(y) {
        var b = y.config || {}, O = [];
        return this.each(function(T) {
          if (!(i(this).prop("tagName").toUpperCase() === "INPUT" && i(this).attr("type").toLowerCase() === "file" && r.FileReader) || !this.files || this.files.length === 0) return !0;
          for (var V = 0; V < this.files.length; V++) O.push({ file: this.files[V], inputElem: this, instanceConfig: i.extend({}, b) });
        }), k(), this;
        function k() {
          if (O.length === 0) E(y.complete) && y.complete();
          else {
            var T, V, z, B, q = O[0];
            if (E(y.before)) {
              var M = y.before(q.file, q.inputElem);
              if (typeof M == "object") {
                if (M.action === "abort") return T = "AbortError", V = q.file, z = q.inputElem, B = M.reason, void (E(y.error) && y.error({ name: T }, V, z, B));
                if (M.action === "skip") return void I();
                typeof M.config == "object" && (q.instanceConfig = i.extend(q.instanceConfig, M.config));
              } else if (M === "skip") return void I();
            }
            var N = q.instanceConfig.complete;
            q.instanceConfig.complete = function(Y) {
              E(N) && N(Y, q.file, q.inputElem), I();
            }, u.parse(q.file, q.instanceConfig);
          }
        }
        function I() {
          O.splice(0, 1), k();
        }
      }), a && (r.onmessage = function(y) {
        y = y.data, u.WORKER_ID === void 0 && y && (u.WORKER_ID = y.workerId), typeof y.input == "string" ? r.postMessage({ workerId: u.WORKER_ID, results: u.parse(y.input, y.config), finished: !0 }) : (r.File && y.input instanceof File || y.input instanceof Object) && (y = u.parse(y.input, y.config)) && r.postMessage({ workerId: u.WORKER_ID, results: y, finished: !0 });
      }), (d.prototype = Object.create(f.prototype)).constructor = d, (p.prototype = Object.create(f.prototype)).constructor = p, (h.prototype = Object.create(h.prototype)).constructor = h, (v.prototype = Object.create(f.prototype)).constructor = v, u;
    });
  })(Jf)), Jf.exports;
}
var Dle = kle();
const Ale = (e) => /* @__PURE__ */ C.jsx(
  "table",
  {
    className: "bg-neutral-200 mb-4 border-collapse rounded border-none",
    ...e
  }
), Cle = ({ data: e }) => {
  const [t, n] = Ve(null), r = async () => {
    const i = await e.text();
    Dle.parse(i, {
      complete: (o) => n(o.data)
    });
  };
  return Ee(() => {
    r();
  }, [e]), t ? /* @__PURE__ */ C.jsx("div", { className: "p-4 rounded-md bg-neutral-200", children: /* @__PURE__ */ C.jsx(Ale, { children: /* @__PURE__ */ C.jsx("tbody", { children: t.map((i, o) => /* @__PURE__ */ C.jsx("tr", { children: Object.keys(i).map((a, s) => /* @__PURE__ */ C.jsx("td", { children: i[a] }, `cell-${o * s}`)) }, `row-${o}`)) }) }) }) : /* @__PURE__ */ C.jsx("div", { className: "grid w-full h-full place-items-center", children: /* @__PURE__ */ C.jsx("p", { children: "Loading..." }) });
}, cO = 5e3, Eue = ({ bucket: e, fileKey: t }) => {
  if (!e || !t)
    return /* @__PURE__ */ C.jsx("div", { children: "Invalid URL" });
  const n = t, r = n.endsWith(".pdf"), i = n.split(".").pop(), o = mle({
    variables: { bucket: e, key: n, limit: r ? void 0 : cO }
  }), [a] = gle(), [s, l] = Ve(null), u = n.split("/").pop() || n, c = Le(
    async (d) => {
      const h = await (await fetch(d, {
        headers: { Range: `bytes=0-${cO}` }
      })).blob();
      l(h);
    },
    [l]
  );
  if (Ee(() => {
    o.data?.presignedDownloadUrl && c(o.data.presignedDownloadUrl);
  }, [o.data?.presignedDownloadUrl, c]), !s)
    return /* @__PURE__ */ C.jsx("div", { className: "grid w-full h-full place-items-center", children: /* @__PURE__ */ C.jsx(Sle, {}) });
  let f;
  switch (i) {
    case "svg":
      f = /* @__PURE__ */ C.jsx(Tle, { data: s });
      break;
    case "csv":
    case "bed":
    case "fastq":
    case "tsv":
      f = /* @__PURE__ */ C.jsx(Cle, { data: s });
      break;
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "bmp":
    case "webp":
    case "tiff":
    case "tif":
    case "ico":
    case "jfif":
      f = /* @__PURE__ */ C.jsx(Ele, { data: s });
      break;
    case "pdf":
      f = /* @__PURE__ */ C.jsx($le, { url: o.data?.presignedDownloadUrl || "" });
      break;
    default:
      f = /* @__PURE__ */ C.jsx("div", { children: "Preview not available for this file type" });
      break;
  }
  return /* @__PURE__ */ C.jsxs("div", { className: "flex flex-col w-full h-full overflow-scroll", children: [
    /* @__PURE__ */ C.jsx(C3, { title: u, children: /* @__PURE__ */ C.jsx(
      Ty,
      {
        onClick: async () => {
          const p = (await a({ variables: { bucket: e, key: n } })).data?.presignedDownloadUrl;
          p && window.open(p);
        },
        variant: "gray",
        children: "Download"
      }
    ) }),
    /* @__PURE__ */ C.jsx("div", { className: "flex justify-around w-full", children: f })
  ] });
}, Ile = ({
  validate: e,
  children: t,
  onFailure: n
}) => {
  const [r, i] = Ve(!0), o = Le(async () => {
    await e() ? i(!1) : n();
  }, []);
  return Ee(() => {
    o();
  }, []), r ? null : /* @__PURE__ */ C.jsx(C.Fragment, { children: t });
};
function Nle(e, t) {
  return t.some(
    (n) => e.some((r) => r.role === n)
  );
}
const Sue = ({
  roles: e,
  children: t,
  loginUrl: n
}) => {
  const [r] = vle({ fetchPolicy: "cache-first" });
  return /* @__PURE__ */ C.jsx(
    Ile,
    {
      onFailure: () => {
        window.location.href = `${n}?redirect=${encodeURIComponent(
          window.location.href
        )}`;
      },
      validate: async () => {
        const i = await r();
        return !(!i.data?.me || !Nle(i.data.me.roles || [], e));
      },
      children: t
    }
  );
}, Oue = ({
  path: e,
  className: t,
  children: n,
  endpoint: r
}) => {
  const i = `${r}/download?bucket=${e}&key=${e}&isFolder=${e.isFolder ? 1 : 0}`;
  return /* @__PURE__ */ C.jsx("a", { className: t, href: i, download: "asfdkl", children: n });
};
function $f(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var rm = { exports: {} }, fO;
function Rle() {
  return fO || (fO = 1, (function(e, t) {
    (function(n) {
      e.exports = n();
    })(function() {
      return (function n(r, i, o) {
        function a(u, c) {
          if (!i[u]) {
            if (!r[u]) {
              var f = typeof $f == "function" && $f;
              if (!c && f) return f(u, !0);
              if (s) return s(u, !0);
              throw new Error("Cannot find module '" + u + "'");
            }
            c = i[u] = { exports: {} }, r[u][0].call(c.exports, function(d) {
              var p = r[u][1][d];
              return a(p || d);
            }, c, c.exports, n, r, i, o);
          }
          return i[u].exports;
        }
        for (var s = typeof $f == "function" && $f, l = 0; l < o.length; l++) a(o[l]);
        return a;
      })({ 1: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h = n("crypto");
          function v($, A) {
            A = _($, A);
            var E;
            return (E = A.algorithm !== "passthrough" ? h.createHash(A.algorithm) : new S()).write === void 0 && (E.write = E.update, E.end = E.update), x(A, E).dispatch($), E.update || E.end(""), E.digest ? E.digest(A.encoding === "buffer" ? void 0 : A.encoding) : ($ = E.read(), A.encoding !== "buffer" ? $.toString(A.encoding) : $);
          }
          (i = r.exports = v).sha1 = function($) {
            return v($);
          }, i.keys = function($) {
            return v($, { excludeValues: !0, algorithm: "sha1", encoding: "hex" });
          }, i.MD5 = function($) {
            return v($, { algorithm: "md5", encoding: "hex" });
          }, i.keysMD5 = function($) {
            return v($, { algorithm: "md5", encoding: "hex", excludeValues: !0 });
          };
          var m = h.getHashes ? h.getHashes().slice() : ["sha1", "md5"], g = (m.push("passthrough"), ["buffer", "hex", "binary", "base64"]);
          function _($, A) {
            var E = {};
            if (E.algorithm = (A = A || {}).algorithm || "sha1", E.encoding = A.encoding || "hex", E.excludeValues = !!A.excludeValues, E.algorithm = E.algorithm.toLowerCase(), E.encoding = E.encoding.toLowerCase(), E.ignoreUnknown = A.ignoreUnknown === !0, E.respectType = A.respectType !== !1, E.respectFunctionNames = A.respectFunctionNames !== !1, E.respectFunctionProperties = A.respectFunctionProperties !== !1, E.unorderedArrays = A.unorderedArrays === !0, E.unorderedSets = A.unorderedSets !== !1, E.unorderedObjects = A.unorderedObjects !== !1, E.replacer = A.replacer || void 0, E.excludeKeys = A.excludeKeys || void 0, $ === void 0) throw new Error("Object argument required.");
            for (var y = 0; y < m.length; ++y) m[y].toLowerCase() === E.algorithm.toLowerCase() && (E.algorithm = m[y]);
            if (m.indexOf(E.algorithm) === -1) throw new Error('Algorithm "' + E.algorithm + '"  not supported. supported values: ' + m.join(", "));
            if (g.indexOf(E.encoding) === -1 && E.algorithm !== "passthrough") throw new Error('Encoding "' + E.encoding + '"  not supported. supported values: ' + g.join(", "));
            return E;
          }
          function w($) {
            if (typeof $ == "function") return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call($)) != null;
          }
          function x($, A, E) {
            E = E || [];
            function y(b) {
              return A.update ? A.update(b, "utf8") : A.write(b, "utf8");
            }
            return { dispatch: function(b) {
              return this["_" + ((b = $.replacer ? $.replacer(b) : b) === null ? "null" : typeof b)](b);
            }, _object: function(b) {
              var O, k = Object.prototype.toString.call(b), I = /\[object (.*)\]/i.exec(k);
              if (I = (I = I ? I[1] : "unknown:[" + k + "]").toLowerCase(), 0 <= (k = E.indexOf(b))) return this.dispatch("[CIRCULAR:" + k + "]");
              if (E.push(b), s !== void 0 && s.isBuffer && s.isBuffer(b)) return y("buffer:"), y(b);
              if (I === "object" || I === "function" || I === "asyncfunction") return k = Object.keys(b), $.unorderedObjects && (k = k.sort()), $.respectType === !1 || w(b) || k.splice(0, 0, "prototype", "__proto__", "constructor"), $.excludeKeys && (k = k.filter(function(T) {
                return !$.excludeKeys(T);
              })), y("object:" + k.length + ":"), O = this, k.forEach(function(T) {
                O.dispatch(T), y(":"), $.excludeValues || O.dispatch(b[T]), y(",");
              });
              if (!this["_" + I]) {
                if ($.ignoreUnknown) return y("[" + I + "]");
                throw new Error('Unknown object type "' + I + '"');
              }
              this["_" + I](b);
            }, _array: function(b, T) {
              T = T !== void 0 ? T : $.unorderedArrays !== !1;
              var k = this;
              if (y("array:" + b.length + ":"), !T || b.length <= 1) return b.forEach(function(V) {
                return k.dispatch(V);
              });
              var I = [], T = b.map(function(V) {
                var z = new S(), B = E.slice();
                return x($, z, B).dispatch(V), I = I.concat(B.slice(E.length)), z.read().toString();
              });
              return E = E.concat(I), T.sort(), this._array(T, !1);
            }, _date: function(b) {
              return y("date:" + b.toJSON());
            }, _symbol: function(b) {
              return y("symbol:" + b.toString());
            }, _error: function(b) {
              return y("error:" + b.toString());
            }, _boolean: function(b) {
              return y("bool:" + b.toString());
            }, _string: function(b) {
              y("string:" + b.length + ":"), y(b.toString());
            }, _function: function(b) {
              y("fn:"), w(b) ? this.dispatch("[native]") : this.dispatch(b.toString()), $.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(b.name)), $.respectFunctionProperties && this._object(b);
            }, _number: function(b) {
              return y("number:" + b.toString());
            }, _xml: function(b) {
              return y("xml:" + b.toString());
            }, _null: function() {
              return y("Null");
            }, _undefined: function() {
              return y("Undefined");
            }, _regexp: function(b) {
              return y("regex:" + b.toString());
            }, _uint8array: function(b) {
              return y("uint8array:"), this.dispatch(Array.prototype.slice.call(b));
            }, _uint8clampedarray: function(b) {
              return y("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(b));
            }, _int8array: function(b) {
              return y("int8array:"), this.dispatch(Array.prototype.slice.call(b));
            }, _uint16array: function(b) {
              return y("uint16array:"), this.dispatch(Array.prototype.slice.call(b));
            }, _int16array: function(b) {
              return y("int16array:"), this.dispatch(Array.prototype.slice.call(b));
            }, _uint32array: function(b) {
              return y("uint32array:"), this.dispatch(Array.prototype.slice.call(b));
            }, _int32array: function(b) {
              return y("int32array:"), this.dispatch(Array.prototype.slice.call(b));
            }, _float32array: function(b) {
              return y("float32array:"), this.dispatch(Array.prototype.slice.call(b));
            }, _float64array: function(b) {
              return y("float64array:"), this.dispatch(Array.prototype.slice.call(b));
            }, _arraybuffer: function(b) {
              return y("arraybuffer:"), this.dispatch(new Uint8Array(b));
            }, _url: function(b) {
              return y("url:" + b.toString());
            }, _map: function(b) {
              return y("map:"), b = Array.from(b), this._array(b, $.unorderedSets !== !1);
            }, _set: function(b) {
              return y("set:"), b = Array.from(b), this._array(b, $.unorderedSets !== !1);
            }, _file: function(b) {
              return y("file:"), this.dispatch([b.name, b.size, b.type, b.lastModfied]);
            }, _blob: function() {
              if ($.ignoreUnknown) return y("[blob]");
              throw Error(`Hashing Blob objects is currently not supported
(see https://github.com/puleos/object-hash/issues/26)
Use "options.replacer" or "options.ignoreUnknown"
`);
            }, _domwindow: function() {
              return y("domwindow");
            }, _bigint: function(b) {
              return y("bigint:" + b.toString());
            }, _process: function() {
              return y("process");
            }, _timer: function() {
              return y("timer");
            }, _pipe: function() {
              return y("pipe");
            }, _tcp: function() {
              return y("tcp");
            }, _udp: function() {
              return y("udp");
            }, _tty: function() {
              return y("tty");
            }, _statwatcher: function() {
              return y("statwatcher");
            }, _securecontext: function() {
              return y("securecontext");
            }, _connection: function() {
              return y("connection");
            }, _zlib: function() {
              return y("zlib");
            }, _context: function() {
              return y("context");
            }, _nodescript: function() {
              return y("nodescript");
            }, _httpparser: function() {
              return y("httpparser");
            }, _dataview: function() {
              return y("dataview");
            }, _signal: function() {
              return y("signal");
            }, _fsevent: function() {
              return y("fsevent");
            }, _tlswrap: function() {
              return y("tlswrap");
            } };
          }
          function S() {
            return { buf: "", write: function($) {
              this.buf += $;
            }, end: function($) {
              this.buf += $;
            }, read: function() {
              return this.buf;
            } };
          }
          i.writeToStream = function($, A, E) {
            return E === void 0 && (E = A, A = {}), x(A = _($, A), E).dispatch($);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
      }, { buffer: 3, crypto: 5, lYpoI2: 11 }], 2: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          (function(h) {
            var v = typeof Uint8Array < "u" ? Uint8Array : Array, m = 43, g = 47, _ = 48, w = 97, x = 65, S = 45, $ = 95;
            function A(E) {
              return E = E.charCodeAt(0), E === m || E === S ? 62 : E === g || E === $ ? 63 : E < _ ? -1 : E < _ + 10 ? E - _ + 26 + 26 : E < x + 26 ? E - x : E < w + 26 ? E - w + 26 : void 0;
            }
            h.toByteArray = function(E) {
              var y, b;
              if (0 < E.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
              var O = E.length, O = E.charAt(O - 2) === "=" ? 2 : E.charAt(O - 1) === "=" ? 1 : 0, k = new v(3 * E.length / 4 - O), I = 0 < O ? E.length - 4 : E.length, T = 0;
              function V(z) {
                k[T++] = z;
              }
              for (y = 0; y < I; y += 4, 0) V((16711680 & (b = A(E.charAt(y)) << 18 | A(E.charAt(y + 1)) << 12 | A(E.charAt(y + 2)) << 6 | A(E.charAt(y + 3)))) >> 16), V((65280 & b) >> 8), V(255 & b);
              return O == 2 ? V(255 & (b = A(E.charAt(y)) << 2 | A(E.charAt(y + 1)) >> 4)) : O == 1 && (V((b = A(E.charAt(y)) << 10 | A(E.charAt(y + 1)) << 4 | A(E.charAt(y + 2)) >> 2) >> 8 & 255), V(255 & b)), k;
            }, h.fromByteArray = function(E) {
              var y, b, O, k, I = E.length % 3, T = "";
              function V(z) {
                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(z);
              }
              for (y = 0, O = E.length - I; y < O; y += 3) b = (E[y] << 16) + (E[y + 1] << 8) + E[y + 2], T += V((k = b) >> 18 & 63) + V(k >> 12 & 63) + V(k >> 6 & 63) + V(63 & k);
              switch (I) {
                case 1:
                  T = (T += V((b = E[E.length - 1]) >> 2)) + V(b << 4 & 63) + "==";
                  break;
                case 2:
                  T = (T = (T += V((b = (E[E.length - 2] << 8) + E[E.length - 1]) >> 10)) + V(b >> 4 & 63)) + V(b << 2 & 63) + "=";
              }
              return T;
            };
          })(i === void 0 ? this.base64js = {} : i);
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
      }, { buffer: 3, lYpoI2: 11 }], 3: [function(n, r, i) {
        (function(o, a, m, l, u, c, f, d, p) {
          var h = n("base64-js"), v = n("ieee754");
          function m(D, P, R) {
            if (!(this instanceof m)) return new m(D, P, R);
            var j, W, J, le, te = typeof D;
            if (P === "base64" && te == "string") for (D = (le = D).trim ? le.trim() : le.replace(/^\s+|\s+$/g, ""); D.length % 4 != 0; ) D += "=";
            if (te == "number") j = q(D);
            else if (te == "string") j = m.byteLength(D, P);
            else {
              if (te != "object") throw new Error("First argument needs to be a number, array or string.");
              j = q(D.length);
            }
            if (m._useTypedArrays ? W = m._augment(new Uint8Array(j)) : ((W = this).length = j, W._isBuffer = !0), m._useTypedArrays && typeof D.byteLength == "number") W._set(D);
            else if (M(le = D) || m.isBuffer(le) || le && typeof le == "object" && typeof le.length == "number") for (J = 0; J < j; J++) m.isBuffer(D) ? W[J] = D.readUInt8(J) : W[J] = D[J];
            else if (te == "string") W.write(D, 0, P);
            else if (te == "number" && !m._useTypedArrays && !R) for (J = 0; J < j; J++) W[J] = 0;
            return W;
          }
          function g(D, P, R, j) {
            return m._charsWritten = Q((function(W) {
              for (var J = [], le = 0; le < W.length; le++) J.push(255 & W.charCodeAt(le));
              return J;
            })(P), D, R, j);
          }
          function _(D, P, R, j) {
            return m._charsWritten = Q((function(W) {
              for (var J, le, te = [], fe = 0; fe < W.length; fe++) le = W.charCodeAt(fe), J = le >> 8, le = le % 256, te.push(le), te.push(J);
              return te;
            })(P), D, R, j);
          }
          function w(D, P, R) {
            var j = "";
            R = Math.min(D.length, R);
            for (var W = P; W < R; W++) j += String.fromCharCode(D[W]);
            return j;
          }
          function x(D, P, R, J) {
            J || (X(typeof R == "boolean", "missing or invalid endian"), X(P != null, "missing offset"), X(P + 1 < D.length, "Trying to read beyond buffer length"));
            var W, J = D.length;
            if (!(J <= P)) return R ? (W = D[P], P + 1 < J && (W |= D[P + 1] << 8)) : (W = D[P] << 8, P + 1 < J && (W |= D[P + 1])), W;
          }
          function S(D, P, R, J) {
            J || (X(typeof R == "boolean", "missing or invalid endian"), X(P != null, "missing offset"), X(P + 3 < D.length, "Trying to read beyond buffer length"));
            var W, J = D.length;
            if (!(J <= P)) return R ? (P + 2 < J && (W = D[P + 2] << 16), P + 1 < J && (W |= D[P + 1] << 8), W |= D[P], P + 3 < J && (W += D[P + 3] << 24 >>> 0)) : (P + 1 < J && (W = D[P + 1] << 16), P + 2 < J && (W |= D[P + 2] << 8), P + 3 < J && (W |= D[P + 3]), W += D[P] << 24 >>> 0), W;
          }
          function $(D, P, R, j) {
            if (j || (X(typeof R == "boolean", "missing or invalid endian"), X(P != null, "missing offset"), X(P + 1 < D.length, "Trying to read beyond buffer length")), !(D.length <= P)) return j = x(D, P, R, !0), 32768 & j ? -1 * (65535 - j + 1) : j;
          }
          function A(D, P, R, j) {
            if (j || (X(typeof R == "boolean", "missing or invalid endian"), X(P != null, "missing offset"), X(P + 3 < D.length, "Trying to read beyond buffer length")), !(D.length <= P)) return j = S(D, P, R, !0), 2147483648 & j ? -1 * (4294967295 - j + 1) : j;
          }
          function E(D, P, R, j) {
            return j || (X(typeof R == "boolean", "missing or invalid endian"), X(P + 3 < D.length, "Trying to read beyond buffer length")), v.read(D, P, R, 23, 4);
          }
          function y(D, P, R, j) {
            return j || (X(typeof R == "boolean", "missing or invalid endian"), X(P + 7 < D.length, "Trying to read beyond buffer length")), v.read(D, P, R, 52, 8);
          }
          function b(D, P, R, j, W) {
            if (W || (X(P != null, "missing value"), X(typeof j == "boolean", "missing or invalid endian"), X(R != null, "missing offset"), X(R + 1 < D.length, "trying to write beyond buffer length"), ne(P, 65535)), W = D.length, !(W <= R)) for (var J = 0, le = Math.min(W - R, 2); J < le; J++) D[R + J] = (P & 255 << 8 * (j ? J : 1 - J)) >>> 8 * (j ? J : 1 - J);
          }
          function O(D, P, R, j, W) {
            if (W || (X(P != null, "missing value"), X(typeof j == "boolean", "missing or invalid endian"), X(R != null, "missing offset"), X(R + 3 < D.length, "trying to write beyond buffer length"), ne(P, 4294967295)), W = D.length, !(W <= R)) for (var J = 0, le = Math.min(W - R, 4); J < le; J++) D[R + J] = P >>> 8 * (j ? J : 3 - J) & 255;
          }
          function k(D, P, R, j, W) {
            W || (X(P != null, "missing value"), X(typeof j == "boolean", "missing or invalid endian"), X(R != null, "missing offset"), X(R + 1 < D.length, "Trying to write beyond buffer length"), se(P, 32767, -32768)), D.length <= R || b(D, 0 <= P ? P : 65535 + P + 1, R, j, W);
          }
          function I(D, P, R, j, W) {
            W || (X(P != null, "missing value"), X(typeof j == "boolean", "missing or invalid endian"), X(R != null, "missing offset"), X(R + 3 < D.length, "Trying to write beyond buffer length"), se(P, 2147483647, -2147483648)), D.length <= R || O(D, 0 <= P ? P : 4294967295 + P + 1, R, j, W);
          }
          function T(D, P, R, j, W) {
            W || (X(P != null, "missing value"), X(typeof j == "boolean", "missing or invalid endian"), X(R != null, "missing offset"), X(R + 3 < D.length, "Trying to write beyond buffer length"), ce(P, 34028234663852886e22, -34028234663852886e22)), D.length <= R || v.write(D, P, R, j, 23, 4);
          }
          function V(D, P, R, j, W) {
            W || (X(P != null, "missing value"), X(typeof j == "boolean", "missing or invalid endian"), X(R != null, "missing offset"), X(R + 7 < D.length, "Trying to write beyond buffer length"), ce(P, 17976931348623157e292, -17976931348623157e292)), D.length <= R || v.write(D, P, R, j, 52, 8);
          }
          i.Buffer = m, i.SlowBuffer = m, i.INSPECT_MAX_BYTES = 50, m.poolSize = 8192, m._useTypedArrays = (function() {
            try {
              var D = new ArrayBuffer(0), P = new Uint8Array(D);
              return P.foo = function() {
                return 42;
              }, P.foo() === 42 && typeof P.subarray == "function";
            } catch {
              return !1;
            }
          })(), m.isEncoding = function(D) {
            switch (String(D).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "binary":
              case "base64":
              case "raw":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, m.isBuffer = function(D) {
            return !(D == null || !D._isBuffer);
          }, m.byteLength = function(D, P) {
            var R;
            switch (D += "", P || "utf8") {
              case "hex":
                R = D.length / 2;
                break;
              case "utf8":
              case "utf-8":
                R = Y(D).length;
                break;
              case "ascii":
              case "binary":
              case "raw":
                R = D.length;
                break;
              case "base64":
                R = ee(D).length;
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                R = 2 * D.length;
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return R;
          }, m.concat = function(D, P) {
            if (X(M(D), `Usage: Buffer.concat(list, [totalLength])
list should be an Array.`), D.length === 0) return new m(0);
            if (D.length === 1) return D[0];
            if (typeof P != "number") for (W = P = 0; W < D.length; W++) P += D[W].length;
            for (var R = new m(P), j = 0, W = 0; W < D.length; W++) {
              var J = D[W];
              J.copy(R, j), j += J.length;
            }
            return R;
          }, m.prototype.write = function(D, P, R, j) {
            isFinite(P) ? isFinite(R) || (j = R, R = void 0) : (fe = j, j = P, P = R, R = fe), P = Number(P) || 0;
            var W, J, le, te, fe = this.length - P;
            switch ((!R || fe < (R = Number(R))) && (R = fe), j = String(j || "utf8").toLowerCase()) {
              case "hex":
                W = (function(De, he, Oe, de) {
                  Oe = Number(Oe) || 0;
                  var Ue = De.length - Oe;
                  (!de || Ue < (de = Number(de))) && (de = Ue), X((Ue = he.length) % 2 == 0, "Invalid hex string"), Ue / 2 < de && (de = Ue / 2);
                  for (var tt = 0; tt < de; tt++) {
                    var vn = parseInt(he.substr(2 * tt, 2), 16);
                    X(!isNaN(vn), "Invalid hex string"), De[Oe + tt] = vn;
                  }
                  return m._charsWritten = 2 * tt, tt;
                })(this, D, P, R);
                break;
              case "utf8":
              case "utf-8":
                J = this, le = P, te = R, W = m._charsWritten = Q(Y(D), J, le, te);
                break;
              case "ascii":
              case "binary":
                W = g(this, D, P, R);
                break;
              case "base64":
                J = this, le = P, te = R, W = m._charsWritten = Q(ee(D), J, le, te);
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                W = _(this, D, P, R);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return W;
          }, m.prototype.toString = function(D, P, R) {
            var j, W, J, le, te = this;
            if (D = String(D || "utf8").toLowerCase(), P = Number(P) || 0, (R = R !== void 0 ? Number(R) : te.length) === P) return "";
            switch (D) {
              case "hex":
                j = (function(fe, De, he) {
                  var Oe = fe.length;
                  (!De || De < 0) && (De = 0), (!he || he < 0 || Oe < he) && (he = Oe);
                  for (var de = "", Ue = De; Ue < he; Ue++) de += N(fe[Ue]);
                  return de;
                })(te, P, R);
                break;
              case "utf8":
              case "utf-8":
                j = (function(fe, De, he) {
                  var Oe = "", de = "";
                  he = Math.min(fe.length, he);
                  for (var Ue = De; Ue < he; Ue++) fe[Ue] <= 127 ? (Oe += K(de) + String.fromCharCode(fe[Ue]), de = "") : de += "%" + fe[Ue].toString(16);
                  return Oe + K(de);
                })(te, P, R);
                break;
              case "ascii":
              case "binary":
                j = w(te, P, R);
                break;
              case "base64":
                W = te, le = R, j = (J = P) === 0 && le === W.length ? h.fromByteArray(W) : h.fromByteArray(W.slice(J, le));
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                j = (function(fe, De, he) {
                  for (var Oe = fe.slice(De, he), de = "", Ue = 0; Ue < Oe.length; Ue += 2) de += String.fromCharCode(Oe[Ue] + 256 * Oe[Ue + 1]);
                  return de;
                })(te, P, R);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return j;
          }, m.prototype.toJSON = function() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          }, m.prototype.copy = function(D, P, R, j) {
            if (P = P || 0, (j = j || j === 0 ? j : this.length) !== (R = R || 0) && D.length !== 0 && this.length !== 0) {
              X(R <= j, "sourceEnd < sourceStart"), X(0 <= P && P < D.length, "targetStart out of bounds"), X(0 <= R && R < this.length, "sourceStart out of bounds"), X(0 <= j && j <= this.length, "sourceEnd out of bounds"), j > this.length && (j = this.length);
              var W = (j = D.length - P < j - R ? D.length - P + R : j) - R;
              if (W < 100 || !m._useTypedArrays) for (var J = 0; J < W; J++) D[J + P] = this[J + R];
              else D._set(this.subarray(R, R + W), P);
            }
          }, m.prototype.slice = function(D, P) {
            var R = this.length;
            if (D = B(D, R, 0), P = B(P, R, R), m._useTypedArrays) return m._augment(this.subarray(D, P));
            for (var j = P - D, W = new m(j, void 0, !0), J = 0; J < j; J++) W[J] = this[J + D];
            return W;
          }, m.prototype.get = function(D) {
            return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(D);
          }, m.prototype.set = function(D, P) {
            return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(D, P);
          }, m.prototype.readUInt8 = function(D, P) {
            if (P || (X(D != null, "missing offset"), X(D < this.length, "Trying to read beyond buffer length")), !(D >= this.length)) return this[D];
          }, m.prototype.readUInt16LE = function(D, P) {
            return x(this, D, !0, P);
          }, m.prototype.readUInt16BE = function(D, P) {
            return x(this, D, !1, P);
          }, m.prototype.readUInt32LE = function(D, P) {
            return S(this, D, !0, P);
          }, m.prototype.readUInt32BE = function(D, P) {
            return S(this, D, !1, P);
          }, m.prototype.readInt8 = function(D, P) {
            if (P || (X(D != null, "missing offset"), X(D < this.length, "Trying to read beyond buffer length")), !(D >= this.length)) return 128 & this[D] ? -1 * (255 - this[D] + 1) : this[D];
          }, m.prototype.readInt16LE = function(D, P) {
            return $(this, D, !0, P);
          }, m.prototype.readInt16BE = function(D, P) {
            return $(this, D, !1, P);
          }, m.prototype.readInt32LE = function(D, P) {
            return A(this, D, !0, P);
          }, m.prototype.readInt32BE = function(D, P) {
            return A(this, D, !1, P);
          }, m.prototype.readFloatLE = function(D, P) {
            return E(this, D, !0, P);
          }, m.prototype.readFloatBE = function(D, P) {
            return E(this, D, !1, P);
          }, m.prototype.readDoubleLE = function(D, P) {
            return y(this, D, !0, P);
          }, m.prototype.readDoubleBE = function(D, P) {
            return y(this, D, !1, P);
          }, m.prototype.writeUInt8 = function(D, P, R) {
            R || (X(D != null, "missing value"), X(P != null, "missing offset"), X(P < this.length, "trying to write beyond buffer length"), ne(D, 255)), P >= this.length || (this[P] = D);
          }, m.prototype.writeUInt16LE = function(D, P, R) {
            b(this, D, P, !0, R);
          }, m.prototype.writeUInt16BE = function(D, P, R) {
            b(this, D, P, !1, R);
          }, m.prototype.writeUInt32LE = function(D, P, R) {
            O(this, D, P, !0, R);
          }, m.prototype.writeUInt32BE = function(D, P, R) {
            O(this, D, P, !1, R);
          }, m.prototype.writeInt8 = function(D, P, R) {
            R || (X(D != null, "missing value"), X(P != null, "missing offset"), X(P < this.length, "Trying to write beyond buffer length"), se(D, 127, -128)), P >= this.length || (0 <= D ? this.writeUInt8(D, P, R) : this.writeUInt8(255 + D + 1, P, R));
          }, m.prototype.writeInt16LE = function(D, P, R) {
            k(this, D, P, !0, R);
          }, m.prototype.writeInt16BE = function(D, P, R) {
            k(this, D, P, !1, R);
          }, m.prototype.writeInt32LE = function(D, P, R) {
            I(this, D, P, !0, R);
          }, m.prototype.writeInt32BE = function(D, P, R) {
            I(this, D, P, !1, R);
          }, m.prototype.writeFloatLE = function(D, P, R) {
            T(this, D, P, !0, R);
          }, m.prototype.writeFloatBE = function(D, P, R) {
            T(this, D, P, !1, R);
          }, m.prototype.writeDoubleLE = function(D, P, R) {
            V(this, D, P, !0, R);
          }, m.prototype.writeDoubleBE = function(D, P, R) {
            V(this, D, P, !1, R);
          }, m.prototype.fill = function(D, P, R) {
            if (P = P || 0, R = R || this.length, X(typeof (D = typeof (D = D || 0) == "string" ? D.charCodeAt(0) : D) == "number" && !isNaN(D), "value is not a number"), X(P <= R, "end < start"), R !== P && this.length !== 0) {
              X(0 <= P && P < this.length, "start out of bounds"), X(0 <= R && R <= this.length, "end out of bounds");
              for (var j = P; j < R; j++) this[j] = D;
            }
          }, m.prototype.inspect = function() {
            for (var D = [], P = this.length, R = 0; R < P; R++) if (D[R] = N(this[R]), R === i.INSPECT_MAX_BYTES) {
              D[R + 1] = "...";
              break;
            }
            return "<Buffer " + D.join(" ") + ">";
          }, m.prototype.toArrayBuffer = function() {
            if (typeof Uint8Array > "u") throw new Error("Buffer.toArrayBuffer not supported in this browser");
            if (m._useTypedArrays) return new m(this).buffer;
            for (var D = new Uint8Array(this.length), P = 0, R = D.length; P < R; P += 1) D[P] = this[P];
            return D.buffer;
          };
          var z = m.prototype;
          function B(D, P, R) {
            return typeof D != "number" ? R : P <= (D = ~~D) ? P : 0 <= D || 0 <= (D += P) ? D : 0;
          }
          function q(D) {
            return (D = ~~Math.ceil(+D)) < 0 ? 0 : D;
          }
          function M(D) {
            return (Array.isArray || function(P) {
              return Object.prototype.toString.call(P) === "[object Array]";
            })(D);
          }
          function N(D) {
            return D < 16 ? "0" + D.toString(16) : D.toString(16);
          }
          function Y(D) {
            for (var P = [], R = 0; R < D.length; R++) {
              var j = D.charCodeAt(R);
              if (j <= 127) P.push(D.charCodeAt(R));
              else for (var W = R, J = (55296 <= j && j <= 57343 && R++, encodeURIComponent(D.slice(W, R + 1)).substr(1).split("%")), le = 0; le < J.length; le++) P.push(parseInt(J[le], 16));
            }
            return P;
          }
          function ee(D) {
            return h.toByteArray(D);
          }
          function Q(D, P, R, j) {
            for (var W = 0; W < j && !(W + R >= P.length || W >= D.length); W++) P[W + R] = D[W];
            return W;
          }
          function K(D) {
            try {
              return decodeURIComponent(D);
            } catch {
              return "�";
            }
          }
          function ne(D, P) {
            X(typeof D == "number", "cannot write a non-number as a number"), X(0 <= D, "specified a negative value for writing an unsigned value"), X(D <= P, "value is larger than maximum value for type"), X(Math.floor(D) === D, "value has a fractional component");
          }
          function se(D, P, R) {
            X(typeof D == "number", "cannot write a non-number as a number"), X(D <= P, "value larger than maximum allowed value"), X(R <= D, "value smaller than minimum allowed value"), X(Math.floor(D) === D, "value has a fractional component");
          }
          function ce(D, P, R) {
            X(typeof D == "number", "cannot write a non-number as a number"), X(D <= P, "value larger than maximum allowed value"), X(R <= D, "value smaller than minimum allowed value");
          }
          function X(D, P) {
            if (!D) throw new Error(P || "Failed assertion");
          }
          m._augment = function(D) {
            return D._isBuffer = !0, D._get = D.get, D._set = D.set, D.get = z.get, D.set = z.set, D.write = z.write, D.toString = z.toString, D.toLocaleString = z.toString, D.toJSON = z.toJSON, D.copy = z.copy, D.slice = z.slice, D.readUInt8 = z.readUInt8, D.readUInt16LE = z.readUInt16LE, D.readUInt16BE = z.readUInt16BE, D.readUInt32LE = z.readUInt32LE, D.readUInt32BE = z.readUInt32BE, D.readInt8 = z.readInt8, D.readInt16LE = z.readInt16LE, D.readInt16BE = z.readInt16BE, D.readInt32LE = z.readInt32LE, D.readInt32BE = z.readInt32BE, D.readFloatLE = z.readFloatLE, D.readFloatBE = z.readFloatBE, D.readDoubleLE = z.readDoubleLE, D.readDoubleBE = z.readDoubleBE, D.writeUInt8 = z.writeUInt8, D.writeUInt16LE = z.writeUInt16LE, D.writeUInt16BE = z.writeUInt16BE, D.writeUInt32LE = z.writeUInt32LE, D.writeUInt32BE = z.writeUInt32BE, D.writeInt8 = z.writeInt8, D.writeInt16LE = z.writeInt16LE, D.writeInt16BE = z.writeInt16BE, D.writeInt32LE = z.writeInt32LE, D.writeInt32BE = z.writeInt32BE, D.writeFloatLE = z.writeFloatLE, D.writeFloatBE = z.writeFloatBE, D.writeDoubleLE = z.writeDoubleLE, D.writeDoubleBE = z.writeDoubleBE, D.fill = z.fill, D.inspect = z.inspect, D.toArrayBuffer = z.toArrayBuffer, D;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
      }, { "base64-js": 2, buffer: 3, ieee754: 10, lYpoI2: 11 }], 4: [function(n, r, i) {
        (function(o, a, h, l, u, c, f, d, p) {
          var h = n("buffer").Buffer, v = 4, m = new h(v);
          m.fill(0), r.exports = { hash: function(g, _, w, x) {
            for (var S = _((function(b, O) {
              b.length % v != 0 && (k = b.length + (v - b.length % v), b = h.concat([b, m], k));
              for (var k, I = [], T = O ? b.readInt32BE : b.readInt32LE, V = 0; V < b.length; V += v) I.push(T.call(b, V));
              return I;
            })(g = h.isBuffer(g) ? g : new h(g), x), 8 * g.length), _ = x, $ = new h(w), A = _ ? $.writeInt32BE : $.writeInt32LE, E = 0; E < S.length; E++) A.call($, S[E], 4 * E, !0);
            return $;
          } };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 5: [function(n, r, i) {
        (function(o, a, h, l, u, c, f, d, p) {
          var h = n("buffer").Buffer, v = n("./sha"), m = n("./sha256"), g = n("./rng"), _ = { sha1: v, sha256: m, md5: n("./md5") }, w = 64, x = new h(w);
          function S(b, O) {
            var k = _[b = b || "sha1"], I = [];
            return k || $("algorithm:", b, "is not yet supported"), { update: function(T) {
              return h.isBuffer(T) || (T = new h(T)), I.push(T), T.length, this;
            }, digest: function(T) {
              var V = h.concat(I), V = O ? (function(z, B, q) {
                h.isBuffer(B) || (B = new h(B)), h.isBuffer(q) || (q = new h(q)), B.length > w ? B = z(B) : B.length < w && (B = h.concat([B, x], w));
                for (var M = new h(w), N = new h(w), Y = 0; Y < w; Y++) M[Y] = 54 ^ B[Y], N[Y] = 92 ^ B[Y];
                return q = z(h.concat([M, q])), z(h.concat([N, q]));
              })(k, O, V) : k(V);
              return I = null, T ? V.toString(T) : V;
            } };
          }
          function $() {
            var b = [].slice.call(arguments).join(" ");
            throw new Error([b, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join(`
`));
          }
          x.fill(0), i.createHash = function(b) {
            return S(b);
          }, i.createHmac = S, i.randomBytes = function(b, O) {
            if (!O || !O.call) return new h(g(b));
            try {
              O.call(this, void 0, new h(g(b)));
            } catch (k) {
              O(k);
            }
          };
          var A, E = ["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], y = function(b) {
            i[b] = function() {
              $("sorry,", b, "is not implemented yet");
            };
          };
          for (A in E) y(E[A]);
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./md5": 6, "./rng": 7, "./sha": 8, "./sha256": 9, buffer: 3, lYpoI2: 11 }], 6: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h = n("./helpers");
          function v($, A) {
            $[A >> 5] |= 128 << A % 32, $[14 + (A + 64 >>> 9 << 4)] = A;
            for (var E = 1732584193, y = -271733879, b = -1732584194, O = 271733878, k = 0; k < $.length; k += 16) {
              var I = E, T = y, V = b, z = O, E = g(E, y, b, O, $[k + 0], 7, -680876936), O = g(O, E, y, b, $[k + 1], 12, -389564586), b = g(b, O, E, y, $[k + 2], 17, 606105819), y = g(y, b, O, E, $[k + 3], 22, -1044525330);
              E = g(E, y, b, O, $[k + 4], 7, -176418897), O = g(O, E, y, b, $[k + 5], 12, 1200080426), b = g(b, O, E, y, $[k + 6], 17, -1473231341), y = g(y, b, O, E, $[k + 7], 22, -45705983), E = g(E, y, b, O, $[k + 8], 7, 1770035416), O = g(O, E, y, b, $[k + 9], 12, -1958414417), b = g(b, O, E, y, $[k + 10], 17, -42063), y = g(y, b, O, E, $[k + 11], 22, -1990404162), E = g(E, y, b, O, $[k + 12], 7, 1804603682), O = g(O, E, y, b, $[k + 13], 12, -40341101), b = g(b, O, E, y, $[k + 14], 17, -1502002290), E = _(E, y = g(y, b, O, E, $[k + 15], 22, 1236535329), b, O, $[k + 1], 5, -165796510), O = _(O, E, y, b, $[k + 6], 9, -1069501632), b = _(b, O, E, y, $[k + 11], 14, 643717713), y = _(y, b, O, E, $[k + 0], 20, -373897302), E = _(E, y, b, O, $[k + 5], 5, -701558691), O = _(O, E, y, b, $[k + 10], 9, 38016083), b = _(b, O, E, y, $[k + 15], 14, -660478335), y = _(y, b, O, E, $[k + 4], 20, -405537848), E = _(E, y, b, O, $[k + 9], 5, 568446438), O = _(O, E, y, b, $[k + 14], 9, -1019803690), b = _(b, O, E, y, $[k + 3], 14, -187363961), y = _(y, b, O, E, $[k + 8], 20, 1163531501), E = _(E, y, b, O, $[k + 13], 5, -1444681467), O = _(O, E, y, b, $[k + 2], 9, -51403784), b = _(b, O, E, y, $[k + 7], 14, 1735328473), E = w(E, y = _(y, b, O, E, $[k + 12], 20, -1926607734), b, O, $[k + 5], 4, -378558), O = w(O, E, y, b, $[k + 8], 11, -2022574463), b = w(b, O, E, y, $[k + 11], 16, 1839030562), y = w(y, b, O, E, $[k + 14], 23, -35309556), E = w(E, y, b, O, $[k + 1], 4, -1530992060), O = w(O, E, y, b, $[k + 4], 11, 1272893353), b = w(b, O, E, y, $[k + 7], 16, -155497632), y = w(y, b, O, E, $[k + 10], 23, -1094730640), E = w(E, y, b, O, $[k + 13], 4, 681279174), O = w(O, E, y, b, $[k + 0], 11, -358537222), b = w(b, O, E, y, $[k + 3], 16, -722521979), y = w(y, b, O, E, $[k + 6], 23, 76029189), E = w(E, y, b, O, $[k + 9], 4, -640364487), O = w(O, E, y, b, $[k + 12], 11, -421815835), b = w(b, O, E, y, $[k + 15], 16, 530742520), E = x(E, y = w(y, b, O, E, $[k + 2], 23, -995338651), b, O, $[k + 0], 6, -198630844), O = x(O, E, y, b, $[k + 7], 10, 1126891415), b = x(b, O, E, y, $[k + 14], 15, -1416354905), y = x(y, b, O, E, $[k + 5], 21, -57434055), E = x(E, y, b, O, $[k + 12], 6, 1700485571), O = x(O, E, y, b, $[k + 3], 10, -1894986606), b = x(b, O, E, y, $[k + 10], 15, -1051523), y = x(y, b, O, E, $[k + 1], 21, -2054922799), E = x(E, y, b, O, $[k + 8], 6, 1873313359), O = x(O, E, y, b, $[k + 15], 10, -30611744), b = x(b, O, E, y, $[k + 6], 15, -1560198380), y = x(y, b, O, E, $[k + 13], 21, 1309151649), E = x(E, y, b, O, $[k + 4], 6, -145523070), O = x(O, E, y, b, $[k + 11], 10, -1120210379), b = x(b, O, E, y, $[k + 2], 15, 718787259), y = x(y, b, O, E, $[k + 9], 21, -343485551), E = S(E, I), y = S(y, T), b = S(b, V), O = S(O, z);
            }
            return Array(E, y, b, O);
          }
          function m($, A, E, y, b, O) {
            return S((A = S(S(A, $), S(y, O))) << b | A >>> 32 - b, E);
          }
          function g($, A, E, y, b, O, k) {
            return m(A & E | ~A & y, $, A, b, O, k);
          }
          function _($, A, E, y, b, O, k) {
            return m(A & y | E & ~y, $, A, b, O, k);
          }
          function w($, A, E, y, b, O, k) {
            return m(A ^ E ^ y, $, A, b, O, k);
          }
          function x($, A, E, y, b, O, k) {
            return m(E ^ (A | ~y), $, A, b, O, k);
          }
          function S($, A) {
            var E = (65535 & $) + (65535 & A);
            return ($ >> 16) + (A >> 16) + (E >> 16) << 16 | 65535 & E;
          }
          r.exports = function($) {
            return h.hash($, v, 16);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 7: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          r.exports = function(h) {
            for (var v, m = new Array(h), g = 0; g < h; g++) (3 & g) == 0 && (v = 4294967296 * Math.random()), m[g] = v >>> ((3 & g) << 3) & 255;
            return m;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 8: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h = n("./helpers");
          function v(_, w) {
            _[w >> 5] |= 128 << 24 - w % 32, _[15 + (w + 64 >> 9 << 4)] = w;
            for (var x, S, $, A = Array(80), E = 1732584193, y = -271733879, b = -1732584194, O = 271733878, k = -1009589776, I = 0; I < _.length; I += 16) {
              for (var T = E, V = y, z = b, B = O, q = k, M = 0; M < 80; M++) {
                A[M] = M < 16 ? _[I + M] : g(A[M - 3] ^ A[M - 8] ^ A[M - 14] ^ A[M - 16], 1);
                var N = m(m(g(E, 5), (N = y, S = b, $ = O, (x = M) < 20 ? N & S | ~N & $ : !(x < 40) && x < 60 ? N & S | N & $ | S & $ : N ^ S ^ $)), m(m(k, A[M]), (x = M) < 20 ? 1518500249 : x < 40 ? 1859775393 : x < 60 ? -1894007588 : -899497514)), k = O, O = b, b = g(y, 30), y = E, E = N;
              }
              E = m(E, T), y = m(y, V), b = m(b, z), O = m(O, B), k = m(k, q);
            }
            return Array(E, y, b, O, k);
          }
          function m(_, w) {
            var x = (65535 & _) + (65535 & w);
            return (_ >> 16) + (w >> 16) + (x >> 16) << 16 | 65535 & x;
          }
          function g(_, w) {
            return _ << w | _ >>> 32 - w;
          }
          r.exports = function(_) {
            return h.hash(_, v, 20, !0);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 9: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          function h(w, x) {
            var S = (65535 & w) + (65535 & x);
            return (w >> 16) + (x >> 16) + (S >> 16) << 16 | 65535 & S;
          }
          function v(w, x) {
            var S, $ = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), A = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), E = new Array(64);
            w[x >> 5] |= 128 << 24 - x % 32, w[15 + (x + 64 >> 9 << 4)] = x;
            for (var y, b, O = 0; O < w.length; O += 16) {
              for (var k = A[0], I = A[1], T = A[2], V = A[3], z = A[4], B = A[5], q = A[6], M = A[7], N = 0; N < 64; N++) E[N] = N < 16 ? w[N + O] : h(h(h((b = E[N - 2], g(b, 17) ^ g(b, 19) ^ _(b, 10)), E[N - 7]), (b = E[N - 15], g(b, 7) ^ g(b, 18) ^ _(b, 3))), E[N - 16]), S = h(h(h(h(M, g(b = z, 6) ^ g(b, 11) ^ g(b, 25)), z & B ^ ~z & q), $[N]), E[N]), y = h(g(y = k, 2) ^ g(y, 13) ^ g(y, 22), k & I ^ k & T ^ I & T), M = q, q = B, B = z, z = h(V, S), V = T, T = I, I = k, k = h(S, y);
              A[0] = h(k, A[0]), A[1] = h(I, A[1]), A[2] = h(T, A[2]), A[3] = h(V, A[3]), A[4] = h(z, A[4]), A[5] = h(B, A[5]), A[6] = h(q, A[6]), A[7] = h(M, A[7]);
            }
            return A;
          }
          var m = n("./helpers"), g = function(w, x) {
            return w >>> x | w << 32 - x;
          }, _ = function(w, x) {
            return w >>> x;
          };
          r.exports = function(w) {
            return m.hash(w, v, 32, !0);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 10: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          i.read = function(h, v, m, g, O) {
            var w, x, S = 8 * O - g - 1, $ = (1 << S) - 1, A = $ >> 1, E = -7, y = m ? O - 1 : 0, b = m ? -1 : 1, O = h[v + y];
            for (y += b, w = O & (1 << -E) - 1, O >>= -E, E += S; 0 < E; w = 256 * w + h[v + y], y += b, E -= 8) ;
            for (x = w & (1 << -E) - 1, w >>= -E, E += g; 0 < E; x = 256 * x + h[v + y], y += b, E -= 8) ;
            if (w === 0) w = 1 - A;
            else {
              if (w === $) return x ? NaN : 1 / 0 * (O ? -1 : 1);
              x += Math.pow(2, g), w -= A;
            }
            return (O ? -1 : 1) * x * Math.pow(2, w - g);
          }, i.write = function(h, v, m, g, _, k) {
            var x, S, $ = 8 * k - _ - 1, A = (1 << $) - 1, E = A >> 1, y = _ === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, b = g ? 0 : k - 1, O = g ? 1 : -1, k = v < 0 || v === 0 && 1 / v < 0 ? 1 : 0;
            for (v = Math.abs(v), isNaN(v) || v === 1 / 0 ? (S = isNaN(v) ? 1 : 0, x = A) : (x = Math.floor(Math.log(v) / Math.LN2), v * (g = Math.pow(2, -x)) < 1 && (x--, g *= 2), 2 <= (v += 1 <= x + E ? y / g : y * Math.pow(2, 1 - E)) * g && (x++, g /= 2), A <= x + E ? (S = 0, x = A) : 1 <= x + E ? (S = (v * g - 1) * Math.pow(2, _), x += E) : (S = v * Math.pow(2, E - 1) * Math.pow(2, _), x = 0)); 8 <= _; h[m + b] = 255 & S, b += O, S /= 256, _ -= 8) ;
            for (x = x << _ | S, $ += _; 0 < $; h[m + b] = 255 & x, b += O, x /= 256, $ -= 8) ;
            h[m + b - O] |= 128 * k;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
      }, { buffer: 3, lYpoI2: 11 }], 11: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h, v, m;
          function g() {
          }
          (o = r.exports = {}).nextTick = (v = typeof window < "u" && window.setImmediate, m = typeof window < "u" && window.postMessage && window.addEventListener, v ? function(_) {
            return window.setImmediate(_);
          } : m ? (h = [], window.addEventListener("message", function(_) {
            var w = _.source;
            w !== window && w !== null || _.data !== "process-tick" || (_.stopPropagation(), 0 < h.length && h.shift()());
          }, !0), function(_) {
            h.push(_), window.postMessage("process-tick", "*");
          }) : function(_) {
            setTimeout(_, 0);
          }), o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.on = g, o.addListener = g, o.once = g, o.off = g, o.removeListener = g, o.removeAllListeners = g, o.emit = g, o.binding = function(_) {
            throw new Error("process.binding is not supported");
          }, o.cwd = function() {
            return "/";
          }, o.chdir = function(_) {
            throw new Error("process.chdir is not supported");
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
      }, { buffer: 3, lYpoI2: 11 }] }, {}, [1])(1);
    });
  })(rm)), rm.exports;
}
var Mle = Rle();
const ea = /* @__PURE__ */ ip(Mle), jle = ({
  children: e,
  showMenu: t
}) => /* @__PURE__ */ C.jsx(
  "div",
  {
    className: `absolute left-0 right-0 z-50 overflow-scroll rounded max-h-40 ${t ? "block" : "hidden"}`,
    children: e
  }
);
function $ue({
  options: e,
  onSelect: t,
  displayKey: n
}) {
  const [r, i] = Ve(!1), o = _e(null), a = () => i(!0), [s, l] = Ve(""), u = Te(() => {
    if (!s) return e;
    const c = new RegExp(s, "i");
    return e.filter((f) => n ? f[n].match(c) : f.match(c));
  }, [s, e]);
  return aJ(o, () => i(!1)), SC(
    {
      Escape: () => i(!1)
    },
    [i]
  ), /* @__PURE__ */ C.jsxs("div", { className: "relative", onFocus: a, children: [
    /* @__PURE__ */ C.jsx(
      Sd,
      {
        autoComplete: "off",
        ref: o,
        type: "text",
        onChange: (c) => l(c.target.value),
        value: s
      }
    ),
    /* @__PURE__ */ C.jsx(jle, { showMenu: r, children: /* @__PURE__ */ C.jsxs(
      Vn.ul,
      {
        className: "flex flex-col w-full h-full p-2 rounded shadow-lg bg-neutral-200",
        layout: !0,
        children: [
          u.length > 0 && u.map((c) => /* @__PURE__ */ C.jsx("li", { className: "hover:text-blue-500", children: /* @__PURE__ */ C.jsx(
            "button",
            {
              onClick: () => {
                t(c), l(
                  n ? c[n] : c
                );
              },
              children: n ? c[n] : c
            }
          ) }, ea(c))),
          r && u.length === 0 && /* @__PURE__ */ C.jsx("p", { className: "italic", children: "No Results" })
        ]
      }
    ) })
  ] });
}
function Tue({
  row: e,
  data: t,
  extras: n = [],
  hide: r,
  transform: i,
  editable: o = !1,
  onEdit: a,
  defaultSortKey: s,
  className: l = "",
  render: u,
  renderHeading: c,
  cell: f
}) {
  const [d, p] = Ve(s ?? ""), [h, v] = Ve(
    "desc"
    /* Descending */
  ), [m, g] = Ve({
    key: "",
    newValue: "",
    value: "",
    hashedRow: ""
  }), _ = Te(() => [...t], [t]), w = _e(null), x = Te(() => d ? _.sort((O, k) => {
    const I = O[d] ?? "", T = k[d] ?? "";
    return I < T ? h === "asc" ? -1 : 1 : I > T ? h === "asc" ? 1 : -1 : 0;
  }) : _, [d, _, h]), S = Te(() => _.length === 0 ? [] : Object.getOwnPropertyNames(_[0]).reduce((k, I) => {
    if (r?.[I])
      return k;
    if (i && i[I]) {
      const T = i[I](I);
      return [
        ...k,
        {
          key: I,
          transformed: T
        }
      ];
    } else
      return console.log(
        `No transform for column ${I}, using key as transformed value`
      ), [...k, { key: I, transformed: I }];
  }, []), [_]), $ = Le(
    (O, k) => u?.[O] ? u[O](k) : O === m.key && ea(k) === m.hashedRow && o ? /* @__PURE__ */ C.jsxs(C.Fragment, { children: [
      /* @__PURE__ */ C.jsx(
        "form",
        {
          className: "absolute left-0 right-0 top-0 bottom-0",
          onSubmit: (I) => {
            I.preventDefault(), a && a({
              column: m.key,
              newValue: m.newValue,
              oldValue: m.value,
              rowData: k
            }), g({
              key: "",
              value: "",
              newValue: "",
              hashedRow: ""
            }), w.current?.blur();
          },
          children: /* @__PURE__ */ C.jsx(
            "textarea",
            {
              className: "w-full h-full",
              onBlur: () => {
                a?.({
                  column: m.key,
                  newValue: m.newValue,
                  oldValue: m.value,
                  rowData: k
                }), g({
                  key: "",
                  value: "",
                  newValue: "",
                  hashedRow: ""
                });
              },
              ref: w,
              autoFocus: !0,
              value: m.newValue,
              onChange: (I) => g({
                key: O,
                value: k[O],
                newValue: I.target.value,
                hashedRow: ea(k)
              })
            },
            `${ea(k)}}-${O}-${k[O]}-input`
          )
        }
      ),
      /* @__PURE__ */ C.jsx("p", { className: "invisible", children: k[O] })
    ] }) : /* @__PURE__ */ C.jsx("div", { children: k[O] }),
    [m, u]
  ), A = e ?? ((O) => /* @__PURE__ */ C.jsx("tr", { ...O })), E = (O) => c ? /* @__PURE__ */ C.jsx(C.Fragment, { children: c(O.children) }) : /* @__PURE__ */ C.jsx("tr", { ...O });
  let y = !0;
  Fle(c) && (c ? y = !0 : y = !1);
  const b = f ?? "td";
  return /* @__PURE__ */ C.jsxs("table", { className: l, children: [
    y && /* @__PURE__ */ C.jsx("thead", { children: /* @__PURE__ */ C.jsxs(E, { children: [
      S.map(
        ({ key: O, transformed: k }) => !r?.[O] && /* @__PURE__ */ C.jsx(
          "th",
          {
            onClick: () => {
              d == O ? v(
                () => h === "asc" ? "desc" : "asc"
                /* Ascending */
              ) : (p(O), v(
                "asc"
                /* Ascending */
              ));
            },
            children: /* @__PURE__ */ C.jsxs("div", { className: "flex justify-start items-center", children: [
              k,
              O === d && h === "asc" && /* @__PURE__ */ C.jsx(
                hr,
                {
                  className: "mx-1",
                  size: "sm",
                  icon: N6
                }
              ),
              O === d && h === "desc" && /* @__PURE__ */ C.jsx(
                hr,
                {
                  className: "mx-1",
                  size: "sm",
                  icon: EO
                }
              )
            ] })
          },
          O
        )
      ),
      (n || []).map(({ key: O }, k) => /* @__PURE__ */ C.jsx("th", { children: O }, `extras-${O}-${k}`))
    ] }) }),
    /* @__PURE__ */ C.jsx("tbody", { children: x.map(
      (O) => A(
        {
          key: ea(O),
          children: Object.entries(O).map(([k, I]) => r?.[k] ? null : !r?.[k] && /* @__PURE__ */ C.jsx(
            b,
            {
              title: I,
              onClick: () => {
                o && !u?.[k] && g({
                  key: k,
                  value: I,
                  newValue: I,
                  hashedRow: ea(O)
                });
              },
              children: $(k, O)
            },
            `${ea(O)}}-${k}-${I}`
          ))
        },
        O
      )
    ) })
  ] });
}
function Fle(e) {
  return typeof e == "boolean";
}
const zle = ui([
  "rounded",
  "px-4",
  "py-2",
  "bg-neutral-50",
  "mr-1",
  "hover:bg-neutral-100",
  "hover:text-black",
  "text-neutral-800"
], {
  variants: {
    active: {
      true: ["bg-black", "hover:bg-black", "text-white"],
      false: []
    }
  }
}), Pue = ({ value: e, children: t }) => {
  const { activeTab: n, setActiveTab: r } = m_();
  return /* @__PURE__ */ C.jsx(
    "button",
    {
      className: zle({ active: n === e }),
      onClick: () => r(e),
      children: t
    }
  );
}, kue = ({
  jobId: e,
  className: t = ""
}) => {
  const { data: n } = ble({ variables: { jobId: e } }), [r, i] = Ve([]);
  return Ee(() => {
    n?.taskQueueLogs && i((o) => [...o, n.taskQueueLogs]);
  }, [n]), /* @__PURE__ */ C.jsx(
    "div",
    {
      className: `${t} relative h-full p-4 overflow-y-scroll rounded bg-neutral-200 text-neutral-800`,
      children: r.map((o, a) => /* @__PURE__ */ C.jsx("pre", { children: o.message }, `task-queue-${e}-${o.timestamp}-${a}`))
    }
  );
}, N3 = He({}), Due = () => Me(N3), Lle = (e = !1) => {
  const [t, n] = Ve(e);
  return Ee(() => {
    const r = localStorage.getItem("darkMode");
    try {
      const i = JSON.parse(r || "");
      n(i.darkMode);
    } catch {
      localStorage.setItem(
        "darkMode",
        JSON.stringify({ darkMode: e })
      );
    }
  }, [n]), Ee(() => {
    localStorage.setItem("darkMode", JSON.stringify({ darkMode: t }));
  }, [t]), {
    darkMode: !1,
    // disable dark mode for now
    setDarkMode: (r) => {
      localStorage.setItem("darkMode", JSON.stringify({ darkMode: !r })), n(r);
    }
  };
}, Aue = ({ children: e }) => {
  const { darkMode: t, setDarkMode: n } = Lle();
  return Ee(() => {
    const r = document.querySelector("body");
    r && r.classList.remove("dark");
  }, [t]), /* @__PURE__ */ C.jsx(N3.Provider, { value: { darkMode: t, setDarkMode: n }, children: /* @__PURE__ */ C.jsx("div", { className: "", children: e }) });
}, Cue = ({
  order: e,
  children: t,
  className: n = ""
}) => {
  function r(i, o) {
    switch (i) {
      case 1:
        return /* @__PURE__ */ C.jsx("h1", { className: `${n} text-2xl text-brand-500`, children: o });
      case 2:
        return /* @__PURE__ */ C.jsx("h2", { className: `${n} text-xl text-brand-600`, children: o });
      case 3:
        return /* @__PURE__ */ C.jsx("h3", { className: `${n} text-brand-800`, children: o });
      case 4:
        return /* @__PURE__ */ C.jsx("h4", { children: o });
      case 5:
        return /* @__PURE__ */ C.jsx("h5", { children: o });
      default:
      case 6:
        return /* @__PURE__ */ C.jsx("h6", { children: o });
    }
  }
  return r(e, t);
};
function Iue({ on: e, onChange: t, className: n = "" }) {
  return /* @__PURE__ */ C.jsx(
    Vn.button,
    {
      layout: !0,
      onClick: () => t(!e),
      className: `
                w-12 h-4 p-1 items-center ${n} flex rounded transition-colors 
                ${e ? "justify-end bg-black" : "justify-start bg-neutral-100"}
            `,
      children: /* @__PURE__ */ C.jsx(
        Vn.div,
        {
          layout: !0,
          className: `w-4 h-2 rounded-sm transition-colors ${e ? "bg-neutral-100" : "bg-neutral-800"}`
        }
      )
    }
  );
}
const Nue = fn(
  ({ className: e, ...t }, n) => /* @__PURE__ */ C.jsx("textarea", { ref: n, ...t, className: Qn(
    "dark:bg-neutral-800 dark:text-neutral-200 bg-white text-black px-2 border-black border font-body",
    e
  ) })
);
export {
  wh as AppLayout,
  Ty as Button,
  xue as CircleSpinner,
  Xle as CopyButton,
  eue as Delete,
  tue as Divider,
  nue as Drawer,
  Um as DrawerButton,
  rue as Dropdown,
  iue as DynamicFormInput,
  oue as Ellipses,
  qV as Error,
  aue as ErrorBoundary,
  $3 as FSFileBrowser,
  Sd as Field,
  IC as FileBrowser,
  gue as FileInput,
  Jle as FlexBox,
  yue as FormikField,
  bue as GridArea,
  Ele as ImagePreview,
  oJ as Input,
  mue as LabFileBrowser,
  vue as LabsFileBrowser,
  v_ as Logo,
  K0 as Menu,
  ca as MenuItem,
  DC as MenuItemStyle,
  yX as MenuStyle,
  rX as Modal,
  fue as ModalContainer,
  wue as NotFound,
  Qle as Note,
  wle as Page,
  C3 as PageHeader,
  xle as PageHeaderTitle,
  Eue as Preview,
  Ile as Protected,
  _ue as ReaderLayout,
  Sue as RequireRoles,
  Oue as S3DownloadLink,
  hue as S3FileBrowser,
  Tle as SVGPreview,
  BV as Select,
  $ue as SelectionSearch,
  Wd as Spacer,
  Sle as Spinner,
  Pue as Tab,
  Gse as TabContent,
  Tue as Table,
  Cle as TablePreview,
  wy as Tabs,
  Hse as TabsList,
  kue as TaskQueueLogs,
  Nue as Textarea,
  N3 as ThemeContext,
  Aue as ThemeProvider,
  Cue as Title,
  Iue as Toggle,
  _X as UploadToast,
  Vse as _FSFileBrowser,
  Mse as _S3FileBrowser,
  rle as fileListToArray,
  _le as pageVariants,
  iX as useModalContext,
  P3 as useTailwindBreakpoint,
  Due as useTheme
};
//# sourceMappingURL=components.js.map
